function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4dbc"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4dbc"] = parcelRequire;
}
parcelRequire.register("7we3r", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    var context = new $ewFRw(defaultConfig);
    var instance = $jJbMR($ewFRw.prototype.request, context);
    // Copy axios.prototype to instance
    $gKvUL.extend(instance, $ewFRw.prototype, context);
    // Copy context to instance
    $gKvUL.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance($lJY4v);
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = $ewFRw;
// Factory for creating new instances
$57966c7e0affc4cb$var$axios.create = function create(instanceConfig) {
    return $57966c7e0affc4cb$var$createInstance($lk5EI($57966c7e0affc4cb$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.Cancel = (parcelRequire("4Tkeq"));

$57966c7e0affc4cb$var$axios.CancelToken = (parcelRequire("lAKPy"));

$57966c7e0affc4cb$var$axios.isCancel = (parcelRequire("7L4QX"));
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$57966c7e0affc4cb$var$axios.spread = (parcelRequire("JEeti"));
module.exports = $57966c7e0affc4cb$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $57966c7e0affc4cb$var$axios;

});
parcelRequire.register("gKvUL", function(module, exports) {
"use strict";

var $jJbMR = parcelRequire("jJbMR");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $c319b2c832c2914a$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $c319b2c832c2914a$var$isArray(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $c319b2c832c2914a$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBuffer(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $c319b2c832c2914a$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $c319b2c832c2914a$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $c319b2c832c2914a$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $c319b2c832c2914a$var$isDate(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $c319b2c832c2914a$var$isFile(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $c319b2c832c2914a$var$isBlob(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $c319b2c832c2914a$var$isFunction(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $c319b2c832c2914a$var$isStream(val) {
    return $c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $c319b2c832c2914a$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $c319b2c832c2914a$var$trim(str) {
    return str.replace(/^\s*/, "").replace(/\s*$/, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $c319b2c832c2914a$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $c319b2c832c2914a$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === "object" && typeof val === "object") result[key] = $c319b2c832c2914a$var$merge(result[key], val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$deepMerge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === "object" && typeof val === "object") result[key] = $c319b2c832c2914a$var$deepMerge(result[key], val);
        else if (typeof val === "object") result[key] = $c319b2c832c2914a$var$deepMerge({}, val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $c319b2c832c2914a$var$extend(a, b, thisArg) {
    $c319b2c832c2914a$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $jJbMR(val, thisArg);
        else a[key] = val;
    });
    return a;
}
module.exports = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isObject: $c319b2c832c2914a$var$isObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isStandardBrowserEnv: $c319b2c832c2914a$var$isStandardBrowserEnv,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    deepMerge: $c319b2c832c2914a$var$deepMerge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim
};

});
parcelRequire.register("jJbMR", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRequire.register("ewFRw", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $a93486d2307f31c3$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $83RYu(),
        response: new $83RYu()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $a93486d2307f31c3$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $lk5EI(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    // Hook up interceptors middleware
    var chain = [
        $dlZEJ,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
$a93486d2307f31c3$var$Axios.prototype.getUri = function getUri(config) {
    config = $lk5EI(this.defaults, config);
    return $cbIsf(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$gKvUL.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request($gKvUL.merge(config || {}, {
            method: method,
            url: url
        }));
    };
});
$gKvUL.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($gKvUL.merge(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $a93486d2307f31c3$var$Axios;

});
parcelRequire.register("cbIsf", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($gKvUL.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $gKvUL.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($gKvUL.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $gKvUL.forEach(val, function parseValue(v) {
                if ($gKvUL.isDate(v)) v = v.toISOString();
                else if ($gKvUL.isObject(v)) v = JSON.stringify(v);
                parts.push($8df8fedf1c1e4428$var$encode(key) + "=" + $8df8fedf1c1e4428$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRequire.register("83RYu", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
function $5de878cd737ef277$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $5de878cd737ef277$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $5de878cd737ef277$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $5de878cd737ef277$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $gKvUL.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $5de878cd737ef277$var$InterceptorManager;

});

parcelRequire.register("dlZEJ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $7YJ0v(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $gKvUL.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $gKvUL.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $lJY4v.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $7YJ0v(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$7L4QX(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $7YJ0v(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRequire.register("7YJ0v", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $gKvUL.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRequire.register("7L4QX", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRequire.register("lJY4v", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $kiL6T = parcelRequire("kiL6T");
var $fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, value) {
    if (!$gKvUL.isUndefined(headers) && $gKvUL.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $fd3c65eeb28abd71$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("at5cb"));
    else if (typeof $hPtJY !== "undefined" && Object.prototype.toString.call($hPtJY) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("at5cb"));
    return adapter;
}
var $fd3c65eeb28abd71$var$defaults = {
    adapter: $fd3c65eeb28abd71$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $kiL6T(headers, "Accept");
            $kiL6T(headers, "Content-Type");
            if ($gKvUL.isFormData(data) || $gKvUL.isArrayBuffer(data) || $gKvUL.isBuffer(data) || $gKvUL.isStream(data) || $gKvUL.isFile(data) || $gKvUL.isBlob(data)) return data;
            if ($gKvUL.isArrayBufferView(data)) return data.buffer;
            if ($gKvUL.isURLSearchParams(data)) {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($gKvUL.isObject(data)) {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, "application/json;charset=utf-8");
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === "string") try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$fd3c65eeb28abd71$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$gKvUL.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = {};
});
$gKvUL.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = $gKvUL.merge($fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $fd3c65eeb28abd71$var$defaults;

});
parcelRequire.register("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRequire.register("kiL6T", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $gKvUL.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRequire.register("at5cb", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $cbIsf = parcelRequire("cbIsf");

var $7GD7a = parcelRequire("7GD7a");

var $lDriZ = parcelRequire("lDriZ");

var $889er = parcelRequire("889er");

var $kjF3e = parcelRequire("kjF3e");

module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($gKvUL.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password || "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $7GD7a(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $cbIsf(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $lDriZ(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === "text" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $kk0E9(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($kjF3e("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($kjF3e("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($kjF3e(timeoutErrorMessage, config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($gKvUL.isStandardBrowserEnv()) {
            var cookies = (parcelRequire("8JRzs"));
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $889er(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $gKvUL.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$gKvUL.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== "json") throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (requestData === undefined) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRequire.register("kk0E9", function(module, exports) {
"use strict";

var $kjF3e = parcelRequire("kjF3e");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!validateStatus || validateStatus(response.status)) resolve(response);
    else reject($kjF3e("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRequire.register("kjF3e", function(module, exports) {
"use strict";

var $8v8A7 = parcelRequire("8v8A7");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $8v8A7(error, config, code, request, response);
};

});
parcelRequire.register("8v8A7", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});



parcelRequire.register("7GD7a", function(module, exports) {
"use strict";

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$ckHwb(requestedURL)) return $fE4ul(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRequire.register("ckHwb", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRequire.register("fE4ul", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRequire.register("lDriZ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $fc026bbf9ee156f1$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $gKvUL.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $gKvUL.trim(line.substr(0, i)).toLowerCase();
        val = $gKvUL.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRequire.register("889er", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $gKvUL.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRequire.register("8JRzs", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($gKvUL.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($gKvUL.isString(path)) cookie.push("path=" + path);
            if ($gKvUL.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});




parcelRequire.register("lk5EI", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "params",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "url",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "maxContentLength",
        "validateStatus",
        "maxRedirects",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath"
    ];
    $gKvUL.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
    });
    $gKvUL.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
        if ($gKvUL.isObject(config2[prop])) config[prop] = $gKvUL.deepMerge(config1[prop], config2[prop]);
        else if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if ($gKvUL.isObject(config1[prop])) config[prop] = $gKvUL.deepMerge(config1[prop]);
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    $gKvUL.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys);
    var otherKeys = Object.keys(config2).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $gKvUL.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    return config;
};

});


parcelRequire.register("4Tkeq", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $38fbfe0afbd5bf1e$var$Cancel(message) {
    this.message = message;
}
$38fbfe0afbd5bf1e$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$38fbfe0afbd5bf1e$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $38fbfe0afbd5bf1e$var$Cancel;

});

parcelRequire.register("lAKPy", function(module, exports) {
"use strict";

var $4Tkeq = parcelRequire("4Tkeq");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $fb81495929d8a282$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $4Tkeq(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $fb81495929d8a282$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $fb81495929d8a282$var$CancelToken.source = function source() {
    var cancel;
    var token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $fb81495929d8a282$var$CancelToken;

});

parcelRequire.register("JEeti", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});


parcelRequire.register("LjoDx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "options", () => $561c80739c064091$export$41c562ebe57d11e2);
$parcel$export(module.exports, "h", () => $561c80739c064091$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "cloneElement", () => $561c80739c064091$export$e530037191fcd5d7);
$parcel$export(module.exports, "rerender", () => $561c80739c064091$export$b095a217686cbd0);
$parcel$export(module.exports, "Component", () => $561c80739c064091$export$16fa2f45be04daa8);
$parcel$export(module.exports, "render", () => $561c80739c064091$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "createRef", () => $561c80739c064091$export$7d1e3a5e95ceca43);
$parcel$export(module.exports, "default", () => $561c80739c064091$export$2e2bcd8739ae039);
$parcel$export(module.exports, "createElement", () => $561c80739c064091$export$dda1d9f60106f0e9);
var $561c80739c064091$var$VNode = function VNode() {};
var $561c80739c064091$export$41c562ebe57d11e2 = {};
var $561c80739c064091$var$stack = [];
var $561c80739c064091$var$EMPTY_CHILDREN = [];
function $561c80739c064091$export$dda1d9f60106f0e9(nodeName, attributes) {
    var children = $561c80739c064091$var$EMPTY_CHILDREN, lastSimple, child, simple, i;
    for(i = arguments.length; i-- > 2;)$561c80739c064091$var$stack.push(arguments[i]);
    if (attributes && attributes.children != null) {
        if (!$561c80739c064091$var$stack.length) $561c80739c064091$var$stack.push(attributes.children);
        delete attributes.children;
    }
    while($561c80739c064091$var$stack.length){
        if ((child = $561c80739c064091$var$stack.pop()) && child.pop !== undefined) for(i = child.length; i--;)$561c80739c064091$var$stack.push(child[i]);
        else {
            if (typeof child === "boolean") child = null;
            if (simple = typeof nodeName !== "function") {
                if (child == null) child = "";
                else if (typeof child === "number") child = String(child);
                else if (typeof child !== "string") simple = false;
            }
            if (simple && lastSimple) children[children.length - 1] += child;
            else if (children === $561c80739c064091$var$EMPTY_CHILDREN) children = [
                child
            ];
            else children.push(child);
            lastSimple = simple;
        }
    }
    var p = new $561c80739c064091$var$VNode();
    p.nodeName = nodeName;
    p.children = children;
    p.attributes = attributes == null ? undefined : attributes;
    p.key = attributes == null ? undefined : attributes.key;
    if ($561c80739c064091$export$41c562ebe57d11e2.vnode !== undefined) $561c80739c064091$export$41c562ebe57d11e2.vnode(p);
    return p;
}
function $561c80739c064091$var$extend(obj, props) {
    for(var i in props)obj[i] = props[i];
    return obj;
}
function $561c80739c064091$var$applyRef(ref, value) {
    if (ref) {
        if (typeof ref == "function") ref(value);
        else ref.current = value;
    }
}
var $561c80739c064091$var$defer = typeof Promise == "function" ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;
function $561c80739c064091$export$e530037191fcd5d7(vnode, props) {
    return $561c80739c064091$export$dda1d9f60106f0e9(vnode.nodeName, $561c80739c064091$var$extend($561c80739c064091$var$extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
}
var $561c80739c064091$var$IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;
var $561c80739c064091$var$items = [];
function $561c80739c064091$var$enqueueRender(component) {
    if (!component._dirty && (component._dirty = true) && $561c80739c064091$var$items.push(component) == 1) ($561c80739c064091$export$41c562ebe57d11e2.debounceRendering || $561c80739c064091$var$defer)($561c80739c064091$export$b095a217686cbd0);
}
function $561c80739c064091$export$b095a217686cbd0() {
    var p;
    while(p = $561c80739c064091$var$items.pop())if (p._dirty) $561c80739c064091$var$renderComponent(p);
}
function $561c80739c064091$var$isSameNodeType(node, vnode, hydrating) {
    if (typeof vnode === "string" || typeof vnode === "number") return node.splitText !== undefined;
    if (typeof vnode.nodeName === "string") return !node._componentConstructor && $561c80739c064091$var$isNamedNode(node, vnode.nodeName);
    return hydrating || node._componentConstructor === vnode.nodeName;
}
function $561c80739c064091$var$isNamedNode(node, nodeName) {
    return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
}
function $561c80739c064091$var$getNodeProps(vnode) {
    var props = $561c80739c064091$var$extend({}, vnode.attributes);
    props.children = vnode.children;
    var defaultProps = vnode.nodeName.defaultProps;
    if (defaultProps !== undefined) {
        for(var i in defaultProps)if (props[i] === undefined) props[i] = defaultProps[i];
    }
    return props;
}
function $561c80739c064091$var$createNode(nodeName, isSvg) {
    var node = isSvg ? document.createElementNS("http://www.w3.org/2000/svg", nodeName) : document.createElement(nodeName);
    node.normalizedNodeName = nodeName;
    return node;
}
function $561c80739c064091$var$removeNode(node) {
    var parentNode = node.parentNode;
    if (parentNode) parentNode.removeChild(node);
}
function $561c80739c064091$var$setAccessor(node, name, old, value, isSvg) {
    if (name === "className") name = "class";
    if (name === "key") ;
    else if (name === "ref") {
        $561c80739c064091$var$applyRef(old, null);
        $561c80739c064091$var$applyRef(value, node);
    } else if (name === "class" && !isSvg) node.className = value || "";
    else if (name === "style") {
        if (!value || typeof value === "string" || typeof old === "string") node.style.cssText = value || "";
        if (value && typeof value === "object") {
            if (typeof old !== "string") {
                for(var i in old)if (!(i in value)) node.style[i] = "";
            }
            for(var i in value)node.style[i] = typeof value[i] === "number" && $561c80739c064091$var$IS_NON_DIMENSIONAL.test(i) === false ? value[i] + "px" : value[i];
        }
    } else if (name === "dangerouslySetInnerHTML") {
        if (value) node.innerHTML = value.__html || "";
    } else if (name[0] == "o" && name[1] == "n") {
        var useCapture = name !== (name = name.replace(/Capture$/, ""));
        name = name.toLowerCase().substring(2);
        if (value) {
            if (!old) node.addEventListener(name, $561c80739c064091$var$eventProxy, useCapture);
        } else node.removeEventListener(name, $561c80739c064091$var$eventProxy, useCapture);
        (node._listeners || (node._listeners = {}))[name] = value;
    } else if (name !== "list" && name !== "type" && !isSvg && name in node) {
        try {
            node[name] = value == null ? "" : value;
        } catch (e) {}
        if ((value == null || value === false) && name != "spellcheck") node.removeAttribute(name);
    } else {
        var ns = isSvg && name !== (name = name.replace(/^xlink:?/, ""));
        if (value == null || value === false) {
            if (ns) node.removeAttributeNS("http://www.w3.org/1999/xlink", name.toLowerCase());
            else node.removeAttribute(name);
        } else if (typeof value !== "function") {
            if (ns) node.setAttributeNS("http://www.w3.org/1999/xlink", name.toLowerCase(), value);
            else node.setAttribute(name, value);
        }
    }
}
function $561c80739c064091$var$eventProxy(e) {
    return this._listeners[e.type]($561c80739c064091$export$41c562ebe57d11e2.event && $561c80739c064091$export$41c562ebe57d11e2.event(e) || e);
}
var $561c80739c064091$var$mounts = [];
var $561c80739c064091$var$diffLevel = 0;
var $561c80739c064091$var$isSvgMode = false;
var $561c80739c064091$var$hydrating = false;
function $561c80739c064091$var$flushMounts() {
    var c;
    while(c = $561c80739c064091$var$mounts.shift()){
        if ($561c80739c064091$export$41c562ebe57d11e2.afterMount) $561c80739c064091$export$41c562ebe57d11e2.afterMount(c);
        if (c.componentDidMount) c.componentDidMount();
    }
}
function $561c80739c064091$var$diff(dom, vnode, context, mountAll, parent, componentRoot) {
    if (!$561c80739c064091$var$diffLevel++) {
        $561c80739c064091$var$isSvgMode = parent != null && parent.ownerSVGElement !== undefined;
        $561c80739c064091$var$hydrating = dom != null && !("__preactattr_" in dom);
    }
    var ret = $561c80739c064091$var$idiff(dom, vnode, context, mountAll, componentRoot);
    if (parent && ret.parentNode !== parent) parent.appendChild(ret);
    if (!--$561c80739c064091$var$diffLevel) {
        $561c80739c064091$var$hydrating = false;
        if (!componentRoot) $561c80739c064091$var$flushMounts();
    }
    return ret;
}
function $561c80739c064091$var$idiff(dom, vnode, context, mountAll, componentRoot) {
    var out = dom, prevSvgMode = $561c80739c064091$var$isSvgMode;
    if (vnode == null || typeof vnode === "boolean") vnode = "";
    if (typeof vnode === "string" || typeof vnode === "number") {
        if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
            if (dom.nodeValue != vnode) dom.nodeValue = vnode;
        } else {
            out = document.createTextNode(vnode);
            if (dom) {
                if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
                $561c80739c064091$var$recollectNodeTree(dom, true);
            }
        }
        out["__preactattr_"] = true;
        return out;
    }
    var vnodeName = vnode.nodeName;
    if (typeof vnodeName === "function") return $561c80739c064091$var$buildComponentFromVNode(dom, vnode, context, mountAll);
    $561c80739c064091$var$isSvgMode = vnodeName === "svg" ? true : vnodeName === "foreignObject" ? false : $561c80739c064091$var$isSvgMode;
    vnodeName = String(vnodeName);
    if (!dom || !$561c80739c064091$var$isNamedNode(dom, vnodeName)) {
        out = $561c80739c064091$var$createNode(vnodeName, $561c80739c064091$var$isSvgMode);
        if (dom) {
            while(dom.firstChild)out.appendChild(dom.firstChild);
            if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
            $561c80739c064091$var$recollectNodeTree(dom, true);
        }
    }
    var fc = out.firstChild, props = out["__preactattr_"], vchildren = vnode.children;
    if (props == null) {
        props = out["__preactattr_"] = {};
        for(var a = out.attributes, i = a.length; i--;)props[a[i].name] = a[i].value;
    }
    if (!$561c80739c064091$var$hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === "string" && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
        if (fc.nodeValue != vchildren[0]) fc.nodeValue = vchildren[0];
    } else if (vchildren && vchildren.length || fc != null) $561c80739c064091$var$innerDiffNode(out, vchildren, context, mountAll, $561c80739c064091$var$hydrating || props.dangerouslySetInnerHTML != null);
    $561c80739c064091$var$diffAttributes(out, vnode.attributes, props);
    $561c80739c064091$var$isSvgMode = prevSvgMode;
    return out;
}
function $561c80739c064091$var$innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
    var originalChildren = dom.childNodes, children = [], keyed = {}, keyedLen = 0, min = 0, len = originalChildren.length, childrenLen = 0, vlen = vchildren ? vchildren.length : 0, j, c, f, vchild, child;
    if (len !== 0) for(var i = 0; i < len; i++){
        var _child = originalChildren[i], props = _child["__preactattr_"], key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
        if (key != null) {
            keyedLen++;
            keyed[key] = _child;
        } else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) children[childrenLen++] = _child;
    }
    if (vlen !== 0) for(var i = 0; i < vlen; i++){
        vchild = vchildren[i];
        child = null;
        var key = vchild.key;
        if (key != null) {
            if (keyedLen && keyed[key] !== undefined) {
                child = keyed[key];
                keyed[key] = undefined;
                keyedLen--;
            }
        } else if (min < childrenLen) {
            for(j = min; j < childrenLen; j++)if (children[j] !== undefined && $561c80739c064091$var$isSameNodeType(c = children[j], vchild, isHydrating)) {
                child = c;
                children[j] = undefined;
                if (j === childrenLen - 1) childrenLen--;
                if (j === min) min++;
                break;
            }
        }
        child = $561c80739c064091$var$idiff(child, vchild, context, mountAll);
        f = originalChildren[i];
        if (child && child !== dom && child !== f) {
            if (f == null) dom.appendChild(child);
            else if (child === f.nextSibling) $561c80739c064091$var$removeNode(f);
            else dom.insertBefore(child, f);
        }
    }
    if (keyedLen) {
        for(var i in keyed)if (keyed[i] !== undefined) $561c80739c064091$var$recollectNodeTree(keyed[i], false);
    }
    while(min <= childrenLen)if ((child = children[childrenLen--]) !== undefined) $561c80739c064091$var$recollectNodeTree(child, false);
}
function $561c80739c064091$var$recollectNodeTree(node, unmountOnly) {
    var component = node._component;
    if (component) $561c80739c064091$var$unmountComponent(component);
    else {
        if (node["__preactattr_"] != null) $561c80739c064091$var$applyRef(node["__preactattr_"].ref, null);
        if (unmountOnly === false || node["__preactattr_"] == null) $561c80739c064091$var$removeNode(node);
        $561c80739c064091$var$removeChildren(node);
    }
}
function $561c80739c064091$var$removeChildren(node) {
    node = node.lastChild;
    while(node){
        var next = node.previousSibling;
        $561c80739c064091$var$recollectNodeTree(node, true);
        node = next;
    }
}
function $561c80739c064091$var$diffAttributes(dom, attrs, old) {
    var name;
    for(name in old)if (!(attrs && attrs[name] != null) && old[name] != null) $561c80739c064091$var$setAccessor(dom, name, old[name], old[name] = undefined, $561c80739c064091$var$isSvgMode);
    for(name in attrs)if (name !== "children" && name !== "innerHTML" && (!(name in old) || attrs[name] !== (name === "value" || name === "checked" ? dom[name] : old[name]))) $561c80739c064091$var$setAccessor(dom, name, old[name], old[name] = attrs[name], $561c80739c064091$var$isSvgMode);
}
var $561c80739c064091$var$recyclerComponents = [];
function $561c80739c064091$var$createComponent(Ctor, props, context) {
    var inst, i = $561c80739c064091$var$recyclerComponents.length;
    if (Ctor.prototype && Ctor.prototype.render) {
        inst = new Ctor(props, context);
        $561c80739c064091$export$16fa2f45be04daa8.call(inst, props, context);
    } else {
        inst = new $561c80739c064091$export$16fa2f45be04daa8(props, context);
        inst.constructor = Ctor;
        inst.render = $561c80739c064091$var$doRender;
    }
    while(i--)if ($561c80739c064091$var$recyclerComponents[i].constructor === Ctor) {
        inst.nextBase = $561c80739c064091$var$recyclerComponents[i].nextBase;
        $561c80739c064091$var$recyclerComponents.splice(i, 1);
        return inst;
    }
    return inst;
}
function $561c80739c064091$var$doRender(props, state, context) {
    return this.constructor(props, context);
}
function $561c80739c064091$var$setComponentProps(component, props, renderMode, context, mountAll) {
    if (component._disable) return;
    component._disable = true;
    component.__ref = props.ref;
    component.__key = props.key;
    delete props.ref;
    delete props.key;
    if (typeof component.constructor.getDerivedStateFromProps === "undefined") {
        if (!component.base || mountAll) {
            if (component.componentWillMount) component.componentWillMount();
        } else if (component.componentWillReceiveProps) component.componentWillReceiveProps(props, context);
    }
    if (context && context !== component.context) {
        if (!component.prevContext) component.prevContext = component.context;
        component.context = context;
    }
    if (!component.prevProps) component.prevProps = component.props;
    component.props = props;
    component._disable = false;
    if (renderMode !== 0) {
        if (renderMode === 1 || $561c80739c064091$export$41c562ebe57d11e2.syncComponentUpdates !== false || !component.base) $561c80739c064091$var$renderComponent(component, 1, mountAll);
        else $561c80739c064091$var$enqueueRender(component);
    }
    $561c80739c064091$var$applyRef(component.__ref, component);
}
function $561c80739c064091$var$renderComponent(component, renderMode, mountAll, isChild) {
    if (component._disable) return;
    var props = component.props, state = component.state, context = component.context, previousProps = component.prevProps || props, previousState = component.prevState || state, previousContext = component.prevContext || context, isUpdate = component.base, nextBase = component.nextBase, initialBase = isUpdate || nextBase, initialChildComponent = component._component, skip = false, snapshot = previousContext, rendered, inst, cbase;
    if (component.constructor.getDerivedStateFromProps) {
        state = $561c80739c064091$var$extend($561c80739c064091$var$extend({}, state), component.constructor.getDerivedStateFromProps(props, state));
        component.state = state;
    }
    if (isUpdate) {
        component.props = previousProps;
        component.state = previousState;
        component.context = previousContext;
        if (renderMode !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) skip = true;
        else if (component.componentWillUpdate) component.componentWillUpdate(props, state, context);
        component.props = props;
        component.state = state;
        component.context = context;
    }
    component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
    component._dirty = false;
    if (!skip) {
        rendered = component.render(props, state, context);
        if (component.getChildContext) context = $561c80739c064091$var$extend($561c80739c064091$var$extend({}, context), component.getChildContext());
        if (isUpdate && component.getSnapshotBeforeUpdate) snapshot = component.getSnapshotBeforeUpdate(previousProps, previousState);
        var childComponent = rendered && rendered.nodeName, toUnmount, base;
        if (typeof childComponent === "function") {
            var childProps = $561c80739c064091$var$getNodeProps(rendered);
            inst = initialChildComponent;
            if (inst && inst.constructor === childComponent && childProps.key == inst.__key) $561c80739c064091$var$setComponentProps(inst, childProps, 1, context, false);
            else {
                toUnmount = inst;
                component._component = inst = $561c80739c064091$var$createComponent(childComponent, childProps, context);
                inst.nextBase = inst.nextBase || nextBase;
                inst._parentComponent = component;
                $561c80739c064091$var$setComponentProps(inst, childProps, 0, context, false);
                $561c80739c064091$var$renderComponent(inst, 1, mountAll, true);
            }
            base = inst.base;
        } else {
            cbase = initialBase;
            toUnmount = initialChildComponent;
            if (toUnmount) cbase = component._component = null;
            if (initialBase || renderMode === 1) {
                if (cbase) cbase._component = null;
                base = $561c80739c064091$var$diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
            }
        }
        if (initialBase && base !== initialBase && inst !== initialChildComponent) {
            var baseParent = initialBase.parentNode;
            if (baseParent && base !== baseParent) {
                baseParent.replaceChild(base, initialBase);
                if (!toUnmount) {
                    initialBase._component = null;
                    $561c80739c064091$var$recollectNodeTree(initialBase, false);
                }
            }
        }
        if (toUnmount) $561c80739c064091$var$unmountComponent(toUnmount);
        component.base = base;
        if (base && !isChild) {
            var componentRef = component, t = component;
            while(t = t._parentComponent)(componentRef = t).base = base;
            base._component = componentRef;
            base._componentConstructor = componentRef.constructor;
        }
    }
    if (!isUpdate || mountAll) $561c80739c064091$var$mounts.push(component);
    else if (!skip) {
        if (component.componentDidUpdate) component.componentDidUpdate(previousProps, previousState, snapshot);
        if ($561c80739c064091$export$41c562ebe57d11e2.afterUpdate) $561c80739c064091$export$41c562ebe57d11e2.afterUpdate(component);
    }
    while(component._renderCallbacks.length)component._renderCallbacks.pop().call(component);
    if (!$561c80739c064091$var$diffLevel && !isChild) $561c80739c064091$var$flushMounts();
}
function $561c80739c064091$var$buildComponentFromVNode(dom, vnode, context, mountAll) {
    var c = dom && dom._component, originalComponent = c, oldDom = dom, isDirectOwner = c && dom._componentConstructor === vnode.nodeName, isOwner = isDirectOwner, props = $561c80739c064091$var$getNodeProps(vnode);
    while(c && !isOwner && (c = c._parentComponent))isOwner = c.constructor === vnode.nodeName;
    if (c && isOwner && (!mountAll || c._component)) {
        $561c80739c064091$var$setComponentProps(c, props, 3, context, mountAll);
        dom = c.base;
    } else {
        if (originalComponent && !isDirectOwner) {
            $561c80739c064091$var$unmountComponent(originalComponent);
            dom = oldDom = null;
        }
        c = $561c80739c064091$var$createComponent(vnode.nodeName, props, context);
        if (dom && !c.nextBase) {
            c.nextBase = dom;
            oldDom = null;
        }
        $561c80739c064091$var$setComponentProps(c, props, 1, context, mountAll);
        dom = c.base;
        if (oldDom && dom !== oldDom) {
            oldDom._component = null;
            $561c80739c064091$var$recollectNodeTree(oldDom, false);
        }
    }
    return dom;
}
function $561c80739c064091$var$unmountComponent(component) {
    if ($561c80739c064091$export$41c562ebe57d11e2.beforeUnmount) $561c80739c064091$export$41c562ebe57d11e2.beforeUnmount(component);
    var base = component.base;
    component._disable = true;
    if (component.componentWillUnmount) component.componentWillUnmount();
    component.base = null;
    var inner = component._component;
    if (inner) $561c80739c064091$var$unmountComponent(inner);
    else if (base) {
        if (base["__preactattr_"] != null) $561c80739c064091$var$applyRef(base["__preactattr_"].ref, null);
        component.nextBase = base;
        $561c80739c064091$var$removeNode(base);
        $561c80739c064091$var$recyclerComponents.push(component);
        $561c80739c064091$var$removeChildren(base);
    }
    $561c80739c064091$var$applyRef(component.__ref, null);
}
function $561c80739c064091$export$16fa2f45be04daa8(props, context) {
    this._dirty = true;
    this.context = context;
    this.props = props;
    this.state = this.state || {};
    this._renderCallbacks = [];
}
$561c80739c064091$var$extend($561c80739c064091$export$16fa2f45be04daa8.prototype, {
    setState: function setState(state, callback) {
        if (!this.prevState) this.prevState = this.state;
        this.state = $561c80739c064091$var$extend($561c80739c064091$var$extend({}, this.state), typeof state === "function" ? state(this.state, this.props) : state);
        if (callback) this._renderCallbacks.push(callback);
        $561c80739c064091$var$enqueueRender(this);
    },
    forceUpdate: function forceUpdate(callback) {
        if (callback) this._renderCallbacks.push(callback);
        $561c80739c064091$var$renderComponent(this, 2);
    },
    render: function render() {}
});
function $561c80739c064091$export$b3890eb0ae9dca99(vnode, parent, merge) {
    return $561c80739c064091$var$diff(merge, vnode, {}, false, parent, false);
}
function $561c80739c064091$export$7d1e3a5e95ceca43() {
    return {};
}
var $561c80739c064091$var$preact = {
    h: $561c80739c064091$export$dda1d9f60106f0e9,
    createElement: $561c80739c064091$export$dda1d9f60106f0e9,
    cloneElement: $561c80739c064091$export$e530037191fcd5d7,
    createRef: $561c80739c064091$export$7d1e3a5e95ceca43,
    Component: $561c80739c064091$export$16fa2f45be04daa8,
    render: $561c80739c064091$export$b3890eb0ae9dca99,
    rerender: $561c80739c064091$export$b095a217686cbd0,
    options: $561c80739c064091$export$41c562ebe57d11e2
};
var $561c80739c064091$export$2e2bcd8739ae039 = $561c80739c064091$var$preact;

});

parcelRequire.register("bCVnn", function(module, exports) {

//! moment-timezone.js
//! version : 0.5.43
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone
(function(root, factory) {
    "use strict";
    /*global define*/ if (0, module.exports) module.exports = factory((parcelRequire("45fvw"))); // Node
    else if (typeof define === "function" && define.amd) define([
        "moment"
    ], factory); // AMD
    else factory(root.moment); // Browser
})(module.exports, function(moment) {
    "use strict";
    // Resolves es6 module loading issue
    if (moment.version === undefined && moment.default) moment = moment.default;
    // Do not load moment-timezone a second time.
    // if (moment.tz !== undefined) {
    // 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
    // 	return moment;
    // }
    var VERSION = "0.5.43", zones = {}, links = {}, countries = {}, names = {}, guesses = {}, cachedGuess;
    if (!moment || typeof moment.version !== "string") logError("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
    var momentVersion = moment.version.split("."), major = +momentVersion[0], minor = +momentVersion[1];
    // Moment.js version check
    if (major < 2 || major === 2 && minor < 6) logError("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + moment.version + ". See momentjs.com");
    /************************************
		Unpacking
	************************************/ function charCodeToInt(charCode) {
        if (charCode > 96) return charCode - 87;
        else if (charCode > 64) return charCode - 29;
        return charCode - 48;
    }
    function unpackBase60(string) {
        var i = 0, parts = string.split("."), whole = parts[0], fractional = parts[1] || "", multiplier = 1, num, out = 0, sign = 1;
        // handle negative numbers
        if (string.charCodeAt(0) === 45) {
            i = 1;
            sign = -1;
        }
        // handle digits before the decimal
        for(i; i < whole.length; i++){
            num = charCodeToInt(whole.charCodeAt(i));
            out = 60 * out + num;
        }
        // handle digits after the decimal
        for(i = 0; i < fractional.length; i++){
            multiplier = multiplier / 60;
            num = charCodeToInt(fractional.charCodeAt(i));
            out += num * multiplier;
        }
        return out * sign;
    }
    function arrayToInt(array) {
        for(var i = 0; i < array.length; i++)array[i] = unpackBase60(array[i]);
    }
    function intToUntil(array, length) {
        for(var i = 0; i < length; i++)array[i] = Math.round((array[i - 1] || 0) + array[i] * 60000); // minutes to milliseconds
        array[length - 1] = Infinity;
    }
    function mapIndices(source, indices) {
        var out = [], i;
        for(i = 0; i < indices.length; i++)out[i] = source[indices[i]];
        return out;
    }
    function unpack(string) {
        var data = string.split("|"), offsets = data[2].split(" "), indices = data[3].split(""), untils = data[4].split(" ");
        arrayToInt(offsets);
        arrayToInt(indices);
        arrayToInt(untils);
        intToUntil(untils, indices.length);
        return {
            name: data[0],
            abbrs: mapIndices(data[1].split(" "), indices),
            offsets: mapIndices(offsets, indices),
            untils: untils,
            population: data[5] | 0
        };
    }
    /************************************
		Zone object
	************************************/ function Zone(packedString) {
        if (packedString) this._set(unpack(packedString));
    }
    Zone.prototype = {
        _set: function(unpacked) {
            this.name = unpacked.name;
            this.abbrs = unpacked.abbrs;
            this.untils = unpacked.untils;
            this.offsets = unpacked.offsets;
            this.population = unpacked.population;
        },
        _index: function(timestamp) {
            var target = +timestamp, untils = this.untils, i;
            for(i = 0; i < untils.length; i++){
                if (target < untils[i]) return i;
            }
        },
        countries: function() {
            var zone_name = this.name;
            return Object.keys(countries).filter(function(country_code) {
                return countries[country_code].zones.indexOf(zone_name) !== -1;
            });
        },
        parse: function(timestamp) {
            var target = +timestamp, offsets = this.offsets, untils = this.untils, max = untils.length - 1, offset, offsetNext, offsetPrev, i;
            for(i = 0; i < max; i++){
                offset = offsets[i];
                offsetNext = offsets[i + 1];
                offsetPrev = offsets[i ? i - 1 : i];
                if (offset < offsetNext && tz.moveAmbiguousForward) offset = offsetNext;
                else if (offset > offsetPrev && tz.moveInvalidForward) offset = offsetPrev;
                if (target < untils[i] - offset * 60000) return offsets[i];
            }
            return offsets[max];
        },
        abbr: function(mom) {
            return this.abbrs[this._index(mom)];
        },
        offset: function(mom) {
            logError("zone.offset has been deprecated in favor of zone.utcOffset");
            return this.offsets[this._index(mom)];
        },
        utcOffset: function(mom) {
            return this.offsets[this._index(mom)];
        }
    };
    /************************************
		Country object
	************************************/ function Country(country_name, zone_names) {
        this.name = country_name;
        this.zones = zone_names;
    }
    /************************************
		Current Timezone
	************************************/ function OffsetAt(at) {
        var timeString = at.toTimeString();
        var abbr = timeString.match(/\([a-z ]+\)/i);
        if (abbr && abbr[0]) {
            // 17:56:31 GMT-0600 (CST)
            // 17:56:31 GMT-0600 (Central Standard Time)
            abbr = abbr[0].match(/[A-Z]/g);
            abbr = abbr ? abbr.join("") : undefined;
        } else {
            // 17:56:31 CST
            // 17:56:31 GMT+0800 (台北標準時間)
            abbr = timeString.match(/[A-Z]{3,5}/g);
            abbr = abbr ? abbr[0] : undefined;
        }
        if (abbr === "GMT") abbr = undefined;
        this.at = +at;
        this.abbr = abbr;
        this.offset = at.getTimezoneOffset();
    }
    function ZoneScore(zone) {
        this.zone = zone;
        this.offsetScore = 0;
        this.abbrScore = 0;
    }
    ZoneScore.prototype.scoreOffsetAt = function(offsetAt) {
        this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
        if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, "") !== offsetAt.abbr) this.abbrScore++;
    };
    function findChange(low, high) {
        var mid, diff;
        while(diff = ((high.at - low.at) / 12e4 | 0) * 6e4){
            mid = new OffsetAt(new Date(low.at + diff));
            if (mid.offset === low.offset) low = mid;
            else high = mid;
        }
        return low;
    }
    function userOffsets() {
        var startYear = new Date().getFullYear() - 2, last = new OffsetAt(new Date(startYear, 0, 1)), offsets = [
            last
        ], change, next, i;
        for(i = 1; i < 48; i++){
            next = new OffsetAt(new Date(startYear, i, 1));
            if (next.offset !== last.offset) {
                change = findChange(last, next);
                offsets.push(change);
                offsets.push(new OffsetAt(new Date(change.at + 6e4)));
            }
            last = next;
        }
        for(i = 0; i < 4; i++){
            offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
            offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
        }
        return offsets;
    }
    function sortZoneScores(a, b) {
        if (a.offsetScore !== b.offsetScore) return a.offsetScore - b.offsetScore;
        if (a.abbrScore !== b.abbrScore) return a.abbrScore - b.abbrScore;
        if (a.zone.population !== b.zone.population) return b.zone.population - a.zone.population;
        return b.zone.name.localeCompare(a.zone.name);
    }
    function addToGuesses(name, offsets) {
        var i, offset;
        arrayToInt(offsets);
        for(i = 0; i < offsets.length; i++){
            offset = offsets[i];
            guesses[offset] = guesses[offset] || {};
            guesses[offset][name] = true;
        }
    }
    function guessesForUserOffsets(offsets) {
        var offsetsLength = offsets.length, filteredGuesses = {}, out = [], i, j, guessesOffset;
        for(i = 0; i < offsetsLength; i++){
            guessesOffset = guesses[offsets[i].offset] || {};
            for(j in guessesOffset)if (guessesOffset.hasOwnProperty(j)) filteredGuesses[j] = true;
        }
        for(i in filteredGuesses)if (filteredGuesses.hasOwnProperty(i)) out.push(names[i]);
        return out;
    }
    function rebuildGuess() {
        // use Intl API when available and returning valid time zone
        try {
            var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (intlName && intlName.length > 3) {
                var name = names[normalizeName(intlName)];
                if (name) return name;
                logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
            }
        } catch (e) {
        // Intl unavailable, fall back to manual guessing.
        }
        var offsets = userOffsets(), offsetsLength = offsets.length, guesses = guessesForUserOffsets(offsets), zoneScores = [], zoneScore, i, j;
        for(i = 0; i < guesses.length; i++){
            zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
            for(j = 0; j < offsetsLength; j++)zoneScore.scoreOffsetAt(offsets[j]);
            zoneScores.push(zoneScore);
        }
        zoneScores.sort(sortZoneScores);
        return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
    }
    function guess(ignoreCache) {
        if (!cachedGuess || ignoreCache) cachedGuess = rebuildGuess();
        return cachedGuess;
    }
    /************************************
		Global Methods
	************************************/ function normalizeName(name) {
        return (name || "").toLowerCase().replace(/\//g, "_");
    }
    function addZone(packed) {
        var i, name, split, normalized;
        if (typeof packed === "string") packed = [
            packed
        ];
        for(i = 0; i < packed.length; i++){
            split = packed[i].split("|");
            name = split[0];
            normalized = normalizeName(name);
            zones[normalized] = packed[i];
            names[normalized] = name;
            addToGuesses(normalized, split[2].split(" "));
        }
    }
    function getZone(name, caller) {
        name = normalizeName(name);
        var zone = zones[name];
        var link;
        if (zone instanceof Zone) return zone;
        if (typeof zone === "string") {
            zone = new Zone(zone);
            zones[name] = zone;
            return zone;
        }
        // Pass getZone to prevent recursion more than 1 level deep
        if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
            zone = zones[name] = new Zone();
            zone._set(link);
            zone.name = names[name];
            return zone;
        }
        return null;
    }
    function getNames() {
        var i, out = [];
        for(i in names)if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) out.push(names[i]);
        return out.sort();
    }
    function getCountryNames() {
        return Object.keys(countries);
    }
    function addLink(aliases) {
        var i, alias, normal0, normal1;
        if (typeof aliases === "string") aliases = [
            aliases
        ];
        for(i = 0; i < aliases.length; i++){
            alias = aliases[i].split("|");
            normal0 = normalizeName(alias[0]);
            normal1 = normalizeName(alias[1]);
            links[normal0] = normal1;
            names[normal0] = alias[0];
            links[normal1] = normal0;
            names[normal1] = alias[1];
        }
    }
    function addCountries(data) {
        var i, country_code, country_zones, split;
        if (!data || !data.length) return;
        for(i = 0; i < data.length; i++){
            split = data[i].split("|");
            country_code = split[0].toUpperCase();
            country_zones = split[1].split(" ");
            countries[country_code] = new Country(country_code, country_zones);
        }
    }
    function getCountry(name) {
        name = name.toUpperCase();
        return countries[name] || null;
    }
    function zonesForCountry(country, with_offset) {
        country = getCountry(country);
        if (!country) return null;
        var zones = country.zones.sort();
        if (with_offset) return zones.map(function(zone_name) {
            var zone = getZone(zone_name);
            return {
                name: zone_name,
                offset: zone.utcOffset(new Date())
            };
        });
        return zones;
    }
    function loadData(data) {
        addZone(data.zones);
        addLink(data.links);
        addCountries(data.countries);
        tz.dataVersion = data.version;
    }
    function zoneExists(name) {
        if (!zoneExists.didShowError) {
            zoneExists.didShowError = true;
            logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
        }
        return !!getZone(name);
    }
    function needsOffset(m) {
        var isUnixTimestamp = m._f === "X" || m._f === "x";
        return !!(m._a && m._tzm === undefined && !isUnixTimestamp);
    }
    function logError(message) {
        if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    }
    /************************************
		moment.tz namespace
	************************************/ function tz(input) {
        var args = Array.prototype.slice.call(arguments, 0, -1), name = arguments[arguments.length - 1], zone = getZone(name), out = moment.utc.apply(null, args);
        if (zone && !moment.isMoment(input) && needsOffset(out)) out.add(zone.parse(out), "minutes");
        out.tz(name);
        return out;
    }
    tz.version = VERSION;
    tz.dataVersion = "";
    tz._zones = zones;
    tz._links = links;
    tz._names = names;
    tz._countries = countries;
    tz.add = addZone;
    tz.link = addLink;
    tz.load = loadData;
    tz.zone = getZone;
    tz.zoneExists = zoneExists; // deprecated in 0.1.0
    tz.guess = guess;
    tz.names = getNames;
    tz.Zone = Zone;
    tz.unpack = unpack;
    tz.unpackBase60 = unpackBase60;
    tz.needsOffset = needsOffset;
    tz.moveInvalidForward = true;
    tz.moveAmbiguousForward = false;
    tz.countries = getCountryNames;
    tz.zonesForCountry = zonesForCountry;
    /************************************
		Interface with Moment.js
	************************************/ var fn = moment.fn;
    moment.tz = tz;
    moment.defaultZone = null;
    moment.updateOffset = function(mom, keepTime) {
        var zone = moment.defaultZone, offset;
        if (mom._z === undefined) {
            if (zone && needsOffset(mom) && !mom._isUTC) {
                mom._d = moment.utc(mom._a)._d;
                mom.utc().add(zone.parse(mom), "minutes");
            }
            mom._z = zone;
        }
        if (mom._z) {
            offset = mom._z.utcOffset(mom);
            if (Math.abs(offset) < 16) offset = offset / 60;
            if (mom.utcOffset !== undefined) {
                var z = mom._z;
                mom.utcOffset(-offset, keepTime);
                mom._z = z;
            } else mom.zone(offset, keepTime);
        }
    };
    fn.tz = function(name, keepTime) {
        if (name) {
            if (typeof name !== "string") throw new Error("Time zone name must be a string, got " + name + " [" + typeof name + "]");
            this._z = getZone(name);
            if (this._z) moment.updateOffset(this, keepTime);
            else logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
            return this;
        }
        if (this._z) return this._z.name;
    };
    function abbrWrap(old) {
        return function() {
            if (this._z) return this._z.abbr(this);
            return old.call(this);
        };
    }
    function resetZoneWrap(old) {
        return function() {
            this._z = null;
            return old.apply(this, arguments);
        };
    }
    function resetZoneWrap2(old) {
        return function() {
            if (arguments.length > 0) this._z = null;
            return old.apply(this, arguments);
        };
    }
    fn.zoneName = abbrWrap(fn.zoneName);
    fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
    fn.utc = resetZoneWrap(fn.utc);
    fn.local = resetZoneWrap(fn.local);
    fn.utcOffset = resetZoneWrap2(fn.utcOffset);
    moment.tz.setDefault = function(name) {
        if (major < 2 || major === 2 && minor < 9) logError("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + moment.version + ".");
        moment.defaultZone = name ? getZone(name) : null;
        return moment;
    };
    // Cloning a moment should include the _z property.
    var momentProperties = moment.momentProperties;
    if (Object.prototype.toString.call(momentProperties) === "[object Array]") {
        // moment 2.8.1+
        momentProperties.push("_z");
        momentProperties.push("_a");
    } else if (momentProperties) // moment 2.7.0
    momentProperties._z = null;
    // INJECT DATA
    return moment;
});

});
parcelRequire.register("45fvw", function(module, exports) {
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias("month", "M");
    // PRIORITY
    addUnitPriority("month", 8);
    // PARSING
    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ""));
            longPieces.push(this.months(mom, ""));
            mixedPieces.push(this.months(mom, ""));
            mixedPieces.push(this.monthsShort(mom, ""));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // ALIASES
    addUnitAlias("year", "y");
    // PRIORITIES
    addUnitPriority("year", 1);
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // ALIASES
    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");
    // PRIORITIES
    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);
    // PARSING
    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // ALIASES
    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");
    // PRIORITY
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // ALIASES
    addUnitAlias("hour", "h");
    // PRIORITY
    addUnitPriority("hour", 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("k", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match("^[^/\\\\]*$") != null;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");
    // PRIORITY
    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // ALIASES
    addUnitAlias("quarter", "Q");
    // PRIORITY
    addUnitPriority("quarter", 7);
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // ALIASES
    addUnitAlias("date", "D");
    // PRIORITY
    addUnitPriority("date", 9);
    // PARSING
    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // ALIASES
    addUnitAlias("dayOfYear", "DDD");
    // PRIORITY
    addUnitPriority("dayOfYear", 4);
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // ALIASES
    addUnitAlias("minute", "m");
    // PRIORITY
    addUnitPriority("minute", 14);
    // PARSING
    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // ALIASES
    addUnitAlias("second", "s");
    // PRIORITY
    addUnitPriority("second", 15);
    // PARSING
    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias("millisecond", "ms");
    // PRIORITY
    addUnitPriority("millisecond", 16);
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.29.4";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});


parcelRequire.register("iNtn6", function(module, exports) {
module.exports = JSON.parse('{"version":"2023c","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5","America/Bahia_Banderas|LMT MST CST MDT PST CDT|71 70 60 60 80 50|0121312141313131313131313131313131313152525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5","America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4","America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|","America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5","America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST MDT PST|7n.Q 70 60 60 80|0121312141313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|01212134121212121212121212121512121212121212121212125212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|01212134121212121212121212121212156565212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5","America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST MDT PST|75.E 70 60 60 80|0121312141313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4","America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5","America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|012121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0|","America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452","America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4","Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4","Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|01212121212121212121212121212121212343434343434343434343434343434312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 e10 2L0 WN0 14n0 gN0 5z0 11B0 WL0 e10 bb0 11B0 TX0 e10 dX0 11B0 On0 gN0 gL0 11B0 Lz0 e10 pb0 WN0 IL0 e10 rX0 WN0 Db0 gN0 uL0 11B0 xz0 e10 An0 11B0 rX0 gN0 Db0 11B0 pb0 e10 Lz0 WN0 mn0 e10 On0 WN0 gL0 gN0 Rb0 11B0 bb0 e10 WL0 11B0 5z0 gN0 11z0 11B0 2L0 gN0 14n0 1fB0 1cL0 1a10 1fz0 14p0 1lb0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 e10 28L0 e10 25X0 gN0 25X0 e10 gL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5","Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 e10 2L0 WN0 14n0 gN0 5z0 11B0 WL0 e10 bb0 11B0 TX0 e10 dX0 11B0 On0 gN0 gL0 11B0 Lz0 e10 pb0 WN0 IL0 e10 rX0 WN0 Db0 gN0 uL0 11B0 xz0 e10 An0 11B0 rX0 gN0 Db0 11B0 pb0 e10 Lz0 WN0 mn0 e10 On0 WN0 gL0 gN0 Rb0 11B0 bb0 e10 WL0 11B0 5z0 gN0 11z0 11B0 2L0 gN0 14n0 1fB0 1cL0 1a10 1fz0 14p0 1lb0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 e10 28L0 e10 25X0 gN0 25X0 e10 gL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|LMT LMT PST PDT JST|fU -84 -80 -90 -90|01232423232|-54m84 2clc0 1vfc4 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 XA0 Wou JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|LMT HMT -02 -01 +00 WET|1G.E 1S.w 20 10 0 0|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232343434343434343434343434343434345434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4","Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30","Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Etc/GMT-10|+10|-a0|0||","Etc/GMT-11|+11|-b0|0||","Etc/GMT-12|+12|-c0|0||","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Etc/GMT-7|+07|-70|0||","Etc/GMT-8|+08|-80|0||","Etc/GMT-9|+09|-90|0||","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+2|-02|20|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5","Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5","Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5","Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4","Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5","Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6","Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4","Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1","Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4","Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2","Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2","Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3","Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56","Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/Reykjavik","Africa/Abidjan|Atlantic/St_Helena","Africa/Abidjan|Iceland","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Chicago|US/Central","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|America/Yellowknife","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Iqaluit|America/Pangnirtung","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Atikokan","America/Panama|America/Cayman","America/Panama|America/Coral_Harbour","America/Phoenix|America/Creston","America/Phoenix|US/Arizona","America/Puerto_Rico|America/Anguilla","America/Puerto_Rico|America/Antigua","America/Puerto_Rico|America/Aruba","America/Puerto_Rico|America/Blanc-Sablon","America/Puerto_Rico|America/Curacao","America/Puerto_Rico|America/Dominica","America/Puerto_Rico|America/Grenada","America/Puerto_Rico|America/Guadeloupe","America/Puerto_Rico|America/Kralendijk","America/Puerto_Rico|America/Lower_Princes","America/Puerto_Rico|America/Marigot","America/Puerto_Rico|America/Montserrat","America/Puerto_Rico|America/Port_of_Spain","America/Puerto_Rico|America/St_Barthelemy","America/Puerto_Rico|America/St_Kitts","America/Puerto_Rico|America/St_Lucia","America/Puerto_Rico|America/St_Thomas","America/Puerto_Rico|America/St_Vincent","America/Puerto_Rico|America/Tortola","America/Puerto_Rico|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|America/Nassau","America/Toronto|America/Nipigon","America/Toronto|America/Thunder_Bay","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|America/Rainy_River","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Bangkok|Indian/Christmas","Asia/Brunei|Asia/Kuching","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Dubai|Indian/Mahe","Asia/Dubai|Indian/Reunion","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Rangoon|Indian/Cocos","Asia/Riyadh|Antarctica/Syowa","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Antarctica/Vostok","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Currie","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Berlin|Arctic/Longyearbyen","Europe/Berlin|Atlantic/Jan_Mayen","Europe/Berlin|Europe/Copenhagen","Europe/Berlin|Europe/Oslo","Europe/Berlin|Europe/Stockholm","Europe/Brussels|Europe/Amsterdam","Europe/Brussels|Europe/Luxembourg","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Kiev|Europe/Kyiv","Europe/Kiev|Europe/Uzhgorod","Europe/Kiev|Europe/Zaporozhye","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Paris|Europe/Monaco","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Maldives|Indian/Kerguelen","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Enderbury|Pacific/Kanton","Pacific/Guadalcanal|Pacific/Pohnpei","Pacific/Guadalcanal|Pacific/Ponape","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Port_Moresby|Antarctica/DumontDUrville","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Majuro","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Puerto_Rico America/Antigua","AI|America/Puerto_Rico America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Asia/Urumqi Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa Antarctica/Vostok","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Puerto_Rico America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Puerto_Rico America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Kuching Asia/Brunei","BO|America/La_Paz","BQ|America/Puerto_Rico America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Toronto America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston","CC|Asia/Yangon Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Puerto_Rico America/Curacao","CX|Asia/Bangkok Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Berlin Europe/Copenhagen","DM|America/Puerto_Rico America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Puerto_Rico America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Abidjan Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Puerto_Rico America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Africa/Abidjan Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Puerto_Rico America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Puerto_Rico America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Brussels Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Paris Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Puerto_Rico America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Puerto_Rico America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana","MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Brussels Europe/Amsterdam","NO|Europe/Berlin Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Asia/Dubai Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Asia/Dubai Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Berlin Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Berlin Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Puerto_Rico America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Asia/Dubai Indian/Maldives Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Puerto_Rico America/Port_of_Spain","TV|Pacific/Tarawa Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kyiv","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Puerto_Rico America/St_Vincent","VE|America/Caracas","VG|America/Puerto_Rico America/Tortola","VI|America/Puerto_Rico America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Tarawa Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}');

});

parcelRequire.register("28aOW", function(module, exports) {

module.exports = import("./" + (parcelRequire("27Lyk")).resolve("8ohr6")).then(()=>parcelRequire("6yf3X"));

});

parcelRequire.register("2aSuR", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("27Lyk")).resolve("8ohr6")),
    import("./" + (parcelRequire("27Lyk")).resolve("eTPMR"))
]).then(()=>parcelRequire("lPtd6"));

});

parcelRequire.register("6KOho", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.0
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-05-11T18:29Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.0", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            else if (nodeType === 1 || nodeType === 9 || nodeType === 11) return elem.textContent;
            else if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\x00") return "�";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\x00-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors (see trac-13936)
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented
        // as part of Sizzle so let's maintain them in the 3.x line
        // for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Reenable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is display: block
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRequire.register("kJWRP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f195ac6af4853fa1$export$2e2bcd8739ae039);
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $f195ac6af4853fa1$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && typeof navigator !== "undefined";
var $f195ac6af4853fa1$var$timeoutDuration = function() {
    var longerTimeoutBrowsers = [
        "Edge",
        "Trident",
        "Firefox"
    ];
    for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
        if ($f195ac6af4853fa1$var$isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
    }
    return 0;
}();
function $f195ac6af4853fa1$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $f195ac6af4853fa1$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $f195ac6af4853fa1$var$timeoutDuration);
        }
    };
}
var $f195ac6af4853fa1$var$supportsMicroTasks = $f195ac6af4853fa1$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $f195ac6af4853fa1$var$debounce = $f195ac6af4853fa1$var$supportsMicroTasks ? $f195ac6af4853fa1$var$microtaskDebounce : $f195ac6af4853fa1$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $f195ac6af4853fa1$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === "[object Function]";
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $f195ac6af4853fa1$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $f195ac6af4853fa1$var$getParentNode(element) {
    if (element.nodeName === "HTML") return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $f195ac6af4853fa1$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case "HTML":
        case "BODY":
            return element.ownerDocument.body;
        case "#document":
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $f195ac6af4853fa1$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $f195ac6af4853fa1$var$getScrollParent($f195ac6af4853fa1$var$getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */ function $f195ac6af4853fa1$var$getReferenceNode(reference) {
    return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var $f195ac6af4853fa1$var$isIE11 = $f195ac6af4853fa1$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $f195ac6af4853fa1$var$isIE10 = $f195ac6af4853fa1$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $f195ac6af4853fa1$var$isIE(version) {
    if (version === 11) return $f195ac6af4853fa1$var$isIE11;
    if (version === 10) return $f195ac6af4853fa1$var$isIE10;
    return $f195ac6af4853fa1$var$isIE11 || $f195ac6af4853fa1$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $f195ac6af4853fa1$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $f195ac6af4853fa1$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === "BODY" || nodeName === "HTML") return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        "TH",
        "TD",
        "TABLE"
    ].indexOf(offsetParent.nodeName) !== -1 && $f195ac6af4853fa1$var$getStyleComputedProperty(offsetParent, "position") === "static") return $f195ac6af4853fa1$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $f195ac6af4853fa1$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === "BODY") return false;
    return nodeName === "HTML" || $f195ac6af4853fa1$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $f195ac6af4853fa1$var$getRoot(node) {
    if (node.parentNode !== null) return $f195ac6af4853fa1$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $f195ac6af4853fa1$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($f195ac6af4853fa1$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $f195ac6af4853fa1$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $f195ac6af4853fa1$var$getRoot(element1);
    if (element1root.host) return $f195ac6af4853fa1$var$findCommonOffsetParent(element1root.host, element2);
    else return $f195ac6af4853fa1$var$findCommonOffsetParent(element1, $f195ac6af4853fa1$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $f195ac6af4853fa1$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "top";
    var upperSide = side === "top" ? "scrollTop" : "scrollLeft";
    var nodeName = element.nodeName;
    if (nodeName === "BODY" || nodeName === "HTML") {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $f195ac6af4853fa1$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $f195ac6af4853fa1$var$getScroll(element, "top");
    var scrollLeft = $f195ac6af4853fa1$var$getScroll(element, "left");
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $f195ac6af4853fa1$var$getBordersSize(styles, axis) {
    var sideA = axis === "x" ? "Left" : "Top";
    var sideB = sideA === "Left" ? "Right" : "Bottom";
    return parseFloat(styles["border" + sideA + "Width"]) + parseFloat(styles["border" + sideB + "Width"]);
}
function $f195ac6af4853fa1$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body["offset" + axis], body["scroll" + axis], html["client" + axis], html["offset" + axis], html["scroll" + axis], $f195ac6af4853fa1$var$isIE(10) ? parseInt(html["offset" + axis]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Top" : "Left")]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Bottom" : "Right")]) : 0);
}
function $f195ac6af4853fa1$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $f195ac6af4853fa1$var$isIE(10) && getComputedStyle(html);
    return {
        height: $f195ac6af4853fa1$var$getSize("Height", body, html, computedStyle),
        width: $f195ac6af4853fa1$var$getSize("Width", body, html, computedStyle)
    };
}
var $f195ac6af4853fa1$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $f195ac6af4853fa1$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $f195ac6af4853fa1$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $f195ac6af4853fa1$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $f195ac6af4853fa1$var$getClientRect(offsets) {
    return $f195ac6af4853fa1$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $f195ac6af4853fa1$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($f195ac6af4853fa1$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $f195ac6af4853fa1$var$getScroll(element, "top");
            var scrollLeft = $f195ac6af4853fa1$var$getScroll(element, "left");
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === "HTML" ? $f195ac6af4853fa1$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.width;
    var height = sizes.height || element.clientHeight || result.height;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $f195ac6af4853fa1$var$getStyleComputedProperty(element);
        horizScrollbar -= $f195ac6af4853fa1$var$getBordersSize(styles, "x");
        vertScrollbar -= $f195ac6af4853fa1$var$getBordersSize(styles, "y");
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $f195ac6af4853fa1$var$getClientRect(result);
}
function $f195ac6af4853fa1$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $f195ac6af4853fa1$var$isIE(10);
    var isHTML = parent.nodeName === "HTML";
    var childrenRect = $f195ac6af4853fa1$var$getBoundingClientRect(children);
    var parentRect = $f195ac6af4853fa1$var$getBoundingClientRect(parent);
    var scrollParent = $f195ac6af4853fa1$var$getScrollParent(children);
    var styles = $f195ac6af4853fa1$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $f195ac6af4853fa1$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop);
        var marginLeft = parseFloat(styles.marginLeft);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== "BODY") offsets = $f195ac6af4853fa1$var$includeScroll(offsets, parent);
    return offsets;
}
function $f195ac6af4853fa1$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $f195ac6af4853fa1$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $f195ac6af4853fa1$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $f195ac6af4853fa1$var$getScroll(html, "left") : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $f195ac6af4853fa1$var$getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $f195ac6af4853fa1$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === "BODY" || nodeName === "HTML") return false;
    if ($f195ac6af4853fa1$var$getStyleComputedProperty(element, "position") === "fixed") return true;
    var parentNode = $f195ac6af4853fa1$var$getParentNode(element);
    if (!parentNode) return false;
    return $f195ac6af4853fa1$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $f195ac6af4853fa1$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $f195ac6af4853fa1$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $f195ac6af4853fa1$var$getStyleComputedProperty(el, "transform") === "none")el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $f195ac6af4853fa1$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $f195ac6af4853fa1$var$getFixedPositionOffsetParent(popper) : $f195ac6af4853fa1$var$findCommonOffsetParent(popper, $f195ac6af4853fa1$var$getReferenceNode(reference));
    // Handle viewport case
    if (boundariesElement === "viewport") boundaries = $f195ac6af4853fa1$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === "scrollParent") {
            boundariesNode = $f195ac6af4853fa1$var$getScrollParent($f195ac6af4853fa1$var$getParentNode(reference));
            if (boundariesNode.nodeName === "BODY") boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === "window") boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $f195ac6af4853fa1$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === "HTML" && !$f195ac6af4853fa1$var$isFixed(offsetParent)) {
            var _getWindowSizes = $f195ac6af4853fa1$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === "number";
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $f195ac6af4853fa1$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf("auto") === -1) return placement;
    var boundaries = $f195ac6af4853fa1$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $f195ac6af4853fa1$var$_extends({
            key: key
        }, rects[key], {
            area: $f195ac6af4853fa1$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split("-")[1];
    return computedPlacement + (variation ? "-" + variation : "");
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $f195ac6af4853fa1$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $f195ac6af4853fa1$var$getFixedPositionOffsetParent(popper) : $f195ac6af4853fa1$var$findCommonOffsetParent(popper, $f195ac6af4853fa1$var$getReferenceNode(reference));
    return $f195ac6af4853fa1$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $f195ac6af4853fa1$var$getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $f195ac6af4853fa1$var$getOppositePlacement(placement) {
    var hash = {
        left: "right",
        right: "left",
        bottom: "top",
        top: "bottom"
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $f195ac6af4853fa1$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split("-")[0];
    // Get popper node sizes
    var popperRect = $f195ac6af4853fa1$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        "right",
        "left"
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? "top" : "left";
    var secondarySide = isHoriz ? "left" : "top";
    var measurement = isHoriz ? "height" : "width";
    var secondaryMeasurement = !isHoriz ? "height" : "width";
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$f195ac6af4853fa1$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $f195ac6af4853fa1$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $f195ac6af4853fa1$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $f195ac6af4853fa1$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $f195ac6af4853fa1$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $f195ac6af4853fa1$var$findIndex(modifiers, "name", ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier["function"]) // eslint-disable-line dot-notation
        console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
        var fn = modifier["function"] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $f195ac6af4853fa1$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $f195ac6af4853fa1$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $f195ac6af4853fa1$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $f195ac6af4853fa1$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $f195ac6af4853fa1$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $f195ac6af4853fa1$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $f195ac6af4853fa1$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute";
    // run the modifiers
    data = $f195ac6af4853fa1$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $f195ac6af4853fa1$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $f195ac6af4853fa1$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        "ms",
        "Webkit",
        "Moz",
        "O"
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? "" + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== "undefined") return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $f195ac6af4853fa1$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($f195ac6af4853fa1$var$isModifierEnabled(this.modifiers, "applyStyle")) {
        this.popper.removeAttribute("x-placement");
        this.popper.style.position = "";
        this.popper.style.top = "";
        this.popper.style.left = "";
        this.popper.style.right = "";
        this.popper.style.bottom = "";
        this.popper.style.willChange = "";
        this.popper.style[$f195ac6af4853fa1$var$getSupportedPropertyName("transform")] = "";
    }
    this.disableEventListeners();
    // remove the popper if user explicitly asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $f195ac6af4853fa1$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $f195ac6af4853fa1$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === "BODY";
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $f195ac6af4853fa1$var$attachToScrollParents($f195ac6af4853fa1$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $f195ac6af4853fa1$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $f195ac6af4853fa1$var$getWindow(reference).addEventListener("resize", state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $f195ac6af4853fa1$var$getScrollParent(reference);
    $f195ac6af4853fa1$var$attachToScrollParents(scrollElement, "scroll", state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $f195ac6af4853fa1$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $f195ac6af4853fa1$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $f195ac6af4853fa1$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $f195ac6af4853fa1$var$getWindow(reference).removeEventListener("resize", state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener("scroll", state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $f195ac6af4853fa1$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $f195ac6af4853fa1$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $f195ac6af4853fa1$var$isNumeric(n) {
    return n !== "" && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $f195ac6af4853fa1$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = "";
        // add unit if the value is numeric and is one of the following
        if ([
            "width",
            "height",
            "top",
            "right",
            "bottom",
            "left"
        ].indexOf(prop) !== -1 && $f195ac6af4853fa1$var$isNumeric(styles[prop])) unit = "px";
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $f195ac6af4853fa1$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $f195ac6af4853fa1$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $f195ac6af4853fa1$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $f195ac6af4853fa1$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $f195ac6af4853fa1$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $f195ac6af4853fa1$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $f195ac6af4853fa1$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $f195ac6af4853fa1$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute("x-placement", placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $f195ac6af4853fa1$var$setStyles(popper, {
        position: options.positionFixed ? "fixed" : "absolute"
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $f195ac6af4853fa1$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        "left",
        "right"
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf("-") !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $f195ac6af4853fa1$var$isFirefox = $f195ac6af4853fa1$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $f195ac6af4853fa1$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === "applyStyle";
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $f195ac6af4853fa1$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $f195ac6af4853fa1$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $f195ac6af4853fa1$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$f195ac6af4853fa1$var$isFirefox);
    var sideA = x === "bottom" ? "top" : "bottom";
    var sideB = y === "right" ? "left" : "right";
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $f195ac6af4853fa1$var$getSupportedPropertyName("transform");
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === "bottom") {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === "HTML") top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === "right") {
        if (offsetParent.nodeName === "HTML") left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = "translate3d(" + left + "px, " + top + "px, 0)";
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = "transform";
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === "bottom" ? -1 : 1;
        var invertLeft = sideB === "right" ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ", " + sideB;
    }
    // Attributes
    var attributes = {
        "x-placement": data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $f195ac6af4853fa1$var$_extends({}, attributes, data.attributes);
    data.styles = $f195ac6af4853fa1$var$_extends({}, styles, data.styles);
    data.arrowStyles = $f195ac6af4853fa1$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $f195ac6af4853fa1$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $f195ac6af4853fa1$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = "`" + requestingName + "`";
        var requested = "`" + requestedName + "`";
        console.warn(requested + " modifier is required by " + _requesting + " modifier in order to work, be sure to include it before " + _requesting + "!");
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$f195ac6af4853fa1$var$isModifierRequired(data.instance.modifiers, "arrow", "keepTogether")) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn("WARNING: `arrow.element` must be child of its popper element!");
        return data;
    }
    var placement = data.placement.split("-")[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        "left",
        "right"
    ].indexOf(placement) !== -1;
    var len = isVertical ? "height" : "width";
    var sideCapitalized = isVertical ? "Top" : "Left";
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? "left" : "top";
    var opSide = isVertical ? "bottom" : "right";
    var arrowElementSize = $f195ac6af4853fa1$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $f195ac6af4853fa1$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $f195ac6af4853fa1$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css["margin" + sideCapitalized]);
    var popperBorderSide = parseFloat(css["border" + sideCapitalized + "Width"]);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $f195ac6af4853fa1$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $f195ac6af4853fa1$var$defineProperty(_data$offsets$arrow, altSide, ""), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $f195ac6af4853fa1$var$getOppositeVariation(variation) {
    if (variation === "end") return "start";
    else if (variation === "start") return "end";
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $f195ac6af4853fa1$var$placements = [
    "auto-start",
    "auto",
    "auto-end",
    "top-start",
    "top",
    "top-end",
    "right-start",
    "right",
    "right-end",
    "bottom-end",
    "bottom",
    "bottom-start",
    "left-end",
    "left",
    "left-start"
];
// Get rid of `auto` `auto-start` and `auto-end`
var $f195ac6af4853fa1$var$validPlacements = $f195ac6af4853fa1$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $f195ac6af4853fa1$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $f195ac6af4853fa1$var$validPlacements.indexOf(placement);
    var arr = $f195ac6af4853fa1$var$validPlacements.slice(index + 1).concat($f195ac6af4853fa1$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $f195ac6af4853fa1$var$BEHAVIORS = {
    FLIP: "flip",
    CLOCKWISE: "clockwise",
    COUNTERCLOCKWISE: "counterclockwise"
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($f195ac6af4853fa1$var$isModifierEnabled(data.instance.modifiers, "inner")) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $f195ac6af4853fa1$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split("-")[0];
    var placementOpposite = $f195ac6af4853fa1$var$getOppositePlacement(placement);
    var variation = data.placement.split("-")[1] || "";
    var flipOrder = [];
    switch(options.behavior){
        case $f195ac6af4853fa1$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $f195ac6af4853fa1$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $f195ac6af4853fa1$var$clockwise(placement);
            break;
        case $f195ac6af4853fa1$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $f195ac6af4853fa1$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split("-")[0];
        placementOpposite = $f195ac6af4853fa1$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === "left" && floor(popperOffsets.right) > floor(refOffsets.left) || placement === "right" && floor(popperOffsets.left) < floor(refOffsets.right) || placement === "top" && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === "bottom" && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === "left" && overflowsLeft || placement === "right" && overflowsRight || placement === "top" && overflowsTop || placement === "bottom" && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            "top",
            "bottom"
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === "start" && overflowsLeft || isVertical && variation === "end" && overflowsRight || !isVertical && variation === "start" && overflowsTop || !isVertical && variation === "end" && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === "start" && overflowsRight || isVertical && variation === "end" && overflowsLeft || !isVertical && variation === "start" && overflowsBottom || !isVertical && variation === "end" && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $f195ac6af4853fa1$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? "-" + variation : "");
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $f195ac6af4853fa1$var$_extends({}, data.offsets.popper, $f195ac6af4853fa1$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $f195ac6af4853fa1$var$runModifiers(data.instance.modifiers, data, "flip");
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split("-")[0];
    var floor = Math.floor;
    var isVertical = [
        "top",
        "bottom"
    ].indexOf(placement) !== -1;
    var side = isVertical ? "right" : "bottom";
    var opSide = isVertical ? "left" : "top";
    var measurement = isVertical ? "width" : "height";
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $f195ac6af4853fa1$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf("%") === 0) {
        var element = void 0;
        switch(unit){
            case "%p":
                element = popperOffsets;
                break;
            case "%":
            case "%r":
            default:
                element = referenceOffsets;
        }
        var rect = $f195ac6af4853fa1$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === "vh" || unit === "vw") {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === "vh") size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $f195ac6af4853fa1$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        "right",
        "left"
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($f195ac6af4853fa1$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(",") === -1) console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? "height" : "width";
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === "" && [
                "+",
                "-"
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $f195ac6af4853fa1$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($f195ac6af4853fa1$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === "-" ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split("-")[0];
    var offsets = void 0;
    if ($f195ac6af4853fa1$var$isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = $f195ac6af4853fa1$var$parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === "left") {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === "right") {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === "top") {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === "bottom") {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $f195ac6af4853fa1$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $f195ac6af4853fa1$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $f195ac6af4853fa1$var$getSupportedPropertyName("transform");
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = "";
    popperStyles.left = "";
    popperStyles[transformProp] = "";
    var boundaries = $f195ac6af4853fa1$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $f195ac6af4853fa1$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === "right" ? "left" : "top";
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === "right" ? popper.width : popper.height));
            return $f195ac6af4853fa1$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            "left",
            "top"
        ].indexOf(placement) !== -1 ? "primary" : "secondary";
        popper = $f195ac6af4853fa1$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split("-")[0];
    var shiftvariation = placement.split("-")[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            "bottom",
            "top"
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? "left" : "top";
        var measurement = isVertical ? "width" : "height";
        var shiftOffsets = {
            start: $f195ac6af4853fa1$var$defineProperty({}, side, reference[side]),
            end: $f195ac6af4853fa1$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $f195ac6af4853fa1$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$hide(data) {
    if (!$f195ac6af4853fa1$var$isModifierRequired(data.instance.modifiers, "hide", "preventOverflow")) return data;
    var refRect = data.offsets.reference;
    var bound = $f195ac6af4853fa1$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === "preventOverflow";
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes["x-out-of-boundaries"] = "";
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes["x-out-of-boundaries"] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split("-")[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        "left",
        "right"
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        "top",
        "left"
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? "left" : "top"] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? "width" : "height"] : 0);
    data.placement = $f195ac6af4853fa1$var$getOppositePlacement(placement);
    data.offsets.popper = $f195ac6af4853fa1$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $f195ac6af4853fa1$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            "left",
            "right",
            "top",
            "bottom"
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: "scrollParent"
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: "[x-arrow]"
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: "flip",
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: "viewport",
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: "bottom",
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: "right"
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$applyStyle,
        /** @prop {Function} */ onLoad: $f195ac6af4853fa1$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $f195ac6af4853fa1$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: "bottom",
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $f195ac6af4853fa1$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $f195ac6af4853fa1$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $f195ac6af4853fa1$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $f195ac6af4853fa1$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $f195ac6af4853fa1$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($f195ac6af4853fa1$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $f195ac6af4853fa1$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $f195ac6af4853fa1$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $f195ac6af4853fa1$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $f195ac6af4853fa1$var$createClass(Popper, [
        {
            key: "update",
            value: function update$$1() {
                return $f195ac6af4853fa1$var$update.call(this);
            }
        },
        {
            key: "destroy",
            value: function destroy$$1() {
                return $f195ac6af4853fa1$var$destroy.call(this);
            }
        },
        {
            key: "enableEventListeners",
            value: function enableEventListeners$$1() {
                return $f195ac6af4853fa1$var$enableEventListeners.call(this);
            }
        },
        {
            key: "disableEventListeners",
            value: function disableEventListeners$$1() {
                return $f195ac6af4853fa1$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $f195ac6af4853fa1$var$Popper.Utils = (typeof window !== "undefined" ? window : $parcel$global).PopperUtils;
$f195ac6af4853fa1$var$Popper.placements = $f195ac6af4853fa1$var$placements;
$f195ac6af4853fa1$var$Popper.Defaults = $f195ac6af4853fa1$var$Defaults;
var $f195ac6af4853fa1$export$2e2bcd8739ae039 = $f195ac6af4853fa1$var$Popper;

});

parcelRequire.register("05SHZ", function(module, exports) {

/*!
  * Bootstrap util.js v4.6.2 (https://getbootstrap.com/)
  * Copyright 2011-2022 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("6KOho")));
})(module.exports, function($) {
    "use strict";
    function _interopDefaultLegacy(e) {
        return e && typeof e === "object" && "default" in e ? e : {
            "default": e
        };
    }
    var $__default = /*#__PURE__*/ _interopDefaultLegacy($);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.6.2): util.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Private TransitionEnd Helpers
   */ var TRANSITION_END = "transitionend";
    var MAX_UID = 1000000;
    var MILLISECONDS_MULTIPLIER = 1000; // Shoutout AngusCroll (https://goo.gl/pxwQGp)
    function toType(obj) {
        if (obj === null || typeof obj === "undefined") return "" + obj;
        return ({}).toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
    }
    function getSpecialTransitionEndEvent() {
        return {
            bindType: TRANSITION_END,
            delegateType: TRANSITION_END,
            handle: function handle(event) {
                if ($__default["default"](event.target).is(this)) return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
                return undefined;
            }
        };
    }
    function transitionEndEmulator(duration) {
        var _this = this;
        var called = false;
        $__default["default"](this).one(Util.TRANSITION_END, function() {
            called = true;
        });
        setTimeout(function() {
            if (!called) Util.triggerTransitionEnd(_this);
        }, duration);
        return this;
    }
    function setTransitionEndSupport() {
        $__default["default"].fn.emulateTransitionEnd = transitionEndEmulator;
        $__default["default"].event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
    }
    /**
   * Public Util API
   */ var Util = {
        TRANSITION_END: "bsTransitionEnd",
        getUID: function getUID(prefix) {
            do // eslint-disable-next-line no-bitwise
            prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
            while (document.getElementById(prefix));
            return prefix;
        },
        getSelectorFromElement: function getSelectorFromElement(element) {
            var selector = element.getAttribute("data-target");
            if (!selector || selector === "#") {
                var hrefAttr = element.getAttribute("href");
                selector = hrefAttr && hrefAttr !== "#" ? hrefAttr.trim() : "";
            }
            try {
                return document.querySelector(selector) ? selector : null;
            } catch (_) {
                return null;
            }
        },
        getTransitionDurationFromElement: function getTransitionDurationFromElement(element) {
            if (!element) return 0;
             // Get transition-duration of the element
            var transitionDuration = $__default["default"](element).css("transition-duration");
            var transitionDelay = $__default["default"](element).css("transition-delay");
            var floatTransitionDuration = parseFloat(transitionDuration);
            var floatTransitionDelay = parseFloat(transitionDelay); // Return 0 if element or transition duration is not found
            if (!floatTransitionDuration && !floatTransitionDelay) return 0;
             // If multiple durations are defined, take the first
            transitionDuration = transitionDuration.split(",")[0];
            transitionDelay = transitionDelay.split(",")[0];
            return (parseFloat(transitionDuration) + parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
        },
        reflow: function reflow(element) {
            return element.offsetHeight;
        },
        triggerTransitionEnd: function triggerTransitionEnd(element) {
            $__default["default"](element).trigger(TRANSITION_END);
        },
        supportsTransitionEnd: function supportsTransitionEnd() {
            return Boolean(TRANSITION_END);
        },
        isElement: function isElement(obj) {
            return (obj[0] || obj).nodeType;
        },
        typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
            for(var property in configTypes)if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
                var expectedTypes = configTypes[property];
                var value = config[property];
                var valueType = value && Util.isElement(value) ? "element" : toType(value);
                if (!new RegExp(expectedTypes).test(valueType)) throw new Error(componentName.toUpperCase() + ": " + ('Option "' + property + '" provided type "' + valueType + '" ') + ('but expected type "' + expectedTypes + '".'));
            }
        },
        findShadowRoot: function findShadowRoot(element) {
            if (!document.documentElement.attachShadow) return null;
             // Can find the shadow root otherwise it'll return the document
            if (typeof element.getRootNode === "function") {
                var root = element.getRootNode();
                return root instanceof ShadowRoot ? root : null;
            }
            if (element instanceof ShadowRoot) return element;
             // when we don't find a shadow root
            if (!element.parentNode) return null;
            return Util.findShadowRoot(element.parentNode);
        },
        jQueryDetection: function jQueryDetection() {
            if (typeof $__default["default"] === "undefined") throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");
            var version = $__default["default"].fn.jquery.split(" ")[0].split(".");
            var minMajor = 1;
            var ltMajor = 2;
            var minMinor = 9;
            var minPatch = 1;
            var maxMajor = 4;
            if (version[0] < ltMajor && version[1] < minMinor || version[0] === minMajor && version[1] === minMinor && version[2] < minPatch || version[0] >= maxMajor) throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0");
        }
    };
    Util.jQueryDetection();
    setTransitionEndSupport();
    return Util;
});

});

function $b8f57191916382d3$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(obj);
}



function $96eac03571e01dbf$export$2e2bcd8739ae039(input, hint) {
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(arg) {
    var key = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(arg, "string");
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $983350b7b3960a26$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $983350b7b3960a26$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $983350b7b3960a26$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $ad4393542232627c$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $ad4393542232627c$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $ad4393542232627c$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $ad4393542232627c$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $ad4393542232627c$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $ad4393542232627c$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $ad4393542232627c$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $ad4393542232627c$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $ad4393542232627c$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($ad4393542232627c$var$isDate(val)) return "date";
    if ($ad4393542232627c$var$isError(val)) return "error";
    var constructorName = $ad4393542232627c$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $ad4393542232627c$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $ad4393542232627c$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $ad4393542232627c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $ad4393542232627c$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $ad4393542232627c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($ad4393542232627c$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($ad4393542232627c$var$formatProdErrorMessage(1));
        return enhancer($ad4393542232627c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($ad4393542232627c$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($ad4393542232627c$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$ad4393542232627c$var$isPlainObject(action)) throw new Error($ad4393542232627c$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($ad4393542232627c$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($ad4393542232627c$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $ad4393542232627c$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$ad4393542232627c$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $ad4393542232627c$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$ad4393542232627c$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $ad4393542232627c$export$8928921ea2d3b126 = $ad4393542232627c$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ad4393542232627c$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $ad4393542232627c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $ad4393542232627c$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$ad4393542232627c$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $ad4393542232627c$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $ad4393542232627c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $ad4393542232627c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($ad4393542232627c$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($ad4393542232627c$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $ad4393542232627c$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $ad4393542232627c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $ad4393542232627c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $ad4393542232627c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $ad4393542232627c$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $ad4393542232627c$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $ad4393542232627c$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


/** PURE_IMPORTS_START _QueueAction,_QueueScheduler PURE_IMPORTS_END */ /** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $5c96a02c592fcff1$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */ 
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */ 
/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */ /** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $73c774b8baa8f75c$export$43bee75e5e14138e = /*@__PURE__*/ function() {
    return Array.isArray || function(x) {
        return x && typeof x.length === "number";
    };
}();


/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $8f49adcd985e1d52$export$a6cdc56e425d0d0a(x) {
    return x !== null && typeof x === "object";
}


/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $26db305c839bca5f$export$f6e2535fb5126e54(x) {
    return typeof x === "function";
}


/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $992a7f9fdade20e5$var$UnsubscriptionErrorImpl = /*@__PURE__*/ function() {
    function UnsubscriptionErrorImpl(errors) {
        Error.call(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
        return this;
    }
    UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return UnsubscriptionErrorImpl;
}();
var $992a7f9fdade20e5$export$c9648b76fd580c34 = $992a7f9fdade20e5$var$UnsubscriptionErrorImpl;


var $903811aedba8ff04$export$f55210826850c514 = /*@__PURE__*/ function() {
    function Subscription(unsubscribe) {
        this.closed = false;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._ctorUnsubscribe = true;
            this._unsubscribe = unsubscribe;
        }
    }
    Subscription.prototype.unsubscribe = function() {
        var errors;
        if (this.closed) return;
        var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (_parentOrParents instanceof Subscription) _parentOrParents.remove(this);
        else if (_parentOrParents !== null) for(var index = 0; index < _parentOrParents.length; ++index){
            var parent_1 = _parentOrParents[index];
            parent_1.remove(this);
        }
        if ((0, $26db305c839bca5f$export$f6e2535fb5126e54)(_unsubscribe)) {
            if (_ctorUnsubscribe) this._unsubscribe = undefined;
            try {
                _unsubscribe.call(this);
            } catch (e) {
                errors = e instanceof (0, $992a7f9fdade20e5$export$c9648b76fd580c34) ? $903811aedba8ff04$var$flattenUnsubscriptionErrors(e.errors) : [
                    e
                ];
            }
        }
        if ((0, $73c774b8baa8f75c$export$43bee75e5e14138e)(_subscriptions)) {
            var index = -1;
            var len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ((0, $8f49adcd985e1d52$export$a6cdc56e425d0d0a)(sub)) try {
                    sub.unsubscribe();
                } catch (e) {
                    errors = errors || [];
                    if (e instanceof (0, $992a7f9fdade20e5$export$c9648b76fd580c34)) errors = errors.concat($903811aedba8ff04$var$flattenUnsubscriptionErrors(e.errors));
                    else errors.push(e);
                }
            }
        }
        if (errors) throw new (0, $992a7f9fdade20e5$export$c9648b76fd580c34)(errors);
    };
    Subscription.prototype.add = function(teardown) {
        var subscription = teardown;
        if (!teardown) return Subscription.EMPTY;
        switch(typeof teardown){
            case "function":
                subscription = new Subscription(teardown);
            case "object":
                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== "function") return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (!(subscription instanceof Subscription)) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error("unrecognized teardown " + teardown + " added to Subscription.");
        }
        var _parentOrParents = subscription._parentOrParents;
        if (_parentOrParents === null) subscription._parentOrParents = this;
        else if (_parentOrParents instanceof Subscription) {
            if (_parentOrParents === this) return subscription;
            subscription._parentOrParents = [
                _parentOrParents,
                this
            ];
        } else if (_parentOrParents.indexOf(this) === -1) _parentOrParents.push(this);
        else return subscription;
        var subscriptions = this._subscriptions;
        if (subscriptions === null) this._subscriptions = [
            subscription
        ];
        else subscriptions.push(subscription);
        return subscription;
    };
    Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
function $903811aedba8ff04$var$flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof (0, $992a7f9fdade20e5$export$c9648b76fd580c34) ? err.errors : err);
    }, []);
}


var $f6d457e70509fbcb$export$e19cd5f9376f8cee = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, $903811aedba8ff04$export$f55210826850c514));


var $a95fe049686c7727$export$b5369ffd7cb2211b = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && this.delay === delay && this.pending === false) return id;
        clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error("executing a cancelled action");
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype._unsubscribe = function() {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) actions.splice(index, 1);
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
        this.delay = null;
    };
    return AsyncAction;
}((0, $f6d457e70509fbcb$export$e19cd5f9376f8cee));


var $d71256283e42e709$export$fec474e58f10935f = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (delay > 0) return _super.prototype.schedule.call(this, state, delay);
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function(state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        return scheduler.flush(this);
    };
    return QueueAction;
}((0, $a95fe049686c7727$export$b5369ffd7cb2211b));


/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */ 
/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */ 
var $150ac7182b4d266e$export$d3e54bb8584cda7c = /*@__PURE__*/ function() {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) now = Scheduler.now;
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = function() {
        return Date.now();
    };
    return Scheduler;
}();


var $5d24049566780726$export$4114a3ec92faa3c6 = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, $150ac7182b4d266e$export$d3e54bb8584cda7c).now;
        var _this = _super.call(this, SchedulerAction, function() {
            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) return AsyncScheduler.delegate.now();
            else return now();
        }) || this;
        _this.actions = [];
        _this.active = false;
        _this.scheduled = undefined;
        return _this;
    }
    AsyncScheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) return AsyncScheduler.delegate.schedule(work, delay, state);
        else return _super.prototype.schedule.call(this, work, delay, state);
    };
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this.active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, $150ac7182b4d266e$export$d3e54bb8584cda7c));


var $e6c8973ee880f348$export$6a0c75a6abc7ad50 = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}((0, $5d24049566780726$export$4114a3ec92faa3c6));


var $5dc13791984594d0$export$69a3263547af8af8 = /*@__PURE__*/ new (0, $e6c8973ee880f348$export$6a0c75a6abc7ad50)((0, $d71256283e42e709$export$fec474e58f10935f));
var $5dc13791984594d0$export$4f7fa46ff53e516f = $5dc13791984594d0$export$69a3263547af8af8;

/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */ 
/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */ /** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */ /** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */ 

/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */ /** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $8345ca6ec0377a1b$var$_enable_super_gross_mode_that_will_cause_bad_things = false;
var $8345ca6ec0377a1b$export$e506a1d27d1eaa20 = {
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling (value){
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn("DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n" + error.stack);
        } else if ($8345ca6ec0377a1b$var$_enable_super_gross_mode_that_will_cause_bad_things) /*@__PURE__*/ console.log("RxJS: Back to a better error behavior. Thank you. <3");
        $8345ca6ec0377a1b$var$_enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling () {
        return $8345ca6ec0377a1b$var$_enable_super_gross_mode_that_will_cause_bad_things;
    }
};


/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $f706439a796b1aea$export$ebb0f299889f975f(err) {
    setTimeout(function() {
        throw err;
    }, 0);
}


var $4d2e93797ac4fd7c$export$6e22c362a0406a2c = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        if ((0, $8345ca6ec0377a1b$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) throw err;
        else (0, $f706439a796b1aea$export$ebb0f299889f975f)(err);
    },
    complete: function() {}
};



/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $241f94060c5a71eb$export$77f77496d7cade10 = /*@__PURE__*/ function() {
    return typeof Symbol === "function" ? /*@__PURE__*/ Symbol("rxSubscriber") : "@@rxSubscriber_" + /*@__PURE__*/ Math.random();
}();
var $241f94060c5a71eb$export$4a2e07ff24d010f0 = $241f94060c5a71eb$export$77f77496d7cade10;




var $0c5e61cfa4404ac4$export$60959659b2c22881 = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch(arguments.length){
            case 0:
                _this.destination = (0, $4d2e93797ac4fd7c$export$6e22c362a0406a2c);
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = (0, $4d2e93797ac4fd7c$export$6e22c362a0406a2c);
                    break;
                }
                if (typeof destinationOrNext === "object") {
                    if (destinationOrNext instanceof Subscriber) {
                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        _this.destination = destinationOrNext;
                        destinationOrNext.add(_this);
                    } else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new $0c5e61cfa4404ac4$export$94eeb6a328cab6c7(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new $0c5e61cfa4404ac4$export$94eeb6a328cab6c7(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[0, $241f94060c5a71eb$export$77f77496d7cade10] = function() {
        return this;
    };
    Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _parentOrParents = this._parentOrParents;
        this._parentOrParents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parentOrParents = _parentOrParents;
        return this;
    };
    return Subscriber;
}((0, $903811aedba8ff04$export$f55210826850c514));
var $0c5e61cfa4404ac4$export$94eeb6a328cab6c7 = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if ((0, $26db305c839bca5f$export$f6e2535fb5126e54)(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== (0, $4d2e93797ac4fd7c$export$6e22c362a0406a2c)) {
                context = Object.create(observerOrNext);
                if ((0, $26db305c839bca5f$export$f6e2535fb5126e54)(context.unsubscribe)) _this.add(context.unsubscribe.bind(context));
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!(0, $8345ca6ec0377a1b$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = (0, $8345ca6ec0377a1b$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) throw err;
                (0, $f706439a796b1aea$export$ebb0f299889f975f)(err);
            } else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                } else (0, $f706439a796b1aea$export$ebb0f299889f975f)(err);
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!(0, $8345ca6ec0377a1b$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            if ((0, $8345ca6ec0377a1b$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) throw err;
            else (0, $f706439a796b1aea$export$ebb0f299889f975f)(err);
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        if (!(0, $8345ca6ec0377a1b$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) throw new Error("bad call");
        try {
            fn.call(this._context, value);
        } catch (err) {
            if ((0, $8345ca6ec0377a1b$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            } else {
                (0, $f706439a796b1aea$export$ebb0f299889f975f)(err);
                return true;
            }
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}($0c5e61cfa4404ac4$export$60959659b2c22881);


function $c352e8cd44aa2a9a$export$f7d54ecb625129e3(observer) {
    while(observer){
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) return false;
        else if (destination && destination instanceof (0, $0c5e61cfa4404ac4$export$60959659b2c22881)) observer = destination;
        else observer = null;
    }
    return true;
}


/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */ 


function $67b23ac9d57820a8$export$2a12c2cebbfd1087(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof (0, $0c5e61cfa4404ac4$export$60959659b2c22881)) return nextOrObserver;
        if (nextOrObserver[0, $241f94060c5a71eb$export$77f77496d7cade10]) return nextOrObserver[0, $241f94060c5a71eb$export$77f77496d7cade10]();
    }
    if (!nextOrObserver && !error && !complete) return new (0, $0c5e61cfa4404ac4$export$60959659b2c22881)((0, $4d2e93797ac4fd7c$export$6e22c362a0406a2c));
    return new (0, $0c5e61cfa4404ac4$export$60959659b2c22881)(nextOrObserver, error, complete);
}


/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $5587cca356a45e0d$export$5ab46cbf6120b33a = /*@__PURE__*/ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();


/** PURE_IMPORTS_START _identity PURE_IMPORTS_END */ /** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $e35fb39d7fe871e0$export$f0954fd7d5368655(x) {
    return x;
}


function $8e25beeee3ff28a2$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $8e25beeee3ff28a2$export$71f88a61afaa14d7(fns);
}
function $8e25beeee3ff28a2$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $e35fb39d7fe871e0$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}



var $87f1d8962784e676$export$77cea355fa80b5f4 = /*@__PURE__*/ function() {
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = (0, $67b23ac9d57820a8$export$2a12c2cebbfd1087)(observerOrNext, error, complete);
        if (operator) sink.add(operator.call(sink, this.source));
        else sink.add(this.source || (0, $8345ca6ec0377a1b$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if ((0, $8345ca6ec0377a1b$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            if ((0, $8345ca6ec0377a1b$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            if ((0, $c352e8cd44aa2a9a$export$f7d54ecb625129e3)(sink)) sink.error(err);
            else console.warn(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $87f1d8962784e676$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function(value) {
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    if (subscription) subscription.unsubscribe();
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    Observable.prototype[0, $5587cca356a45e0d$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        if (operations.length === 0) return this;
        return (0, $8e25beeee3ff28a2$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $87f1d8962784e676$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $87f1d8962784e676$var$getPromiseCtor(promiseCtor) {
    if (!promiseCtor) promiseCtor = (0, $8345ca6ec0377a1b$export$e506a1d27d1eaa20).Promise || Promise;
    if (!promiseCtor) throw new Error("no Promise impl found");
    return promiseCtor;
}




/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $1caeb93c32a31d5c$var$ObjectUnsubscribedErrorImpl = /*@__PURE__*/ function() {
    function ObjectUnsubscribedErrorImpl() {
        Error.call(this);
        this.message = "object unsubscribed";
        this.name = "ObjectUnsubscribedError";
        return this;
    }
    ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ObjectUnsubscribedErrorImpl;
}();
var $1caeb93c32a31d5c$export$f708eee25634bc80 = $1caeb93c32a31d5c$var$ObjectUnsubscribedErrorImpl;


/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */ 

var $db9e3d3ccbb347be$export$b7a41f2bfb5c60c3 = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
    }
    SubjectSubscription.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) return;
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) observers.splice(subscriberIndex, 1);
    };
    return SubjectSubscription;
}((0, $903811aedba8ff04$export$f55210826850c514));



var $7a16164e7ee15ac3$export$d2a63025e8078d0c = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
    }
    return SubjectSubscriber;
}((0, $0c5e61cfa4404ac4$export$60959659b2c22881));
var $7a16164e7ee15ac3$export$b6bbab5a9b109038 = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype[0, $241f94060c5a71eb$export$77f77496d7cade10] = function() {
        return new $7a16164e7ee15ac3$export$d2a63025e8078d0c(this);
    };
    Subject.prototype.lift = function(operator) {
        var subject = new $7a16164e7ee15ac3$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function(value) {
        if (this.closed) throw new (0, $1caeb93c32a31d5c$export$f708eee25634bc80)();
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for(var i = 0; i < len; i++)copy[i].next(value);
        }
    };
    Subject.prototype.error = function(err) {
        if (this.closed) throw new (0, $1caeb93c32a31d5c$export$f708eee25634bc80)();
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].error(err);
        this.observers.length = 0;
    };
    Subject.prototype.complete = function() {
        if (this.closed) throw new (0, $1caeb93c32a31d5c$export$f708eee25634bc80)();
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].complete();
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function(subscriber) {
        if (this.closed) throw new (0, $1caeb93c32a31d5c$export$f708eee25634bc80)();
        else return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        if (this.closed) throw new (0, $1caeb93c32a31d5c$export$f708eee25634bc80)();
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return (0, $903811aedba8ff04$export$f55210826850c514).EMPTY;
        } else if (this.isStopped) {
            subscriber.complete();
            return (0, $903811aedba8ff04$export$f55210826850c514).EMPTY;
        } else {
            this.observers.push(subscriber);
            return new (0, $db9e3d3ccbb347be$export$b7a41f2bfb5c60c3)(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $87f1d8962784e676$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $7a16164e7ee15ac3$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $87f1d8962784e676$export$77cea355fa80b5f4));
var $7a16164e7ee15ac3$export$155189cde295587d = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) destination.next(value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) this.destination.error(err);
    };
    AnonymousSubject.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) this.destination.complete();
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) return this.source.subscribe(subscriber);
        else return (0, $903811aedba8ff04$export$f55210826850c514).EMPTY;
    };
    return AnonymousSubject;
}($7a16164e7ee15ac3$export$b6bbab5a9b109038);

/** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */ 
/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */ /** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $0f733e2bdfe469ee$export$ab22aa77f372e159 = function(array) {
    return function(subscriber) {
        for(var i = 0, len = array.length; i < len && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    };
};


/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */ 
var $92107966df70d874$export$3adcd774773826b8 = function(promise) {
    return function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $f706439a796b1aea$export$ebb0f299889f975f));
        return subscriber;
    };
};


/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ /** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $0c6076e3e9fec9bd$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var $0c6076e3e9fec9bd$export$6f58e2338da23f4d = /*@__PURE__*/ $0c6076e3e9fec9bd$export$aa9956be4ae4fe8();
var $0c6076e3e9fec9bd$export$9785f547d3164dac = $0c6076e3e9fec9bd$export$6f58e2338da23f4d;


var $e94fadf285319eb2$export$176678a6ee07b575 = function(iterable) {
    return function(subscriber) {
        var iterator = iterable[0, $0c6076e3e9fec9bd$export$6f58e2338da23f4d]();
        do {
            var item = void 0;
            try {
                item = iterator.next();
            } catch (err) {
                subscriber.error(err);
                return subscriber;
            }
            if (item.done) {
                subscriber.complete();
                break;
            }
            subscriber.next(item.value);
            if (subscriber.closed) break;
        }while (true);
        if (typeof iterator.return === "function") subscriber.add(function() {
            if (iterator.return) iterator.return();
        });
        return subscriber;
    };
};


/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ 
var $867febe8bb84922d$export$253b2a6a99e75857 = function(obj) {
    return function(subscriber) {
        var obs = obj[0, $5587cca356a45e0d$export$5ab46cbf6120b33a]();
        if (typeof obs.subscribe !== "function") throw new TypeError("Provided object does not correctly implement Symbol.observable");
        else return obs.subscribe(subscriber);
    };
};


/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $0fafb2ab94116590$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};


/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $b8ce22dbbed07cc3$export$4369c812aac99591(value) {
    return !!value && typeof value.subscribe !== "function" && typeof value.then === "function";
}





var $22dbcf3659b003f0$export$45e4095b0ba1d337 = function(result) {
    if (!!result && typeof result[0, $5587cca356a45e0d$export$5ab46cbf6120b33a] === "function") return (0, $867febe8bb84922d$export$253b2a6a99e75857)(result);
    else if ((0, $0fafb2ab94116590$export$1e2f57719e155213)(result)) return (0, $0f733e2bdfe469ee$export$ab22aa77f372e159)(result);
    else if ((0, $b8ce22dbbed07cc3$export$4369c812aac99591)(result)) return (0, $92107966df70d874$export$3adcd774773826b8)(result);
    else if (!!result && typeof result[0, $0c6076e3e9fec9bd$export$6f58e2338da23f4d] === "function") return (0, $e94fadf285319eb2$export$176678a6ee07b575)(result);
    else {
        var value = (0, $8f49adcd985e1d52$export$a6cdc56e425d0d0a)(result) ? "an invalid object" : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + " You can provide an Observable, Promise, Array, or Iterable.";
        throw new TypeError(msg);
    }
};


/** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */ /** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */ 


function $b5714df43994063f$export$ed8bd553a12b6a30(input, scheduler) {
    return new (0, $87f1d8962784e676$export$77cea355fa80b5f4)(function(subscriber) {
        var sub = new (0, $903811aedba8ff04$export$f55210826850c514)();
        sub.add(scheduler.schedule(function() {
            var observable = input[0, $5587cca356a45e0d$export$5ab46cbf6120b33a]();
            sub.add(observable.subscribe({
                next: function(value) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.next(value);
                    }));
                },
                error: function(err) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.error(err);
                    }));
                },
                complete: function() {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }
            }));
        }));
        return sub;
    });
}


/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ 

function $e017f0ec21a75950$export$fc9afd948577f0a8(input, scheduler) {
    return new (0, $87f1d8962784e676$export$77cea355fa80b5f4)(function(subscriber) {
        var sub = new (0, $903811aedba8ff04$export$f55210826850c514)();
        sub.add(scheduler.schedule(function() {
            return input.then(function(value) {
                sub.add(scheduler.schedule(function() {
                    subscriber.next(value);
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }));
            }, function(err) {
                sub.add(scheduler.schedule(function() {
                    return subscriber.error(err);
                }));
            });
        }));
        return sub;
    });
}


/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ 

function $1ec9dcbf7b7dc580$export$b34673931371729a(input, scheduler) {
    return new (0, $87f1d8962784e676$export$77cea355fa80b5f4)(function(subscriber) {
        var sub = new (0, $903811aedba8ff04$export$f55210826850c514)();
        var i = 0;
        sub.add(scheduler.schedule(function() {
            if (i === input.length) {
                subscriber.complete();
                return;
            }
            subscriber.next(input[i++]);
            if (!subscriber.closed) sub.add(this.schedule());
        }));
        return sub;
    });
}


/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */ 


function $8b9a5f00b74e9e57$export$2b75c58ab9b5b766(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, $87f1d8962784e676$export$77cea355fa80b5f4)(function(subscriber) {
        var sub = new (0, $903811aedba8ff04$export$f55210826850c514)();
        var iterator;
        sub.add(function() {
            if (iterator && typeof iterator.return === "function") iterator.return();
        });
        sub.add(scheduler.schedule(function() {
            iterator = input[0, $0c6076e3e9fec9bd$export$6f58e2338da23f4d]();
            sub.add(scheduler.schedule(function() {
                if (subscriber.closed) return;
                var value;
                var done;
                try {
                    var result = iterator.next();
                    value = result.value;
                    done = result.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else {
                    subscriber.next(value);
                    this.schedule();
                }
            }));
        }));
        return sub;
    });
}


/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ 
function $724d4ee0e900f485$export$48c0cddbc99c45c2(input) {
    return input && typeof input[0, $5587cca356a45e0d$export$5ab46cbf6120b33a] === "function";
}




/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ 
function $c788ab326b1b133a$export$9652023d9040757(input) {
    return input && typeof input[0, $0c6076e3e9fec9bd$export$6f58e2338da23f4d] === "function";
}


function $65858c5917fe53ed$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $724d4ee0e900f485$export$48c0cddbc99c45c2)(input)) return (0, $b5714df43994063f$export$ed8bd553a12b6a30)(input, scheduler);
        else if ((0, $b8ce22dbbed07cc3$export$4369c812aac99591)(input)) return (0, $e017f0ec21a75950$export$fc9afd948577f0a8)(input, scheduler);
        else if ((0, $0fafb2ab94116590$export$1e2f57719e155213)(input)) return (0, $1ec9dcbf7b7dc580$export$b34673931371729a)(input, scheduler);
        else if ((0, $c788ab326b1b133a$export$9652023d9040757)(input) || typeof input === "string") return (0, $8b9a5f00b74e9e57$export$2b75c58ab9b5b766)(input, scheduler);
    }
    throw new TypeError((input !== null && typeof input || input) + " is not observable");
}


function $d98b9cf92f0fc696$export$6788812c4e6611e6(input, scheduler) {
    if (!scheduler) {
        if (input instanceof (0, $87f1d8962784e676$export$77cea355fa80b5f4)) return input;
        return new (0, $87f1d8962784e676$export$77cea355fa80b5f4)((0, $22dbcf3659b003f0$export$45e4095b0ba1d337)(input));
    } else return (0, $65858c5917fe53ed$export$49c44dfc2bb21d70)(input, scheduler);
}


/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */ 

/** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */ /** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ 
var $89eaa6b44cb073a6$export$ccb33e29d92c9a58 = /*@__PURE__*/ new (0, $87f1d8962784e676$export$77cea355fa80b5f4)(function(subscriber) {
    return subscriber.complete();
});
function $89eaa6b44cb073a6$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $89eaa6b44cb073a6$var$emptyScheduled(scheduler) : $89eaa6b44cb073a6$export$ccb33e29d92c9a58;
}
function $89eaa6b44cb073a6$var$emptyScheduled(scheduler) {
    return new (0, $87f1d8962784e676$export$77cea355fa80b5f4)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}


/** PURE_IMPORTS_START _util_isScheduler,_fromArray,_scheduled_scheduleArray PURE_IMPORTS_END */ /** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $c70b56b236674ebc$export$187e35932e88c15c(value) {
    return value && typeof value.schedule === "function";
}


/** PURE_IMPORTS_START _Observable,_util_subscribeToArray,_scheduled_scheduleArray PURE_IMPORTS_END */ 


function $64b1b74ab7847db2$export$571d59b505e6bb4e(input, scheduler) {
    if (!scheduler) return new (0, $87f1d8962784e676$export$77cea355fa80b5f4)((0, $0f733e2bdfe469ee$export$ab22aa77f372e159)(input));
    else return (0, $1ec9dcbf7b7dc580$export$b34673931371729a)(input, scheduler);
}



function $02622667f18df45a$export$ba255e9e49e00608() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = args[args.length - 1];
    if ((0, $c70b56b236674ebc$export$187e35932e88c15c)(scheduler)) {
        args.pop();
        return (0, $1ec9dcbf7b7dc580$export$b34673931371729a)(args, scheduler);
    } else return (0, $64b1b74ab7847db2$export$571d59b505e6bb4e)(args);
}


/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ 
function $87e0120617403241$export$8bf7aba4a9e09055(error, scheduler) {
    if (!scheduler) return new (0, $87f1d8962784e676$export$77cea355fa80b5f4)(function(subscriber) {
        return subscriber.error(error);
    });
    else return new (0, $87f1d8962784e676$export$77cea355fa80b5f4)(function(subscriber) {
        return scheduler.schedule($87e0120617403241$var$dispatch, 0, {
            error: error,
            subscriber: subscriber
        });
    });
}
function $87e0120617403241$var$dispatch(_a) {
    var error = _a.error, subscriber = _a.subscriber;
    subscriber.error(error);
}


var $8f7bb2e6bd2983b4$export$f59c804e350a7a80;
/*@__PURE__*/ (function(NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})($8f7bb2e6bd2983b4$export$f59c804e350a7a80 || ($8f7bb2e6bd2983b4$export$f59c804e350a7a80 = {}));
var $8f7bb2e6bd2983b4$export$14834abbfce3b8cd = /*@__PURE__*/ function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === "N";
    }
    Notification.prototype.observe = function(observer) {
        switch(this.kind){
            case "N":
                return observer.next && observer.next(this.value);
            case "E":
                return observer.error && observer.error(this.error);
            case "C":
                return observer.complete && observer.complete();
        }
    };
    Notification.prototype.do = function(next, error, complete) {
        var kind = this.kind;
        switch(kind){
            case "N":
                return next && next(this.value);
            case "E":
                return error && error(this.error);
            case "C":
                return complete && complete();
        }
    };
    Notification.prototype.accept = function(nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === "function") return this.observe(nextOrObserver);
        else return this.do(nextOrObserver, error, complete);
    };
    Notification.prototype.toObservable = function() {
        var kind = this.kind;
        switch(kind){
            case "N":
                return (0, $02622667f18df45a$export$ba255e9e49e00608)(this.value);
            case "E":
                return (0, $87e0120617403241$export$8bf7aba4a9e09055)(this.error);
            case "C":
                return (0, $89eaa6b44cb073a6$export$6e22c362a0406a2c)();
        }
        throw new Error("unexpected notification kind value");
    };
    Notification.createNext = function(value) {
        if (typeof value !== "undefined") return new Notification("N", value);
        return Notification.undefinedValueNotification;
    };
    Notification.createError = function(err) {
        return new Notification("E", undefined, err);
    };
    Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification("C");
    Notification.undefinedValueNotification = new Notification("N", undefined);
    return Notification;
}();


function $c4ad9afc7e05fdc9$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function observeOnOperatorFunction(source) {
        return source.lift(new $c4ad9afc7e05fdc9$export$b8e2e9b883c1952(scheduler, delay));
    };
}
var $c4ad9afc7e05fdc9$export$b8e2e9b883c1952 = /*@__PURE__*/ function() {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) delay = 0;
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $c4ad9afc7e05fdc9$export$2ccc19882708a0(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}();
var $c4ad9afc7e05fdc9$export$2ccc19882708a0 = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) delay = 0;
        var _this = _super.call(this, destination) || this;
        _this.scheduler = scheduler;
        _this.delay = delay;
        return _this;
    }
    ObserveOnSubscriber.dispatch = function(arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function(notification) {
        var destination = this.destination;
        destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new $c4ad9afc7e05fdc9$export$6358f3d000008d47(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function(value) {
        this.scheduleMessage((0, $8f7bb2e6bd2983b4$export$14834abbfce3b8cd).createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function(err) {
        this.scheduleMessage((0, $8f7bb2e6bd2983b4$export$14834abbfce3b8cd).createError(err));
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype._complete = function() {
        this.scheduleMessage((0, $8f7bb2e6bd2983b4$export$14834abbfce3b8cd).createComplete());
        this.unsubscribe();
    };
    return ObserveOnSubscriber;
}((0, $0c5e61cfa4404ac4$export$60959659b2c22881));
var $c4ad9afc7e05fdc9$export$6358f3d000008d47 = /*@__PURE__*/ function() {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}();

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ 

function $0df2ebea4aa1249c$export$871de8747c9eaa88(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== "function") throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
        return source.lift(new $0df2ebea4aa1249c$export$65d6be2d9a2ba8ee(project, thisArg));
    };
}
var $0df2ebea4aa1249c$export$65d6be2d9a2ba8ee = /*@__PURE__*/ function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $0df2ebea4aa1249c$var$MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
var $0df2ebea4aa1249c$var$MapSubscriber = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}((0, $0c5e61cfa4404ac4$export$60959659b2c22881));

/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ 


/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */ 



var $23eb368cee048f82$export$20b3446cf1c359c0 = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(SimpleInnerSubscriber, _super);
    function SimpleInnerSubscriber(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        return _this;
    }
    SimpleInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(value);
    };
    SimpleInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    SimpleInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete();
        this.unsubscribe();
    };
    return SimpleInnerSubscriber;
}((0, $0c5e61cfa4404ac4$export$60959659b2c22881));
var $23eb368cee048f82$export$319f8c60b2d80b53 = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(ComplexInnerSubscriber, _super);
    function ComplexInnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        return _this;
    }
    ComplexInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this);
    };
    ComplexInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    ComplexInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return ComplexInnerSubscriber;
}((0, $0c5e61cfa4404ac4$export$60959659b2c22881));
var $23eb368cee048f82$export$b73f91a09e7d5376 = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(SimpleOuterSubscriber, _super);
    function SimpleOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleOuterSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    SimpleOuterSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    SimpleOuterSubscriber.prototype.notifyComplete = function() {
        this.destination.complete();
    };
    return SimpleOuterSubscriber;
}((0, $0c5e61cfa4404ac4$export$60959659b2c22881));
var $23eb368cee048f82$export$9643bd8e0cc0c90a = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(ComplexOuterSubscriber, _super);
    function ComplexOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComplexOuterSubscriber.prototype.notifyNext = function(_outerValue, innerValue, _outerIndex, _innerSub) {
        this.destination.next(innerValue);
    };
    ComplexOuterSubscriber.prototype.notifyError = function(error) {
        this.destination.error(error);
    };
    ComplexOuterSubscriber.prototype.notifyComplete = function(_innerSub) {
        this.destination.complete();
    };
    return ComplexOuterSubscriber;
}((0, $0c5e61cfa4404ac4$export$60959659b2c22881));
function $23eb368cee048f82$export$d34bac9c0f124cff(result, innerSubscriber) {
    if (innerSubscriber.closed) return undefined;
    if (result instanceof (0, $87f1d8962784e676$export$77cea355fa80b5f4)) return result.subscribe(innerSubscriber);
    var subscription;
    try {
        subscription = (0, $22dbcf3659b003f0$export$45e4095b0ba1d337)(result)(innerSubscriber);
    } catch (error) {
        innerSubscriber.error(error);
    }
    return subscription;
}


function $8ee93c856d38203a$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === "function") return function(source) {
        return source.pipe($8ee93c856d38203a$export$6b9f6c0d32c093f9(function(a, i) {
            return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(project(a, i)).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }, concurrent));
    };
    else if (typeof resultSelector === "number") concurrent = resultSelector;
    return function(source) {
        return source.lift(new $8ee93c856d38203a$export$397d304a18305ca8(project, concurrent));
    };
}
var $8ee93c856d38203a$export$397d304a18305ca8 = /*@__PURE__*/ function() {
    function MergeMapOperator(project, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.project = project;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $8ee93c856d38203a$export$c13a9be6692e882(observer, this.project, this.concurrent));
    };
    return MergeMapOperator;
}();
var $8ee93c856d38203a$export$c13a9be6692e882 = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeMapSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) this._tryNext(value);
        else this.buffer.push(value);
    };
    MergeMapSubscriber.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result);
    };
    MergeMapSubscriber.prototype._innerSub = function(ish) {
        var innerSubscriber = new (0, $23eb368cee048f82$export$20b3446cf1c359c0)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = (0, $23eb368cee048f82$export$d34bac9c0f124cff)(ish, innerSubscriber);
        if (innerSubscription !== innerSubscriber) destination.add(innerSubscription);
    };
    MergeMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
        this.unsubscribe();
    };
    MergeMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype.notifyComplete = function() {
        var buffer = this.buffer;
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapSubscriber;
}((0, $23eb368cee048f82$export$b73f91a09e7d5376));
var $8ee93c856d38203a$export$5b8affa63fc6df16 = $8ee93c856d38203a$export$6b9f6c0d32c093f9;

/** PURE_IMPORTS_START _observable_SubscribeOnObservable PURE_IMPORTS_END */ /** PURE_IMPORTS_START tslib,_Observable,_scheduler_asap,_util_isNumeric PURE_IMPORTS_END */ 

/** PURE_IMPORTS_START _AsapAction,_AsapScheduler PURE_IMPORTS_END */ /** PURE_IMPORTS_START tslib,_util_Immediate,_AsyncAction PURE_IMPORTS_END */ 
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $67a37a1498a9b7bd$var$nextHandle = 1;
var $67a37a1498a9b7bd$var$RESOLVED = /*@__PURE__*/ function() {
    return /*@__PURE__*/ Promise.resolve();
}();
var $67a37a1498a9b7bd$var$activeHandles = {};
function $67a37a1498a9b7bd$var$findAndClearHandle(handle) {
    if (handle in $67a37a1498a9b7bd$var$activeHandles) {
        delete $67a37a1498a9b7bd$var$activeHandles[handle];
        return true;
    }
    return false;
}
var $67a37a1498a9b7bd$export$9bf7f22d83f7b5af = {
    setImmediate: function(cb) {
        var handle = $67a37a1498a9b7bd$var$nextHandle++;
        $67a37a1498a9b7bd$var$activeHandles[handle] = true;
        $67a37a1498a9b7bd$var$RESOLVED.then(function() {
            return $67a37a1498a9b7bd$var$findAndClearHandle(handle) && cb();
        });
        return handle;
    },
    clearImmediate: function(handle) {
        $67a37a1498a9b7bd$var$findAndClearHandle(handle);
    }
};
var $67a37a1498a9b7bd$export$3967e9a9db29c776 = {
    pending: function() {
        return Object.keys($67a37a1498a9b7bd$var$activeHandles).length;
    }
};



var $7fd0ae5cdfa9e6be$export$6a72523e12463e75 = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = (0, $67a37a1498a9b7bd$export$9bf7f22d83f7b5af).setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        if (scheduler.actions.length === 0) {
            (0, $67a37a1498a9b7bd$export$9bf7f22d83f7b5af).clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}((0, $a95fe049686c7727$export$b5369ffd7cb2211b));


/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */ 

var $2f81fca73a5f0851$export$e27ac4cacb0fee33 = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function(action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while(++index < count && (action = actions.shift()))action.unsubscribe();
            throw error;
        }
    };
    return AsapScheduler;
}((0, $5d24049566780726$export$4114a3ec92faa3c6));


var $a4f1f20f60ea8f89$export$25915e3b9bb42559 = /*@__PURE__*/ new (0, $2f81fca73a5f0851$export$e27ac4cacb0fee33)((0, $7fd0ae5cdfa9e6be$export$6a72523e12463e75));
var $a4f1f20f60ea8f89$export$dc4d482300a341e1 = $a4f1f20f60ea8f89$export$25915e3b9bb42559;


/** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */ 
function $ad6f1ca4aa2d78c9$export$e90fb89750dba83f(val) {
    return !(0, $73c774b8baa8f75c$export$43bee75e5e14138e)(val) && val - parseFloat(val) + 1 >= 0;
}


var $c7e14f8e5559ae58$export$263b2fb50aa2df2c = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(SubscribeOnObservable, _super);
    function SubscribeOnObservable(source, delayTime, scheduler) {
        if (delayTime === void 0) delayTime = 0;
        if (scheduler === void 0) scheduler = (0, $a4f1f20f60ea8f89$export$dc4d482300a341e1);
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.delayTime = delayTime;
        _this.scheduler = scheduler;
        if (!(0, $ad6f1ca4aa2d78c9$export$e90fb89750dba83f)(delayTime) || delayTime < 0) _this.delayTime = 0;
        if (!scheduler || typeof scheduler.schedule !== "function") _this.scheduler = (0, $a4f1f20f60ea8f89$export$dc4d482300a341e1);
        return _this;
    }
    SubscribeOnObservable.create = function(source, delay, scheduler) {
        if (delay === void 0) delay = 0;
        if (scheduler === void 0) scheduler = (0, $a4f1f20f60ea8f89$export$dc4d482300a341e1);
        return new SubscribeOnObservable(source, delay, scheduler);
    };
    SubscribeOnObservable.dispatch = function(arg) {
        var source = arg.source, subscriber = arg.subscriber;
        return this.add(source.subscribe(subscriber));
    };
    SubscribeOnObservable.prototype._subscribe = function(subscriber) {
        var delay = this.delayTime;
        var source = this.source;
        var scheduler = this.scheduler;
        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
            source: source,
            subscriber: subscriber
        });
    };
    return SubscribeOnObservable;
}((0, $87f1d8962784e676$export$77cea355fa80b5f4));


function $95a5f6b488204012$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function subscribeOnOperatorFunction(source) {
        return source.lift(new $95a5f6b488204012$var$SubscribeOnOperator(scheduler, delay));
    };
}
var $95a5f6b488204012$var$SubscribeOnOperator = /*@__PURE__*/ function() {
    function SubscribeOnOperator(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    SubscribeOnOperator.prototype.call = function(subscriber, source) {
        return new (0, $c7e14f8e5559ae58$export$263b2fb50aa2df2c)(source, this.delay, this.scheduler).subscribe(subscriber);
    };
    return SubscribeOnOperator;
}();



/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ 

function $9b40e534aee37321$export$3dea766d36a8935f(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $9b40e534aee37321$var$FilterOperator(predicate, thisArg));
    };
}
var $9b40e534aee37321$var$FilterOperator = /*@__PURE__*/ function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $9b40e534aee37321$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
var $9b40e534aee37321$var$FilterSubscriber = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
    }
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}((0, $0c5e61cfa4404ac4$export$60959659b2c22881));


var $098da3bfff4d96e5$var$keyHasType = function keyHasType(type, key) {
    return type === key || typeof key === "function" && type === key.toString();
};
var $098da3bfff4d96e5$export$5db8774c0df95fce = function ofType() {
    for(var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++)keys[_key] = arguments[_key];
    return function(source) {
        return source.pipe((0, $9b40e534aee37321$export$3dea766d36a8935f)(function(_ref) {
            var type = _ref.type;
            var len = keys.length;
            if (len === 1) return $098da3bfff4d96e5$var$keyHasType(type, keys[0]);
            else for(var i = 0; i < len; i++){
                if ($098da3bfff4d96e5$var$keyHasType(type, keys[i])) return true;
            }
            return false;
        }));
    };
};


var $d5d1d39df45de85c$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $d5d1d39df45de85c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d5d1d39df45de85c$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d5d1d39df45de85c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $d5d1d39df45de85c$export$fa75b7f5c32db4e9 = function(_Observable) {
    $d5d1d39df45de85c$var$_inherits(ActionsObservable, _Observable);
    $d5d1d39df45de85c$var$_createClass(ActionsObservable, null, [
        {
            key: "of",
            value: function of() {
                return new this((0, $02622667f18df45a$export$ba255e9e49e00608).apply(undefined, arguments));
            }
        },
        {
            key: "from",
            value: function from(actions, scheduler) {
                return new this((0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(actions, scheduler));
            }
        }
    ]);
    function ActionsObservable(actionsSubject) {
        $d5d1d39df45de85c$var$_classCallCheck(this, ActionsObservable);
        var _this = $d5d1d39df45de85c$var$_possibleConstructorReturn(this, (ActionsObservable.__proto__ || Object.getPrototypeOf(ActionsObservable)).call(this));
        _this.source = actionsSubject;
        return _this;
    }
    $d5d1d39df45de85c$var$_createClass(ActionsObservable, [
        {
            key: "lift",
            value: function lift(operator) {
                var observable = new ActionsObservable(this);
                observable.operator = operator;
                return observable;
            }
        },
        {
            key: "ofType",
            value: function ofType() {
                return (0, $098da3bfff4d96e5$export$5db8774c0df95fce).apply(undefined, arguments)(this);
            }
        }
    ]);
    return ActionsObservable;
}((0, $87f1d8962784e676$export$77cea355fa80b5f4));



function $d4d2f85d64a7bde5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d4d2f85d64a7bde5$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d4d2f85d64a7bde5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $d4d2f85d64a7bde5$export$5997f2b62c7a70ab = function(_Observable) {
    $d4d2f85d64a7bde5$var$_inherits(StateObservable, _Observable);
    function StateObservable(stateSubject, initialState) {
        $d4d2f85d64a7bde5$var$_classCallCheck(this, StateObservable);
        var _this = $d4d2f85d64a7bde5$var$_possibleConstructorReturn(this, (StateObservable.__proto__ || Object.getPrototypeOf(StateObservable)).call(this, function(subscriber) {
            var subscription = _this.__notifier.subscribe(subscriber);
            if (subscription && !subscription.closed) subscriber.next(_this.value);
            return subscription;
        }));
        _this.value = initialState;
        _this.__notifier = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        _this.__subscription = stateSubject.subscribe(function(value) {
            // We only want to update state$ if it has actually changed since
            // redux requires reducers use immutability patterns.
            // This is basically what distinctUntilChanged() does but it's so simple
            // we don't need to pull that code in
            if (value !== _this.value) {
                _this.value = value;
                _this.__notifier.next(value);
            }
        });
        return _this;
    }
    return StateObservable;
}((0, $87f1d8962784e676$export$77cea355fa80b5f4));



function $ec13e319864e87c6$export$147cf6f7ce5462cb() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // This isn't great. RxJS doesn't publicly export the constructor for
    // QueueScheduler nor QueueAction, so we reach in. We need to do this because
    // we don't want our internal queuing mechanism to be on the same queue as any
    // other RxJS code outside of redux-observable internals.
    var QueueScheduler = (0, $5dc13791984594d0$export$69a3263547af8af8).constructor;
    var uniqueQueueScheduler = new QueueScheduler((0, $5dc13791984594d0$export$69a3263547af8af8).SchedulerAction);
    var epic$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
    var store = void 0;
    var epicMiddleware = function epicMiddleware(_store) {
        store = _store;
        var actionSubject$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)().pipe((0, $c4ad9afc7e05fdc9$export$9007f49c319d1ac7)(uniqueQueueScheduler));
        var stateSubject$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)().pipe((0, $c4ad9afc7e05fdc9$export$9007f49c319d1ac7)(uniqueQueueScheduler));
        var action$ = new (0, $d5d1d39df45de85c$export$fa75b7f5c32db4e9)(actionSubject$);
        var state$ = new (0, $d4d2f85d64a7bde5$export$5997f2b62c7a70ab)(stateSubject$, store.getState());
        var result$ = epic$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(epic) {
            var output$ = "dependencies" in options ? epic(action$, state$, options.dependencies) : epic(action$, state$);
            if (!output$) throw new TypeError('Your root Epic "' + (epic.name || "<anonymous>") + "\" does not return a stream. Double check you're not missing a return statement!");
            return output$;
        }), (0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(output$) {
            return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(output$).pipe((0, $95a5f6b488204012$export$1eb44d8f5f64733b)(uniqueQueueScheduler), (0, $c4ad9afc7e05fdc9$export$9007f49c319d1ac7)(uniqueQueueScheduler));
        }));
        result$.subscribe(store.dispatch);
        return function(next) {
            return function(action) {
                // Downstream middleware gets the action first,
                // which includes their reducers, so state is
                // updated before epics receive the action
                var result = next(action);
                // It's important to update the state$ before we emit
                // the action because otherwise it would be stale
                stateSubject$.next(store.getState());
                actionSubject$.next(action);
                return result;
            };
        };
    };
    epicMiddleware.run = function(rootEpic) {
        epic$.next(rootEpic);
    };
    return epicMiddleware;
}


var $79637b0fcd305eaf$export$1e511d4a378977f5;
var $79637b0fcd305eaf$export$d32324a03b6bde1b;
var $79637b0fcd305eaf$export$321b1ffcca858b2b;
"use strict";

var $79637b0fcd305eaf$require$compose = $ad4393542232627c$export$f672e0b6f7222cd7;
$79637b0fcd305eaf$export$1e511d4a378977f5 = true;
$79637b0fcd305eaf$export$d32324a03b6bde1b = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return undefined;
    if (typeof arguments[0] === "object") return $79637b0fcd305eaf$require$compose;
    return $79637b0fcd305eaf$require$compose.apply(null, arguments);
};
$79637b0fcd305eaf$export$321b1ffcca858b2b = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop) {
        return noop;
    };
};



var $4c71eb74f53637d3$var$PREFIX = "[User]";
var $4c71eb74f53637d3$export$3b2141b862a8a681 = "".concat($4c71eb74f53637d3$var$PREFIX, " TEST");
var $4c71eb74f53637d3$export$ff67457b75dbf12a = "".concat($4c71eb74f53637d3$var$PREFIX, " GET_CURRENT_USER");
var $4c71eb74f53637d3$export$9f7afae2db72e315 = "".concat($4c71eb74f53637d3$var$PREFIX, " GET_CURRENT_USER_SUCCESS");
var $4c71eb74f53637d3$export$377fd6b229ea180c = "".concat($4c71eb74f53637d3$var$PREFIX, " GET_CURRENT_USER_FAIL");
var $4c71eb74f53637d3$export$eed606b4351295d7 = "".concat($4c71eb74f53637d3$var$PREFIX, " LOGIN");
var $4c71eb74f53637d3$export$5223a5682801fa43 = "".concat($4c71eb74f53637d3$var$PREFIX, " LOGIN_SUCCESS");
var $4c71eb74f53637d3$export$d2473a15d627f3f1 = "".concat($4c71eb74f53637d3$var$PREFIX, " LOGIN_FAIL");
var $4c71eb74f53637d3$export$35e541d26a145a7c = "".concat($4c71eb74f53637d3$var$PREFIX, " LOGOUT");
var $4c71eb74f53637d3$export$3343dae88069f1c1 = "".concat($4c71eb74f53637d3$var$PREFIX, " LOGOUT_SUCCESS");
var $4c71eb74f53637d3$export$9f7331ccf987e298 = "".concat($4c71eb74f53637d3$var$PREFIX, " LOGOUT_FAIL");
var $4c71eb74f53637d3$export$dfa3dd78ac296cf2 = "".concat($4c71eb74f53637d3$var$PREFIX, " GET_AGENTS");
var $4c71eb74f53637d3$export$2cee90acddd38be3 = "".concat($4c71eb74f53637d3$var$PREFIX, " GET_AGENTS_SUCCESS");
var $4c71eb74f53637d3$export$319c3bd92910657b = "".concat($4c71eb74f53637d3$var$PREFIX, " GET_AGENTS_FAIL");
var $4c71eb74f53637d3$export$d1320805de2a0f43 = "".concat($4c71eb74f53637d3$var$PREFIX, " GET_SUPERVISORS");
var $4c71eb74f53637d3$export$9340e630ef96adf9 = "".concat($4c71eb74f53637d3$var$PREFIX, " GET_SUPERVISORS_SUCCESS");
var $4c71eb74f53637d3$export$cb4b8cd408a4cf59 = "".concat($4c71eb74f53637d3$var$PREFIX, " GET_SUPERVISORS_FAIL");
var $4c71eb74f53637d3$export$c387b27c89715baf = "".concat($4c71eb74f53637d3$var$PREFIX, " GET_ALL_USERS");
var $4c71eb74f53637d3$export$fe57b74e71d14dac = "".concat($4c71eb74f53637d3$var$PREFIX, " GET_ALL_USERS_SUCCESS");
var $4c71eb74f53637d3$export$88d862a652497e0e = "".concat($4c71eb74f53637d3$var$PREFIX, " GET_ALL_USERS_FAIL");
var $4c71eb74f53637d3$export$3f05487ba7fe474b = "".concat($4c71eb74f53637d3$var$PREFIX, " CREATE_BANK_ACCOUNT");
var $4c71eb74f53637d3$export$ee530607025cca78 = "".concat($4c71eb74f53637d3$var$PREFIX, " CREATE_BANK_ACCOUNT_SUCCESS");
var $4c71eb74f53637d3$export$d0054b7b1f190d7d = "".concat($4c71eb74f53637d3$var$PREFIX, " CREATE_BANK_ACCOUNT_FAIL");
var $4c71eb74f53637d3$export$74d61c62c586516a = "".concat($4c71eb74f53637d3$var$PREFIX, " GET_BANKS");
var $4c71eb74f53637d3$export$b35549a768d86f1d = "".concat($4c71eb74f53637d3$var$PREFIX, " GET_BANKS_SUCCESS");
var $4c71eb74f53637d3$export$354d102f939e7d36 = "".concat($4c71eb74f53637d3$var$PREFIX, " GET_BANKS_FAIL");
var $4c71eb74f53637d3$export$3886e73aa4232c67 = "".concat($4c71eb74f53637d3$var$PREFIX, " CREATE_USER");
var $4c71eb74f53637d3$export$6d67d91c36640f61 = "".concat($4c71eb74f53637d3$var$PREFIX, " CREATE_USER_SUCCESS");
var $4c71eb74f53637d3$export$4698e032cc52a71f = "".concat($4c71eb74f53637d3$var$PREFIX, " CREATE_USER_FAIL");
var $4c71eb74f53637d3$export$86dd998f89ad8fa6 = "".concat($4c71eb74f53637d3$var$PREFIX, " CREATE_EMPLOYEE");
var $4c71eb74f53637d3$export$7166cfbaabfdff16 = "".concat($4c71eb74f53637d3$var$PREFIX, " CREATE_EMPLOYEE_SUCCESS");
var $4c71eb74f53637d3$export$36cb7752d13f2d79 = "".concat($4c71eb74f53637d3$var$PREFIX, " CREATE_EMPLOYEE_FAIL");
var $4c71eb74f53637d3$export$1f1e8f449be51a90 = "".concat($4c71eb74f53637d3$var$PREFIX, " EDIT_EMPLOYEE");
var $4c71eb74f53637d3$export$199fc288a799e4ca = "".concat($4c71eb74f53637d3$var$PREFIX, " EDIT_EMPLOYEE_SUCCESS");
var $4c71eb74f53637d3$export$c488315308d3ad19 = "".concat($4c71eb74f53637d3$var$PREFIX, " EDIT_EMPLOYEE_FAIL");
var $4c71eb74f53637d3$export$67e8c4b0fd356271 = "".concat($4c71eb74f53637d3$var$PREFIX, " CHANGE_PASSWORD");
var $4c71eb74f53637d3$export$52dd5c72d66642a1 = "".concat($4c71eb74f53637d3$var$PREFIX, " CHANGE_PASSWORD_SUCCESS");
var $4c71eb74f53637d3$export$d482da6a78662f2b = "".concat($4c71eb74f53637d3$var$PREFIX, " CHANGE_PASSWORD_FAIL");
var $4c71eb74f53637d3$export$6630f5bab1479efb = "".concat($4c71eb74f53637d3$var$PREFIX, " ASSIGN_BANK_ACCOUNT");
var $4c71eb74f53637d3$export$fb19d1a424549748 = "".concat($4c71eb74f53637d3$var$PREFIX, " ASSIGN_BANK_ACCOUNT_SUCCESS");
var $4c71eb74f53637d3$export$14672cddbab9360c = "".concat($4c71eb74f53637d3$var$PREFIX, " ASSIGN_BANK_ACCOUNT_FAIL");
var $4c71eb74f53637d3$export$b75cf570f6a6871c = "".concat($4c71eb74f53637d3$var$PREFIX, " CHANGE_STATUS");
var $4c71eb74f53637d3$export$f60915d6b30a1ca2 = "".concat($4c71eb74f53637d3$var$PREFIX, " CHANGE_STATUS_SUCCESS");
var $4c71eb74f53637d3$export$5f15db445b3fa7d7 = "".concat($4c71eb74f53637d3$var$PREFIX, " CHANGE_STATUS_FAIL");
var $4c71eb74f53637d3$export$e65d189135623f3a = "".concat($4c71eb74f53637d3$var$PREFIX, " CREATE_SUPERVISOR_DATA");
var $4c71eb74f53637d3$export$fb7a63b79b41ba6d = "".concat($4c71eb74f53637d3$var$PREFIX, " CREATE_SUPERVISOR_DATA_SUCCESS");
var $4c71eb74f53637d3$export$46a683e6e65eb26 = "".concat($4c71eb74f53637d3$var$PREFIX, " CREATE_SUPERVISOR_DATA_FAIL");
var $4c71eb74f53637d3$export$d0fb24651868d5d6 = "".concat($4c71eb74f53637d3$var$PREFIX, " UPDATE_SUPERVISOR_STOCK");
var $4c71eb74f53637d3$export$795bf10706f7695b = "".concat($4c71eb74f53637d3$var$PREFIX, " UPDATE_SUPERVISOR_STOCK_SUCCESS");
var $4c71eb74f53637d3$export$eee37f47ec9fd5af = "".concat($4c71eb74f53637d3$var$PREFIX, " UPDATE_SUPERVISOR_STOCK_FAIL");
var $4c71eb74f53637d3$export$ce53836c0900812a = "".concat($4c71eb74f53637d3$var$PREFIX, " RESET_STATES");


const $ad7802471dc8ad45$export$93ca241731165d07 = "IN_PROGRESS";
const $ad7802471dc8ad45$export$3ee3100c952bc770 = "SUCCESS";
const $ad7802471dc8ad45$export$71d4adaa9696bca2 = "FAILED";
const $ad7802471dc8ad45$export$76350ffc4854c457 = "UNTOUCHED";


var $995f42c48d93e7ce$var$initialState = {};
function $995f42c48d93e7ce$export$2e2bcd8739ae039(state, action) {
    if (state === void 0) state = $995f42c48d93e7ce$var$initialState;
    switch(action.type){
        case $4c71eb74f53637d3$export$ff67457b75dbf12a:
        case $4c71eb74f53637d3$export$9f7afae2db72e315:
        case $4c71eb74f53637d3$export$377fd6b229ea180c:
            return Object.assign({}, state, action.payload);
        case $4c71eb74f53637d3$export$dfa3dd78ac296cf2:
        case $4c71eb74f53637d3$export$2cee90acddd38be3:
        case $4c71eb74f53637d3$export$319c3bd92910657b:
            return Object.assign({}, state, action.payload);
        case $4c71eb74f53637d3$export$d1320805de2a0f43:
        case $4c71eb74f53637d3$export$9340e630ef96adf9:
        case $4c71eb74f53637d3$export$cb4b8cd408a4cf59:
            return Object.assign({}, state, action.payload);
        case $4c71eb74f53637d3$export$c387b27c89715baf:
        case $4c71eb74f53637d3$export$fe57b74e71d14dac:
        case $4c71eb74f53637d3$export$88d862a652497e0e:
            return Object.assign({}, state, action.payload);
        case $4c71eb74f53637d3$export$74d61c62c586516a:
        case $4c71eb74f53637d3$export$b35549a768d86f1d:
        case $4c71eb74f53637d3$export$354d102f939e7d36:
            return Object.assign({}, state, action.payload);
        case $4c71eb74f53637d3$export$3f05487ba7fe474b:
            return Object.assign({}, state, action.payload, {
                createBankAccountState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $4c71eb74f53637d3$export$ee530607025cca78:
            return Object.assign({}, state, action.payload, {
                createBankAccountState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $4c71eb74f53637d3$export$d0054b7b1f190d7d:
            return Object.assign({}, state, action.payload, {
                createBankAccountState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $4c71eb74f53637d3$export$3886e73aa4232c67:
            return Object.assign({}, state, action.payload, {
                createUserState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $4c71eb74f53637d3$export$6d67d91c36640f61:
            return Object.assign({}, state, action.payload, {
                createUserState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $4c71eb74f53637d3$export$4698e032cc52a71f:
            return Object.assign({}, state, action.payload, {
                createUserState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $4c71eb74f53637d3$export$67e8c4b0fd356271:
            return Object.assign({}, state, action.payload, {
                changePasswordStatus: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $4c71eb74f53637d3$export$52dd5c72d66642a1:
            return Object.assign({}, state, action.payload, {
                changePasswordStatus: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $4c71eb74f53637d3$export$d482da6a78662f2b:
            return Object.assign({}, state, action.payload, {
                changePasswordStatus: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $4c71eb74f53637d3$export$6630f5bab1479efb:
            return Object.assign({}, state, action.payload, {
                assignBankAccountStatus: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $4c71eb74f53637d3$export$fb19d1a424549748:
            return Object.assign({}, state, action.payload, {
                assignBankAccountStatus: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $4c71eb74f53637d3$export$14672cddbab9360c:
            return Object.assign({}, state, action.payload, {
                assignBankAccountStatus: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $4c71eb74f53637d3$export$b75cf570f6a6871c:
            return Object.assign({}, state, action.payload, {
                changeActiveStatus: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $4c71eb74f53637d3$export$f60915d6b30a1ca2:
            return Object.assign({}, state, action.payload, {
                changeActiveStatus: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $4c71eb74f53637d3$export$5f15db445b3fa7d7:
            return Object.assign({}, state, action.payload, {
                changeActiveStatus: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $4c71eb74f53637d3$export$ce53836c0900812a:
            return Object.assign({}, state, action.payload, {
                createBankAccountState: (0, $ad7802471dc8ad45$export$76350ffc4854c457),
                createUserState: (0, $ad7802471dc8ad45$export$76350ffc4854c457),
                changePasswordStatus: (0, $ad7802471dc8ad45$export$76350ffc4854c457),
                assignBankAccountStatus: (0, $ad7802471dc8ad45$export$76350ffc4854c457),
                changeActiveStatus: (0, $ad7802471dc8ad45$export$76350ffc4854c457),
                postPutRequestStatus: (0, $ad7802471dc8ad45$export$76350ffc4854c457),
                createEmployeeState: (0, $ad7802471dc8ad45$export$76350ffc4854c457)
            });
        case $4c71eb74f53637d3$export$eed606b4351295d7:
            return Object.assign({}, state, action.payload);
        case $4c71eb74f53637d3$export$5223a5682801fa43:
            return Object.assign({}, state, action.payload, {
                authPassword: null,
                authUsername: null
            });
        case $4c71eb74f53637d3$export$d2473a15d627f3f1:
            return Object.assign({}, state, action.payload, {
                authPassword: null,
                authUsername: null
            });
        case $4c71eb74f53637d3$export$35e541d26a145a7c:
        case $4c71eb74f53637d3$export$3343dae88069f1c1:
            return Object.assign({}, state, action.payload);
        case $4c71eb74f53637d3$export$d0fb24651868d5d6:
        case $4c71eb74f53637d3$export$e65d189135623f3a:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $4c71eb74f53637d3$export$795bf10706f7695b:
        case $4c71eb74f53637d3$export$fb7a63b79b41ba6d:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $4c71eb74f53637d3$export$eee37f47ec9fd5af:
        case $4c71eb74f53637d3$export$46a683e6e65eb26:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $4c71eb74f53637d3$export$86dd998f89ad8fa6:
        case $4c71eb74f53637d3$export$1f1e8f449be51a90:
            return Object.assign({}, state, action.payload, {
                createEmployeeState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $4c71eb74f53637d3$export$7166cfbaabfdff16:
        case $4c71eb74f53637d3$export$199fc288a799e4ca:
            return Object.assign({}, state, action.payload, {
                createEmployeeState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $4c71eb74f53637d3$export$36cb7752d13f2d79:
        case $4c71eb74f53637d3$export$c488315308d3ad19:
            return Object.assign({}, state, action.payload, {
                createEmployeeState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        default:
            return state;
    }
}


var $ea864d6f3cd9447e$var$PREFIX = "[REMITTANCE]";
var $ea864d6f3cd9447e$export$4f0aa2f7c1eac83e = "".concat($ea864d6f3cd9447e$var$PREFIX, " SUBMIT_REMITTANCE");
var $ea864d6f3cd9447e$export$68b862e0d897562f = "".concat($ea864d6f3cd9447e$var$PREFIX, " SUBMIT_REMITTANCE_SUCCESS");
var $ea864d6f3cd9447e$export$538007741e882bbf = "".concat($ea864d6f3cd9447e$var$PREFIX, " SUBMIT_REMITTANCE_FAIL");
var $ea864d6f3cd9447e$export$e82cebb195cca37c = "".concat($ea864d6f3cd9447e$var$PREFIX, " GET_GRID_REMITTANCE");
var $ea864d6f3cd9447e$export$91b422ec07f86303 = "".concat($ea864d6f3cd9447e$var$PREFIX, " GET_GRID_REMITTANCE_SUCCESS");
var $ea864d6f3cd9447e$export$7781d9de80c0e585 = "".concat($ea864d6f3cd9447e$var$PREFIX, " GET_GRID_REMITTANCE_FAIL");
var $ea864d6f3cd9447e$export$b89956564774937f = "".concat($ea864d6f3cd9447e$var$PREFIX, " GET_REPORT_GRID_REMITTANCE");
var $ea864d6f3cd9447e$export$5676aa6ad8be94ad = "".concat($ea864d6f3cd9447e$var$PREFIX, " GET_REPORT_GRID_REMITTANCE_SUCCESS");
var $ea864d6f3cd9447e$export$de67a0d68d773d25 = "".concat($ea864d6f3cd9447e$var$PREFIX, " GET_REPORT_GRID_REMITTANCE_FAIL");
var $ea864d6f3cd9447e$export$ac8ddd8847849ab = "".concat($ea864d6f3cd9447e$var$PREFIX, " GET_REMITTANCE_TOTAL");
var $ea864d6f3cd9447e$export$ebb5a9a0e3df52b0 = "".concat($ea864d6f3cd9447e$var$PREFIX, " GET_REMITTANCE_TOTAL_SUCCESS");
var $ea864d6f3cd9447e$export$37877b3afd681a6d = "".concat($ea864d6f3cd9447e$var$PREFIX, " GET_REMITTANCE_TOTAL_FAIL");
var $ea864d6f3cd9447e$export$6846fb968bdf775b = "".concat($ea864d6f3cd9447e$var$PREFIX, " GET_REMITTANCE_TOTAL_MONTH");
var $ea864d6f3cd9447e$export$2bc5c5033fc1d7c8 = "".concat($ea864d6f3cd9447e$var$PREFIX, " GET_REMITTANCE_TOTAL_MONTH_SUCCESS");
var $ea864d6f3cd9447e$export$af72e095ba9f5b67 = "".concat($ea864d6f3cd9447e$var$PREFIX, " GET_REMITTANCE_TOTAL_MONTH_FAIL");
var $ea864d6f3cd9447e$export$ab2ecf21d87194a9 = "".concat($ea864d6f3cd9447e$var$PREFIX, " SUBMIT_EDIT_REQUEST");
var $ea864d6f3cd9447e$export$7f322859f452c805 = "".concat($ea864d6f3cd9447e$var$PREFIX, " SUBMIT_EDIT_REQUEST_SUCCESS");
var $ea864d6f3cd9447e$export$e4b9d21ba9cdebce = "".concat($ea864d6f3cd9447e$var$PREFIX, " SUBMIT_EDIT_REQUEST_FAIL");
var $ea864d6f3cd9447e$export$1c44b3cf184102c = "".concat($ea864d6f3cd9447e$var$PREFIX, " SUBMIT_DELETE_REQUEST");
var $ea864d6f3cd9447e$export$6912c6b7f329ddf8 = "".concat($ea864d6f3cd9447e$var$PREFIX, " SUBMIT_DELETE_REQUEST_SUCCESS");
var $ea864d6f3cd9447e$export$a70fe050778144ae = "".concat($ea864d6f3cd9447e$var$PREFIX, " SUBMIT_DELETE_REQUEST_FAIL");
var $ea864d6f3cd9447e$export$4107b97e676630a2 = "".concat($ea864d6f3cd9447e$var$PREFIX, " APPROVE_REMITTANCE");
var $ea864d6f3cd9447e$export$ed09ec00ca0af97 = "".concat($ea864d6f3cd9447e$var$PREFIX, " APPROVE_REMITTANCE_SUCCESS");
var $ea864d6f3cd9447e$export$43e946fa582bde3b = "".concat($ea864d6f3cd9447e$var$PREFIX, " APPROVE_REMITTANCE_FAIL");
var $ea864d6f3cd9447e$export$a9fdcde8bac1b31f = "".concat($ea864d6f3cd9447e$var$PREFIX, " RESET_REMITTANCE_STATES");
var $ea864d6f3cd9447e$export$e7552e3670d2fd5b = "".concat($ea864d6f3cd9447e$var$PREFIX, " GENERATE_SERVERSIDE_REPORT");
var $ea864d6f3cd9447e$export$e7d0f30aded58f25 = "".concat($ea864d6f3cd9447e$var$PREFIX, " GENERATE_SERVERSIDE_REPORT_SUCCESS");
var $ea864d6f3cd9447e$export$56bc8e1b4f48d88b = "".concat($ea864d6f3cd9447e$var$PREFIX, " GENERATE_SERVERSIDE_REPORT_FAIL");



var $b7c6f9d9aca86ec1$var$initialState = {};
function $b7c6f9d9aca86ec1$export$2e2bcd8739ae039(state, action) {
    if (state === void 0) state = $b7c6f9d9aca86ec1$var$initialState;
    switch(action.type){
        case $ea864d6f3cd9447e$export$4f0aa2f7c1eac83e:
            return Object.assign({}, state, action.payload, {
                submitRemitState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $ea864d6f3cd9447e$export$68b862e0d897562f:
            return Object.assign({}, state, {
                submitRemitState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $ea864d6f3cd9447e$export$538007741e882bbf:
            return Object.assign({}, state, {
                submitRemitState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $ea864d6f3cd9447e$export$e82cebb195cca37c:
            return Object.assign({}, state, action.payload, {
                gridRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $ea864d6f3cd9447e$export$91b422ec07f86303:
            return Object.assign({}, state, action.payload, {
                gridRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $ea864d6f3cd9447e$export$7781d9de80c0e585:
            return Object.assign({}, state, {
                gridRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $ea864d6f3cd9447e$export$b89956564774937f:
            return Object.assign({}, state, action.payload, {
                reportRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $ea864d6f3cd9447e$export$5676aa6ad8be94ad:
            return Object.assign({}, state, action.payload, {
                reportRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $ea864d6f3cd9447e$export$de67a0d68d773d25:
            return Object.assign({}, state, {
                reportRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $ea864d6f3cd9447e$export$ac8ddd8847849ab:
        case $ea864d6f3cd9447e$export$ebb5a9a0e3df52b0:
        case $ea864d6f3cd9447e$export$37877b3afd681a6d:
            return Object.assign({}, state, action.payload);
        case $ea864d6f3cd9447e$export$6846fb968bdf775b:
        case $ea864d6f3cd9447e$export$2bc5c5033fc1d7c8:
        case $ea864d6f3cd9447e$export$af72e095ba9f5b67:
            return Object.assign({}, state, action.payload);
        case $ea864d6f3cd9447e$export$ab2ecf21d87194a9:
            return Object.assign({}, state, action.payload, {
                editRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $ea864d6f3cd9447e$export$7f322859f452c805:
            return Object.assign({}, state, {
                editRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $ea864d6f3cd9447e$export$e4b9d21ba9cdebce:
            return Object.assign({}, state, {
                editRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $ea864d6f3cd9447e$export$1c44b3cf184102c:
            return Object.assign({}, state, action.payload, {
                deleteRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $ea864d6f3cd9447e$export$6912c6b7f329ddf8:
            return Object.assign({}, state, {
                deleteRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $ea864d6f3cd9447e$export$a70fe050778144ae:
            return Object.assign({}, state, {
                deleteRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $ea864d6f3cd9447e$export$4107b97e676630a2:
            return Object.assign({}, state, action.payload, {
                approveRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $ea864d6f3cd9447e$export$ed09ec00ca0af97:
            return Object.assign({}, state, {
                approveRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $ea864d6f3cd9447e$export$43e946fa582bde3b:
            return Object.assign({}, state, {
                approveRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $ea864d6f3cd9447e$export$a9fdcde8bac1b31f:
            return Object.assign({}, state, {
                approveRequestState: (0, $ad7802471dc8ad45$export$76350ffc4854c457),
                editRequestState: (0, $ad7802471dc8ad45$export$76350ffc4854c457),
                deleteRequestState: (0, $ad7802471dc8ad45$export$76350ffc4854c457)
            });
        case $ea864d6f3cd9447e$export$e7552e3670d2fd5b:
            return Object.assign({}, state, action.payload, {
                reportRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $ea864d6f3cd9447e$export$e7d0f30aded58f25:
            return Object.assign({}, state, action.payload, {
                reportRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $ea864d6f3cd9447e$export$56bc8e1b4f48d88b:
            return Object.assign({}, state, {
                reportRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        default:
            return state;
    }
}


var $25ac7cc755ebed09$var$PREFIX = "[Audit]";
var $25ac7cc755ebed09$export$13452f8bbda82685 = "".concat($25ac7cc755ebed09$var$PREFIX, " GET_GRID_AUDIT");
var $25ac7cc755ebed09$export$7afed574562a2885 = "".concat($25ac7cc755ebed09$var$PREFIX, " GET_GRID_AUDIT_SUCCESS");
var $25ac7cc755ebed09$export$d4fc8d9db769c49 = "".concat($25ac7cc755ebed09$var$PREFIX, " GET_GRID_AUDIT_FAIL");


var $d63ec98a47b07ca5$var$initialState = {};
function $d63ec98a47b07ca5$export$2e2bcd8739ae039(state, action) {
    if (state === void 0) state = $d63ec98a47b07ca5$var$initialState;
    switch(action.type){
        case $25ac7cc755ebed09$export$13452f8bbda82685:
        case $25ac7cc755ebed09$export$7afed574562a2885:
        case $25ac7cc755ebed09$export$d4fc8d9db769c49:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}


var $5ee26f856325551b$var$PREFIX = "[Update]";
var $5ee26f856325551b$export$f0fed340523808db = "".concat($5ee26f856325551b$var$PREFIX, " GET_GRID_UPDATE");
var $5ee26f856325551b$export$fe384e566dbcf73 = "".concat($5ee26f856325551b$var$PREFIX, " GET_GRID_UPDATE_SUCCESS");
var $5ee26f856325551b$export$ddb124701de44293 = "".concat($5ee26f856325551b$var$PREFIX, " GET_GRID_UPDATE_SUCCESS");
var $5ee26f856325551b$export$ba66402981b8dbe1 = "".concat($5ee26f856325551b$var$PREFIX, " APPROVE_REQUEST_EDIT");
var $5ee26f856325551b$export$f8520b2e576311d3 = "".concat($5ee26f856325551b$var$PREFIX, " APPROVE_REQUEST_EDIT_SUCCESS");
var $5ee26f856325551b$export$a81c28656b6d36be = "".concat($5ee26f856325551b$var$PREFIX, " APPROVE_REQUEST_EDIT_FAIL");
var $5ee26f856325551b$export$be6f145b71ba0393 = "".concat($5ee26f856325551b$var$PREFIX, " REJECT_REQUEST_EDIT");
var $5ee26f856325551b$export$74290b6372bb35d4 = "".concat($5ee26f856325551b$var$PREFIX, " REJECT_REQUEST_EDIT_SUCCESS");
var $5ee26f856325551b$export$56fd14446ca4c29f = "".concat($5ee26f856325551b$var$PREFIX, " REJECT_REQUEST_EDIT_FAIL");
var $5ee26f856325551b$export$2e4ccd371a4d296c = "".concat($5ee26f856325551b$var$PREFIX, " APPROVE_REQUEST_DELETE");
var $5ee26f856325551b$export$a2ab994bb90bb76e = "".concat($5ee26f856325551b$var$PREFIX, " APPROVE_REQUEST_DELETE_SUCCESS");
var $5ee26f856325551b$export$ad40c97a29117f4a = "".concat($5ee26f856325551b$var$PREFIX, " APPROVE_REQUEST_DELETE_FAIL");
var $5ee26f856325551b$export$6a2afda38f4a1418 = "".concat($5ee26f856325551b$var$PREFIX, " REJECT_REQUEST_DELETE");
var $5ee26f856325551b$export$655eeb28b533f7e5 = "".concat($5ee26f856325551b$var$PREFIX, " REJECT_REQUEST_DELETE_SUCCESS");
var $5ee26f856325551b$export$6471f570e355eb7e = "".concat($5ee26f856325551b$var$PREFIX, " REJECT_REQUEST_DELETE_FAIL");



var $f9641e568400062e$var$initialState = {};
function $f9641e568400062e$export$2e2bcd8739ae039(state, action) {
    if (state === void 0) state = $f9641e568400062e$var$initialState;
    switch(action.type){
        case $5ee26f856325551b$export$f0fed340523808db:
        case $5ee26f856325551b$export$fe384e566dbcf73:
        case $5ee26f856325551b$export$ddb124701de44293:
            return Object.assign({}, state, action.payload);
        case $5ee26f856325551b$export$ba66402981b8dbe1:
            return Object.assign({}, state, action.payload, {
                editRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $5ee26f856325551b$export$f8520b2e576311d3:
            return Object.assign({}, state, action.payload, {
                editRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $5ee26f856325551b$export$a81c28656b6d36be:
            return Object.assign({}, state, action.payload, {
                editRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $5ee26f856325551b$export$be6f145b71ba0393:
            return Object.assign({}, state, action.payload, {
                editRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $5ee26f856325551b$export$74290b6372bb35d4:
            return Object.assign({}, state, action.payload, {
                editRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $5ee26f856325551b$export$56fd14446ca4c29f:
            return Object.assign({}, state, action.payload, {
                editRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $5ee26f856325551b$export$2e4ccd371a4d296c:
            return Object.assign({}, state, action.payload, {
                editRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $5ee26f856325551b$export$a2ab994bb90bb76e:
            return Object.assign({}, state, action.payload, {
                editRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $5ee26f856325551b$export$ad40c97a29117f4a:
            return Object.assign({}, state, action.payload, {
                editRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $5ee26f856325551b$export$6a2afda38f4a1418:
            return Object.assign({}, state, action.payload, {
                editRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $5ee26f856325551b$export$655eeb28b533f7e5:
            return Object.assign({}, state, action.payload, {
                editRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $5ee26f856325551b$export$6471f570e355eb7e:
            return Object.assign({}, state, action.payload, {
                editRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        default:
            return state;
    }
}


var $7859e0852b06702e$var$PREFIX = "[Vehicle]";
var $7859e0852b06702e$export$6d686d51d5c3c8d0 = "".concat($7859e0852b06702e$var$PREFIX, " GET_VEHICLES");
var $7859e0852b06702e$export$719c81f6a7b18cd9 = "".concat($7859e0852b06702e$var$PREFIX, " GET_VEHICLES_SUCCESS");
var $7859e0852b06702e$export$d053e9a3a6f6b6fa = "".concat($7859e0852b06702e$var$PREFIX, " GET_VEHICLES_FAIL");
var $7859e0852b06702e$export$3366fc19859b9ff8 = "".concat($7859e0852b06702e$var$PREFIX, " CREATE_VEHICLE");
var $7859e0852b06702e$export$ce38865bc92ccaf6 = "".concat($7859e0852b06702e$var$PREFIX, " CREATE_VEHICLE_SUCCESS");
var $7859e0852b06702e$export$642b701085f6396d = "".concat($7859e0852b06702e$var$PREFIX, " CREATE_VEHICLE_FAIL");
var $7859e0852b06702e$export$aa1eb15edf81c53f = "".concat($7859e0852b06702e$var$PREFIX, " EDIT_VEHICLE");
var $7859e0852b06702e$export$fc9423c375cacbc = "".concat($7859e0852b06702e$var$PREFIX, " EDIT_VEHICLE_SUCCESS");
var $7859e0852b06702e$export$7e5952ba3a7ae659 = "".concat($7859e0852b06702e$var$PREFIX, " EDIT_VEHICLE_FAIL");
var $7859e0852b06702e$export$cf8065a69c02ae59 = "".concat($7859e0852b06702e$var$PREFIX, " CREATE_VEHICLE_FILE");
var $7859e0852b06702e$export$ba29fe9678473527 = "".concat($7859e0852b06702e$var$PREFIX, " CREATE_VEHICLE_FILE_SUCCESS");
var $7859e0852b06702e$export$f162630ac92a787c = "".concat($7859e0852b06702e$var$PREFIX, " CREATE_VEHICLE_FILE_FAIL");
var $7859e0852b06702e$export$417d121b6bc4be50 = "".concat($7859e0852b06702e$var$PREFIX, " GET_VEHICLE_FILES");
var $7859e0852b06702e$export$59fbf74044cf4b65 = "".concat($7859e0852b06702e$var$PREFIX, " GET_VEHICLE_FILES_SUCCESS");
var $7859e0852b06702e$export$3c7c5390d1b89499 = "".concat($7859e0852b06702e$var$PREFIX, " GET_VEHICLE_FILES_FAIL");
var $7859e0852b06702e$export$615e5a2c325fd326 = "".concat($7859e0852b06702e$var$PREFIX, " APPROVE_VEHICLE_FILE");
var $7859e0852b06702e$export$5d7dfa4840bc6a4 = "".concat($7859e0852b06702e$var$PREFIX, " APPROVE_VEHICLE_FILE_SUCCESS");
var $7859e0852b06702e$export$dd5053c11256b135 = "".concat($7859e0852b06702e$var$PREFIX, " APPROVE_VEHICLE_FILE_FAIL");
var $7859e0852b06702e$export$b5f09aa9d5f1a613 = "".concat($7859e0852b06702e$var$PREFIX, " REJECT_VEHICLE_FILE");
var $7859e0852b06702e$export$42577fe475e0ad42 = "".concat($7859e0852b06702e$var$PREFIX, " REJECT_VEHICLE_FILE_SUCCESS");
var $7859e0852b06702e$export$eaa60d4c17f242ac = "".concat($7859e0852b06702e$var$PREFIX, " REJECT_VEHICLE_FILE_FAIL");
var $7859e0852b06702e$export$30687d321270ea99 = "".concat($7859e0852b06702e$var$PREFIX, " GET_JOB_ORDERS");
var $7859e0852b06702e$export$ec82f8864ae350b = "".concat($7859e0852b06702e$var$PREFIX, " GET_JOB_ORDERS_SUCCESS");
var $7859e0852b06702e$export$1899b5f35b3fd63a = "".concat($7859e0852b06702e$var$PREFIX, " GET_JOB_ORDERS_FAIL");
var $7859e0852b06702e$export$6beda060f5e67d2f = "".concat($7859e0852b06702e$var$PREFIX, " CREATE_JOB_ORDER");
var $7859e0852b06702e$export$bdcb11859281f97a = "".concat($7859e0852b06702e$var$PREFIX, " CREATE_JOB_ORDER_SUCCESS");
var $7859e0852b06702e$export$b3bce86cc111e693 = "".concat($7859e0852b06702e$var$PREFIX, " CREATE_JOB_ORDER_FAIL");
var $7859e0852b06702e$export$be2eeddad8b7feff = "".concat($7859e0852b06702e$var$PREFIX, " CREATE_JOB_ORDER_CLEANUP");
var $7859e0852b06702e$export$1c3e1589bb6475a7 = "".concat($7859e0852b06702e$var$PREFIX, " UPDATE_JOB_ORDER");
var $7859e0852b06702e$export$86c76a9d7918893a = "".concat($7859e0852b06702e$var$PREFIX, " UPDATE_JOB_ORDER_SUCCESS");
var $7859e0852b06702e$export$9722702f2f44a66c = "".concat($7859e0852b06702e$var$PREFIX, " UPDATE_JOB_ORDER_FAIL");
var $7859e0852b06702e$export$664e2379a8eddc0c = "".concat($7859e0852b06702e$var$PREFIX, " GET_MEDICAL_HISTORY");
var $7859e0852b06702e$export$3fd184262df598c4 = "".concat($7859e0852b06702e$var$PREFIX, " GET_MEDICAL_HISTORY_SUCCESS");
var $7859e0852b06702e$export$bf59c09bbb596efd = "".concat($7859e0852b06702e$var$PREFIX, " GET_MEDICAL_HISTORY_FAIL");
var $7859e0852b06702e$export$53f4e43bfbd6f4cc = "".concat($7859e0852b06702e$var$PREFIX, " GENERATE_VEHICLE_EXPENSE_REPORT");
var $7859e0852b06702e$export$2b756767309e17c8 = "".concat($7859e0852b06702e$var$PREFIX, " GENERATE_VEHICLE_EXPENSE_REPORT_SUCCESS");
var $7859e0852b06702e$export$885cc1cfdd23e593 = "".concat($7859e0852b06702e$var$PREFIX, " GENERATE_VEHICLE_EXPENSE_REPORT_FAIL");
var $7859e0852b06702e$export$9d73ba9f67b08be4 = "".concat($7859e0852b06702e$var$PREFIX, " RESET_VEHICLE_FILE_STATE");



var $8c8865a3a484658c$var$initialState = {};
function $8c8865a3a484658c$export$2e2bcd8739ae039(state, action) {
    if (state === void 0) state = $8c8865a3a484658c$var$initialState;
    switch(action.type){
        case $7859e0852b06702e$export$6d686d51d5c3c8d0:
        case $7859e0852b06702e$export$719c81f6a7b18cd9:
        case $7859e0852b06702e$export$d053e9a3a6f6b6fa:
            return Object.assign({}, state, action.payload, {
                respondVehicleFileState: (0, $ad7802471dc8ad45$export$76350ffc4854c457)
            });
        case $7859e0852b06702e$export$417d121b6bc4be50:
        case $7859e0852b06702e$export$59fbf74044cf4b65:
        case $7859e0852b06702e$export$3c7c5390d1b89499:
            return Object.assign({}, state, action.payload);
        case $7859e0852b06702e$export$3366fc19859b9ff8:
            return Object.assign({}, state, action.payload, {
                createVehicleState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $7859e0852b06702e$export$ce38865bc92ccaf6:
        case $7859e0852b06702e$export$642b701085f6396d:
            return Object.assign({}, state, action.payload);
        case $7859e0852b06702e$export$aa1eb15edf81c53f:
            return Object.assign({}, state, action.payload, {
                editVehicleState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $7859e0852b06702e$export$fc9423c375cacbc:
        case $7859e0852b06702e$export$7e5952ba3a7ae659:
            return Object.assign({}, state, action.payload);
        case $7859e0852b06702e$export$cf8065a69c02ae59:
            return Object.assign({}, state, action.payload, {
                createVehicleFileState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $7859e0852b06702e$export$ba29fe9678473527:
        case $7859e0852b06702e$export$f162630ac92a787c:
            return Object.assign({}, state, action.payload);
        case $7859e0852b06702e$export$615e5a2c325fd326:
            return Object.assign({}, state, action.payload, {
                respondVehicleFileState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $7859e0852b06702e$export$5d7dfa4840bc6a4:
        case $7859e0852b06702e$export$dd5053c11256b135:
            return Object.assign({}, state, action.payload);
        case $7859e0852b06702e$export$b5f09aa9d5f1a613:
            return Object.assign({}, state, action.payload, {
                respondVehicleFileState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $7859e0852b06702e$export$42577fe475e0ad42:
        case $7859e0852b06702e$export$eaa60d4c17f242ac:
            return Object.assign({}, state, action.payload);
        case $7859e0852b06702e$export$30687d321270ea99:
        case $7859e0852b06702e$export$ec82f8864ae350b:
        case $7859e0852b06702e$export$1899b5f35b3fd63a:
            return Object.assign({}, state, action.payload);
        case $7859e0852b06702e$export$6beda060f5e67d2f:
        case $7859e0852b06702e$export$bdcb11859281f97a:
        case $7859e0852b06702e$export$b3bce86cc111e693:
        case $7859e0852b06702e$export$be2eeddad8b7feff:
            return Object.assign({}, state, action.payload);
        case $7859e0852b06702e$export$1c3e1589bb6475a7:
        case $7859e0852b06702e$export$86c76a9d7918893a:
        case $7859e0852b06702e$export$9722702f2f44a66c:
            return Object.assign({}, state, action.payload);
        case $7859e0852b06702e$export$664e2379a8eddc0c:
        case $7859e0852b06702e$export$3fd184262df598c4:
        case $7859e0852b06702e$export$bf59c09bbb596efd:
            return Object.assign({}, state, action.payload);
        case $7859e0852b06702e$export$53f4e43bfbd6f4cc:
        case $7859e0852b06702e$export$2b756767309e17c8:
        case $7859e0852b06702e$export$885cc1cfdd23e593:
            return Object.assign({}, state, action.payload);
        case $7859e0852b06702e$export$9d73ba9f67b08be4:
            return Object.assign({}, state, {
                createVehicleFileState: (0, $ad7802471dc8ad45$export$76350ffc4854c457)
            });
        default:
            return state;
    }
}


var $65e879dcad4ecaad$var$PREFIX = "[MICROSCOPE]";
var $65e879dcad4ecaad$export$7d659f58fd3701d = "".concat($65e879dcad4ecaad$var$PREFIX, " RETRIEVE_GRAPH_DATA");
var $65e879dcad4ecaad$export$5a447246bca8957e = "".concat($65e879dcad4ecaad$var$PREFIX, " RETRIEVE_GRAPH_DATA_SUCCESS");
var $65e879dcad4ecaad$export$36512567e53b44be = "".concat($65e879dcad4ecaad$var$PREFIX, " RETRIEVE_GRAPH_DATA_FAIL");



var $8c93ae5ece50f634$var$initialState = {};
function $8c93ae5ece50f634$export$2e2bcd8739ae039(state, action) {
    if (state === void 0) state = $8c93ae5ece50f634$var$initialState;
    switch(action.type){
        case $65e879dcad4ecaad$export$7d659f58fd3701d:
            return Object.assign({}, state, action.payload, {
                retrieveGraphDataStatus: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $65e879dcad4ecaad$export$5a447246bca8957e:
            return Object.assign({}, state, action.payload, {
                retrieveGraphDataStatus: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $65e879dcad4ecaad$export$36512567e53b44be:
            return Object.assign({}, state, action.payload, {
                retrieveGraphDataStatus: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        default:
            return state;
    }
}


var $0aa7832c96ad7a8d$var$PREFIX = "[Withdrawal]";
var $0aa7832c96ad7a8d$export$8a851eeafd335d3f = "".concat($0aa7832c96ad7a8d$var$PREFIX, " GET_PRICES");
var $0aa7832c96ad7a8d$export$975edb9d659b30a5 = "".concat($0aa7832c96ad7a8d$var$PREFIX, " GET_PRICES_SUCCESS");
var $0aa7832c96ad7a8d$export$da19de0c16ebf170 = "".concat($0aa7832c96ad7a8d$var$PREFIX, " GET_PRICES_FAIL");
var $0aa7832c96ad7a8d$export$77f66c384bff48ec = "".concat($0aa7832c96ad7a8d$var$PREFIX, " GET_GRID_WITHDRAWAL");
var $0aa7832c96ad7a8d$export$ed4400dd59fce138 = "".concat($0aa7832c96ad7a8d$var$PREFIX, " GET_GRID_WITHDRAWAL_SUCCESS");
var $0aa7832c96ad7a8d$export$20e6536dbfe7c63c = "".concat($0aa7832c96ad7a8d$var$PREFIX, " GET_GRID_WITHDRAWAL_FAIL");
var $0aa7832c96ad7a8d$export$e232a12d14bb88be = "".concat($0aa7832c96ad7a8d$var$PREFIX, " CREATE_WITHDRAWAL");
var $0aa7832c96ad7a8d$export$3983fc4c8496d6cf = "".concat($0aa7832c96ad7a8d$var$PREFIX, " CREATE_WITHDRAWAL_SUCCESS");
var $0aa7832c96ad7a8d$export$81d888d902e22f40 = "".concat($0aa7832c96ad7a8d$var$PREFIX, " CREATE_WITHDRAWAL_FAIL");
var $0aa7832c96ad7a8d$export$ce7e3994f699d240 = "".concat($0aa7832c96ad7a8d$var$PREFIX, " APPROVE_WITHDRAWAL");
var $0aa7832c96ad7a8d$export$9178df8e2755611c = "".concat($0aa7832c96ad7a8d$var$PREFIX, " APPROVE_WITHDRAWAL_SUCCESS");
var $0aa7832c96ad7a8d$export$f216b0b9b90fff3f = "".concat($0aa7832c96ad7a8d$var$PREFIX, " APPROVE_WITHDRAWAL_FAIL");
var $0aa7832c96ad7a8d$export$16822945959ccb2e = "".concat($0aa7832c96ad7a8d$var$PREFIX, " REJECT_WITHDRAWAL");
var $0aa7832c96ad7a8d$export$49fd866ab749dbbe = "".concat($0aa7832c96ad7a8d$var$PREFIX, " REJECT_WITHDRAWAL_SUCCESS");
var $0aa7832c96ad7a8d$export$68738a51a9df9881 = "".concat($0aa7832c96ad7a8d$var$PREFIX, " REJECT_WITHDRAWAL_FAIL");
var $0aa7832c96ad7a8d$export$f521ec80f2675a14 = "".concat($0aa7832c96ad7a8d$var$PREFIX, " REEDIT_WITHDRAWAL");
var $0aa7832c96ad7a8d$export$62b23a759d6b00e6 = "".concat($0aa7832c96ad7a8d$var$PREFIX, " REEDIT_WITHDRAWAL_SUCCESS");
var $0aa7832c96ad7a8d$export$2c2d9df55e7bbbc5 = "".concat($0aa7832c96ad7a8d$var$PREFIX, " REEDIT_WITHDRAWAL_FAIL");
var $0aa7832c96ad7a8d$export$85e7a25aa0be6caf = "".concat($0aa7832c96ad7a8d$var$PREFIX, " UPDATE_WITHDRAWAL");
var $0aa7832c96ad7a8d$export$3aa263c9608ce90e = "".concat($0aa7832c96ad7a8d$var$PREFIX, " UPDATE_WITHDRAWAL_SUCCESS");
var $0aa7832c96ad7a8d$export$3dfc9d330b932f39 = "".concat($0aa7832c96ad7a8d$var$PREFIX, " UPDATE_WITHDRAWAL_FAIL");
var $0aa7832c96ad7a8d$export$a2888da95f8fb454 = "".concat($0aa7832c96ad7a8d$var$PREFIX, " REEDIT_ACCEPT_WITHDRAWAL");
var $0aa7832c96ad7a8d$export$d5f54c41d72f5b13 = "".concat($0aa7832c96ad7a8d$var$PREFIX, " REEDIT_ACCEPT_WITHDRAWAL_SUCCESS");
var $0aa7832c96ad7a8d$export$ca74fbdd027d39d1 = "".concat($0aa7832c96ad7a8d$var$PREFIX, " REEDIT_ACCEPT_WITHDRAWAL_FAIL");
var $0aa7832c96ad7a8d$export$6cd1afba76b7e164 = "".concat($0aa7832c96ad7a8d$var$PREFIX, " REEDIT_DECLINE_WITHDRAWAL");
var $0aa7832c96ad7a8d$export$2817b96f4157750f = "".concat($0aa7832c96ad7a8d$var$PREFIX, " REEDIT_DECLINE_WITHDRAWAL_SUCCESS");
var $0aa7832c96ad7a8d$export$790e9cd8fc434e0c = "".concat($0aa7832c96ad7a8d$var$PREFIX, " REEDIT_DECLINE_WITHDRAWAL_FAIL");
var $0aa7832c96ad7a8d$export$7602920c18a69ec5 = "".concat($0aa7832c96ad7a8d$var$PREFIX, " RESET_WITHDRAWAL_STATE");



var $497457a0f6cf0104$var$initialState = {};
function $497457a0f6cf0104$export$2e2bcd8739ae039(state, action) {
    if (state === void 0) state = $497457a0f6cf0104$var$initialState;
    switch(action.type){
        case $0aa7832c96ad7a8d$export$8a851eeafd335d3f:
            return Object.assign({}, state, action.payload, {
                priceRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $0aa7832c96ad7a8d$export$975edb9d659b30a5:
        case $0aa7832c96ad7a8d$export$da19de0c16ebf170:
            return Object.assign({}, state, action.payload);
        case $0aa7832c96ad7a8d$export$77f66c384bff48ec:
            return Object.assign({}, state, action.payload, {
                gridRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $0aa7832c96ad7a8d$export$ed4400dd59fce138:
        case $0aa7832c96ad7a8d$export$20e6536dbfe7c63c:
            return Object.assign({}, state, action.payload);
        case $0aa7832c96ad7a8d$export$e232a12d14bb88be:
        case $0aa7832c96ad7a8d$export$ce7e3994f699d240:
        case $0aa7832c96ad7a8d$export$16822945959ccb2e:
        case $0aa7832c96ad7a8d$export$f521ec80f2675a14:
        case $0aa7832c96ad7a8d$export$85e7a25aa0be6caf:
        case $0aa7832c96ad7a8d$export$a2888da95f8fb454:
        case $0aa7832c96ad7a8d$export$6cd1afba76b7e164:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $0aa7832c96ad7a8d$export$3983fc4c8496d6cf:
        case $0aa7832c96ad7a8d$export$9178df8e2755611c:
        case $0aa7832c96ad7a8d$export$49fd866ab749dbbe:
        case $0aa7832c96ad7a8d$export$62b23a759d6b00e6:
        case $0aa7832c96ad7a8d$export$3aa263c9608ce90e:
        case $0aa7832c96ad7a8d$export$d5f54c41d72f5b13:
        case $0aa7832c96ad7a8d$export$2817b96f4157750f:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $0aa7832c96ad7a8d$export$81d888d902e22f40:
        case $0aa7832c96ad7a8d$export$f216b0b9b90fff3f:
        case $0aa7832c96ad7a8d$export$68738a51a9df9881:
        case $0aa7832c96ad7a8d$export$2c2d9df55e7bbbc5:
        case $0aa7832c96ad7a8d$export$3dfc9d330b932f39:
        case $0aa7832c96ad7a8d$export$ca74fbdd027d39d1:
        case $0aa7832c96ad7a8d$export$790e9cd8fc434e0c:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $0aa7832c96ad7a8d$export$7602920c18a69ec5:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$76350ffc4854c457)
            });
        default:
            return state;
    }
}


var $5dbd95920940fbf7$var$PREFIX = "[Disposal]";
var $5dbd95920940fbf7$export$ccf130fa81c04150 = "".concat($5dbd95920940fbf7$var$PREFIX, " GET_GRID_DISPOSAL");
var $5dbd95920940fbf7$export$3ae694984dad8df0 = "".concat($5dbd95920940fbf7$var$PREFIX, " GET_GRID_DISPOSAL_SUCCESS");
var $5dbd95920940fbf7$export$a57ecdf4cdd82ab3 = "".concat($5dbd95920940fbf7$var$PREFIX, " GET_GRID_DISPOSAL_FAIL");
var $5dbd95920940fbf7$export$39abb8eb105ebb6e = "".concat($5dbd95920940fbf7$var$PREFIX, " CREATE_DISPOSAL");
var $5dbd95920940fbf7$export$fd160439eae40c54 = "".concat($5dbd95920940fbf7$var$PREFIX, " CREATE_DISPOSAL_SUCCESS");
var $5dbd95920940fbf7$export$cd6919ab739e1e26 = "".concat($5dbd95920940fbf7$var$PREFIX, " CREATE_DISPOSAL_FAIL");
var $5dbd95920940fbf7$export$be87a995de4ebda4 = "".concat($5dbd95920940fbf7$var$PREFIX, " RESET_DISPOSAL_STATE");
var $5dbd95920940fbf7$export$d80ec8aacf18617a = "".concat($5dbd95920940fbf7$var$PREFIX, " CREATE_LOCATION");
var $5dbd95920940fbf7$export$612688e2fffd0385 = "".concat($5dbd95920940fbf7$var$PREFIX, " CREATE_LOCATION_SUCCESS");
var $5dbd95920940fbf7$export$dcc288d79863c22f = "".concat($5dbd95920940fbf7$var$PREFIX, " CREATE_LOCATION_FAIL");



var $baa69557691c451f$var$initialState = {};
function $baa69557691c451f$export$2e2bcd8739ae039(state, action) {
    if (state === void 0) state = $baa69557691c451f$var$initialState;
    switch(action.type){
        case $5dbd95920940fbf7$export$ccf130fa81c04150:
            return Object.assign({}, state, action.payload, {
                gridRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $5dbd95920940fbf7$export$3ae694984dad8df0:
        case $5dbd95920940fbf7$export$a57ecdf4cdd82ab3:
            return Object.assign({}, state, action.payload);
        case $5dbd95920940fbf7$export$39abb8eb105ebb6e:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $5dbd95920940fbf7$export$fd160439eae40c54:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $5dbd95920940fbf7$export$cd6919ab739e1e26:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $5dbd95920940fbf7$export$d80ec8aacf18617a:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $5dbd95920940fbf7$export$612688e2fffd0385:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $5dbd95920940fbf7$export$dcc288d79863c22f:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $5dbd95920940fbf7$export$be87a995de4ebda4:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$76350ffc4854c457)
            });
        default:
            return state;
    }
}


var $9faeaaf3b7b2176c$var$PREFIX = "[CashbondLoan]";
var $9faeaaf3b7b2176c$export$1034728adc42b984 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GET_GRID_CASHBOND");
var $9faeaaf3b7b2176c$export$19af10c664e95825 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GET_GRID_CASHBOND_SUCCESS");
var $9faeaaf3b7b2176c$export$339af5882dae5595 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GET_GRID_CASHBOND_FAIL");
var $9faeaaf3b7b2176c$export$7a6efbf66dd44bf6 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " CREATE_CASHBOND");
var $9faeaaf3b7b2176c$export$3085e8f469fc5f08 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " CREATE_CASHBOND_SUCCESS");
var $9faeaaf3b7b2176c$export$9d14d09497dbe8af = "".concat($9faeaaf3b7b2176c$var$PREFIX, " CREATE_CASHBOND_FAIL");
var $9faeaaf3b7b2176c$export$80f112149f100e38 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " CREATE_CASHBOND_PAYMENT");
var $9faeaaf3b7b2176c$export$8493a5d3efb13529 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " CREATE_CASHBOND_PAYMENT_SUCCESS");
var $9faeaaf3b7b2176c$export$f39666e12bd0fb6f = "".concat($9faeaaf3b7b2176c$var$PREFIX, " CREATE_CASHBOND_PAYMENT_FAIL");
var $9faeaaf3b7b2176c$export$843b4ad7e23f8cba = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GET_GRID_LOAN");
var $9faeaaf3b7b2176c$export$64903e6356674f0c = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GET_GRID_LOAN_SUCCESS");
var $9faeaaf3b7b2176c$export$46eac9d2d2adca6d = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GET_GRID_LOAN_FAIL");
var $9faeaaf3b7b2176c$export$d38286f15dd53ade = "".concat($9faeaaf3b7b2176c$var$PREFIX, " CREATE_LOAN");
var $9faeaaf3b7b2176c$export$83c38cdff29b2c33 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " CREATE_LOAN_SUCCESS");
var $9faeaaf3b7b2176c$export$6df051a5c38750d5 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " CREATE_LOAN_FAIL");
var $9faeaaf3b7b2176c$export$6964af2754c72e35 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " CREATE_LOAN_PAYMENT");
var $9faeaaf3b7b2176c$export$79f2d2b27d9fe3b5 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " CREATE_LOAN_PAYMENT_SUCCESS");
var $9faeaaf3b7b2176c$export$be8be11ea691e2bf = "".concat($9faeaaf3b7b2176c$var$PREFIX, " CREATE_LOAN_PAYMENT_FAIL");
var $9faeaaf3b7b2176c$export$63c41752fe5bdae7 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " UPDATE_LOAN_STATUS");
var $9faeaaf3b7b2176c$export$3d59594cfdbe6fe6 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " UPDATE_LOAN_STATUS_SUCCESS");
var $9faeaaf3b7b2176c$export$a946d7e2cec5e064 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " UPDATE_LOAN_STATUS_FAIL");
var $9faeaaf3b7b2176c$export$b9bca83af8eb0508 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GET_LOAN_PAYMENTS");
var $9faeaaf3b7b2176c$export$f77c581b8ceb94f5 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GET_LOAN_PAYMENTS_SUCCESS");
var $9faeaaf3b7b2176c$export$a46cfbcc82d27a72 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GET_LOAN_PAYMENTS_FAIL");
var $9faeaaf3b7b2176c$export$81f41e5e6f50faec = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GET_BOND_PAYMENTS");
var $9faeaaf3b7b2176c$export$f722b6c3d4f8732f = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GET_BOND_PAYMENTS_SUCCESS");
var $9faeaaf3b7b2176c$export$9ab2f391e0e39d88 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GET_BOND_PAYMENTS_FAIL");
var $9faeaaf3b7b2176c$export$a3a05ad01a242f49 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GENERATE_SERVERSIDE_LOAN_REPORT");
var $9faeaaf3b7b2176c$export$956e1db7f310e1ac = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GENERATE_SERVERSIDE_LOAN_REPORT_SUCCESS");
var $9faeaaf3b7b2176c$export$fb7356bebcbe05bb = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GENERATE_SERVERSIDE_LOAN_REPORT_FAIL");
var $9faeaaf3b7b2176c$export$603f5590406dec35 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GENERATE_SERVERSIDE_CASHBOND_REPORT");
var $9faeaaf3b7b2176c$export$9696ea8fb11576d5 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GENERATE_SERVERSIDE_CASHBOND_REPORT_SUCCESS");
var $9faeaaf3b7b2176c$export$caeca8d2b4653fd = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GENERATE_SERVERSIDE_CASHBOND_REPORT_FAIL");
var $9faeaaf3b7b2176c$export$b982743d6eb42399 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " APPROVE_LOAN_PAYMENT");
var $9faeaaf3b7b2176c$export$735e5dda1eefe53e = "".concat($9faeaaf3b7b2176c$var$PREFIX, " APPROVE_LOAN_PAYMENT_SUCCESS");
var $9faeaaf3b7b2176c$export$95871123abe3b6cf = "".concat($9faeaaf3b7b2176c$var$PREFIX, " APPROVE_LOAN_PAYMENT_FAILURE");
var $9faeaaf3b7b2176c$export$286befb5f9ea4091 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " REJECT_LOAN_PAYMENT");
var $9faeaaf3b7b2176c$export$9319d8db591c99dd = "".concat($9faeaaf3b7b2176c$var$PREFIX, " REJECT_LOAN_PAYMENT_SUCCESS");
var $9faeaaf3b7b2176c$export$be20dc77e94a1e5a = "".concat($9faeaaf3b7b2176c$var$PREFIX, " REJECT_LOAN_PAYMENT_FAILURE");
var $9faeaaf3b7b2176c$export$157e6387758438c2 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " APPROVE_CASHBOND_PAYMENT");
var $9faeaaf3b7b2176c$export$752f4ce6cbf46779 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " APPROVE_CASHBOND_PAYMENT_SUCCESS");
var $9faeaaf3b7b2176c$export$6de406e9572a75db = "".concat($9faeaaf3b7b2176c$var$PREFIX, " APPROVE_CASHBOND_PAYMENT_FAILURE");
var $9faeaaf3b7b2176c$export$14d190b43fbb82db = "".concat($9faeaaf3b7b2176c$var$PREFIX, " REJECT_BOND_PAYMENT");
var $9faeaaf3b7b2176c$export$2e86298be2304ce = "".concat($9faeaaf3b7b2176c$var$PREFIX, " REJECT_BOND_PAYMENT_SUCCESS");
var $9faeaaf3b7b2176c$export$a697c7c30d95ef9a = "".concat($9faeaaf3b7b2176c$var$PREFIX, " REJECT_BOND_PAYMENT_FAILURE");
var $9faeaaf3b7b2176c$export$ccae5949e85ee97c = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GENERATE_SERVERSIDE_LOAN_PAYMENT_REPORT_SUCCESS");
var $9faeaaf3b7b2176c$export$ffc6ac2cbc266632 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GENERATE_SERVERSIDE_LOAN_PAYMENT_REPORT");
var $9faeaaf3b7b2176c$export$e5ff0702d50f5d0 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GENERATE_SERVERSIDE_LOAN_PAYMENT_REPORT_FAIL");
var $9faeaaf3b7b2176c$export$d7e9dc491b583a64 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GENERATE_SERVERSIDE_BOND_PAYMENT_REPORT_SUCCESS");
var $9faeaaf3b7b2176c$export$71767bdee8fc1b58 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GENERATE_SERVERSIDE_BOND_PAYMENT_REPORT");
var $9faeaaf3b7b2176c$export$aba0b87fdc14ee96 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " GENERATE_SERVERSIDE_BOND_PAYMENT_REPORT_FAIL");
var $9faeaaf3b7b2176c$export$401f3f70fe7a3e61 = "".concat($9faeaaf3b7b2176c$var$PREFIX, " RESET_CASHBONDLOAN_STATE");



var $ebe5d741cc1e1f8d$var$initialState = {};
function $ebe5d741cc1e1f8d$export$2e2bcd8739ae039(state, action) {
    if (state === void 0) state = $ebe5d741cc1e1f8d$var$initialState;
    switch(action.type){
        case $9faeaaf3b7b2176c$export$1034728adc42b984:
        case $9faeaaf3b7b2176c$export$843b4ad7e23f8cba:
            return Object.assign({}, state, action.payload, {
                gridRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $9faeaaf3b7b2176c$export$19af10c664e95825:
        case $9faeaaf3b7b2176c$export$339af5882dae5595:
        case $9faeaaf3b7b2176c$export$64903e6356674f0c:
        case $9faeaaf3b7b2176c$export$46eac9d2d2adca6d:
            return Object.assign({}, state, action.payload);
        case $9faeaaf3b7b2176c$export$7a6efbf66dd44bf6:
        case $9faeaaf3b7b2176c$export$80f112149f100e38:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $9faeaaf3b7b2176c$export$3085e8f469fc5f08:
        case $9faeaaf3b7b2176c$export$8493a5d3efb13529:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $9faeaaf3b7b2176c$export$9d14d09497dbe8af:
        case $9faeaaf3b7b2176c$export$f39666e12bd0fb6f:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $9faeaaf3b7b2176c$export$b982743d6eb42399:
        case $9faeaaf3b7b2176c$export$286befb5f9ea4091:
        case $9faeaaf3b7b2176c$export$157e6387758438c2:
        case $9faeaaf3b7b2176c$export$14d190b43fbb82db:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $9faeaaf3b7b2176c$export$735e5dda1eefe53e:
        case $9faeaaf3b7b2176c$export$9319d8db591c99dd:
        case $9faeaaf3b7b2176c$export$752f4ce6cbf46779:
        case $9faeaaf3b7b2176c$export$2e86298be2304ce:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $9faeaaf3b7b2176c$export$95871123abe3b6cf:
        case $9faeaaf3b7b2176c$export$be20dc77e94a1e5a:
        case $9faeaaf3b7b2176c$export$6de406e9572a75db:
        case $9faeaaf3b7b2176c$export$a697c7c30d95ef9a:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $9faeaaf3b7b2176c$export$d38286f15dd53ade:
        case $9faeaaf3b7b2176c$export$63c41752fe5bdae7:
        case $9faeaaf3b7b2176c$export$6964af2754c72e35:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $9faeaaf3b7b2176c$export$83c38cdff29b2c33:
        case $9faeaaf3b7b2176c$export$3d59594cfdbe6fe6:
        case $9faeaaf3b7b2176c$export$79f2d2b27d9fe3b5:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $9faeaaf3b7b2176c$export$6df051a5c38750d5:
        case $9faeaaf3b7b2176c$export$a946d7e2cec5e064:
        case $9faeaaf3b7b2176c$export$be8be11ea691e2bf:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $9faeaaf3b7b2176c$export$b9bca83af8eb0508:
        case $9faeaaf3b7b2176c$export$81f41e5e6f50faec:
            return Object.assign({}, state, action.payload, {
                paymentsRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07),
                postPutRequestState: (0, $ad7802471dc8ad45$export$76350ffc4854c457)
            });
        case $9faeaaf3b7b2176c$export$f77c581b8ceb94f5:
        case $9faeaaf3b7b2176c$export$f722b6c3d4f8732f:
            return Object.assign({}, state, action.payload, {
                paymentsRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $9faeaaf3b7b2176c$export$a46cfbcc82d27a72:
        case $9faeaaf3b7b2176c$export$9ab2f391e0e39d88:
            return Object.assign({}, state, action.payload, {
                paymentsRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $9faeaaf3b7b2176c$export$a3a05ad01a242f49:
        case $9faeaaf3b7b2176c$export$ffc6ac2cbc266632:
        case $9faeaaf3b7b2176c$export$603f5590406dec35:
        case $9faeaaf3b7b2176c$export$71767bdee8fc1b58:
            return Object.assign({}, state, action.payload, {
                reportRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $9faeaaf3b7b2176c$export$956e1db7f310e1ac:
        case $9faeaaf3b7b2176c$export$ccae5949e85ee97c:
        case $9faeaaf3b7b2176c$export$9696ea8fb11576d5:
        case $9faeaaf3b7b2176c$export$d7e9dc491b583a64:
            return Object.assign({}, state, action.payload, {
                reportRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $9faeaaf3b7b2176c$export$fb7356bebcbe05bb:
        case $9faeaaf3b7b2176c$export$e5ff0702d50f5d0:
        case $9faeaaf3b7b2176c$export$caeca8d2b4653fd:
        case $9faeaaf3b7b2176c$export$aba0b87fdc14ee96:
            return Object.assign({}, state, action.payload, {
                reportRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        case $9faeaaf3b7b2176c$export$401f3f70fe7a3e61:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$76350ffc4854c457)
            });
        default:
            return state;
    }
}


var $42d61ffa1d8a8d2b$var$PREFIX = "[Motorpool]";
var $42d61ffa1d8a8d2b$export$4b47e70039a23c0d = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " GET_SUPPLIERS");
var $42d61ffa1d8a8d2b$export$32b066daf13f7977 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " GET_SUPPLIERS_SUCCESS");
var $42d61ffa1d8a8d2b$export$ebbea60c1b54611b = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " GET_SUPPLIERS_FAIL");
var $42d61ffa1d8a8d2b$export$7a1acd13345d31d1 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_SUPPLIER");
var $42d61ffa1d8a8d2b$export$b71b943ab130b03f = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_SUPPLIER_SUCCESS");
var $42d61ffa1d8a8d2b$export$4779443e691a9bd = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_SUPPLIER_FAIL");
var $42d61ffa1d8a8d2b$export$23577ab1e176bf94 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " EDIT_SUPPLIER");
var $42d61ffa1d8a8d2b$export$44298b320dfe6ec6 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " EDIT_SUPPLIER_SUCCESS");
var $42d61ffa1d8a8d2b$export$f34471b32366d385 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " EDIT_SUPPLIER_FAIL");
var $42d61ffa1d8a8d2b$export$2c11d93fae2a2b91 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " GET_PURCHASE_DOCUMENTS");
var $42d61ffa1d8a8d2b$export$70207d327e8500d0 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " GET_PURCHASE_DOCUMENTS_SUCCESS");
var $42d61ffa1d8a8d2b$export$45bfd5011359c969 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " GET_PURCHASE_DOCUMENTS_FAIL");
var $42d61ffa1d8a8d2b$export$e85b08d1656584fd = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_PURCHASE_DOCUMENT");
var $42d61ffa1d8a8d2b$export$e5c7903e2195e3ac = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_PURCHASE_DOCUMENT_SUCCESS");
var $42d61ffa1d8a8d2b$export$b845d0418853eecb = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_PURCHASE_DOCUMENT_FAIL");
var $42d61ffa1d8a8d2b$export$f30ae27113e62e75 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " UPDATE_PURCHASE_DOCUMENT");
var $42d61ffa1d8a8d2b$export$b69d620fbf73f545 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " UPDATE_PURCHASE_DOCUMENT_SUCCESS");
var $42d61ffa1d8a8d2b$export$afefe0bf69fede53 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " UPDATE_PURCHASE_DOCUMENT_FAIL");
var $42d61ffa1d8a8d2b$export$45cf4d2d5931e7 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " SIGN_PURCHASE_DOCUMENT");
var $42d61ffa1d8a8d2b$export$53823b43d4098e03 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " SIGN_PURCHASE_DOCUMENT_SUCCESS");
var $42d61ffa1d8a8d2b$export$67830277ccc1ab6d = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " SIGN_PURCHASE_DOCUMENT_FAIL");
var $42d61ffa1d8a8d2b$export$219ad08fb66a8ce9 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_RECEIVING_REPORT");
var $42d61ffa1d8a8d2b$export$e0ac74c5766a60d9 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_RECEIVING_REPORT_SUCCESS");
var $42d61ffa1d8a8d2b$export$f29abefab8453a58 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_RECEIVING_REPORT_FAIL");
var $42d61ffa1d8a8d2b$export$ac218852b62ed936 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " GET_ITEMS");
var $42d61ffa1d8a8d2b$export$e55e65db5c6ebc42 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " GET_ITEMS_SUCCESS");
var $42d61ffa1d8a8d2b$export$f53f0f104c900386 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " GET_ITEMS_FAIL");
var $42d61ffa1d8a8d2b$export$12c5a76e8711aaf9 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_ITEM");
var $42d61ffa1d8a8d2b$export$80b327feb60df2a = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_ITEM_SUCCESS");
var $42d61ffa1d8a8d2b$export$584e6de652fbe73e = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_ITEM_FAIL");
var $42d61ffa1d8a8d2b$export$dd693b166ab0dca = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " GET_JO");
var $42d61ffa1d8a8d2b$export$53d1136df7b5cf9c = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " GET_JO_SUCCESS");
var $42d61ffa1d8a8d2b$export$d8418dc15898d972 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " GET_JO_FAIL");
var $42d61ffa1d8a8d2b$export$b756dd7da319f967 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_JO");
var $42d61ffa1d8a8d2b$export$79358c9c16287abf = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_JO_SUCCESS");
var $42d61ffa1d8a8d2b$export$aff5e0b21debd35c = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_JO_FAIL");
var $42d61ffa1d8a8d2b$export$8c063221a5c296f6 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " GET_IW");
var $42d61ffa1d8a8d2b$export$13c539a07d1605e1 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " GET_IW_SUCCESS");
var $42d61ffa1d8a8d2b$export$7732b475b1e07505 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " GET_IW_FAIL");
var $42d61ffa1d8a8d2b$export$957a5f118c67b29c = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_IW");
var $42d61ffa1d8a8d2b$export$a54a5efc08fff5af = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_IW_SUCCESS");
var $42d61ffa1d8a8d2b$export$8beb5a11d319cfa9 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_IW_FAIL");
var $42d61ffa1d8a8d2b$export$7b12c10955d2c61b = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " UPDATE_IW");
var $42d61ffa1d8a8d2b$export$c618038f5b3f5ec1 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " UPDATE_IW_SUCCESS");
var $42d61ffa1d8a8d2b$export$258b9e16767bed39 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " UPDATE_IW_FAIL");
var $42d61ffa1d8a8d2b$export$80f60acd99fb252a = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " PROCESS_IW");
var $42d61ffa1d8a8d2b$export$42ee4228479b90c4 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " PROCESS_IW_SUCCESS");
var $42d61ffa1d8a8d2b$export$96915d545c772da0 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " PROCESS_IW_FAIL");
var $42d61ffa1d8a8d2b$export$8f972aa3ca99dbc7 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " APPROVE_IW");
var $42d61ffa1d8a8d2b$export$552a720dae6b32bc = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " APPROVE_IW_SUCCESS");
var $42d61ffa1d8a8d2b$export$654ddfb89504dc59 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " APPROVE_IW_FAIL");
var $42d61ffa1d8a8d2b$export$3eb2cadfcad095b9 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " UPDATE_V2_JOB_ORDER");
var $42d61ffa1d8a8d2b$export$d94f1a0f25fdedab = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " UPDATE_V2_JOB_ORDER_SUCCESS");
var $42d61ffa1d8a8d2b$export$5386f8a90287c45c = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " UPDATE_V2_JOB_ORDER_FAIL");
var $42d61ffa1d8a8d2b$export$c732d4e88ae15264 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_PO");
var $42d61ffa1d8a8d2b$export$6b1566edaa626f78 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_PO_SUCCESS");
var $42d61ffa1d8a8d2b$export$59d345a959f778e2 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " CREATE_PO_FAIL");
var $42d61ffa1d8a8d2b$export$9847d0c5208657f5 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " APPROVE_PO");
var $42d61ffa1d8a8d2b$export$34cd4a419e817371 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " APPROVE_PO_SUCCESS");
var $42d61ffa1d8a8d2b$export$b8701ca7eea9c506 = "".concat($42d61ffa1d8a8d2b$var$PREFIX, " APPROVE_PO_FAIL");



var $c5bb627329b3b02d$var$initialState = {};
function $c5bb627329b3b02d$export$2e2bcd8739ae039(state, action) {
    if (state === void 0) state = $c5bb627329b3b02d$var$initialState;
    switch(action.type){
        case $42d61ffa1d8a8d2b$export$ac218852b62ed936:
            return Object.assign({}, state, action.payload, {
                itemRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $42d61ffa1d8a8d2b$export$e55e65db5c6ebc42:
        case $42d61ffa1d8a8d2b$export$f53f0f104c900386:
            return Object.assign({}, state, action.payload);
        case $42d61ffa1d8a8d2b$export$4b47e70039a23c0d:
            return Object.assign({}, state, action.payload, {
                supplierRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $42d61ffa1d8a8d2b$export$32b066daf13f7977:
        case $42d61ffa1d8a8d2b$export$45bfd5011359c969:
            return Object.assign({}, state, action.payload);
        case $42d61ffa1d8a8d2b$export$2c11d93fae2a2b91:
            return Object.assign({}, state, action.payload, {
                pdRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07),
                postPutRequestState: (0, $ad7802471dc8ad45$export$76350ffc4854c457)
            });
        case $42d61ffa1d8a8d2b$export$70207d327e8500d0:
        case $42d61ffa1d8a8d2b$export$45bfd5011359c969:
            return Object.assign({}, state, action.payload);
        case $42d61ffa1d8a8d2b$export$dd693b166ab0dca:
            return Object.assign({}, state, action.payload, {
                itemRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07),
                postPutRequestState: (0, $ad7802471dc8ad45$export$76350ffc4854c457)
            });
        case $42d61ffa1d8a8d2b$export$53d1136df7b5cf9c:
        case $42d61ffa1d8a8d2b$export$d8418dc15898d972:
            return Object.assign({}, state, action.payload);
        case $42d61ffa1d8a8d2b$export$8c063221a5c296f6:
            return Object.assign({}, state, action.payload, {
                itemRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $42d61ffa1d8a8d2b$export$13c539a07d1605e1:
        case $42d61ffa1d8a8d2b$export$7732b475b1e07505:
            return Object.assign({}, state, action.payload);
        case $42d61ffa1d8a8d2b$export$e85b08d1656584fd:
        case $42d61ffa1d8a8d2b$export$f30ae27113e62e75:
        case $42d61ffa1d8a8d2b$export$45cf4d2d5931e7:
        case $42d61ffa1d8a8d2b$export$219ad08fb66a8ce9:
        case $42d61ffa1d8a8d2b$export$7a1acd13345d31d1:
        case $42d61ffa1d8a8d2b$export$23577ab1e176bf94:
        case $42d61ffa1d8a8d2b$export$12c5a76e8711aaf9:
        case $42d61ffa1d8a8d2b$export$b756dd7da319f967:
        case $42d61ffa1d8a8d2b$export$957a5f118c67b29c:
        case $42d61ffa1d8a8d2b$export$7b12c10955d2c61b:
        case $42d61ffa1d8a8d2b$export$80f60acd99fb252a:
        case $42d61ffa1d8a8d2b$export$8f972aa3ca99dbc7:
        case $42d61ffa1d8a8d2b$export$3eb2cadfcad095b9:
        case $42d61ffa1d8a8d2b$export$c732d4e88ae15264:
        case $42d61ffa1d8a8d2b$export$9847d0c5208657f5:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
            });
        case $42d61ffa1d8a8d2b$export$e5c7903e2195e3ac:
        case $42d61ffa1d8a8d2b$export$b69d620fbf73f545:
        case $42d61ffa1d8a8d2b$export$53823b43d4098e03:
        case $42d61ffa1d8a8d2b$export$e0ac74c5766a60d9:
        case $42d61ffa1d8a8d2b$export$b71b943ab130b03f:
        case $42d61ffa1d8a8d2b$export$44298b320dfe6ec6:
        case $42d61ffa1d8a8d2b$export$80b327feb60df2a:
        case $42d61ffa1d8a8d2b$export$79358c9c16287abf:
        case $42d61ffa1d8a8d2b$export$a54a5efc08fff5af:
        case $42d61ffa1d8a8d2b$export$c618038f5b3f5ec1:
        case $42d61ffa1d8a8d2b$export$42ee4228479b90c4:
        case $42d61ffa1d8a8d2b$export$552a720dae6b32bc:
        case $42d61ffa1d8a8d2b$export$d94f1a0f25fdedab:
        case $42d61ffa1d8a8d2b$export$6b1566edaa626f78:
        case $42d61ffa1d8a8d2b$export$34cd4a419e817371:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
            });
        case $42d61ffa1d8a8d2b$export$b845d0418853eecb:
        case $42d61ffa1d8a8d2b$export$afefe0bf69fede53:
        case $42d61ffa1d8a8d2b$export$67830277ccc1ab6d:
        case $42d61ffa1d8a8d2b$export$f29abefab8453a58:
        case $42d61ffa1d8a8d2b$export$4779443e691a9bd:
        case $42d61ffa1d8a8d2b$export$f34471b32366d385:
        case $42d61ffa1d8a8d2b$export$584e6de652fbe73e:
        case $42d61ffa1d8a8d2b$export$aff5e0b21debd35c:
        case $42d61ffa1d8a8d2b$export$8beb5a11d319cfa9:
        case $42d61ffa1d8a8d2b$export$258b9e16767bed39:
        case $42d61ffa1d8a8d2b$export$96915d545c772da0:
        case $42d61ffa1d8a8d2b$export$654ddfb89504dc59:
        case $42d61ffa1d8a8d2b$export$5386f8a90287c45c:
        case $42d61ffa1d8a8d2b$export$59d345a959f778e2:
        case $42d61ffa1d8a8d2b$export$b8701ca7eea9c506:
            return Object.assign({}, state, action.payload, {
                postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
            });
        default:
            return state;
    }
}


var $f0fa1efe65ee6779$var$reducers = {
    user: (0, $995f42c48d93e7ce$export$2e2bcd8739ae039),
    remittance: (0, $b7c6f9d9aca86ec1$export$2e2bcd8739ae039),
    audit: (0, $d63ec98a47b07ca5$export$2e2bcd8739ae039),
    updates: (0, $f9641e568400062e$export$2e2bcd8739ae039),
    vehicles: (0, $8c8865a3a484658c$export$2e2bcd8739ae039),
    microscope: (0, $8c93ae5ece50f634$export$2e2bcd8739ae039),
    withdrawal: (0, $497457a0f6cf0104$export$2e2bcd8739ae039),
    disposal: (0, $baa69557691c451f$export$2e2bcd8739ae039),
    cashbondloan: (0, $ebe5d741cc1e1f8d$export$2e2bcd8739ae039),
    motorpool: (0, $c5bb627329b3b02d$export$2e2bcd8739ae039)
};
var $f0fa1efe65ee6779$var$rootReducer = (0, $ad4393542232627c$export$66e4520cdb265d18)($f0fa1efe65ee6779$var$reducers);
var $f0fa1efe65ee6779$export$2e2bcd8739ae039 = $f0fa1efe65ee6779$var$rootReducer;


/** PURE_IMPORTS_START _Observable,_util_isScheduler,_operators_mergeAll,_fromArray PURE_IMPORTS_END */ 

/** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */ 

function $f91e6d6e71ec76b6$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return (0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)((0, $e35fb39d7fe871e0$export$f0954fd7d5368655), concurrent);
}



function $f7078d3929c96a7f$export$4950aa0f605343fb() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ((0, $c70b56b236674ebc$export$187e35932e88c15c)(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === "number") concurrent = observables.pop();
    } else if (typeof last === "number") concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof (0, $87f1d8962784e676$export$77cea355fa80b5f4)) return observables[0];
    return (0, $f91e6d6e71ec76b6$export$18aef43295bbe906)(concurrent)((0, $64b1b74ab7847db2$export$571d59b505e6bb4e)(observables, scheduler));
}


function $22783a2c8c11cfe1$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var $22783a2c8c11cfe1$export$6259fe981e4a41dc = function combineEpics() {
    for(var _len = arguments.length, epics = Array(_len), _key = 0; _key < _len; _key++)epics[_key] = arguments[_key];
    var merger = function merger() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return (0, $f7078d3929c96a7f$export$4950aa0f605343fb).apply(undefined, $22783a2c8c11cfe1$var$_toConsumableArray(epics.map(function(epic) {
            var output$ = epic.apply(undefined, args);
            if (!output$) throw new TypeError('combineEpics: one of the provided Epics "' + (epic.name || "<anonymous>") + "\" does not return a stream. Double check you're not missing a return statement!");
            return output$;
        })));
    };
    // Technically the `name` property on Function's are supposed to be read-only.
    // While some JS runtimes allow it anyway (so this is useful in debugging)
    // some actually throw an exception when you attempt to do so.
    try {
        Object.defineProperty(merger, "name", {
            value: "combineEpics(" + epics.map(function(epic) {
                return epic.name || "<anonymous>";
            }).join(", ") + ")"
        });
    } catch (e) {}
    return merger;
};


var $f4f0268b008d3e35$exports = {};

$parcel$export($f4f0268b008d3e35$exports, "default", () => $f4f0268b008d3e35$export$2e2bcd8739ae039);

/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ 



function $73546da28e450aaf$export$9f6ea8e48bc26eab(project, resultSelector) {
    if (typeof resultSelector === "function") return function(source) {
        return source.pipe($73546da28e450aaf$export$9f6ea8e48bc26eab(function(a, i) {
            return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(project(a, i)).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }));
    };
    return function(source) {
        return source.lift(new $73546da28e450aaf$var$SwitchMapOperator(project));
    };
}
var $73546da28e450aaf$var$SwitchMapOperator = /*@__PURE__*/ function() {
    function SwitchMapOperator(project) {
        this.project = project;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $73546da28e450aaf$var$SwitchMapSubscriber(subscriber, this.project));
    };
    return SwitchMapOperator;
}();
var $73546da28e450aaf$var$SwitchMapSubscriber = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.index = 0;
        return _this;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        var innerSubscriber = new (0, $23eb368cee048f82$export$20b3446cf1c359c0)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        this.innerSubscription = (0, $23eb368cee048f82$export$d34bac9c0f124cff)(result, innerSubscriber);
        if (this.innerSubscription !== innerSubscriber) destination.add(this.innerSubscription);
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
        this.unsubscribe();
    };
    SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = undefined;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function() {
        this.innerSubscription = undefined;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    return SwitchMapSubscriber;
}((0, $23eb368cee048f82$export$b73f91a09e7d5376));

/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ 

function $ba3a949fb0190b34$export$3dede90624df3ba9(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $ba3a949fb0190b34$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
var $ba3a949fb0190b34$var$CatchOperator = /*@__PURE__*/ function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ba3a949fb0190b34$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
var $ba3a949fb0190b34$var$CatchSubscriber = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        var _this = _super.call(this, destination) || this;
        _this.selector = selector;
        _this.caught = caught;
        return _this;
    }
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            var innerSubscriber = new (0, $23eb368cee048f82$export$20b3446cf1c359c0)(this);
            this.add(innerSubscriber);
            var innerSubscription = (0, $23eb368cee048f82$export$d34bac9c0f124cff)(result, innerSubscriber);
            if (innerSubscription !== innerSubscriber) this.add(innerSubscription);
        }
    };
    return CatchSubscriber;
}((0, $23eb368cee048f82$export$b73f91a09e7d5376));

/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */ 
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ 

var $cb4eda232789f610$export$e5fdd83ec9152026 = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(OuterSubscriber, _super);
    function OuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OuterSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function(error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function(innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}((0, $0c5e61cfa4404ac4$export$60959659b2c22881));


/** PURE_IMPORTS_START _InnerSubscriber,_subscribeTo,_Observable PURE_IMPORTS_END */ /** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ 

var $c4477983fc3b82e4$export$6cd922279ed50d2b = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        _this.index = 0;
        return _this;
    }
    InnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}((0, $0c5e61cfa4404ac4$export$60959659b2c22881));




function $be07864dd1399f69$export$d0604af3321cfb1b(outerSubscriber, result, outerValue, outerIndex, innerSubscriber) {
    if (innerSubscriber === void 0) innerSubscriber = new (0, $c4477983fc3b82e4$export$6cd922279ed50d2b)(outerSubscriber, outerValue, outerIndex);
    if (innerSubscriber.closed) return undefined;
    if (result instanceof (0, $87f1d8962784e676$export$77cea355fa80b5f4)) return result.subscribe(innerSubscriber);
    return (0, $22dbcf3659b003f0$export$45e4095b0ba1d337)(result)(innerSubscriber);
}


function $dd030c518003cbd3$export$d449030e5c10edf7() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return function(source) {
        var project;
        if (typeof args[args.length - 1] === "function") project = args.pop();
        var observables = args;
        return source.lift(new $dd030c518003cbd3$var$WithLatestFromOperator(observables, project));
    };
}
var $dd030c518003cbd3$var$WithLatestFromOperator = /*@__PURE__*/ function() {
    function WithLatestFromOperator(observables, project) {
        this.observables = observables;
        this.project = project;
    }
    WithLatestFromOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $dd030c518003cbd3$var$WithLatestFromSubscriber(subscriber, this.observables, this.project));
    };
    return WithLatestFromOperator;
}();
var $dd030c518003cbd3$var$WithLatestFromSubscriber = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(WithLatestFromSubscriber, _super);
    function WithLatestFromSubscriber(destination, observables, project) {
        var _this = _super.call(this, destination) || this;
        _this.observables = observables;
        _this.project = project;
        _this.toRespond = [];
        var len = observables.length;
        _this.values = new Array(len);
        for(var i = 0; i < len; i++)_this.toRespond.push(i);
        for(var i = 0; i < len; i++){
            var observable = observables[i];
            _this.add((0, $be07864dd1399f69$export$d0604af3321cfb1b)(_this, observable, undefined, i));
        }
        return _this;
    }
    WithLatestFromSubscriber.prototype.notifyNext = function(_outerValue, innerValue, outerIndex) {
        this.values[outerIndex] = innerValue;
        var toRespond = this.toRespond;
        if (toRespond.length > 0) {
            var found = toRespond.indexOf(outerIndex);
            if (found !== -1) toRespond.splice(found, 1);
        }
    };
    WithLatestFromSubscriber.prototype.notifyComplete = function() {};
    WithLatestFromSubscriber.prototype._next = function(value) {
        if (this.toRespond.length === 0) {
            var args = [
                value
            ].concat(this.values);
            if (this.project) this._tryProject(args);
            else this.destination.next(args);
        }
    };
    WithLatestFromSubscriber.prototype._tryProject = function(args) {
        var result;
        try {
            result = this.project.apply(this, args);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return WithLatestFromSubscriber;
}((0, $cb4eda232789f610$export$e5fdd83ec9152026));



var $b302555736d21bd7$exports = {};

$b302555736d21bd7$exports = (parcelRequire("7we3r"));





var $LjoDx = parcelRequire("LjoDx");
var $7a4e6c0902e6b5c3$export$630b861e381da807 = 0;
var $7a4e6c0902e6b5c3$export$78870863d853b399 = 1;
function $7a4e6c0902e6b5c3$var$createToastContainer() {
    var vdom, toastContainer;
    vdom = (0, $LjoDx.h)("div", {
        class: "anglo-toast__container",
        id: "angloToastContainer"
    });
    toastContainer = (0, $LjoDx.render)(vdom, document.body);
    return toastContainer;
}
function $7a4e6c0902e6b5c3$var$closeToast(id) {
    var element = document.getElementById(id);
    (0, $LjoDx.render)(null, element, element);
}
var $7a4e6c0902e6b5c3$var$onToastClick = function(id) {
    $7a4e6c0902e6b5c3$var$closeToast(id);
};
function $7a4e6c0902e6b5c3$var$getToastTypeClass(type) {
    switch(type){
        case $7a4e6c0902e6b5c3$export$78870863d853b399:
            return "toast-error";
        case $7a4e6c0902e6b5c3$export$630b861e381da807:
        default:
            return "";
    }
}
function $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17(params) {
    var id = "anglo-toast-".concat(Math.floor(Math.random() * 1000));
    var toast, vdom;
    var toastContainer = document.getElementById("angloToastContainer");
    if (!toastContainer) toastContainer = $7a4e6c0902e6b5c3$var$createToastContainer();
    var duration = params.duration ? params.duration : 3000;
    var toastTitleClasses = "anglo-toast__title toast-header";
    var toastMessageClasses = "anglo-toast__message toast-body";
    var toastType = params.type ? params.type : $7a4e6c0902e6b5c3$export$630b861e381da807;
    vdom = (0, $LjoDx.h)("div", {
        class: "anglo-toast toast ".concat($7a4e6c0902e6b5c3$var$getToastTypeClass(toastType)),
        id: id,
        onClick: function(e) {
            return $7a4e6c0902e6b5c3$var$onToastClick(id);
        }
    }, [
        (0, $LjoDx.h)("span", {
            class: toastTitleClasses
        }, params.title),
        (0, $LjoDx.h)("p", {
            class: toastMessageClasses
        }, params.message)
    ]);
    toast = (0, $LjoDx.render)(vdom, toastContainer);
    setTimeout(function() {
        // console.log('unmounting toast');
        (0, $LjoDx.render)(null, toast, toast);
    // call close
    }, duration);
}



var $972f523c8d7c94b0$export$fbc6c17f0981c6e7 = function(argFilters) {
    var filters = "?";
    var currentFilters = argFilters ? argFilters : [];
    var index = 0;
    currentFilters.forEach(function(value, key) {
        if (index === 0) filters = filters.concat("".concat(key, "=").concat(value));
        else filters = filters.concat("&".concat(key, "=").concat(value));
        index++;
    });
    return filters;
};
var $972f523c8d7c94b0$export$316d811a61bf3914 = function(gridData) {
    return gridData["totalCount"] && gridData["totalCount"][0] ? gridData["totalCount"][0].count : 0;
};
var $972f523c8d7c94b0$export$e61094535130c45d = function(errResponse, templateMessage) {
    console.log(errResponse);
    var message;
    if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
    (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
        title: templateMessage,
        message: message ? message : "Please contact the system admin.",
        duration: 3000,
        type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
    });
};


const $6ac96fa96dbfc52a$export$6a92ee59a864e7f2 = "//api.cartaatc.com";
const $6ac96fa96dbfc52a$export$8132710d1930b03e = {
    dateTime: "YYYY-MM-DD HH:mm:ss",
    date: "YYYY-MM-DD",
    dateWorded: "MMMM DD, YYYY"
};
const $6ac96fa96dbfc52a$export$ec5ef886be2edbb8 = 10;
const $6ac96fa96dbfc52a$export$117ed8e927f4bd45 = 50;



var $f4f0268b008d3e35$var$__assign = undefined && undefined.__assign || function() {
    $f4f0268b008d3e35$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f4f0268b008d3e35$var$__assign.apply(this, arguments);
};
// should be something like api.carta.com
var $f4f0268b008d3e35$var$userBasePath = "".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/user");
var $f4f0268b008d3e35$var$userEffects = [];
var $f4f0268b008d3e35$var$test = function(test$) {
    return test$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($4c71eb74f53637d3$export$3b2141b862a8a681), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function() {
        return (0, $02622667f18df45a$export$ba255e9e49e00608)({
            type: $4c71eb74f53637d3$export$3343dae88069f1c1
        });
    }));
};
var $f4f0268b008d3e35$var$login = function(login$) {
    return login$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($4c71eb74f53637d3$export$eed606b4351295d7), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var userData = {
            username: action.payload.authUsername,
            password: action.payload.authPassword
        };
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat($f4f0268b008d3e35$var$userBasePath, "/login"), userData, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $4c71eb74f53637d3$export$5223a5682801fa43,
                payload: {
                    loginState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response && errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to login",
                message: message ? message : "Invalid email or password.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to login",
                message: message,
                duration: 3000
            });
            var action = {
                type: $4c71eb74f53637d3$export$d2473a15d627f3f1,
                payload: {
                    loginState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f4f0268b008d3e35$var$loginSuccess = function(loginSuccess$) {
    return loginSuccess$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($4c71eb74f53637d3$export$5223a5682801fa43), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function() {
        var action = {
            type: $4c71eb74f53637d3$export$ff67457b75dbf12a
        };
        setTimeout(function() {
            location.href = "/";
        }, 250);
        return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
    }));
};
var $f4f0268b008d3e35$var$getCurrentUser = function(getCurrentUser$) {
    return getCurrentUser$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($4c71eb74f53637d3$export$ff67457b75dbf12a), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat($f4f0268b008d3e35$var$userBasePath, "/me"), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var currentUser = response.data[0];
            var action = {
                type: $4c71eb74f53637d3$export$9f7afae2db72e315,
                payload: {
                    currentUser: currentUser,
                    getCurrentUserState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResp) {
            var action = {
                type: $4c71eb74f53637d3$export$377fd6b229ea180c,
                payload: {
                    getCurrentUserState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f4f0268b008d3e35$var$logout = function(logout$) {
    return logout$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($4c71eb74f53637d3$export$35e541d26a145a7c), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function() {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat($f4f0268b008d3e35$var$userBasePath, "/logout"), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function() {
            var action = {
                type: $4c71eb74f53637d3$export$3343dae88069f1c1,
                payload: {
                    currentUser: null
                }
            };
            setTimeout(function() {
                location.href = "/login";
            }, 250);
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function() {
            var action = {
                type: $4c71eb74f53637d3$export$9f7331ccf987e298
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f4f0268b008d3e35$var$getAgents = function(getOverallTotal$) {
    return getOverallTotal$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($4c71eb74f53637d3$export$dfa3dd78ac296cf2), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var filters = "?";
        if (action.payload && action.payload.employeeFilters) {
            var index_1 = 0;
            action.payload.employeeFilters.forEach(function(v, k) {
                if (index_1 > 0) filters = filters.concat("&");
                filters = filters.concat("".concat(k, "=").concat(v));
                index_1++;
            });
        }
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/agent").concat(filters), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var agents = response.data["results"];
            var action = {
                type: $4c71eb74f53637d3$export$2cee90acddd38be3,
                payload: {
                    agents: agents
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $4c71eb74f53637d3$export$319c3bd92910657b
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get agents",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f4f0268b008d3e35$var$getSupervisors = function(getSupervisors$) {
    return getSupervisors$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($4c71eb74f53637d3$export$d1320805de2a0f43), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var filters = "?";
        if (action.payload && action.payload.filters) {
            var index_2 = 0;
            action.payload.filters.forEach(function(v, k) {
                if (index_2 > 0) filters = filters.concat("&");
                filters = filters.concat("".concat(k, "=").concat(v));
                index_2++;
            });
        }
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/supervisor").concat(filters), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var supervisors = response.data["results"];
            var action = {
                type: $4c71eb74f53637d3$export$9340e630ef96adf9,
                payload: {
                    supervisors: supervisors
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $4c71eb74f53637d3$export$cb4b8cd408a4cf59
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get supervisors",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f4f0268b008d3e35$var$getAllUsers = function(getAllUsers$) {
    return getAllUsers$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($4c71eb74f53637d3$export$c387b27c89715baf), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var _a;
        var filters = (0, $972f523c8d7c94b0$export$fbc6c17f0981c6e7)((_a = action.payload) === null || _a === void 0 ? void 0 : _a.filters);
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/user/all").concat(filters), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            console.log("asd", response);
            var allUsers = response.data[0].data;
            var action = {
                type: $4c71eb74f53637d3$export$fe57b74e71d14dac,
                payload: {
                    allUsers: allUsers,
                    total: response.data[0].totalCount[0].count
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $4c71eb74f53637d3$export$88d862a652497e0e
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get all users",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f4f0268b008d3e35$var$getBankAccounts = function(getBankAccounts$) {
    return getBankAccounts$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($4c71eb74f53637d3$export$74d61c62c586516a), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise;
        if (action.payload && action.payload.isSubmitRemit) promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/banks/get-assignments"), {
            withCredentials: true
        });
        else promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/banks"), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var allBankAccounts = response.data["results"];
            var action = {
                type: $4c71eb74f53637d3$export$b35549a768d86f1d,
                payload: {
                    allBankAccounts: allBankAccounts,
                    isSubmitRemit: false
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $4c71eb74f53637d3$export$354d102f939e7d36
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get all bank accounts",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f4f0268b008d3e35$var$createBankAccount = function(createBankAccount$) {
    return createBankAccount$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($4c71eb74f53637d3$export$3f05487ba7fe474b), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var bankAccount = action.payload.bankAccount;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/banks/create-account"), bankAccount, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var action = {
                type: $4c71eb74f53637d3$export$ee530607025cca78
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Create Bank Account",
                message: "Successfully created a new bank account",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $4c71eb74f53637d3$export$d0054b7b1f190d7d
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to create bank account",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f4f0268b008d3e35$var$createUser = function(createUser$) {
    return createUser$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($4c71eb74f53637d3$export$3886e73aa4232c67), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var userToCreate = action.payload.userToCreate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/user/register"), userToCreate, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var action = {
                type: $4c71eb74f53637d3$export$6d67d91c36640f61
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Create Bank Account",
                message: "Successfully created a new user",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $4c71eb74f53637d3$export$4698e032cc52a71f
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to create user",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f4f0268b008d3e35$var$changePassword = function(changePassword$) {
    return changePassword$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($4c71eb74f53637d3$export$67e8c4b0fd356271), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var userToUpdate = action.payload.userToUpdate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/user/change-password"), userToUpdate, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var action = {
                type: $4c71eb74f53637d3$export$52dd5c72d66642a1
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Changed password",
                message: "Successfully changed user password",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $4c71eb74f53637d3$export$d482da6a78662f2b
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to changed user password",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f4f0268b008d3e35$var$assignBankAccount = function(assignBankAccount$) {
    return assignBankAccount$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($4c71eb74f53637d3$export$6630f5bab1479efb), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/banks/assign"), {
            accountNumber: action.payload.bankAccountNumber,
            username: action.payload.userToAssign
        }, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var action = {
                type: $4c71eb74f53637d3$export$fb19d1a424549748
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Assign Bank Account",
                message: "Successfully assigned a new bank account to user",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $4c71eb74f53637d3$export$14672cddbab9360c
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to assign bank account",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f4f0268b008d3e35$var$changeStatus = function(changeStatus$) {
    return changeStatus$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($4c71eb74f53637d3$export$b75cf570f6a6871c), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var userToUpdate = action.payload.userToUpdate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/user/change-status"), userToUpdate, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var action = {
                type: $4c71eb74f53637d3$export$f60915d6b30a1ca2
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Changed status",
                message: "Successfully changed user status",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $4c71eb74f53637d3$export$5f15db445b3fa7d7
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to changed user status",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f4f0268b008d3e35$var$updateStocks = function(updateStocks$) {
    return updateStocks$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($4c71eb74f53637d3$export$d0fb24651868d5d6), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/supervisor/update-stocks"), {
            supervisorId: action.payload.supervisorToUpdate,
            brandBreakdown: action.payload.stocksToUpdate
        }, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $4c71eb74f53637d3$export$795bf10706f7695b,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Supervisor Update to Stocks",
                message: "You have successfully updated stocks",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed Supervisor Update",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed Supervisor Update",
                message: message,
                duration: 3000
            });
            var action = {
                type: $4c71eb74f53637d3$export$eee37f47ec9fd5af,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f4f0268b008d3e35$var$createSupervisorRegData = function(createSupervisorRegData$) {
    return createSupervisorRegData$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($4c71eb74f53637d3$export$e65d189135623f3a), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/supervisor"), action.payload.supervisorRegistrationData, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $4c71eb74f53637d3$export$fb7a63b79b41ba6d,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Create Supervisor Data",
                message: "You have successfully created supervisor data",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed Create Supervisor Data",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed Create Supervisor Data",
                message: message,
                duration: 3000
            });
            var action = {
                type: $4c71eb74f53637d3$export$46a683e6e65eb26,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f4f0268b008d3e35$var$resetUserChain = function(resetUserChain$) {
    return resetUserChain$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($4c71eb74f53637d3$export$ee530607025cca78, $4c71eb74f53637d3$export$795bf10706f7695b, $4c71eb74f53637d3$export$6d67d91c36640f61, $4c71eb74f53637d3$export$fb19d1a424549748, $4c71eb74f53637d3$export$f60915d6b30a1ca2, $4c71eb74f53637d3$export$fb19d1a424549748), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function() {
        var action = {
            type: $4c71eb74f53637d3$export$c387b27c89715baf
        };
        return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
    }));
};
var $f4f0268b008d3e35$var$resetChainGrid = function(resetChainGrid$) {
    return resetChainGrid$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($4c71eb74f53637d3$export$ce53836c0900812a), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function() {
        var action = {
            type: $4c71eb74f53637d3$export$c387b27c89715baf
        };
        return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
    }));
};
var $f4f0268b008d3e35$var$createEmployee = function(createEmployee$) {
    return createEmployee$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($4c71eb74f53637d3$export$86dd998f89ad8fa6), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var employee = action.payload.employeeToCreate;
        var supervisorUsername = action.payload.supervisorUsername;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/agent/mgmt"), $f4f0268b008d3e35$var$__assign($f4f0268b008d3e35$var$__assign({}, employee), {
            supervisorUsername: supervisorUsername
        }), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var action = {
                type: $4c71eb74f53637d3$export$7166cfbaabfdff16
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Create Employee",
                message: "Successfully created a new employee",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $4c71eb74f53637d3$export$36cb7752d13f2d79
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to create employee",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f4f0268b008d3e35$var$editEmployee = function(editEmployee$) {
    return editEmployee$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($4c71eb74f53637d3$export$1f1e8f449be51a90), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var employee = action.payload.employeeToCreate;
        var supervisorUsername = action.payload.supervisorUsername;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/agent/update-employee"), $f4f0268b008d3e35$var$__assign($f4f0268b008d3e35$var$__assign({}, employee), {
            supervisorUsername: supervisorUsername
        }), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var action = {
                type: $4c71eb74f53637d3$export$199fc288a799e4ca
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Edit Employee",
                message: "Successfully edit employee",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $4c71eb74f53637d3$export$c488315308d3ad19
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to edit employee",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
// ! Make sure to add created epics to array 
$f4f0268b008d3e35$var$userEffects.push($f4f0268b008d3e35$var$test);
$f4f0268b008d3e35$var$userEffects.push($f4f0268b008d3e35$var$login);
$f4f0268b008d3e35$var$userEffects.push($f4f0268b008d3e35$var$loginSuccess);
$f4f0268b008d3e35$var$userEffects.push($f4f0268b008d3e35$var$getCurrentUser);
$f4f0268b008d3e35$var$userEffects.push($f4f0268b008d3e35$var$logout);
$f4f0268b008d3e35$var$userEffects.push($f4f0268b008d3e35$var$getAgents);
$f4f0268b008d3e35$var$userEffects.push($f4f0268b008d3e35$var$getSupervisors);
$f4f0268b008d3e35$var$userEffects.push($f4f0268b008d3e35$var$getAllUsers);
$f4f0268b008d3e35$var$userEffects.push($f4f0268b008d3e35$var$createBankAccount);
$f4f0268b008d3e35$var$userEffects.push($f4f0268b008d3e35$var$createUser);
$f4f0268b008d3e35$var$userEffects.push($f4f0268b008d3e35$var$getBankAccounts);
$f4f0268b008d3e35$var$userEffects.push($f4f0268b008d3e35$var$changePassword);
$f4f0268b008d3e35$var$userEffects.push($f4f0268b008d3e35$var$assignBankAccount);
$f4f0268b008d3e35$var$userEffects.push($f4f0268b008d3e35$var$changeStatus);
$f4f0268b008d3e35$var$userEffects.push($f4f0268b008d3e35$var$updateStocks);
$f4f0268b008d3e35$var$userEffects.push($f4f0268b008d3e35$var$createSupervisorRegData);
$f4f0268b008d3e35$var$userEffects.push($f4f0268b008d3e35$var$createEmployee);
$f4f0268b008d3e35$var$userEffects.push($f4f0268b008d3e35$var$editEmployee);
$f4f0268b008d3e35$var$userEffects.push($f4f0268b008d3e35$var$resetChainGrid);
$f4f0268b008d3e35$var$userEffects.push($f4f0268b008d3e35$var$resetUserChain);
var $f4f0268b008d3e35$export$2e2bcd8739ae039 = $f4f0268b008d3e35$var$userEffects;


var $32688a3bd395dec2$exports = {};

$parcel$export($32688a3bd395dec2$exports, "default", () => $32688a3bd395dec2$export$2e2bcd8739ae039);








var $32688a3bd395dec2$var$__assign = undefined && undefined.__assign || function() {
    $32688a3bd395dec2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $32688a3bd395dec2$var$__assign.apply(this, arguments);
};
var $32688a3bd395dec2$var$remittanceEffects = [];
var $32688a3bd395dec2$var$submitRemit = function(submitRemit$) {
    return submitRemit$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($ea864d6f3cd9447e$export$4f0aa2f7c1eac83e), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/remittance"), {
            data: action.payload.remittancesToUpload
        }, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $ea864d6f3cd9447e$export$68b862e0d897562f
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success remittance submit",
                message: "You have successfully uploaded your remittances",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit remittance",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit remittance",
                message: message,
                duration: 3000
            });
            var action = {
                type: $ea864d6f3cd9447e$export$538007741e882bbf
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $32688a3bd395dec2$var$getGridData = function(getGridData$) {
    return getGridData$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($ea864d6f3cd9447e$export$e82cebb195cca37c), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var retrievedFilters;
        var stateFilters = state.remittance.filters;
        var filters = "?";
        if (action.payload && action.payload.filters) {
            if (stateFilters) retrievedFilters = $32688a3bd395dec2$var$__assign($32688a3bd395dec2$var$__assign({}, action.payload.filters), stateFilters);
            else retrievedFilters = action.payload.filters;
            var index = 0;
            for(var k in retrievedFilters){
                if (index > 0) filters = filters.concat("&");
                filters = filters.concat("".concat(k, "=").concat(retrievedFilters[k]));
                index++;
            }
        } else if (stateFilters) {
            var index = 0;
            for(var k in stateFilters){
                if (index > 0) filters = filters.concat("&");
                filters = filters.concat("".concat(k, "=").concat(stateFilters[k]));
                index++;
            }
        }
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/remittance").concat(filters), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var gridData = JSON.parse(JSON.stringify(response.data["results"]));
            var action;
            if (gridData["totalCount"] && gridData["totalCount"][0]) action = {
                type: $ea864d6f3cd9447e$export$91b422ec07f86303,
                payload: {
                    remittanceGridData: gridData["data"],
                    total: gridData["totalCount"][0].count
                }
            };
            else action = {
                type: $ea864d6f3cd9447e$export$91b422ec07f86303,
                payload: {
                    remittanceGridData: [],
                    total: 0
                }
            };
            if (retrievedFilters) action.payload.filters = retrievedFilters;
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var action = {
                type: $ea864d6f3cd9447e$export$7781d9de80c0e585
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get grid data",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get grid data",
                message: message,
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $32688a3bd395dec2$var$getReportGridData = function(getReportGridData$) {
    return getReportGridData$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($ea864d6f3cd9447e$export$b89956564774937f), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var filters = "?";
        if (action.payload && action.payload.filters) {
            var index_1 = 0;
            action.payload.filters.forEach(function(v, k) {
                if (index_1 > 0) filters = filters.concat("&");
                filters = filters.concat("".concat(k, "=").concat(v));
                index_1++;
            });
        }
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/remittance").concat(filters), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var gridData = JSON.parse(JSON.stringify(response.data["results"]));
            var action = {
                type: $ea864d6f3cd9447e$export$91b422ec07f86303,
                payload: {
                    reportGridData: gridData["data"]
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var action = {
                type: $ea864d6f3cd9447e$export$7781d9de80c0e585
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get grid data",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get grid data",
                message: message,
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $32688a3bd395dec2$var$getServersideReport = function(getReportGridData$) {
    return getReportGridData$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($ea864d6f3cd9447e$export$e7552e3670d2fd5b), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var filters = "?";
        if (action.payload && action.payload.filters) {
            var index_2 = 0;
            action.payload.filters.forEach(function(v, k) {
                if (index_2 > 0) filters = filters.concat("&");
                filters = filters.concat("".concat(k, "=").concat(v));
                index_2++;
            });
        }
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/remittance/report").concat(filters), {
            withCredentials: true,
            responseType: "blob",
            headers: {
                "Accept": "application/pdf"
            }
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var action = {
                type: $ea864d6f3cd9447e$export$e7d0f30aded58f25
            };
            if (response) {
                var blob = new Blob([
                    response.data
                ], {
                    type: "application/pdf"
                });
                window.open(URL.createObjectURL(blob));
            }
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var action = {
                type: $ea864d6f3cd9447e$export$56bc8e1b4f48d88b
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get grid data",
                message: "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $32688a3bd395dec2$var$getOverallTotal = function(getOverallTotal$) {
    return getOverallTotal$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($ea864d6f3cd9447e$export$ac8ddd8847849ab), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/dashboard/remittance/total"), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var total = response.data["results"][0];
            var action = {
                type: $ea864d6f3cd9447e$export$ebb5a9a0e3df52b0,
                payload: {
                    overallTotal: total
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $ea864d6f3cd9447e$export$37877b3afd681a6d
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get overall total",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $32688a3bd395dec2$var$getMonthTotal = function(getOverallTotal$) {
    return getOverallTotal$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($ea864d6f3cd9447e$export$6846fb968bdf775b), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/dashboard/remittance/month"), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var current = response.data["results"].current[0];
            var previous = response.data["results"].previous[0];
            var action = {
                type: $ea864d6f3cd9447e$export$2bc5c5033fc1d7c8,
                payload: {
                    currentMonthTotal: current,
                    previousMonthTotal: previous
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $ea864d6f3cd9447e$export$af72e095ba9f5b67
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get month total",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $32688a3bd395dec2$var$getApprovedTotal = function(getApprovedTotal$) {
    return getApprovedTotal$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($ea864d6f3cd9447e$export$ac8ddd8847849ab), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/dashboard/remittance/approved-total"), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var total = response.data["results"][0];
            var action = {
                type: $ea864d6f3cd9447e$export$ebb5a9a0e3df52b0,
                payload: {
                    overallTotal: total
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $ea864d6f3cd9447e$export$37877b3afd681a6d
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get overall total",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $32688a3bd395dec2$var$submitEditRequest = function(submitEditRequest$) {
    return submitEditRequest$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($ea864d6f3cd9447e$export$ab2ecf21d87194a9), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/update-request/edit"), action.payload.editRequest, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $ea864d6f3cd9447e$export$7f322859f452c805
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success remittance edit",
                message: "You have successfully submitted an edit request",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit edit",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit remittance",
                message: message,
                duration: 3000
            });
            var action = {
                type: $ea864d6f3cd9447e$export$e4b9d21ba9cdebce
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $32688a3bd395dec2$var$submitDeleteRequest = function(submitDeleteRequest$) {
    return submitDeleteRequest$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($ea864d6f3cd9447e$export$ab2ecf21d87194a9), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/update-request/delete"), action.payload.deleteRequest, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $ea864d6f3cd9447e$export$6912c6b7f329ddf8
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success request remittance delete",
                message: "You have successfully submitted delete edit request",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit delete request",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit delete request",
                message: message,
                duration: 3000
            });
            var action = {
                type: $ea864d6f3cd9447e$export$a70fe050778144ae
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $32688a3bd395dec2$var$approveRemittance = function(approveRemittance$) {
    return approveRemittance$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($ea864d6f3cd9447e$export$4107b97e676630a2), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/remittance/clear"), {
            remittanceId: action.payload.remittanceId,
            receiptNumber: action.payload.receiptNumber
        }, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $ea864d6f3cd9447e$export$ed09ec00ca0af97
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success cleared",
                message: "You have successfully cleared this remittance",
                duration: 3000
            });
            // setTimeout(() => {
            //   location.reload();
            // }, 350);
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit remittance clearance",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit remittance clearance",
                message: message,
                duration: 3000
            });
            var action = {
                type: $ea864d6f3cd9447e$export$43e946fa582bde3b
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $32688a3bd395dec2$var$resetChain = function(resetChain$) {
    return resetChain$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($ea864d6f3cd9447e$export$ed09ec00ca0af97), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function() {
        var action = {
            type: $ea864d6f3cd9447e$export$a9fdcde8bac1b31f
        };
        return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
    }));
};
var $32688a3bd395dec2$var$clearChain = function(clearChain$) {
    return clearChain$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($ea864d6f3cd9447e$export$ed09ec00ca0af97), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function() {
        var action = {
            type: $ea864d6f3cd9447e$export$e82cebb195cca37c
        };
        return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
    }));
};
// ! Make sure to add created epics to array 
$32688a3bd395dec2$var$remittanceEffects.push($32688a3bd395dec2$var$submitRemit);
$32688a3bd395dec2$var$remittanceEffects.push($32688a3bd395dec2$var$getOverallTotal);
$32688a3bd395dec2$var$remittanceEffects.push($32688a3bd395dec2$var$getMonthTotal);
$32688a3bd395dec2$var$remittanceEffects.push($32688a3bd395dec2$var$getGridData);
$32688a3bd395dec2$var$remittanceEffects.push($32688a3bd395dec2$var$submitEditRequest);
$32688a3bd395dec2$var$remittanceEffects.push($32688a3bd395dec2$var$submitDeleteRequest);
$32688a3bd395dec2$var$remittanceEffects.push($32688a3bd395dec2$var$approveRemittance);
$32688a3bd395dec2$var$remittanceEffects.push($32688a3bd395dec2$var$resetChain);
$32688a3bd395dec2$var$remittanceEffects.push($32688a3bd395dec2$var$getReportGridData);
$32688a3bd395dec2$var$remittanceEffects.push($32688a3bd395dec2$var$getServersideReport);
$32688a3bd395dec2$var$remittanceEffects.push($32688a3bd395dec2$var$clearChain);
var $32688a3bd395dec2$export$2e2bcd8739ae039 = $32688a3bd395dec2$var$remittanceEffects;









var $d5eed2b019ffdb13$var$auditEffects = [];
var $d5eed2b019ffdb13$var$getGridData = function(getGridData$) {
    return getGridData$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($25ac7cc755ebed09$export$13452f8bbda82685), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/audit-log"), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var gridData = JSON.parse(JSON.stringify(response.data["results"]));
            var action = {
                type: $25ac7cc755ebed09$export$7afed574562a2885,
                payload: {
                    auditGridData: gridData
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var action = {
                type: $25ac7cc755ebed09$export$d4fc8d9db769c49
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get grid data",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get grid data",
                message: message,
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
// ! Make sure to add created epics to array 
$d5eed2b019ffdb13$var$auditEffects.push($d5eed2b019ffdb13$var$getGridData);
var $d5eed2b019ffdb13$export$2e2bcd8739ae039 = $d5eed2b019ffdb13$var$auditEffects;


var $6f9d9b985abcee58$exports = {};

$parcel$export($6f9d9b985abcee58$exports, "default", () => $6f9d9b985abcee58$export$2e2bcd8739ae039);








var $6f9d9b985abcee58$var$__assign = undefined && undefined.__assign || function() {
    $6f9d9b985abcee58$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6f9d9b985abcee58$var$__assign.apply(this, arguments);
};
var $6f9d9b985abcee58$var$updateEffects = [];
var $6f9d9b985abcee58$var$getEditGridData = function(getEditGridData$) {
    return getEditGridData$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($5ee26f856325551b$export$f0fed340523808db), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var retrievedFilters;
        var stateFilters = state.updates.filters;
        var filters = "?";
        if (action.payload && action.payload.filters) {
            if (stateFilters) retrievedFilters = $6f9d9b985abcee58$var$__assign($6f9d9b985abcee58$var$__assign({}, action.payload.filters), stateFilters);
            else retrievedFilters = action.payload.filters;
            var index = 0;
            for(var k in retrievedFilters){
                if (index > 0) filters = filters.concat("&");
                filters = filters.concat("".concat(k, "=").concat(retrievedFilters[k]));
                index++;
            }
        } else if (stateFilters) {
            var index = 0;
            for(var k in stateFilters){
                if (index > 0) filters = filters.concat("&");
                filters = filters.concat("".concat(k, "=").concat(stateFilters[k]));
                index++;
            }
        }
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/update-request").concat(filters), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var gridData = JSON.parse(JSON.stringify(response.data["results"]));
            var action = {
                type: $5ee26f856325551b$export$fe384e566dbcf73,
                payload: {
                    editGridData: gridData
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var action = {
                type: $5ee26f856325551b$export$ddb124701de44293
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get grid data",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get grid data",
                message: message,
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $6f9d9b985abcee58$var$approveEdit = function(approveEdit$) {
    return approveEdit$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($5ee26f856325551b$export$ba66402981b8dbe1), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/update-request/edit"), {
            remittanceId: action.payload.remittanceId,
            responseReason: action.payload.responseReason
        }, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var action = {
                type: $5ee26f856325551b$export$f8520b2e576311d3
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success request approve",
                message: "You have successfully approved this request",
                duration: 3000
            });
            setTimeout(function() {
                location.reload();
            }, 350);
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var action = {
                type: $5ee26f856325551b$export$a81c28656b6d36be
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to approve request",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to approve request",
                message: message,
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $6f9d9b985abcee58$var$rejectEdit = function(approveEdit$) {
    return approveEdit$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($5ee26f856325551b$export$be6f145b71ba0393), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/update-request/edit/reject"), {
            remittanceId: action.payload.remittanceId,
            responseReason: action.payload.responseReason
        }, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var action = {
                type: $5ee26f856325551b$export$74290b6372bb35d4
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success request reject",
                message: "You have successfully rejected this request",
                duration: 3000
            });
            setTimeout(function() {
                location.reload();
            }, 350);
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var action = {
                type: $5ee26f856325551b$export$56fd14446ca4c29f
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to reject request",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to reject request",
                message: message,
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $6f9d9b985abcee58$var$approveDelete = function(approveEdit$) {
    return approveEdit$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($5ee26f856325551b$export$2e4ccd371a4d296c), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/update-request/delete"), {
            remittanceId: action.payload.remittanceId,
            responseReason: action.payload.responseReason
        }, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var action = {
                type: $5ee26f856325551b$export$a2ab994bb90bb76e
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success request approve",
                message: "You have successfully approved this request",
                duration: 3000
            });
            setTimeout(function() {
                location.reload();
            }, 350);
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var action = {
                type: $5ee26f856325551b$export$ad40c97a29117f4a
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to approve delete",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to approve delete",
                message: message,
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $6f9d9b985abcee58$var$rejectDelete = function(approveEdit$) {
    return approveEdit$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($5ee26f856325551b$export$6a2afda38f4a1418), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/update-request/delete/reject"), {
            remittanceId: action.payload.remittanceId,
            responseReason: action.payload.responseReason
        }, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var action = {
                type: $5ee26f856325551b$export$655eeb28b533f7e5
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success request reject",
                message: "You have successfully rejected this request",
                duration: 3000
            });
            setTimeout(function() {
                location.reload();
            }, 350);
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var action = {
                type: $5ee26f856325551b$export$6471f570e355eb7e
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to reject request",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to reject request",
                message: message,
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
// ! Make sure to add created epics to array 
$6f9d9b985abcee58$var$updateEffects.push($6f9d9b985abcee58$var$getEditGridData);
$6f9d9b985abcee58$var$updateEffects.push($6f9d9b985abcee58$var$approveEdit);
$6f9d9b985abcee58$var$updateEffects.push($6f9d9b985abcee58$var$approveDelete);
$6f9d9b985abcee58$var$updateEffects.push($6f9d9b985abcee58$var$rejectEdit);
$6f9d9b985abcee58$var$updateEffects.push($6f9d9b985abcee58$var$rejectDelete);
var $6f9d9b985abcee58$export$2e2bcd8739ae039 = $6f9d9b985abcee58$var$updateEffects;


var $f48a89c798c28bd4$exports = {};

$parcel$export($f48a89c798c28bd4$exports, "default", () => $f48a89c798c28bd4$export$2e2bcd8739ae039);









var $f48a89c798c28bd4$var$__assign = undefined && undefined.__assign || function() {
    $f48a89c798c28bd4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f48a89c798c28bd4$var$__assign.apply(this, arguments);
};
var $f48a89c798c28bd4$var$vehicleEffects = [];
var $f48a89c798c28bd4$var$getGridData = function(getGridData$) {
    return getGridData$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($7859e0852b06702e$export$6d686d51d5c3c8d0), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var retrievedFilters;
        var stateFilters = state.vehicles.filters;
        var filters = "?";
        if (action.payload && action.payload.filters) {
            if (stateFilters) retrievedFilters = $f48a89c798c28bd4$var$__assign($f48a89c798c28bd4$var$__assign({}, action.payload.filters), stateFilters);
            else retrievedFilters = action.payload.filters;
            var index = 0;
            for(var k in retrievedFilters){
                if (index > 0) filters = filters.concat("&");
                filters = filters.concat("".concat(k, "=").concat(retrievedFilters[k]));
                index++;
            }
        } else if (stateFilters) {
            var index = 0;
            for(var k in stateFilters){
                if (index > 0) filters = filters.concat("&");
                filters = filters.concat("".concat(k, "=").concat(stateFilters[k]));
                index++;
            }
        }
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/vehicle").concat(filters), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var gridData = JSON.parse(JSON.stringify(response.data["results"]));
            var action = {
                type: $7859e0852b06702e$export$719c81f6a7b18cd9,
                payload: {
                    vehicles: gridData["data"],
                    totalVehicles: gridData["totalCount"][0] ? gridData["totalCount"][0].count : 0
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var action = {
                type: $7859e0852b06702e$export$d053e9a3a6f6b6fa
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response && errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get vehicle data",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get vehicle data",
                message: "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f48a89c798c28bd4$var$createVehicle = function(submitRemit$) {
    return submitRemit$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($7859e0852b06702e$export$3366fc19859b9ff8), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/vehicle"), action.payload.vehicleToCreate, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $7859e0852b06702e$export$ce38865bc92ccaf6,
                payload: {
                    createVehicleState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Vehicle submit",
                message: "You have successfully submitted a Vehicle",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Vehicle",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Vehicle",
                message: message,
                duration: 3000
            });
            var action = {
                type: $7859e0852b06702e$export$642b701085f6396d,
                payload: {
                    createVehicleState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f48a89c798c28bd4$var$updateGrid = function(updateGrid$) {
    return updateGrid$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($7859e0852b06702e$export$ce38865bc92ccaf6), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        return (0, $02622667f18df45a$export$ba255e9e49e00608)({
            type: $7859e0852b06702e$export$6d686d51d5c3c8d0,
            payload: {
                createVehicleState: (0, $ad7802471dc8ad45$export$76350ffc4854c457)
            }
        });
    }));
};
var $f48a89c798c28bd4$var$editVehicle = function(editVehicle$) {
    return editVehicle$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($7859e0852b06702e$export$aa1eb15edf81c53f), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/vehicle"), action.payload.vehicleToUpdate, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $7859e0852b06702e$export$fc9423c375cacbc,
                payload: {
                    editVehicleState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Vehicle edit",
                message: "You have successfully submitted a Vehicle",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to edit Vehicle",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to edit Vehicle",
                message: message,
                duration: 3000
            });
            var action = {
                type: $7859e0852b06702e$export$7e5952ba3a7ae659,
                payload: {
                    editVehicleState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f48a89c798c28bd4$var$updateGridEdit = function(updateGrid$) {
    return updateGrid$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($7859e0852b06702e$export$fc9423c375cacbc), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        return (0, $02622667f18df45a$export$ba255e9e49e00608)({
            type: $7859e0852b06702e$export$6d686d51d5c3c8d0,
            payload: {
                editVehicleState: (0, $ad7802471dc8ad45$export$76350ffc4854c457)
            }
        });
    }));
};
var $f48a89c798c28bd4$var$createVehicleFile = function(createVehicleFile$) {
    return createVehicleFile$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($7859e0852b06702e$export$cf8065a69c02ae59), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/vehicle-file"), action.payload.vehicleFileToCreate, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $7859e0852b06702e$export$ba29fe9678473527,
                payload: {
                    createVehicleFileState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Vehicle File submit",
                message: "You have successfully submitted a Vehicle Report",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Vehicle File",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Vehicle File",
                message: message,
                duration: 3000
            });
            var action = {
                type: $7859e0852b06702e$export$f162630ac92a787c,
                payload: {
                    createVehicleFileState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f48a89c798c28bd4$var$getVehicleFiles = function(getVehicleFiles$) {
    return getVehicleFiles$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($7859e0852b06702e$export$417d121b6bc4be50), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var retrievedFilters;
        var stateFilters = state.vehicles.filters;
        var filters = "?";
        if (action.payload && action.payload.filters) {
            if (stateFilters) retrievedFilters = $f48a89c798c28bd4$var$__assign($f48a89c798c28bd4$var$__assign({}, action.payload.filters), stateFilters);
            else retrievedFilters = action.payload.filters;
            var index = 0;
            for(var k in retrievedFilters){
                if (index > 0) filters = filters.concat("&");
                filters = filters.concat("".concat(k, "=").concat(retrievedFilters[k]));
                index++;
            }
        } else if (stateFilters) {
            var index = 0;
            for(var k in stateFilters){
                if (index > 0) filters = filters.concat("&");
                filters = filters.concat("".concat(k, "=").concat(stateFilters[k]));
                index++;
            }
        }
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/vehicle-file").concat(filters), {
            // params: retrievedFilters,
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var gridData = JSON.parse(JSON.stringify(response.data["results"]));
            var action = {
                type: $7859e0852b06702e$export$59fbf74044cf4b65,
                payload: {
                    vehicleFiles: gridData["data"],
                    totalVehicleFiles: gridData["totalCount"][0] ? gridData["totalCount"][0].count : 0
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var action = {
                type: $7859e0852b06702e$export$3c7c5390d1b89499
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response && errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get vehicle file data",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get vehicle file data",
                message: "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f48a89c798c28bd4$var$approveVehicleFile = function(approveVehicleFile$) {
    return approveVehicleFile$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($7859e0852b06702e$export$615e5a2c325fd326), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/vehicle-file/approve"), {
            responseReason: action.payload.responseReason,
            _id: action.payload.vehicleFileToUpdate,
            vehicleId: action.payload.vehicleId
        }, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $7859e0852b06702e$export$5d7dfa4840bc6a4,
                payload: {
                    respondVehicleFileState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Vehicle File submit",
                message: "You have successfully accepted the file",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to respond Vehicle File",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to respond Vehicle File",
                message: message,
                duration: 3000
            });
            var action = {
                type: $7859e0852b06702e$export$dd5053c11256b135,
                payload: {
                    respondVehicleFileState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f48a89c798c28bd4$var$rejectVehicleFile = function(rejectVehicleFile$) {
    return rejectVehicleFile$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($7859e0852b06702e$export$b5f09aa9d5f1a613), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/vehicle-file/reject"), {
            responseReason: action.payload.responseReason,
            _id: action.payload.vehicleFileToUpdate,
            vehicleId: action.payload.vehicleId
        }, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $7859e0852b06702e$export$42577fe475e0ad42,
                payload: {
                    respondVehicleFileState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Vehicle File response",
                message: "You have successfully rejected the file",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to respond Vehicle File",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to respond Vehicle File",
                message: message,
                duration: 3000
            });
            var action = {
                type: $7859e0852b06702e$export$eaa60d4c17f242ac,
                payload: {
                    respondVehicleFileState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f48a89c798c28bd4$var$getJobOrders = function(getVehicleFiles$) {
    return getVehicleFiles$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($7859e0852b06702e$export$30687d321270ea99), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/vehicle-job-order"), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var gridData = JSON.parse(JSON.stringify(response.data["results"]));
            var action = {
                type: $7859e0852b06702e$export$ec82f8864ae350b,
                payload: {
                    jobOrders: gridData
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var action = {
                type: $7859e0852b06702e$export$1899b5f35b3fd63a
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response && errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get job order data",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get order data",
                message: "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f48a89c798c28bd4$var$createJobOrder = function(createVehicleFile$) {
    return createVehicleFile$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($7859e0852b06702e$export$6beda060f5e67d2f), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/vehicle-job-order"), action.payload.jobOrderToCreate, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $7859e0852b06702e$export$bdcb11859281f97a,
                payload: {
                    createJobOrderState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success create job order",
                message: "You have successfully created a job order.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to create job order",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to create job order",
                message: message,
                duration: 3000
            });
            var action = {
                type: $7859e0852b06702e$export$b3bce86cc111e693,
                payload: {
                    createJobOrderState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f48a89c798c28bd4$var$getMedicalHistory = function(getVehicleFiles$) {
    return getVehicleFiles$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($7859e0852b06702e$export$664e2379a8eddc0c), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/vehicle-medical-history"), {
            params: {
                vehicleId: action.payload.vehicleId
            },
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var gridData = JSON.parse(JSON.stringify(response.data["results"]));
            var action = {
                type: $7859e0852b06702e$export$3fd184262df598c4,
                payload: {
                    vehicleMedicalHistory: gridData
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var action = {
                type: $7859e0852b06702e$export$bf59c09bbb596efd
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response && errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get job order data",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get order data",
                message: "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f48a89c798c28bd4$var$createJobOrderCleanup = function(createVehicleFile$) {
    return createVehicleFile$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($7859e0852b06702e$export$bdcb11859281f97a), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var returnAction = {
            type: $7859e0852b06702e$export$be2eeddad8b7feff,
            payload: {
                createJobOrderState: (0, $ad7802471dc8ad45$export$76350ffc4854c457)
            }
        };
        return (0, $02622667f18df45a$export$ba255e9e49e00608)(returnAction);
    }));
};
var $f48a89c798c28bd4$var$updateJobOrder = function(createVehicleFile$) {
    return createVehicleFile$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($7859e0852b06702e$export$1c3e1589bb6475a7), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/vehicle-job-order"), action.payload.jobOrderToUpdate, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $7859e0852b06702e$export$86c76a9d7918893a,
                payload: {
                    updateJobOrderState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success create job order",
                message: "You have successfully updated a job order.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to create job order",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to create job order",
                message: message,
                duration: 3000
            });
            var action = {
                type: $7859e0852b06702e$export$9722702f2f44a66c,
                payload: {
                    updateJobOrderState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f48a89c798c28bd4$var$getExpenseReport = function(getExpenseReport$) {
    return getExpenseReport$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($7859e0852b06702e$export$53f4e43bfbd6f4cc), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var filters = "?";
        if (action.payload && action.payload.filters) {
            var index = 0;
            var v = void 0;
            for(var k in action.payload.filters){
                v = action.payload.filters[k];
                if (index > 0) filters = filters.concat("&");
                if (v) filters = filters.concat("".concat(k, "=").concat(v));
                index++;
            }
        // action.payload.filters.forEach((v, k) => {
        //   if (index > 0) {
        //     filters = filters.concat('&');
        //   }
        //   filters = filters.concat(`${k}=${v}`);
        //   index++;
        // });
        }
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/vehicle-file/expenses").concat(filters), {
            withCredentials: true,
            responseType: "blob",
            headers: {
                "Accept": "application/pdf"
            }
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var action = {
                type: $7859e0852b06702e$export$2b756767309e17c8
            };
            if (response) {
                var blob = new Blob([
                    response.data
                ], {
                    type: "application/pdf"
                });
                window.open(URL.createObjectURL(blob));
            }
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var action = {
                type: $7859e0852b06702e$export$885cc1cfdd23e593
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to generate expense report",
                message: "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $f48a89c798c28bd4$var$resetChain = function(resetChain$) {
    return resetChain$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($7859e0852b06702e$export$ba29fe9678473527), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function() {
        var action = {
            type: $7859e0852b06702e$export$9d73ba9f67b08be4
        };
        return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
    }));
};
// ! Make sure to add created epics to array 
$f48a89c798c28bd4$var$vehicleEffects.push($f48a89c798c28bd4$var$getGridData);
$f48a89c798c28bd4$var$vehicleEffects.push($f48a89c798c28bd4$var$createVehicle);
$f48a89c798c28bd4$var$vehicleEffects.push($f48a89c798c28bd4$var$updateGrid);
$f48a89c798c28bd4$var$vehicleEffects.push($f48a89c798c28bd4$var$editVehicle);
$f48a89c798c28bd4$var$vehicleEffects.push($f48a89c798c28bd4$var$updateGridEdit);
$f48a89c798c28bd4$var$vehicleEffects.push($f48a89c798c28bd4$var$createVehicleFile);
$f48a89c798c28bd4$var$vehicleEffects.push($f48a89c798c28bd4$var$getVehicleFiles);
$f48a89c798c28bd4$var$vehicleEffects.push($f48a89c798c28bd4$var$approveVehicleFile);
$f48a89c798c28bd4$var$vehicleEffects.push($f48a89c798c28bd4$var$rejectVehicleFile);
$f48a89c798c28bd4$var$vehicleEffects.push($f48a89c798c28bd4$var$getJobOrders);
$f48a89c798c28bd4$var$vehicleEffects.push($f48a89c798c28bd4$var$createJobOrder);
$f48a89c798c28bd4$var$vehicleEffects.push($f48a89c798c28bd4$var$getMedicalHistory);
$f48a89c798c28bd4$var$vehicleEffects.push($f48a89c798c28bd4$var$createJobOrderCleanup);
$f48a89c798c28bd4$var$vehicleEffects.push($f48a89c798c28bd4$var$updateJobOrder);
$f48a89c798c28bd4$var$vehicleEffects.push($f48a89c798c28bd4$var$getExpenseReport);
$f48a89c798c28bd4$var$vehicleEffects.push($f48a89c798c28bd4$var$resetChain);
var $f48a89c798c28bd4$export$2e2bcd8739ae039 = $f48a89c798c28bd4$var$vehicleEffects;








var $8e82173ade3ead1e$var$microscopeEffects = [];
var $8e82173ade3ead1e$var$retrieveGraphData = function(retrieveGraphData$) {
    return retrieveGraphData$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($65e879dcad4ecaad$export$7d659f58fd3701d), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var config = action.payload.remittanceConfig;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/microscope/remittance"), config, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            console.log("resp", resp);
            var action = {
                type: $65e879dcad4ecaad$export$5a447246bca8957e,
                payload: {
                    remittanceGraphData: resp.data["res"]
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errRes) {
            var action = {
                type: $65e879dcad4ecaad$export$36512567e53b44be
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
$8e82173ade3ead1e$var$microscopeEffects.push($8e82173ade3ead1e$var$retrieveGraphData);
var $8e82173ade3ead1e$export$2e2bcd8739ae039 = $8e82173ade3ead1e$var$microscopeEffects;











var $d818bbdc69f5596e$var$withdrawalEffects = [];
var $d818bbdc69f5596e$var$getBrandPrices = function(getBrandPrices$) {
    return getBrandPrices$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($0aa7832c96ad7a8d$export$8a851eeafd335d3f), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/prices"), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var prices = JSON.parse(JSON.stringify(response.data["results"]));
            var action = {
                type: $0aa7832c96ad7a8d$export$975edb9d659b30a5,
                payload: {
                    brandPrices: prices,
                    priceRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var action = {
                type: $0aa7832c96ad7a8d$export$da19de0c16ebf170,
                payload: {
                    priceRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get brand prices",
                message: "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $d818bbdc69f5596e$var$getGridData = function(getGridData$) {
    return getGridData$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($0aa7832c96ad7a8d$export$77f66c384bff48ec), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        /*
      Let's make a rule that the filter that is passed in the action
      contains both old and new. Meaning, we will never need to do
      the combination of current + new filters.
    // */ var action = _a[0], state = _a[1];
        var filters = "?";
        var currentFilters = action.payload.filters;
        var index = 0;
        currentFilters.forEach(function(value, key) {
            if (index === 0) filters = filters.concat("".concat(key, "=").concat(value));
            else filters = filters.concat("&".concat(key, "=").concat(value));
            index++;
        });
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/withdrawal").concat(filters), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var gridData = JSON.parse(JSON.stringify(response.data["results"]));
            var action = {
                type: $0aa7832c96ad7a8d$export$ed4400dd59fce138,
                payload: {
                    withdrawals: gridData.data,
                    total: gridData["totalCount"] && gridData["totalCount"][0] ? gridData["totalCount"][0].count : 0,
                    gridRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $0aa7832c96ad7a8d$export$20e6536dbfe7c63c,
                payload: {
                    gridRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response && errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get withdrawal grid data",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get withdrawal grid data",
                message: message,
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $d818bbdc69f5596e$var$createWithdrawal = function(submitWithdrawal$) {
    return submitWithdrawal$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($0aa7832c96ad7a8d$export$e232a12d14bb88be), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/withdrawal"), {
            supervisor: state.user.currentUser.supervisor.supervisorId,
            brandGroups: action.payload.brandGroupsToCreate
        }, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $0aa7832c96ad7a8d$export$3983fc4c8496d6cf,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Withdrawal submission",
                message: "You have successfully submitted a Withdrawal request",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Withdrawal request",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Withdrawal request",
                message: message,
                duration: 3000
            });
            var action = {
                type: $0aa7832c96ad7a8d$export$81d888d902e22f40,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $d818bbdc69f5596e$var$approveWithdrawal = function(approveWithdrawal$) {
    return approveWithdrawal$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($0aa7832c96ad7a8d$export$ce7e3994f699d240), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/withdrawal/approve"), {
            withdrawalId: action.payload.withdrawalId
        }, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $0aa7832c96ad7a8d$export$9178df8e2755611c,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Withdrawal approval",
                message: "You have successfully approved a Withdrawal request",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to approve Withdrawal request",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to approve Withdrawal request",
                message: message,
                duration: 3000
            });
            var action = {
                type: $0aa7832c96ad7a8d$export$f216b0b9b90fff3f,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $d818bbdc69f5596e$var$rejectWithdrawal = function(rejectWithdrawal$) {
    return rejectWithdrawal$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($0aa7832c96ad7a8d$export$16822945959ccb2e), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/withdrawal/reject"), {
            withdrawalId: action.payload.withdrawalId
        }, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $0aa7832c96ad7a8d$export$49fd866ab749dbbe,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Withdrawal reject",
                message: "You have successfully rejected a Withdrawal request",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to approve Withdrawal request",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to approve Withdrawal request",
                message: message,
                duration: 3000
            });
            var action = {
                type: $0aa7832c96ad7a8d$export$68738a51a9df9881,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $d818bbdc69f5596e$var$updateWithdrawal = function(updateWithdrawal$) {
    return updateWithdrawal$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($0aa7832c96ad7a8d$export$85e7a25aa0be6caf), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/withdrawal/update"), {
            withdrawalId: action.payload.withdrawalId,
            currentStage: action.payload.currentStage,
            targetStage: action.payload.targetStage,
            dateOfWithdrawal: action.payload.dateOfWithdrawal,
            dateOfShipment: action.payload.dateOfShipment,
            supervisor: action.payload.supervisor
        }, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $0aa7832c96ad7a8d$export$3aa263c9608ce90e,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Withdrawal update",
                message: "You have successfully updated a Withdrawal request",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to update Withdrawal request",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to update Withdrawal request",
                message: message,
                duration: 3000
            });
            var action = {
                type: $0aa7832c96ad7a8d$export$3dfc9d330b932f39,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $d818bbdc69f5596e$var$reeditWithdrawal = function(reeditWithdrawal$) {
    return reeditWithdrawal$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($0aa7832c96ad7a8d$export$f521ec80f2675a14), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/withdrawal/reedit"), {
            withdrawalId: action.payload.withdrawalId,
            updatedBrands: action.payload.updatedBrands
        }, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $0aa7832c96ad7a8d$export$62b23a759d6b00e6,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Withdrawal update",
                message: "You have successfully updated a Withdrawal request",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to update Withdrawal request",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to update Withdrawal request",
                message: message,
                duration: 3000
            });
            var action = {
                type: $0aa7832c96ad7a8d$export$2c2d9df55e7bbbc5,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $d818bbdc69f5596e$var$reeditAcceptWithdrawal = function(reeditAcceptWithdrawal$) {
    return reeditAcceptWithdrawal$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($0aa7832c96ad7a8d$export$a2888da95f8fb454), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/withdrawal/reedit-accept"), {
            withdrawalId: action.payload.withdrawalId
        }, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $0aa7832c96ad7a8d$export$d5f54c41d72f5b13,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Withdrawal reedit acceptance",
                message: "You have successfully accepted the Withdrawal reedit",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to accept Withdrawal reedit",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to accept Withdrawal reedit",
                message: message,
                duration: 3000
            });
            var action = {
                type: $0aa7832c96ad7a8d$export$ca74fbdd027d39d1,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $d818bbdc69f5596e$var$reeditDeclineWithdrawal = function(reeditDeclineWithdrawal$) {
    return reeditDeclineWithdrawal$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($0aa7832c96ad7a8d$export$6cd1afba76b7e164), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/withdrawal/reedit-decline"), {
            withdrawalId: action.payload.withdrawalId
        }, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $0aa7832c96ad7a8d$export$2817b96f4157750f,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Withdrawal reedit acceptance",
                message: "You have successfully accepted the Withdrawal reedit",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to accept Withdrawal reedit",
                message: message ? message : "Please contact the system admin.",
                duration: 3000
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to accept Withdrawal reedit",
                message: message,
                duration: 3000
            });
            var action = {
                type: $0aa7832c96ad7a8d$export$790e9cd8fc434e0c,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $d818bbdc69f5596e$var$resetWithdrawalChain = function(resetWithdrawalChain$) {
    return resetWithdrawalChain$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($0aa7832c96ad7a8d$export$3983fc4c8496d6cf, $0aa7832c96ad7a8d$export$9178df8e2755611c, $0aa7832c96ad7a8d$export$49fd866ab749dbbe, $0aa7832c96ad7a8d$export$62b23a759d6b00e6, $0aa7832c96ad7a8d$export$3aa263c9608ce90e, $0aa7832c96ad7a8d$export$d5f54c41d72f5b13, $0aa7832c96ad7a8d$export$2817b96f4157750f), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function() {
        var action = {
            type: $0aa7832c96ad7a8d$export$7602920c18a69ec5
        };
        return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
    }));
};
// ! Make sure to add created epics to array 
$d818bbdc69f5596e$var$withdrawalEffects.push($d818bbdc69f5596e$var$getBrandPrices);
$d818bbdc69f5596e$var$withdrawalEffects.push($d818bbdc69f5596e$var$getGridData);
$d818bbdc69f5596e$var$withdrawalEffects.push($d818bbdc69f5596e$var$createWithdrawal);
$d818bbdc69f5596e$var$withdrawalEffects.push($d818bbdc69f5596e$var$approveWithdrawal);
$d818bbdc69f5596e$var$withdrawalEffects.push($d818bbdc69f5596e$var$rejectWithdrawal);
$d818bbdc69f5596e$var$withdrawalEffects.push($d818bbdc69f5596e$var$updateWithdrawal);
$d818bbdc69f5596e$var$withdrawalEffects.push($d818bbdc69f5596e$var$reeditWithdrawal);
$d818bbdc69f5596e$var$withdrawalEffects.push($d818bbdc69f5596e$var$reeditAcceptWithdrawal);
$d818bbdc69f5596e$var$withdrawalEffects.push($d818bbdc69f5596e$var$reeditDeclineWithdrawal);
$d818bbdc69f5596e$var$withdrawalEffects.push($d818bbdc69f5596e$var$resetWithdrawalChain);
var $d818bbdc69f5596e$export$2e2bcd8739ae039 = $d818bbdc69f5596e$var$withdrawalEffects;











var $7ca0a94ec5d9399b$var$withdrawalEffects = [];
var $7ca0a94ec5d9399b$var$getGridData = function(getGridData$) {
    return getGridData$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($5dbd95920940fbf7$export$ccf130fa81c04150), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        /*
      Let's make a rule that the filter that is passed in the action
      contains both old and new. Meaning, we will never need to do
      the combination of current + new filters.
    // */ var action = _a[0], state = _a[1];
        var filters = "?";
        var currentFilters = action.payload.filters;
        var index = 0;
        currentFilters.forEach(function(value, key) {
            if (index === 0) filters = filters.concat("".concat(key, "=").concat(value));
            else filters = filters.concat("&".concat(key, "=").concat(value));
            index++;
        });
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/disposal").concat(filters), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var gridData = JSON.parse(JSON.stringify(response.data["results"]));
            var action = {
                type: $5dbd95920940fbf7$export$3ae694984dad8df0,
                payload: {
                    disposals: gridData.data,
                    total: gridData["totalCount"] && gridData["totalCount"][0] ? gridData["totalCount"][0].count : 0,
                    gridRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $5dbd95920940fbf7$export$a57ecdf4cdd82ab3,
                payload: {
                    gridRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response && errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get withdrawal grid data",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get withdrawal grid data",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $7ca0a94ec5d9399b$var$createDisposal = function(createDisposal$) {
    return createDisposal$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($5dbd95920940fbf7$export$39abb8eb105ebb6e), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var disposal = action.payload.disposalToCreate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/disposal"), disposal, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $5dbd95920940fbf7$export$fd160439eae40c54,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Withdrawal submission",
                message: "You have successfully submitted a Disposal",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Disposal",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Disposal",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            var action = {
                type: $5dbd95920940fbf7$export$cd6919ab739e1e26,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $7ca0a94ec5d9399b$var$resetDisposalChain = function(resetWithdrawalChain$) {
    return resetWithdrawalChain$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($5dbd95920940fbf7$export$fd160439eae40c54, $5dbd95920940fbf7$export$612688e2fffd0385), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function() {
        var action = {
            type: $5dbd95920940fbf7$export$be87a995de4ebda4
        };
        return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
    }));
};
var $7ca0a94ec5d9399b$var$createLocation = function(createLocation$) {
    return createLocation$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($5dbd95920940fbf7$export$d80ec8aacf18617a), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var locationToCreate = action.payload.locationToCreate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/location"), locationToCreate, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $5dbd95920940fbf7$export$612688e2fffd0385,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Location creation",
                message: "You have successfully added a new location.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to create Location",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to create Location",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            var action = {
                type: $5dbd95920940fbf7$export$dcc288d79863c22f,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
// ! Make sure to add created epics to array 
// withdrawalEffects.push(getBrandPrices);
$7ca0a94ec5d9399b$var$withdrawalEffects.push($7ca0a94ec5d9399b$var$getGridData);
$7ca0a94ec5d9399b$var$withdrawalEffects.push($7ca0a94ec5d9399b$var$createDisposal);
$7ca0a94ec5d9399b$var$withdrawalEffects.push($7ca0a94ec5d9399b$var$createLocation);
// withdrawalEffects.push(rejectWithdrawal);
// withdrawalEffects.push(updateWithdrawal);
// withdrawalEffects.push(reeditWithdrawal);
// withdrawalEffects.push(reeditAcceptWithdrawal);
// withdrawalEffects.push(reeditDeclineWithdrawal);
$7ca0a94ec5d9399b$var$withdrawalEffects.push($7ca0a94ec5d9399b$var$resetDisposalChain);
var $7ca0a94ec5d9399b$export$2e2bcd8739ae039 = $7ca0a94ec5d9399b$var$withdrawalEffects;











//^^ Literally others locally
var $fb1b6046ee242cc0$var$cashbondLoanEffects = [];
var $fb1b6046ee242cc0$var$getCashBondGridData = function(getGridData$) {
    return getGridData$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($9faeaaf3b7b2176c$export$1034728adc42b984), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var filters = "?";
        var currentFilters = action.payload.filters ? action.payload.filters : [];
        var index = 0;
        currentFilters.forEach(function(value, key) {
            if (index === 0) filters = filters.concat("".concat(key, "=").concat(value));
            else filters = filters.concat("&".concat(key, "=").concat(value));
            index++;
        });
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/cashbond").concat(filters), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var gridData = JSON.parse(JSON.stringify(response.data["results"]));
            var action = {
                type: $9faeaaf3b7b2176c$export$19af10c664e95825,
                payload: {
                    cashbonds: gridData.data,
                    total: gridData["totalCount"] && gridData["totalCount"][0] ? gridData["totalCount"][0].count : 0,
                    gridRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var action = {
                type: $9faeaaf3b7b2176c$export$339af5882dae5595,
                payload: {
                    gridRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response && errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get cashbond grid data",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get cashbond grid data",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $fb1b6046ee242cc0$var$createCashBond = function(createCashBond$) {
    return createCashBond$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($9faeaaf3b7b2176c$export$7a6efbf66dd44bf6), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var cashbond = action.payload.cashbondToCreate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/cashbond"), cashbond, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $9faeaaf3b7b2176c$export$3085e8f469fc5f08,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Cashbond submission",
                message: "You have successfully submitted a Cashbond",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Cashbond",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Cashbond",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            var action = {
                type: $9faeaaf3b7b2176c$export$9d14d09497dbe8af,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $fb1b6046ee242cc0$var$createCashbondPayment = function(createCashBond$) {
    return createCashBond$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($9faeaaf3b7b2176c$export$80f112149f100e38), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var bondPayment = action.payload.cashbondPaymentToCreate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/bond-payment"), bondPayment, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $9faeaaf3b7b2176c$export$79f2d2b27d9fe3b5,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Cashbond Payment submission",
                message: "You have successfully submitted a Cashbond Payment",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Cashbond Payment",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Cashbond Payment",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            var action = {
                type: $9faeaaf3b7b2176c$export$be8be11ea691e2bf,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $fb1b6046ee242cc0$var$getLoanGridData = function(getLoanGridData$) {
    return getLoanGridData$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($9faeaaf3b7b2176c$export$843b4ad7e23f8cba), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var filters = "?";
        var currentFilters = action.payload.filters ? action.payload.filters : [];
        var index = 0;
        currentFilters.forEach(function(value, key) {
            if (index === 0) filters = filters.concat("".concat(key, "=").concat(value));
            else filters = filters.concat("&".concat(key, "=").concat(value));
            index++;
        });
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/loan").concat(filters), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var gridData = JSON.parse(JSON.stringify(response.data["results"]));
            var action = {
                type: $9faeaaf3b7b2176c$export$64903e6356674f0c,
                payload: {
                    loans: gridData.data,
                    total: gridData["totalCount"] && gridData["totalCount"][0] ? gridData["totalCount"][0].count : 0,
                    gridRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $9faeaaf3b7b2176c$export$46eac9d2d2adca6d,
                payload: {
                    gridRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response && errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get loan grid data",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get loan grid data",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $fb1b6046ee242cc0$var$createLoan = function(createCashBond$) {
    return createCashBond$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($9faeaaf3b7b2176c$export$d38286f15dd53ade), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var _b;
        var action = _a[0], state = _a[1];
        var loan = (_b = action.payload) === null || _b === void 0 ? void 0 : _b.loanToCreate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/loan"), loan, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $9faeaaf3b7b2176c$export$83c38cdff29b2c33,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Loan submission",
                message: "You have successfully submitted a Loan",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Loan",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Loan",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            var action = {
                type: $9faeaaf3b7b2176c$export$6df051a5c38750d5,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $fb1b6046ee242cc0$var$createLoanPayment = function(createCashBond$) {
    return createCashBond$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($9faeaaf3b7b2176c$export$6964af2754c72e35), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var _b;
        var action = _a[0], state = _a[1];
        var loanPayment = (_b = action.payload) === null || _b === void 0 ? void 0 : _b.loanPaymentToCreate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/loan-payment"), loanPayment, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $9faeaaf3b7b2176c$export$79f2d2b27d9fe3b5,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Loan Payment submission",
                message: "You have successfully submitted a Loan Payment",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Loan Payment",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Loan Payment",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            var action = {
                type: $9faeaaf3b7b2176c$export$be8be11ea691e2bf,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $fb1b6046ee242cc0$var$updateLoanStatus = function(createCashBond$) {
    return createCashBond$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($9faeaaf3b7b2176c$export$63c41752fe5bdae7), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var loanStatus = action.payload.loanStatusToUpdate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/loan"), loanStatus, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $9faeaaf3b7b2176c$export$3d59594cfdbe6fe6,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Loan Status Update",
                message: "You have successfully submitted a Loan Status Update",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Loan Status Update",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Loan Status Update",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            var action = {
                type: $9faeaaf3b7b2176c$export$a946d7e2cec5e064,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $fb1b6046ee242cc0$var$approveLoanPaymentStatus = function(approveLoanPaymentStatus$) {
    return approveLoanPaymentStatus$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($9faeaaf3b7b2176c$export$b982743d6eb42399), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var _b;
        var action = _a[0], state = _a[1];
        var loanPaymentUpdate = (_b = action.payload) === null || _b === void 0 ? void 0 : _b.loanPaymentToUpdate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/loan-payment/approve"), loanPaymentUpdate, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $9faeaaf3b7b2176c$export$735e5dda1eefe53e,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Loan Status Update",
                message: "You have successfully submitted a Loan Status Update",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Loan Status Update",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Loan Status Update",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            var action = {
                type: $9faeaaf3b7b2176c$export$95871123abe3b6cf,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $fb1b6046ee242cc0$var$approveCashbondPaymentStatus = function(approveLoanPaymentStatus$) {
    return approveLoanPaymentStatus$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($9faeaaf3b7b2176c$export$157e6387758438c2), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var _b;
        var action = _a[0], state = _a[1];
        var bondPaymentUpdate = (_b = action.payload) === null || _b === void 0 ? void 0 : _b.cashbondPaymentToUpdate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/bond-payment/approve"), bondPaymentUpdate, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $9faeaaf3b7b2176c$export$752f4ce6cbf46779,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Cashbond Status Update",
                message: "You have successfully submitted a Cashbond Status Update",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Cashbond Status Update",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Cashbond Status Update",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            var action = {
                type: $9faeaaf3b7b2176c$export$6de406e9572a75db,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $fb1b6046ee242cc0$var$getLoanPaymentsData = function(getLoanPaymentsData$) {
    return getLoanPaymentsData$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($9faeaaf3b7b2176c$export$b9bca83af8eb0508), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var filters = "?";
        var currentFilters = action.payload.filters ? action.payload.filters : [];
        var index = 0;
        currentFilters.forEach(function(value, key) {
            if (index === 0) filters = filters.concat("".concat(key, "=").concat(value));
            else filters = filters.concat("&".concat(key, "=").concat(value));
            index++;
        });
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/loan-payment").concat(filters), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var gridData = JSON.parse(JSON.stringify(response.data["results"]));
            var action = {
                type: $9faeaaf3b7b2176c$export$64903e6356674f0c,
                payload: {
                    loanPayments: gridData.data,
                    total: gridData["totalCount"] && gridData["totalCount"][0] ? gridData["totalCount"][0].count : 0,
                    paymentsRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $9faeaaf3b7b2176c$export$46eac9d2d2adca6d,
                payload: {
                    paymentsRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response && errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get loan payments data",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get loan payments data",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $fb1b6046ee242cc0$var$getBondPaymentsData = function(getBondPaymentsData$) {
    return getBondPaymentsData$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($9faeaaf3b7b2176c$export$81f41e5e6f50faec), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var filters = "?";
        var currentFilters = action.payload.filters ? action.payload.filters : [];
        var index = 0;
        currentFilters.forEach(function(value, key) {
            if (index === 0) filters = filters.concat("".concat(key, "=").concat(value));
            else filters = filters.concat("&".concat(key, "=").concat(value));
            index++;
        });
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/bond-payment").concat(filters), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var gridData = JSON.parse(JSON.stringify(response.data["results"]));
            var action = {
                type: $9faeaaf3b7b2176c$export$f722b6c3d4f8732f,
                payload: {
                    bondPayment: gridData.data,
                    total: gridData["totalCount"] && gridData["totalCount"][0] ? gridData["totalCount"][0].count : 0,
                    paymentsRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $9faeaaf3b7b2176c$export$9ab2f391e0e39d88,
                payload: {
                    paymentsRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response && errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get loan payments data",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get loan payments data",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $fb1b6046ee242cc0$var$getServersideLoanReport = function(getReportGridData$) {
    return getReportGridData$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($9faeaaf3b7b2176c$export$a3a05ad01a242f49), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var filters = "?";
        if (action.payload && action.payload.filters) {
            var index_1 = 0;
            action.payload.filters.forEach(function(v, k) {
                if (index_1 > 0) filters = filters.concat("&");
                filters = filters.concat("".concat(k, "=").concat(v));
                index_1++;
            });
        }
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/loan/report").concat(filters), {
            withCredentials: true,
            responseType: "blob",
            headers: {
                "Accept": "application/pdf"
            }
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var action = {
                type: $9faeaaf3b7b2176c$export$956e1db7f310e1ac
            };
            if (response) {
                var blob = new Blob([
                    response.data
                ], {
                    type: "application/pdf"
                });
                window.open(URL.createObjectURL(blob));
            }
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var action = {
                type: $9faeaaf3b7b2176c$export$fb7356bebcbe05bb
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get grid data",
                message: "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $fb1b6046ee242cc0$var$getServersideCashbondReport = function(getReportGridData$) {
    return getReportGridData$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($9faeaaf3b7b2176c$export$603f5590406dec35), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var filters = "?";
        if (action.payload && action.payload.filters) {
            var index_2 = 0;
            action.payload.filters.forEach(function(v, k) {
                if (index_2 > 0) filters = filters.concat("&");
                filters = filters.concat("".concat(k, "=").concat(v));
                index_2++;
            });
        }
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/cashbond/report").concat(filters), {
            withCredentials: true,
            responseType: "blob",
            headers: {
                "Accept": "application/pdf"
            }
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var action = {
                type: $9faeaaf3b7b2176c$export$9696ea8fb11576d5
            };
            if (response) {
                var blob = new Blob([
                    response.data
                ], {
                    type: "application/pdf"
                });
                window.open(URL.createObjectURL(blob));
            }
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var action = {
                type: $9faeaaf3b7b2176c$export$caeca8d2b4653fd
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get grid data",
                message: "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $fb1b6046ee242cc0$var$getServersideLoanPaymentReport = function(getReportGridData$) {
    return getReportGridData$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($9faeaaf3b7b2176c$export$ffc6ac2cbc266632), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var filters = "?";
        if (action.payload && action.payload.filters) {
            var index_3 = 0;
            action.payload.filters.forEach(function(v, k) {
                if (index_3 > 0) filters = filters.concat("&");
                filters = filters.concat("".concat(k, "=").concat(v));
                index_3++;
            });
        }
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/loan-payment/report").concat(filters), {
            withCredentials: true,
            responseType: "blob",
            headers: {
                "Accept": "application/pdf"
            }
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var action = {
                type: $9faeaaf3b7b2176c$export$ccae5949e85ee97c
            };
            if (response) {
                var blob = new Blob([
                    response.data
                ], {
                    type: "application/pdf"
                });
                window.open(URL.createObjectURL(blob));
            }
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var action = {
                type: $9faeaaf3b7b2176c$export$e5ff0702d50f5d0
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get grid data",
                message: "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $fb1b6046ee242cc0$var$getServersideCashbondPaymentReport = function(getReportGridData$) {
    return getReportGridData$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($9faeaaf3b7b2176c$export$71767bdee8fc1b58), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(action) {
        var filters = "?";
        if (action.payload && action.payload.filters) {
            var index_4 = 0;
            action.payload.filters.forEach(function(v, k) {
                if (index_4 > 0) filters = filters.concat("&");
                filters = filters.concat("".concat(k, "=").concat(v));
                index_4++;
            });
        }
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/bond-payment/report").concat(filters), {
            withCredentials: true,
            responseType: "blob",
            headers: {
                "Accept": "application/pdf"
            }
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var action = {
                type: $9faeaaf3b7b2176c$export$d7e9dc491b583a64
            };
            if (response) {
                var blob = new Blob([
                    response.data
                ], {
                    type: "application/pdf"
                });
                window.open(URL.createObjectURL(blob));
            }
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var action = {
                type: $9faeaaf3b7b2176c$export$aba0b87fdc14ee96
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to get grid data",
                message: "Please contact the system admin.",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $fb1b6046ee242cc0$var$rejectLoanPaymentStatus = function(rejectLoanPaymentStatus$) {
    return rejectLoanPaymentStatus$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($9faeaaf3b7b2176c$export$286befb5f9ea4091), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var _b;
        var action = _a[0], state = _a[1];
        var loanPaymentUpdate = (_b = action.payload) === null || _b === void 0 ? void 0 : _b.loanPaymentToUpdate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/loan-payment/reject"), loanPaymentUpdate, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $9faeaaf3b7b2176c$export$9319d8db591c99dd,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Loan Status Update",
                message: "You have successfully submitted a Loan Status Update",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Loan Status Update",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Loan Status Update",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            var action = {
                type: $9faeaaf3b7b2176c$export$be20dc77e94a1e5a,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $fb1b6046ee242cc0$var$rejectCashbondPaymentStatus = function(rejectCashbondPaymentStatus$) {
    return rejectCashbondPaymentStatus$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($9faeaaf3b7b2176c$export$14d190b43fbb82db), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var _b;
        var action = _a[0], state = _a[1];
        var bondPaymentUpdate = (_b = action.payload) === null || _b === void 0 ? void 0 : _b.cashbondPaymentToUpdate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/bond-payment/reject"), bondPaymentUpdate, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $9faeaaf3b7b2176c$export$2e86298be2304ce,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Cashbond Status Update",
                message: "You have successfully submitted a Cashbond Status Update",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Cashbond Status Update",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Cashbond Status Update",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            var action = {
                type: $9faeaaf3b7b2176c$export$a697c7c30d95ef9a,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
$fb1b6046ee242cc0$var$cashbondLoanEffects.push($fb1b6046ee242cc0$var$getCashBondGridData);
$fb1b6046ee242cc0$var$cashbondLoanEffects.push($fb1b6046ee242cc0$var$createCashBond);
$fb1b6046ee242cc0$var$cashbondLoanEffects.push($fb1b6046ee242cc0$var$createCashbondPayment);
$fb1b6046ee242cc0$var$cashbondLoanEffects.push($fb1b6046ee242cc0$var$getServersideCashbondReport);
$fb1b6046ee242cc0$var$cashbondLoanEffects.push($fb1b6046ee242cc0$var$getBondPaymentsData);
$fb1b6046ee242cc0$var$cashbondLoanEffects.push($fb1b6046ee242cc0$var$getLoanGridData);
$fb1b6046ee242cc0$var$cashbondLoanEffects.push($fb1b6046ee242cc0$var$createLoan);
$fb1b6046ee242cc0$var$cashbondLoanEffects.push($fb1b6046ee242cc0$var$createLoanPayment);
$fb1b6046ee242cc0$var$cashbondLoanEffects.push($fb1b6046ee242cc0$var$updateLoanStatus);
$fb1b6046ee242cc0$var$cashbondLoanEffects.push($fb1b6046ee242cc0$var$getLoanPaymentsData);
$fb1b6046ee242cc0$var$cashbondLoanEffects.push($fb1b6046ee242cc0$var$getServersideLoanReport);
$fb1b6046ee242cc0$var$cashbondLoanEffects.push($fb1b6046ee242cc0$var$approveLoanPaymentStatus);
$fb1b6046ee242cc0$var$cashbondLoanEffects.push($fb1b6046ee242cc0$var$approveCashbondPaymentStatus);
$fb1b6046ee242cc0$var$cashbondLoanEffects.push($fb1b6046ee242cc0$var$rejectLoanPaymentStatus);
$fb1b6046ee242cc0$var$cashbondLoanEffects.push($fb1b6046ee242cc0$var$rejectCashbondPaymentStatus);
$fb1b6046ee242cc0$var$cashbondLoanEffects.push($fb1b6046ee242cc0$var$getServersideLoanPaymentReport);
$fb1b6046ee242cc0$var$cashbondLoanEffects.push($fb1b6046ee242cc0$var$getServersideCashbondPaymentReport);
var $fb1b6046ee242cc0$export$2e2bcd8739ae039 = $fb1b6046ee242cc0$var$cashbondLoanEffects;












var $8f2b169202e9ad3c$exports = {};

$parcel$export($8f2b169202e9ad3c$exports, "SignPDModal", () => $8f2b169202e9ad3c$export$103c73515acb9ce1);
$parcel$export($8f2b169202e9ad3c$exports, "SIGN_ACTION_NOTE", () => $8f2b169202e9ad3c$export$af8f23d5f78834c3);
$parcel$export($8f2b169202e9ad3c$exports, "SIGN_ACTION_REQUEST_APPROVE", () => $8f2b169202e9ad3c$export$799082bd3ee8b4ae);

var $LjoDx = parcelRequire("LjoDx");
var $60313e3b9e75c852$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ 

function $89e911a23ad872a9$export$779c5fb865a0172e(compare, keySelector) {
    return function(source) {
        return source.lift(new $89e911a23ad872a9$var$DistinctUntilChangedOperator(compare, keySelector));
    };
}
var $89e911a23ad872a9$var$DistinctUntilChangedOperator = /*@__PURE__*/ function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $89e911a23ad872a9$var$DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
var $89e911a23ad872a9$var$DistinctUntilChangedSubscriber = /*@__PURE__*/ function(_super) {
    $5c96a02c592fcff1$export$a8ba968b8961cb8a(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.hasKey = false;
        if (typeof compare === "function") _this.compare = compare;
        return _this;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var key;
        try {
            var keySelector = this.keySelector;
            key = keySelector ? keySelector(value) : value;
        } catch (err) {
            return this.destination.error(err);
        }
        var result = false;
        if (this.hasKey) try {
            var compare = this.compare;
            result = compare(this.key, key);
        } catch (err) {
            return this.destination.error(err);
        }
        else this.hasKey = true;
        if (!result) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}((0, $0c5e61cfa4404ac4$export$60959659b2c22881));


var $3f2ba7f1e3532510$exports = {};

$parcel$export($3f2ba7f1e3532510$exports, "Modal", () => $3f2ba7f1e3532510$export$2b77a92f1a5ad772);
$parcel$export($3f2ba7f1e3532510$exports, "onModalOpened", () => $3f2ba7f1e3532510$export$3d2484a322f45203);

var $LjoDx = parcelRequire("LjoDx");
var $3f2ba7f1e3532510$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3f2ba7f1e3532510$export$2b77a92f1a5ad772 = /** @class */ function(_super) {
    $3f2ba7f1e3532510$var$__extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onOutsideClick = function(ev) {
            var target = ev.target;
            if (target !== _this.refNode) // The reason for doing this instead of doing an outright this.props['close']()
            // is because we might need the close function to return something.
            // this help wrap aroud and the close function is called right;
            _this.doModalClose();
        };
        return _this;
    }
    Modal.prototype.componentDidMount = function() {
        if (this.props["isOutsideClickClose"] && this.props["containerId"]) {
            var container = document.getElementById(this.props["containerId"]);
            container.addEventListener("mousedown", this.onOutsideClick, false);
        }
    };
    return Modal;
}((0, $LjoDx.Component));
var $3f2ba7f1e3532510$export$3d2484a322f45203 = function(key, params) {
    var paramMap = new Map();
    for(var k in params)paramMap.set(k, params[k]);
    return {
        name: key,
        parameters: paramMap
    };
};


class $49e398741f5b1a93$export$a455218a85c89869 {
    constructor(validators, customValidators, defaultValue){
        this.isPristine = true;
        this.validators = validators;
        this.customValidators = customValidators;
        this.value = defaultValue;
    }
}
class $49e398741f5b1a93$export$a7fed597f4b8afd8 {
    constructor(fields){
        this.fields = fields;
        this.isValid = false;
    }
    static cloneFrom(form) {
        let clonedFields = {};
        for(let k in form.fields){
            let prevField = form.fields[k];
            clonedFields[k] = new $49e398741f5b1a93$export$a455218a85c89869(prevField.validators, prevField.customValidators, prevField.value);
            clonedFields[k].isValid = prevField.isValid;
        }
        let clone = new $49e398741f5b1a93$export$a7fed597f4b8afd8(clonedFields);
        return clone;
    }
}
const $49e398741f5b1a93$export$85a71696a80c2ae2 = (value, fieldName, form, form$)=>{
    // Manually do this because in order to follow the 
    // hopplerLinkstate validation system
    let clonedFields = {};
    for(let k in form.fields){
        let prevField = form.fields[k];
        clonedFields[k] = new $49e398741f5b1a93$export$a455218a85c89869(prevField.validators, prevField.customValidators, prevField.value);
        clonedFields[k].isValid = prevField.isValid;
    }
    let clone = new $49e398741f5b1a93$export$a7fed597f4b8afd8(clonedFields);
    clone.fields[fieldName].value = value;
    clone.fields[fieldName].isPristine = false;
    // clone.fields[fieldName].customValidators.forEach(a => a(clone.fields[fieldName], clone));
    form$.next(clone);
};


const $fc45e937e6d1b794$export$a7a0278c004aac3f = "required";
const $fc45e937e6d1b794$export$d290fa47940df19d = "email";
const $fc45e937e6d1b794$export$976c37132e9c6a10 = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
function $fc45e937e6d1b794$export$ed692cabb252e59b(form) {
    form.isValid = true; // set form isValid to true first.
    // later we set to false if a single field becomes invalid
    for(let key in form.fields){
        const field = form.fields[key];
        let invalidCounts = 0;
        // set pristine to false when a form is validated.
        // Something can't be pristine when sent to inspection.
        // That means it's been "touched"
        if (field.isPristine) field.isPristine = false;
        if (field.validators && field.validators.includes($fc45e937e6d1b794$export$a7a0278c004aac3f)) {
            if (!field.value) invalidCounts++;
        }
        if (field.validators && field.validators.includes($fc45e937e6d1b794$export$d290fa47940df19d)) {
            if (!$fc45e937e6d1b794$export$976c37132e9c6a10.test(field.value)) invalidCounts++;
        }
        if (field.customValidators) field.customValidators.forEach((validator)=>{
            let isValid = true;
            isValid = validator(field, form);
            if (isValid == false) invalidCounts++;
        });
        if (invalidCounts > 0) {
            field.isValid = false;
            form.isValid = false;
        } else field.isValid = true;
    }
}
function $fc45e937e6d1b794$export$7c1f5a29b59be526(field) {
    if (field.isPristine) return false;
    return !field.isValid;
}



function $7689db45fd0b6293$export$2e2bcd8739ae039(subject, form, fieldName, toggleable) {
    return function(event) {
        var clone = (0, $49e398741f5b1a93$export$a7fed597f4b8afd8).cloneFrom(form);
        var target = event.target;
        var value = target.value;
        if (toggleable) {
            if (target.nodeName && target.type.match(/^che|rad/)) value = target.checked;
        }
        clone.fields[fieldName].value = value;
        clone.fields[fieldName].isPristine = false;
        subject.next(clone);
    };
}
function $7689db45fd0b6293$export$1065ee7c53aa27ff(subject, form, fieldName, value) {
    var clone = (0, $49e398741f5b1a93$export$a7fed597f4b8afd8).cloneFrom(form);
    clone.fields[fieldName].value = value;
    clone.fields[fieldName].isPristine = false;
    subject.next(clone);
}





var $LjoDx = parcelRequire("LjoDx");
var $75d6025062e781ef$export$89b84a018a9c9ba3 = function(isVisible) {
    if (isVisible) return (0, $LjoDx.h)("div", {
        class: "col offset-md-9 d-flex justify-content-end"
    }, (0, $LjoDx.h)("div", {
        class: "spinner-border text-primary mt-3",
        role: "status"
    }, (0, $LjoDx.h)("span", {
        class: "sr-only"
    }, "Loading...")));
};



var $8f2b169202e9ad3c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8f2b169202e9ad3c$export$103c73515acb9ce1 = /** @class */ function(_super) {
    $8f2b169202e9ad3c$var$__extends(SignPDModal, _super);
    function SignPDModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            if (_this.props.close) _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            // const restFieldName: string = getSignActionRestFieldName(
            //   this.props.signAction
            // );
            var purchaseDocumentSignPayload = {
                purchaseDocumentId: _this.props.pd.purchaseDocumentId,
                signAction: _this.props.signAction
            };
            purchaseDocumentSignPayload[_this.props.signAction] = form.fields["actionBy"].value;
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $42d61ffa1d8a8d2b$export$45cf4d2d5931e7),
                payload: {
                    purchaseDocumentSignPayload: purchaseDocumentSignPayload
                }
            });
        };
        _this.createForm(props);
        return _this;
    }
    SignPDModal.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            actionBy: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    SignPDModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var motorpool$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.motorpool;
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
        }));
    };
    SignPDModal.prototype.getFormBlock = function(props, state) {
        var form = this.state.form;
        var fieldName = $8f2b169202e9ad3c$export$ee5307445f41333d(props.signAction);
        return (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, fieldName), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["actionBy"])
            }),
            type: "text",
            value: form.fields["actionBy"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "actionBy"),
            placeholder: fieldName
        })))));
    };
    SignPDModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return (0, $75d6025062e781ef$export$89b84a018a9c9ba3)(state.isPostInProgress);
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !state.form.isValid
        }, "Submit"))));
    };
    SignPDModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-pd-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Update Purchase Document | ", props.pd.purchaseDocumentId)), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions"
        }, this.getActionsRow(props, state)));
    };
    return SignPDModal;
}((0, $3f2ba7f1e3532510$exports.Modal));
var $8f2b169202e9ad3c$export$ee5307445f41333d = function(signAction) {
    var fieldName = "";
    switch(signAction){
        case $8f2b169202e9ad3c$export$af8f23d5f78834c3:
            fieldName = "Noted By";
            break;
        case $8f2b169202e9ad3c$export$799082bd3ee8b4ae:
            fieldName = "Request Approved By";
            break;
    }
    return fieldName;
};
var $8f2b169202e9ad3c$export$af8f23d5f78834c3 = "notedBy";
var $8f2b169202e9ad3c$export$799082bd3ee8b4ae = "requestApprovedBy";
var $8f2b169202e9ad3c$export$cc35d0e77634d48f = "orderApprovedBy";


var $666598065b2c8474$var$motorpoolEffects = [];
var $666598065b2c8474$var$getPurchaseDocuments = function(getPurchaseDocuments$) {
    return getPurchaseDocuments$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($42d61ffa1d8a8d2b$export$2c11d93fae2a2b91), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var _b;
        var action = _a[0], state = _a[1];
        var filters = (0, $972f523c8d7c94b0$export$fbc6c17f0981c6e7)((_b = action.payload) === null || _b === void 0 ? void 0 : _b.filters);
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/purchase").concat(filters), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var gridData = JSON.parse(JSON.stringify(response.data[0]));
            var action = {
                type: $42d61ffa1d8a8d2b$export$70207d327e8500d0,
                payload: {
                    purchaseDocuments: gridData.data,
                    pdTotal: (0, $972f523c8d7c94b0$export$316d811a61bf3914)(gridData),
                    pdRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $42d61ffa1d8a8d2b$export$45bfd5011359c969,
                payload: {
                    pdRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            (0, $972f523c8d7c94b0$export$e61094535130c45d)(errResponse, "Failed to retrieve purchase documents");
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $666598065b2c8474$var$getSuppliers = function(getSuppliers$) {
    return getSuppliers$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($42d61ffa1d8a8d2b$export$4b47e70039a23c0d), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var _b;
        var action = _a[0], state = _a[1];
        var filters = (0, $972f523c8d7c94b0$export$fbc6c17f0981c6e7)((_b = action.payload) === null || _b === void 0 ? void 0 : _b.filters);
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/supplier").concat(filters), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var gridData = JSON.parse(JSON.stringify(response.data[0]));
            var action = {
                type: $42d61ffa1d8a8d2b$export$32b066daf13f7977,
                payload: {
                    suppliers: gridData.data,
                    total: (0, $972f523c8d7c94b0$export$316d811a61bf3914)(gridData),
                    pdRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $42d61ffa1d8a8d2b$export$ebbea60c1b54611b,
                payload: {
                    pdRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            (0, $972f523c8d7c94b0$export$e61094535130c45d)(errResponse, "Failed to retrieve suppliers");
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $666598065b2c8474$var$createSupplier = function(createSupplier$) {
    return createSupplier$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($42d61ffa1d8a8d2b$export$7a1acd13345d31d1), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var supplier = action.payload.supplierToCreate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/supplier/create"), supplier, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $42d61ffa1d8a8d2b$export$b71b943ab130b03f,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Supplier submission",
                message: "You have successfully submitted a Supplier",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Supplier",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Supplier",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            var action = {
                type: $42d61ffa1d8a8d2b$export$b845d0418853eecb,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $666598065b2c8474$var$editSupplier = function(editSupplier$) {
    return editSupplier$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($42d61ffa1d8a8d2b$export$23577ab1e176bf94), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var supplier = action.payload.supplierToEdit;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/supplier/update"), supplier, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $42d61ffa1d8a8d2b$export$44298b320dfe6ec6,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Supplier submission",
                message: "You have successfully submitted a Supplier",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Supplier",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Supplier",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            var action = {
                type: $42d61ffa1d8a8d2b$export$f34471b32366d385,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $666598065b2c8474$var$createPd = function(createPd$) {
    return createPd$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($42d61ffa1d8a8d2b$export$e85b08d1656584fd), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var pd = action.payload.purchaseDocumentToCreate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/purchase/create"), pd, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $42d61ffa1d8a8d2b$export$e5c7903e2195e3ac,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Purchase Document submission",
                message: "You have successfully submitted a Purchase Document",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Purchase Document",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Purchase Document",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            var action = {
                type: $42d61ffa1d8a8d2b$export$b845d0418853eecb,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $666598065b2c8474$var$updatePd = function(updatePd$) {
    return updatePd$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($42d61ffa1d8a8d2b$export$f30ae27113e62e75), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var pd = action.payload.purchaseDocumentToUpdate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/purchase/update"), pd, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $42d61ffa1d8a8d2b$export$b69d620fbf73f545,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Purchase Document update",
                message: "You have successfully updated a Purchase Document",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to update Purchase Document",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to update Purchase Document",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            var action = {
                type: $42d61ffa1d8a8d2b$export$afefe0bf69fede53,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $666598065b2c8474$var$notePd = function(notePd$) {
    return notePd$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($42d61ffa1d8a8d2b$export$45cf4d2d5931e7), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var purchaseDocumentSignPayload = action.payload.purchaseDocumentSignPayload;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/purchase/").concat($666598065b2c8474$var$getSignPath(purchaseDocumentSignPayload.signAction)), purchaseDocumentSignPayload, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $42d61ffa1d8a8d2b$export$b69d620fbf73f545,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Purchase Document update",
                message: "You have successfully updated a Purchase Document",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to update Purchase Document",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to update Purchase Document",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            var action = {
                type: $42d61ffa1d8a8d2b$export$afefe0bf69fede53,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $666598065b2c8474$var$createRR = function(createRR$) {
    return createRR$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($42d61ffa1d8a8d2b$export$219ad08fb66a8ce9), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var purchaseDocumentId = action.payload.purchaseDocumentId;
        var receivingReport = action.payload.receivingReport;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/purchase/receive-report"), {
            purchaseDocumentId: purchaseDocumentId,
            receivingReport: receivingReport
        }, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $42d61ffa1d8a8d2b$export$e0ac74c5766a60d9,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Create Receiving Report",
                message: "You have successfully updated a Receiving Report",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to Create Receiving Report",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to Create Receiving Report",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            var action = {
                type: $42d61ffa1d8a8d2b$export$f29abefab8453a58,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $666598065b2c8474$var$getItems = function(getItems$) {
    return getItems$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($42d61ffa1d8a8d2b$export$ac218852b62ed936), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var _b;
        var action = _a[0], state = _a[1];
        var filters = (0, $972f523c8d7c94b0$export$fbc6c17f0981c6e7)((_b = action.payload) === null || _b === void 0 ? void 0 : _b.filters);
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/item").concat(filters), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var gridData = JSON.parse(JSON.stringify(response.data[0]));
            var action = {
                type: $42d61ffa1d8a8d2b$export$e55e65db5c6ebc42,
                payload: {
                    items: gridData.data,
                    total: (0, $972f523c8d7c94b0$export$316d811a61bf3914)(gridData),
                    pdRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $42d61ffa1d8a8d2b$export$f53f0f104c900386,
                payload: {
                    pdRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            (0, $972f523c8d7c94b0$export$e61094535130c45d)(errResponse, "Failed to retrieve items");
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $666598065b2c8474$var$createItem = function(createItem$) {
    return createItem$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($42d61ffa1d8a8d2b$export$12c5a76e8711aaf9), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var item = action.payload.itemToCreate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/item/create"), item, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $42d61ffa1d8a8d2b$export$80b327feb60df2a,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Item submission",
                message: "You have successfully submitted a Item",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Supplier",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Item",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            var action = {
                type: $42d61ffa1d8a8d2b$export$584e6de652fbe73e,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $666598065b2c8474$var$getSignPath = function(action) {
    var path = "";
    switch(action){
        case 0, $8f2b169202e9ad3c$exports.SIGN_ACTION_NOTE:
            path = "note";
            break;
        case 0, $8f2b169202e9ad3c$exports.SIGN_ACTION_REQUEST_APPROVE:
            path = "approve";
            break;
    }
    return path;
};
var $666598065b2c8474$var$createJO = function(createJO$) {
    return createJO$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($42d61ffa1d8a8d2b$export$b756dd7da319f967), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var jo = action.payload.joToCreate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/job-order/create"), jo, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $42d61ffa1d8a8d2b$export$79358c9c16287abf,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Job Order submission",
                message: "You have successfully submitted a JO",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Supplier",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit JO",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            var action = {
                type: $42d61ffa1d8a8d2b$export$aff5e0b21debd35c,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $666598065b2c8474$var$updateJO = function(updateJO$) {
    return updateJO$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($42d61ffa1d8a8d2b$export$3eb2cadfcad095b9), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var jo = action.payload.joToUpdate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/job-order/update"), jo, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $42d61ffa1d8a8d2b$export$d94f1a0f25fdedab,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Job Order update",
                message: "You have successfully submitted a JO",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            (0, $972f523c8d7c94b0$export$e61094535130c45d)(errResponse, "Failed to update JO");
            var action = {
                type: $42d61ffa1d8a8d2b$export$5386f8a90287c45c,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $666598065b2c8474$var$getJOs = function(getJOs$) {
    return getJOs$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($42d61ffa1d8a8d2b$export$dd693b166ab0dca), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var _b;
        var action = _a[0], state = _a[1];
        var filters = (0, $972f523c8d7c94b0$export$fbc6c17f0981c6e7)((_b = action.payload) === null || _b === void 0 ? void 0 : _b.filters);
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/job-order").concat(filters), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var gridData = JSON.parse(JSON.stringify(response.data[0]));
            console.log(response.data);
            var action = {
                type: $42d61ffa1d8a8d2b$export$53d1136df7b5cf9c,
                payload: {
                    jobOrders: gridData.data,
                    total: (0, $972f523c8d7c94b0$export$316d811a61bf3914)(gridData),
                    joRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $42d61ffa1d8a8d2b$export$d8418dc15898d972,
                payload: {
                    joRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            (0, $972f523c8d7c94b0$export$e61094535130c45d)(errResponse, "Failed to retrieve items");
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $666598065b2c8474$var$createIW = function(createIW$) {
    return createIW$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($42d61ffa1d8a8d2b$export$957a5f118c67b29c), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var iw = action.payload.iwToCreate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).post("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/withdrawal/create"), iw, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $42d61ffa1d8a8d2b$export$a54a5efc08fff5af,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success Job Order submission",
                message: "You have successfully submitted an Item Withdrawal",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            var message;
            if (errResponse.response && errResponse.response.data && errResponse.response.data.msg) message = errResponse.response.data.msg;
            if (errResponse.response.status == 400) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Item Withdrawal",
                message: message ? message : "Please contact the system admin.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to submit Item Withdrawal",
                message: message,
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            var action = {
                type: $42d61ffa1d8a8d2b$export$8beb5a11d319cfa9,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $666598065b2c8474$var$updateIW = function(updateIW$) {
    return updateIW$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($42d61ffa1d8a8d2b$export$7b12c10955d2c61b), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var iw = action.payload.iwToUpdate;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/withdrawal/update"), iw, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $42d61ffa1d8a8d2b$export$c618038f5b3f5ec1,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success withdrawal submission",
                message: "You have successfully updated a withdrawal",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            (0, $972f523c8d7c94b0$export$e61094535130c45d)(errResponse, "Failed to update withdrawal");
            var action = {
                type: $42d61ffa1d8a8d2b$export$258b9e16767bed39,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $666598065b2c8474$var$getIWs = function(getIWs$) {
    return getIWs$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($42d61ffa1d8a8d2b$export$8c063221a5c296f6), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var _b;
        var action = _a[0], state = _a[1];
        var filters = (0, $972f523c8d7c94b0$export$fbc6c17f0981c6e7)((_b = action.payload) === null || _b === void 0 ? void 0 : _b.filters);
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/withdrawal").concat(filters), {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(response) {
            var gridData = JSON.parse(JSON.stringify(response.data[0]));
            var action = {
                type: $42d61ffa1d8a8d2b$export$13c539a07d1605e1,
                payload: {
                    itemWithdrawals: gridData.data,
                    total: (0, $972f523c8d7c94b0$export$316d811a61bf3914)(gridData),
                    iwRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            console.log(errResponse);
            var action = {
                type: $42d61ffa1d8a8d2b$export$7732b475b1e07505,
                payload: {
                    iwRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            (0, $972f523c8d7c94b0$export$e61094535130c45d)(errResponse, "Failed to retrieve items");
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $666598065b2c8474$var$processIW = function(processIW$) {
    return processIW$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($42d61ffa1d8a8d2b$export$80f60acd99fb252a), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var iwSignPayload = action.payload.iwSignPayload;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/withdrawal/process"), iwSignPayload, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $42d61ffa1d8a8d2b$export$42ee4228479b90c4,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success withdrawal update",
                message: "You have successfully updated an item withdrawal",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            (0, $972f523c8d7c94b0$export$e61094535130c45d)(errResponse, "Failed to process withdrawal");
            var action = {
                type: $42d61ffa1d8a8d2b$export$96915d545c772da0,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $666598065b2c8474$var$approveIW = function(approveIW$) {
    return approveIW$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($42d61ffa1d8a8d2b$export$8f972aa3ca99dbc7), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var iwSignPayload = action.payload.iwSignPayload;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/withdrawal/approve"), iwSignPayload, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $42d61ffa1d8a8d2b$export$552a720dae6b32bc,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success withdrawal update",
                message: "You have successfully updated an item withdrawal",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            (0, $972f523c8d7c94b0$export$e61094535130c45d)(errResponse, "Failed to process withdrawal");
            var action = {
                type: $42d61ffa1d8a8d2b$export$654ddfb89504dc59,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $666598065b2c8474$var$createPO = function(createPO$) {
    return createPO$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($42d61ffa1d8a8d2b$export$c732d4e88ae15264), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var pd = action.payload.purchaseDocumentSignPayload;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/purchase/order"), pd, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $42d61ffa1d8a8d2b$export$6b1566edaa626f78,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success create Purchase Order",
                message: "You have successfully created Purchase Order",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            (0, $972f523c8d7c94b0$export$e61094535130c45d)(errResponse, "Failed to create Purchase Order");
            var action = {
                type: $42d61ffa1d8a8d2b$export$59d345a959f778e2,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
var $666598065b2c8474$var$approvePO = function(approvePO$) {
    return approvePO$.pipe((0, $098da3bfff4d96e5$export$5db8774c0df95fce)($42d61ffa1d8a8d2b$export$9847d0c5208657f5), (0, $dd030c518003cbd3$export$d449030e5c10edf7)((0, $364b9d08877d223b$export$9f88e9db215c9dfb)), (0, $73546da28e450aaf$export$9f6ea8e48bc26eab)(function(_a) {
        var action = _a[0], state = _a[1];
        var pd = action.payload.purchaseDocumentSignPayload;
        var promise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).put("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/purchase/approve-order"), pd, {
            withCredentials: true
        });
        return (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)(promise).pipe((0, $8ee93c856d38203a$export$6b9f6c0d32c093f9)(function(resp) {
            var action = {
                type: $42d61ffa1d8a8d2b$export$34cd4a419e817371,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$3ee3100c952bc770)
                }
            };
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Success approve Purchase Order",
                message: "You have successfully approved Purchase Order",
                duration: 3000
            });
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }), (0, $ba3a949fb0190b34$export$3dede90624df3ba9)(function(errResponse) {
            (0, $972f523c8d7c94b0$export$e61094535130c45d)(errResponse, "Failed to approve Purchase Order");
            var action = {
                type: $42d61ffa1d8a8d2b$export$b8701ca7eea9c506,
                payload: {
                    postPutRequestState: (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)
                }
            };
            return (0, $02622667f18df45a$export$ba255e9e49e00608)(action);
        }));
    }));
};
$666598065b2c8474$var$motorpoolEffects.push($666598065b2c8474$var$getPurchaseDocuments);
$666598065b2c8474$var$motorpoolEffects.push($666598065b2c8474$var$getSuppliers);
$666598065b2c8474$var$motorpoolEffects.push($666598065b2c8474$var$createPd);
$666598065b2c8474$var$motorpoolEffects.push($666598065b2c8474$var$updatePd);
$666598065b2c8474$var$motorpoolEffects.push($666598065b2c8474$var$notePd);
$666598065b2c8474$var$motorpoolEffects.push($666598065b2c8474$var$createRR);
$666598065b2c8474$var$motorpoolEffects.push($666598065b2c8474$var$getItems);
$666598065b2c8474$var$motorpoolEffects.push($666598065b2c8474$var$createSupplier);
$666598065b2c8474$var$motorpoolEffects.push($666598065b2c8474$var$editSupplier);
$666598065b2c8474$var$motorpoolEffects.push($666598065b2c8474$var$createItem);
$666598065b2c8474$var$motorpoolEffects.push($666598065b2c8474$var$createJO);
$666598065b2c8474$var$motorpoolEffects.push($666598065b2c8474$var$getJOs);
$666598065b2c8474$var$motorpoolEffects.push($666598065b2c8474$var$updateJO);
$666598065b2c8474$var$motorpoolEffects.push($666598065b2c8474$var$createPO);
$666598065b2c8474$var$motorpoolEffects.push($666598065b2c8474$var$approvePO);
$666598065b2c8474$var$motorpoolEffects.push($666598065b2c8474$var$createIW);
$666598065b2c8474$var$motorpoolEffects.push($666598065b2c8474$var$getIWs);
$666598065b2c8474$var$motorpoolEffects.push($666598065b2c8474$var$updateIW);
$666598065b2c8474$var$motorpoolEffects.push($666598065b2c8474$var$processIW);
$666598065b2c8474$var$motorpoolEffects.push($666598065b2c8474$var$approveIW);
var $666598065b2c8474$export$2e2bcd8739ae039 = $666598065b2c8474$var$motorpoolEffects;




var $69fb97d23521c798$export$fdbb603bbeea7672 = [];
$69fb97d23521c798$export$fdbb603bbeea7672 = $69fb97d23521c798$export$fdbb603bbeea7672.concat((0, $f4f0268b008d3e35$exports.default));
$69fb97d23521c798$export$fdbb603bbeea7672 = $69fb97d23521c798$export$fdbb603bbeea7672.concat((0, $32688a3bd395dec2$exports.default));
$69fb97d23521c798$export$fdbb603bbeea7672 = $69fb97d23521c798$export$fdbb603bbeea7672.concat((0, $d5eed2b019ffdb13$export$2e2bcd8739ae039));
$69fb97d23521c798$export$fdbb603bbeea7672 = $69fb97d23521c798$export$fdbb603bbeea7672.concat((0, $6f9d9b985abcee58$exports.default));
$69fb97d23521c798$export$fdbb603bbeea7672 = $69fb97d23521c798$export$fdbb603bbeea7672.concat((0, $f48a89c798c28bd4$exports.default));
$69fb97d23521c798$export$fdbb603bbeea7672 = $69fb97d23521c798$export$fdbb603bbeea7672.concat((0, $8e82173ade3ead1e$export$2e2bcd8739ae039));
$69fb97d23521c798$export$fdbb603bbeea7672 = $69fb97d23521c798$export$fdbb603bbeea7672.concat((0, $d818bbdc69f5596e$export$2e2bcd8739ae039));
$69fb97d23521c798$export$fdbb603bbeea7672 = $69fb97d23521c798$export$fdbb603bbeea7672.concat((0, $7ca0a94ec5d9399b$export$2e2bcd8739ae039));
$69fb97d23521c798$export$fdbb603bbeea7672 = $69fb97d23521c798$export$fdbb603bbeea7672.concat((0, $fb1b6046ee242cc0$export$2e2bcd8739ae039));
$69fb97d23521c798$export$fdbb603bbeea7672 = $69fb97d23521c798$export$fdbb603bbeea7672.concat((0, $666598065b2c8474$export$2e2bcd8739ae039));
var $69fb97d23521c798$export$49b6a7dfc84f00c4 = (0, $22783a2c8c11cfe1$export$6259fe981e4a41dc).apply(void 0, $69fb97d23521c798$export$fdbb603bbeea7672);
setTimeout(function() {
    var action = {
        type: $4c71eb74f53637d3$export$ff67457b75dbf12a
    };
    (0, $364b9d08877d223b$export$2e2bcd8739ae039)().dispatch(action);
}, 200);



var $364b9d08877d223b$var$epicMiddleware = (0, $ec13e319864e87c6$export$147cf6f7ce5462cb)();
var $364b9d08877d223b$var$appStore = (0, $ad4393542232627c$export$f51a9068ac82ea43)((0, $f0fa1efe65ee6779$export$2e2bcd8739ae039), (0, $79637b0fcd305eaf$export$d32324a03b6bde1b)((0, $ad4393542232627c$export$9ff26e0402cc7b7)($364b9d08877d223b$var$epicMiddleware)));
var $364b9d08877d223b$export$9f88e9db215c9dfb = (0, $d98b9cf92f0fc696$export$6788812c4e6611e6)($364b9d08877d223b$var$appStore);
// ! Important line here or else the rootEpic will never be used.
$364b9d08877d223b$var$epicMiddleware.run((0, $69fb97d23521c798$export$49b6a7dfc84f00c4));
function $364b9d08877d223b$export$2e2bcd8739ae039() {
    return $364b9d08877d223b$var$appStore;
}



var $LjoDx = parcelRequire("LjoDx");
var $6a59fa973dab83d3$export$ba6e2dd81d982fe = {
    isOnClient: function() {
        // window and window.document (the DOM) only exist in client
        // console.log('checking code run');
        return !!(window != undefined && window.document);
    }
};


var $d5ba0d87554d611e$exports = {};

$parcel$export($d5ba0d87554d611e$exports, "PreactApp", () => $d5ba0d87554d611e$export$1b925f4758db83dd);

var $LjoDx = parcelRequire("LjoDx");
var $ea0dbf761ed9dde7$var$EMPTY$1 = {};
function $ea0dbf761ed9dde7$var$assign(obj, props) {
    // eslint-disable-next-line guard-for-in
    for(var i in props)obj[i] = props[i];
    return obj;
}
function $ea0dbf761ed9dde7$var$exec(url, route, opts) {
    var reg = /(?:\?([^#]*))?(#.*)?$/, c = url.match(reg), matches = {}, ret;
    if (c && c[1]) {
        var p = c[1].split("&");
        for(var i = 0; i < p.length; i++){
            var r = p[i].split("=");
            matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join("="));
        }
    }
    url = $ea0dbf761ed9dde7$var$segmentize(url.replace(reg, ""));
    route = $ea0dbf761ed9dde7$var$segmentize(route || "");
    var max = Math.max(url.length, route.length);
    for(var i$1 = 0; i$1 < max; i$1++){
        if (route[i$1] && route[i$1].charAt(0) === ":") {
            var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ""), flags = (route[i$1].match(/[+*?]+$/) || $ea0dbf761ed9dde7$var$EMPTY$1)[0] || "", plus = ~flags.indexOf("+"), star = ~flags.indexOf("*"), val = url[i$1] || "";
            if (!val && !star && (flags.indexOf("?") < 0 || plus)) {
                ret = false;
                break;
            }
            matches[param] = decodeURIComponent(val);
            if (plus || star) {
                matches[param] = url.slice(i$1).map(decodeURIComponent).join("/");
                break;
            }
        } else if (route[i$1] !== url[i$1]) {
            ret = false;
            break;
        }
    }
    if (opts.default !== true && ret === false) return false;
    return matches;
}
function $ea0dbf761ed9dde7$var$pathRankSort(a, b) {
    return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}
// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function $ea0dbf761ed9dde7$var$prepareVNodeForRanking(vnode, index) {
    vnode.index = index;
    vnode.rank = $ea0dbf761ed9dde7$var$rankChild(vnode);
    return vnode.attributes;
}
function $ea0dbf761ed9dde7$var$segmentize(url) {
    return url.replace(/(^\/+|\/+$)/g, "").split("/");
}
function $ea0dbf761ed9dde7$var$rankSegment(segment) {
    return segment.charAt(0) == ":" ? 1 + "*+?".indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}
function $ea0dbf761ed9dde7$var$rank(path) {
    return $ea0dbf761ed9dde7$var$segmentize(path).map($ea0dbf761ed9dde7$var$rankSegment).join("");
}
function $ea0dbf761ed9dde7$var$rankChild(vnode) {
    return vnode.attributes.default ? 0 : $ea0dbf761ed9dde7$var$rank(vnode.attributes.path);
}
var $ea0dbf761ed9dde7$var$customHistory = null;
var $ea0dbf761ed9dde7$var$ROUTERS = [];
var $ea0dbf761ed9dde7$export$bae87ececa397a84 = [];
var $ea0dbf761ed9dde7$var$EMPTY = {};
function $ea0dbf761ed9dde7$var$isPreactElement(node) {
    return node.__preactattr_ != null || typeof Symbol !== "undefined" && node[Symbol.for("preactattr")] != null;
}
function $ea0dbf761ed9dde7$var$setUrl(url, type) {
    if (type === void 0) type = "push";
    if ($ea0dbf761ed9dde7$var$customHistory && $ea0dbf761ed9dde7$var$customHistory[type]) $ea0dbf761ed9dde7$var$customHistory[type](url);
    else if (typeof history !== "undefined" && history[type + "State"]) history[type + "State"](null, null, url);
}
function $ea0dbf761ed9dde7$export$dc90482e4ef07afd() {
    var url;
    if ($ea0dbf761ed9dde7$var$customHistory && $ea0dbf761ed9dde7$var$customHistory.location) url = $ea0dbf761ed9dde7$var$customHistory.location;
    else if ($ea0dbf761ed9dde7$var$customHistory && $ea0dbf761ed9dde7$var$customHistory.getCurrentLocation) url = $ea0dbf761ed9dde7$var$customHistory.getCurrentLocation();
    else url = typeof location !== "undefined" ? location : $ea0dbf761ed9dde7$var$EMPTY;
    return "" + (url.pathname || "") + (url.search || "");
}
function $ea0dbf761ed9dde7$export$4cb887bfde2d34ca(url, replace) {
    if (replace === void 0) replace = false;
    if (typeof url !== "string" && url.url) {
        replace = url.replace;
        url = url.url;
    }
    // only push URL into history if we can handle it
    if ($ea0dbf761ed9dde7$var$canRoute(url)) $ea0dbf761ed9dde7$var$setUrl(url, replace ? "replace" : "push");
    return $ea0dbf761ed9dde7$var$routeTo(url);
}
/** Check if the given URL can be handled by any router instances. */ function $ea0dbf761ed9dde7$var$canRoute(url) {
    for(var i = $ea0dbf761ed9dde7$var$ROUTERS.length; i--;){
        if ($ea0dbf761ed9dde7$var$ROUTERS[i].canRoute(url)) return true;
    }
    return false;
}
/** Tell all router instances to handle the given URL.  */ function $ea0dbf761ed9dde7$var$routeTo(url) {
    var didRoute = false;
    for(var i = 0; i < $ea0dbf761ed9dde7$var$ROUTERS.length; i++)if ($ea0dbf761ed9dde7$var$ROUTERS[i].routeTo(url) === true) didRoute = true;
    for(var i$1 = $ea0dbf761ed9dde7$export$bae87ececa397a84.length; i$1--;)$ea0dbf761ed9dde7$export$bae87ececa397a84[i$1](url);
    return didRoute;
}
function $ea0dbf761ed9dde7$var$routeFromLink(node) {
    // only valid elements
    if (!node || !node.getAttribute) return;
    var href = node.getAttribute("href"), target = node.getAttribute("target");
    // ignore links with targets and non-path URLs
    if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) return;
    // attempt to route, if no match simply cede control to browser
    return $ea0dbf761ed9dde7$export$4cb887bfde2d34ca(href);
}
function $ea0dbf761ed9dde7$var$handleLinkClick(e) {
    if (e.button == 0) {
        $ea0dbf761ed9dde7$var$routeFromLink(e.currentTarget || e.target || this);
        return $ea0dbf761ed9dde7$var$prevent(e);
    }
}
function $ea0dbf761ed9dde7$var$prevent(e) {
    if (e) {
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        if (e.stopPropagation) e.stopPropagation();
        e.preventDefault();
    }
    return false;
}
function $ea0dbf761ed9dde7$var$delegateLinkHandler(e) {
    // ignore events the browser takes care of already:
    if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) return;
    var t = e.target;
    do if (String(t.nodeName).toUpperCase() === "A" && t.getAttribute("href") && $ea0dbf761ed9dde7$var$isPreactElement(t)) {
        if (t.hasAttribute("native")) return;
        // if link is handled by the router, prevent browser defaults
        if ($ea0dbf761ed9dde7$var$routeFromLink(t)) return $ea0dbf761ed9dde7$var$prevent(e);
    }
    while (t = t.parentNode);
}
var $ea0dbf761ed9dde7$var$eventListenersInitialized = false;
function $ea0dbf761ed9dde7$var$initEventListeners() {
    if ($ea0dbf761ed9dde7$var$eventListenersInitialized) return;
    if (typeof addEventListener === "function") {
        if (!$ea0dbf761ed9dde7$var$customHistory) addEventListener("popstate", function() {
            $ea0dbf761ed9dde7$var$routeTo($ea0dbf761ed9dde7$export$dc90482e4ef07afd());
        });
        addEventListener("click", $ea0dbf761ed9dde7$var$delegateLinkHandler);
    }
    $ea0dbf761ed9dde7$var$eventListenersInitialized = true;
}
var $ea0dbf761ed9dde7$export$55185c17a0fcbe46 = function(Component$$1) {
    function Router(props) {
        Component$$1.call(this, props);
        if (props.history) $ea0dbf761ed9dde7$var$customHistory = props.history;
        this.state = {
            url: props.url || $ea0dbf761ed9dde7$export$dc90482e4ef07afd()
        };
        $ea0dbf761ed9dde7$var$initEventListeners();
    }
    if (Component$$1) Router.__proto__ = Component$$1;
    Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
    Router.prototype.constructor = Router;
    Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (props.static !== true) return true;
        return props.url !== this.props.url || props.onChange !== this.props.onChange;
    };
    /** Check if the given URL can be matched against any children */ Router.prototype.canRoute = function canRoute(url) {
        return this.getMatchingChildren(this.props.children, url, false).length > 0;
    };
    /** Re-render children with a new URL to match against. */ Router.prototype.routeTo = function routeTo(url) {
        this._didRoute = false;
        this.setState({
            url: url
        });
        // if we're in the middle of an update, don't synchronously re-route.
        if (this.updating) return this.canRoute(url);
        this.forceUpdate();
        return this._didRoute;
    };
    Router.prototype.componentWillMount = function componentWillMount() {
        $ea0dbf761ed9dde7$var$ROUTERS.push(this);
        this.updating = true;
    };
    Router.prototype.componentDidMount = function componentDidMount() {
        var this$1 = this;
        if ($ea0dbf761ed9dde7$var$customHistory) this.unlisten = $ea0dbf761ed9dde7$var$customHistory.listen(function(location1) {
            this$1.routeTo("" + (location1.pathname || "") + (location1.search || ""));
        });
        this.updating = false;
    };
    Router.prototype.componentWillUnmount = function componentWillUnmount() {
        if (typeof this.unlisten === "function") this.unlisten();
        $ea0dbf761ed9dde7$var$ROUTERS.splice($ea0dbf761ed9dde7$var$ROUTERS.indexOf(this), 1);
    };
    Router.prototype.componentWillUpdate = function componentWillUpdate() {
        this.updating = true;
    };
    Router.prototype.componentDidUpdate = function componentDidUpdate() {
        this.updating = false;
    };
    Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
        return children.filter($ea0dbf761ed9dde7$var$prepareVNodeForRanking).sort($ea0dbf761ed9dde7$var$pathRankSort).map(function(vnode) {
            var matches = $ea0dbf761ed9dde7$var$exec(url, vnode.attributes.path, vnode.attributes);
            if (matches) {
                if (invoke !== false) {
                    var newProps = {
                        url: url,
                        matches: matches
                    };
                    $ea0dbf761ed9dde7$var$assign(newProps, matches);
                    delete newProps.ref;
                    delete newProps.key;
                    return (0, $LjoDx.cloneElement)(vnode, newProps);
                }
                return vnode;
            }
        }).filter(Boolean);
    };
    Router.prototype.render = function render(ref, ref$1) {
        var children = ref.children;
        var onChange = ref.onChange;
        var url = ref$1.url;
        var active = this.getMatchingChildren(children, url, true);
        var current = active[0] || null;
        this._didRoute = !!current;
        var previous = this.previousUrl;
        if (url !== previous) {
            this.previousUrl = url;
            if (typeof onChange === "function") onChange({
                router: this,
                url: url,
                previous: previous,
                active: active,
                current: current
            });
        }
        return current;
    };
    return Router;
}((0, $LjoDx.Component));
var $ea0dbf761ed9dde7$export$a6c7ac8248d6e38a = function(props) {
    return (0, $LjoDx.h)("a", $ea0dbf761ed9dde7$var$assign({
        onClick: $ea0dbf761ed9dde7$var$handleLinkClick
    }, props));
};
var $ea0dbf761ed9dde7$export$e7b0ac011bb776c6 = function(props) {
    return (0, $LjoDx.h)(props.component, props);
};
$ea0dbf761ed9dde7$export$55185c17a0fcbe46.subscribers = $ea0dbf761ed9dde7$export$bae87ececa397a84;
$ea0dbf761ed9dde7$export$55185c17a0fcbe46.getCurrentUrl = $ea0dbf761ed9dde7$export$dc90482e4ef07afd;
$ea0dbf761ed9dde7$export$55185c17a0fcbe46.route = $ea0dbf761ed9dde7$export$4cb887bfde2d34ca;
$ea0dbf761ed9dde7$export$55185c17a0fcbe46.Router = $ea0dbf761ed9dde7$export$55185c17a0fcbe46;
$ea0dbf761ed9dde7$export$55185c17a0fcbe46.Route = $ea0dbf761ed9dde7$export$e7b0ac011bb776c6;
$ea0dbf761ed9dde7$export$55185c17a0fcbe46.Link = $ea0dbf761ed9dde7$export$a6c7ac8248d6e38a;
var $ea0dbf761ed9dde7$export$2e2bcd8739ae039 = $ea0dbf761ed9dde7$export$55185c17a0fcbe46;



var $LjoDx = parcelRequire("LjoDx");
var $0c2ffb8529973f6f$exports = {};

$parcel$export($0c2ffb8529973f6f$exports, "Navbar", () => $0c2ffb8529973f6f$export$42cfbb80f7861e77);

var $LjoDx = parcelRequire("LjoDx");



var $0c2ffb8529973f6f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0c2ffb8529973f6f$export$42cfbb80f7861e77 = /** @class */ function(_super) {
    $0c2ffb8529973f6f$var$__extends(Navbar, _super);
    function Navbar(props) {
        var _this = _super.call(this, props) || this;
        _this.onMenuButtonClicked = function() {
            _this.props.sidenavMenuCallback();
        };
        _this.onLogout = function() {
            (0, $364b9d08877d223b$export$2e2bcd8739ae039)().dispatch({
                type: (0, $4c71eb74f53637d3$export$35e541d26a145a7c)
            });
        };
        _this.onSubmitRemit = function() {
            (0, $ea0dbf761ed9dde7$export$4cb887bfde2d34ca)("/remittance/submit");
        };
        return _this;
    }
    Navbar.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "anglo-navbar"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-navbar__contents"
        }, (0, $LjoDx.h)("div", {
            class: "container-fluid h-100"
        }, (0, $LjoDx.h)("div", {
            class: "row h-100 align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-2 d-xl-none anglo-navbar__burger-menu d-flex justify-content-center"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-icon",
            onClick: this.onMenuButtonClicked
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-bars"
        }))), (0, $LjoDx.h)("div", {
            class: "col-4 col-xl-2 anglo-navbar__logo"
        }, (0, $LjoDx.h)("img", {
            src: "/assets/aatcLogo.jpg",
            alt: ""
        })), (0, $LjoDx.h)("div", {
            class: "\n                  col-6 col-xl-4 offset-xl-6 \n                  anglo-navbar__post-property \n                  d-flex justify-content-center\n                  d-md-flex justify-content-md-end\n                "
        }, (0, $LjoDx.h)("button", {
            class: "d-none d-md-block btn btn-light mr-3",
            onClick: this.onLogout
        }, "Logout"), (0, $LjoDx.h)("button", {
            class: "btn btn-primary",
            onClick: this.onSubmitRemit
        }, "Submit a Remittance"))))), (0, $LjoDx.h)("div", {
            class: "anglo-navbar__padding"
        }));
    };
    return Navbar;
}((0, $LjoDx.Component));


var $8f5e6c1f64b6d302$exports = {};

$parcel$export($8f5e6c1f64b6d302$exports, "AngloDashboard", () => $8f5e6c1f64b6d302$export$3d27f75ccb427347);

var $LjoDx = parcelRequire("LjoDx");
var $942dea15bc973271$exports = {};

$parcel$export($942dea15bc973271$exports, "DataDisplayWidget", () => $942dea15bc973271$export$8716752205022318);

var $LjoDx = parcelRequire("LjoDx");
function $9e0c3e3a397653e5$export$63ad841d70774900(value) {
    return "".concat(value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
}
function $9e0c3e3a397653e5$export$a81f732198733497(value) {
    return "".concat(value.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
}


var $942dea15bc973271$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
// It's called DataDisplay even though most of what is shows is comparison
// between the broker's average and the top 20 others
// because it's preferred to have this more usable
var $942dea15bc973271$export$8716752205022318 = /** @class */ function(_super) {
    $942dea15bc973271$var$__extends(DataDisplayWidget, _super);
    function DataDisplayWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.setState({
            name: props.name,
            data1: props.data1,
            data1Label: props.data1Label,
            data2: props.data2,
            data2Label: props.data2Label
        });
        return _this;
    }
    DataDisplayWidget.prototype.getComingSoonBlock = function(props) {
        if (props.isComingSoon) return (0, $LjoDx.h)("div", {
            class: "anglo-data-display-widget__coming-soon"
        }, (0, $LjoDx.h)("h4", {
            class: "anglo-data-display-widget__coming-soon__h4"
        }, "Feature coming soon"));
    };
    DataDisplayWidget.prototype.getExternalLinkBlock = function(props) {
        if (props.externalLink) return (0, $LjoDx.h)("a", {
            href: props.externalLink,
            class: "anglo-data-display-widget__external-link"
        }, "See details ", (0, $LjoDx.h)("i", {
            class: "fas fa-chevron-right"
        }));
    };
    DataDisplayWidget.prototype.getChangeAmountBlock = function(props) {
        if (props.changeAmount) {
            if (props.isChangePositive) return (0, $LjoDx.h)("span", {
                class: "anglo-data-display-widget__change-amount green"
            }, "+ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(props.changeAmount), " ", (0, $LjoDx.h)("i", {
                class: "fas fa-arrow-up"
            }));
            else return (0, $LjoDx.h)("span", {
                class: "anglo-data-display-widget__change-amount red"
            }, (0, $9e0c3e3a397653e5$export$a81f732198733497)(props.changeAmount), " ", (0, $LjoDx.h)("i", {
                class: "fas fa-arrow-down"
            }));
        }
    };
    DataDisplayWidget.prototype.getSecondDataBlock = function(state) {
        if (state.data2) return (0, $LjoDx.h)("div", {
            class: "col-12 anglo-data-display-widget__data pt-3"
        }, (0, $LjoDx.h)("h4", {
            class: "anglo-data-display-widget__data__amount"
        }, state.data2), (0, $LjoDx.h)("p", {
            class: "anglo-data-display-widget__data__label"
        }, state.data2Label));
    };
    DataDisplayWidget.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "anglo-data-display-widget"
        }, this.getComingSoonBlock(props), (0, $LjoDx.h)("div", {
            class: "row no-gutters"
        }, (0, $LjoDx.h)("div", {
            class: "col-8 anglo-data-display-widget__name"
        }, state.name, " ", this.getChangeAmountBlock(props)), (0, $LjoDx.h)("div", {
            class: "col-4 d-flex justify-content-end"
        }, this.getExternalLinkBlock(props))), (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col anglo-data-display-widget__data first mb-3"
        }, (0, $LjoDx.h)("h4", {
            class: "anglo-data-display-widget__data__amount"
        }, state.data1), (0, $LjoDx.h)("p", {
            class: "anglo-data-display-widget__data__label"
        }, state.data1Label)), this.getSecondDataBlock(state)));
    };
    return DataDisplayWidget;
}((0, $LjoDx.Component));







var $79e51595f8ff96f0$exports = {};

$parcel$export($79e51595f8ff96f0$exports, "AgentListWidget", () => $79e51595f8ff96f0$export$64e5dc868440d00);

var $LjoDx = parcelRequire("LjoDx");

var $79e51595f8ff96f0$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $79e51595f8ff96f0$export$64e5dc868440d00 = /** @class */ function(_super) {
    $79e51595f8ff96f0$var$__extends(AgentListWidget, _super);
    function AgentListWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleCollapsable = function() {
            _this.setState({
                isCollapseVisible: !_this.state.isCollapseVisible
            });
        };
        _this.setState({
            agents: props.agents
        });
        return _this;
    }
    AgentListWidget.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "hi-broker-leaderboard-widget widget-collapsable"
        }, (0, $LjoDx.h)("div", {
            class: "row widget-collapsable__toggle-row"
        }, (0, $LjoDx.h)("div", {
            class: "col-10"
        }, (0, $LjoDx.h)("h4", {
            class: "hi-broker-leaderboard-widget__name"
        }, "Agent List")), (0, $LjoDx.h)("div", {
            class: "col-2 d-md-none"
        }, (0, $LjoDx.h)("i", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("fas fa-chevron-down", {
                "visible": state.isCollapseVisible
            }),
            onClick: this.toggleCollapsable
        }))), (0, $LjoDx.h)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("widget-collapsable__body", {
                "visible": state.isCollapseVisible
            })
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("p", {
            class: "hi-broker-leaderboard-widget__desc"
        }, "All your agents"))), (0, $LjoDx.h)("div", {
            class: "row hi-broker-leaderboard-widget__broker-list mt-4"
        }, state.agents.map(function(agent, index) {
            return (0, $LjoDx.h)("div", {
                class: "col-12 hi-broker-leaderboard-widget__broker mb-4"
            }, (0, $LjoDx.h)("div", {
                class: "hi-broker-leaderboard-widget__broker__img"
            }), (0, $LjoDx.h)("div", {
                class: "hi-broker-leaderboard-widget__broker__details"
            }, (0, $LjoDx.h)("p", {
                class: "hi-broker-leaderboard-widget__broker__name"
            }, agent.firstName, " ", agent.lastName), (0, $LjoDx.h)("p", {
                class: "hi-broker-leaderboard-widget__broker__counts"
            }, (0, $LjoDx.h)("span", {
                class: "hi-broker-leaderboard-widget__broker__counts__inquiry"
            }, agent.isActive ? "Active" : "Offline"))), (0, $LjoDx.h)("div", {
                class: "hi-broker-leaderboard-widget__broker__placement"
            }, (0, $LjoDx.h)("div", {
                class: "hi-broker-leaderboard-widget__broker__placement__badge ".concat(!agent.isActive ? "offline" : "")
            }, index + 1)));
        }))));
    };
    return AgentListWidget;
}((0, $LjoDx.Component));



const $8fe02efeca48d35b$export$42554a643c5ad5e4 = [
    `The cutoff for remittances is 9pm on week days. Remittances uploaded on a weekend will be
  processed the following monday.`,
    `Always double check the amount you remit.`,
    `In case of errors, you may request your remittances to be editted.`
];


var $8f5e6c1f64b6d302$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8f5e6c1f64b6d302$export$3d27f75ccb427347 = /** @class */ function(_super) {
    $8f5e6c1f64b6d302$var$__extends(AngloDashboard, _super);
    function AngloDashboard(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.setState({
            currentTipIndex: 0
        });
        _this.setupTipInterval();
        return _this;
    }
    AngloDashboard.prototype.coinFlip = function() {
        var num = Math.floor(Math.random() * 10);
        return num % 2 == 0;
    };
    AngloDashboard.prototype.setupTipInterval = function() {
        var _this = this;
        setInterval(function() {
            var index = _this.state.currentTipIndex;
            if (index < (0, $8fe02efeca48d35b$export$42554a643c5ad5e4).length - 1) _this.setState({
                currentTipIndex: index + 1
            });
            else _this.setState({
                currentTipIndex: 0
            });
        }, 5000);
    };
    AngloDashboard.prototype.componentDidMount = function() {
        var _this = this;
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.user;
        }));
        this.subs.push(user$.subscribe(function(user) {
            if (user.agents) _this.setState({
                agents: user.agents
            });
        }));
        var remittance$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.remittance;
        }));
        // set overall Total
        this.subs.push(remittance$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(remittance) {
            return remittance.overallTotal;
        })).subscribe(function(overallTotal) {
            _this.setState({
                overallTotal: overallTotal
            });
        }));
        // set curMonth Total
        this.subs.push(remittance$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(remittance) {
            return remittance.currentMonthTotal;
        })).subscribe(function(currentMonthTotal) {
            _this.setState({
                currentMonthTotal: currentMonthTotal
            });
        }));
        // set previousMonthTotal Total
        this.subs.push(remittance$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(remittance) {
            return remittance.previousMonthTotal;
        })).subscribe(function(previousMonthTotal) {
            _this.setState({
                previousMonthTotal: previousMonthTotal
            });
        }));
        this.initialStoreDispatches();
    };
    AngloDashboard.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $ea864d6f3cd9447e$export$e82cebb195cca37c),
            payload: {
                filters: {
                    page: 1
                }
            }
        });
        store.dispatch({
            type: (0, $ea864d6f3cd9447e$export$ac8ddd8847849ab)
        });
        store.dispatch({
            type: (0, $ea864d6f3cd9447e$export$6846fb968bdf775b)
        });
        store.dispatch({
            type: (0, $4c71eb74f53637d3$export$dfa3dd78ac296cf2)
        });
        store.dispatch({
            type: (0, $7859e0852b06702e$export$6d686d51d5c3c8d0),
            payload: {
                filters: {
                    page: 1
                }
            }
        });
    };
    AngloDashboard.prototype.getOverallTotalBlock = function(state) {
        if (state.overallTotal) return (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6"
        }, (0, $LjoDx.h)((0, $942dea15bc973271$exports.DataDisplayWidget), {
            name: "Overall Total",
            data1: "₱ ".concat((0, $9e0c3e3a397653e5$export$63ad841d70774900)(state.overallTotal.total)),
            data1Label: "Total Remitted Amount (Overall)",
            data2: state.overallTotal.count,
            data2Label: "Number of Remittances Submitted (Overall)"
        }));
    };
    AngloDashboard.prototype.getMonthAmountBlock = function(state) {
        if (state.currentMonthTotal && state.previousMonthTotal) {
            var change = state.currentMonthTotal.total - state.previousMonthTotal.total;
            var isPos = state.currentMonthTotal.total > state.previousMonthTotal.total;
            return (0, $LjoDx.h)("div", {
                class: "col-12 col-md-6 col-md-6 mt-4 mt-md-0"
            }, (0, $LjoDx.h)((0, $942dea15bc973271$exports.DataDisplayWidget), {
                name: "Monthly Amount",
                data1: "₱ ".concat((0, $9e0c3e3a397653e5$export$63ad841d70774900)(state.currentMonthTotal.total)),
                data1Label: "Total Remitted Amount (Current Month)",
                data2: "₱ ".concat((0, $9e0c3e3a397653e5$export$63ad841d70774900)(state.previousMonthTotal.total)),
                data2Label: "Total Remitted Amount (Previous Month)",
                changeAmount: change,
                isChangePositive: isPos
            }));
        }
    };
    AngloDashboard.prototype.getMonthCountBlock = function(state) {
        if (state.currentMonthTotal && state.previousMonthTotal) {
            var change = state.currentMonthTotal.count - state.previousMonthTotal.count;
            var isPos = state.currentMonthTotal.count > state.previousMonthTotal.count;
            return (0, $LjoDx.h)("div", {
                class: "col-12 col-md-6 col-md-6 mt-4 mt-md-0"
            }, (0, $LjoDx.h)((0, $942dea15bc973271$exports.DataDisplayWidget), {
                name: "Monthly Count",
                data1: state.currentMonthTotal.count,
                data1Label: "Number of Remittances Submitted (Current Month)",
                data2: state.previousMonthTotal.count,
                data2Label: "Number of Remittances Submitted (Previous Month)",
                changeAmount: change,
                isChangePositive: isPos
            }));
        }
    };
    AngloDashboard.prototype.getSomethingBlock = function(state) {
        if (state.currentMonthTotal && state.previousMonthTotal) return (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 col-md-6 mt-4 mt-md-0"
        }, (0, $LjoDx.h)((0, $942dea15bc973271$exports.DataDisplayWidget), {
            isComingSoon: true,
            name: "Average Something",
            data1: 123,
            data1Label: "Number of Average Something",
            data2: 123,
            data2Label: "Number of Average Something Top 20"
        }));
    };
    AngloDashboard.prototype.getAgentsBlock = function(state) {
        if (state.agents && state.agents.length > 0) return (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 col-lg-12"
        }, (0, $LjoDx.h)((0, $79e51595f8ff96f0$exports.AgentListWidget), {
            agents: state.agents
        }));
    };
    AngloDashboard.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "anglo__dashboard"
        }, (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-8 col-lg-4"
        }, (0, $LjoDx.h)("nav", {
            "aria-label": "breadcrumb"
        }, (0, $LjoDx.h)("ol", {
            class: "breadcrumb"
        }, (0, $LjoDx.h)("li", {
            class: "breadcrumb-item"
        }, (0, $LjoDx.h)("a", {
            href: "#"
        }, "Dashboard"))))), (0, $LjoDx.h)("div", {
            class: "col-4 col-lg-2 offset-lg-6 d-flex justify-content-end align-items-center"
        }, (0, $LjoDx.h)("a", {
            class: "anglo__dashboard__faq",
            href: "#"
        }))), (0, $LjoDx.h)("div", {
            class: "row mt-4"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "anglo__dashboard__tips mt-2"
        }, "Tips:", (0, $LjoDx.h)("span", {
            class: "ml-2"
        }, (0, $8fe02efeca48d35b$export$42554a643c5ad5e4)[state.currentTipIndex])))), (0, $LjoDx.h)("div", {
            class: "row mt-5"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-12 anglo__dashboard__widget-column"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, this.getOverallTotalBlock(state), this.getSomethingBlock(state)), (0, $LjoDx.h)("div", {
            class: "row mt-4 mt-xl-5"
        }, this.getMonthAmountBlock(state), this.getMonthCountBlock(state))))));
    };
    return AngloDashboard;
}((0, $LjoDx.Component));


var $ecac5cf7ec1afbdd$exports = {};

$parcel$export($ecac5cf7ec1afbdd$exports, "PreactTester", () => $ecac5cf7ec1afbdd$export$782370ecc45e47c8);

var $LjoDx = parcelRequire("LjoDx");
var $ecac5cf7ec1afbdd$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ecac5cf7ec1afbdd$export$782370ecc45e47c8 = /** @class */ function(_super) {
    $ecac5cf7ec1afbdd$var$__extends(PreactTester, _super);
    function PreactTester() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PreactTester.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", null, (0, $LjoDx.h)("h3", null, "This is for testing preact components.", (0, $LjoDx.h)("div", {
            class: "mb-5"
        })));
    };
    return PreactTester;
}((0, $LjoDx.Component));





var $388f15e0b6245f4f$exports = {};

$parcel$export($388f15e0b6245f4f$exports, "SubmitRemittance", () => $388f15e0b6245f4f$export$1dcc0f3997c9bb0f);

var $LjoDx = parcelRequire("LjoDx");

var $80e1c1c28a093336$exports = {};

(function(global, factory) {
    $80e1c1c28a093336$exports = factory((parcelRequire("LjoDx")));
})($80e1c1c28a093336$exports, function(preact) {
    "use strict";
    var asyncGenerator = function() {
        function AwaitValue(value) {
            this.value = value;
        }
        function AsyncGenerator(gen) {
            var front, back;
            function send(key, arg) {
                return new Promise(function(resolve, reject) {
                    var request = {
                        key: key,
                        arg: arg,
                        resolve: resolve,
                        reject: reject,
                        next: null
                    };
                    if (back) back = back.next = request;
                    else {
                        front = back = request;
                        resume(key, arg);
                    }
                });
            }
            function resume(key, arg) {
                try {
                    var result = gen[key](arg);
                    var value = result.value;
                    if (value instanceof AwaitValue) Promise.resolve(value.value).then(function(arg) {
                        resume("next", arg);
                    }, function(arg) {
                        resume("throw", arg);
                    });
                    else settle(result.done ? "return" : "normal", result.value);
                } catch (err) {
                    settle("throw", err);
                }
            }
            function settle(type, value) {
                switch(type){
                    case "return":
                        front.resolve({
                            value: value,
                            done: true
                        });
                        break;
                    case "throw":
                        front.reject(value);
                        break;
                    default:
                        front.resolve({
                            value: value,
                            done: false
                        });
                        break;
                }
                front = front.next;
                if (front) resume(front.key, front.arg);
                else back = null;
            }
            this._invoke = send;
            if (typeof gen.return !== "function") this.return = undefined;
        }
        if (typeof Symbol === "function" && Symbol.asyncIterator) AsyncGenerator.prototype[Symbol.asyncIterator] = function() {
            return this;
        };
        AsyncGenerator.prototype.next = function(arg) {
            return this._invoke("next", arg);
        };
        AsyncGenerator.prototype.throw = function(arg) {
            return this._invoke("throw", arg);
        };
        AsyncGenerator.prototype.return = function(arg) {
            return this._invoke("return", arg);
        };
        return {
            wrap: function(fn) {
                return function() {
                    return new AsyncGenerator(fn.apply(this, arguments));
                };
            },
            await: function(value) {
                return new AwaitValue(value);
            }
        };
    }();
    var classCallCheck = function(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
    var inherits = function(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    };
    var possibleConstructorReturn = function(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    };
    var Portal = function(_Component) {
        inherits(Portal, _Component);
        function Portal() {
            classCallCheck(this, Portal);
            return possibleConstructorReturn(this, _Component.apply(this, arguments));
        }
        Portal.prototype.componentDidUpdate = function componentDidUpdate(props) {
            for(var i in props){
                if (props[i] !== this.props[i]) return setTimeout(this.renderLayer);
            }
        };
        Portal.prototype.componentDidMount = function componentDidMount() {
            this.isMounted = true;
            this.renderLayer = this.renderLayer.bind(this);
            this.renderLayer();
        };
        Portal.prototype.componentWillUnmount = function componentWillUnmount() {
            this.renderLayer(false);
            this.isMounted = false;
            if (this.remote) this.remote.parentNode.removeChild(this.remote);
        };
        Portal.prototype.findNode = function findNode(node) {
            return typeof node === "string" ? document.querySelector(node) : node;
        };
        Portal.prototype.renderLayer = function renderLayer() {
            var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            if (!this.isMounted) return;
            if (this.props.into !== this.intoPointer) {
                this.intoPointer = this.props.into;
                if (this.into && this.remote) this.remote = preact.render(preact.h(PortalProxy, null), this.into, this.remote);
                this.into = this.findNode(this.props.into);
            }
            this.remote = preact.render(preact.h(PortalProxy, {
                context: this.context
            }, show && this.props.children || null), this.into, this.remote);
        };
        Portal.prototype.render = function render() {
            return null;
        };
        return Portal;
    }(preact.Component);
    var PortalProxy = function(_Component2) {
        inherits(PortalProxy, _Component2);
        function PortalProxy() {
            classCallCheck(this, PortalProxy);
            return possibleConstructorReturn(this, _Component2.apply(this, arguments));
        }
        PortalProxy.prototype.getChildContext = function getChildContext() {
            return this.props.context;
        };
        PortalProxy.prototype.render = function render(_ref) {
            var children = _ref.children;
            return children && children[0] || null;
        };
        return PortalProxy;
    }(preact.Component);
    return Portal;
});


var $8f0643c1e1a747fe$exports = {};

var $8f0643c1e1a747fe$var$moment = $8f0643c1e1a747fe$exports = (parcelRequire("bCVnn"));

$8f0643c1e1a747fe$var$moment.tz.load((parcelRequire("iNtn6")));







var $beda7ca2e1efa502$exports = {};

$parcel$export($beda7ca2e1efa502$exports, "DatePicker", () => $beda7ca2e1efa502$export$5109c6dd95d8fb00);

var $LjoDx = parcelRequire("LjoDx");



var $beda7ca2e1efa502$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
"date-picker";
var $beda7ca2e1efa502$export$5109c6dd95d8fb00 = /** @class */ function(_super) {
    $beda7ca2e1efa502$var$__extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.reset = function() {
            _this.setState({
                selectedDate: ""
            });
            _this.clearCalendar();
        };
        _this.checkClick = function(event) {
            if (!_this.node.contains(event.target)) _this.setState({
                isCalendarVisible: false
            });
        };
        _this.onInputFocus = function(e) {
            if (_this.props.disabled) return;
            _this.setState({
                isCalendarVisible: true
            });
        };
        // This method runs everytime a user types something 
        // on the date picker input. We only call state change
        // when the e.target.value's length is 0
        _this.onInputChange = function(e) {
            var inputValue = e.target.value;
            if (inputValue.length == 0) _this.clearCalendar();
        };
        _this.onNextMonthClicked = function(e) {
            e.preventDefault();
            var nextMonth = (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(_this.state.currentMonth.add(1, "months"));
            _this.setupCalendarData(nextMonth);
        };
        _this.onPreviousMonthClicked = function(e) {
            e.preventDefault();
            var previousMonth = (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(_this.state.currentMonth.subtract(1, "months"));
            _this.setupCalendarData(previousMonth);
        };
        _this.onYearChange = function(e) {
            var year = e.target.value;
            var yearChanged = (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(_this.state.currentMonth);
            yearChanged.year(year);
            _this.setupCalendarData(yearChanged);
        };
        // for now, we will restrict the user to the only way 
        // to change dates is via the picker. Any typed
        // input will be ignored as we'll have to handle
        // some string -> moment parsing issues
        // onInputValueChange = (e) => {
        // }
        _this.onDateClicked = function(day, e) {
            // remove active class from all elements
            var dateElements = document.querySelectorAll(".date-picker__calendar__date");
            dateElements.forEach(function(el) {
                return el.classList.remove("active");
            });
            // set target element to have active
            var target = e.target;
            target.classList.add("active");
            var referenceDate = (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(_this.state.currentMonth);
            var selectedDate = referenceDate.date(day).format((0, $6ac96fa96dbfc52a$export$8132710d1930b03e).date);
            _this.setState({
                selectedDate: selectedDate,
                isCalendarVisible: false
            });
            if (_this.props.onDateSelected) _this.props.onDateSelected(selectedDate);
        };
        _this.setState({
            now: (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))()
        });
        if (props.min) _this.setState({
            minDate: (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(props.min, (0, $6ac96fa96dbfc52a$export$8132710d1930b03e).date)
        });
        if (props.initialValue) _this.setState({
            // selectedDate: moment(props.initialValue).format(Formats.date)
            selectedDate: (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(props.initialValue, (0, $6ac96fa96dbfc52a$export$8132710d1930b03e).date).format((0, $6ac96fa96dbfc52a$export$8132710d1930b03e).date)
        });
        else _this.setState({
            selectedDate: ""
        });
        _this.setupCalendarData();
        if (props.reset) _this.props.reset(_this.reset);
        return _this;
    }
    DatePicker.prototype.componentWillUpdate = function() {
        if (this.props.initialValue) this.setState({
            // selectedDate: moment(props.initialValue).format(Formats.date)
            selectedDate: (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(this.props.initialValue, (0, $6ac96fa96dbfc52a$export$8132710d1930b03e).date).format((0, $6ac96fa96dbfc52a$export$8132710d1930b03e).date)
        });
        else this.setState({
            selectedDate: ""
        });
    };
    DatePicker.prototype.componentDidMount = function() {
        document.addEventListener("mousedown", this.checkClick, false);
    };
    DatePicker.prototype.componentWillUnmount = function() {
        document.removeEventListener("mousedown", this.checkClick, false);
    };
    DatePicker.prototype.clearCalendar = function() {
        // remove active class from all elements
        var dateElements = document.querySelectorAll(".date-picker__calendar__date");
        dateElements.forEach(function(el) {
            return el.classList.remove("active");
        });
        this.setState({
            selectedDate: undefined,
            isCalendarVisible: false
        });
        if (this.props.onDateSelected) this.props.onDateSelected(undefined);
    };
    DatePicker.prototype.setupCalendarData = function(dateArg) {
        var calendar = [];
        var referenceMoment;
        // we use moment to create references because should the dateArg
        // be altered via add, subtract, startOf, etc, it alters
        // the original
        if (dateArg) referenceMoment = (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(dateArg);
        else referenceMoment = (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(this.state.now);
        var startOfMonth = (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(referenceMoment).startOf("month");
        var endOfMonth = (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(referenceMoment).endOf("month");
        var nextMonth = (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(referenceMoment).add(1, "months");
        var previousMonth = (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(referenceMoment).subtract(1, "months");
        for(var day = 1; day <= endOfMonth.date(); day++)calendar.push(day);
        this.setState({
            currentCalendar: calendar,
            startOfCurrentMonth: startOfMonth,
            endOfCurrentMonth: endOfMonth,
            currentMonth: referenceMoment,
            nextMonth: nextMonth,
            previousMonth: previousMonth,
            currentYear: referenceMoment.year()
        });
    };
    DatePicker.prototype.getCurrentMonthBlock = function(props, state) {
        // if currentMonth is same as minDate month, that's when you do the disabled dates
        // so we don't have to keep checking on a per date basis.
        var _this = this;
        var isMinDateSameMonth = state.currentMonth.isSameOrBefore(state.minDate, "month");
        var isCurMonthBeforeMin = state.currentMonth.isBefore(state.minDate, "month");
        var initialValueMoment;
        var initialValueDate;
        if (props.initialValue) {
            initialValueMoment = (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(this.props.initialValue, (0, $6ac96fa96dbfc52a$export$8132710d1930b03e).dateTime);
            initialValueDate = initialValueMoment.date();
        }
        if (state.minDate && isMinDateSameMonth) {
            var minDay_1 = state.minDate.date();
            if (isCurMonthBeforeMin) // auto disabled since it's before the min
            return state.currentCalendar.map(function(date) {
                return (0, $LjoDx.h)("div", {
                    class: "date-picker__calendar__date disabled"
                }, date);
            });
            else return state.currentCalendar.map(function(date) {
                return (0, $LjoDx.h)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("date-picker__calendar__date", {
                        "disabled": date < minDay_1,
                        "active": initialValueDate == date
                    }),
                    value: date,
                    onClick: _this.onDateClicked.bind(_this, date)
                }, date);
            });
        } else return state.currentCalendar.map(function(date) {
            return (0, $LjoDx.h)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("date-picker__calendar__date", {
                    "active": initialValueDate == date
                }),
                value: date,
                onClick: _this.onDateClicked.bind(_this, date)
            }, date);
        });
    };
    // a calendar has 7 columns, for the 7 days of the week
    // Sun, Mon -> Sat
    DatePicker.prototype.getCalendarBlock = function(props, state) {
        var startOfMonthDay = state.startOfCurrentMonth.day();
        var endOfPreviousMonthDay = (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(state.previousMonth).endOf("month").date();
        var daysBeforeStartOfMonth = [];
        // we start on 0 in order to push the day alignment by 1,
        // so that the sundays are on the left side of the calendar
        for(var i = 0; i < startOfMonthDay; i++)daysBeforeStartOfMonth.push(endOfPreviousMonthDay - (5 - i));
        var endOfMonthDay = state.endOfCurrentMonth.day();
        var daysAfterEndOfMonth = [];
        for(var i = 1; i <= 6 - endOfMonthDay; i++)daysAfterEndOfMonth.push(i);
        return (0, $LjoDx.h)("div", {
            class: "date-picker__calendar"
        }, // prevMonth
        daysBeforeStartOfMonth.map(function(day) {
            return (0, $LjoDx.h)("div", {
                class: "date-picker__calendar__date previous"
            }, day);
        }), this.getCurrentMonthBlock(props, state), // nextMonth
        daysAfterEndOfMonth.map(function(day) {
            return (0, $LjoDx.h)("div", {
                class: "date-picker__calendar__date previous"
            }, day);
        }));
    };
    DatePicker.prototype.render = function(props, state) {
        var _this = this;
        var erp = [];
        for(var i_1 = 2020; i_1 <= 2030; i_1++)erp.push(i_1);
        var currentyear = state.currentMonth.year();
        var pastThreeYears = [];
        var nextThreeYears = [];
        var maxYearCount = 3;
        var i = 0;
        if (props.includePastCentury) for(; i < 100; i++)pastThreeYears.push(currentyear - 100 + i);
        else for(i = 0; i < maxYearCount; i++){
            pastThreeYears.push(currentyear - (maxYearCount - i));
            nextThreeYears.push(currentyear + (i + 1));
        }
        return (0, $LjoDx.h)("div", {
            class: "date-picker",
            ref: function(node) {
                return _this.node = node;
            }
        }, (0, $LjoDx.h)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("date-picker__calendar-container", {
                "active": state.isCalendarVisible
            })
        }, (0, $LjoDx.h)("div", {
            class: "date-picker__calendar-container__control-row align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "date-picker__calendar-container__control-row__current-date"
        }, (0, $LjoDx.h)("span", {
            class: "date-picker__calendar-container__control-row__current-date__month"
        }, state.currentMonth.format("MMMM")), (0, $LjoDx.h)("span", {
            class: "date-picker__calendar-container__control-row__current-date__year"
        }, (0, $LjoDx.h)("select", {
            class: "date-picker__calendar-container__control-row__current-date__year-selector",
            onChange: this.onYearChange,
            value: state.currentYear
        }, pastThreeYears.map(function(year) {
            return (0, $LjoDx.h)("option", {
                value: year
            }, year);
        }), (0, $LjoDx.h)("option", {
            selected: true,
            value: state.currentMonth.year()
        }, state.currentMonth.year()), nextThreeYears.map(function(year) {
            return (0, $LjoDx.h)("option", {
                value: year
            }, year);
        })))), (0, $LjoDx.h)("div", {
            class: "date-picker__calendar-container__control-row__controls"
        }, (0, $LjoDx.h)("button", {
            type: "button",
            class: "btn",
            onClick: this.onPreviousMonthClicked
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-chevron-left"
        })), (0, $LjoDx.h)("button", {
            type: "button",
            class: "btn ml-1",
            onClick: this.onNextMonthClicked
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-chevron-right"
        })))), (0, $LjoDx.h)("div", {
            class: "date-picker__calendar-headers"
        }, (0, $LjoDx.h)("div", {
            class: "date-picker__calendar__date header"
        }, "Sun"), (0, $LjoDx.h)("div", {
            class: "date-picker__calendar__date header"
        }, "Mon"), (0, $LjoDx.h)("div", {
            class: "date-picker__calendar__date header"
        }, "Tue"), (0, $LjoDx.h)("div", {
            class: "date-picker__calendar__date header"
        }, "Wed"), (0, $LjoDx.h)("div", {
            class: "date-picker__calendar__date header"
        }, "Thu"), (0, $LjoDx.h)("div", {
            class: "date-picker__calendar__date header"
        }, "Fri"), (0, $LjoDx.h)("div", {
            class: "date-picker__calendar__date header"
        }, "Sat")), this.getCalendarBlock(props, state)), (0, $LjoDx.h)("div", {
            class: "date-picker__input-container",
            onClick: this.onInputFocus
        }, (0, $LjoDx.h)("input", {
            type: "text",
            disabled: props.disabled,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("date-picker__input-container__input", "form-control", {
                invalid: !props.isValid && !props.isPristine
            }),
            placeholder: props.placeholder || "Select a date",
            value: state.selectedDate,
            onFocus: this.onInputFocus,
            onInput: this.onInputChange
        }), (0, $LjoDx.h)("span", {
            class: "date-picker__input-container__icon"
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-calendar-alt"
        }))));
    };
    return DatePicker;
}((0, $LjoDx.Component));








var $eb0c70f62dd91971$exports = {};

$parcel$export($eb0c70f62dd91971$exports, "AutocompleteSector", () => $eb0c70f62dd91971$export$7b86e1146daca4b2);

var $LjoDx = parcelRequire("LjoDx");


// this function is copied from https://blog.flowandform.agency/debounce-in-react-fc5ed305a0e8
function $8cf160f30389af36$export$61fc7d43ac8f84b0(a, b, c) {
    var d, e;
    return function() {
        function h() {
            d = null, c || (e = a.apply(f, g));
        }
        var f = this, g = arguments;
        return clearTimeout(d), d = setTimeout(h, b), c && !d && (e = a.apply(f, g)), e;
    };
}




var $eb0c70f62dd91971$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $eb0c70f62dd91971$export$7b86e1146daca4b2 = /** @class */ function(_super) {
    $eb0c70f62dd91971$var$__extends(AutocompleteSector, _super);
    function AutocompleteSector(props) {
        var _this = _super.call(this, props) || this;
        _this.onSearchInputChange = (0, $8cf160f30389af36$export$61fc7d43ac8f84b0)(function(event) {
            var searchTerm = event.target.value;
            if (searchTerm && searchTerm.length >= 2) _this.getSearchResults(searchTerm);
            _this.setState({
                search: searchTerm
            });
        }, 500);
        _this.onResultClick = function(result) {
            var label = result.name;
            _this.setState({
                search: label,
                searchResults: [],
                isSearchResultsVisible: false
            });
            _this.props.onResultSelected(result);
        };
        _this.setState({
            searchResults: []
        });
        if (props.initialValue) _this.setState({
            search: props.initialValue
        });
        return _this;
    }
    AutocompleteSector.prototype.getSearchResults = function(searchTerm) {
        var _this = this;
        var params = {
            sectorName: searchTerm
        };
        var axiosPromise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/sector"), {
            params: params,
            withCredentials: true
        });
        axiosPromise.then(function(response) {
            var results = response.data.results;
            _this.setState({
                searchResults: results,
                isSearchResultsVisible: true
            });
        }).catch(function(errResp) {
            var message = errResp.response.data.msg ? errResp.response.data.msg : null;
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to retrieve search",
                message: message,
                duration: 3000
            });
        });
    };
    AutocompleteSector.prototype.render = function(props, state) {
        var _this = this;
        var result = function(member, index) {
            return (0, $LjoDx.h)("p", {
                onClick: _this.onResultClick.bind(_this, member)
            }, member.name);
        };
        return (0, $LjoDx.h)("div", {
            class: "autocomplete-search"
        }, (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("autocomplete-search__input form-control"),
            disabled: props.disabled,
            placeholder: "Search for an area/sector",
            value: state.search,
            onInput: this.onSearchInputChange.bind(this)
        }), (0, $LjoDx.h)("span", {
            class: "autocomplete-search__icon"
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-search"
        })), (0, $LjoDx.h)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("autocomplete-search__results", {
                active: state.isSearchResultsVisible
            })
        }, this.state.searchResults.map(function(member, i) {
            return result(member, i);
        })));
    };
    return AutocompleteSector;
}((0, $LjoDx.Component));


var $388f15e0b6245f4f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $388f15e0b6245f4f$export$1dcc0f3997c9bb0f = /** @class */ function(_super) {
    $388f15e0b6245f4f$var$__extends(SubmitRemittance, _super);
    function SubmitRemittance(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.handleDatepickerValidation = function(date, fieldName) {
            var currentForm = _this.state.remittanceForm;
            // Manually do this because in order to follow the 
            // hopplerLinkstate validation system
            var clonedFields = {};
            for(var k in currentForm.fields){
                var prevField = currentForm.fields[k];
                clonedFields[k] = new (0, $49e398741f5b1a93$export$a455218a85c89869)(prevField.validators, prevField.customValidators, prevField.value);
                clonedFields[k].isValid = prevField.isValid;
            }
            var clone = new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(clonedFields);
            clone.fields[fieldName].value = date;
            clone.fields[fieldName].isPristine = false;
            // clone.fields[fieldName].customValidators.forEach(a => a(clone.fields[fieldName], clone));
            _this.form$.next(clone);
        };
        _this.onDateSelected = function(date) {
            _this.handleDatepickerValidation(date, "dateOfTransaction");
        };
        _this.onSubmit = function() {
            // e.preventDefault();
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(_this.state.remittanceForm);
            if (!_this.state.remittanceForm.isValid) return;
            var form = _this.state.remittanceForm;
            // console.log('valid form');
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            var payload = {
                remittancesToUpload: _this.state.remittances
            };
            store.dispatch({
                type: (0, $ea864d6f3cd9447e$export$4f0aa2f7c1eac83e),
                payload: payload
            });
        };
        _this.onAddRemittance = function() {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(_this.state.remittanceForm);
            if (!_this.state.remittanceForm.isValid) return;
            var form = _this.state.remittanceForm;
            var remittance = {
                amount: Number.parseFloat(form.fields["amount"].value),
                receivingBankAccount: form.fields["bankAccount"].value,
                dateOfTransaction: form.fields["dateOfTransaction"].value,
                area: form.fields["area"].value,
                salesAgent: form.fields["salesAgent"].value
            };
            var remittances = _this.state.remittances;
            remittances.push(remittance);
            _this.setState({
                isFormVisible: false
            });
        };
        _this.onToggleForm = function() {
            //remittanceForm
            _this.setState({
                isFormVisible: !_this.state.isFormVisible
            });
        };
        _this.onEditRemittance = function(remittance, index) {
            var form = _this.state.remittanceForm;
            form.fields["dateOfTransaction"].value = remittance.dateOfTransaction;
            form.fields["amount"].value = remittance.amount;
            form.fields["bankAccount"].value = remittance.receivingBankAccount;
            form.fields["area"].value = remittance.area;
            form.fields["salesAgent"].value = remittance.salesAgent;
            _this.setState({
                isFormVisible: true,
                isEditing: true,
                currentlySelectedIndex: index
            });
        };
        _this.onRemoveRemittance = function(index) {
            var remittances = _this.state.remittances;
            remittances.splice(index, 1);
            _this.setState({
                remittances: remittances
            });
        };
        _this.onCancelEdit = function() {
            _this.setState({
                currentlySelectedIndex: -1,
                isFormVisible: false,
                isEditing: false
            });
        };
        _this.onCompleteEdit = function() {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(_this.state.remittanceForm);
            if (!_this.state.remittanceForm.isValid) return;
            var form = _this.state.remittanceForm;
            console.log("valid form");
            var remittance = {
                amount: Number.parseFloat(form.fields["amount"].value),
                receivingBankAccount: form.fields["bankAccount"].value,
                dateOfTransaction: form.fields["dateOfTransaction"].value,
                area: form.fields["area"].value,
                salesAgent: form.fields["salesAgent"].value
            };
            var remittances = _this.state.remittances;
            remittances[_this.state.currentlySelectedIndex] = remittance;
            _this.setState({
                currentlySelectedIndex: -1,
                isFormVisible: false,
                isEditing: false,
                remittances: remittances
            });
        };
        _this.onSectorSearchChange = function(sector) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.remittanceForm, "area", sector.name);
        };
        _this.setState({
            now: (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(new Date()).format((0, $6ac96fa96dbfc52a$export$8132710d1930b03e).date),
            remittances: []
        });
        // if user exists in store, redirect
        _this.createForm();
        return _this;
    }
    SubmitRemittance.prototype.componentDidMount = function() {
        var _this = this;
        var remittance$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.remittance;
        }));
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.user;
        }));
        this.subs.push(remittance$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(remittance) {
            return remittance.submitRemitState;
        })).subscribe(function(submitRemitState) {
            if (submitRemitState == (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isSubmitInProgress: true
            });
            else {
                if (submitRemitState == (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) _this.resetComponent();
                _this.setState({
                    isSubmitInProgress: false
                });
            }
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.allBankAccounts;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(allBankAccounts) {
            if (allBankAccounts) _this.setState({
                allBankAccounts: allBankAccounts
            });
        }));
        this.initialStoreDispatches();
    };
    SubmitRemittance.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $4c71eb74f53637d3$export$74d61c62c586516a),
            payload: {
                isSubmitRemit: true
            }
        });
    };
    SubmitRemittance.prototype.getStartOfMonth = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(new Date()).startOf("month").format((0, $6ac96fa96dbfc52a$export$8132710d1930b03e).date);
    };
    SubmitRemittance.prototype.getEndOfPreviousMOnth = function() {
        var date = (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(new Date()).subtract(1, "M").endOf("month").format((0, $6ac96fa96dbfc52a$export$8132710d1930b03e).date);
        return date;
    };
    SubmitRemittance.prototype.getFormattedDate = function(date) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(date).format("MMMM DD, YYYY");
    };
    SubmitRemittance.prototype.resetComponent = function() {
        this.setState({
            isSubmitLocked: true,
            isSubmitSuccess: true
        });
        setTimeout(function() {
            window.location.reload();
        }, 4000);
    // this.setState({
    //   remittanceForm : null
    // });
    // let fields: FieldList = {
    //   'bankAccount': new Field(['required'], null, ''),
    //   'amount': new Field(['required'], null, ''),
    //   'dateOfTransaction': new Field(['required'], null, ''),
    //   'area': new Field([] , null, ''),
    //   'salesAgent': new Field([] , null, ''),
    // };
    // this.setState({
    //   remittanceForm: new Form(fields)
    // });
    // this.form$.next(this.state.remittanceForm);
    };
    SubmitRemittance.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "bankAccount": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                "required"
            ], null, ""),
            "amount": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                "required"
            ], null, ""),
            "dateOfTransaction": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                "required"
            ], null, ""),
            "area": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "salesAgent": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            remittanceForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["remittanceForm"] = form;
            _this.setState(state);
        });
    };
    SubmitRemittance.prototype.getSpinnerBlock = function(state) {
        if (state.isSubmitInProgress) return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    SubmitRemittance.prototype.getSubmitBlock = function(state) {
        var form = state.remittanceForm;
        if (!state.isSubmitInProgress) return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            disabled: !form.isValid,
            onClick: this.onSubmit
        }, "Submit"));
    };
    SubmitRemittance.prototype.getOpenFormBlock = function(state) {
        if (!state.isFormVisible) return (0, $LjoDx.h)("button", {
            class: "anglo-remittance__open-form mb-3",
            onClick: this.onToggleForm
        }, "Add another remittance");
    };
    SubmitRemittance.prototype.getEditRemittanceBlock = function(state) {
        if (state.isEditing) return (0, $LjoDx.h)("div", {
            class: "col offset-md-6 d-flex justify-content-end"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-50 mr-3",
            onClick: this.onCancelEdit
        }, "Cancel"), (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-50",
            onClick: this.onCompleteEdit
        }, "Edit"));
    };
    SubmitRemittance.prototype.getAddRemittanceBlock = function(state) {
        if (!state.isEditing) return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onAddRemittance
        }, "Add Remittance"));
    };
    SubmitRemittance.prototype.getListBlock = function(state) {
        var _this = this;
        if (state.isEditing) {
            var current = state.remittances[state.currentlySelectedIndex];
            return (0, $LjoDx.h)("div", {
                class: "row anglo-remittance__list my-4"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 col-md-4 mb-3"
            }, (0, $LjoDx.h)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("anglo-remittance__list__item selected")
            }, (0, $LjoDx.h)("div", {
                class: "anglo-remittance__list__item__upper"
            }, (0, $LjoDx.h)("div", null, current.receivingBankAccount), (0, $LjoDx.h)("div", null, this.getFormattedDate(current.dateOfTransaction)), (0, $LjoDx.h)("div", null, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(current.amount))), (0, $LjoDx.h)("div", {
                class: "anglo-remittance__list__item__lower"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-remittance__list__item__detail"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-remittance__list__item__detail__label"
            }, "Area"), (0, $LjoDx.h)("div", {
                class: "anglo-remittance__list__item__detail__value"
            }, current.area ? current.area : "N/A ")), (0, $LjoDx.h)("div", {
                class: "anglo-remittance__list__item__detail"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-remittance__list__item__detail__label"
            }, "Sales Agent"), (0, $LjoDx.h)("div", {
                class: "anglo-remittance__list__item__detail__value"
            }, current.salesAgent ? current.salesAgent : "N/A "))))));
        }
        return (0, $LjoDx.h)("div", {
            class: "row anglo-remittance__list"
        }, state.remittances.map(function(member, index) {
            return (0, $LjoDx.h)("div", {
                class: "col-12 col-md-6 col-lg-4 mb-3"
            }, (0, $LjoDx.h)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("anglo-remittance__list__item", {
                    "selected": index === state.currentlySelectedIndex
                })
            }, (0, $LjoDx.h)("div", {
                class: "anglo-remittance__list__item__upper"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-outline-dark anglo-remittance__list__item__upper__close",
                onClick: function(ev) {
                    return _this.onRemoveRemittance(index);
                }
            }, (0, $LjoDx.h)("i", {
                class: "fas fa-trash"
            })), (0, $LjoDx.h)("div", null, member.receivingBankAccount), (0, $LjoDx.h)("div", null, _this.getFormattedDate(member.dateOfTransaction)), (0, $LjoDx.h)("div", null, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(member.amount))), (0, $LjoDx.h)("div", {
                class: "anglo-remittance__list__item__lower"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-remittance__list__item__detail"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-remittance__list__item__detail__label"
            }, "Area"), (0, $LjoDx.h)("div", {
                class: "anglo-remittance__list__item__detail__value"
            }, member.area ? member.area : "N/A ")), (0, $LjoDx.h)("div", {
                class: "anglo-remittance__list__item__detail"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-remittance__list__item__detail__label"
            }, "Sales Agent"), (0, $LjoDx.h)("div", {
                class: "anglo-remittance__list__item__detail__value"
            }, member.salesAgent ? member.salesAgent : "N/A "))), (0, $LjoDx.h)("button", {
                class: "anglo-remittance__list__item__action w-100",
                onClick: function(ev) {
                    return _this.onEditRemittance(member, index);
                }
            }, "Edit")));
        }), !state.isFormVisible ? (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("button", {
            class: " anglo-remittance__list__add",
            onClick: this.onToggleForm
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-plus"
        }))) : null);
    };
    SubmitRemittance.prototype.getFormBlock = function(state) {
        var form = state.remittanceForm;
        if (state.isFormVisible) return (0, $LjoDx.h)("div", {
            class: "anglo-remittance__submit-form",
            id: "remittanceForm"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Receiving Bank Account*"), (0, $LjoDx.h)("select", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["bankAccount"])
            }),
            placeholder: "Bank Account",
            value: form.fields["bankAccount"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "bankAccount")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, "Select Account"), state.allBankAccounts.map(function(acc) {
            return (0, $LjoDx.h)("option", {
                value: acc.bankAccountName
            }, acc.bankAccountName);
        }))), (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Date of Transaction*"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: this.onDateSelected,
            initialValue: form.fields["dateOfTransaction"].value,
            min: this.getEndOfPreviousMOnth(),
            isValid: form.fields["dateOfTransaction"].isValid,
            isPristine: form.fields["dateOfTransaction"].isPristine
        }))), (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Amount Remitted*"), (0, $LjoDx.h)("input", {
            type: "number",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["amount"])
            }),
            step: "0.01",
            value: state.remittanceForm.fields["amount"].value,
            placeholder: "Amount Remitted",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, state.remittanceForm, "amount")
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3 mt-lg-0"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Area"), (0, $LjoDx.h)((0, $eb0c70f62dd91971$exports.AutocompleteSector), {
            onResultSelected: this.onSectorSearchChange
        })), (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Sales Agent"), (0, $LjoDx.h)("input", {
            class: "form-control",
            type: "text",
            onInput: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "salesAgent"),
            value: form.fields["salesAgent"].value,
            placeholder: "Agent name"
        }))), (0, $LjoDx.h)("div", {
            class: "row mt-5 align-items-end"
        }, this.getSpinnerBlock(state), this.getAddRemittanceBlock(state), this.getEditRemittanceBlock(state)));
    };
    SubmitRemittance.prototype.getPortalBlock = function(state) {
        if (state.isSubmitSuccess) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
            into: "body"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-modal-container",
            id: "anglo-modal-111"
        }, (0, $LjoDx.h)("div", {
            class: "container anglo-modal"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 text-center"
        }, (0, $LjoDx.h)("h3", {
            class: "anglo-remittance__success-submit mb-3"
        }, "Successfully submitted remittances!"), (0, $LjoDx.h)("p", null, "Your remittances have been uploaded and processed in the system."), (0, $LjoDx.h)("p", null, "This page will auto reload in 3 seconds. Please wait."))))));
    };
    SubmitRemittance.prototype.render = function(props, state) {
        var form = state.remittanceForm;
        if (!state.allBankAccounts) return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
        return (0, $LjoDx.h)("div", {
            class: "anglo-remittance"
        }, (0, $LjoDx.h)("div", {
            class: "container-fluid "
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-8 col-lg-4"
        }, (0, $LjoDx.h)("nav", {
            "aria-label": "breadcrumb"
        }, (0, $LjoDx.h)("ol", {
            class: "breadcrumb"
        }, (0, $LjoDx.h)("li", {
            class: "breadcrumb-item"
        }, (0, $LjoDx.h)("a", {
            href: "/remittance"
        }, "Remittance")), (0, $LjoDx.h)("li", {
            class: "breadcrumb-item active",
            "aria-current": "page"
        }, "Submit Remittance"))))), (0, $LjoDx.h)("div", {
            class: "row mt-4"
        }, (0, $LjoDx.h)("div", {
            class: "col"
        }, this.getPortalBlock(state), this.getListBlock(state), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, this.getFormBlock(state))), (0, $LjoDx.h)("div", {
            class: "row d-md-none mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.onSubmit,
            disabled: state.remittances.length < 1
        }, "Upload Remittances")))), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3 mt-lg-0"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-remittance__right"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-remittance__reminders"
        }, (0, $LjoDx.h)("h2", {
            class: "anglo-remittance__reminders__h2"
        }, "Reminders"), (0, $LjoDx.h)("ul", {
            class: "anglo-remittance__reminders__ul"
        }, (0, $LjoDx.h)("li", {
            class: "anglo-remittance__reminders__p"
        }, "Always make sure the account number you're remitting to is correct. Double checking with your receipt is best."), (0, $LjoDx.h)("li", {
            class: "anglo-remittance__reminders__p"
        }, "You don't need to place commas in the amount field."), (0, $LjoDx.h)("li", {
            class: "anglo-remittance__reminders__p"
        }, "Ensure that the Area you are remitting from is correct."), (0, $LjoDx.h)("li", {
            class: "anglo-remittance__reminders__p"
        }, "The last day of the previous month is open for any late uploads."))), (0, $LjoDx.h)("div", {
            class: "row mt-4"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 d-none d-md-block"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.onSubmit,
            disabled: state.remittances.length < 1 || state.isSubmitLocked
        }, "Upload Remittances"))), (0, $LjoDx.h)("div", {
            class: "row mt-4"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 d-none d-md-block"
        }, this.getOpenFormBlock(state))))))));
    };
    return SubmitRemittance;
}((0, $LjoDx.Component));


var $b364e60c259a0096$exports = {};

$parcel$export($b364e60c259a0096$exports, "Sidenav", () => $b364e60c259a0096$export$40a91cd7866fd4b5);

var $LjoDx = parcelRequire("LjoDx");


const $b9c3387011d11553$export$819e975c5d2910e9 = "role_supervisor";
const $b9c3387011d11553$export$a805ed97d1d93366 = "role_auditor";
const $b9c3387011d11553$export$9cb152b3a874b8b0 = "role_vehicle-manager";
const $b9c3387011d11553$export$b38e98e302041724 = "role_management";
const $b9c3387011d11553$export$ecb30477529ca9f0 = "role_super_admin";
const $b9c3387011d11553$export$314e71fc1506697c = "role_admin-sales";
const $b9c3387011d11553$export$d1cfdc29cbc61821 = [
    "role_agent",
    "role_supervisor",
    "role_auditor",
    "role_vehicle-manager",
    "role_management",
    "role_super_admin",
    $b9c3387011d11553$export$314e71fc1506697c
];
const $b9c3387011d11553$export$b58386da8102e2ea = [
    "role_supervisor",
    "role_auditor",
    "role_vehicle-manager",
    "role_management",
    $b9c3387011d11553$export$314e71fc1506697c
];




var $b364e60c259a0096$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b364e60c259a0096$export$40a91cd7866fd4b5 = /** @class */ function(_super) {
    $b364e60c259a0096$var$__extends(Sidenav, _super);
    function Sidenav(props) {
        var _this = _super.call(this, props) || this;
        _this.onLogout = function() {
            (0, $364b9d08877d223b$export$2e2bcd8739ae039)().dispatch({
                type: (0, $4c71eb74f53637d3$export$35e541d26a145a7c)
            });
        };
        _this.isRouteActive = function(routeName) {
            var _a = _this.state.currentRoute.split("/"), blank = _a[0], first = _a[1];
            return first == routeName;
        };
        _this.canAccessLoanAndCashbondPayments = function(state) {
            if (state.isUserManagerOrAbove) return true;
            else if (state.hasSupervisorData) return true;
            else if (_this.props.currentUser.role === (0, $b9c3387011d11553$export$314e71fc1506697c)) return true;
            return false;
        };
        _this.canAccessWithdrawals = function(state) {
            if (state.isUserManagerOrAbove) return true;
            else if (state.hasSupervisorData) return true;
            else if (_this.props.currentUser.role === (0, $b9c3387011d11553$export$314e71fc1506697c)) return true;
            return false;
        };
        _this.canAccessRemittance = function(state) {
            if (_this.props.currentUser.role === (0, $b9c3387011d11553$export$819e975c5d2910e9)) return true;
            else if (state.isAuditorOrAbove) return true;
            else if (state.hasSupervisorData) return true;
            else if (_this.props.currentUser.role === (0, $b9c3387011d11553$export$314e71fc1506697c)) return false;
            else if (state.currentUser.role === (0, $b9c3387011d11553$export$9cb152b3a874b8b0)) return false;
            return false;
        };
        _this.setState({
            isSidenavVisible: props.isSidenavVisible,
            currentUser: props.currentUser,
            currentRoute: location.pathname
        });
        return _this;
    }
    Sidenav.prototype.componentWillReceiveProps = function(props, b) {
        this.setState({
            isSidenavVisible: props.isSidenavVisible,
            currentUser: props.currentUser,
            currentRoute: props.currentRoute
        });
        if (props.currentUser.role === "role_management" || props.currentUser.role === "role_super_admin") this.setState({
            isUserManagerOrAbove: true,
            isAuditorOrAbove: true
        });
        else if (props.currentUser.role === "role_auditor") this.setState({
            isUserManagerOrAbove: false,
            isAuditorOrAbove: true
        });
        else {
            this.setState({
                isUserManagerOrAbove: false,
                isAuditorOrAbove: false
            });
            if (props.currentUser.supervisor && props.currentUser.supervisor.supervisorId) this.setState({
                hasSupervisorData: true
            });
        }
    };
    Sidenav.prototype.getRole = function(state) {
        var roleName;
        switch(state.currentUser.role){
            case "role_supervisor":
                roleName = "Supervisor";
                break;
            case "role_auditor":
                roleName = "Auditor";
                break;
            case "role_management":
                roleName = "Management";
                break;
            case 0, $b9c3387011d11553$export$314e71fc1506697c:
                roleName = "Admin Sales";
                break;
        }
        return roleName;
    };
    Sidenav.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", null, (0, $LjoDx.h)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("anglo__sidenav-container", {
                visible: state.isSidenavVisible
            })
        }, (0, $LjoDx.h)("div", {
            class: "anglo__sidenav"
        }, (0, $LjoDx.h)("div", {
            class: "anglo__sidenav__user"
        }, (0, $LjoDx.h)("div", {
            class: "anglo__sidenav__user__img"
        }), (0, $LjoDx.h)("p", {
            class: "anglo__sidenav__user__name"
        }, state.currentUser.firstName, " ", state.currentUser.lastName), (0, $LjoDx.h)("p", {
            class: "anglo__sidenav__user__type"
        }, this.getRole(state))), (0, $LjoDx.h)("ul", {
            class: "anglo__sidenav__routes-list"
        }, (0, $LjoDx.h)("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("anglo__sidenav__routes-list__item", {
                active: this.isRouteActive("dashboard")
            }),
            onClick: function() {
                (0, $ea0dbf761ed9dde7$export$4cb887bfde2d34ca)("/dashboard");
            }
        }, (0, $LjoDx.h)("a", null, (0, $LjoDx.h)("i", {
            class: "fas fa-chart-line"
        }), "Dashboard")), (0, $LjoDx.h)("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("anglo__sidenav__routes-list__item", {
                active: this.isRouteActive("remittance"),
                hidden: !this.canAccessRemittance(state)
            }),
            onClick: function() {
                (0, $ea0dbf761ed9dde7$export$4cb887bfde2d34ca)("/remittance");
            }
        }, (0, $LjoDx.h)("a", null, (0, $LjoDx.h)("i", {
            class: "fas fa-money-bill-wave"
        }), "Remittances")), (0, $LjoDx.h)("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("anglo__sidenav__routes-list__item", {
                active: this.isRouteActive("cashbond-loan")
            }),
            onClick: function() {
                (0, $ea0dbf761ed9dde7$export$4cb887bfde2d34ca)("/cashbond-loan");
            }
        }, (0, $LjoDx.h)("a", null, (0, $LjoDx.h)("i", {
            class: "fas fa-money-check-alt"
        }), "Cashbonds/Loans")), (0, $LjoDx.h)("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("anglo__sidenav__routes-list__item", {
                active: this.isRouteActive("loan-payments"),
                hidden: !state.isAuditorOrAbove
            }),
            onClick: function() {
                (0, $ea0dbf761ed9dde7$export$4cb887bfde2d34ca)("/loan-payments");
            }
        }, (0, $LjoDx.h)("a", null, (0, $LjoDx.h)("i", {
            class: "fa fa-file",
            "aria-hidden": "true"
        }), "Loan Payments")), (0, $LjoDx.h)("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("anglo__sidenav__routes-list__item", {
                active: this.isRouteActive("cashbond-payments")
            }),
            onClick: function() {
                (0, $ea0dbf761ed9dde7$export$4cb887bfde2d34ca)("/cashbond-payments");
            }
        }, (0, $LjoDx.h)("a", null, (0, $LjoDx.h)("i", {
            class: "fa fa-calendar",
            "aria-hidden": "true"
        }), "Cashbond Payments")), (0, $LjoDx.h)("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("anglo__sidenav__routes-list__item", {
                active: this.isRouteActive("withdrawal"),
                hidden: !this.canAccessWithdrawals(state)
            }),
            onClick: function() {
                (0, $ea0dbf761ed9dde7$export$4cb887bfde2d34ca)("/withdrawal");
            }
        }, (0, $LjoDx.h)("a", null, (0, $LjoDx.h)("i", {
            class: "fas fa-dolly-flatbed"
        }), "Withdrawals")), (0, $LjoDx.h)("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("anglo__sidenav__routes-list__item", {
                active: this.isRouteActive("disposal"),
                hidden: !this.canAccessWithdrawals(state)
            }),
            onClick: function() {
                (0, $ea0dbf761ed9dde7$export$4cb887bfde2d34ca)("/disposal");
            }
        }, (0, $LjoDx.h)("a", null, (0, $LjoDx.h)("i", {
            class: "fas fa-people-carry"
        }), "Disposals")), (0, $LjoDx.h)("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("anglo__sidenav__routes-list__item", {
                active: this.isRouteActive("microscope"),
                hidden: !state.isUserManagerOrAbove
            }),
            onClick: function() {
                (0, $ea0dbf761ed9dde7$export$4cb887bfde2d34ca)("/microscope");
            }
        }, (0, $LjoDx.h)("a", null, (0, $LjoDx.h)("i", {
            class: "fas fa-chart-line"
        }), "Remittance Microscope")), (0, $LjoDx.h)("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("anglo__sidenav__routes-list__item", {
                active: this.isRouteActive("updates"),
                hidden: state.isUserManagerOrAbove || state.isAuditorOrAbove || state.currentUser.role === (0, $b9c3387011d11553$export$9cb152b3a874b8b0) || state.currentUser.role === (0, $b9c3387011d11553$export$314e71fc1506697c)
            }),
            onClick: function() {
                (0, $ea0dbf761ed9dde7$export$4cb887bfde2d34ca)("/updates");
            }
        }, (0, $LjoDx.h)("a", null, (0, $LjoDx.h)("i", {
            class: "fas fa-bell"
        }), "Updates")), (0, $LjoDx.h)("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("anglo__sidenav__routes-list__item", {
                active: this.isRouteActive("user-management"),
                hidden: !state.isUserManagerOrAbove
            }),
            onClick: function() {
                (0, $ea0dbf761ed9dde7$export$4cb887bfde2d34ca)("/user-management");
            }
        }, (0, $LjoDx.h)("a", null, (0, $LjoDx.h)("i", {
            class: "fas fa-users-cog"
        }), "User Management")), (0, $LjoDx.h)("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("anglo__sidenav__routes-list__item", {
                active: this.isRouteActive("user-management"),
                hidden: !state.isUserManagerOrAbove
            }),
            onClick: function() {
                (0, $ea0dbf761ed9dde7$export$4cb887bfde2d34ca)("/employees");
            }
        }, (0, $LjoDx.h)("a", null, (0, $LjoDx.h)("i", {
            class: "fas fa-male"
        }), "Employee Management")), (0, $LjoDx.h)("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("anglo__sidenav__routes-list__item", {
                active: this.isRouteActive("audits"),
                hidden: !state.isAuditorOrAbove
            }),
            onClick: function() {
                (0, $ea0dbf761ed9dde7$export$4cb887bfde2d34ca)("/audits");
            }
        }, (0, $LjoDx.h)("a", null, (0, $LjoDx.h)("i", {
            class: "fas fa-file-invoice-dollar"
        }), "Auditing", state.currentUser.editRequests.length > 0 ? (0, $LjoDx.h)("span", {
            class: "anglo__sidenav__routes-list__item__notif"
        }, state.currentUser.editRequests.length) : "")), (0, $LjoDx.h)("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("anglo__sidenav__routes-list__item", {
                active: this.isRouteActive("history"),
                hidden: !state.isUserManagerOrAbove
            }),
            onClick: function() {
                (0, $ea0dbf761ed9dde7$export$4cb887bfde2d34ca)("/history");
            }
        }, (0, $LjoDx.h)("a", null, (0, $LjoDx.h)("i", {
            class: "fas fa-book"
        }), "History Logs")), (0, $LjoDx.h)("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("anglo__sidenav__routes-list__item", {
                active: this.isRouteActive("vehicles"),
                hidden: state.currentUser.role === "role_auditor"
            }),
            onClick: function() {
                (0, $ea0dbf761ed9dde7$export$4cb887bfde2d34ca)("/vehicles");
            }
        }, (0, $LjoDx.h)("a", null, (0, $LjoDx.h)("i", {
            class: "fas fa-truck"
        }), "Vehicles")), (0, $LjoDx.h)("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("anglo__sidenav__routes-list__item", {
                active: this.isRouteActive("vehicles"),
                hidden: state.currentUser.role === "role_auditor"
            }),
            onClick: function() {
                (0, $ea0dbf761ed9dde7$export$4cb887bfde2d34ca)("/motorpool");
            }
        }, (0, $LjoDx.h)("a", null, (0, $LjoDx.h)("i", {
            class: "fas fa-key"
        }), "Motorpool")), (0, $LjoDx.h)("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("anglo__sidenav__routes-list__item", {
                active: this.isRouteActive("vehicles"),
                hidden: state.currentUser.role === "role_auditor"
            }),
            onClick: function() {
                (0, $ea0dbf761ed9dde7$export$4cb887bfde2d34ca)("/job-orders");
            }
        }, (0, $LjoDx.h)("a", null, (0, $LjoDx.h)("i", {
            class: "fas fa-wrench"
        }), "Job Orders")), (0, $LjoDx.h)("li", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("anglo__sidenav__routes-list__item d-md-none"),
            onClick: function() {
                _this.onLogout();
            }
        }, (0, $LjoDx.h)("a", null, "Logout"))))), (0, $LjoDx.h)("div", {
            class: "anglo__content__sidenav-padding d-none d-xl-block"
        }));
    };
    return Sidenav;
}((0, $LjoDx.Component));


var $787290684425694f$exports = {};

$parcel$export($787290684425694f$exports, "PAGE_SIZE", () => $787290684425694f$export$8ec3d08588d2eeda);
$parcel$export($787290684425694f$exports, "DashRemittance", () => $787290684425694f$export$1ec54e393e95ca5a);

var $LjoDx = parcelRequire("LjoDx");













var $607cca298669fe2d$exports = {};

$parcel$export($607cca298669fe2d$exports, "RequestEditModal", () => $607cca298669fe2d$export$61da8fbb1752503e);

var $LjoDx = parcelRequire("LjoDx");
function $8846dd5c02dd2c05$var$dlv(obj, key, def, p) {
    p = 0;
    key = key.split ? key.split(".") : key;
    while(obj && p < key.length)obj = obj[key[p++]];
    return obj === undefined ? def : obj;
}
/** Create an Event handler function that sets a given state property.
 *	@param {Component} component	The component whose state should be updated
 *	@param {string} key				A dot-notated key path to update in the component's state
 *	@param {string} eventPath		A dot-notated key path to the value that should be retrieved from the Event or component
 *	@returns {function} linkedStateHandler
 */ function $8846dd5c02dd2c05$var$linkState(component, key, eventPath) {
    var path = key.split("."), cache = component.__lsc || (component.__lsc = {});
    return cache[key + eventPath] || (cache[key + eventPath] = function(e) {
        var t = e && e.target || this, state = {}, obj = state, v = typeof eventPath === "string" ? $8846dd5c02dd2c05$var$dlv(e, eventPath) : t.nodeName ? t.type.match(/^che|rad/) ? t.checked : t.value : e, i = 0;
        for(; i < path.length - 1; i++)obj = obj[path[i]] || (obj[path[i]] = !i && component.state[path[i]] || {});
        obj[path[i]] = v;
        component.setState(state);
    });
}
var $8846dd5c02dd2c05$export$2e2bcd8739ae039 = $8846dd5c02dd2c05$var$linkState;











var $607cca298669fe2d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $607cca298669fe2d$export$61da8fbb1752503e = /** @class */ function(_super) {
    $607cca298669fe2d$var$__extends(RequestEditModal, _super);
    function RequestEditModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onDateSelected = function(date) {
            var dateField = _this.state.fields.find(function(member) {
                return member["fieldName"] === "dateOfTransaction";
            });
            if (dateField) dateField["newValue"] = date;
            else {
                dateField = {
                    fieldName: "dateOfTransaction",
                    newValue: date
                };
                var fields = _this.state.fields;
                fields.push(dateField);
                _this.setState({
                    fields: fields,
                    isFormValid: _this.isFormValid()
                });
            }
        };
        _this.onValueChange = function(e) {
            // const value = Number.parseInt(e.target.value);
            var value = e.target.value;
            var valueField = _this.state.fields.find(function(member) {
                return member["fieldName"] === "amount";
            });
            if (valueField) valueField["newValue"] = value;
            else valueField = {
                fieldName: "amount",
                newValue: value
            };
            var fields = _this.state.fields;
            fields.push(valueField);
            _this.setState({
                fields: fields,
                amountValue: value,
                isFormValid: _this.isFormValid()
            });
        };
        _this.onsalesAgentChange = function(e) {
            var value = e.target.value;
            var valueField = _this.state.fields.find(function(member) {
                return member["fieldName"] === "salesAgent";
            });
            if (valueField) valueField["newValue"] = value;
            else valueField = {
                fieldName: "salesAgent",
                newValue: value
            };
            var fields = _this.state.fields;
            fields.push(valueField);
            _this.setState({
                fields: fields,
                isFormValid: _this.isFormValid()
            });
        };
        _this.onBranchChange = function(e) {
            var value = e.target.value;
            var valueField = _this.state.fields.find(function(member) {
                return member["fieldName"] === "area";
            });
            if (valueField) valueField["newValue"] = value;
            else valueField = {
                fieldName: "area",
                newValue: value
            };
            var fields = _this.state.fields;
            fields.push(valueField);
            _this.setState({
                fields: fields
            });
        };
        _this.onReasonChange = function(e) {
            var value = e.target.value;
            _this.setState({
                reason: value,
                isFormValid: _this.isFormValid()
            });
        };
        _this.onSectorSearchChange = function(sector) {
            console.log(sector);
            var valueField = _this.state.fields.find(function(member) {
                return member["fieldName"] === "area";
            });
            if (valueField) valueField["newValue"] = sector.name;
            else valueField = {
                fieldName: "area",
                newValue: sector.name
            };
            var fields = _this.state.fields;
            fields.push(valueField);
            _this.setState({
                fields: fields,
                isFormValid: _this.isFormValid()
            });
        };
        _this.onSubmit = function() {
            if (!_this.isFormValid()) {
                _this.setState({
                    isFormValid: false
                });
                return;
            }
            _this.setState({
                isFormValid: true
            });
            var finalFields = [];
            var fields = _this.state.fields;
            fields.forEach(function(field) {
                var found = finalFields.find(function(m) {
                    return m["fieldName"] === field["fieldName"];
                });
                if (!found) finalFields.push(field);
            });
            var editRequest = {
                remittanceId: _this.props.remittance.remittanceId,
                fields: finalFields,
                reason: _this.state.reason
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $ea864d6f3cd9447e$export$ab2ecf21d87194a9),
                payload: {
                    editRequest: editRequest
                }
            });
        };
        _this.setState({
            fields: [
                {
                    fieldName: "amount",
                    newValue: props.remittance.amount
                },
                {
                    fieldName: "salesAgent",
                    newValue: props.remittance.salesAgent
                },
                {
                    fieldName: "dateOfTransaction",
                    newValue: props.remittance.dateOfTransaction
                },
                {
                    fieldName: "area",
                    newValue: props.remittance.area
                }
            ],
            reason: null,
            amountValue: null,
            area: null,
            salesAgent: null
        });
        return _this;
    }
    RequestEditModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var remittance$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(app) {
            return app.remittance;
        }));
        this.subs.push(remittance$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(remittance) {
            return remittance.editRequestState;
        })).subscribe(function(reqState) {
            _this.setState({
                editRequestState: reqState
            });
            if (reqState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) _this.doModalClose();
        }));
    };
    RequestEditModal.prototype.componentWillUnmount = function() {
        console.log("unmounting");
    };
    RequestEditModal.prototype.getStartOfMonth = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(new Date()).startOf("month").format((0, $6ac96fa96dbfc52a$export$8132710d1930b03e).date);
    };
    RequestEditModal.prototype.getSpinnerBlock = function(state) {
        if (state.editRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    RequestEditModal.prototype.isFormValid = function() {
        var isValid = true;
        // if (!this.state.fields || this.state.fields.length < 1) {
        //   isValid = false;
        // }
        if (!this.state.isAmountSelected && !this.state.isReceivingSelected && !this.state.isDateOfTransactionSelected && !this.state.isBranchSelected) isValid = false;
        var amount = this.state.fields.find(function(member) {
            return member["fieldName"] === "amount";
        });
        var salesAgent = this.state.fields.find(function(member) {
            return member["fieldName"] === "salesAgent";
        });
        var dateOfTransaction = this.state.fields.find(function(member) {
            return member["fieldName"] === "dateOfTransaction";
        });
        var area = this.state.fields.find(function(member) {
            return member["fieldName"] === "area";
        });
        if (this.state.isAmountSelected && !amount.newValue) isValid = false;
        if (this.state.isReceivingSelected && !salesAgent.newValue) isValid = false;
        if (this.state.isDateOfTransactionSelected && !dateOfTransaction.newValue) isValid = false;
        if (this.state.isBranchSelected && !area.newValue) isValid = false;
        if (!this.state.reason) isValid = false;
        return isValid;
    };
    RequestEditModal.prototype.render = function(props, state) {
        var _this = this;
        // Need to use the actual form 
        var amount = state.fields.find(function(member) {
            return member["fieldName"] === "amount";
        });
        var salesAgent = state.fields.find(function(member) {
            return member["fieldName"] === "salesAgent";
        });
        var dateOfTransaction = state.fields.find(function(member) {
            return member["fieldName"] === "dateOfTransaction";
        });
        var area = state.fields.find(function(member) {
            return member["fieldName"] === "area";
        });
        return (0, $LjoDx.h)("div", {
            class: "anglo-request-edit-modal container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Request to edit remittance | ", (0, $LjoDx.h)("small", null, props.remittance.remittanceId))), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-request-edit-modal__field"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-request-edit-modal__field__head"
        }, (0, $LjoDx.h)("h4", null, "Amount"), (0, $LjoDx.h)("input", {
            type: "checkbox",
            onChange: (0, $8846dd5c02dd2c05$export$2e2bcd8739ae039)(this, "isAmountSelected"),
            checked: state.isAmountSelected
        })), (0, $LjoDx.h)("div", {
            class: "mt-2"
        }, (0, $LjoDx.h)("input", {
            type: "number",
            class: "form-control",
            step: "0.01",
            disabled: !state.isAmountSelected,
            value: amount.newValue,
            onInput: function(e) {
                return _this.onValueChange(e);
            },
            placeholder: "Value"
        })))), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-request-edit-modal__field"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-request-edit-modal__field__head"
        }, (0, $LjoDx.h)("h4", null, "Sales Agent"), (0, $LjoDx.h)("input", {
            type: "checkbox",
            onChange: (0, $8846dd5c02dd2c05$export$2e2bcd8739ae039)(this, "isReceivingSelected"),
            checked: state.isReceivingSelected
        })), (0, $LjoDx.h)("div", {
            class: "mt-2"
        }, (0, $LjoDx.h)("input", {
            type: "text",
            class: "form-control",
            disabled: !state.isReceivingSelected,
            value: salesAgent.newValue,
            onInput: function(e) {
                return _this.onsalesAgentChange(e);
            },
            placeholder: "Sales Agent Name"
        })))), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-request-edit-modal__field"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-request-edit-modal__field__head"
        }, (0, $LjoDx.h)("h4", null, "Date of Transaction"), (0, $LjoDx.h)("input", {
            type: "checkbox",
            onChange: (0, $8846dd5c02dd2c05$export$2e2bcd8739ae039)(this, "isDateOfTransactionSelected"),
            checked: state.isDateOfTransactionSelected
        })), (0, $LjoDx.h)("div", {
            class: "mt-2"
        }, (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            initialValue: dateOfTransaction.newValue,
            onDateSelected: this.onDateSelected,
            disabled: !state.isDateOfTransactionSelected,
            min: this.getStartOfMonth(),
            isValid: true
        })))), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-request-edit-modal__field"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-request-edit-modal__field__head"
        }, (0, $LjoDx.h)("h4", null, "Area"), (0, $LjoDx.h)("input", {
            type: "checkbox",
            onChange: (0, $8846dd5c02dd2c05$export$2e2bcd8739ae039)(this, "isBranchSelected"),
            checked: state.isBranchSelected
        })), (0, $LjoDx.h)("div", {
            class: "mt-2"
        }, (0, $LjoDx.h)((0, $eb0c70f62dd91971$exports.AutocompleteSector), {
            disabled: !state.isBranchSelected,
            initialValue: area.newValue,
            onResultSelected: this.onSectorSearchChange
        })))), (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("h4", {
            class: "anglo-request-edit-modal__label"
        }, "Reason*"), (0, $LjoDx.h)("textarea", {
            class: "form-control anglo-request-edit-modal__reason",
            onInput: function(e) {
                return _this.onReasonChange(e);
            },
            value: state.reason,
            placeholder: "Reason for changes"
        })), (0, $LjoDx.h)("div", {
            class: "col-9 mt-3 pt-2"
        }, !state.isFormValid ? (0, $LjoDx.h)("span", {
            class: "anglo-request-edit-modal__error"
        }, "You have a field with missing values or not selected a field to edit.") : null), (0, $LjoDx.h)("div", {
            class: "col-1"
        }, this.getSpinnerBlock(state)), (0, $LjoDx.h)("div", {
            class: "col-2 mt-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit
        }, "Submit"))));
    };
    return RequestEditModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $e85371888f2032cb$exports = {};

$parcel$export($e85371888f2032cb$exports, "RequestDeleteModal", () => $e85371888f2032cb$export$353d8b8c2ee27f0d);

var $LjoDx = parcelRequire("LjoDx");





var $e85371888f2032cb$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $e85371888f2032cb$export$353d8b8c2ee27f0d = /** @class */ function(_super) {
    $e85371888f2032cb$var$__extends(RequestDeleteModal, _super);
    function RequestDeleteModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onReasonChange = function(e) {
            var value = e.target.value;
            _this.setState({
                reason: value,
                isFormValid: _this.isFormValid()
            });
        };
        _this.onSubmit = function() {
            if (!_this.isFormValid()) {
                _this.setState({
                    isFormValid: false
                });
                return;
            }
            _this.setState({
                isFormValid: true
            });
            var deleteRequest = {
                remittanceId: _this.props.remittance.remittanceId,
                reason: _this.state.reason
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $ea864d6f3cd9447e$export$ab2ecf21d87194a9),
                payload: {
                    deleteRequest: deleteRequest
                }
            });
        };
        _this.setState({
            reason: null
        });
        return _this;
    }
    RequestDeleteModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var remittance$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(app) {
            return app.remittance;
        }));
        this.subs.push(remittance$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(remittance) {
            return remittance.deleteRequestState;
        })).subscribe(function(reqState) {
            _this.setState({
                deleteRequestState: reqState
            });
            if (reqState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) _this.doModalClose();
        }));
    };
    RequestDeleteModal.prototype.getSpinnerBlock = function(state) {
        if (state.deleteRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    RequestDeleteModal.prototype.isFormValid = function() {
        var isValid = true;
        if (!this.state.reason) isValid = false;
        return isValid;
    };
    RequestDeleteModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "anglo-request-edit-modal container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Request to delete remittance | ", (0, $LjoDx.h)("small", null, props.remittance.remittanceId))), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("h4", {
            class: "anglo-request-edit-modal__label"
        }, "Reason*"), (0, $LjoDx.h)("textarea", {
            class: "form-control anglo-request-edit-modal__reason",
            onInput: function(e) {
                return _this.onReasonChange(e);
            },
            value: state.reason,
            placeholder: "Reason for changes"
        })), (0, $LjoDx.h)("div", {
            class: "col-9 mt-3 pt-2"
        }, !state.isFormValid ? (0, $LjoDx.h)("span", {
            class: "anglo-request-edit-modal__error"
        }, "A reason is required") : null), (0, $LjoDx.h)("div", {
            class: "col-1"
        }, this.getSpinnerBlock(state)), (0, $LjoDx.h)("div", {
            class: "col-2 mt-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit
        }, "Submit"))));
    };
    return RequestDeleteModal;
}((0, $3f2ba7f1e3532510$exports.Modal));



var $0eaa8c8dd0ff6bbe$exports = {};

$parcel$export($0eaa8c8dd0ff6bbe$exports, "ReportModal", () => $0eaa8c8dd0ff6bbe$export$efb60ace09439e95);

var $LjoDx = parcelRequire("LjoDx");




var $5a197630e9446689$exports = {};
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    $5a197630e9446689$exports = factory();
})($5a197630e9446689$exports, function() {
    "use strict";
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = "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";
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = "!";
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = "strict";
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                "normal",
                "auto",
                "loose"
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === "strict" ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: "normal",
            wordBreak: "normal"
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === "break-all" || options.wordBreak === "break-word") classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === "keep-all" ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === "undefined" ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === "url" && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ""
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = "";
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = "";
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = "";
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === "undefined" ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== "undefined" ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case "rem":
            case "em":
                return 16 * token.number; // TODO use correct font-size
            case "px":
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = "deg";
    var GRAD = "grad";
    var RAD = "rad";
    var TURN = "turn";
    var angle = {
        name: "angle",
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(" ");
        switch(sideOrCorner){
            case "to bottom right":
            case "to right bottom":
            case "left top":
            case "top left":
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case "to top":
            case "bottom":
                return deg(0);
            case "to bottom left":
            case "to left bottom":
            case "right top":
            case "top right":
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case "to right":
            case "left":
                return deg(90);
            case "to top left":
            case "to left top":
            case "right bottom":
            case "bottom right":
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case "to bottom":
            case "top":
                return deg(180);
            case "to top right":
            case "to right top":
            case "left bottom":
            case "bottom left":
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case "to left":
            case "right":
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: "color",
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === "undefined") throw new Error('Attempting to parse an unsupported color function "' + value.name + '"');
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== "undefined") return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== "undefined" && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: "background-clip",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === "number" ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === "to") {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    "top",
                    "left",
                    "right",
                    "bottom"
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === "linear") {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === "radial") {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === "from") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === "to") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === "color-stop") {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = "closest-side";
    var FARTHEST_SIDE = "farthest-side";
    var CLOSEST_CORNER = "closest-corner";
    var FARTHEST_CORNER = "farthest-corner";
    var CIRCLE = "circle";
    var ELLIPSE = "ellipse";
    var COVER = "cover";
    var CONTAIN = "contain";
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case "center":
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case "top":
                            case "left":
                                position.push(ZERO_LENGTH);
                                return acc;
                            case "right":
                            case "bottom":
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case "at":
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case "center":
                        position.push(FIFTY_PERCENT);
                        return false;
                    case "top":
                    case "left":
                        position.push(ZERO_LENGTH);
                        return false;
                    case "right":
                    case "bottom":
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: "image",
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === "undefined") throw new Error('Attempting to parse an unsupported image function "' + value.name + '"');
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === "none") && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        "linear-gradient": linearGradient,
        "-moz-linear-gradient": prefixLinearGradient,
        "-ms-linear-gradient": prefixLinearGradient,
        "-o-linear-gradient": prefixLinearGradient,
        "-webkit-linear-gradient": prefixLinearGradient,
        "radial-gradient": radialGradient,
        "-moz-radial-gradient": prefixRadialGradient,
        "-ms-radial-gradient": prefixRadialGradient,
        "-o-radial-gradient": prefixRadialGradient,
        "-webkit-radial-gradient": prefixRadialGradient,
        "-webkit-gradient": webkitGradient
    };
    var backgroundImage = {
        name: "background-image",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: "background-origin",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: "background-position",
        initialValue: "0% 0%",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: "background-repeat",
        initialValue: "repeat",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(" ");
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case "no-repeat":
                return 1 /* NO_REPEAT */ ;
            case "repeat-x":
            case "repeat no-repeat":
                return 2 /* REPEAT_X */ ;
            case "repeat-y":
            case "no-repeat repeat":
                return 3 /* REPEAT_Y */ ;
            case "repeat":
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: "background-size",
        initialValue: "0",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: "transparent",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "color"
        };
    };
    var borderTopColor = borderColorForSide("top");
    var borderRightColor = borderColorForSide("right");
    var borderBottomColor = borderColorForSide("bottom");
    var borderLeftColor = borderColorForSide("left");
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: "0 0",
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide("top-left");
    var borderTopRightRadius = borderRadiusForSide("top-right");
    var borderBottomRightRadius = borderRadiusForSide("bottom-right");
    var borderBottomLeftRadius = borderRadiusForSide("bottom-left");
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: "solid",
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case "none":
                        return 0 /* NONE */ ;
                    case "dashed":
                        return 2 /* DASHED */ ;
                    case "dotted":
                        return 3 /* DOTTED */ ;
                    case "double":
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide("top");
    var borderRightStyle = borderStyleForSide("right");
    var borderBottomStyle = borderStyleForSide("bottom");
    var borderLeftStyle = borderStyleForSide("left");
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: "0",
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide("top");
    var borderRightWidth = borderWidthForSide("right");
    var borderBottomWidth = borderWidthForSide("bottom");
    var borderLeftWidth = borderWidthForSide("left");
    var color = {
        name: "color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var direction = {
        name: "direction",
        initialValue: "ltr",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case "rtl":
                    return 1 /* RTL */ ;
                case "ltr":
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: "display",
        initialValue: "inline-block",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case "block":
            case "-webkit-box":
                return 2 /* BLOCK */ ;
            case "inline":
                return 4 /* INLINE */ ;
            case "run-in":
                return 8 /* RUN_IN */ ;
            case "flow":
                return 16 /* FLOW */ ;
            case "flow-root":
                return 32 /* FLOW_ROOT */ ;
            case "table":
                return 64 /* TABLE */ ;
            case "flex":
            case "-webkit-flex":
                return 128 /* FLEX */ ;
            case "grid":
            case "-ms-grid":
                return 256 /* GRID */ ;
            case "ruby":
                return 512 /* RUBY */ ;
            case "subgrid":
                return 1024 /* SUBGRID */ ;
            case "list-item":
                return 2048 /* LIST_ITEM */ ;
            case "table-row-group":
                return 4096 /* TABLE_ROW_GROUP */ ;
            case "table-header-group":
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case "table-footer-group":
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case "table-row":
                return 32768 /* TABLE_ROW */ ;
            case "table-cell":
                return 65536 /* TABLE_CELL */ ;
            case "table-column-group":
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case "table-column":
                return 262144 /* TABLE_COLUMN */ ;
            case "table-caption":
                return 524288 /* TABLE_CAPTION */ ;
            case "ruby-base":
                return 1048576 /* RUBY_BASE */ ;
            case "ruby-text":
                return 2097152 /* RUBY_TEXT */ ;
            case "ruby-base-container":
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case "ruby-text-container":
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case "contents":
                return 16777216 /* CONTENTS */ ;
            case "inline-block":
                return 33554432 /* INLINE_BLOCK */ ;
            case "inline-list-item":
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case "inline-table":
                return 134217728 /* INLINE_TABLE */ ;
            case "inline-flex":
                return 268435456 /* INLINE_FLEX */ ;
            case "inline-grid":
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: "float",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case "left":
                    return 1 /* LEFT */ ;
                case "right":
                    return 2 /* RIGHT */ ;
                case "inline-start":
                    return 3 /* INLINE_START */ ;
                case "inline-end":
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: "letter-spacing",
        initialValue: "0",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "normal") return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: "line-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case "strict":
                    return LINE_BREAK.STRICT;
                case "normal":
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: "line-height",
        initialValue: "normal",
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === "normal") return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: "list-style-image",
        initialValue: "none",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: "list-style-position",
        initialValue: "outside",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case "inside":
                    return 0 /* INSIDE */ ;
                case "outside":
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: "list-style-type",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case "disc":
                    return 0 /* DISC */ ;
                case "circle":
                    return 1 /* CIRCLE */ ;
                case "square":
                    return 2 /* SQUARE */ ;
                case "decimal":
                    return 3 /* DECIMAL */ ;
                case "cjk-decimal":
                    return 4 /* CJK_DECIMAL */ ;
                case "decimal-leading-zero":
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case "lower-roman":
                    return 6 /* LOWER_ROMAN */ ;
                case "upper-roman":
                    return 7 /* UPPER_ROMAN */ ;
                case "lower-greek":
                    return 8 /* LOWER_GREEK */ ;
                case "lower-alpha":
                    return 9 /* LOWER_ALPHA */ ;
                case "upper-alpha":
                    return 10 /* UPPER_ALPHA */ ;
                case "arabic-indic":
                    return 11 /* ARABIC_INDIC */ ;
                case "armenian":
                    return 12 /* ARMENIAN */ ;
                case "bengali":
                    return 13 /* BENGALI */ ;
                case "cambodian":
                    return 14 /* CAMBODIAN */ ;
                case "cjk-earthly-branch":
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case "cjk-heavenly-stem":
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case "cjk-ideographic":
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case "devanagari":
                    return 18 /* DEVANAGARI */ ;
                case "ethiopic-numeric":
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case "georgian":
                    return 20 /* GEORGIAN */ ;
                case "gujarati":
                    return 21 /* GUJARATI */ ;
                case "gurmukhi":
                    return 22 /* GURMUKHI */ ;
                case "hebrew":
                    return 22 /* HEBREW */ ;
                case "hiragana":
                    return 23 /* HIRAGANA */ ;
                case "hiragana-iroha":
                    return 24 /* HIRAGANA_IROHA */ ;
                case "japanese-formal":
                    return 25 /* JAPANESE_FORMAL */ ;
                case "japanese-informal":
                    return 26 /* JAPANESE_INFORMAL */ ;
                case "kannada":
                    return 27 /* KANNADA */ ;
                case "katakana":
                    return 28 /* KATAKANA */ ;
                case "katakana-iroha":
                    return 29 /* KATAKANA_IROHA */ ;
                case "khmer":
                    return 30 /* KHMER */ ;
                case "korean-hangul-formal":
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case "korean-hanja-formal":
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case "korean-hanja-informal":
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case "lao":
                    return 34 /* LAO */ ;
                case "lower-armenian":
                    return 35 /* LOWER_ARMENIAN */ ;
                case "malayalam":
                    return 36 /* MALAYALAM */ ;
                case "mongolian":
                    return 37 /* MONGOLIAN */ ;
                case "myanmar":
                    return 38 /* MYANMAR */ ;
                case "oriya":
                    return 39 /* ORIYA */ ;
                case "persian":
                    return 40 /* PERSIAN */ ;
                case "simp-chinese-formal":
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case "simp-chinese-informal":
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case "tamil":
                    return 43 /* TAMIL */ ;
                case "telugu":
                    return 44 /* TELUGU */ ;
                case "thai":
                    return 45 /* THAI */ ;
                case "tibetan":
                    return 46 /* TIBETAN */ ;
                case "trad-chinese-formal":
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case "trad-chinese-informal":
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case "upper-armenian":
                    return 49 /* UPPER_ARMENIAN */ ;
                case "disclosure-open":
                    return 50 /* DISCLOSURE_OPEN */ ;
                case "disclosure-closed":
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case "none":
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: "0",
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide("top");
    var marginRight = marginForSide("right");
    var marginBottom = marginForSide("bottom");
    var marginLeft = marginForSide("left");
    var overflow = {
        name: "overflow",
        initialValue: "visible",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case "hidden":
                        return 1 /* HIDDEN */ ;
                    case "scroll":
                        return 2 /* SCROLL */ ;
                    case "clip":
                        return 3 /* CLIP */ ;
                    case "auto":
                        return 4 /* AUTO */ ;
                    case "visible":
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: "overflow-wrap",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case "break-word":
                    return "break-word" /* BREAK_WORD */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: "0",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "length-percentage"
        };
    };
    var paddingTop = paddingForSide("top");
    var paddingRight = paddingForSide("right");
    var paddingBottom = paddingForSide("bottom");
    var paddingLeft = paddingForSide("left");
    var textAlign = {
        name: "text-align",
        initialValue: "left",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case "right":
                    return 2 /* RIGHT */ ;
                case "center":
                case "justify":
                    return 1 /* CENTER */ ;
                case "left":
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: "position",
        initialValue: "static",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case "relative":
                    return 1 /* RELATIVE */ ;
                case "absolute":
                    return 2 /* ABSOLUTE */ ;
                case "fixed":
                    return 3 /* FIXED */ ;
                case "sticky":
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: "text-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: "text-transform",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case "uppercase":
                    return 2 /* UPPERCASE */ ;
                case "lowercase":
                    return 1 /* LOWERCASE */ ;
                case "capitalize":
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: "transform",
        initialValue: "none",
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === "undefined") throw new Error('Attempting to parse an unsupported transform function "' + token.name + '"');
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: "transform-origin",
        initialValue: "50% 50%",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: "visible",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case "hidden":
                    return 1 /* HIDDEN */ ;
                case "collapse":
                    return 2 /* COLLAPSE */ ;
                case "visible":
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: "word-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case "break-all":
                    return WORD_BREAK.BREAK_ALL;
                case "keep-all":
                    return WORD_BREAK.KEEP_ALL;
                case "normal":
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: "z-index",
        initialValue: "auto",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: "time",
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case "s":
                    return 1000 * value.number;
                case "ms":
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: "opacity",
        initialValue: "1",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var textDecorationLine = {
        name: "text-decoration-line",
        initialValue: "none",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case "underline":
                        return 1 /* UNDERLINE */ ;
                    case "overline":
                        return 2 /* OVERLINE */ ;
                    case "line-through":
                        return 3 /* LINE_THROUGH */ ;
                    case "none":
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: "",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(" "));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(" "));
            return results.map(function(result) {
                return result.indexOf(" ") === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: "0",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "length"
    };
    var fontWeight = {
        name: "font-weight",
        initialValue: "normal",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case "bold":
                    return 700;
                case "normal":
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: "font-variant",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: "font-style",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case "oblique":
                    return "oblique" /* OBLIQUE */ ;
                case "italic":
                    return "italic" /* ITALIC */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: "content",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: "counter-increment",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: "counter-reset",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== "none") {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: "duration",
        initialValue: "0s",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: "quotes",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return "";
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return "";
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: "box-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, "inset")) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: "paint-order",
        initialValue: "normal",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case "stroke":
                        layers.push(1 /* STROKE */ );
                        break;
                    case "fill":
                        layers.push(0 /* FILL */ );
                        break;
                    case "markers":
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: "currentcolor",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: "0",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== "undefined" ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case "angle":
                        return angle.parse(context, parser.parseComponentValue());
                    case "color":
                        return color$1.parse(context, parser.parseComponentValue());
                    case "image":
                        return image.parse(context, parser.parseComponentValue());
                    case "length":
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case "length-percentage":
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case "time":
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = "data-html2canvas-debug";
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case "all":
                return 1 /* ALL */ ;
            case "clone":
                return 2 /* CLONE */ ;
            case "parse":
                return 3 /* PARSE */ ;
            case "render":
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = "0s";
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = "none";
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = "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";
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement("boundtest");
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = "block";
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement("boundtest");
        testElement.style.width = "50px";
        testElement.style.display = "block";
        testElement.style.fontSize = "12px";
        testElement.style.letterSpacing = "0px";
        testElement.style.wordSpacing = "0px";
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof "".repeat === "function" ? "&#128104;".repeat(10) : "";
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== "undefined";
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === "string";
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement("canvas");
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext("2d");
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = "rgb(0, 255, 0)";
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = "red";
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = "red";
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement("div");
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = "http://www.w3.org/2000/svg";
        var svg = document.createElementNS(xmlns, "svg");
        var foreignObject = document.createElementNS(xmlns, "foreignObject");
        svg.setAttributeNS(null, "width", width.toString());
        svg.setAttributeNS(null, "height", height.toString());
        foreignObject.setAttributeNS(null, "width", "100%");
        foreignObject.setAttributeNS(null, "height", "100%");
        foreignObject.setAttributeNS(null, "x", x.toString());
        foreignObject.setAttributeNS(null, "y", y.toString());
        foreignObject.setAttributeNS(null, "externalResourcesRequired", "true");
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, "SUPPORT_RANGE_BOUNDS", {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, "SUPPORT_WORD_BREAKING", {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, "SUPPORT_SVG_DRAWING", {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === "function" && typeof window.fetch === "function" ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, "SUPPORT_FOREIGNOBJECT_DRAWING", {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_IMAGES", {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, "SUPPORT_RESPONSE_TYPE", {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = "withCredentials" in new XMLHttpRequest();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_XHR", {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== "undefined" && Intl.Segmenter);
            Object.defineProperty(FEATURES, "SUPPORT_NATIVE_TEXT_SEGMENTATION", {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement("html2canvaswrapper");
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error("Node has no owner document");
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "grapheme"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "word"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? "break-word" : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = "";
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = "";
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute("width", bounds.width + "px");
            img.setAttribute("height", bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === "boolean" && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: "px",
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join("•") : node.value;
        return value.length === 0 ? node.placeholder || "" : value;
    };
    var CHECKBOX = "checkbox";
    var RADIO = "radio";
    var PASSWORD = "password";
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || "" : "";
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        "OL",
        "UL",
        "MENU"
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== "undefined" && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === "object";
    };
    var isLIElement = function(node) {
        return node.tagName === "LI";
    };
    var isOLElement = function(node) {
        return node.tagName === "OL";
    };
    var isInputElement = function(node) {
        return node.tagName === "INPUT";
    };
    var isHTMLElement = function(node) {
        return node.tagName === "HTML";
    };
    var isSVGElement = function(node) {
        return node.tagName === "svg";
    };
    var isBodyElement = function(node) {
        return node.tagName === "BODY";
    };
    var isCanvasElement = function(node) {
        return node.tagName === "CANVAS";
    };
    var isVideoElement = function(node) {
        return node.tagName === "VIDEO";
    };
    var isImageElement = function(node) {
        return node.tagName === "IMG";
    };
    var isIFrameElement = function(node) {
        return node.tagName === "IFRAME";
    };
    var isStyleElement = function(node) {
        return node.tagName === "STYLE";
    };
    var isScriptElement = function(node) {
        return node.tagName === "SCRIPT";
    };
    var isTextareaElement = function(node) {
        return node.tagName === "TEXTAREA";
    };
    var isSelectElement = function(node) {
        return node.tagName === "SELECT";
    };
    var isSlotElement = function(node) {
        return node.tagName === "SLOT";
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf("-") > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            "M",
            "CM",
            "D",
            "CD",
            "C",
            "XC",
            "L",
            "XL",
            "X",
            "IX",
            "V",
            "IV",
            "I"
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "Ք",
            "Փ",
            "Ւ",
            "Ց",
            "Ր",
            "Տ",
            "Վ",
            "Ս",
            "Ռ",
            "Ջ",
            "Պ",
            "Չ",
            "Ո",
            "Շ",
            "Ն",
            "Յ",
            "Մ",
            "Ճ",
            "Ղ",
            "Ձ",
            "Հ",
            "Կ",
            "Ծ",
            "Խ",
            "Լ",
            "Ի",
            "Ժ",
            "Թ",
            "Ը",
            "Է",
            "Զ",
            "Ե",
            "Դ",
            "Գ",
            "Բ",
            "Ա"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "י׳",
            "ט׳",
            "ח׳",
            "ז׳",
            "ו׳",
            "ה׳",
            "ד׳",
            "ג׳",
            "ב׳",
            "א׳",
            "ת",
            "ש",
            "ר",
            "ק",
            "צ",
            "פ",
            "ע",
            "ס",
            "נ",
            "מ",
            "ל",
            "כ",
            "יט",
            "יח",
            "יז",
            "טז",
            "טו",
            "י",
            "ט",
            "ח",
            "ז",
            "ו",
            "ה",
            "ד",
            "ג",
            "ב",
            "א"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "ჵ",
            "ჰ",
            "ჯ",
            "ჴ",
            "ხ",
            "ჭ",
            "წ",
            "ძ",
            "ც",
            "ჩ",
            "შ",
            "ყ",
            "ღ",
            "ქ",
            "ფ",
            "ჳ",
            "ტ",
            "ს",
            "რ",
            "ჟ",
            "პ",
            "ო",
            "ჲ",
            "ნ",
            "მ",
            "ლ",
            "კ",
            "ი",
            "თ",
            "ჱ",
            "ზ",
            "ვ",
            "ე",
            "დ",
            "გ",
            "ბ",
            "ა"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, "") + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = "";
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? "-" : "") + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = ". ";
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== "") string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : "") + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : "") + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "十百千萬";
    var CHINESE_FORMAL_MULTIPLIERS = "拾佰仟萬";
    var JAPANESE_NEGATIVE = "マイナス";
    var KOREAN_NEGATIVE = "마이너스";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? ". " : "";
        var cjkSuffix = appendSuffix ? "、" : "";
        var koreanSuffix = appendSuffix ? ", " : "";
        var spaceSuffix = appendSuffix ? " " : "";
        switch(type){
            case 0 /* DISC */ :
                return "•" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "◦" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "◾" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "〇一二三四五六七八九", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "子丑寅卯辰巳午未申酉戌亥", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "甲乙丙丁戊己庚辛壬癸", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "零一二三四五六七八九", CHINESE_INFORMAL_MULTIPLIERS, "負", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "零壹貳參肆伍陸柒捌玖", CHINESE_FORMAL_MULTIPLIERS, "負", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "零一二三四五六七八九", CHINESE_INFORMAL_MULTIPLIERS, "负", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "零壹贰叁肆伍陆柒捌玖", CHINESE_FORMAL_MULTIPLIERS, "负", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "〇一二三四五六七八九", "十百千万", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "零壱弐参四伍六七八九", "拾百千万", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "영일이삼사오육칠팔구", "십백천만", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "零一二三四五六七八九", "十百千萬", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "零壹貳參四五六七八九", "拾百千", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = "data-html2canvas-ignore";
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error("Cloned element does not have an owner document");
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn("Unable to restore scroll position for cloned document");
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === "undefined") return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === "function") return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = "";
                }
                if (clone.loading === "lazy") clone.loading = "eager";
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement("html2canvascustomelement");
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === "string") return css + rule.cssText;
                        return css;
                    }, "");
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error("Unable to access cssRules property", e);
                if (e.name !== "SecurityError") throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement("img");
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext("2d");
                var clonedCtx = clonedCanvas.getContext("2d");
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext("webgl2")) !== null && _a !== void 0 ? _a : canvas.getContext("webgl");
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement("canvas");
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext("2d");
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement("canvas");
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== "function" || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === "function") {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = "none";
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ":before");
                var styleAfter = window1.getComputedStyle(node, ":after");
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === "none" || value === "-moz-alt-content" || style.display === "none") return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement("html2canvaspseudoelement");
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement("img");
                    img.src = token.value;
                    img.style.opacity = "1";
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === "attr") {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ""));
                    } else if (token.name === "counter") {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === "counters") {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : "";
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case "open-quote":
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case "close-quote":
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement("iframe");
        cloneIframeContainer.className = "html2canvas-container";
        cloneIframeContainer.style.visibility = "hidden";
        cloneIframeContainer.style.position = "fixed";
        cloneIframeContainer.style.left = "-10000px";
        cloneIframeContainer.style.top = "0px";
        cloneIframeContainer.style.border = "0";
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = "no"; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, "true");
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === "complete") {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        "all",
        "d",
        "content" // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = "";
        if (doctype) {
            str += "<!DOCTYPE ";
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += '"' + doctype.publicId + '"';
            if (doctype.systemId) str += '"' + doctype.systemId + '"';
            str += ">";
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ":before";
    var PSEUDO_AFTER = ":after";
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before";
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after";
    var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement("style");
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return "about:blank";
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement("a");
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = "about:blank";
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === "string" && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = "anonymous";
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== "undefined";
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error("No proxy defined");
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? "blob" : "text";
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === "text") resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener("load", function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener("error", function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf("?") > -1 ? "&" : "?";
                xhr.open("GET", "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== "text" && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === "blob";
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === "svg" || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === "number" && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === "number";
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === "undefined") return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    var SAMPLE_TEXT = "Hidden Text";
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement("div");
            var img = this._document.createElement("img");
            var span = this._document.createElement("span");
            var body = this._document.body;
            container.style.visibility = "hidden";
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = "0";
            container.style.padding = "0";
            container.style.whiteSpace = "nowrap";
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = "0";
            img.style.padding = "0";
            img.style.verticalAlign = "baseline";
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = "0";
            span.style.padding = "0";
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = "normal";
            img.style.verticalAlign = "super";
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === "undefined") this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = "bottom";
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === "normal" || variant === "small-caps";
            }).join("");
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(", ");
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(" "),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? "rtl" : "ltr";
                    this.ctx.textAlign = "left";
                    this.ctx.textBaseline = "alphabetic";
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = "";
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? "miter" : "round";
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = "";
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = "miter";
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = "left";
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "middle";
                                this.ctx.textAlign = "right";
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = "bottom";
                                this.ctx.textAlign = "left";
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement("canvas");
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), "repeat");
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement("canvas");
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext("2d");
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, "repeat");
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : "rgba(0,0,0,1)";
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = "round";
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return "center";
            case 2 /* RIGHT */ :
                return "right";
            case 0 /* LEFT */ :
            default:
                return "left";
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        "-apple-system",
        "system-ui"
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.debug === "function") // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== "undefined" && window.console && typeof console.info === "function") // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.warn === "function") // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.error === "function") // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== "undefined") CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== "object") return [
                            2 /*return*/ ,
                            Promise.reject("Invalid element provided as first argument")
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === "string" ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});


var $d4a0bfe8d6ddfc13$exports = {};
!function(t) {
    "function" == typeof define && define.amd ? define(t) : t();
}(function() {
    "use strict";
    /** @license
   * jsPDF - PDF Document creation from JavaScript
   * Version 1.5.3 Built on 2018-12-27T14:11:42.696Z
   *                      CommitID d93d28db14
   *
   * Copyright (c) 2010-2016 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
   *               2010 Aaron Spike, https://github.com/acspike
   *               2012 Willow Systems Corporation, willow-systems.com
   *               2012 Pablo Hess, https://github.com/pablohess
   *               2012 Florian Jenett, https://github.com/fjenett
   *               2013 Warren Weckesser, https://github.com/warrenweckesser
   *               2013 Youssef Beddad, https://github.com/lifof
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2013 Stefan Slonevskiy, https://github.com/stefslon
   *               2013 Jeremy Morel, https://github.com/jmorel
   *               2013 Christoph Hartmann, https://github.com/chris-rock
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Makes, https://github.com/dollaruw
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Steven Spungin, https://github.com/Flamenco
   *               2014 Kenneth Glassey, https://github.com/Gavvers
   *
   * Licensed under the MIT License
   *
   * Contributor(s):
   *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
   *    kim3er, mfo, alnorth, Flamenco
   */ function se(t) {
        return (se = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t;
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        })(t);
    }
    !function(t) {
        if ("object" !== se(t.console)) {
            t.console = {};
            for(var e, n, r = t.console, i = function() {}, o = [
                "memory"
            ], a = "assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(","); e = o.pop();)r[e] || (r[e] = {});
            for(; n = a.pop();)r[n] || (r[n] = i);
        }
        var s, l, h, u, c = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        void 0 === t.btoa && (t.btoa = function(t) {
            var e, n, r, i, o, a = 0, s = 0, l = "", h = [];
            if (!t) return t;
            for(; e = (o = t.charCodeAt(a++) << 16 | t.charCodeAt(a++) << 8 | t.charCodeAt(a++)) >> 18 & 63, n = o >> 12 & 63, r = o >> 6 & 63, i = 63 & o, h[s++] = c.charAt(e) + c.charAt(n) + c.charAt(r) + c.charAt(i), a < t.length;);
            l = h.join("");
            var u = t.length % 3;
            return (u ? l.slice(0, u - 3) : l) + "===".slice(u || 3);
        }), void 0 === t.atob && (t.atob = function(t) {
            var e, n, r, i, o, a, s = 0, l = 0, h = [];
            if (!t) return t;
            for(t += ""; e = (a = c.indexOf(t.charAt(s++)) << 18 | c.indexOf(t.charAt(s++)) << 12 | (i = c.indexOf(t.charAt(s++))) << 6 | (o = c.indexOf(t.charAt(s++)))) >> 16 & 255, n = a >> 8 & 255, r = 255 & a, h[l++] = 64 == i ? String.fromCharCode(e) : 64 == o ? String.fromCharCode(e, n) : String.fromCharCode(e, n, r), s < t.length;);
            return h.join("");
        }), Array.prototype.map || (Array.prototype.map = function(t) {
            if (null == this || "function" != typeof t) throw new TypeError;
            for(var e = Object(this), n = e.length >>> 0, r = new Array(n), i = 1 < arguments.length ? arguments[1] : void 0, o = 0; o < n; o++)o in e && (r[o] = t.call(i, e[o], o, e));
            return r;
        }), Array.isArray || (Array.isArray = function(t) {
            return "[object Array]" === Object.prototype.toString.call(t);
        }), Array.prototype.forEach || (Array.prototype.forEach = function(t, e) {
            if (null == this || "function" != typeof t) throw new TypeError;
            for(var n = Object(this), r = n.length >>> 0, i = 0; i < r; i++)i in n && t.call(e, n[i], i, n);
        }), Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
            value: function(t) {
                if (null == this) throw new TypeError('"this" is null or not defined');
                var e = Object(this), n = e.length >>> 0;
                if ("function" != typeof t) throw new TypeError("predicate must be a function");
                for(var r = arguments[1], i = 0; i < n;){
                    var o = e[i];
                    if (t.call(r, o, i, e)) return o;
                    i++;
                }
            },
            configurable: !0,
            writable: !0
        }), Object.keys || (Object.keys = (s = Object.prototype.hasOwnProperty, l = !({
            toString: null
        }).propertyIsEnumerable("toString"), u = (h = [
            "toString",
            "toLocaleString",
            "valueOf",
            "hasOwnProperty",
            "isPrototypeOf",
            "propertyIsEnumerable",
            "constructor"
        ]).length, function(t) {
            if ("object" !== se(t) && ("function" != typeof t || null === t)) throw new TypeError;
            var e, n, r = [];
            for(e in t)s.call(t, e) && r.push(e);
            if (l) for(n = 0; n < u; n++)s.call(t, h[n]) && r.push(h[n]);
            return r;
        })), "function" != typeof Object.assign && (Object.assign = function(t) {
            if (null == t) throw new TypeError("Cannot convert undefined or null to object");
            t = Object(t);
            for(var e = 1; e < arguments.length; e++){
                var n = arguments[e];
                if (null != n) for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
            }
            return t;
        }), String.prototype.trim || (String.prototype.trim = function() {
            return this.replace(/^\s+|\s+$/g, "");
        }), String.prototype.trimLeft || (String.prototype.trimLeft = function() {
            return this.replace(/^\s+/g, "");
        }), String.prototype.trimRight || (String.prototype.trimRight = function() {
            return this.replace(/\s+$/g, "");
        }), Number.isInteger = Number.isInteger || function(t) {
            return "number" == typeof t && isFinite(t) && Math.floor(t) === t;
        };
    }("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")());
    var t, e, n, _, l, F, P, p, d, k, a, o, s, h, u, c, r, i, f, g, m, y, v, w, b, x, I, C, B, N, L, A, S, j, E, M, O, q, T, R, D, U, z, H, W, V, G, Y, J, X, K, Z, Q, $, tt, et, nt, rt, it, ot, at, st, lt = function(ie) {
        function oe(o) {
            if ("object" !== se(o)) throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
            var a = {};
            this.subscribe = function(t, e, n) {
                if (n = n || !1, "string" != typeof t || "function" != typeof e || "boolean" != typeof n) throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
                a.hasOwnProperty(t) || (a[t] = {});
                var r = Math.random().toString(35);
                return a[t][r] = [
                    e,
                    !!n
                ], r;
            }, this.unsubscribe = function(t) {
                for(var e in a)if (a[e][t]) return delete a[e][t], 0 === Object.keys(a[e]).length && delete a[e], !0;
                return !1;
            }, this.publish = function(t) {
                if (a.hasOwnProperty(t)) {
                    var e = Array.prototype.slice.call(arguments, 1), n = [];
                    for(var r in a[t]){
                        var i = a[t][r];
                        try {
                            i[0].apply(o, e);
                        } catch (t) {
                            ie.console && console.error("jsPDF PubSub Error", t.message, t);
                        }
                        i[1] && n.push(r);
                    }
                    n.length && n.forEach(this.unsubscribe);
                }
            }, this.getTopics = function() {
                return a;
            };
        }
        function ae(t, e, i, n) {
            var r = {}, o = [], a = 1;
            "object" === se(t) && (t = (r = t).orientation, e = r.unit || e, i = r.format || i, n = r.compress || r.compressPdf || n, o = r.filters || (!0 === n ? [
                "FlateEncode"
            ] : o), a = "number" == typeof r.userUnit ? Math.abs(r.userUnit) : 1), e = e || "mm", t = ("" + (t || "P")).toLowerCase();
            var s = r.putOnlyUsedFonts || !0, K = {}, l = {
                internal: {},
                __private__: {}
            };
            l.__private__.PubSub = oe;
            var h = "1.3", u = l.__private__.getPdfVersion = function() {
                return h;
            }, c = (l.__private__.setPdfVersion = function(t) {
                h = t;
            }, {
                a0: [
                    2383.94,
                    3370.39
                ],
                a1: [
                    1683.78,
                    2383.94
                ],
                a2: [
                    1190.55,
                    1683.78
                ],
                a3: [
                    841.89,
                    1190.55
                ],
                a4: [
                    595.28,
                    841.89
                ],
                a5: [
                    419.53,
                    595.28
                ],
                a6: [
                    297.64,
                    419.53
                ],
                a7: [
                    209.76,
                    297.64
                ],
                a8: [
                    147.4,
                    209.76
                ],
                a9: [
                    104.88,
                    147.4
                ],
                a10: [
                    73.7,
                    104.88
                ],
                b0: [
                    2834.65,
                    4008.19
                ],
                b1: [
                    2004.09,
                    2834.65
                ],
                b2: [
                    1417.32,
                    2004.09
                ],
                b3: [
                    1000.63,
                    1417.32
                ],
                b4: [
                    708.66,
                    1000.63
                ],
                b5: [
                    498.9,
                    708.66
                ],
                b6: [
                    354.33,
                    498.9
                ],
                b7: [
                    249.45,
                    354.33
                ],
                b8: [
                    175.75,
                    249.45
                ],
                b9: [
                    124.72,
                    175.75
                ],
                b10: [
                    87.87,
                    124.72
                ],
                c0: [
                    2599.37,
                    3676.54
                ],
                c1: [
                    1836.85,
                    2599.37
                ],
                c2: [
                    1298.27,
                    1836.85
                ],
                c3: [
                    918.43,
                    1298.27
                ],
                c4: [
                    649.13,
                    918.43
                ],
                c5: [
                    459.21,
                    649.13
                ],
                c6: [
                    323.15,
                    459.21
                ],
                c7: [
                    229.61,
                    323.15
                ],
                c8: [
                    161.57,
                    229.61
                ],
                c9: [
                    113.39,
                    161.57
                ],
                c10: [
                    79.37,
                    113.39
                ],
                dl: [
                    311.81,
                    623.62
                ],
                letter: [
                    612,
                    792
                ],
                "government-letter": [
                    576,
                    756
                ],
                legal: [
                    612,
                    1008
                ],
                "junior-legal": [
                    576,
                    360
                ],
                ledger: [
                    1224,
                    792
                ],
                tabloid: [
                    792,
                    1224
                ],
                "credit-card": [
                    153,
                    243
                ]
            }), f = (l.__private__.getPageFormats = function() {
                return c;
            }, l.__private__.getPageFormat = function(t) {
                return c[t];
            });
            "string" == typeof i && (i = f(i)), i = i || f("a4");
            var p, Z = l.f2 = l.__private__.f2 = function(t) {
                if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f2");
                return t.toFixed(2);
            }, Q = l.__private__.f3 = function(t) {
                if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f3");
                return t.toFixed(3);
            }, d = "00000000000000000000000000000000", g = l.__private__.getFileId = function() {
                return d;
            }, m = l.__private__.setFileId = function(t) {
                return t = t || "12345678901234567890123456789012".split("").map(function() {
                    return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
                }).join(""), d = t;
            };
            l.setFileId = function(t) {
                return m(t), this;
            }, l.getFileId = function() {
                return g();
            };
            var y = l.__private__.convertDateToPDFDate = function(t) {
                var e = t.getTimezoneOffset(), n = e < 0 ? "+" : "-", r = Math.floor(Math.abs(e / 60)), i = Math.abs(e % 60), o = [
                    n,
                    P(r),
                    "'",
                    P(i),
                    "'"
                ].join("");
                return [
                    "D:",
                    t.getFullYear(),
                    P(t.getMonth() + 1),
                    P(t.getDate()),
                    P(t.getHours()),
                    P(t.getMinutes()),
                    P(t.getSeconds()),
                    o
                ].join("");
            }, v = l.__private__.convertPDFDateToDate = function(t) {
                var e = parseInt(t.substr(2, 4), 10), n = parseInt(t.substr(6, 2), 10) - 1, r = parseInt(t.substr(8, 2), 10), i = parseInt(t.substr(10, 2), 10), o = parseInt(t.substr(12, 2), 10), a = parseInt(t.substr(14, 2), 10);
                parseInt(t.substr(16, 2), 10), parseInt(t.substr(20, 2), 10);
                return new Date(e, n, r, i, o, a, 0);
            }, w = l.__private__.setCreationDate = function(t) {
                var e;
                if (void 0 === t && (t = new Date), "object" === se(t) && "[object Date]" === Object.prototype.toString.call(t)) e = y(t);
                else {
                    if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|\-0[0-9]|\-1[0-1])\'(0[0-9]|[1-5][0-9])\'?$/.test(t)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
                    e = t;
                }
                return p = e;
            }, b = l.__private__.getCreationDate = function(t) {
                var e = p;
                return "jsDate" === t && (e = v(p)), e;
            };
            l.setCreationDate = function(t) {
                return w(t), this;
            }, l.getCreationDate = function(t) {
                return b(t);
            };
            var x, N, L, A, S, $, _, F, P = l.__private__.padd2 = function(t) {
                return ("0" + parseInt(t)).slice(-2);
            }, k = !1, I = [], C = [], B = 0, tt = (l.__private__.setCustomOutputDestination = function(t) {
                N = t;
            }, l.__private__.resetCustomOutputDestination = function(t) {
                N = void 0;
            }, l.__private__.out = function(t) {
                var e;
                return t = "string" == typeof t ? t : t.toString(), (e = void 0 === N ? k ? I[x] : C : N).push(t), k || (B += t.length + 1), e;
            }), j = l.__private__.write = function(t) {
                return tt(1 === arguments.length ? t.toString() : Array.prototype.join.call(arguments, " "));
            }, E = l.__private__.getArrayBuffer = function(t) {
                for(var e = t.length, n = new ArrayBuffer(e), r = new Uint8Array(n); e--;)r[e] = t.charCodeAt(e);
                return n;
            }, M = [
                [
                    "Helvetica",
                    "helvetica",
                    "normal",
                    "WinAnsiEncoding"
                ],
                [
                    "Helvetica-Bold",
                    "helvetica",
                    "bold",
                    "WinAnsiEncoding"
                ],
                [
                    "Helvetica-Oblique",
                    "helvetica",
                    "italic",
                    "WinAnsiEncoding"
                ],
                [
                    "Helvetica-BoldOblique",
                    "helvetica",
                    "bolditalic",
                    "WinAnsiEncoding"
                ],
                [
                    "Courier",
                    "courier",
                    "normal",
                    "WinAnsiEncoding"
                ],
                [
                    "Courier-Bold",
                    "courier",
                    "bold",
                    "WinAnsiEncoding"
                ],
                [
                    "Courier-Oblique",
                    "courier",
                    "italic",
                    "WinAnsiEncoding"
                ],
                [
                    "Courier-BoldOblique",
                    "courier",
                    "bolditalic",
                    "WinAnsiEncoding"
                ],
                [
                    "Times-Roman",
                    "times",
                    "normal",
                    "WinAnsiEncoding"
                ],
                [
                    "Times-Bold",
                    "times",
                    "bold",
                    "WinAnsiEncoding"
                ],
                [
                    "Times-Italic",
                    "times",
                    "italic",
                    "WinAnsiEncoding"
                ],
                [
                    "Times-BoldItalic",
                    "times",
                    "bolditalic",
                    "WinAnsiEncoding"
                ],
                [
                    "ZapfDingbats",
                    "zapfdingbats",
                    "normal",
                    null
                ],
                [
                    "Symbol",
                    "symbol",
                    "normal",
                    null
                ]
            ], et = (l.__private__.getStandardFonts = function(t) {
                return M;
            }, r.fontSize || 16), O = (l.__private__.setFontSize = l.setFontSize = function(t) {
                return et = t, this;
            }, l.__private__.getFontSize = l.getFontSize = function() {
                return et;
            }), nt = r.R2L || !1, q = (l.__private__.setR2L = l.setR2L = function(t) {
                return nt = t, this;
            }, l.__private__.getR2L = l.getR2L = function(t) {
                return nt;
            }, l.__private__.setZoomMode = function(t) {
                var e = [
                    void 0,
                    null,
                    "fullwidth",
                    "fullheight",
                    "fullpage",
                    "original"
                ];
                if (/^\d*\.?\d*\%$/.test(t)) L = t;
                else if (isNaN(t)) {
                    if (-1 === e.indexOf(t)) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + t + '" is not recognized.');
                    L = t;
                } else L = parseInt(t, 10);
            }), T = (l.__private__.getZoomMode = function() {
                return L;
            }, l.__private__.setPageMode = function(t) {
                if (-1 == [
                    void 0,
                    null,
                    "UseNone",
                    "UseOutlines",
                    "UseThumbs",
                    "FullScreen"
                ].indexOf(t)) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + t + '" is not recognized.');
                A = t;
            }), R = (l.__private__.getPageMode = function() {
                return A;
            }, l.__private__.setLayoutMode = function(t) {
                if (-1 == [
                    void 0,
                    null,
                    "continuous",
                    "single",
                    "twoleft",
                    "tworight",
                    "two"
                ].indexOf(t)) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + t + '" is not recognized.');
                S = t;
            }), D = (l.__private__.getLayoutMode = function() {
                return S;
            }, l.__private__.setDisplayMode = l.setDisplayMode = function(t, e, n) {
                return q(t), R(e), T(n), this;
            }, {
                title: "",
                subject: "",
                author: "",
                keywords: "",
                creator: ""
            }), U = (l.__private__.getDocumentProperty = function(t) {
                if (-1 === Object.keys(D).indexOf(t)) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
                return D[t];
            }, l.__private__.getDocumentProperties = function(t) {
                return D;
            }, l.__private__.setDocumentProperties = l.setProperties = l.setDocumentProperties = function(t) {
                for(var e in D)D.hasOwnProperty(e) && t[e] && (D[e] = t[e]);
                return this;
            }, l.__private__.setDocumentProperty = function(t, e) {
                if (-1 === Object.keys(D).indexOf(t)) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
                return D[t] = e;
            }, 0), z = [], rt = {}, H = {}, W = 0, V = [], G = [], it = new oe(l), Y = r.hotfixes || [], J = l.__private__.newObject = function() {
                var t = X();
                return ot(t, !0), t;
            }, X = l.__private__.newObjectDeferred = function() {
                return z[++U] = function() {
                    return B;
                }, U;
            }, ot = function(t, e) {
                return e = "boolean" == typeof e && e, z[t] = B, e && tt(t + " 0 obj"), t;
            }, at = l.__private__.newAdditionalObject = function() {
                var t = {
                    objId: X(),
                    content: ""
                };
                return G.push(t), t;
            }, st = X(), lt = X(), ht = l.__private__.decodeColorString = function(t) {
                var e = t.split(" ");
                if (2 === e.length && ("g" === e[1] || "G" === e[1])) {
                    var n = parseFloat(e[0]);
                    e = [
                        n,
                        n,
                        n,
                        "r"
                    ];
                }
                for(var r = "#", i = 0; i < 3; i++)r += ("0" + Math.floor(255 * parseFloat(e[i])).toString(16)).slice(-2);
                return r;
            }, ut = l.__private__.encodeColorString = function(t) {
                var e;
                "string" == typeof t && (t = {
                    ch1: t
                });
                var n = t.ch1, r = t.ch2, i = t.ch3, o = t.ch4, a = (t.precision, "draw" === t.pdfColorType ? [
                    "G",
                    "RG",
                    "K"
                ] : [
                    "g",
                    "rg",
                    "k"
                ]);
                if ("string" == typeof n && "#" !== n.charAt(0)) {
                    var s = new RGBColor(n);
                    if (s.ok) n = s.toHex();
                    else if (!/^\d*\.?\d*$/.test(n)) throw new Error('Invalid color "' + n + '" passed to jsPDF.encodeColorString.');
                }
                if ("string" == typeof n && /^#[0-9A-Fa-f]{3}$/.test(n) && (n = "#" + n[1] + n[1] + n[2] + n[2] + n[3] + n[3]), "string" == typeof n && /^#[0-9A-Fa-f]{6}$/.test(n)) {
                    var l = parseInt(n.substr(1), 16);
                    n = l >> 16 & 255, r = l >> 8 & 255, i = 255 & l;
                }
                if (void 0 === r || void 0 === o && n === r && r === i) {
                    if ("string" == typeof n) e = n + " " + a[0];
                    else switch(t.precision){
                        case 2:
                            e = Z(n / 255) + " " + a[0];
                            break;
                        case 3:
                        default:
                            e = Q(n / 255) + " " + a[0];
                    }
                } else if (void 0 === o || "object" === se(o)) {
                    if (o && !isNaN(o.a) && 0 === o.a) return e = [
                        "1.000",
                        "1.000",
                        "1.000",
                        a[1]
                    ].join(" ");
                    if ("string" == typeof n) e = [
                        n,
                        r,
                        i,
                        a[1]
                    ].join(" ");
                    else switch(t.precision){
                        case 2:
                            e = [
                                Z(n / 255),
                                Z(r / 255),
                                Z(i / 255),
                                a[1]
                            ].join(" ");
                            break;
                        default:
                        case 3:
                            e = [
                                Q(n / 255),
                                Q(r / 255),
                                Q(i / 255),
                                a[1]
                            ].join(" ");
                    }
                } else if ("string" == typeof n) e = [
                    n,
                    r,
                    i,
                    o,
                    a[2]
                ].join(" ");
                else switch(t.precision){
                    case 2:
                        e = [
                            Z(n / 255),
                            Z(r / 255),
                            Z(i / 255),
                            Z(o / 255),
                            a[2]
                        ].join(" ");
                        break;
                    case 3:
                    default:
                        e = [
                            Q(n / 255),
                            Q(r / 255),
                            Q(i / 255),
                            Q(o / 255),
                            a[2]
                        ].join(" ");
                }
                return e;
            }, ct = l.__private__.getFilters = function() {
                return o;
            }, ft = l.__private__.putStream = function(t) {
                var e = (t = t || {}).data || "", n = t.filters || ct(), r = t.alreadyAppliedFilters || [], i = t.addLength1 || !1, o = e.length, a = {};
                !0 === n && (n = [
                    "FlateEncode"
                ]);
                var s = t.additionalKeyValues || [], l = (a = void 0 !== ae.API.processDataByFilters ? ae.API.processDataByFilters(e, n) : {
                    data: e,
                    reverseChain: []
                }).reverseChain + (Array.isArray(r) ? r.join(" ") : r.toString());
                0 !== a.data.length && (s.push({
                    key: "Length",
                    value: a.data.length
                }), !0 === i && s.push({
                    key: "Length1",
                    value: o
                })), 0 != l.length && (l.split("/").length - 1 == 1 ? s.push({
                    key: "Filter",
                    value: l
                }) : s.push({
                    key: "Filter",
                    value: "[" + l + "]"
                })), tt("<<");
                for(var h = 0; h < s.length; h++)tt("/" + s[h].key + " " + s[h].value);
                tt(">>"), 0 !== a.data.length && (tt("stream"), tt(a.data), tt("endstream"));
            }, pt = l.__private__.putPage = function(t) {
                t.mediaBox;
                var e = t.number, n = t.data, r = t.objId, i = t.contentsObjId;
                ot(r, !0);
                V[x].mediaBox.topRightX, V[x].mediaBox.bottomLeftX, V[x].mediaBox.topRightY, V[x].mediaBox.bottomLeftY;
                tt("<</Type /Page"), tt("/Parent " + t.rootDictionaryObjId + " 0 R"), tt("/Resources " + t.resourceDictionaryObjId + " 0 R"), tt("/MediaBox [" + parseFloat(Z(t.mediaBox.bottomLeftX)) + " " + parseFloat(Z(t.mediaBox.bottomLeftY)) + " " + Z(t.mediaBox.topRightX) + " " + Z(t.mediaBox.topRightY) + "]"), null !== t.cropBox && tt("/CropBox [" + Z(t.cropBox.bottomLeftX) + " " + Z(t.cropBox.bottomLeftY) + " " + Z(t.cropBox.topRightX) + " " + Z(t.cropBox.topRightY) + "]"), null !== t.bleedBox && tt("/BleedBox [" + Z(t.bleedBox.bottomLeftX) + " " + Z(t.bleedBox.bottomLeftY) + " " + Z(t.bleedBox.topRightX) + " " + Z(t.bleedBox.topRightY) + "]"), null !== t.trimBox && tt("/TrimBox [" + Z(t.trimBox.bottomLeftX) + " " + Z(t.trimBox.bottomLeftY) + " " + Z(t.trimBox.topRightX) + " " + Z(t.trimBox.topRightY) + "]"), null !== t.artBox && tt("/ArtBox [" + Z(t.artBox.bottomLeftX) + " " + Z(t.artBox.bottomLeftY) + " " + Z(t.artBox.topRightX) + " " + Z(t.artBox.topRightY) + "]"), "number" == typeof t.userUnit && 1 !== t.userUnit && tt("/UserUnit " + t.userUnit), it.publish("putPage", {
                    objId: r,
                    pageContext: V[e],
                    pageNumber: e,
                    page: n
                }), tt("/Contents " + i + " 0 R"), tt(">>"), tt("endobj");
                var o = n.join("\n");
                return ot(i, !0), ft({
                    data: o,
                    filters: ct()
                }), tt("endobj"), r;
            }, dt = l.__private__.putPages = function() {
                var t, e, n = [];
                for(t = 1; t <= W; t++)V[t].objId = X(), V[t].contentsObjId = X();
                for(t = 1; t <= W; t++)n.push(pt({
                    number: t,
                    data: I[t],
                    objId: V[t].objId,
                    contentsObjId: V[t].contentsObjId,
                    mediaBox: V[t].mediaBox,
                    cropBox: V[t].cropBox,
                    bleedBox: V[t].bleedBox,
                    trimBox: V[t].trimBox,
                    artBox: V[t].artBox,
                    userUnit: V[t].userUnit,
                    rootDictionaryObjId: st,
                    resourceDictionaryObjId: lt
                }));
                ot(st, !0), tt("<</Type /Pages");
                var r = "/Kids [";
                for(e = 0; e < W; e++)r += n[e] + " 0 R ";
                tt(r + "]"), tt("/Count " + W), tt(">>"), tt("endobj"), it.publish("postPutPages");
            }, gt = function() {
                !function() {
                    for(var t in rt)rt.hasOwnProperty(t) && (!1 === s || !0 === s && K.hasOwnProperty(t)) && (e = rt[t], it.publish("putFont", {
                        font: e,
                        out: tt,
                        newObject: J,
                        putStream: ft
                    }), !0 !== e.isAlreadyPutted && (e.objectNumber = J(), tt("<<"), tt("/Type /Font"), tt("/BaseFont /" + e.postScriptName), tt("/Subtype /Type1"), "string" == typeof e.encoding && tt("/Encoding /" + e.encoding), tt("/FirstChar 32"), tt("/LastChar 255"), tt(">>"), tt("endobj")));
                    var e;
                }(), it.publish("putResources"), ot(lt, !0), tt("<<"), function() {
                    for(var t in tt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), tt("/Font <<"), rt)rt.hasOwnProperty(t) && (!1 === s || !0 === s && K.hasOwnProperty(t)) && tt("/" + t + " " + rt[t].objectNumber + " 0 R");
                    tt(">>"), tt("/XObject <<"), it.publish("putXobjectDict"), tt(">>");
                }(), tt(">>"), tt("endobj"), it.publish("postPutResources");
            }, mt = function(t, e, n) {
                H.hasOwnProperty(e) || (H[e] = {}), H[e][n] = t;
            }, yt = function(t, e, n, r, i) {
                i = i || !1;
                var o = "F" + (Object.keys(rt).length + 1).toString(10), a = {
                    id: o,
                    postScriptName: t,
                    fontName: e,
                    fontStyle: n,
                    encoding: r,
                    isStandardFont: i,
                    metadata: {}
                };
                return it.publish("addFont", {
                    font: a,
                    instance: this
                }), void 0 !== o && (rt[o] = a, mt(o, e, n)), o;
            }, vt = l.__private__.pdfEscape = l.pdfEscape = function(t, e) {
                return (function(t, e) {
                    var n, r, i, o, a, s, l, h, u;
                    if (i = (e = e || {}).sourceEncoding || "Unicode", a = e.outputEncoding, (e.autoencode || a) && rt[$].metadata && rt[$].metadata[i] && rt[$].metadata[i].encoding && (o = rt[$].metadata[i].encoding, !a && rt[$].encoding && (a = rt[$].encoding), !a && o.codePages && (a = o.codePages[0]), "string" == typeof a && (a = o[a]), a)) {
                        for(l = !1, s = [], n = 0, r = t.length; n < r; n++)(h = a[t.charCodeAt(n)]) ? s.push(String.fromCharCode(h)) : s.push(t[n]), s[n].charCodeAt(0) >> 8 && (l = !0);
                        t = s.join("");
                    }
                    for(n = t.length; void 0 === l && 0 !== n;)t.charCodeAt(n - 1) >> 8 && (l = !0), n--;
                    if (!l) return t;
                    for(s = e.noBOM ? [] : [
                        254,
                        255
                    ], n = 0, r = t.length; n < r; n++){
                        if ((u = (h = t.charCodeAt(n)) >> 8) >> 8) throw new Error("Character at position " + n + " of string '" + t + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
                        s.push(u), s.push(h - (u << 8));
                    }
                    return String.fromCharCode.apply(void 0, s);
                })(t, e).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
            }, wt = l.__private__.beginPage = function(t, e) {
                var n, r = "string" == typeof e && e.toLowerCase();
                if ("string" == typeof t && (n = f(t.toLowerCase())) && (t = n[0], e = n[1]), Array.isArray(t) && (e = t[1], t = t[0]), (isNaN(t) || isNaN(e)) && (t = i[0], e = i[1]), r) {
                    switch(r.substr(0, 1)){
                        case "l":
                            t < e && (r = "s");
                            break;
                        case "p":
                            e < t && (r = "s");
                    }
                    "s" === r && (n = t, t = e, e = n);
                }
                (14400 < t || 14400 < e) && (console.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), t = Math.min(14400, t), e = Math.min(14400, e)), i = [
                    t,
                    e
                ], k = !0, I[++W] = [], V[W] = {
                    objId: 0,
                    contentsObjId: 0,
                    userUnit: Number(a),
                    artBox: null,
                    bleedBox: null,
                    cropBox: null,
                    trimBox: null,
                    mediaBox: {
                        bottomLeftX: 0,
                        bottomLeftY: 0,
                        topRightX: Number(t),
                        topRightY: Number(e)
                    }
                }, xt(W);
            }, bt = function() {
                wt.apply(this, arguments), Dt(Rt), tt(Jt), 0 !== te && tt(te + " J"), 0 !== ne && tt(ne + " j"), it.publish("addPage", {
                    pageNumber: W
                });
            }, xt = function(t) {
                0 < t && t <= W && (x = t);
            }, Nt = l.__private__.getNumberOfPages = l.getNumberOfPages = function() {
                return I.length - 1;
            }, Lt = function(t, e, n) {
                var r, i = void 0;
                return n = n || {}, t = void 0 !== t ? t : rt[$].fontName, e = void 0 !== e ? e : rt[$].fontStyle, r = t.toLowerCase(), void 0 !== H[r] && void 0 !== H[r][e] ? i = H[r][e] : void 0 !== H[t] && void 0 !== H[t][e] ? i = H[t][e] : !1 === n.disableWarning && console.warn("Unable to look up font label for font '" + t + "', '" + e + "'. Refer to getFontList() for available fonts."), i || n.noFallback || null == (i = H.times[e]) && (i = H.times.normal), i;
            }, At = l.__private__.putInfo = function() {
                for(var t in J(), tt("<<"), tt("/Producer (jsPDF " + ae.version + ")"), D)D.hasOwnProperty(t) && D[t] && tt("/" + t.substr(0, 1).toUpperCase() + t.substr(1) + " (" + vt(D[t]) + ")");
                tt("/CreationDate (" + p + ")"), tt(">>"), tt("endobj");
            }, St = l.__private__.putCatalog = function(t) {
                var e = (t = t || {}).rootDictionaryObjId || st;
                switch(J(), tt("<<"), tt("/Type /Catalog"), tt("/Pages " + e + " 0 R"), L || (L = "fullwidth"), L){
                    case "fullwidth":
                        tt("/OpenAction [3 0 R /FitH null]");
                        break;
                    case "fullheight":
                        tt("/OpenAction [3 0 R /FitV null]");
                        break;
                    case "fullpage":
                        tt("/OpenAction [3 0 R /Fit]");
                        break;
                    case "original":
                        tt("/OpenAction [3 0 R /XYZ null null 1]");
                        break;
                    default:
                        var n = "" + L;
                        "%" === n.substr(n.length - 1) && (L = parseInt(L) / 100), "number" == typeof L && tt("/OpenAction [3 0 R /XYZ null null " + Z(L) + "]");
                }
                switch(S || (S = "continuous"), S){
                    case "continuous":
                        tt("/PageLayout /OneColumn");
                        break;
                    case "single":
                        tt("/PageLayout /SinglePage");
                        break;
                    case "two":
                    case "twoleft":
                        tt("/PageLayout /TwoColumnLeft");
                        break;
                    case "tworight":
                        tt("/PageLayout /TwoColumnRight");
                }
                A && tt("/PageMode /" + A), it.publish("putCatalog"), tt(">>"), tt("endobj");
            }, _t = l.__private__.putTrailer = function() {
                tt("trailer"), tt("<<"), tt("/Size " + (U + 1)), tt("/Root " + U + " 0 R"), tt("/Info " + (U - 1) + " 0 R"), tt("/ID [ <" + d + "> <" + d + "> ]"), tt(">>");
            }, Ft = l.__private__.putHeader = function() {
                tt("%PDF-" + h), tt("%\xba\xdf\xac\xe0");
            }, Pt = l.__private__.putXRef = function() {
                var t = 1, e = "0000000000";
                for(tt("xref"), tt("0 " + (U + 1)), tt("0000000000 65535 f "), t = 1; t <= U; t++)"function" == typeof z[t] ? tt((e + z[t]()).slice(-10) + " 00000 n ") : void 0 !== z[t] ? tt((e + z[t]).slice(-10) + " 00000 n ") : tt("0000000000 00000 n ");
            }, kt = l.__private__.buildDocument = function() {
                k = !1, B = U = 0, C = [], z = [], G = [], st = X(), lt = X(), it.publish("buildDocument"), Ft(), dt(), function() {
                    it.publish("putAdditionalObjects");
                    for(var t = 0; t < G.length; t++){
                        var e = G[t];
                        ot(e.objId, !0), tt(e.content), tt("endobj");
                    }
                    it.publish("postPutAdditionalObjects");
                }(), gt(), At(), St();
                var t = B;
                return Pt(), _t(), tt("startxref"), tt("" + t), tt("%%EOF"), k = !0, C.join("\n");
            }, It = l.__private__.getBlob = function(t) {
                return new Blob([
                    E(t)
                ], {
                    type: "application/pdf"
                });
            }, Ct = l.output = l.__private__.output = ((F = function(t, e) {
                e = e || {};
                var n = kt();
                switch("string" == typeof e ? e = {
                    filename: e
                } : e.filename = e.filename || "generated.pdf", t){
                    case void 0:
                        return n;
                    case "save":
                        l.save(e.filename);
                        break;
                    case "arraybuffer":
                        return E(n);
                    case "blob":
                        return It(n);
                    case "bloburi":
                    case "bloburl":
                        if (void 0 !== ie.URL && "function" == typeof ie.URL.createObjectURL) return ie.URL && ie.URL.createObjectURL(It(n)) || void 0;
                        console.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
                        break;
                    case "datauristring":
                    case "dataurlstring":
                        return "data:application/pdf;filename=" + e.filename + ";base64," + btoa(n);
                    case "dataurlnewwindow":
                        var r = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring") + '"></iframe></body></html>', i = ie.open();
                        if (null !== i && i.document.write(r), i || "undefined" == typeof safari) return i;
                    case "datauri":
                    case "dataurl":
                        return ie.document.location.href = "data:application/pdf;filename=" + e.filename + ";base64," + btoa(n);
                    default:
                        return null;
                }
            }).foo = function() {
                try {
                    return F.apply(this, arguments);
                } catch (t) {
                    var e = t.stack || "";
                    ~e.indexOf(" at ") && (e = e.split(" at ")[1]);
                    var n = "Error in function " + e.split("\n")[0].split("<")[0] + ": " + t.message;
                    if (!ie.console) throw new Error(n);
                    ie.console.error(n, t), ie.alert && alert(n);
                }
            }, (F.foo.bar = F).foo), Bt = function(t) {
                return !0 === Array.isArray(Y) && -1 < Y.indexOf(t);
            };
            switch(e){
                case "pt":
                    _ = 1;
                    break;
                case "mm":
                    _ = 72 / 25.4;
                    break;
                case "cm":
                    _ = 72 / 2.54;
                    break;
                case "in":
                    _ = 72;
                    break;
                case "px":
                    _ = 1 == Bt("px_scaling") ? .75 : 96 / 72;
                    break;
                case "pc":
                case "em":
                    _ = 12;
                    break;
                case "ex":
                    _ = 6;
                    break;
                default:
                    throw new Error("Invalid unit: " + e);
            }
            w(), m();
            var jt = l.__private__.getPageInfo = function(t) {
                if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
                return {
                    objId: V[t].objId,
                    pageNumber: t,
                    pageContext: V[t]
                };
            }, Et = l.__private__.getPageInfoByObjId = function(t) {
                for(var e in V)if (V[e].objId === t) break;
                if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
                return jt(e);
            }, Mt = l.__private__.getCurrentPageInfo = function() {
                return {
                    objId: V[x].objId,
                    pageNumber: x,
                    pageContext: V[x]
                };
            };
            l.addPage = function() {
                return bt.apply(this, arguments), this;
            }, l.setPage = function() {
                return xt.apply(this, arguments), this;
            }, l.insertPage = function(t) {
                return this.addPage(), this.movePage(x, t), this;
            }, l.movePage = function(t, e) {
                if (e < t) {
                    for(var n = I[t], r = V[t], i = t; e < i; i--)I[i] = I[i - 1], V[i] = V[i - 1];
                    I[e] = n, V[e] = r, this.setPage(e);
                } else if (t < e) {
                    for(n = I[t], r = V[t], i = t; i < e; i++)I[i] = I[i + 1], V[i] = V[i + 1];
                    I[e] = n, V[e] = r, this.setPage(e);
                }
                return this;
            }, l.deletePage = function() {
                return (function(t) {
                    0 < t && t <= W && (I.splice(t, 1), --W < x && (x = W), this.setPage(x));
                }).apply(this, arguments), this;
            };
            l.__private__.text = l.text = function(t, e, n, i) {
                var r;
                "number" != typeof t || "number" != typeof e || "string" != typeof n && !Array.isArray(n) || (r = n, n = e, e = t, t = r);
                var o = arguments[3], a = arguments[4], s = arguments[5];
                if ("object" === se(o) && null !== o || ("string" == typeof a && (s = a, a = null), "string" == typeof o && (s = o, o = null), "number" == typeof o && (a = o, o = null), i = {
                    flags: o,
                    angle: a,
                    align: s
                }), (o = o || {}).noBOM = o.noBOM || !0, o.autoencode = o.autoencode || !0, isNaN(e) || isNaN(n) || null == t) throw new Error("Invalid arguments passed to jsPDF.text");
                if (0 === t.length) return c;
                var l, h = "", u = "number" == typeof i.lineHeightFactor ? i.lineHeightFactor : Tt, c = i.scope || this;
                function f(t) {
                    for(var e, n = t.concat(), r = [], i = n.length; i--;)"string" == typeof (e = n.shift()) ? r.push(e) : Array.isArray(t) && 1 === e.length ? r.push(e[0]) : r.push([
                        e[0],
                        e[1],
                        e[2]
                    ]);
                    return r;
                }
                function p(t, e) {
                    var n;
                    if ("string" == typeof t) n = e(t)[0];
                    else if (Array.isArray(t)) {
                        for(var r, i, o = t.concat(), a = [], s = o.length; s--;)"string" == typeof (r = o.shift()) ? a.push(e(r)[0]) : Array.isArray(r) && "string" === r[0] && (i = e(r[0], r[1], r[2]), a.push([
                            i[0],
                            i[1],
                            i[2]
                        ]));
                        n = a;
                    }
                    return n;
                }
                var d = !1, g = !0;
                if ("string" == typeof t) d = !0;
                else if (Array.isArray(t)) {
                    for(var m, y = t.concat(), v = [], w = y.length; w--;)("string" != typeof (m = y.shift()) || Array.isArray(m) && "string" != typeof m[0]) && (g = !1);
                    d = g;
                }
                if (!1 === d) throw new Error('Type of text must be string or Array. "' + t + '" is not recognized.');
                var b = rt[$].encoding;
                "WinAnsiEncoding" !== b && "StandardEncoding" !== b || (t = p(t, function(t, e, n) {
                    var r;
                    return [
                        (r = t, r = r.split("	").join(Array(i.TabLen || 9).join(" ")), vt(r, o)),
                        e,
                        n
                    ];
                })), "string" == typeof t && (t = t.match(/[\r?\n]/) ? t.split(/\r\n|\r|\n/g) : [
                    t
                ]);
                var x = et / c.internal.scaleFactor, N = x * (Tt - 1);
                switch(i.baseline){
                    case "bottom":
                        n -= N;
                        break;
                    case "top":
                        n += x - N;
                        break;
                    case "hanging":
                        n += x - 2 * N;
                        break;
                    case "middle":
                        n += x / 2 - N;
                }
                0 < (O = i.maxWidth || 0) && ("string" == typeof t ? t = c.splitTextToSize(t, O) : "[object Array]" === Object.prototype.toString.call(t) && (t = c.splitTextToSize(t.join(" "), O)));
                var L = {
                    text: t,
                    x: e,
                    y: n,
                    options: i,
                    mutex: {
                        pdfEscape: vt,
                        activeFontKey: $,
                        fonts: rt,
                        activeFontSize: et
                    }
                };
                it.publish("preProcessText", L), t = L.text;
                a = (i = L.options).angle;
                var A = c.internal.scaleFactor, S = [];
                if (a) {
                    a *= Math.PI / 180;
                    var _ = Math.cos(a), F = Math.sin(a);
                    S = [
                        Z(_),
                        Z(F),
                        Z(-1 * F),
                        Z(_)
                    ];
                }
                void 0 !== (M = i.charSpace) && (h += Q(M * A) + " Tc\n");
                i.lang;
                var P = -1, k = void 0 !== i.renderingMode ? i.renderingMode : i.stroke, I = c.internal.getCurrentPageInfo().pageContext;
                switch(k){
                    case 0:
                    case !1:
                    case "fill":
                        P = 0;
                        break;
                    case 1:
                    case !0:
                    case "stroke":
                        P = 1;
                        break;
                    case 2:
                    case "fillThenStroke":
                        P = 2;
                        break;
                    case 3:
                    case "invisible":
                        P = 3;
                        break;
                    case 4:
                    case "fillAndAddForClipping":
                        P = 4;
                        break;
                    case 5:
                    case "strokeAndAddPathForClipping":
                        P = 5;
                        break;
                    case 6:
                    case "fillThenStrokeAndAddToPathForClipping":
                        P = 6;
                        break;
                    case 7:
                    case "addToPathForClipping":
                        P = 7;
                }
                var C = void 0 !== I.usedRenderingMode ? I.usedRenderingMode : -1;
                -1 !== P ? h += P + " Tr\n" : -1 !== C && (h += "0 Tr\n"), -1 !== P && (I.usedRenderingMode = P);
                s = i.align || "left";
                var B = et * u, j = c.internal.pageSize.getWidth(), E = (A = c.internal.scaleFactor, rt[$]), M = i.charSpace || Qt, O = i.maxWidth || 0, q = (o = {}, []);
                if ("[object Array]" === Object.prototype.toString.call(t)) {
                    var T, R;
                    v = f(t);
                    "left" !== s && (R = v.map(function(t) {
                        return c.getStringUnitWidth(t, {
                            font: E,
                            charSpace: M,
                            fontSize: et
                        }) * et / A;
                    }));
                    var D, U = Math.max.apply(Math, R), z = 0;
                    if ("right" === s) {
                        e -= R[0], t = [];
                        var H = 0;
                        for(w = v.length; H < w; H++)R[H], T = 0 === H ? (D = Wt(e), Vt(n)) : (D = (z - R[H]) * A, -B), t.push([
                            v[H],
                            D,
                            T
                        ]), z = R[H];
                    } else if ("center" === s) {
                        e -= R[0] / 2, t = [];
                        for(H = 0, w = v.length; H < w; H++)R[H], T = 0 === H ? (D = Wt(e), Vt(n)) : (D = (z - R[H]) / 2 * A, -B), t.push([
                            v[H],
                            D,
                            T
                        ]), z = R[H];
                    } else if ("left" === s) {
                        t = [];
                        for(H = 0, w = v.length; H < w; H++)T = 0 === H ? Vt(n) : -B, D = 0 === H ? Wt(e) : 0, t.push(v[H]);
                    } else {
                        if ("justify" !== s) throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
                        t = [];
                        for(O = 0 !== O ? O : j, H = 0, w = v.length; H < w; H++)T = 0 === H ? Vt(n) : -B, D = 0 === H ? Wt(e) : 0, H < w - 1 && q.push(((O - R[H]) / (v[H].split(" ").length - 1) * A).toFixed(2)), t.push([
                            v[H],
                            D,
                            T
                        ]);
                    }
                }
                !0 === ("boolean" == typeof i.R2L ? i.R2L : nt) && (t = p(t, function(t, e, n) {
                    return [
                        t.split("").reverse().join(""),
                        e,
                        n
                    ];
                }));
                L = {
                    text: t,
                    x: e,
                    y: n,
                    options: i,
                    mutex: {
                        pdfEscape: vt,
                        activeFontKey: $,
                        fonts: rt,
                        activeFontSize: et
                    }
                };
                it.publish("postProcessText", L), t = L.text, l = L.mutex.isHex;
                v = f(t);
                t = [];
                var W, V, G, Y = 0, J = (w = v.length, "");
                for(H = 0; H < w; H++)J = "", Array.isArray(v[H]) ? (W = parseFloat(v[H][1]), V = parseFloat(v[H][2]), G = (l ? "<" : "(") + v[H][0] + (l ? ">" : ")"), Y = 1) : (W = Wt(e), V = Vt(n), G = (l ? "<" : "(") + v[H] + (l ? ">" : ")")), void 0 !== q && void 0 !== q[H] && (J = q[H] + " Tw\n"), 0 !== S.length && 0 === H ? t.push(J + S.join(" ") + " " + W.toFixed(2) + " " + V.toFixed(2) + " Tm\n" + G) : 1 === Y || 0 === Y && 0 === H ? t.push(J + W.toFixed(2) + " " + V.toFixed(2) + " Td\n" + G) : t.push(J + G);
                t = 0 === Y ? t.join(" Tj\nT* ") : t.join(" Tj\n"), t += " Tj\n";
                var X = "BT\n/" + $ + " " + et + " Tf\n" + (et * u).toFixed(2) + " TL\n" + Kt + "\n";
                return X += h, X += t, tt(X += "ET"), K[$] = !0, c;
            }, l.__private__.lstext = l.lstext = function(t, e, n, r) {
                return console.warn("jsPDF.lstext is deprecated"), this.text(t, e, n, {
                    charSpace: r
                });
            }, l.__private__.clip = l.clip = function(t) {
                tt("evenodd" === t ? "W*" : "W"), tt("n");
            }, l.__private__.clip_fixed = l.clip_fixed = function(t) {
                console.log("clip_fixed is deprecated"), l.clip(t);
            };
            var Ot = l.__private__.isValidStyle = function(t) {
                var e = !1;
                return -1 !== [
                    void 0,
                    null,
                    "S",
                    "F",
                    "DF",
                    "FD",
                    "f",
                    "f*",
                    "B",
                    "B*"
                ].indexOf(t) && (e = !0), e;
            }, qt = l.__private__.getStyle = function(t) {
                var e = "S";
                return "F" === t ? e = "f" : "FD" === t || "DF" === t ? e = "B" : "f" !== t && "f*" !== t && "B" !== t && "B*" !== t || (e = t), e;
            };
            l.__private__.line = l.line = function(t, e, n, r) {
                if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw new Error("Invalid arguments passed to jsPDF.line");
                return this.lines([
                    [
                        n - t,
                        r - e
                    ]
                ], t, e);
            }, l.__private__.lines = l.lines = function(t, e, n, r, i, o) {
                var a, s, l, h, u, c, f, p, d, g, m, y;
                if ("number" == typeof t && (y = n, n = e, e = t, t = y), r = r || [
                    1,
                    1
                ], o = o || !1, isNaN(e) || isNaN(n) || !Array.isArray(t) || !Array.isArray(r) || !Ot(i) || "boolean" != typeof o) throw new Error("Invalid arguments passed to jsPDF.lines");
                for(tt(Q(Wt(e)) + " " + Q(Vt(n)) + " m "), a = r[0], s = r[1], h = t.length, g = e, m = n, l = 0; l < h; l++)2 === (u = t[l]).length ? (g = u[0] * a + g, m = u[1] * s + m, tt(Q(Wt(g)) + " " + Q(Vt(m)) + " l")) : (c = u[0] * a + g, f = u[1] * s + m, p = u[2] * a + g, d = u[3] * s + m, g = u[4] * a + g, m = u[5] * s + m, tt(Q(Wt(c)) + " " + Q(Vt(f)) + " " + Q(Wt(p)) + " " + Q(Vt(d)) + " " + Q(Wt(g)) + " " + Q(Vt(m)) + " c"));
                return o && tt(" h"), null !== i && tt(qt(i)), this;
            }, l.__private__.rect = l.rect = function(t, e, n, r, i) {
                if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || !Ot(i)) throw new Error("Invalid arguments passed to jsPDF.rect");
                return tt([
                    Z(Wt(t)),
                    Z(Vt(e)),
                    Z(n * _),
                    Z(-r * _),
                    "re"
                ].join(" ")), null !== i && tt(qt(i)), this;
            }, l.__private__.triangle = l.triangle = function(t, e, n, r, i, o, a) {
                if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i) || isNaN(o) || !Ot(a)) throw new Error("Invalid arguments passed to jsPDF.triangle");
                return this.lines([
                    [
                        n - t,
                        r - e
                    ],
                    [
                        i - n,
                        o - r
                    ],
                    [
                        t - i,
                        e - o
                    ]
                ], t, e, [
                    1,
                    1
                ], a, !0), this;
            }, l.__private__.roundedRect = l.roundedRect = function(t, e, n, r, i, o, a) {
                if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i) || isNaN(o) || !Ot(a)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
                var s = 4 / 3 * (Math.SQRT2 - 1);
                return this.lines([
                    [
                        n - 2 * i,
                        0
                    ],
                    [
                        i * s,
                        0,
                        i,
                        o - o * s,
                        i,
                        o
                    ],
                    [
                        0,
                        r - 2 * o
                    ],
                    [
                        0,
                        o * s,
                        -i * s,
                        o,
                        -i,
                        o
                    ],
                    [
                        2 * i - n,
                        0
                    ],
                    [
                        -i * s,
                        0,
                        -i,
                        -o * s,
                        -i,
                        -o
                    ],
                    [
                        0,
                        2 * o - r
                    ],
                    [
                        0,
                        -o * s,
                        i * s,
                        -o,
                        i,
                        -o
                    ]
                ], t + i, e, [
                    1,
                    1
                ], a), this;
            }, l.__private__.ellipse = l.ellipse = function(t, e, n, r, i) {
                if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || !Ot(i)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
                var o = 4 / 3 * (Math.SQRT2 - 1) * n, a = 4 / 3 * (Math.SQRT2 - 1) * r;
                return tt([
                    Z(Wt(t + n)),
                    Z(Vt(e)),
                    "m",
                    Z(Wt(t + n)),
                    Z(Vt(e - a)),
                    Z(Wt(t + o)),
                    Z(Vt(e - r)),
                    Z(Wt(t)),
                    Z(Vt(e - r)),
                    "c"
                ].join(" ")), tt([
                    Z(Wt(t - o)),
                    Z(Vt(e - r)),
                    Z(Wt(t - n)),
                    Z(Vt(e - a)),
                    Z(Wt(t - n)),
                    Z(Vt(e)),
                    "c"
                ].join(" ")), tt([
                    Z(Wt(t - n)),
                    Z(Vt(e + a)),
                    Z(Wt(t - o)),
                    Z(Vt(e + r)),
                    Z(Wt(t)),
                    Z(Vt(e + r)),
                    "c"
                ].join(" ")), tt([
                    Z(Wt(t + o)),
                    Z(Vt(e + r)),
                    Z(Wt(t + n)),
                    Z(Vt(e + a)),
                    Z(Wt(t + n)),
                    Z(Vt(e)),
                    "c"
                ].join(" ")), null !== i && tt(qt(i)), this;
            }, l.__private__.circle = l.circle = function(t, e, n, r) {
                if (isNaN(t) || isNaN(e) || isNaN(n) || !Ot(r)) throw new Error("Invalid arguments passed to jsPDF.circle");
                return this.ellipse(t, e, n, n, r);
            };
            l.setFont = function(t, e) {
                return $ = Lt(t, e, {
                    disableWarning: !1
                }), this;
            }, l.setFontStyle = l.setFontType = function(t) {
                return $ = Lt(void 0, t), this;
            };
            l.__private__.getFontList = l.getFontList = function() {
                var t, e, n, r = {};
                for(t in H)if (H.hasOwnProperty(t)) for(e in r[t] = n = [], H[t])H[t].hasOwnProperty(e) && n.push(e);
                return r;
            };
            l.addFont = function(t, e, n, r) {
                yt.call(this, t, e, n, r = r || "Identity-H");
            };
            var Tt, Rt = r.lineWidth || .200025, Dt = l.__private__.setLineWidth = l.setLineWidth = function(t) {
                return tt((t * _).toFixed(2) + " w"), this;
            }, Ut = (l.__private__.setLineDash = ae.API.setLineDash = function(t, e) {
                if (t = t || [], e = e || 0, isNaN(e) || !Array.isArray(t)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
                return t = t.map(function(t) {
                    return (t * _).toFixed(3);
                }).join(" "), e = parseFloat((e * _).toFixed(3)), tt("[" + t + "] " + e + " d"), this;
            }, l.__private__.getLineHeight = l.getLineHeight = function() {
                return et * Tt;
            }), zt = (Ut = l.__private__.getLineHeight = l.getLineHeight = function() {
                return et * Tt;
            }, l.__private__.setLineHeightFactor = l.setLineHeightFactor = function(t) {
                return "number" == typeof (t = t || 1.15) && (Tt = t), this;
            }), Ht = l.__private__.getLineHeightFactor = l.getLineHeightFactor = function() {
                return Tt;
            };
            zt(r.lineHeight);
            var Wt = l.__private__.getHorizontalCoordinate = function(t) {
                return t * _;
            }, Vt = l.__private__.getVerticalCoordinate = function(t) {
                return V[x].mediaBox.topRightY - V[x].mediaBox.bottomLeftY - t * _;
            }, Gt = l.__private__.getHorizontalCoordinateString = function(t) {
                return Z(t * _);
            }, Yt = l.__private__.getVerticalCoordinateString = function(t) {
                return Z(V[x].mediaBox.topRightY - V[x].mediaBox.bottomLeftY - t * _);
            }, Jt = r.strokeColor || "0 G", Xt = (l.__private__.getStrokeColor = l.getDrawColor = function() {
                return ht(Jt);
            }, l.__private__.setStrokeColor = l.setDrawColor = function(t, e, n, r) {
                return Jt = ut({
                    ch1: t,
                    ch2: e,
                    ch3: n,
                    ch4: r,
                    pdfColorType: "draw",
                    precision: 2
                }), tt(Jt), this;
            }, r.fillColor || "0 g"), Kt = (l.__private__.getFillColor = l.getFillColor = function() {
                return ht(Xt);
            }, l.__private__.setFillColor = l.setFillColor = function(t, e, n, r) {
                return Xt = ut({
                    ch1: t,
                    ch2: e,
                    ch3: n,
                    ch4: r,
                    pdfColorType: "fill",
                    precision: 2
                }), tt(Xt), this;
            }, r.textColor || "0 g"), Zt = l.__private__.getTextColor = l.getTextColor = function() {
                return ht(Kt);
            }, Qt = (l.__private__.setTextColor = l.setTextColor = function(t, e, n, r) {
                return Kt = ut({
                    ch1: t,
                    ch2: e,
                    ch3: n,
                    ch4: r,
                    pdfColorType: "text",
                    precision: 3
                }), this;
            }, r.charSpace || 0), $t = l.__private__.getCharSpace = l.getCharSpace = function() {
                return Qt;
            }, te = (l.__private__.setCharSpace = l.setCharSpace = function(t) {
                if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
                return Qt = t, this;
            }, 0);
            l.CapJoinStyles = {
                0: 0,
                butt: 0,
                but: 0,
                miter: 0,
                1: 1,
                round: 1,
                rounded: 1,
                circle: 1,
                2: 2,
                projecting: 2,
                project: 2,
                square: 2,
                bevel: 2
            };
            l.__private__.setLineCap = l.setLineCap = function(t) {
                var e = l.CapJoinStyles[t];
                if (void 0 === e) throw new Error("Line cap style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
                return tt((te = e) + " J"), this;
            };
            var ee, ne = 0;
            l.__private__.setLineJoin = l.setLineJoin = function(t) {
                var e = l.CapJoinStyles[t];
                if (void 0 === e) throw new Error("Line join style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
                return tt((ne = e) + " j"), this;
            }, l.__private__.setMiterLimit = l.setMiterLimit = function(t) {
                if (t = t || 0, isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setMiterLimit");
                return ee = parseFloat(Z(t * _)), tt(ee + " M"), this;
            };
            for(var re in l.save = function(r, t) {
                if (r = r || "generated.pdf", (t = t || {}).returnPromise = t.returnPromise || !1, !1 !== t.returnPromise) return new Promise(function(t, e) {
                    try {
                        var n = le(It(kt()), r);
                        "function" == typeof le.unload && ie.setTimeout && setTimeout(le.unload, 911), t(n);
                    } catch (t) {
                        e(t.message);
                    }
                });
                le(It(kt()), r), "function" == typeof le.unload && ie.setTimeout && setTimeout(le.unload, 911);
            }, ae.API)ae.API.hasOwnProperty(re) && ("events" === re && ae.API.events.length ? function(t, e) {
                var n, r, i;
                for(i = e.length - 1; -1 !== i; i--)n = e[i][0], r = e[i][1], t.subscribe.apply(t, [
                    n
                ].concat("function" == typeof r ? [
                    r
                ] : r));
            }(it, ae.API.events) : l[re] = ae.API[re]);
            return l.internal = {
                pdfEscape: vt,
                getStyle: qt,
                getFont: function() {
                    return rt[Lt.apply(l, arguments)];
                },
                getFontSize: O,
                getCharSpace: $t,
                getTextColor: Zt,
                getLineHeight: Ut,
                getLineHeightFactor: Ht,
                write: j,
                getHorizontalCoordinate: Wt,
                getVerticalCoordinate: Vt,
                getCoordinateString: Gt,
                getVerticalCoordinateString: Yt,
                collections: {},
                newObject: J,
                newAdditionalObject: at,
                newObjectDeferred: X,
                newObjectDeferredBegin: ot,
                getFilters: ct,
                putStream: ft,
                events: it,
                scaleFactor: _,
                pageSize: {
                    getWidth: function() {
                        return (V[x].mediaBox.topRightX - V[x].mediaBox.bottomLeftX) / _;
                    },
                    setWidth: function(t) {
                        V[x].mediaBox.topRightX = t * _ + V[x].mediaBox.bottomLeftX;
                    },
                    getHeight: function() {
                        return (V[x].mediaBox.topRightY - V[x].mediaBox.bottomLeftY) / _;
                    },
                    setHeight: function(t) {
                        V[x].mediaBox.topRightY = t * _ + V[x].mediaBox.bottomLeftY;
                    }
                },
                output: Ct,
                getNumberOfPages: Nt,
                pages: I,
                out: tt,
                f2: Z,
                f3: Q,
                getPageInfo: jt,
                getPageInfoByObjId: Et,
                getCurrentPageInfo: Mt,
                getPDFVersion: u,
                hasHotfix: Bt
            }, Object.defineProperty(l.internal.pageSize, "width", {
                get: function() {
                    return (V[x].mediaBox.topRightX - V[x].mediaBox.bottomLeftX) / _;
                },
                set: function(t) {
                    V[x].mediaBox.topRightX = t * _ + V[x].mediaBox.bottomLeftX;
                },
                enumerable: !0,
                configurable: !0
            }), Object.defineProperty(l.internal.pageSize, "height", {
                get: function() {
                    return (V[x].mediaBox.topRightY - V[x].mediaBox.bottomLeftY) / _;
                },
                set: function(t) {
                    V[x].mediaBox.topRightY = t * _ + V[x].mediaBox.bottomLeftY;
                },
                enumerable: !0,
                configurable: !0
            }), function(t) {
                for(var e = 0, n = M.length; e < n; e++){
                    var r = yt(t[e][0], t[e][1], t[e][2], M[e][3], !0);
                    K[r] = !0;
                    var i = t[e][0].split("-");
                    mt(r, i[0], i[1] || "");
                }
                it.publish("addFonts", {
                    fonts: rt,
                    dictionary: H
                });
            }(M), $ = "F1", bt(i, t), it.publish("initialized"), l;
        }
        return ae.API = {
            events: []
        }, ae.version = "1.5.3", "function" == typeof define && define.amd ? define("jsPDF", function() {
            return ae;
        }) : (0, $d4a0bfe8d6ddfc13$exports) ? ($d4a0bfe8d6ddfc13$exports = ae, $d4a0bfe8d6ddfc13$exports.jsPDF = ae) : ie.jsPDF = ae, ae;
    }("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")());
    /**
   * @license
   * Copyright (c) 2016 Alexander Weidt,
   * https://github.com/BiggA94
   * 
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */ (function(t, e) {
        var A, n = 1, S = function(t) {
            return t.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
        }, y = function(t) {
            return t.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
        }, _ = function(t) {
            if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f2");
            return t.toFixed(2);
        }, s = function(t) {
            if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f2");
            return t.toFixed(5);
        };
        t.__acroform__ = {};
        var r = function(t, e) {
            t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
        }, v = function(t) {
            return t * n;
        }, w = function(t) {
            return t / n;
        }, l = function(t) {
            var e = new j, n = Y.internal.getHeight(t) || 0, r = Y.internal.getWidth(t) || 0;
            return e.BBox = [
                0,
                0,
                Number(_(r)),
                Number(_(n))
            ], e;
        }, i = t.__acroform__.setBit = function(t, e) {
            if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
            return t |= 1 << e;
        }, o = t.__acroform__.clearBit = function(t, e) {
            if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
            return t &= ~(1 << e);
        }, a = t.__acroform__.getBit = function(t, e) {
            if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
            return 0 == (t & 1 << e) ? 0 : 1;
        }, b = t.__acroform__.getBitForPdf = function(t, e) {
            if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
            return a(t, e - 1);
        }, x = t.__acroform__.setBitForPdf = function(t, e) {
            if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
            return i(t, e - 1);
        }, N = t.__acroform__.clearBitForPdf = function(t, e, n) {
            if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
            return o(t, e - 1);
        }, c = t.__acroform__.calculateCoordinates = function(t) {
            var e = this.internal.getHorizontalCoordinate, n = this.internal.getVerticalCoordinate, r = t[0], i = t[1], o = t[2], a = t[3], s = {};
            return s.lowerLeft_X = e(r) || 0, s.lowerLeft_Y = n(i + a) || 0, s.upperRight_X = e(r + o) || 0, s.upperRight_Y = n(i) || 0, [
                Number(_(s.lowerLeft_X)),
                Number(_(s.lowerLeft_Y)),
                Number(_(s.upperRight_X)),
                Number(_(s.upperRight_Y))
            ];
        }, f = function(t) {
            if (t.appearanceStreamContent) return t.appearanceStreamContent;
            if (t.V || t.DV) {
                var e = [], n = t.V || t.DV, r = h(t, n), i = A.internal.getFont(t.fontName, t.fontStyle).id;
                e.push("/Tx BMC"), e.push("q"), e.push("BT"), e.push(A.__private__.encodeColorString(t.color)), e.push("/" + i + " " + _(r.fontSize) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push(r.text), e.push("ET"), e.push("Q"), e.push("EMC");
                var o = new l(t);
                return o.stream = e.join("\n"), o;
            }
        }, h = function(i, t) {
            var e = i.maxFontSize || 12, n = (i.fontName, {
                text: "",
                fontSize: ""
            }), o = (t = ")" == (t = "(" == t.substr(0, 1) ? t.substr(1) : t).substr(t.length - 1) ? t.substr(0, t.length - 1) : t).split(" "), r = (A.__private__.encodeColorString(i.color), e), a = Y.internal.getHeight(i) || 0;
            a = a < 0 ? -a : a;
            var s = Y.internal.getWidth(i) || 0;
            s = s < 0 ? -s : s;
            var l = function(t, e, n) {
                if (t + 1 < o.length) {
                    var r = e + " " + o[t + 1];
                    return F(r, i, n).width <= s - 4;
                }
                return !1;
            };
            r++;
            t: for(;;){
                t = "";
                var h = F("3", i, --r).height, u = i.multiline ? a - r : (a - h) / 2, c = -2, f = u += 2, p = 0, d = 0, g = 0;
                if (r <= 0) {
                    t = "(...) Tj\n", t += "% Width of Text: " + F(t, i, r = 12).width + ", FieldWidth:" + s + "\n";
                    break;
                }
                g = F(o[0] + " ", i, r).width;
                var m = "", y = 0;
                for(var v in o)if (o.hasOwnProperty(v)) {
                    m = " " == (m += o[v] + " ").substr(m.length - 1) ? m.substr(0, m.length - 1) : m;
                    var w = parseInt(v);
                    g = F(m + " ", i, r).width;
                    var b = l(w, m, r), x = v >= o.length - 1;
                    if (b && !x) {
                        m += " ";
                        continue;
                    }
                    if (b || x) {
                        if (x) d = w;
                        else if (i.multiline && a < (h + 2) * (y + 2) + 2) continue t;
                    } else {
                        if (!i.multiline) continue t;
                        if (a < (h + 2) * (y + 2) + 2) continue t;
                        d = w;
                    }
                    for(var N = "", L = p; L <= d; L++)N += o[L] + " ";
                    switch(N = " " == N.substr(N.length - 1) ? N.substr(0, N.length - 1) : N, g = F(N, i, r).width, i.textAlign){
                        case "right":
                            c = s - g - 2;
                            break;
                        case "center":
                            c = (s - g) / 2;
                            break;
                        case "left":
                        default:
                            c = 2;
                    }
                    t += _(c) + " " + _(f) + " Td\n", t += "(" + S(N) + ") Tj\n", t += -_(c) + " 0 Td\n", f = -(r + 2), g = 0, p = d + 1, y++, m = "";
                }
                break;
            }
            return n.text = t, n.fontSize = r, n;
        }, F = function(t, e, n) {
            var r = A.internal.getFont(e.fontName, e.fontStyle), i = A.getStringUnitWidth(t, {
                font: r,
                fontSize: parseFloat(n),
                charSpace: 0
            }) * parseFloat(n);
            return {
                height: A.getStringUnitWidth("3", {
                    font: r,
                    fontSize: parseFloat(n),
                    charSpace: 0
                }) * parseFloat(n) * 1.5,
                width: i
            };
        }, u = {
            fields: [],
            xForms: [],
            acroFormDictionaryRoot: null,
            printedOut: !1,
            internal: null,
            isInitialized: !1
        }, p = function() {
            A.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
            var t = A.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
            for(var e in t)if (t.hasOwnProperty(e)) {
                var n = t[e];
                n.objId = void 0, n.hasAnnotation && d.call(A, n);
            }
        }, d = function(t) {
            var e = {
                type: "reference",
                object: t
            };
            void 0 === A.internal.getPageInfo(t.page).pageContext.annotations.find(function(t) {
                return t.type === e.type && t.object === e.object;
            }) && A.internal.getPageInfo(t.page).pageContext.annotations.push(e);
        }, g = function() {
            if (void 0 === A.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("putCatalogCallback: Root missing.");
            A.internal.write("/AcroForm " + A.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
        }, m = function() {
            A.internal.events.unsubscribe(A.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete A.internal.acroformPlugin.acroFormDictionaryRoot._eventID, A.internal.acroformPlugin.printedOut = !0;
        }, L = function(t) {
            var e = !t;
            t || (A.internal.newObjectDeferredBegin(A.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), A.internal.acroformPlugin.acroFormDictionaryRoot.putStream());
            t = t || A.internal.acroformPlugin.acroFormDictionaryRoot.Kids;
            for(var n in t)if (t.hasOwnProperty(n)) {
                var r = t[n], i = [], o = r.Rect;
                if (r.Rect && (r.Rect = c.call(this, r.Rect)), A.internal.newObjectDeferredBegin(r.objId, !0), r.DA = Y.createDefaultAppearanceStream(r), "object" === se(r) && "function" == typeof r.getKeyValueListForStream && (i = r.getKeyValueListForStream()), r.Rect = o, r.hasAppearanceStream && !r.appearanceStreamContent) {
                    var a = f.call(this, r);
                    i.push({
                        key: "AP",
                        value: "<</N " + a + ">>"
                    }), A.internal.acroformPlugin.xForms.push(a);
                }
                if (r.appearanceStreamContent) {
                    var s = "";
                    for(var l in r.appearanceStreamContent)if (r.appearanceStreamContent.hasOwnProperty(l)) {
                        var h = r.appearanceStreamContent[l];
                        if (s += "/" + l + " ", s += "<<", 1 <= Object.keys(h).length || Array.isArray(h)) for(var n in h){
                            var u;
                            if (h.hasOwnProperty(n)) "function" == typeof (u = h[n]) && (u = u.call(this, r)), s += "/" + n + " " + u + " ", 0 <= A.internal.acroformPlugin.xForms.indexOf(u) || A.internal.acroformPlugin.xForms.push(u);
                        }
                        else "function" == typeof (u = h) && (u = u.call(this, r)), s += "/" + n + " " + u, 0 <= A.internal.acroformPlugin.xForms.indexOf(u) || A.internal.acroformPlugin.xForms.push(u);
                        s += ">>";
                    }
                    i.push({
                        key: "AP",
                        value: "<<\n" + s + ">>"
                    });
                }
                A.internal.putStream({
                    additionalKeyValues: i
                }), A.internal.out("endobj");
            }
            e && P.call(this, A.internal.acroformPlugin.xForms);
        }, P = function(t) {
            for(var e in t)if (t.hasOwnProperty(e)) {
                var n = e, r = t[e];
                A.internal.newObjectDeferredBegin(r && r.objId, !0), "object" === se(r) && "function" == typeof r.putStream && r.putStream(), delete t[n];
            }
        }, k = function() {
            if (void 0 !== this.internal && (void 0 === this.internal.acroformPlugin || !1 === this.internal.acroformPlugin.isInitialized)) {
                if (A = this, M.FieldNum = 0, this.internal.acroformPlugin = JSON.parse(JSON.stringify(u)), this.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
                n = A.internal.scaleFactor, A.internal.acroformPlugin.acroFormDictionaryRoot = new E, A.internal.acroformPlugin.acroFormDictionaryRoot._eventID = A.internal.events.subscribe("postPutResources", m), A.internal.events.subscribe("buildDocument", p), A.internal.events.subscribe("putCatalog", g), A.internal.events.subscribe("postPutPages", L), A.internal.acroformPlugin.isInitialized = !0;
            }
        }, I = t.__acroform__.arrayToPdfArray = function(t) {
            if (Array.isArray(t)) {
                for(var e = "[", n = 0; n < t.length; n++)switch(0 !== n && (e += " "), se(t[n])){
                    case "boolean":
                    case "number":
                    case "object":
                        e += t[n].toString();
                        break;
                    case "string":
                        "/" !== t[n].substr(0, 1) ? e += "(" + S(t[n].toString()) + ")" : e += t[n].toString();
                }
                return e += "]";
            }
            throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
        };
        var C = function(t) {
            return (t = t || "").toString(), t = "(" + S(t) + ")";
        }, B = function() {
            var e;
            Object.defineProperty(this, "objId", {
                configurable: !0,
                get: function() {
                    if (e || (e = A.internal.newObjectDeferred()), !e) throw new Error("AcroFormPDFObject: Couldn't create Object ID");
                    return e;
                },
                set: function(t) {
                    e = t;
                }
            });
        };
        B.prototype.toString = function() {
            return this.objId + " 0 R";
        }, B.prototype.putStream = function() {
            var t = this.getKeyValueListForStream();
            A.internal.putStream({
                data: this.stream,
                additionalKeyValues: t
            }), A.internal.out("endobj");
        }, B.prototype.getKeyValueListForStream = function() {
            return function(t) {
                var e = [], n = Object.getOwnPropertyNames(t).filter(function(t) {
                    return "content" != t && "appearanceStreamContent" != t && "_" != t.substring(0, 1);
                });
                for(var r in n)if (!1 === Object.getOwnPropertyDescriptor(t, n[r]).configurable) {
                    var i = n[r], o = t[i];
                    o && (Array.isArray(o) ? e.push({
                        key: i,
                        value: I(o)
                    }) : o instanceof B ? e.push({
                        key: i,
                        value: o.objId + " 0 R"
                    }) : "function" != typeof o && e.push({
                        key: i,
                        value: o
                    }));
                }
                return e;
            }(this);
        };
        var j = function() {
            B.call(this), Object.defineProperty(this, "Type", {
                value: "/XObject",
                configurable: !1,
                writeable: !0
            }), Object.defineProperty(this, "Subtype", {
                value: "/Form",
                configurable: !1,
                writeable: !0
            }), Object.defineProperty(this, "FormType", {
                value: 1,
                configurable: !1,
                writeable: !0
            });
            var e, n = [];
            Object.defineProperty(this, "BBox", {
                configurable: !1,
                writeable: !0,
                get: function() {
                    return n;
                },
                set: function(t) {
                    n = t;
                }
            }), Object.defineProperty(this, "Resources", {
                value: "2 0 R",
                configurable: !1,
                writeable: !0
            }), Object.defineProperty(this, "stream", {
                enumerable: !1,
                configurable: !0,
                set: function(t) {
                    e = t.trim();
                },
                get: function() {
                    return e || null;
                }
            });
        };
        r(j, B);
        var E = function() {
            B.call(this);
            var e, t = [];
            Object.defineProperty(this, "Kids", {
                enumerable: !1,
                configurable: !0,
                get: function() {
                    return 0 < t.length ? t : void 0;
                }
            }), Object.defineProperty(this, "Fields", {
                enumerable: !1,
                configurable: !1,
                get: function() {
                    return t;
                }
            }), Object.defineProperty(this, "DA", {
                enumerable: !1,
                configurable: !1,
                get: function() {
                    if (e) return "(" + e + ")";
                },
                set: function(t) {
                    e = t;
                }
            });
        };
        r(E, B);
        var M = function t() {
            B.call(this);
            var e = 4;
            Object.defineProperty(this, "F", {
                enumerable: !1,
                configurable: !1,
                get: function() {
                    return e;
                },
                set: function(t) {
                    if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute F supplied.');
                    e = t;
                }
            }), Object.defineProperty(this, "showWhenPrinted", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(e, 3));
                },
                set: function(t) {
                    !0 === Boolean(t) ? this.F = x(e, 3) : this.F = N(e, 3);
                }
            });
            var n = 0;
            Object.defineProperty(this, "Ff", {
                enumerable: !1,
                configurable: !1,
                get: function() {
                    return n;
                },
                set: function(t) {
                    if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute Ff supplied.');
                    n = t;
                }
            });
            var r = [];
            Object.defineProperty(this, "Rect", {
                enumerable: !1,
                configurable: !1,
                get: function() {
                    if (0 !== r.length) return r;
                },
                set: function(t) {
                    r = void 0 !== t ? t : [];
                }
            }), Object.defineProperty(this, "x", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return !r || isNaN(r[0]) ? 0 : w(r[0]);
                },
                set: function(t) {
                    r[0] = v(t);
                }
            }), Object.defineProperty(this, "y", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return !r || isNaN(r[1]) ? 0 : w(r[1]);
                },
                set: function(t) {
                    r[1] = v(t);
                }
            }), Object.defineProperty(this, "width", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return !r || isNaN(r[2]) ? 0 : w(r[2]);
                },
                set: function(t) {
                    r[2] = v(t);
                }
            }), Object.defineProperty(this, "height", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return !r || isNaN(r[3]) ? 0 : w(r[3]);
                },
                set: function(t) {
                    r[3] = v(t);
                }
            });
            var i = "";
            Object.defineProperty(this, "FT", {
                enumerable: !0,
                configurable: !1,
                get: function() {
                    return i;
                },
                set: function(t) {
                    switch(t){
                        case "/Btn":
                        case "/Tx":
                        case "/Ch":
                        case "/Sig":
                            i = t;
                            break;
                        default:
                            throw new Error('Invalid value "' + t + '" for attribute FT supplied.');
                    }
                }
            });
            var o = null;
            Object.defineProperty(this, "T", {
                enumerable: !0,
                configurable: !1,
                get: function() {
                    if (!o || o.length < 1) {
                        if (this instanceof H) return;
                        o = "FieldObject" + t.FieldNum++;
                    }
                    return "(" + S(o) + ")";
                },
                set: function(t) {
                    o = t.toString();
                }
            }), Object.defineProperty(this, "fieldName", {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return o;
                },
                set: function(t) {
                    o = t;
                }
            });
            var a = "helvetica";
            Object.defineProperty(this, "fontName", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return a;
                },
                set: function(t) {
                    a = t;
                }
            });
            var s = "normal";
            Object.defineProperty(this, "fontStyle", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return s;
                },
                set: function(t) {
                    s = t;
                }
            });
            var l = 0;
            Object.defineProperty(this, "fontSize", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return w(l);
                },
                set: function(t) {
                    l = v(t);
                }
            });
            var h = 50;
            Object.defineProperty(this, "maxFontSize", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return w(h);
                },
                set: function(t) {
                    h = v(t);
                }
            });
            var u = "black";
            Object.defineProperty(this, "color", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return u;
                },
                set: function(t) {
                    u = t;
                }
            });
            var c = "/F1 0 Tf 0 g";
            Object.defineProperty(this, "DA", {
                enumerable: !0,
                configurable: !1,
                get: function() {
                    if (!(!c || this instanceof H || this instanceof V)) return C(c);
                },
                set: function(t) {
                    t = t.toString(), c = t;
                }
            });
            var f = null;
            Object.defineProperty(this, "DV", {
                enumerable: !1,
                configurable: !1,
                get: function() {
                    if (f) return this instanceof D == !1 ? C(f) : f;
                },
                set: function(t) {
                    t = t.toString(), f = this instanceof D == !1 ? "(" === t.substr(0, 1) ? y(t.substr(1, t.length - 2)) : y(t) : t;
                }
            }), Object.defineProperty(this, "defaultValue", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return this instanceof D == !0 ? y(f.substr(1, f.length - 1)) : f;
                },
                set: function(t) {
                    t = t.toString(), f = this instanceof D == !0 ? "/" + t : t;
                }
            });
            var p = null;
            Object.defineProperty(this, "V", {
                enumerable: !1,
                configurable: !1,
                get: function() {
                    if (p) return this instanceof D == !1 ? C(p) : p;
                },
                set: function(t) {
                    t = t.toString(), p = this instanceof D == !1 ? "(" === t.substr(0, 1) ? y(t.substr(1, t.length - 2)) : y(t) : t;
                }
            }), Object.defineProperty(this, "value", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return this instanceof D == !0 ? y(p.substr(1, p.length - 1)) : p;
                },
                set: function(t) {
                    t = t.toString(), p = this instanceof D == !0 ? "/" + t : t;
                }
            }), Object.defineProperty(this, "hasAnnotation", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return this.Rect;
                }
            }), Object.defineProperty(this, "Type", {
                enumerable: !0,
                configurable: !1,
                get: function() {
                    return this.hasAnnotation ? "/Annot" : null;
                }
            }), Object.defineProperty(this, "Subtype", {
                enumerable: !0,
                configurable: !1,
                get: function() {
                    return this.hasAnnotation ? "/Widget" : null;
                }
            });
            var d, g = !1;
            Object.defineProperty(this, "hasAppearanceStream", {
                enumerable: !0,
                configurable: !0,
                writeable: !0,
                get: function() {
                    return g;
                },
                set: function(t) {
                    t = Boolean(t), g = t;
                }
            }), Object.defineProperty(this, "page", {
                enumerable: !0,
                configurable: !0,
                writeable: !0,
                get: function() {
                    if (d) return d;
                },
                set: function(t) {
                    d = t;
                }
            }), Object.defineProperty(this, "readOnly", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(this.Ff, 1));
                },
                set: function(t) {
                    !0 === Boolean(t) ? this.Ff = x(this.Ff, 1) : this.Ff = N(this.Ff, 1);
                }
            }), Object.defineProperty(this, "required", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(this.Ff, 2));
                },
                set: function(t) {
                    !0 === Boolean(t) ? this.Ff = x(this.Ff, 2) : this.Ff = N(this.Ff, 2);
                }
            }), Object.defineProperty(this, "noExport", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(this.Ff, 3));
                },
                set: function(t) {
                    !0 === Boolean(t) ? this.Ff = x(this.Ff, 3) : this.Ff = N(this.Ff, 3);
                }
            });
            var m = null;
            Object.defineProperty(this, "Q", {
                enumerable: !0,
                configurable: !1,
                get: function() {
                    if (null !== m) return m;
                },
                set: function(t) {
                    if (-1 === [
                        0,
                        1,
                        2
                    ].indexOf(t)) throw new Error('Invalid value "' + t + '" for attribute Q supplied.');
                    m = t;
                }
            }), Object.defineProperty(this, "textAlign", {
                get: function() {
                    var t = "left";
                    switch(m){
                        case 0:
                        default:
                            t = "left";
                            break;
                        case 1:
                            t = "center";
                            break;
                        case 2:
                            t = "right";
                    }
                    return t;
                },
                configurable: !0,
                enumerable: !0,
                set: function(t) {
                    switch(t){
                        case "right":
                        case 2:
                            m = 2;
                            break;
                        case "center":
                        case 1:
                            m = 1;
                            break;
                        case "left":
                        case 0:
                        default:
                            m = 0;
                    }
                }
            });
        };
        r(M, B);
        var O = function() {
            M.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
            var e = 0;
            Object.defineProperty(this, "TI", {
                enumerable: !0,
                configurable: !1,
                get: function() {
                    return e;
                },
                set: function(t) {
                    e = t;
                }
            }), Object.defineProperty(this, "topIndex", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return e;
                },
                set: function(t) {
                    e = t;
                }
            });
            var r = [];
            Object.defineProperty(this, "Opt", {
                enumerable: !0,
                configurable: !1,
                get: function() {
                    return I(r);
                },
                set: function(t) {
                    var e, n;
                    n = [], "string" == typeof (e = t) && (n = function(t, e, n) {
                        n || (n = 1);
                        for(var r, i = []; r = e.exec(t);)i.push(r[n]);
                        return i;
                    }(e, /\((.*?)\)/g)), r = n;
                }
            }), this.getOptions = function() {
                return r;
            }, this.setOptions = function(t) {
                r = t, this.sort && r.sort();
            }, this.addOption = function(t) {
                t = (t = t || "").toString(), r.push(t), this.sort && r.sort();
            }, this.removeOption = function(t, e) {
                for(e = e || !1, t = (t = t || "").toString(); -1 !== r.indexOf(t) && (r.splice(r.indexOf(t), 1), !1 !== e););
            }, Object.defineProperty(this, "combo", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(this.Ff, 18));
                },
                set: function(t) {
                    !0 === Boolean(t) ? this.Ff = x(this.Ff, 18) : this.Ff = N(this.Ff, 18);
                }
            }), Object.defineProperty(this, "edit", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(this.Ff, 19));
                },
                set: function(t) {
                    !0 === this.combo && (!0 === Boolean(t) ? this.Ff = x(this.Ff, 19) : this.Ff = N(this.Ff, 19));
                }
            }), Object.defineProperty(this, "sort", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(this.Ff, 20));
                },
                set: function(t) {
                    !0 === Boolean(t) ? (this.Ff = x(this.Ff, 20), r.sort()) : this.Ff = N(this.Ff, 20);
                }
            }), Object.defineProperty(this, "multiSelect", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(this.Ff, 22));
                },
                set: function(t) {
                    !0 === Boolean(t) ? this.Ff = x(this.Ff, 22) : this.Ff = N(this.Ff, 22);
                }
            }), Object.defineProperty(this, "doNotSpellCheck", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(this.Ff, 23));
                },
                set: function(t) {
                    !0 === Boolean(t) ? this.Ff = x(this.Ff, 23) : this.Ff = N(this.Ff, 23);
                }
            }), Object.defineProperty(this, "commitOnSelChange", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(this.Ff, 27));
                },
                set: function(t) {
                    !0 === Boolean(t) ? this.Ff = x(this.Ff, 27) : this.Ff = N(this.Ff, 27);
                }
            }), this.hasAppearanceStream = !1;
        };
        r(O, M);
        var q = function() {
            O.call(this), this.fontName = "helvetica", this.combo = !1;
        };
        r(q, O);
        var T = function() {
            q.call(this), this.combo = !0;
        };
        r(T, q);
        var R = function() {
            T.call(this), this.edit = !0;
        };
        r(R, T);
        var D = function() {
            M.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(this.Ff, 15));
                },
                set: function(t) {
                    !0 === Boolean(t) ? this.Ff = x(this.Ff, 15) : this.Ff = N(this.Ff, 15);
                }
            }), Object.defineProperty(this, "radio", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(this.Ff, 16));
                },
                set: function(t) {
                    !0 === Boolean(t) ? this.Ff = x(this.Ff, 16) : this.Ff = N(this.Ff, 16);
                }
            }), Object.defineProperty(this, "pushButton", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(this.Ff, 17));
                },
                set: function(t) {
                    !0 === Boolean(t) ? this.Ff = x(this.Ff, 17) : this.Ff = N(this.Ff, 17);
                }
            }), Object.defineProperty(this, "radioIsUnison", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(this.Ff, 26));
                },
                set: function(t) {
                    !0 === Boolean(t) ? this.Ff = x(this.Ff, 26) : this.Ff = N(this.Ff, 26);
                }
            });
            var e, n = {};
            Object.defineProperty(this, "MK", {
                enumerable: !1,
                configurable: !1,
                get: function() {
                    if (0 !== Object.keys(n).length) {
                        var t, e = [];
                        for(t in e.push("<<"), n)e.push("/" + t + " (" + n[t] + ")");
                        return e.push(">>"), e.join("\n");
                    }
                },
                set: function(t) {
                    "object" === se(t) && (n = t);
                }
            }), Object.defineProperty(this, "caption", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return n.CA || "";
                },
                set: function(t) {
                    "string" == typeof t && (n.CA = t);
                }
            }), Object.defineProperty(this, "AS", {
                enumerable: !1,
                configurable: !1,
                get: function() {
                    return e;
                },
                set: function(t) {
                    e = t;
                }
            }), Object.defineProperty(this, "appearanceState", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return e.substr(1, e.length - 1);
                },
                set: function(t) {
                    e = "/" + t;
                }
            });
        };
        r(D, M);
        var U = function() {
            D.call(this), this.pushButton = !0;
        };
        r(U, D);
        var z = function() {
            D.call(this), this.radio = !0, this.pushButton = !1;
            var e = [];
            Object.defineProperty(this, "Kids", {
                enumerable: !0,
                configurable: !1,
                get: function() {
                    return e;
                },
                set: function(t) {
                    e = void 0 !== t ? t : [];
                }
            });
        };
        r(z, D);
        var H = function() {
            var e, n;
            M.call(this), Object.defineProperty(this, "Parent", {
                enumerable: !1,
                configurable: !1,
                get: function() {
                    return e;
                },
                set: function(t) {
                    e = t;
                }
            }), Object.defineProperty(this, "optionName", {
                enumerable: !1,
                configurable: !0,
                get: function() {
                    return n;
                },
                set: function(t) {
                    n = t;
                }
            });
            var r, i = {};
            Object.defineProperty(this, "MK", {
                enumerable: !1,
                configurable: !1,
                get: function() {
                    var t, e = [];
                    for(t in e.push("<<"), i)e.push("/" + t + " (" + i[t] + ")");
                    return e.push(">>"), e.join("\n");
                },
                set: function(t) {
                    "object" === se(t) && (i = t);
                }
            }), Object.defineProperty(this, "caption", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return i.CA || "";
                },
                set: function(t) {
                    "string" == typeof t && (i.CA = t);
                }
            }), Object.defineProperty(this, "AS", {
                enumerable: !1,
                configurable: !1,
                get: function() {
                    return r;
                },
                set: function(t) {
                    r = t;
                }
            }), Object.defineProperty(this, "appearanceState", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return r.substr(1, r.length - 1);
                },
                set: function(t) {
                    r = "/" + t;
                }
            }), this.optionName = name, this.caption = "l", this.appearanceState = "Off", this._AppearanceType = Y.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(name);
        };
        r(H, M), z.prototype.setAppearance = function(t) {
            if (!("createAppearanceStream" in t && "getCA" in t)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
            for(var e in this.Kids)if (this.Kids.hasOwnProperty(e)) {
                var n = this.Kids[e];
                n.appearanceStreamContent = t.createAppearanceStream(n.optionName), n.caption = t.getCA();
            }
        }, z.prototype.createOption = function(t) {
            this.Kids.length;
            var e = new H;
            return e.Parent = this, e.optionName = t, this.Kids.push(e), J.call(this, e), e;
        };
        var W = function() {
            D.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = Y.CheckBox.createAppearanceStream();
        };
        r(W, D);
        var V = function() {
            M.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(this.Ff, 13));
                },
                set: function(t) {
                    !0 === Boolean(t) ? this.Ff = x(this.Ff, 13) : this.Ff = N(this.Ff, 13);
                }
            }), Object.defineProperty(this, "fileSelect", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(this.Ff, 21));
                },
                set: function(t) {
                    !0 === Boolean(t) ? this.Ff = x(this.Ff, 21) : this.Ff = N(this.Ff, 21);
                }
            }), Object.defineProperty(this, "doNotSpellCheck", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(this.Ff, 23));
                },
                set: function(t) {
                    !0 === Boolean(t) ? this.Ff = x(this.Ff, 23) : this.Ff = N(this.Ff, 23);
                }
            }), Object.defineProperty(this, "doNotScroll", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(this.Ff, 24));
                },
                set: function(t) {
                    !0 === Boolean(t) ? this.Ff = x(this.Ff, 24) : this.Ff = N(this.Ff, 24);
                }
            }), Object.defineProperty(this, "comb", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(this.Ff, 25));
                },
                set: function(t) {
                    !0 === Boolean(t) ? this.Ff = x(this.Ff, 25) : this.Ff = N(this.Ff, 25);
                }
            }), Object.defineProperty(this, "richText", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(this.Ff, 26));
                },
                set: function(t) {
                    !0 === Boolean(t) ? this.Ff = x(this.Ff, 26) : this.Ff = N(this.Ff, 26);
                }
            });
            var e = null;
            Object.defineProperty(this, "MaxLen", {
                enumerable: !0,
                configurable: !1,
                get: function() {
                    return e;
                },
                set: function(t) {
                    e = t;
                }
            }), Object.defineProperty(this, "maxLength", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return e;
                },
                set: function(t) {
                    Number.isInteger(t) && (e = t);
                }
            }), Object.defineProperty(this, "hasAppearanceStream", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return this.V || this.DV;
                }
            });
        };
        r(V, M);
        var G = function() {
            V.call(this), Object.defineProperty(this, "password", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return Boolean(b(this.Ff, 14));
                },
                set: function(t) {
                    !0 === Boolean(t) ? this.Ff = x(this.Ff, 14) : this.Ff = N(this.Ff, 14);
                }
            }), this.password = !0;
        };
        r(G, V);
        var Y = {
            CheckBox: {
                createAppearanceStream: function() {
                    return {
                        N: {
                            On: Y.CheckBox.YesNormal
                        },
                        D: {
                            On: Y.CheckBox.YesPushDown,
                            Off: Y.CheckBox.OffPushDown
                        }
                    };
                },
                YesPushDown: function(t) {
                    var e = l(t), n = [], r = A.internal.getFont(t.fontName, t.fontStyle).id, i = A.__private__.encodeColorString(t.color), o = h(t, t.caption);
                    return n.push("0.749023 g"), n.push("0 0 " + _(Y.internal.getWidth(t)) + " " + _(Y.internal.getHeight(t)) + " re"), n.push("f"), n.push("BMC"), n.push("q"), n.push("0 0 1 rg"), n.push("/" + r + " " + _(o.fontSize) + " Tf " + i), n.push("BT"), n.push(o.text), n.push("ET"), n.push("Q"), n.push("EMC"), e.stream = n.join("\n"), e;
                },
                YesNormal: function(t) {
                    var e = l(t), n = A.internal.getFont(t.fontName, t.fontStyle).id, r = A.__private__.encodeColorString(t.color), i = [], o = Y.internal.getHeight(t), a = Y.internal.getWidth(t), s = h(t, t.caption);
                    return i.push("1 g"), i.push("0 0 " + _(a) + " " + _(o) + " re"), i.push("f"), i.push("q"), i.push("0 0 1 rg"), i.push("0 0 " + _(a - 1) + " " + _(o - 1) + " re"), i.push("W"), i.push("n"), i.push("0 g"), i.push("BT"), i.push("/" + n + " " + _(s.fontSize) + " Tf " + r), i.push(s.text), i.push("ET"), i.push("Q"), e.stream = i.join("\n"), e;
                },
                OffPushDown: function(t) {
                    var e = l(t), n = [];
                    return n.push("0.749023 g"), n.push("0 0 " + _(Y.internal.getWidth(t)) + " " + _(Y.internal.getHeight(t)) + " re"), n.push("f"), e.stream = n.join("\n"), e;
                }
            },
            RadioButton: {
                Circle: {
                    createAppearanceStream: function(t) {
                        var e = {
                            D: {
                                Off: Y.RadioButton.Circle.OffPushDown
                            },
                            N: {}
                        };
                        return e.N[t] = Y.RadioButton.Circle.YesNormal, e.D[t] = Y.RadioButton.Circle.YesPushDown, e;
                    },
                    getCA: function() {
                        return "l";
                    },
                    YesNormal: function(t) {
                        var e = l(t), n = [], r = Y.internal.getWidth(t) <= Y.internal.getHeight(t) ? Y.internal.getWidth(t) / 4 : Y.internal.getHeight(t) / 4;
                        r = Number((.9 * r).toFixed(5));
                        var i = Y.internal.Bezier_C, o = Number((r * i).toFixed(5));
                        return n.push("q"), n.push("1 0 0 1 " + s(Y.internal.getWidth(t) / 2) + " " + s(Y.internal.getHeight(t) / 2) + " cm"), n.push(r + " 0 m"), n.push(r + " " + o + " " + o + " " + r + " 0 " + r + " c"), n.push("-" + o + " " + r + " -" + r + " " + o + " -" + r + " 0 c"), n.push("-" + r + " -" + o + " -" + o + " -" + r + " 0 -" + r + " c"), n.push(o + " -" + r + " " + r + " -" + o + " " + r + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
                    },
                    YesPushDown: function(t) {
                        var e = l(t), n = [], r = Y.internal.getWidth(t) <= Y.internal.getHeight(t) ? Y.internal.getWidth(t) / 4 : Y.internal.getHeight(t) / 4, i = (r = Number((.9 * r).toFixed(5)), Number((2 * r).toFixed(5))), o = Number((i * Y.internal.Bezier_C).toFixed(5)), a = Number((r * Y.internal.Bezier_C).toFixed(5));
                        return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + s(Y.internal.getWidth(t) / 2) + " " + s(Y.internal.getHeight(t) / 2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + o + " " + o + " " + i + " 0 " + i + " c"), n.push("-" + o + " " + i + " -" + i + " " + o + " -" + i + " 0 c"), n.push("-" + i + " -" + o + " -" + o + " -" + i + " 0 -" + i + " c"), n.push(o + " -" + i + " " + i + " -" + o + " " + i + " 0 c"), n.push("f"), n.push("Q"), n.push("0 g"), n.push("q"), n.push("1 0 0 1 " + s(Y.internal.getWidth(t) / 2) + " " + s(Y.internal.getHeight(t) / 2) + " cm"), n.push(r + " 0 m"), n.push(r + " " + a + " " + a + " " + r + " 0 " + r + " c"), n.push("-" + a + " " + r + " -" + r + " " + a + " -" + r + " 0 c"), n.push("-" + r + " -" + a + " -" + a + " -" + r + " 0 -" + r + " c"), n.push(a + " -" + r + " " + r + " -" + a + " " + r + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
                    },
                    OffPushDown: function(t) {
                        var e = l(t), n = [], r = Y.internal.getWidth(t) <= Y.internal.getHeight(t) ? Y.internal.getWidth(t) / 4 : Y.internal.getHeight(t) / 4, i = (r = Number((.9 * r).toFixed(5)), Number((2 * r).toFixed(5))), o = Number((i * Y.internal.Bezier_C).toFixed(5));
                        return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + s(Y.internal.getWidth(t) / 2) + " " + s(Y.internal.getHeight(t) / 2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + o + " " + o + " " + i + " 0 " + i + " c"), n.push("-" + o + " " + i + " -" + i + " " + o + " -" + i + " 0 c"), n.push("-" + i + " -" + o + " -" + o + " -" + i + " 0 -" + i + " c"), n.push(o + " -" + i + " " + i + " -" + o + " " + i + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
                    }
                },
                Cross: {
                    createAppearanceStream: function(t) {
                        var e = {
                            D: {
                                Off: Y.RadioButton.Cross.OffPushDown
                            },
                            N: {}
                        };
                        return e.N[t] = Y.RadioButton.Cross.YesNormal, e.D[t] = Y.RadioButton.Cross.YesPushDown, e;
                    },
                    getCA: function() {
                        return "8";
                    },
                    YesNormal: function(t) {
                        var e = l(t), n = [], r = Y.internal.calculateCross(t);
                        return n.push("q"), n.push("1 1 " + _(Y.internal.getWidth(t) - 2) + " " + _(Y.internal.getHeight(t) - 2) + " re"), n.push("W"), n.push("n"), n.push(_(r.x1.x) + " " + _(r.x1.y) + " m"), n.push(_(r.x2.x) + " " + _(r.x2.y) + " l"), n.push(_(r.x4.x) + " " + _(r.x4.y) + " m"), n.push(_(r.x3.x) + " " + _(r.x3.y) + " l"), n.push("s"), n.push("Q"), e.stream = n.join("\n"), e;
                    },
                    YesPushDown: function(t) {
                        var e = l(t), n = Y.internal.calculateCross(t), r = [];
                        return r.push("0.749023 g"), r.push("0 0 " + _(Y.internal.getWidth(t)) + " " + _(Y.internal.getHeight(t)) + " re"), r.push("f"), r.push("q"), r.push("1 1 " + _(Y.internal.getWidth(t) - 2) + " " + _(Y.internal.getHeight(t) - 2) + " re"), r.push("W"), r.push("n"), r.push(_(n.x1.x) + " " + _(n.x1.y) + " m"), r.push(_(n.x2.x) + " " + _(n.x2.y) + " l"), r.push(_(n.x4.x) + " " + _(n.x4.y) + " m"), r.push(_(n.x3.x) + " " + _(n.x3.y) + " l"), r.push("s"), r.push("Q"), e.stream = r.join("\n"), e;
                    },
                    OffPushDown: function(t) {
                        var e = l(t), n = [];
                        return n.push("0.749023 g"), n.push("0 0 " + _(Y.internal.getWidth(t)) + " " + _(Y.internal.getHeight(t)) + " re"), n.push("f"), e.stream = n.join("\n"), e;
                    }
                }
            },
            createDefaultAppearanceStream: function(t) {
                var e = A.internal.getFont(t.fontName, t.fontStyle).id, n = A.__private__.encodeColorString(t.color);
                return "/" + e + " " + t.fontSize + " Tf " + n;
            }
        };
        Y.internal = {
            Bezier_C: .551915024494,
            calculateCross: function(t) {
                var e = Y.internal.getWidth(t), n = Y.internal.getHeight(t), r = Math.min(e, n);
                return {
                    x1: {
                        x: (e - r) / 2,
                        y: (n - r) / 2 + r
                    },
                    x2: {
                        x: (e - r) / 2 + r,
                        y: (n - r) / 2
                    },
                    x3: {
                        x: (e - r) / 2,
                        y: (n - r) / 2
                    },
                    x4: {
                        x: (e - r) / 2 + r,
                        y: (n - r) / 2 + r
                    }
                };
            }
        }, Y.internal.getWidth = function(t) {
            var e = 0;
            return "object" === se(t) && (e = v(t.Rect[2])), e;
        }, Y.internal.getHeight = function(t) {
            var e = 0;
            return "object" === se(t) && (e = v(t.Rect[3])), e;
        };
        var J = t.addField = function(t) {
            if (k.call(this), !(t instanceof M)) throw new Error("Invalid argument passed to jsPDF.addField.");
            return (function(t) {
                A.internal.acroformPlugin.printedOut && (A.internal.acroformPlugin.printedOut = !1, A.internal.acroformPlugin.acroFormDictionaryRoot = null), A.internal.acroformPlugin.acroFormDictionaryRoot || k.call(A), A.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t);
            }).call(this, t), t.page = A.internal.getCurrentPageInfo().pageNumber, this;
        };
        t.addButton = function(t) {
            if (t instanceof D == !1) throw new Error("Invalid argument passed to jsPDF.addButton.");
            return J.call(this, t);
        }, t.addTextField = function(t) {
            if (t instanceof V == !1) throw new Error("Invalid argument passed to jsPDF.addTextField.");
            return J.call(this, t);
        }, t.addChoiceField = function(t) {
            if (t instanceof O == !1) throw new Error("Invalid argument passed to jsPDF.addChoiceField.");
            return J.call(this, t);
        };
        "object" == se(e) && void 0 === e.ChoiceField && void 0 === e.ListBox && void 0 === e.ComboBox && void 0 === e.EditBox && void 0 === e.Button && void 0 === e.PushButton && void 0 === e.RadioButton && void 0 === e.CheckBox && void 0 === e.TextField && void 0 === e.PasswordField ? (e.ChoiceField = O, e.ListBox = q, e.ComboBox = T, e.EditBox = R, e.Button = D, e.PushButton = U, e.RadioButton = z, e.CheckBox = W, e.TextField = V, e.PasswordField = G, e.AcroForm = {
            Appearance: Y
        }) : console.warn("AcroForm-Classes are not populated into global-namespace, because the class-Names exist already."), t.AcroFormChoiceField = O, t.AcroFormListBox = q, t.AcroFormComboBox = T, t.AcroFormEditBox = R, t.AcroFormButton = D, t.AcroFormPushButton = U, t.AcroFormRadioButton = z, t.AcroFormCheckBox = W, t.AcroFormTextField = V, t.AcroFormPasswordField = G, t.AcroFormAppearance = Y, t.AcroForm = {
            ChoiceField: O,
            ListBox: q,
            ComboBox: T,
            EditBox: R,
            Button: D,
            PushButton: U,
            RadioButton: z,
            CheckBox: W,
            TextField: V,
            PasswordField: G,
            Appearance: Y
        };
    })((window.tmp = lt).API, "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global), /** @license
   * jsPDF addImage plugin
   * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
   *               2013 Chris Dowling, https://github.com/gingerchris
   *               2013 Trinh Ho, https://github.com/ineedfat
   *               2013 Edwin Alejandro Perez, https://github.com/eaparango
   *               2013 Norah Smith, https://github.com/burnburnrocket
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   */ function(x) {
        var N = "addImage_", l = {
            PNG: [
                [
                    137,
                    80,
                    78,
                    71
                ]
            ],
            TIFF: [
                [
                    77,
                    77,
                    0,
                    42
                ],
                [
                    73,
                    73,
                    42,
                    0
                ]
            ],
            JPEG: [
                [
                    255,
                    216,
                    255,
                    224,
                    void 0,
                    void 0,
                    74,
                    70,
                    73,
                    70,
                    0
                ],
                [
                    255,
                    216,
                    255,
                    225,
                    void 0,
                    void 0,
                    69,
                    120,
                    105,
                    102,
                    0,
                    0
                ]
            ],
            JPEG2000: [
                [
                    0,
                    0,
                    0,
                    12,
                    106,
                    80,
                    32,
                    32
                ]
            ],
            GIF87a: [
                [
                    71,
                    73,
                    70,
                    56,
                    55,
                    97
                ]
            ],
            GIF89a: [
                [
                    71,
                    73,
                    70,
                    56,
                    57,
                    97
                ]
            ],
            BMP: [
                [
                    66,
                    77
                ],
                [
                    66,
                    65
                ],
                [
                    67,
                    73
                ],
                [
                    67,
                    80
                ],
                [
                    73,
                    67
                ],
                [
                    80,
                    84
                ]
            ]
        }, h = x.getImageFileTypeByImageData = function(t, e) {
            var n, r;
            e = e || "UNKNOWN";
            var i, o, a, s = "UNKNOWN";
            for(a in x.isArrayBufferView(t) && (t = x.arrayBufferToBinaryString(t)), l)for(i = l[a], n = 0; n < i.length; n += 1){
                for(o = !0, r = 0; r < i[n].length; r += 1)if (void 0 !== i[n][r] && i[n][r] !== t.charCodeAt(r)) {
                    o = !1;
                    break;
                }
                if (!0 === o) {
                    s = a;
                    break;
                }
            }
            return "UNKNOWN" === s && "UNKNOWN" !== e && (console.warn('FileType of Image not recognized. Processing image as "' + e + '".'), s = e), s;
        }, n = function t(e) {
            for(var n = this.internal.newObject(), r = this.internal.write, i = this.internal.putStream, o = (0, this.internal.getFilters)(); -1 !== o.indexOf("FlateEncode");)o.splice(o.indexOf("FlateEncode"), 1);
            e.n = n;
            var a = [];
            if (a.push({
                key: "Type",
                value: "/XObject"
            }), a.push({
                key: "Subtype",
                value: "/Image"
            }), a.push({
                key: "Width",
                value: e.w
            }), a.push({
                key: "Height",
                value: e.h
            }), e.cs === this.color_spaces.INDEXED ? a.push({
                key: "ColorSpace",
                value: "[/Indexed /DeviceRGB " + (e.pal.length / 3 - 1) + " " + ("smask" in e ? n + 2 : n + 1) + " 0 R]"
            }) : (a.push({
                key: "ColorSpace",
                value: "/" + e.cs
            }), e.cs === this.color_spaces.DEVICE_CMYK && a.push({
                key: "Decode",
                value: "[1 0 1 0 1 0 1 0]"
            })), a.push({
                key: "BitsPerComponent",
                value: e.bpc
            }), "dp" in e && a.push({
                key: "DecodeParms",
                value: "<<" + e.dp + ">>"
            }), "trns" in e && e.trns.constructor == Array) {
                for(var s = "", l = 0, h = e.trns.length; l < h; l++)s += e.trns[l] + " " + e.trns[l] + " ";
                a.push({
                    key: "Mask",
                    value: "[" + s + "]"
                });
            }
            "smask" in e && a.push({
                key: "SMask",
                value: n + 1 + " 0 R"
            });
            var u = void 0 !== e.f ? [
                "/" + e.f
            ] : void 0;
            if (i({
                data: e.data,
                additionalKeyValues: a,
                alreadyAppliedFilters: u
            }), r("endobj"), "smask" in e) {
                var c = "/Predictor " + e.p + " /Colors 1 /BitsPerComponent " + e.bpc + " /Columns " + e.w, f = {
                    w: e.w,
                    h: e.h,
                    cs: "DeviceGray",
                    bpc: e.bpc,
                    dp: c,
                    data: e.smask
                };
                "f" in e && (f.f = e.f), t.call(this, f);
            }
            e.cs === this.color_spaces.INDEXED && (this.internal.newObject(), i({
                data: this.arrayBufferToBinaryString(new Uint8Array(e.pal))
            }), r("endobj"));
        }, L = function() {
            var t = this.internal.collections[N + "images"];
            for(var e in t)n.call(this, t[e]);
        }, A = function() {
            var t, e = this.internal.collections[N + "images"], n = this.internal.write;
            for(var r in e)n("/I" + (t = e[r]).i, t.n, "0", "R");
        }, S = function(t) {
            return "function" == typeof x["process" + t.toUpperCase()];
        }, _ = function(t) {
            return "object" === se(t) && 1 === t.nodeType;
        }, F = function(t, e) {
            if ("IMG" === t.nodeName && t.hasAttribute("src")) {
                var n = "" + t.getAttribute("src");
                if (0 === n.indexOf("data:image/")) return unescape(n);
                var r = x.loadFile(n);
                if (void 0 !== r) return btoa(r);
            }
            if ("CANVAS" === t.nodeName) {
                var i = t;
                return t.toDataURL("image/jpeg", 1);
            }
            (i = document.createElement("canvas")).width = t.clientWidth || t.width, i.height = t.clientHeight || t.height;
            var o = i.getContext("2d");
            if (!o) throw "addImage requires canvas to be supported by browser.";
            return o.drawImage(t, 0, 0, i.width, i.height), i.toDataURL("png" == ("" + e).toLowerCase() ? "image/png" : "image/jpeg");
        }, P = function(t, e) {
            var n;
            if (e) {
                for(var r in e)if (t === e[r].alias) {
                    n = e[r];
                    break;
                }
            }
            return n;
        };
        x.color_spaces = {
            DEVICE_RGB: "DeviceRGB",
            DEVICE_GRAY: "DeviceGray",
            DEVICE_CMYK: "DeviceCMYK",
            CAL_GREY: "CalGray",
            CAL_RGB: "CalRGB",
            LAB: "Lab",
            ICC_BASED: "ICCBased",
            INDEXED: "Indexed",
            PATTERN: "Pattern",
            SEPARATION: "Separation",
            DEVICE_N: "DeviceN"
        }, x.decode = {
            DCT_DECODE: "DCTDecode",
            FLATE_DECODE: "FlateDecode",
            LZW_DECODE: "LZWDecode",
            JPX_DECODE: "JPXDecode",
            JBIG2_DECODE: "JBIG2Decode",
            ASCII85_DECODE: "ASCII85Decode",
            ASCII_HEX_DECODE: "ASCIIHexDecode",
            RUN_LENGTH_DECODE: "RunLengthDecode",
            CCITT_FAX_DECODE: "CCITTFaxDecode"
        }, x.image_compression = {
            NONE: "NONE",
            FAST: "FAST",
            MEDIUM: "MEDIUM",
            SLOW: "SLOW"
        }, x.sHashCode = function(t) {
            var e, n = 0;
            if (0 === (t = t || "").length) return n;
            for(e = 0; e < t.length; e++)n = (n << 5) - n + t.charCodeAt(e), n |= 0;
            return n;
        }, x.isString = function(t) {
            return "string" == typeof t;
        }, x.validateStringAsBase64 = function(t) {
            (t = t || "").toString().trim();
            var e = !0;
            return 0 === t.length && (e = !1), t.length % 4 != 0 && (e = !1), !1 === /^[A-Za-z0-9+\/]+$/.test(t.substr(0, t.length - 2)) && (e = !1), !1 === /^[A-Za-z0-9\/][A-Za-z0-9+\/]|[A-Za-z0-9+\/]=|==$/.test(t.substr(-2)) && (e = !1), e;
        }, x.extractInfoFromBase64DataURI = function(t) {
            return /^data:([\w]+?\/([\w]+?));\S*;*base64,(.+)$/g.exec(t);
        }, x.extractImageFromDataUrl = function(t) {
            var e = (t = t || "").split("base64,"), n = null;
            if (2 === e.length) {
                var r = /^data:(\w*\/\w*);*(charset=[\w=-]*)*;*$/.exec(e[0]);
                Array.isArray(r) && (n = {
                    mimeType: r[1],
                    charset: r[2],
                    data: e[1]
                });
            }
            return n;
        }, x.supportsArrayBuffer = function() {
            return "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array;
        }, x.isArrayBuffer = function(t) {
            return !!this.supportsArrayBuffer() && t instanceof ArrayBuffer;
        }, x.isArrayBufferView = function(t) {
            return !!this.supportsArrayBuffer() && "undefined" != typeof Uint32Array && (t instanceof Int8Array || t instanceof Uint8Array || "undefined" != typeof Uint8ClampedArray && t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array);
        }, x.binaryStringToUint8Array = function(t) {
            for(var e = t.length, n = new Uint8Array(e), r = 0; r < e; r++)n[r] = t.charCodeAt(r);
            return n;
        }, x.arrayBufferToBinaryString = function(t) {
            if ("function" == typeof atob) return atob(this.arrayBufferToBase64(t));
        }, x.arrayBufferToBase64 = function(t) {
            for(var e, n = "", r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = new Uint8Array(t), o = i.byteLength, a = o % 3, s = o - a, l = 0; l < s; l += 3)n += r[(16515072 & (e = i[l] << 16 | i[l + 1] << 8 | i[l + 2])) >> 18] + r[(258048 & e) >> 12] + r[(4032 & e) >> 6] + r[63 & e];
            return 1 == a ? n += r[(252 & (e = i[s])) >> 2] + r[(3 & e) << 4] + "==" : 2 == a && (n += r[(64512 & (e = i[s] << 8 | i[s + 1])) >> 10] + r[(1008 & e) >> 4] + r[(15 & e) << 2] + "="), n;
        }, x.createImageInfo = function(t, e, n, r, i, o, a, s, l, h, u, c, f) {
            var p = {
                alias: s,
                w: e,
                h: n,
                cs: r,
                bpc: i,
                i: a,
                data: t
            };
            return o && (p.f = o), l && (p.dp = l), h && (p.trns = h), u && (p.pal = u), c && (p.smask = c), f && (p.p = f), p;
        }, x.addImage = function(t, e, n, r, i, o, a, s, l) {
            var h = "";
            if ("string" != typeof e) {
                var u = o;
                o = i, i = r, r = n, n = e, e = u;
            }
            if ("object" === se(t) && !_(t) && "imageData" in t) {
                var c = t;
                t = c.imageData, e = c.format || e || "UNKNOWN", n = c.x || n || 0, r = c.y || r || 0, i = c.w || i, o = c.h || o, a = c.alias || a, s = c.compression || s, l = c.rotation || c.angle || l;
            }
            var f = this.internal.getFilters();
            if (void 0 === s && -1 !== f.indexOf("FlateEncode") && (s = "SLOW"), "string" == typeof t && (t = unescape(t)), isNaN(n) || isNaN(r)) throw console.error("jsPDF.addImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addImage");
            var p, d, g, m, y, v, w, b = (function() {
                var t = this.internal.collections[N + "images"];
                return t || (this.internal.collections[N + "images"] = t = {}, this.internal.events.subscribe("putResources", L), this.internal.events.subscribe("putXobjectDict", A)), t;
            }).call(this);
            if (!((p = P(t, b)) || (_(t) && (t = F(t, e)), (null == (w = a) || 0 === w.length) && (a = "string" == typeof (v = t) ? x.sHashCode(v) : x.isArrayBufferView(v) ? x.sHashCode(x.arrayBufferToBinaryString(v)) : null), p = P(a, b)))) {
                if (this.isString(t) && ("" !== (h = this.convertStringToImageData(t)) ? t = h : void 0 !== (h = x.loadFile(t)) && (t = h)), e = this.getImageFileTypeByImageData(t, e), !S(e)) throw new Error("addImage does not support files of type '" + e + "', please ensure that a plugin for '" + e + "' support is added.");
                if (this.supportsArrayBuffer() && (t instanceof Uint8Array || (d = t, t = this.binaryStringToUint8Array(t))), !(p = this["process" + e.toUpperCase()](t, (y = 0, (m = b) && (y = Object.keys ? Object.keys(m).length : function(t) {
                    var e = 0;
                    for(var n in t)t.hasOwnProperty(n) && e++;
                    return e;
                }(m)), y), a, ((g = s) && "string" == typeof g && (g = g.toUpperCase()), g in x.image_compression ? g : x.image_compression.NONE), d))) throw new Error("An unknown error occurred whilst processing the image");
            }
            return (function(t, e, n, r, i, o, a, s) {
                var l = (function(t, e, n) {
                    return t || e || (e = t = -96), t < 0 && (t = -1 * n.w * 72 / t / this.internal.scaleFactor), e < 0 && (e = -1 * n.h * 72 / e / this.internal.scaleFactor), 0 === t && (t = e * n.w / n.h), 0 === e && (e = t * n.h / n.w), [
                        t,
                        e
                    ];
                }).call(this, n, r, i), h = this.internal.getCoordinateString, u = this.internal.getVerticalCoordinateString;
                if (n = l[0], r = l[1], a[o] = i, s) {
                    s *= Math.PI / 180;
                    var c = Math.cos(s), f = Math.sin(s), p = function(t) {
                        return t.toFixed(4);
                    }, d = [
                        p(c),
                        p(f),
                        p(-1 * f),
                        p(c),
                        0,
                        0,
                        "cm"
                    ];
                }
                this.internal.write("q"), s ? (this.internal.write([
                    1,
                    "0",
                    "0",
                    1,
                    h(t),
                    u(e + r),
                    "cm"
                ].join(" ")), this.internal.write(d.join(" ")), this.internal.write([
                    h(n),
                    "0",
                    "0",
                    h(r),
                    "0",
                    "0",
                    "cm"
                ].join(" "))) : this.internal.write([
                    h(n),
                    "0",
                    "0",
                    h(r),
                    h(t),
                    u(e + r),
                    "cm"
                ].join(" ")), this.internal.write("/I" + i.i + " Do"), this.internal.write("Q");
            }).call(this, n, r, i, o, p, p.i, b, l), this;
        }, x.convertStringToImageData = function(t) {
            var e, n = "";
            if (this.isString(t)) {
                var r;
                e = null !== (r = this.extractImageFromDataUrl(t)) ? r.data : t;
                try {
                    n = atob(e);
                } catch (t) {
                    throw x.validateStringAsBase64(e) ? new Error("atob-Error in jsPDF.convertStringToImageData " + t.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertStringToImageData ");
                }
            }
            return n;
        };
        var u = function(t, e) {
            return t.subarray(e, e + 5);
        };
        x.processJPEG = function(t, e, n, r, i, o) {
            var a, s = this.decode.DCT_DECODE;
            if (!this.isString(t) && !this.isArrayBuffer(t) && !this.isArrayBufferView(t)) return null;
            if (this.isString(t) && (a = function(t) {
                var e;
                if ("JPEG" !== h(t)) throw new Error("getJpegSize requires a binary string jpeg file");
                for(var n = 256 * t.charCodeAt(4) + t.charCodeAt(5), r = 4, i = t.length; r < i;){
                    if (r += n, 255 !== t.charCodeAt(r)) throw new Error("getJpegSize could not find the size of the image");
                    if (192 === t.charCodeAt(r + 1) || 193 === t.charCodeAt(r + 1) || 194 === t.charCodeAt(r + 1) || 195 === t.charCodeAt(r + 1) || 196 === t.charCodeAt(r + 1) || 197 === t.charCodeAt(r + 1) || 198 === t.charCodeAt(r + 1) || 199 === t.charCodeAt(r + 1)) return e = 256 * t.charCodeAt(r + 5) + t.charCodeAt(r + 6), [
                        256 * t.charCodeAt(r + 7) + t.charCodeAt(r + 8),
                        e,
                        t.charCodeAt(r + 9)
                    ];
                    r += 2, n = 256 * t.charCodeAt(r) + t.charCodeAt(r + 1);
                }
            }(t)), this.isArrayBuffer(t) && (t = new Uint8Array(t)), this.isArrayBufferView(t) && (a = function(t) {
                if (65496 != (t[0] << 8 | t[1])) throw new Error("Supplied data is not a JPEG");
                for(var e, n = t.length, r = (t[4] << 8) + t[5], i = 4; i < n;){
                    if (r = ((e = u(t, i += r))[2] << 8) + e[3], (192 === e[1] || 194 === e[1]) && 255 === e[0] && 7 < r) return {
                        width: ((e = u(t, i + 5))[2] << 8) + e[3],
                        height: (e[0] << 8) + e[1],
                        numcomponents: e[4]
                    };
                    i += 2;
                }
                throw new Error("getJpegSizeFromBytes could not find the size of the image");
            }(t), t = i || this.arrayBufferToBinaryString(t)), void 0 === o) switch(a.numcomponents){
                case 1:
                    o = this.color_spaces.DEVICE_GRAY;
                    break;
                case 4:
                    o = this.color_spaces.DEVICE_CMYK;
                    break;
                default:
                case 3:
                    o = this.color_spaces.DEVICE_RGB;
            }
            return this.createImageInfo(t, a.width, a.height, o, 8, s, e, n);
        }, x.processJPG = function() {
            return this.processJPEG.apply(this, arguments);
        }, x.getImageProperties = function(t) {
            var e, n, r = "";
            if (_(t) && (t = F(t)), this.isString(t) && ("" !== (r = this.convertStringToImageData(t)) ? t = r : void 0 !== (r = x.loadFile(t)) && (t = r)), n = this.getImageFileTypeByImageData(t), !S(n)) throw new Error("addImage does not support files of type '" + n + "', please ensure that a plugin for '" + n + "' support is added.");
            if (this.supportsArrayBuffer() && (t instanceof Uint8Array || (t = this.binaryStringToUint8Array(t))), !(e = this["process" + n.toUpperCase()](t))) throw new Error("An unknown error occurred whilst processing the image");
            return {
                fileType: n,
                width: e.w,
                height: e.h,
                colorSpace: e.cs,
                compressionMode: e.f,
                bitsPerComponent: e.bpc
            };
        };
    }(lt.API), /**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ t = lt.API, lt.API.events.push([
        "addPage",
        function(t) {
            this.internal.getPageInfo(t.pageNumber).pageContext.annotations = [];
        }
    ]), t.events.push([
        "putPage",
        function(t) {
            for(var e = this.internal.getPageInfoByObjId(t.objId), n = t.pageContext.annotations, r = function(t) {
                if (void 0 !== t && "" != t) return !0;
            }, i = !1, o = 0; o < n.length && !i; o++)switch((l = n[o]).type){
                case "link":
                    if (r(l.options.url) || r(l.options.pageNumber)) {
                        i = !0;
                        break;
                    }
                case "reference":
                case "text":
                case "freetext":
                    i = !0;
            }
            if (0 != i) {
                this.internal.write("/Annots ["), this.internal.pageSize.height;
                var a = this.internal.getCoordinateString, s = this.internal.getVerticalCoordinateString;
                for(o = 0; o < n.length; o++){
                    var l;
                    switch((l = n[o]).type){
                        case "reference":
                            this.internal.write(" " + l.object.objId + " 0 R ");
                            break;
                        case "text":
                            var h = this.internal.newAdditionalObject(), u = this.internal.newAdditionalObject(), c = l.title || "Note";
                            m = "<</Type /Annot /Subtype /Text " + (p = "/Rect [" + a(l.bounds.x) + " " + s(l.bounds.y + l.bounds.h) + " " + a(l.bounds.x + l.bounds.w) + " " + s(l.bounds.y) + "] ") + "/Contents (" + l.contents + ")", m += " /Popup " + u.objId + " 0 R", m += " /P " + e.objId + " 0 R", m += " /T (" + c + ") >>", h.content = m;
                            var f = h.objId + " 0 R";
                            m = "<</Type /Annot /Subtype /Popup " + (p = "/Rect [" + a(l.bounds.x + 30) + " " + s(l.bounds.y + l.bounds.h) + " " + a(l.bounds.x + l.bounds.w + 30) + " " + s(l.bounds.y) + "] ") + " /Parent " + f, l.open && (m += " /Open true"), m += " >>", u.content = m, this.internal.write(h.objId, "0 R", u.objId, "0 R");
                            break;
                        case "freetext":
                            var p = "/Rect [" + a(l.bounds.x) + " " + s(l.bounds.y) + " " + a(l.bounds.x + l.bounds.w) + " " + s(l.bounds.y + l.bounds.h) + "] ", d = l.color || "#000000";
                            m = "<</Type /Annot /Subtype /FreeText " + p + "/Contents (" + l.contents + ")", m += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + d + ")", m += " /Border [0 0 0]", m += " >>", this.internal.write(m);
                            break;
                        case "link":
                            if (l.options.name) {
                                var g = this.annotations._nameMap[l.options.name];
                                l.options.pageNumber = g.page, l.options.top = g.y;
                            } else l.options.top || (l.options.top = 0);
                            p = "/Rect [" + a(l.x) + " " + s(l.y) + " " + a(l.x + l.w) + " " + s(l.y + l.h) + "] ";
                            var m = "";
                            if (l.options.url) m = "<</Type /Annot /Subtype /Link " + p + "/Border [0 0 0] /A <</S /URI /URI (" + l.options.url + ") >>";
                            else if (l.options.pageNumber) switch(m = "<</Type /Annot /Subtype /Link " + p + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(l.options.pageNumber).objId + " 0 R", l.options.magFactor = l.options.magFactor || "XYZ", l.options.magFactor){
                                case "Fit":
                                    m += " /Fit]";
                                    break;
                                case "FitH":
                                    m += " /FitH " + l.options.top + "]";
                                    break;
                                case "FitV":
                                    l.options.left = l.options.left || 0, m += " /FitV " + l.options.left + "]";
                                    break;
                                case "XYZ":
                                default:
                                    var y = s(l.options.top);
                                    l.options.left = l.options.left || 0, void 0 === l.options.zoom && (l.options.zoom = 0), m += " /XYZ " + l.options.left + " " + y + " " + l.options.zoom + "]";
                            }
                            "" != m && (m += " >>", this.internal.write(m));
                    }
                }
                this.internal.write("]");
            }
        }
    ]), t.createAnnotation = function(t) {
        var e = this.internal.getCurrentPageInfo();
        switch(t.type){
            case "link":
                this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
                break;
            case "text":
            case "freetext":
                e.pageContext.annotations.push(t);
        }
    }, t.link = function(t, e, n, r, i) {
        this.internal.getCurrentPageInfo().pageContext.annotations.push({
            x: t,
            y: e,
            w: n,
            h: r,
            options: i,
            type: "link"
        });
    }, t.textWithLink = function(t, e, n, r) {
        var i = this.getTextWidth(t), o = this.internal.getLineHeight() / this.internal.scaleFactor;
        return this.text(t, e, n), n += .2 * o, this.link(e, n - o, i, o, r), i;
    }, t.getTextWidth = function(t) {
        var e = this.internal.getFontSize();
        return this.getStringUnitWidth(t) * e / this.internal.scaleFactor;
    }, /**
   * @license
   * Copyright (c) 2017 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ function(t) {
        var h = {
            1569: [
                65152
            ],
            1570: [
                65153,
                65154
            ],
            1571: [
                65155,
                65156
            ],
            1572: [
                65157,
                65158
            ],
            1573: [
                65159,
                65160
            ],
            1574: [
                65161,
                65162,
                65163,
                65164
            ],
            1575: [
                65165,
                65166
            ],
            1576: [
                65167,
                65168,
                65169,
                65170
            ],
            1577: [
                65171,
                65172
            ],
            1578: [
                65173,
                65174,
                65175,
                65176
            ],
            1579: [
                65177,
                65178,
                65179,
                65180
            ],
            1580: [
                65181,
                65182,
                65183,
                65184
            ],
            1581: [
                65185,
                65186,
                65187,
                65188
            ],
            1582: [
                65189,
                65190,
                65191,
                65192
            ],
            1583: [
                65193,
                65194
            ],
            1584: [
                65195,
                65196
            ],
            1585: [
                65197,
                65198
            ],
            1586: [
                65199,
                65200
            ],
            1587: [
                65201,
                65202,
                65203,
                65204
            ],
            1588: [
                65205,
                65206,
                65207,
                65208
            ],
            1589: [
                65209,
                65210,
                65211,
                65212
            ],
            1590: [
                65213,
                65214,
                65215,
                65216
            ],
            1591: [
                65217,
                65218,
                65219,
                65220
            ],
            1592: [
                65221,
                65222,
                65223,
                65224
            ],
            1593: [
                65225,
                65226,
                65227,
                65228
            ],
            1594: [
                65229,
                65230,
                65231,
                65232
            ],
            1601: [
                65233,
                65234,
                65235,
                65236
            ],
            1602: [
                65237,
                65238,
                65239,
                65240
            ],
            1603: [
                65241,
                65242,
                65243,
                65244
            ],
            1604: [
                65245,
                65246,
                65247,
                65248
            ],
            1605: [
                65249,
                65250,
                65251,
                65252
            ],
            1606: [
                65253,
                65254,
                65255,
                65256
            ],
            1607: [
                65257,
                65258,
                65259,
                65260
            ],
            1608: [
                65261,
                65262
            ],
            1609: [
                65263,
                65264,
                64488,
                64489
            ],
            1610: [
                65265,
                65266,
                65267,
                65268
            ],
            1649: [
                64336,
                64337
            ],
            1655: [
                64477
            ],
            1657: [
                64358,
                64359,
                64360,
                64361
            ],
            1658: [
                64350,
                64351,
                64352,
                64353
            ],
            1659: [
                64338,
                64339,
                64340,
                64341
            ],
            1662: [
                64342,
                64343,
                64344,
                64345
            ],
            1663: [
                64354,
                64355,
                64356,
                64357
            ],
            1664: [
                64346,
                64347,
                64348,
                64349
            ],
            1667: [
                64374,
                64375,
                64376,
                64377
            ],
            1668: [
                64370,
                64371,
                64372,
                64373
            ],
            1670: [
                64378,
                64379,
                64380,
                64381
            ],
            1671: [
                64382,
                64383,
                64384,
                64385
            ],
            1672: [
                64392,
                64393
            ],
            1676: [
                64388,
                64389
            ],
            1677: [
                64386,
                64387
            ],
            1678: [
                64390,
                64391
            ],
            1681: [
                64396,
                64397
            ],
            1688: [
                64394,
                64395
            ],
            1700: [
                64362,
                64363,
                64364,
                64365
            ],
            1702: [
                64366,
                64367,
                64368,
                64369
            ],
            1705: [
                64398,
                64399,
                64400,
                64401
            ],
            1709: [
                64467,
                64468,
                64469,
                64470
            ],
            1711: [
                64402,
                64403,
                64404,
                64405
            ],
            1713: [
                64410,
                64411,
                64412,
                64413
            ],
            1715: [
                64406,
                64407,
                64408,
                64409
            ],
            1722: [
                64414,
                64415
            ],
            1723: [
                64416,
                64417,
                64418,
                64419
            ],
            1726: [
                64426,
                64427,
                64428,
                64429
            ],
            1728: [
                64420,
                64421
            ],
            1729: [
                64422,
                64423,
                64424,
                64425
            ],
            1733: [
                64480,
                64481
            ],
            1734: [
                64473,
                64474
            ],
            1735: [
                64471,
                64472
            ],
            1736: [
                64475,
                64476
            ],
            1737: [
                64482,
                64483
            ],
            1739: [
                64478,
                64479
            ],
            1740: [
                64508,
                64509,
                64510,
                64511
            ],
            1744: [
                64484,
                64485,
                64486,
                64487
            ],
            1746: [
                64430,
                64431
            ],
            1747: [
                64432,
                64433
            ]
        }, a = {
            65247: {
                65154: 65269,
                65156: 65271,
                65160: 65273,
                65166: 65275
            },
            65248: {
                65154: 65270,
                65156: 65272,
                65160: 65274,
                65166: 65276
            },
            65165: {
                65247: {
                    65248: {
                        65258: 65010
                    }
                }
            },
            1617: {
                1612: 64606,
                1613: 64607,
                1614: 64608,
                1615: 64609,
                1616: 64610
            }
        }, e = {
            1612: 64606,
            1613: 64607,
            1614: 64608,
            1615: 64609,
            1616: 64610
        }, n = [
            1570,
            1571,
            1573,
            1575
        ];
        t.__arabicParser__ = {};
        var r = t.__arabicParser__.isInArabicSubstitutionA = function(t) {
            return void 0 !== h[t.charCodeAt(0)];
        }, u = t.__arabicParser__.isArabicLetter = function(t) {
            return "string" == typeof t && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t);
        }, i = t.__arabicParser__.isArabicEndLetter = function(t) {
            return u(t) && r(t) && h[t.charCodeAt(0)].length <= 2;
        }, o = t.__arabicParser__.isArabicAlfLetter = function(t) {
            return u(t) && 0 <= n.indexOf(t.charCodeAt(0));
        }, s = (t.__arabicParser__.arabicLetterHasIsolatedForm = function(t) {
            return u(t) && r(t) && 1 <= h[t.charCodeAt(0)].length;
        }, t.__arabicParser__.arabicLetterHasFinalForm = function(t) {
            return u(t) && r(t) && 2 <= h[t.charCodeAt(0)].length;
        }), l = (t.__arabicParser__.arabicLetterHasInitialForm = function(t) {
            return u(t) && r(t) && 3 <= h[t.charCodeAt(0)].length;
        }, t.__arabicParser__.arabicLetterHasMedialForm = function(t) {
            return u(t) && r(t) && 4 == h[t.charCodeAt(0)].length;
        }), c = t.__arabicParser__.resolveLigatures = function(t) {
            var e = 0, n = a, r = 0, i = "", o = 0;
            for(e = 0; e < t.length; e += 1)void 0 !== n[t.charCodeAt(e)] ? (o++, "number" == typeof (n = n[t.charCodeAt(e)]) && (r = -1 !== (r = f(t.charAt(e), t.charAt(e - o), t.charAt(e + 1))) ? r : 0, i += String.fromCharCode(n), n = a, o = 0), e === t.length - 1 && (n = a, i += t.charAt(e - (o - 1)), e -= o - 1, o = 0)) : (n = a, i += t.charAt(e - o), e -= o, o = 0);
            return i;
        }, f = (t.__arabicParser__.isArabicDiacritic = function(t) {
            return void 0 !== t && void 0 !== e[t.charCodeAt(0)];
        }, t.__arabicParser__.getCorrectForm = function(t, e, n) {
            return u(t) ? !1 === r(t) ? -1 : !s(t) || !u(e) && !u(n) || !u(n) && i(e) || i(t) && !u(e) || i(t) && o(e) || i(t) && i(e) ? 0 : l(t) && u(e) && !i(e) && u(n) && s(n) ? 3 : i(t) || !u(n) ? 1 : 2 : -1;
        }), p = t.__arabicParser__.processArabic = t.processArabic = function(t) {
            var e = 0, n = 0, r = 0, i = "", o = "", a = "", s = (t = t || "").split("\\s+"), l = [];
            for(e = 0; e < s.length; e += 1){
                for(l.push(""), n = 0; n < s[e].length; n += 1)i = s[e][n], o = s[e][n - 1], a = s[e][n + 1], u(i) ? (r = f(i, o, a), l[e] += -1 !== r ? String.fromCharCode(h[i.charCodeAt(0)][r]) : i) : l[e] += i;
                l[e] = c(l[e]);
            }
            return l.join(" ");
        };
        t.events.push([
            "preProcessText",
            function(t) {
                var e = t.text, n = (t.x, t.y, t.options || {}), r = (t.mutex, n.lang, []);
                if ("[object Array]" === Object.prototype.toString.call(e)) {
                    var i = 0;
                    for(r = [], i = 0; i < e.length; i += 1)"[object Array]" === Object.prototype.toString.call(e[i]) ? r.push([
                        p(e[i][0]),
                        e[i][1],
                        e[i][2]
                    ]) : r.push([
                        p(e[i])
                    ]);
                    t.text = r;
                } else t.text = p(e);
            }
        ]);
    }(lt.API), lt.API.autoPrint = function(t) {
        var e;
        switch((t = t || {}).variant = t.variant || "non-conform", t.variant){
            case "javascript":
                this.addJS("print({});");
                break;
            case "non-conform":
            default:
                this.internal.events.subscribe("postPutResources", function() {
                    e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
                }), this.internal.events.subscribe("putCatalog", function() {
                    this.internal.out("/OpenAction " + e + " 0 R");
                });
        }
        return this;
    }, /**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ e = lt.API, (n = function() {
        var e = void 0;
        Object.defineProperty(this, "pdf", {
            get: function() {
                return e;
            },
            set: function(t) {
                e = t;
            }
        });
        var n = 150;
        Object.defineProperty(this, "width", {
            get: function() {
                return n;
            },
            set: function(t) {
                n = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 150 : t, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = n + 1);
            }
        });
        var r = 300;
        Object.defineProperty(this, "height", {
            get: function() {
                return r;
            },
            set: function(t) {
                r = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 300 : t, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = r + 1);
            }
        });
        var i = [];
        Object.defineProperty(this, "childNodes", {
            get: function() {
                return i;
            },
            set: function(t) {
                i = t;
            }
        });
        var o = {};
        Object.defineProperty(this, "style", {
            get: function() {
                return o;
            },
            set: function(t) {
                o = t;
            }
        }), Object.defineProperty(this, "parentNode", {
            get: function() {
                return !1;
            }
        });
    }).prototype.getContext = function(t, e) {
        var n;
        if ("2d" !== (t = t || "2d")) return null;
        for(n in e)this.pdf.context2d.hasOwnProperty(n) && (this.pdf.context2d[n] = e[n]);
        return (this.pdf.context2d._canvas = this).pdf.context2d;
    }, n.prototype.toDataURL = function() {
        throw new Error("toDataURL is not implemented.");
    }, e.events.push([
        "initialized",
        function() {
            this.canvas = new n, this.canvas.pdf = this;
        }
    ]), /** 
   * @license
   * ====================================================================
   * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
   *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Hall, james@parall.ax
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */ _ = lt.API, F = {
        x: void 0,
        y: void 0,
        w: void 0,
        h: void 0,
        ln: void 0
    }, P = 1, p = function(t, e, n, r, i) {
        F = {
            x: t,
            y: e,
            w: n,
            h: r,
            ln: i
        };
    }, d = function() {
        return F;
    }, k = {
        left: 0,
        top: 0,
        bottom: 0
    }, _.setHeaderFunction = function(t) {
        l = t;
    }, _.getTextDimensions = function(t, e) {
        var n = this.table_font_size || this.internal.getFontSize(), r = (this.internal.getFont().fontStyle, (e = e || {}).scaleFactor || this.internal.scaleFactor), i = 0, o = 0, a = 0;
        if ("string" == typeof t) 0 != (i = this.getStringUnitWidth(t) * n) && (o = 1);
        else {
            if ("[object Array]" !== Object.prototype.toString.call(t)) throw new Error("getTextDimensions expects text-parameter to be of type String or an Array of Strings.");
            for(var s = 0; s < t.length; s++)i < (a = this.getStringUnitWidth(t[s]) * n) && (i = a);
            0 !== i && (o = t.length);
        }
        return {
            w: i /= r,
            h: Math.max((o * n * this.getLineHeightFactor() - n * (this.getLineHeightFactor() - 1)) / r, 0)
        };
    }, _.cellAddPage = function() {
        var t = this.margins || k;
        this.addPage(), p(t.left, t.top, void 0, void 0), P += 1;
    }, _.cellInitialize = function() {
        F = {
            x: void 0,
            y: void 0,
            w: void 0,
            h: void 0,
            ln: void 0
        }, P = 1;
    }, _.cell = function(t, e, n, r, i, o, a) {
        var s = d(), l = !1;
        if (void 0 !== s.ln) {
            if (s.ln === o) t = s.x + s.w, e = s.y;
            else {
                var h = this.margins || k;
                s.y + s.h + r + 13 >= this.internal.pageSize.getHeight() - h.bottom && (this.cellAddPage(), l = !0, this.printHeaders && this.tableHeaderRow && this.printHeaderRow(o, !0)), e = d().y + d().h, l && (e = 23);
            }
        }
        if (void 0 !== i[0]) {
            if (this.printingHeaderRow ? this.rect(t, e, n, r, "FD") : this.rect(t, e, n, r), "right" === a) {
                i instanceof Array || (i = [
                    i
                ]);
                for(var u = 0; u < i.length; u++){
                    var c = i[u], f = this.getStringUnitWidth(c) * this.internal.getFontSize() / this.internal.scaleFactor;
                    this.text(c, t + n - f - 3, e + this.internal.getLineHeight() * (u + 1));
                }
            } else this.text(i, t + 3, e + this.internal.getLineHeight());
        }
        return p(t, e, n, r, o), this;
    }, _.arrayMax = function(t, e) {
        var n, r, i, o = t[0];
        for(n = 0, r = t.length; n < r; n += 1)i = t[n], e ? -1 === e(o, i) && (o = i) : o < i && (o = i);
        return o;
    }, _.table = function(t, e, n, r, i) {
        if (!n) throw "No data for PDF table";
        var o, a, s, l, h, u, c, f, p, d, g = [], m = [], y = {}, v = {}, w = [], b = [], x = !1, N = !0, L = 12, A = k;
        if (A.width = this.internal.pageSize.getWidth(), i && (!0 === i.autoSize && (x = !0), !1 === i.printHeaders && (N = !1), i.fontSize && (L = i.fontSize), i.css && void 0 !== i.css["font-size"] && (L = 16 * i.css["font-size"]), i.margins && (A = i.margins)), this.lnMod = 0, F = {
            x: void 0,
            y: void 0,
            w: void 0,
            h: void 0,
            ln: void 0
        }, P = 1, this.printHeaders = N, this.margins = A, this.setFontSize(L), this.table_font_size = L, null == r) g = Object.keys(n[0]);
        else if (r[0] && "string" != typeof r[0]) for(a = 0, s = r.length; a < s; a += 1)o = r[a], g.push(o.name), m.push(o.prompt), v[o.name] = o.width * (19.049976 / 25.4);
        else g = r;
        if (x) for(d = function(t) {
            return t[o];
        }, a = 0, s = g.length; a < s; a += 1){
            for(y[o = g[a]] = n.map(d), w.push(this.getTextDimensions(m[a] || o, {
                scaleFactor: 1
            }).w), c = 0, l = (u = y[o]).length; c < l; c += 1)h = u[c], w.push(this.getTextDimensions(h, {
                scaleFactor: 1
            }).w);
            v[o] = _.arrayMax(w), w = [];
        }
        if (N) {
            var S = this.calculateLineHeight(g, v, m.length ? m : g);
            for(a = 0, s = g.length; a < s; a += 1)o = g[a], b.push([
                t,
                e,
                v[o],
                S,
                String(m.length ? m[a] : o)
            ]);
            this.setTableHeaderRow(b), this.printHeaderRow(1, !1);
        }
        for(a = 0, s = n.length; a < s; a += 1)for(f = n[a], S = this.calculateLineHeight(g, v, f), c = 0, p = g.length; c < p; c += 1)o = g[c], this.cell(t, e, v[o], S, f[o], a + 2, o.align);
        return this.lastCellPos = F, this.table_x = t, this.table_y = e, this;
    }, _.calculateLineHeight = function(t, e, n) {
        for(var r, i = 0, o = 0; o < t.length; o++){
            n[r = t[o]] = this.splitTextToSize(String(n[r]), e[r] - 3);
            var a = this.internal.getLineHeight() * n[r].length + 3;
            i < a && (i = a);
        }
        return i;
    }, _.setTableHeaderRow = function(t) {
        this.tableHeaderRow = t;
    }, _.printHeaderRow = function(t, e) {
        if (!this.tableHeaderRow) throw "Property tableHeaderRow does not exist.";
        var n, r, i, o;
        if (this.printingHeaderRow = !0, void 0 !== l) {
            var a = l(this, P);
            p(a[0], a[1], a[2], a[3], -1);
        }
        this.setFontStyle("bold");
        var s = [];
        for(i = 0, o = this.tableHeaderRow.length; i < o; i += 1)this.setFillColor(200, 200, 200), n = this.tableHeaderRow[i], e && (this.margins.top = 13, n[1] = this.margins && this.margins.top || 0, s.push(n)), r = [].concat(n), this.cell.apply(this, r.concat(t));
        0 < s.length && this.setTableHeaderRow(s), this.setFontStyle("normal"), this.printingHeaderRow = !1;
    }, /**
   * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
   *
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */ function(t, e) {
        var l, i, o, h, u, c = function(t) {
            return t = t || {}, this.isStrokeTransparent = t.isStrokeTransparent || !1, this.strokeOpacity = t.strokeOpacity || 1, this.strokeStyle = t.strokeStyle || "#000000", this.fillStyle = t.fillStyle || "#000000", this.isFillTransparent = t.isFillTransparent || !1, this.fillOpacity = t.fillOpacity || 1, this.font = t.font || "10px sans-serif", this.textBaseline = t.textBaseline || "alphabetic", this.textAlign = t.textAlign || "left", this.lineWidth = t.lineWidth || 1, this.lineJoin = t.lineJoin || "miter", this.lineCap = t.lineCap || "butt", this.path = t.path || [], this.transform = void 0 !== t.transform ? t.transform.clone() : new M, this.globalCompositeOperation = t.globalCompositeOperation || "normal", this.globalAlpha = t.globalAlpha || 1, this.clip_path = t.clip_path || [], this.currentPoint = t.currentPoint || new j, this.miterLimit = t.miterLimit || 10, this.lastPoint = t.lastPoint || new j, this.ignoreClearRect = "boolean" != typeof t.ignoreClearRect || t.ignoreClearRect, this;
        };
        t.events.push([
            "initialized",
            function() {
                this.context2d = new n(this), l = this.internal.f2, this.internal.f3, i = this.internal.getCoordinateString, o = this.internal.getVerticalCoordinateString, h = this.internal.getHorizontalCoordinate, u = this.internal.getVerticalCoordinate;
            }
        ]);
        var n = function(t) {
            Object.defineProperty(this, "canvas", {
                get: function() {
                    return {
                        parentNode: !1,
                        style: !1
                    };
                }
            }), Object.defineProperty(this, "pdf", {
                get: function() {
                    return t;
                }
            });
            var e = !1;
            Object.defineProperty(this, "pageWrapXEnabled", {
                get: function() {
                    return e;
                },
                set: function(t) {
                    e = Boolean(t);
                }
            });
            var n = !1;
            Object.defineProperty(this, "pageWrapYEnabled", {
                get: function() {
                    return n;
                },
                set: function(t) {
                    n = Boolean(t);
                }
            });
            var r = 0;
            Object.defineProperty(this, "posX", {
                get: function() {
                    return r;
                },
                set: function(t) {
                    isNaN(t) || (r = t);
                }
            });
            var i = 0;
            Object.defineProperty(this, "posY", {
                get: function() {
                    return i;
                },
                set: function(t) {
                    isNaN(t) || (i = t);
                }
            });
            var o = !1;
            Object.defineProperty(this, "autoPaging", {
                get: function() {
                    return o;
                },
                set: function(t) {
                    o = Boolean(t);
                }
            });
            var a = 0;
            Object.defineProperty(this, "lastBreak", {
                get: function() {
                    return a;
                },
                set: function(t) {
                    a = t;
                }
            });
            var s = [];
            Object.defineProperty(this, "pageBreaks", {
                get: function() {
                    return s;
                },
                set: function(t) {
                    s = t;
                }
            });
            var l = new c;
            Object.defineProperty(this, "ctx", {
                get: function() {
                    return l;
                },
                set: function(t) {
                    t instanceof c && (l = t);
                }
            }), Object.defineProperty(this, "path", {
                get: function() {
                    return l.path;
                },
                set: function(t) {
                    l.path = t;
                }
            });
            var h = [];
            Object.defineProperty(this, "ctxStack", {
                get: function() {
                    return h;
                },
                set: function(t) {
                    h = t;
                }
            }), Object.defineProperty(this, "fillStyle", {
                get: function() {
                    return this.ctx.fillStyle;
                },
                set: function(t) {
                    var e;
                    e = f(t), this.ctx.fillStyle = e.style, this.ctx.isFillTransparent = 0 === e.a, this.ctx.fillOpacity = e.a, this.pdf.setFillColor(e.r, e.g, e.b, {
                        a: e.a
                    }), this.pdf.setTextColor(e.r, e.g, e.b, {
                        a: e.a
                    });
                }
            }), Object.defineProperty(this, "strokeStyle", {
                get: function() {
                    return this.ctx.strokeStyle;
                },
                set: function(t) {
                    var e = f(t);
                    this.ctx.strokeStyle = e.style, this.ctx.isStrokeTransparent = 0 === e.a, this.ctx.strokeOpacity = e.a, 0 === e.a ? this.pdf.setDrawColor(255, 255, 255) : (e.a, this.pdf.setDrawColor(e.r, e.g, e.b));
                }
            }), Object.defineProperty(this, "lineCap", {
                get: function() {
                    return this.ctx.lineCap;
                },
                set: function(t) {
                    -1 !== [
                        "butt",
                        "round",
                        "square"
                    ].indexOf(t) && (this.ctx.lineCap = t, this.pdf.setLineCap(t));
                }
            }), Object.defineProperty(this, "lineWidth", {
                get: function() {
                    return this.ctx.lineWidth;
                },
                set: function(t) {
                    isNaN(t) || (this.ctx.lineWidth = t, this.pdf.setLineWidth(t));
                }
            }), Object.defineProperty(this, "lineJoin", {
                get: function() {
                    return this.ctx.lineJoin;
                },
                set: function(t) {
                    -1 !== [
                        "bevel",
                        "round",
                        "miter"
                    ].indexOf(t) && (this.ctx.lineJoin = t, this.pdf.setLineJoin(t));
                }
            }), Object.defineProperty(this, "miterLimit", {
                get: function() {
                    return this.ctx.miterLimit;
                },
                set: function(t) {
                    isNaN(t) || (this.ctx.miterLimit = t, this.pdf.setMiterLimit(t));
                }
            }), Object.defineProperty(this, "textBaseline", {
                get: function() {
                    return this.ctx.textBaseline;
                },
                set: function(t) {
                    this.ctx.textBaseline = t;
                }
            }), Object.defineProperty(this, "textAlign", {
                get: function() {
                    return this.ctx.textAlign;
                },
                set: function(t) {
                    -1 !== [
                        "right",
                        "end",
                        "center",
                        "left",
                        "start"
                    ].indexOf(t) && (this.ctx.textAlign = t);
                }
            }), Object.defineProperty(this, "font", {
                get: function() {
                    return this.ctx.font;
                },
                set: function(t) {
                    var e;
                    if (this.ctx.font = t, null !== (e = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))) {
                        var n = e[1], r = (e[2], e[3]), i = e[4], o = e[5], a = e[6];
                        i = "px" === o ? Math.floor(parseFloat(i)) : "em" === o ? Math.floor(parseFloat(i) * this.pdf.getFontSize()) : Math.floor(parseFloat(i)), this.pdf.setFontSize(i);
                        var s = "";
                        ("bold" === r || 700 <= parseInt(r, 10) || "bold" === n) && (s = "bold"), "italic" === n && (s += "italic"), 0 === s.length && (s = "normal");
                        for(var l = "", h = a.toLowerCase().replace(/"|'/g, "").split(/\s*,\s*/), u = {
                            arial: "Helvetica",
                            verdana: "Helvetica",
                            helvetica: "Helvetica",
                            "sans-serif": "Helvetica",
                            fixed: "Courier",
                            monospace: "Courier",
                            terminal: "Courier",
                            courier: "Courier",
                            times: "Times",
                            cursive: "Times",
                            fantasy: "Times",
                            serif: "Times"
                        }, c = 0; c < h.length; c++){
                            if (void 0 !== this.pdf.internal.getFont(h[c], s, {
                                noFallback: !0,
                                disableWarning: !0
                            })) {
                                l = h[c];
                                break;
                            }
                            if ("bolditalic" === s && void 0 !== this.pdf.internal.getFont(h[c], "bold", {
                                noFallback: !0,
                                disableWarning: !0
                            })) l = h[c], s = "bold";
                            else if (void 0 !== this.pdf.internal.getFont(h[c], "normal", {
                                noFallback: !0,
                                disableWarning: !0
                            })) {
                                l = h[c], s = "normal";
                                break;
                            }
                        }
                        if ("" === l) {
                            for(c = 0; c < h.length; c++)if (u[h[c]]) {
                                l = u[h[c]];
                                break;
                            }
                        }
                        l = "" === l ? "Times" : l, this.pdf.setFont(l, s);
                    }
                }
            }), Object.defineProperty(this, "globalCompositeOperation", {
                get: function() {
                    return this.ctx.globalCompositeOperation;
                },
                set: function(t) {
                    this.ctx.globalCompositeOperation = t;
                }
            }), Object.defineProperty(this, "globalAlpha", {
                get: function() {
                    return this.ctx.globalAlpha;
                },
                set: function(t) {
                    this.ctx.globalAlpha = t;
                }
            }), Object.defineProperty(this, "ignoreClearRect", {
                get: function() {
                    return this.ctx.ignoreClearRect;
                },
                set: function(t) {
                    this.ctx.ignoreClearRect = Boolean(t);
                }
            });
        };
        n.prototype.fill = function() {
            r.call(this, "fill", !1);
        }, n.prototype.stroke = function() {
            r.call(this, "stroke", !1);
        }, n.prototype.beginPath = function() {
            this.path = [
                {
                    type: "begin"
                }
            ];
        }, n.prototype.moveTo = function(t, e) {
            if (isNaN(t) || isNaN(e)) throw console.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
            var n = this.ctx.transform.applyToPoint(new j(t, e));
            this.path.push({
                type: "mt",
                x: n.x,
                y: n.y
            }), this.ctx.lastPoint = new j(t, e);
        }, n.prototype.closePath = function() {
            var t = new j(0, 0), e = 0;
            for(e = this.path.length - 1; -1 !== e; e--)if ("begin" === this.path[e].type && "object" === se(this.path[e + 1]) && "number" == typeof this.path[e + 1].x) {
                t = new j(this.path[e + 1].x, this.path[e + 1].y), this.path.push({
                    type: "lt",
                    x: t.x,
                    y: t.y
                });
                break;
            }
            "object" === se(this.path[e + 2]) && "number" == typeof this.path[e + 2].x && this.path.push(JSON.parse(JSON.stringify(this.path[e + 2]))), this.path.push({
                type: "close"
            }), this.ctx.lastPoint = new j(t.x, t.y);
        }, n.prototype.lineTo = function(t, e) {
            if (isNaN(t) || isNaN(e)) throw console.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
            var n = this.ctx.transform.applyToPoint(new j(t, e));
            this.path.push({
                type: "lt",
                x: n.x,
                y: n.y
            }), this.ctx.lastPoint = new j(n.x, n.y);
        }, n.prototype.clip = function() {
            this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), r.call(this, null, !0);
        }, n.prototype.quadraticCurveTo = function(t, e, n, r) {
            if (isNaN(n) || isNaN(r) || isNaN(t) || isNaN(e)) throw console.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
            var i = this.ctx.transform.applyToPoint(new j(n, r)), o = this.ctx.transform.applyToPoint(new j(t, e));
            this.path.push({
                type: "qct",
                x1: o.x,
                y1: o.y,
                x: i.x,
                y: i.y
            }), this.ctx.lastPoint = new j(i.x, i.y);
        }, n.prototype.bezierCurveTo = function(t, e, n, r, i, o) {
            if (isNaN(i) || isNaN(o) || isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw console.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
            var a = this.ctx.transform.applyToPoint(new j(i, o)), s = this.ctx.transform.applyToPoint(new j(t, e)), l = this.ctx.transform.applyToPoint(new j(n, r));
            this.path.push({
                type: "bct",
                x1: s.x,
                y1: s.y,
                x2: l.x,
                y2: l.y,
                x: a.x,
                y: a.y
            }), this.ctx.lastPoint = new j(a.x, a.y);
        }, n.prototype.arc = function(t, e, n, r, i, o) {
            if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i)) throw console.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
            if (o = Boolean(o), !this.ctx.transform.isIdentity) {
                var a = this.ctx.transform.applyToPoint(new j(t, e));
                t = a.x, e = a.y;
                var s = this.ctx.transform.applyToPoint(new j(0, n)), l = this.ctx.transform.applyToPoint(new j(0, 0));
                n = Math.sqrt(Math.pow(s.x - l.x, 2) + Math.pow(s.y - l.y, 2));
            }
            Math.abs(i - r) >= 2 * Math.PI && (r = 0, i = 2 * Math.PI), this.path.push({
                type: "arc",
                x: t,
                y: e,
                radius: n,
                startAngle: r,
                endAngle: i,
                counterclockwise: o
            });
        }, n.prototype.arcTo = function(t, e, n, r, i) {
            throw new Error("arcTo not implemented.");
        }, n.prototype.rect = function(t, e, n, r) {
            if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw console.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
            this.moveTo(t, e), this.lineTo(t + n, e), this.lineTo(t + n, e + r), this.lineTo(t, e + r), this.lineTo(t, e), this.lineTo(t + n, e), this.lineTo(t, e);
        }, n.prototype.fillRect = function(t, e, n, r) {
            if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw console.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
            if (!N.call(this)) {
                var i = {};
                "butt" !== this.lineCap && (i.lineCap = this.lineCap, this.lineCap = "butt"), "miter" !== this.lineJoin && (i.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(t, e, n, r), this.fill(), i.hasOwnProperty("lineCap") && (this.lineCap = i.lineCap), i.hasOwnProperty("lineJoin") && (this.lineJoin = i.lineJoin);
            }
        }, n.prototype.strokeRect = function(t, e, n, r) {
            if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw console.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
            L.call(this) || (this.beginPath(), this.rect(t, e, n, r), this.stroke());
        }, n.prototype.clearRect = function(t, e, n, r) {
            if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r)) throw console.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
            this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(t, e, n, r));
        }, n.prototype.save = function(t) {
            t = "boolean" != typeof t || t;
            for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, n = 0; n < this.pdf.internal.getNumberOfPages(); n++)this.pdf.setPage(n + 1), this.pdf.internal.out("q");
            if (this.pdf.setPage(e), t) {
                this.ctx.fontSize = this.pdf.internal.getFontSize();
                var r = new c(this.ctx);
                this.ctxStack.push(this.ctx), this.ctx = r;
            }
        }, n.prototype.restore = function(t) {
            t = "boolean" != typeof t || t;
            for(var e = this.pdf.internal.getCurrentPageInfo().pageNumber, n = 0; n < this.pdf.internal.getNumberOfPages(); n++)this.pdf.setPage(n + 1), this.pdf.internal.out("Q");
            this.pdf.setPage(e), t && 0 !== this.ctxStack.length && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin);
        }, n.prototype.toDataURL = function() {
            throw new Error("toDataUrl not implemented.");
        };
        var f = function(t) {
            var e, n, r, i;
            if (!0 === t.isCanvasGradient && (t = t.getColor()), !t) return {
                r: 0,
                g: 0,
                b: 0,
                a: 0,
                style: t
            };
            if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t)) i = r = n = e = 0;
            else {
                var o = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);
                if (null !== o) e = parseInt(o[1]), n = parseInt(o[2]), r = parseInt(o[3]), i = 1;
                else if (null !== (o = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/.exec(t))) e = parseInt(o[1]), n = parseInt(o[2]), r = parseInt(o[3]), i = parseFloat(o[4]);
                else {
                    if (i = 1, "string" == typeof t && "#" !== t.charAt(0)) {
                        var a = new RGBColor(t);
                        t = a.ok ? a.toHex() : "#000000";
                    }
                    4 === t.length ? (e = t.substring(1, 2), e += e, n = t.substring(2, 3), n += n, r = t.substring(3, 4), r += r) : (e = t.substring(1, 3), n = t.substring(3, 5), r = t.substring(5, 7)), e = parseInt(e, 16), n = parseInt(n, 16), r = parseInt(r, 16);
                }
            }
            return {
                r: e,
                g: n,
                b: r,
                a: i,
                style: t
            };
        }, N = function() {
            return this.ctx.isFillTransparent || 0 == this.globalAlpha;
        }, L = function() {
            return Boolean(this.ctx.isStrokeTransparent || 0 == this.globalAlpha);
        };
        n.prototype.fillText = function(t, e, n, r) {
            if (isNaN(e) || isNaN(n) || "string" != typeof t) throw console.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
            if (r = isNaN(r) ? void 0 : r, !N.call(this)) {
                n = a.call(this, n);
                var i = B(this.ctx.transform.rotation), o = this.ctx.transform.scaleX;
                s.call(this, {
                    text: t,
                    x: e,
                    y: n,
                    scale: o,
                    angle: i,
                    align: this.textAlign,
                    maxWidth: r
                });
            }
        }, n.prototype.strokeText = function(t, e, n, r) {
            if (isNaN(e) || isNaN(n) || "string" != typeof t) throw console.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
            if (!L.call(this)) {
                r = isNaN(r) ? void 0 : r, n = a.call(this, n);
                var i = B(this.ctx.transform.rotation), o = this.ctx.transform.scaleX;
                s.call(this, {
                    text: t,
                    x: e,
                    y: n,
                    scale: o,
                    renderingMode: "stroke",
                    angle: i,
                    align: this.textAlign,
                    maxWidth: r
                });
            }
        }, n.prototype.measureText = function(t) {
            if ("string" != typeof t) throw console.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
            var e = this.pdf, n = this.pdf.internal.scaleFactor, r = e.internal.getFontSize(), i = e.getStringUnitWidth(t) * r / e.internal.scaleFactor;
            return new function(t) {
                var e = (t = t || {}).width || 0;
                return Object.defineProperty(this, "width", {
                    get: function() {
                        return e;
                    }
                }), this;
            }({
                width: i *= Math.round(96 * n / 72 * 1e4) / 1e4
            });
        }, n.prototype.scale = function(t, e) {
            if (isNaN(t) || isNaN(e)) throw console.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
            var n = new M(t, 0, 0, e, 0, 0);
            this.ctx.transform = this.ctx.transform.multiply(n);
        }, n.prototype.rotate = function(t) {
            if (isNaN(t)) throw console.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
            var e = new M(Math.cos(t), Math.sin(t), -Math.sin(t), Math.cos(t), 0, 0);
            this.ctx.transform = this.ctx.transform.multiply(e);
        }, n.prototype.translate = function(t, e) {
            if (isNaN(t) || isNaN(e)) throw console.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
            var n = new M(1, 0, 0, 1, t, e);
            this.ctx.transform = this.ctx.transform.multiply(n);
        }, n.prototype.transform = function(t, e, n, r, i, o) {
            if (isNaN(t) || isNaN(e) || isNaN(n) || isNaN(r) || isNaN(i) || isNaN(o)) throw console.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
            var a = new M(t, e, n, r, i, o);
            this.ctx.transform = this.ctx.transform.multiply(a);
        }, n.prototype.setTransform = function(t, e, n, r, i, o) {
            t = isNaN(t) ? 1 : t, e = isNaN(e) ? 0 : e, n = isNaN(n) ? 0 : n, r = isNaN(r) ? 1 : r, i = isNaN(i) ? 0 : i, o = isNaN(o) ? 0 : o, this.ctx.transform = new M(t, e, n, r, i, o);
        }, n.prototype.drawImage = function(t, e, n, r, i, o, a, s, l) {
            var h = this.pdf.getImageProperties(t), u = 1, c = 1, f = 1, p = 1;
            void 0 !== r && void 0 !== s && (f = s / r, p = l / i, u = h.width / r * s / r, c = h.height / i * l / i), void 0 === o && (o = e, a = n, n = e = 0), void 0 !== r && void 0 === s && (s = r, l = i), void 0 === r && void 0 === s && (s = h.width, l = h.height);
            var d = this.ctx.transform.decompose(), g = B(d.rotate.shx);
            d.scale.sx, d.scale.sy;
            for(var m, y = new M, v = ((y = (y = (y = y.multiply(d.translate)).multiply(d.skew)).multiply(d.scale)).applyToPoint(new j(s, l)), y.applyToRectangle(new E(o - e * f, a - n * p, r * u, i * c))), w = F.call(this, v), b = [], x = 0; x < w.length; x += 1)-1 === b.indexOf(w[x]) && b.push(w[x]);
            if (b.sort(), this.autoPaging) for(var N = b[0], L = b[b.length - 1], A = N; A < L + 1; A++){
                if (this.pdf.setPage(A), 0 !== this.ctx.clip_path.length) {
                    var S = this.path;
                    m = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = P(m, this.posX, -1 * this.pdf.internal.pageSize.height * (A - 1) + this.posY), k.call(this, "fill", !0), this.path = S;
                }
                var _ = JSON.parse(JSON.stringify(v));
                _ = P([
                    _
                ], this.posX, -1 * this.pdf.internal.pageSize.height * (A - 1) + this.posY)[0], this.pdf.addImage(t, "jpg", _.x, _.y, _.w, _.h, null, null, g);
            }
            else this.pdf.addImage(t, "jpg", v.x, v.y, v.w, v.h, null, null, g);
        };
        var F = function(t, e, n) {
            var r = [];
            switch(e = e || this.pdf.internal.pageSize.width, n = n || this.pdf.internal.pageSize.height, t.type){
                default:
                case "mt":
                case "lt":
                    r.push(Math.floor((t.y + this.posY) / n) + 1);
                    break;
                case "arc":
                    r.push(Math.floor((t.y + this.posY - t.radius) / n) + 1), r.push(Math.floor((t.y + this.posY + t.radius) / n) + 1);
                    break;
                case "qct":
                    var i = w(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x, t.y);
                    r.push(Math.floor(i.y / n) + 1), r.push(Math.floor((i.y + i.h) / n) + 1);
                    break;
                case "bct":
                    var o = b(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x2, t.y2, t.x, t.y);
                    r.push(Math.floor(o.y / n) + 1), r.push(Math.floor((o.y + o.h) / n) + 1);
                    break;
                case "rect":
                    r.push(Math.floor((t.y + this.posY) / n) + 1), r.push(Math.floor((t.y + t.h + this.posY) / n) + 1);
            }
            for(var a = 0; a < r.length; a += 1)for(; this.pdf.internal.getNumberOfPages() < r[a];)v.call(this);
            return r;
        }, v = function() {
            var t = this.fillStyle, e = this.strokeStyle, n = this.font, r = this.lineCap, i = this.lineWidth, o = this.lineJoin;
            this.pdf.addPage(), this.fillStyle = t, this.strokeStyle = e, this.font = n, this.lineCap = r, this.lineWidth = i, this.lineJoin = o;
        }, P = function(t, e, n) {
            for(var r = 0; r < t.length; r++)switch(t[r].type){
                case "bct":
                    t[r].x2 += e, t[r].y2 += n;
                case "qct":
                    t[r].x1 += e, t[r].y1 += n;
                case "mt":
                case "lt":
                case "arc":
                default:
                    t[r].x += e, t[r].y += n;
            }
            return t;
        }, r = function(t, e) {
            for(var n, r, i = this.fillStyle, o = this.strokeStyle, a = (this.font, this.lineCap), s = this.lineWidth, l = this.lineJoin, h = JSON.parse(JSON.stringify(this.path)), u = JSON.parse(JSON.stringify(this.path)), c = [], f = 0; f < u.length; f++)if (void 0 !== u[f].x) for(var p = F.call(this, u[f]), d = 0; d < p.length; d += 1)-1 === c.indexOf(p[d]) && c.push(p[d]);
            for(f = 0; f < c.length; f++)for(; this.pdf.internal.getNumberOfPages() < c[f];)v.call(this);
            if (c.sort(), this.autoPaging) {
                var g = c[0], m = c[c.length - 1];
                for(f = g; f < m + 1; f++){
                    if (this.pdf.setPage(f), this.fillStyle = i, this.strokeStyle = o, this.lineCap = a, this.lineWidth = s, this.lineJoin = l, 0 !== this.ctx.clip_path.length) {
                        var y = this.path;
                        n = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = P(n, this.posX, -1 * this.pdf.internal.pageSize.height * (f - 1) + this.posY), k.call(this, t, !0), this.path = y;
                    }
                    r = JSON.parse(JSON.stringify(h)), this.path = P(r, this.posX, -1 * this.pdf.internal.pageSize.height * (f - 1) + this.posY), !1 !== e && 0 !== f || k.call(this, t, e);
                }
            } else k.call(this, t, e);
            this.path = h;
        }, k = function(t, e) {
            if (("stroke" !== t || e || !L.call(this)) && ("stroke" === t || e || !N.call(this))) {
                var n = [];
                this.ctx.globalAlpha;
                this.ctx.fillOpacity < 1 && this.ctx.fillOpacity;
                for(var r, i = this.path, o = 0; o < i.length; o++){
                    var a = i[o];
                    switch(a.type){
                        case "begin":
                            n.push({
                                begin: !0
                            });
                            break;
                        case "close":
                            n.push({
                                close: !0
                            });
                            break;
                        case "mt":
                            n.push({
                                start: a,
                                deltas: [],
                                abs: []
                            });
                            break;
                        case "lt":
                            var s = n.length;
                            if (!isNaN(i[o - 1].x)) {
                                var l = [
                                    a.x - i[o - 1].x,
                                    a.y - i[o - 1].y
                                ];
                                if (0 < s) {
                                    for(; 0 <= s; s--)if (!0 !== n[s - 1].close && !0 !== n[s - 1].begin) {
                                        n[s - 1].deltas.push(l), n[s - 1].abs.push(a);
                                        break;
                                    }
                                }
                            }
                            break;
                        case "bct":
                            l = [
                                a.x1 - i[o - 1].x,
                                a.y1 - i[o - 1].y,
                                a.x2 - i[o - 1].x,
                                a.y2 - i[o - 1].y,
                                a.x - i[o - 1].x,
                                a.y - i[o - 1].y
                            ];
                            n[n.length - 1].deltas.push(l);
                            break;
                        case "qct":
                            var h = i[o - 1].x + 2 / 3 * (a.x1 - i[o - 1].x), u = i[o - 1].y + 2 / 3 * (a.y1 - i[o - 1].y), c = a.x + 2 / 3 * (a.x1 - a.x), f = a.y + 2 / 3 * (a.y1 - a.y), p = a.x, d = a.y;
                            l = [
                                h - i[o - 1].x,
                                u - i[o - 1].y,
                                c - i[o - 1].x,
                                f - i[o - 1].y,
                                p - i[o - 1].x,
                                d - i[o - 1].y
                            ];
                            n[n.length - 1].deltas.push(l);
                            break;
                        case "arc":
                            n.push({
                                deltas: [],
                                abs: [],
                                arc: !0
                            }), Array.isArray(n[n.length - 1].abs) && n[n.length - 1].abs.push(a);
                    }
                }
                r = e ? null : "stroke" === t ? "stroke" : "fill";
                for(o = 0; o < n.length; o++){
                    if (n[o].arc) for(var g = n[o].abs, m = 0; m < g.length; m++){
                        var y = g[m];
                        if (void 0 !== y.startAngle) {
                            var v = B(y.startAngle), w = B(y.endAngle), b = y.x, x = y.y;
                            A.call(this, b, x, y.radius, v, w, y.counterclockwise, r, e);
                        } else I.call(this, y.x, y.y);
                    }
                    if (!n[o].arc && !0 !== n[o].close && !0 !== n[o].begin) {
                        b = n[o].start.x, x = n[o].start.y;
                        C.call(this, n[o].deltas, b, x, null, null);
                    }
                }
                r && S.call(this, r), e && _.call(this);
            }
        }, a = function(t) {
            var e = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, n = e * (this.pdf.internal.getLineHeightFactor() - 1);
            switch(this.ctx.textBaseline){
                case "bottom":
                    return t - n;
                case "top":
                    return t + e - n;
                case "hanging":
                    return t + e - 2 * n;
                case "middle":
                    return t + e / 2 - n;
                case "ideographic":
                    return t;
                case "alphabetic":
                default:
                    return t;
            }
        };
        n.prototype.createLinearGradient = function() {
            var t = function() {};
            return t.colorStops = [], t.addColorStop = function(t, e) {
                this.colorStops.push([
                    t,
                    e
                ]);
            }, t.getColor = function() {
                return 0 === this.colorStops.length ? "#000000" : this.colorStops[0][1];
            }, t.isCanvasGradient = !0, t;
        }, n.prototype.createPattern = function() {
            return this.createLinearGradient();
        }, n.prototype.createRadialGradient = function() {
            return this.createLinearGradient();
        };
        var A = function(t, e, n, r, i, o, a, s) {
            this.pdf.internal.scaleFactor;
            for(var l = y(r), h = y(i), u = g.call(this, n, l, h, o), c = 0; c < u.length; c++){
                var f = u[c];
                0 === c && p.call(this, f.x1 + t, f.y1 + e), d.call(this, t, e, f.x2, f.y2, f.x3, f.y3, f.x4, f.y4);
            }
            s ? _.call(this) : S.call(this, a);
        }, S = function(t) {
            switch(t){
                case "stroke":
                    this.pdf.internal.out("S");
                    break;
                case "fill":
                    this.pdf.internal.out("f");
            }
        }, _ = function() {
            this.pdf.clip();
        }, p = function(t, e) {
            this.pdf.internal.out(i(t) + " " + o(e) + " m");
        }, s = function(t) {
            var e;
            switch(t.align){
                case "right":
                case "end":
                    e = "right";
                    break;
                case "center":
                    e = "center";
                    break;
                case "left":
                case "start":
                default:
                    e = "left";
            }
            var n = this.ctx.transform.applyToPoint(new j(t.x, t.y)), r = this.ctx.transform.decompose(), i = new M;
            i = (i = (i = i.multiply(r.translate)).multiply(r.skew)).multiply(r.scale);
            for(var o, a = this.pdf.getTextDimensions(t.text), s = this.ctx.transform.applyToRectangle(new E(t.x, t.y, a.w, a.h)), l = i.applyToRectangle(new E(t.x, t.y - a.h, a.w, a.h)), h = F.call(this, l), u = [], c = 0; c < h.length; c += 1)-1 === u.indexOf(h[c]) && u.push(h[c]);
            if (u.sort(), !0 === this.autoPaging) for(var f = u[0], p = u[u.length - 1], d = f; d < p + 1; d++){
                if (this.pdf.setPage(d), 0 !== this.ctx.clip_path.length) {
                    var g = this.path;
                    o = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = P(o, this.posX, -1 * this.pdf.internal.pageSize.height * (d - 1) + this.posY), k.call(this, "fill", !0), this.path = g;
                }
                var m = JSON.parse(JSON.stringify(s));
                if (m = P([
                    m
                ], this.posX, -1 * this.pdf.internal.pageSize.height * (d - 1) + this.posY)[0], .01 <= t.scale) {
                    var y = this.pdf.internal.getFontSize();
                    this.pdf.setFontSize(y * t.scale);
                }
                this.pdf.text(t.text, m.x, m.y, {
                    angle: t.angle,
                    align: e,
                    renderingMode: t.renderingMode,
                    maxWidth: t.maxWidth
                }), .01 <= t.scale && this.pdf.setFontSize(y);
            }
            else {
                if (.01 <= t.scale) {
                    y = this.pdf.internal.getFontSize();
                    this.pdf.setFontSize(y * t.scale);
                }
                this.pdf.text(t.text, n.x + this.posX, n.y + this.posY, {
                    angle: t.angle,
                    align: e,
                    renderingMode: t.renderingMode,
                    maxWidth: t.maxWidth
                }), .01 <= t.scale && this.pdf.setFontSize(y);
            }
        }, I = function(t, e, n, r) {
            n = n || 0, r = r || 0, this.pdf.internal.out(i(t + n) + " " + o(e + r) + " l");
        }, C = function(t, e, n) {
            return this.pdf.lines(t, e, n, null, null);
        }, d = function(t, e, n, r, i, o, a, s) {
            this.pdf.internal.out([
                l(h(n + t)),
                l(u(r + e)),
                l(h(i + t)),
                l(u(o + e)),
                l(h(a + t)),
                l(u(s + e)),
                "c"
            ].join(" "));
        }, g = function(t, e, n, r) {
            var i = 2 * Math.PI, o = e;
            (o < i || i < o) && (o %= i);
            var a = n;
            (a < i || i < a) && (a %= i);
            for(var s = [], l = Math.PI / 2, h = r ? -1 : 1, u = e, c = Math.min(i, Math.abs(a - o)); 1e-5 < c;){
                var f = u + h * Math.min(c, l);
                s.push(m.call(this, t, u, f)), c -= Math.abs(f - u), u = f;
            }
            return s;
        }, m = function(t, e, n) {
            var r = (n - e) / 2, i = t * Math.cos(r), o = t * Math.sin(r), a = i, s = -o, l = a * a + s * s, h = l + a * i + s * o, u = 4 / 3 * (Math.sqrt(2 * l * h) - h) / (a * o - s * i), c = a - u * s, f = s + u * a, p = c, d = -f, g = r + e, m = Math.cos(g), y = Math.sin(g);
            return {
                x1: t * Math.cos(e),
                y1: t * Math.sin(e),
                x2: c * m - f * y,
                y2: c * y + f * m,
                x3: p * m - d * y,
                y3: p * y + d * m,
                x4: t * Math.cos(n),
                y4: t * Math.sin(n)
            };
        }, B = function(t) {
            return 180 * t / Math.PI;
        }, y = function(t) {
            return t * Math.PI / 180;
        }, w = function(t, e, n, r, i, o) {
            var a = t + .5 * (n - t), s = e + .5 * (r - e), l = i + .5 * (n - i), h = o + .5 * (r - o), u = Math.min(t, i, a, l), c = Math.max(t, i, a, l), f = Math.min(e, o, s, h), p = Math.max(e, o, s, h);
            return new E(u, f, c - u, p - f);
        }, b = function(t, e, n, r, i, o, a, s) {
            for(var l, h, u, c, f, p, d, g, m, y, v, w, b, x = n - t, N = r - e, L = i - n, A = o - r, S = a - i, _ = s - o, F = 0; F < 41; F++)g = (p = (h = t + (l = F / 40) * x) + l * ((c = n + l * L) - h)) + l * (c + l * (i + l * S - c) - p), m = (d = (u = e + l * N) + l * ((f = r + l * A) - u)) + l * (f + l * (o + l * _ - f) - d), b = 0 == F ? (w = y = g, v = m) : (y = Math.min(y, g), v = Math.min(v, m), w = Math.max(w, g), Math.max(b, m));
            return new E(Math.round(y), Math.round(v), Math.round(w - y), Math.round(b - v));
        }, j = function(t, e) {
            var n = t || 0;
            Object.defineProperty(this, "x", {
                enumerable: !0,
                get: function() {
                    return n;
                },
                set: function(t) {
                    isNaN(t) || (n = parseFloat(t));
                }
            });
            var r = e || 0;
            Object.defineProperty(this, "y", {
                enumerable: !0,
                get: function() {
                    return r;
                },
                set: function(t) {
                    isNaN(t) || (r = parseFloat(t));
                }
            });
            var i = "pt";
            return Object.defineProperty(this, "type", {
                enumerable: !0,
                get: function() {
                    return i;
                },
                set: function(t) {
                    i = t.toString();
                }
            }), this;
        }, E = function(t, e, n, r) {
            j.call(this, t, e), this.type = "rect";
            var i = n || 0;
            Object.defineProperty(this, "w", {
                enumerable: !0,
                get: function() {
                    return i;
                },
                set: function(t) {
                    isNaN(t) || (i = parseFloat(t));
                }
            });
            var o = r || 0;
            return Object.defineProperty(this, "h", {
                enumerable: !0,
                get: function() {
                    return o;
                },
                set: function(t) {
                    isNaN(t) || (o = parseFloat(t));
                }
            }), this;
        }, M = function(t, e, n, r, i, o) {
            var a = [];
            return Object.defineProperty(this, "sx", {
                get: function() {
                    return a[0];
                },
                set: function(t) {
                    a[0] = Math.round(1e5 * t) / 1e5;
                }
            }), Object.defineProperty(this, "shy", {
                get: function() {
                    return a[1];
                },
                set: function(t) {
                    a[1] = Math.round(1e5 * t) / 1e5;
                }
            }), Object.defineProperty(this, "shx", {
                get: function() {
                    return a[2];
                },
                set: function(t) {
                    a[2] = Math.round(1e5 * t) / 1e5;
                }
            }), Object.defineProperty(this, "sy", {
                get: function() {
                    return a[3];
                },
                set: function(t) {
                    a[3] = Math.round(1e5 * t) / 1e5;
                }
            }), Object.defineProperty(this, "tx", {
                get: function() {
                    return a[4];
                },
                set: function(t) {
                    a[4] = Math.round(1e5 * t) / 1e5;
                }
            }), Object.defineProperty(this, "ty", {
                get: function() {
                    return a[5];
                },
                set: function(t) {
                    a[5] = Math.round(1e5 * t) / 1e5;
                }
            }), Object.defineProperty(this, "rotation", {
                get: function() {
                    return Math.atan2(this.shx, this.sx);
                }
            }), Object.defineProperty(this, "scaleX", {
                get: function() {
                    return this.decompose().scale.sx;
                }
            }), Object.defineProperty(this, "scaleY", {
                get: function() {
                    return this.decompose().scale.sy;
                }
            }), Object.defineProperty(this, "isIdentity", {
                get: function() {
                    return 1 === this.sx && 0 === this.shy && 0 === this.shx && 1 === this.sy && 0 === this.tx && 0 === this.ty;
                }
            }), this.sx = isNaN(t) ? 1 : t, this.shy = isNaN(e) ? 0 : e, this.shx = isNaN(n) ? 0 : n, this.sy = isNaN(r) ? 1 : r, this.tx = isNaN(i) ? 0 : i, this.ty = isNaN(o) ? 0 : o, this;
        };
        M.prototype.multiply = function(t) {
            var e = t.sx * this.sx + t.shy * this.shx, n = t.sx * this.shy + t.shy * this.sy, r = t.shx * this.sx + t.sy * this.shx, i = t.shx * this.shy + t.sy * this.sy, o = t.tx * this.sx + t.ty * this.shx + this.tx, a = t.tx * this.shy + t.ty * this.sy + this.ty;
            return new M(e, n, r, i, o, a);
        }, M.prototype.decompose = function() {
            var t = this.sx, e = this.shy, n = this.shx, r = this.sy, i = this.tx, o = this.ty, a = Math.sqrt(t * t + e * e), s = (t /= a) * n + (e /= a) * r;
            n -= t * s, r -= e * s;
            var l = Math.sqrt(n * n + r * r);
            return s /= l, t * (r /= l) < e * (n /= l) && (t = -t, e = -e, s = -s, a = -a), {
                scale: new M(a, 0, 0, l, 0, 0),
                translate: new M(1, 0, 0, 1, i, o),
                rotate: new M(t, e, -e, t, 0, 0),
                skew: new M(1, 0, s, 1, 0, 0)
            };
        }, M.prototype.applyToPoint = function(t) {
            var e = t.x * this.sx + t.y * this.shx + this.tx, n = t.x * this.shy + t.y * this.sy + this.ty;
            return new j(e, n);
        }, M.prototype.applyToRectangle = function(t) {
            var e = this.applyToPoint(t), n = this.applyToPoint(new j(t.x + t.w, t.y + t.h));
            return new E(e.x, e.y, n.x - e.x, n.y - e.y);
        }, M.prototype.clone = function() {
            var t = this.sx, e = this.shy, n = this.shx, r = this.sy, i = this.tx, o = this.ty;
            return new M(t, e, n, r, i, o);
        };
    }(lt.API, "undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")()), /**
   * jsPDF filters PlugIn
   * Copyright (c) 2014 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ a = lt.API, o = function(t) {
        var r, e, n, i, o, a, s, l, h, u;
        for(/[^\x00-\xFF]/.test(t), e = [], n = 0, i = (t += r = "\x00\x00\x00\x00".slice(t.length % 4 || 4)).length; n < i; n += 4)0 !== (o = (t.charCodeAt(n) << 24) + (t.charCodeAt(n + 1) << 16) + (t.charCodeAt(n + 2) << 8) + t.charCodeAt(n + 3)) ? (a = (o = ((o = ((o = ((o = (o - (u = o % 85)) / 85) - (h = o % 85)) / 85) - (l = o % 85)) / 85) - (s = o % 85)) / 85) % 85, e.push(a + 33, s + 33, l + 33, h + 33, u + 33)) : e.push(122);
        return function(t, e) {
            for(var n = r.length; 0 < n; n--)t.pop();
        }(e), String.fromCharCode.apply(String, e) + "~>";
    }, s = function(t) {
        var r, e, n, i, o, a = String, s = "length", l = "charCodeAt", h = "slice", u = "replace";
        for(t[h](-2), t = t[h](0, -2)[u](/\s/g, "")[u]("z", "!!!!!"), n = [], i = 0, o = (t += r = "uuuuu"[h](t[s] % 5 || 5))[s]; i < o; i += 5)e = 52200625 * (t[l](i) - 33) + 614125 * (t[l](i + 1) - 33) + 7225 * (t[l](i + 2) - 33) + 85 * (t[l](i + 3) - 33) + (t[l](i + 4) - 33), n.push(255 & e >> 24, 255 & e >> 16, 255 & e >> 8, 255 & e);
        return function(t, e) {
            for(var n = r[s]; 0 < n; n--)t.pop();
        }(n), a.fromCharCode.apply(a, n);
    }, h = function(t) {
        for(var e = "", n = 0; n < t.length; n += 1)e += ("0" + t.charCodeAt(n).toString(16)).slice(-2);
        return e += ">";
    }, u = function(t) {
        var e = new RegExp(/^([0-9A-Fa-f]{2})+$/);
        if (-1 !== (t = t.replace(/\s/g, "")).indexOf(">") && (t = t.substr(0, t.indexOf(">"))), t.length % 2 && (t += "0"), !1 === e.test(t)) return "";
        for(var n = "", r = 0; r < t.length; r += 2)n += String.fromCharCode("0x" + (t[r] + t[r + 1]));
        return n;
    }, c = function(t, e) {
        e = Object.assign({
            predictor: 1,
            colors: 1,
            bitsPerComponent: 8,
            columns: 1
        }, e);
        for(var n, r, i = [], o = t.length; o--;)i[o] = t.charCodeAt(o);
        return n = a.adler32cs.from(t), (r = new Deflater(6)).append(new Uint8Array(i)), t = r.flush(), (i = new Uint8Array(t.length + 6)).set(new Uint8Array([
            120,
            156
        ])), i.set(t, 2), i.set(new Uint8Array([
            255 & n,
            n >> 8 & 255,
            n >> 16 & 255,
            n >> 24 & 255
        ]), t.length + 2), t = String.fromCharCode.apply(null, i);
    }, a.processDataByFilters = function(t, e) {
        var n = 0, r = t || "", i = [];
        for("string" == typeof (e = e || []) && (e = [
            e
        ]), n = 0; n < e.length; n += 1)switch(e[n]){
            case "ASCII85Decode":
            case "/ASCII85Decode":
                r = s(r), i.push("/ASCII85Encode");
                break;
            case "ASCII85Encode":
            case "/ASCII85Encode":
                r = o(r), i.push("/ASCII85Decode");
                break;
            case "ASCIIHexDecode":
            case "/ASCIIHexDecode":
                r = u(r), i.push("/ASCIIHexEncode");
                break;
            case "ASCIIHexEncode":
            case "/ASCIIHexEncode":
                r = h(r), i.push("/ASCIIHexDecode");
                break;
            case "FlateEncode":
            case "/FlateEncode":
                r = c(r), i.push("/FlateDecode");
                break;
            default:
                throw 'The filter: "' + e[n] + '" is not implemented';
        }
        return {
            data: r,
            reverseChain: i.reverse().join(" ")
        };
    }, /**
   * jsPDF fileloading PlugIn
   * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ (r = lt.API).loadFile = function(t, e, n) {
        var r;
        e = e || !0, n = n || function() {};
        try {
            r = function(t, e, n) {
                var r = new XMLHttpRequest, i = [], o = 0, a = function(t) {
                    var e = t.length, n = String.fromCharCode;
                    for(o = 0; o < e; o += 1)i.push(n(255 & t.charCodeAt(o)));
                    return i.join("");
                };
                if (r.open("GET", t, !e), r.overrideMimeType("text/plain; charset=x-user-defined"), !1 === e && (r.onload = function() {
                    return a(this.responseText);
                }), r.send(null), 200 === r.status) return e ? a(r.responseText) : void 0;
                console.warn('Unable to load file "' + t + '"');
            }(t, e);
        } catch (t) {
            r = void 0;
        }
        return r;
    }, r.loadImageFile = r.loadFile, /**
   * Copyright (c) 2018 Erik Koopmans
   * Released under the MIT License.
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ i = lt.API, f = "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global, g = function(t) {
        var e = se(t);
        return "undefined" === e ? "undefined" : "string" === e || t instanceof String ? "string" : "number" === e || t instanceof Number ? "number" : "function" === e || t instanceof Function ? "function" : t && t.constructor === Array ? "array" : t && 1 === t.nodeType ? "element" : "object" === e ? "object" : "unknown";
    }, m = function(t, e) {
        var n = document.createElement(t);
        if (e.className && (n.className = e.className), e.innerHTML) {
            n.innerHTML = e.innerHTML;
            for(var r = n.getElementsByTagName("script"), i = r.length; 0 < i--;)r[i].parentNode.removeChild(r[i]);
        }
        for(var o in e.style)n.style[o] = e.style[o];
        return n;
    }, (((y = function t(e) {
        var n = Object.assign(t.convert(Promise.resolve()), JSON.parse(JSON.stringify(t.template))), r = t.convert(Promise.resolve(), n);
        return r = (r = r.setProgress(1, t, 1, [
            t
        ])).set(e);
    }).prototype = Object.create(Promise.prototype)).constructor = y).convert = function(t, e) {
        return t.__proto__ = e || y.prototype, t;
    }, y.template = {
        prop: {
            src: null,
            container: null,
            overlay: null,
            canvas: null,
            img: null,
            pdf: null,
            pageSize: null,
            callback: function() {}
        },
        progress: {
            val: 0,
            state: null,
            n: 0,
            stack: []
        },
        opt: {
            filename: "file.pdf",
            margin: [
                0,
                0,
                0,
                0
            ],
            enableLinks: !0,
            x: 0,
            y: 0,
            html2canvas: {},
            jsPDF: {}
        }
    }, y.prototype.from = function(t, e) {
        return this.then(function() {
            switch(e = e || function(t) {
                switch(g(t)){
                    case "string":
                        return "string";
                    case "element":
                        return "canvas" === t.nodeName.toLowerCase ? "canvas" : "element";
                    default:
                        return "unknown";
                }
            }(t)){
                case "string":
                    return this.set({
                        src: m("div", {
                            innerHTML: t
                        })
                    });
                case "element":
                    return this.set({
                        src: t
                    });
                case "canvas":
                    return this.set({
                        canvas: t
                    });
                case "img":
                    return this.set({
                        img: t
                    });
                default:
                    return this.error("Unknown source type.");
            }
        });
    }, y.prototype.to = function(t) {
        switch(t){
            case "container":
                return this.toContainer();
            case "canvas":
                return this.toCanvas();
            case "img":
                return this.toImg();
            case "pdf":
                return this.toPdf();
            default:
                return this.error("Invalid target.");
        }
    }, y.prototype.toContainer = function() {
        return this.thenList([
            function() {
                return this.prop.src || this.error("Cannot duplicate - no source HTML.");
            },
            function() {
                return this.prop.pageSize || this.setPageSize();
            }
        ]).then(function() {
            var t = {
                position: "relative",
                display: "inline-block",
                width: Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) + "px",
                left: 0,
                right: 0,
                top: 0,
                margin: "auto",
                backgroundColor: "white"
            }, e = function t(e, n) {
                for(var r = 3 === e.nodeType ? document.createTextNode(e.nodeValue) : e.cloneNode(!1), i = e.firstChild; i; i = i.nextSibling)!0 !== n && 1 === i.nodeType && "SCRIPT" === i.nodeName || r.appendChild(t(i, n));
                return 1 === e.nodeType && ("CANVAS" === e.nodeName ? (r.width = e.width, r.height = e.height, r.getContext("2d").drawImage(e, 0, 0)) : "TEXTAREA" !== e.nodeName && "SELECT" !== e.nodeName || (r.value = e.value), r.addEventListener("load", function() {
                    r.scrollTop = e.scrollTop, r.scrollLeft = e.scrollLeft;
                }, !0)), r;
            }(this.prop.src, this.opt.html2canvas.javascriptEnabled);
            "BODY" === e.tagName && (t.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = m("div", {
                className: "html2pdf__overlay",
                style: {
                    position: "fixed",
                    overflow: "hidden",
                    zIndex: 1e3,
                    left: "-100000px",
                    right: 0,
                    bottom: 0,
                    top: 0
                }
            }), this.prop.container = m("div", {
                className: "html2pdf__container",
                style: t
            }), this.prop.container.appendChild(e), this.prop.container.firstChild.appendChild(m("div", {
                style: {
                    clear: "both",
                    border: "0 none transparent",
                    margin: 0,
                    padding: 0,
                    height: 0
                }
            })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
        });
    }, y.prototype.toCanvas = function() {
        var t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(t).then(function() {
            var t = Object.assign({}, this.opt.html2canvas);
            if (delete t.onrendered, this.isHtml2CanvasLoaded()) return html2canvas(this.prop.container, t);
        }).then(function(t) {
            (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, y.prototype.toContext2d = function() {
        var t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(t).then(function() {
            var t = this.opt.jsPDF, e = Object.assign({
                async: !0,
                allowTaint: !0,
                backgroundColor: "#ffffff",
                imageTimeout: 15e3,
                logging: !0,
                proxy: null,
                removeContainer: !0,
                foreignObjectRendering: !1,
                useCORS: !1
            }, this.opt.html2canvas);
            if (delete e.onrendered, t.context2d.autoPaging = !0, t.context2d.posX = this.opt.x, t.context2d.posY = this.opt.y, e.windowHeight = e.windowHeight || 0, e.windowHeight = 0 == e.windowHeight ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : e.windowHeight, this.isHtml2CanvasLoaded()) return html2canvas(this.prop.container, e);
        }).then(function(t) {
            (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, y.prototype.toImg = function() {
        return this.thenList([
            function() {
                return this.prop.canvas || this.toCanvas();
            }
        ]).then(function() {
            var t = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
            this.prop.img = document.createElement("img"), this.prop.img.src = t;
        });
    }, y.prototype.toPdf = function() {
        return this.thenList([
            function() {
                return this.toContext2d();
            }
        ]).then(function() {
            this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
        });
    }, y.prototype.output = function(t, e, n) {
        return "img" === (n = n || "pdf").toLowerCase() || "image" === n.toLowerCase() ? this.outputImg(t, e) : this.outputPdf(t, e);
    }, y.prototype.outputPdf = function(t, e) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            return this.prop.pdf.output(t, e);
        });
    }, y.prototype.outputImg = function(t, e) {
        return this.thenList([
            function() {
                return this.prop.img || this.toImg();
            }
        ]).then(function() {
            switch(t){
                case void 0:
                case "img":
                    return this.prop.img;
                case "datauristring":
                case "dataurlstring":
                    return this.prop.img.src;
                case "datauri":
                case "dataurl":
                    return document.location.href = this.prop.img.src;
                default:
                    throw 'Image output type "' + t + '" is not supported.';
            }
        });
    }, y.prototype.isHtml2CanvasLoaded = function() {
        var t = void 0 !== f.html2canvas;
        return t || console.error("html2canvas not loaded."), t;
    }, y.prototype.save = function(t) {
        if (this.isHtml2CanvasLoaded()) return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).set(t ? {
            filename: t
        } : null).then(function() {
            this.prop.pdf.save(this.opt.filename);
        });
    }, y.prototype.doCallback = function(t) {
        if (this.isHtml2CanvasLoaded()) return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            this.prop.callback(this.prop.pdf);
        });
    }, y.prototype.set = function(e) {
        if ("object" !== g(e)) return this;
        var t = Object.keys(e || {}).map(function(t) {
            if (t in y.template.prop) return function() {
                this.prop[t] = e[t];
            };
            switch(t){
                case "margin":
                    return this.setMargin.bind(this, e.margin);
                case "jsPDF":
                    return function() {
                        return this.opt.jsPDF = e.jsPDF, this.setPageSize();
                    };
                case "pageSize":
                    return this.setPageSize.bind(this, e.pageSize);
                default:
                    return function() {
                        this.opt[t] = e[t];
                    };
            }
        }, this);
        return this.then(function() {
            return this.thenList(t);
        });
    }, y.prototype.get = function(e, n) {
        return this.then(function() {
            var t = e in y.template.prop ? this.prop[e] : this.opt[e];
            return n ? n(t) : t;
        });
    }, y.prototype.setMargin = function(t) {
        return this.then(function() {
            switch(g(t)){
                case "number":
                    t = [
                        t,
                        t,
                        t,
                        t
                    ];
                case "array":
                    if (2 === t.length && (t = [
                        t[0],
                        t[1],
                        t[0],
                        t[1]
                    ]), 4 === t.length) break;
                default:
                    return this.error("Invalid margin array.");
            }
            this.opt.margin = t;
        }).then(this.setPageSize);
    }, y.prototype.setPageSize = function(t) {
        function e(t, e) {
            return Math.floor(t * e / 72 * 96);
        }
        return this.then(function() {
            (t = t || lt.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (t.inner = {
                width: t.width - this.opt.margin[1] - this.opt.margin[3],
                height: t.height - this.opt.margin[0] - this.opt.margin[2]
            }, t.inner.px = {
                width: e(t.inner.width, t.k),
                height: e(t.inner.height, t.k)
            }, t.inner.ratio = t.inner.height / t.inner.width), this.prop.pageSize = t;
        });
    }, y.prototype.setProgress = function(t, e, n, r) {
        return null != t && (this.progress.val = t), null != e && (this.progress.state = e), null != n && (this.progress.n = n), null != r && (this.progress.stack = r), this.progress.ratio = this.progress.val / this.progress.state, this;
    }, y.prototype.updateProgress = function(t, e, n, r) {
        return this.setProgress(t ? this.progress.val + t : null, e || null, n ? this.progress.n + n : null, r ? this.progress.stack.concat(r) : null);
    }, y.prototype.then = function(t, e) {
        var n = this;
        return this.thenCore(t, e, function(e, t) {
            return n.updateProgress(null, null, 1, [
                e
            ]), Promise.prototype.then.call(this, function(t) {
                return n.updateProgress(null, e), t;
            }).then(e, t).then(function(t) {
                return n.updateProgress(1), t;
            });
        });
    }, y.prototype.thenCore = function(t, e, n) {
        n = n || Promise.prototype.then;
        var r = this;
        t && (t = t.bind(r)), e && (e = e.bind(r));
        var i = -1 !== Promise.toString().indexOf("[native code]") && "Promise" === Promise.name ? r : y.convert(Object.assign({}, r), Promise.prototype), o = n.call(i, t, e);
        return y.convert(o, r.__proto__);
    }, y.prototype.thenExternal = function(t, e) {
        return Promise.prototype.then.call(this, t, e);
    }, y.prototype.thenList = function(t) {
        var e = this;
        return t.forEach(function(t) {
            e = e.thenCore(t);
        }), e;
    }, y.prototype.catch = function(t) {
        t && (t = t.bind(this));
        var e = Promise.prototype.catch.call(this, t);
        return y.convert(e, this);
    }, y.prototype.catchExternal = function(t) {
        return Promise.prototype.catch.call(this, t);
    }, y.prototype.error = function(t) {
        return this.then(function() {
            throw new Error(t);
        });
    }, y.prototype.using = y.prototype.set, y.prototype.saveAs = y.prototype.save, y.prototype.export = y.prototype.output, y.prototype.run = y.prototype.then, lt.getPageSize = function(t, e, n) {
        if ("object" === se(t)) {
            var r = t;
            t = r.orientation, e = r.unit || e, n = r.format || n;
        }
        e = e || "mm", n = n || "a4", t = ("" + (t || "P")).toLowerCase();
        var i = ("" + n).toLowerCase(), o = {
            a0: [
                2383.94,
                3370.39
            ],
            a1: [
                1683.78,
                2383.94
            ],
            a2: [
                1190.55,
                1683.78
            ],
            a3: [
                841.89,
                1190.55
            ],
            a4: [
                595.28,
                841.89
            ],
            a5: [
                419.53,
                595.28
            ],
            a6: [
                297.64,
                419.53
            ],
            a7: [
                209.76,
                297.64
            ],
            a8: [
                147.4,
                209.76
            ],
            a9: [
                104.88,
                147.4
            ],
            a10: [
                73.7,
                104.88
            ],
            b0: [
                2834.65,
                4008.19
            ],
            b1: [
                2004.09,
                2834.65
            ],
            b2: [
                1417.32,
                2004.09
            ],
            b3: [
                1000.63,
                1417.32
            ],
            b4: [
                708.66,
                1000.63
            ],
            b5: [
                498.9,
                708.66
            ],
            b6: [
                354.33,
                498.9
            ],
            b7: [
                249.45,
                354.33
            ],
            b8: [
                175.75,
                249.45
            ],
            b9: [
                124.72,
                175.75
            ],
            b10: [
                87.87,
                124.72
            ],
            c0: [
                2599.37,
                3676.54
            ],
            c1: [
                1836.85,
                2599.37
            ],
            c2: [
                1298.27,
                1836.85
            ],
            c3: [
                918.43,
                1298.27
            ],
            c4: [
                649.13,
                918.43
            ],
            c5: [
                459.21,
                649.13
            ],
            c6: [
                323.15,
                459.21
            ],
            c7: [
                229.61,
                323.15
            ],
            c8: [
                161.57,
                229.61
            ],
            c9: [
                113.39,
                161.57
            ],
            c10: [
                79.37,
                113.39
            ],
            dl: [
                311.81,
                623.62
            ],
            letter: [
                612,
                792
            ],
            "government-letter": [
                576,
                756
            ],
            legal: [
                612,
                1008
            ],
            "junior-legal": [
                576,
                360
            ],
            ledger: [
                1224,
                792
            ],
            tabloid: [
                792,
                1224
            ],
            "credit-card": [
                153,
                243
            ]
        };
        switch(e){
            case "pt":
                var a = 1;
                break;
            case "mm":
                a = 72 / 25.4;
                break;
            case "cm":
                a = 72 / 2.54;
                break;
            case "in":
                a = 72;
                break;
            case "px":
                a = .75;
                break;
            case "pc":
            case "em":
                a = 12;
                break;
            case "ex":
                a = 6;
                break;
            default:
                throw "Invalid unit: " + e;
        }
        if (o.hasOwnProperty(i)) var s = o[i][1] / a, l = o[i][0] / a;
        else try {
            s = n[1], l = n[0];
        } catch (t) {
            throw new Error("Invalid format: " + n);
        }
        if ("p" === t || "portrait" === t) {
            if (t = "p", s < l) {
                var h = l;
                l = s, s = h;
            }
        } else {
            if ("l" !== t && "landscape" !== t) throw "Invalid orientation: " + t;
            t = "l", l < s && (h = l, l = s, s = h);
        }
        return {
            width: l,
            height: s,
            unit: e,
            k: a
        };
    }, i.html = function(t, e) {
        (e = e || {}).callback = e.callback || function() {}, e.html2canvas = e.html2canvas || {}, e.html2canvas.canvas = e.html2canvas.canvas || this.canvas, e.jsPDF = e.jsPDF || this, e.jsPDF;
        var n = new y(e);
        return e.worker ? n : n.from(t).doCallback();
    }, lt.API.addJS = function(t) {
        return b = t, this.internal.events.subscribe("postPutResources", function(t) {
            v = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (v + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), w = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + b + ")"), this.internal.out(">>"), this.internal.out("endobj");
        }), this.internal.events.subscribe("putCatalog", function() {
            void 0 !== v && void 0 !== w && this.internal.out("/Names <</JavaScript " + v + " 0 R>>");
        }), this;
    }, /**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ (x = lt.API).events.push([
        "postPutResources",
        function() {
            var t = this, e = /^(\d+) 0 obj$/;
            if (0 < this.outline.root.children.length) for(var n = t.outline.render().split(/\r\n/), r = 0; r < n.length; r++){
                var i = n[r], o = e.exec(i);
                if (null != o) {
                    var a = o[1];
                    t.internal.newObjectDeferredBegin(a, !1);
                }
                t.internal.write(i);
            }
            if (this.outline.createNamedDestinations) {
                var s = this.internal.pages.length, l = [];
                for(r = 0; r < s; r++){
                    var h = t.internal.newObject();
                    l.push(h);
                    var u = t.internal.getPageInfo(r + 1);
                    t.internal.write("<< /D[" + u.objId + " 0 R /XYZ null null null]>> endobj");
                }
                var c = t.internal.newObject();
                for(t.internal.write("<< /Names [ "), r = 0; r < l.length; r++)t.internal.write("(page_" + (r + 1) + ")" + l[r] + " 0 R");
                t.internal.write(" ] >>", "endobj"), t.internal.newObject(), t.internal.write("<< /Dests " + c + " 0 R"), t.internal.write(">>", "endobj");
            }
        }
    ]), x.events.push([
        "putCatalog",
        function() {
            0 < this.outline.root.children.length && (this.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && this.internal.write("/Names " + namesOid + " 0 R"));
        }
    ]), x.events.push([
        "initialized",
        function() {
            var a = this;
            a.outline = {
                createNamedDestinations: !1,
                root: {
                    children: []
                }
            }, a.outline.add = function(t, e, n) {
                var r = {
                    title: e,
                    options: n,
                    children: []
                };
                return null == t && (t = this.root), t.children.push(r), r;
            }, a.outline.render = function() {
                return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = a, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
            }, a.outline.genIds_r = function(t) {
                t.id = a.internal.newObjectDeferred();
                for(var e = 0; e < t.children.length; e++)this.genIds_r(t.children[e]);
            }, a.outline.renderRoot = function(t) {
                this.objStart(t), this.line("/Type /Outlines"), 0 < t.children.length && (this.line("/First " + this.makeRef(t.children[0])), this.line("/Last " + this.makeRef(t.children[t.children.length - 1]))), this.line("/Count " + this.count_r({
                    count: 0
                }, t)), this.objEnd();
            }, a.outline.renderItems = function(t) {
                this.ctx.pdf.internal.getCoordinateString;
                for(var e = this.ctx.pdf.internal.getVerticalCoordinateString, n = 0; n < t.children.length; n++){
                    var r = t.children[n];
                    this.objStart(r), this.line("/Title " + this.makeString(r.title)), this.line("/Parent " + this.makeRef(t)), 0 < n && this.line("/Prev " + this.makeRef(t.children[n - 1])), n < t.children.length - 1 && this.line("/Next " + this.makeRef(t.children[n + 1])), 0 < r.children.length && (this.line("/First " + this.makeRef(r.children[0])), this.line("/Last " + this.makeRef(r.children[r.children.length - 1])));
                    var i = this.count = this.count_r({
                        count: 0
                    }, r);
                    if (0 < i && this.line("/Count " + i), r.options && r.options.pageNumber) {
                        var o = a.internal.getPageInfo(r.options.pageNumber);
                        this.line("/Dest [" + o.objId + " 0 R /XYZ 0 " + e(0) + " 0]");
                    }
                    this.objEnd();
                }
                for(n = 0; n < t.children.length; n++)r = t.children[n], this.renderItems(r);
            }, a.outline.line = function(t) {
                this.ctx.val += t + "\r\n";
            }, a.outline.makeRef = function(t) {
                return t.id + " 0 R";
            }, a.outline.makeString = function(t) {
                return "(" + a.internal.pdfEscape(t) + ")";
            }, a.outline.objStart = function(t) {
                this.ctx.val += "\r\n" + t.id + " 0 obj\r\n<<\r\n";
            }, a.outline.objEnd = function(t) {
                this.ctx.val += ">> \r\nendobj\r\n";
            }, a.outline.count_r = function(t, e) {
                for(var n = 0; n < e.children.length; n++)t.count++, this.count_r(t, e.children[n]);
                return t.count;
            };
        }
    ]), /**
   * @license
   * 
   * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   * ====================================================================
   */ I = lt.API, C = function() {
        var t = "function" == typeof Deflater;
        if (!t) throw new Error("requires deflate.js for compression");
        return t;
    }, B = function(t, e, n, r) {
        var i = 5, o = E;
        switch(r){
            case I.image_compression.FAST:
                i = 3, o = j;
                break;
            case I.image_compression.MEDIUM:
                i = 6, o = M;
                break;
            case I.image_compression.SLOW:
                i = 9, o = O;
        }
        t = A(t, e, n, o);
        var a = new Uint8Array(N(i)), s = L(t), l = new Deflater(i), h = l.append(t), u = l.flush(), c = a.length + h.length + u.length, f = new Uint8Array(c + 4);
        return f.set(a), f.set(h, a.length), f.set(u, a.length + h.length), f[c++] = s >>> 24 & 255, f[c++] = s >>> 16 & 255, f[c++] = s >>> 8 & 255, f[c++] = 255 & s, I.arrayBufferToBinaryString(f);
    }, N = function(t, e) {
        var n = Math.LOG2E * Math.log(32768) - 8 << 4 | 8, r = n << 8;
        return r |= Math.min(3, (e - 1 & 255) >> 1) << 6, r |= 0, [
            n,
            255 & (r += 31 - r % 31)
        ];
    }, L = function(t, e) {
        for(var n, r = 1, i = 0, o = t.length, a = 0; 0 < o;){
            for(o -= n = e < o ? e : o; i += r += t[a++], --n;);
            r %= 65521, i %= 65521;
        }
        return (i << 16 | r) >>> 0;
    }, A = function(t, e, n, r) {
        for(var i, o, a, s = t.length / e, l = new Uint8Array(t.length + s), h = T(), u = 0; u < s; u++){
            if (a = u * e, i = t.subarray(a, a + e), r) l.set(r(i, n, o), a + u);
            else {
                for(var c = 0, f = h.length, p = []; c < f; c++)p[c] = h[c](i, n, o);
                var d = R(p.concat());
                l.set(p[d], a + u);
            }
            o = i;
        }
        return l;
    }, S = function(t, e, n) {
        var r = Array.apply([], t);
        return r.unshift(0), r;
    }, j = function(t, e, n) {
        var r, i = [], o = 0, a = t.length;
        for(i[0] = 1; o < a; o++)r = t[o - e] || 0, i[o + 1] = t[o] - r + 256 & 255;
        return i;
    }, E = function(t, e, n) {
        var r, i = [], o = 0, a = t.length;
        for(i[0] = 2; o < a; o++)r = n && n[o] || 0, i[o + 1] = t[o] - r + 256 & 255;
        return i;
    }, M = function(t, e, n) {
        var r, i, o = [], a = 0, s = t.length;
        for(o[0] = 3; a < s; a++)r = t[a - e] || 0, i = n && n[a] || 0, o[a + 1] = t[a] + 256 - (r + i >>> 1) & 255;
        return o;
    }, O = function(t, e, n) {
        var r, i, o, a, s = [], l = 0, h = t.length;
        for(s[0] = 4; l < h; l++)r = t[l - e] || 0, i = n && n[l] || 0, o = n && n[l - e] || 0, a = q(r, i, o), s[l + 1] = t[l] - a + 256 & 255;
        return s;
    }, q = function(t, e, n) {
        var r = t + e - n, i = Math.abs(r - t), o = Math.abs(r - e), a = Math.abs(r - n);
        return i <= o && i <= a ? t : o <= a ? e : n;
    }, T = function() {
        return [
            S,
            j,
            E,
            M,
            O
        ];
    }, R = function(t) {
        for(var e, n, r, i = 0, o = t.length; i < o;)((e = D(t[i].slice(1))) < n || !n) && (n = e, r = i), i++;
        return r;
    }, D = function(t) {
        for(var e = 0, n = t.length, r = 0; e < n;)r += Math.abs(t[e++]);
        return r;
    }, I.processPNG = function(t, e, n, r, i) {
        var o, a, s, l, h, u, c = this.color_spaces.DEVICE_RGB, f = this.decode.FLATE_DECODE, p = 8;
        if (this.isArrayBuffer(t) && (t = new Uint8Array(t)), this.isArrayBufferView(t)) {
            if ("function" != typeof PNG || "function" != typeof kt) throw new Error("PNG support requires png.js and zlib.js");
            if (t = (o = new PNG(t)).imgData, p = o.bits, c = o.colorSpace, l = o.colors, -1 !== [
                4,
                6
            ].indexOf(o.colorType)) {
                if (8 === o.bits) for(var d, g = (_ = 32 == o.pixelBitlength ? new Uint32Array(o.decodePixels().buffer) : 16 == o.pixelBitlength ? new Uint16Array(o.decodePixels().buffer) : new Uint8Array(o.decodePixels().buffer)).length, m = new Uint8Array(g * o.colors), y = new Uint8Array(g), v = o.pixelBitlength - o.bits, w = 0, b = 0; w < g; w++){
                    for(x = _[w], d = 0; d < v;)m[b++] = x >>> d & 255, d += o.bits;
                    y[w] = x >>> d & 255;
                }
                if (16 === o.bits) {
                    g = (_ = new Uint32Array(o.decodePixels().buffer)).length, m = new Uint8Array(g * (32 / o.pixelBitlength) * o.colors), y = new Uint8Array(g * (32 / o.pixelBitlength));
                    for(var x, N = 1 < o.colors, L = b = w = 0; w < g;)x = _[w++], m[b++] = x >>> 0 & 255, N && (m[b++] = x >>> 16 & 255, x = _[w++], m[b++] = x >>> 0 & 255), y[L++] = x >>> 16 & 255;
                    p = 8;
                }
                r !== I.image_compression.NONE && C() ? (t = B(m, o.width * o.colors, o.colors, r), u = B(y, o.width, 1, r)) : (t = m, u = y, f = null);
            }
            if (3 === o.colorType && (c = this.color_spaces.INDEXED, h = o.palette, o.transparency.indexed)) {
                var A = o.transparency.indexed, S = 0;
                for(w = 0, g = A.length; w < g; ++w)S += A[w];
                if ((S /= 255) == g - 1 && -1 !== A.indexOf(0)) s = [
                    A.indexOf(0)
                ];
                else if (S !== g) {
                    var _ = o.decodePixels();
                    for(y = new Uint8Array(_.length), w = 0, g = _.length; w < g; w++)y[w] = A[_[w]];
                    u = B(y, o.width, 1);
                }
            }
            var F = function(t) {
                var e;
                switch(t){
                    case I.image_compression.FAST:
                        e = 11;
                        break;
                    case I.image_compression.MEDIUM:
                        e = 13;
                        break;
                    case I.image_compression.SLOW:
                        e = 14;
                        break;
                    default:
                        e = 12;
                }
                return e;
            }(r);
            return a = f === this.decode.FLATE_DECODE ? "/Predictor " + F + " /Colors " + l + " /BitsPerComponent " + p + " /Columns " + o.width : "/Colors " + l + " /BitsPerComponent " + p + " /Columns " + o.width, (this.isArrayBuffer(t) || this.isArrayBufferView(t)) && (t = this.arrayBufferToBinaryString(t)), (u && this.isArrayBuffer(u) || this.isArrayBufferView(u)) && (u = this.arrayBufferToBinaryString(u)), this.createImageInfo(t, o.width, o.height, c, p, f, e, n, a, s, h, u, F);
        }
        throw new Error("Unsupported PNG image data, try using JPEG instead.");
    }, /**
   * @license
   * Copyright (c) 2017 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ (U = lt.API).processGIF89A = function(t, e, n, r, i) {
        var o = new At(t), a = o.width, s = o.height, l = [];
        o.decodeAndBlitFrameRGBA(0, l);
        var h = {
            data: l,
            width: a,
            height: s
        }, u = new _t(100).encode(h, 100);
        return U.processJPEG.call(this, u, e, n, r);
    }, U.processGIF87A = U.processGIF89A, /**
   * Copyright (c) 2018 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ (z = lt.API).processBMP = function(t, e, n, r, i) {
        var o = new Ft(t, !1), a = o.width, s = o.height, l = {
            data: o.getData(),
            width: a,
            height: s
        }, h = new _t(100).encode(l, 100);
        return z.processJPEG.call(this, h, e, n, r);
    }, lt.API.setLanguage = function(t) {
        return void 0 === this.internal.languageSettings && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), void 0 !== ({
            af: "Afrikaans",
            sq: "Albanian",
            ar: "Arabic (Standard)",
            "ar-DZ": "Arabic (Algeria)",
            "ar-BH": "Arabic (Bahrain)",
            "ar-EG": "Arabic (Egypt)",
            "ar-IQ": "Arabic (Iraq)",
            "ar-JO": "Arabic (Jordan)",
            "ar-KW": "Arabic (Kuwait)",
            "ar-LB": "Arabic (Lebanon)",
            "ar-LY": "Arabic (Libya)",
            "ar-MA": "Arabic (Morocco)",
            "ar-OM": "Arabic (Oman)",
            "ar-QA": "Arabic (Qatar)",
            "ar-SA": "Arabic (Saudi Arabia)",
            "ar-SY": "Arabic (Syria)",
            "ar-TN": "Arabic (Tunisia)",
            "ar-AE": "Arabic (U.A.E.)",
            "ar-YE": "Arabic (Yemen)",
            an: "Aragonese",
            hy: "Armenian",
            as: "Assamese",
            ast: "Asturian",
            az: "Azerbaijani",
            eu: "Basque",
            be: "Belarusian",
            bn: "Bengali",
            bs: "Bosnian",
            br: "Breton",
            bg: "Bulgarian",
            my: "Burmese",
            ca: "Catalan",
            ch: "Chamorro",
            ce: "Chechen",
            zh: "Chinese",
            "zh-HK": "Chinese (Hong Kong)",
            "zh-CN": "Chinese (PRC)",
            "zh-SG": "Chinese (Singapore)",
            "zh-TW": "Chinese (Taiwan)",
            cv: "Chuvash",
            co: "Corsican",
            cr: "Cree",
            hr: "Croatian",
            cs: "Czech",
            da: "Danish",
            nl: "Dutch (Standard)",
            "nl-BE": "Dutch (Belgian)",
            en: "English",
            "en-AU": "English (Australia)",
            "en-BZ": "English (Belize)",
            "en-CA": "English (Canada)",
            "en-IE": "English (Ireland)",
            "en-JM": "English (Jamaica)",
            "en-NZ": "English (New Zealand)",
            "en-PH": "English (Philippines)",
            "en-ZA": "English (South Africa)",
            "en-TT": "English (Trinidad & Tobago)",
            "en-GB": "English (United Kingdom)",
            "en-US": "English (United States)",
            "en-ZW": "English (Zimbabwe)",
            eo: "Esperanto",
            et: "Estonian",
            fo: "Faeroese",
            fj: "Fijian",
            fi: "Finnish",
            fr: "French (Standard)",
            "fr-BE": "French (Belgium)",
            "fr-CA": "French (Canada)",
            "fr-FR": "French (France)",
            "fr-LU": "French (Luxembourg)",
            "fr-MC": "French (Monaco)",
            "fr-CH": "French (Switzerland)",
            fy: "Frisian",
            fur: "Friulian",
            gd: "Gaelic (Scots)",
            "gd-IE": "Gaelic (Irish)",
            gl: "Galacian",
            ka: "Georgian",
            de: "German (Standard)",
            "de-AT": "German (Austria)",
            "de-DE": "German (Germany)",
            "de-LI": "German (Liechtenstein)",
            "de-LU": "German (Luxembourg)",
            "de-CH": "German (Switzerland)",
            el: "Greek",
            gu: "Gujurati",
            ht: "Haitian",
            he: "Hebrew",
            hi: "Hindi",
            hu: "Hungarian",
            is: "Icelandic",
            id: "Indonesian",
            iu: "Inuktitut",
            ga: "Irish",
            it: "Italian (Standard)",
            "it-CH": "Italian (Switzerland)",
            ja: "Japanese",
            kn: "Kannada",
            ks: "Kashmiri",
            kk: "Kazakh",
            km: "Khmer",
            ky: "Kirghiz",
            tlh: "Klingon",
            ko: "Korean",
            "ko-KP": "Korean (North Korea)",
            "ko-KR": "Korean (South Korea)",
            la: "Latin",
            lv: "Latvian",
            lt: "Lithuanian",
            lb: "Luxembourgish",
            mk: "FYRO Macedonian",
            ms: "Malay",
            ml: "Malayalam",
            mt: "Maltese",
            mi: "Maori",
            mr: "Marathi",
            mo: "Moldavian",
            nv: "Navajo",
            ng: "Ndonga",
            ne: "Nepali",
            no: "Norwegian",
            nb: "Norwegian (Bokmal)",
            nn: "Norwegian (Nynorsk)",
            oc: "Occitan",
            or: "Oriya",
            om: "Oromo",
            fa: "Persian",
            "fa-IR": "Persian/Iran",
            pl: "Polish",
            pt: "Portuguese",
            "pt-BR": "Portuguese (Brazil)",
            pa: "Punjabi",
            "pa-IN": "Punjabi (India)",
            "pa-PK": "Punjabi (Pakistan)",
            qu: "Quechua",
            rm: "Rhaeto-Romanic",
            ro: "Romanian",
            "ro-MO": "Romanian (Moldavia)",
            ru: "Russian",
            "ru-MO": "Russian (Moldavia)",
            sz: "Sami (Lappish)",
            sg: "Sango",
            sa: "Sanskrit",
            sc: "Sardinian",
            sd: "Sindhi",
            si: "Singhalese",
            sr: "Serbian",
            sk: "Slovak",
            sl: "Slovenian",
            so: "Somani",
            sb: "Sorbian",
            es: "Spanish",
            "es-AR": "Spanish (Argentina)",
            "es-BO": "Spanish (Bolivia)",
            "es-CL": "Spanish (Chile)",
            "es-CO": "Spanish (Colombia)",
            "es-CR": "Spanish (Costa Rica)",
            "es-DO": "Spanish (Dominican Republic)",
            "es-EC": "Spanish (Ecuador)",
            "es-SV": "Spanish (El Salvador)",
            "es-GT": "Spanish (Guatemala)",
            "es-HN": "Spanish (Honduras)",
            "es-MX": "Spanish (Mexico)",
            "es-NI": "Spanish (Nicaragua)",
            "es-PA": "Spanish (Panama)",
            "es-PY": "Spanish (Paraguay)",
            "es-PE": "Spanish (Peru)",
            "es-PR": "Spanish (Puerto Rico)",
            "es-ES": "Spanish (Spain)",
            "es-UY": "Spanish (Uruguay)",
            "es-VE": "Spanish (Venezuela)",
            sx: "Sutu",
            sw: "Swahili",
            sv: "Swedish",
            "sv-FI": "Swedish (Finland)",
            "sv-SV": "Swedish (Sweden)",
            ta: "Tamil",
            tt: "Tatar",
            te: "Teluga",
            th: "Thai",
            tig: "Tigre",
            ts: "Tsonga",
            tn: "Tswana",
            tr: "Turkish",
            tk: "Turkmen",
            uk: "Ukrainian",
            hsb: "Upper Sorbian",
            ur: "Urdu",
            ve: "Venda",
            vi: "Vietnamese",
            vo: "Volapuk",
            wa: "Walloon",
            cy: "Welsh",
            xh: "Xhosa",
            ji: "Yiddish",
            zu: "Zulu"
        })[t] && (this.internal.languageSettings.languageCode = t, !1 === this.internal.languageSettings.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
            this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
        }), this.internal.languageSettings.isSubscribed = !0)), this;
    }, /** @license
   * MIT license.
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */ H = lt.API, W = H.getCharWidthsArray = function(t, e) {
        var n, r, i, o = (e = e || {}).font || this.internal.getFont(), a = e.fontSize || this.internal.getFontSize(), s = e.charSpace || this.internal.getCharSpace(), l = e.widths ? e.widths : o.metadata.Unicode.widths, h = l.fof ? l.fof : 1, u = e.kerning ? e.kerning : o.metadata.Unicode.kerning, c = u.fof ? u.fof : 1, f = 0, p = l[0] || h, d = [];
        for(n = 0, r = t.length; n < r; n++)i = t.charCodeAt(n), "function" == typeof o.metadata.widthOfString ? d.push((o.metadata.widthOfGlyph(o.metadata.characterToGlyph(i)) + s * (1e3 / a) || 0) / 1e3) : d.push((l[i] || p) / h + (u[i] && u[i][f] || 0) / c), f = i;
        return d;
    }, V = H.getArraySum = function(t) {
        for(var e = t.length, n = 0; e;)n += t[--e];
        return n;
    }, G = H.getStringUnitWidth = function(t, e) {
        var n = (e = e || {}).fontSize || this.internal.getFontSize(), r = e.font || this.internal.getFont(), i = e.charSpace || this.internal.getCharSpace();
        return "function" == typeof r.metadata.widthOfString ? r.metadata.widthOfString(t, n, i) / n : V(W.apply(this, arguments));
    }, Y = function(t, e, n, r) {
        for(var i = [], o = 0, a = t.length, s = 0; o !== a && s + e[o] < n;)s += e[o], o++;
        i.push(t.slice(0, o));
        var l = o;
        for(s = 0; o !== a;)s + e[o] > r && (i.push(t.slice(l, o)), s = 0, l = o), s += e[o], o++;
        return l !== o && i.push(t.slice(l, o)), i;
    }, J = function(t, e, n) {
        n || (n = {});
        var r, i, o, a, s, l, h = [], u = [
            h
        ], c = n.textIndent || 0, f = 0, p = 0, d = t.split(" "), g = W.apply(this, [
            " ",
            n
        ])[0];
        if (l = -1 === n.lineIndent ? d[0].length + 2 : n.lineIndent || 0) {
            var m = Array(l).join(" "), y = [];
            d.map(function(t) {
                1 < (t = t.split(/\s*\n/)).length ? y = y.concat(t.map(function(t, e) {
                    return (e && t.length ? "\n" : "") + t;
                })) : y.push(t[0]);
            }), d = y, l = G.apply(this, [
                m,
                n
            ]);
        }
        for(o = 0, a = d.length; o < a; o++){
            var v = 0;
            if (r = d[o], l && "\n" == r[0] && (r = r.substr(1), v = 1), i = W.apply(this, [
                r,
                n
            ]), e < c + f + (p = V(i)) || v) {
                if (e < p) {
                    for(s = Y.apply(this, [
                        r,
                        i,
                        e - (c + f),
                        e
                    ]), h.push(s.shift()), h = [
                        s.pop()
                    ]; s.length;)u.push([
                        s.shift()
                    ]);
                    p = V(i.slice(r.length - (h[0] ? h[0].length : 0)));
                } else h = [
                    r
                ];
                u.push(h), c = p + l, f = g;
            } else h.push(r), c += f + p, f = g;
        }
        if (l) var w = function(t, e) {
            return (e ? m : "") + t.join(" ");
        };
        else w = function(t) {
            return t.join(" ");
        };
        return u.map(w);
    }, H.splitTextToSize = function(t, e, n) {
        var r, i = (n = n || {}).fontSize || this.internal.getFontSize(), o = (function(t) {
            var e = {
                0: 1
            }, n = {};
            if (t.widths && t.kerning) return {
                widths: t.widths,
                kerning: t.kerning
            };
            var r = this.internal.getFont(t.fontName, t.fontStyle), i = "Unicode";
            return r.metadata[i] ? {
                widths: r.metadata[i].widths || e,
                kerning: r.metadata[i].kerning || n
            } : {
                font: r.metadata,
                fontSize: this.internal.getFontSize(),
                charSpace: this.internal.getCharSpace()
            };
        }).call(this, n);
        r = Array.isArray(t) ? t : t.split(/\r?\n/);
        var a = 1 * this.internal.scaleFactor * e / i;
        o.textIndent = n.textIndent ? 1 * n.textIndent * this.internal.scaleFactor / i : 0, o.lineIndent = n.lineIndent;
        var s, l, h = [];
        for(s = 0, l = r.length; s < l; s++)h = h.concat(J.apply(this, [
            r[s],
            a,
            o
        ]));
        return h;
    }, /** @license
   jsPDF standard_fonts_metrics plugin
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   * MIT license.
   * 
   * ====================================================================
   */ X = lt.API, Z = {
        codePages: [
            "WinAnsiEncoding"
        ],
        WinAnsiEncoding: (K = function(t) {
            for(var e = "klmnopqrstuvwxyz", n = {}, r = 0; r < e.length; r++)n[e[r]] = "0123456789abcdef"[r];
            var i, o, a, s, l, h = {}, u = 1, c = h, f = [], p = "", d = "", g = t.length - 1;
            for(r = 1; r != g;)l = t[r], r += 1, "'" == l ? o = o ? (s = o.join(""), i) : [] : o ? o.push(l) : "{" == l ? (f.push([
                c,
                s
            ]), c = {}, s = i) : "}" == l ? ((a = f.pop())[0][a[1]] = c, s = i, c = a[0]) : "-" == l ? u = -1 : s === i ? n.hasOwnProperty(l) ? (p += n[l], s = parseInt(p, 16) * u, u = 1, p = "") : p += l : n.hasOwnProperty(l) ? (d += n[l], c[s] = parseInt(d, 16) * u, u = 1, s = i, d = "") : d += l;
            return h;
        })("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")
    }, Q = {
        Unicode: {
            Courier: Z,
            "Courier-Bold": Z,
            "Courier-BoldOblique": Z,
            "Courier-Oblique": Z,
            Helvetica: Z,
            "Helvetica-Bold": Z,
            "Helvetica-BoldOblique": Z,
            "Helvetica-Oblique": Z,
            "Times-Roman": Z,
            "Times-Bold": Z,
            "Times-BoldItalic": Z,
            "Times-Italic": Z
        }
    }, $ = {
        Unicode: {
            "Courier-Oblique": K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-BoldItalic": K("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),
            "Helvetica-Bold": K("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            Courier: K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-BoldOblique": K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Bold": K("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),
            Symbol: K("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),
            Helvetica: K("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),
            "Helvetica-BoldOblique": K("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            ZapfDingbats: K("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-Bold": K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Italic": K("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),
            "Times-Roman": K("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),
            "Helvetica-Oblique": K("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
        }
    }, X.events.push([
        "addFont",
        function(t) {
            var e, n, r, i = t.font, o = "Unicode";
            (e = $[o][i.postScriptName]) && ((n = i.metadata[o] ? i.metadata[o] : i.metadata[o] = {}).widths = e.widths, n.kerning = e.kerning), (r = Q[o][i.postScriptName]) && ((n = i.metadata[o] ? i.metadata[o] : i.metadata[o] = {}).encoding = r).codePages && r.codePages.length && (i.encoding = r.codePages[0]);
        }
    ]), /**
   * @license
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ tt = lt, "undefined" != typeof self && self || "undefined" != typeof $parcel$global && $parcel$global || "undefined" != typeof window && window || Function("return this")(), tt.API.events.push([
        "addFont",
        function(t) {
            var e = t.font, n = t.instance;
            if (void 0 !== n && n.existsFileInVFS(e.postScriptName)) {
                var r = n.getFileFromVFS(e.postScriptName);
                if ("string" != typeof r) throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + e.postScriptName + "').");
                e.metadata = tt.API.TTFFont.open(e.postScriptName, e.fontName, r, e.encoding), e.metadata.Unicode = e.metadata.Unicode || {
                    encoding: {},
                    kerning: {},
                    widths: []
                }, e.metadata.glyIdsUsed = [
                    0
                ];
            } else if (!1 === e.isStandardFont) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + e.postScriptName + "').");
        }
    ]), /** @license
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   * 
   * 
   * ====================================================================
   */ (et = lt.API).addSvg = function(t, e, n, r, i) {
        if (void 0 === e || void 0 === n) throw new Error("addSVG needs values for 'x' and 'y'");
        function o(t) {
            for(var e = parseFloat(t[1]), n = parseFloat(t[2]), r = [], i = 3, o = t.length; i < o;)"c" === t[i] ? (r.push([
                parseFloat(t[i + 1]),
                parseFloat(t[i + 2]),
                parseFloat(t[i + 3]),
                parseFloat(t[i + 4]),
                parseFloat(t[i + 5]),
                parseFloat(t[i + 6])
            ]), i += 7) : "l" === t[i] ? (r.push([
                parseFloat(t[i + 1]),
                parseFloat(t[i + 2])
            ]), i += 3) : i += 1;
            return [
                e,
                n,
                r
            ];
        }
        var a, s, l, h, u, c, f, p, d = (h = document, p = h.createElement("iframe"), u = ".jsPDF_sillysvg_iframe {display:none;position:absolute;}", (f = (c = h).createElement("style")).type = "text/css", f.styleSheet ? f.styleSheet.cssText = u : f.appendChild(c.createTextNode(u)), c.getElementsByTagName("head")[0].appendChild(f), p.name = "childframe", p.setAttribute("width", 0), p.setAttribute("height", 0), p.setAttribute("frameborder", "0"), p.setAttribute("scrolling", "no"), p.setAttribute("seamless", "seamless"), p.setAttribute("class", "jsPDF_sillysvg_iframe"), h.body.appendChild(p), p), g = (a = t, (l = ((s = d).contentWindow || s.contentDocument).document).write(a), l.close(), l.getElementsByTagName("svg")[0]), m = [
            1,
            1
        ], y = parseFloat(g.getAttribute("width")), v = parseFloat(g.getAttribute("height"));
        y && v && (r && i ? m = [
            r / y,
            i / v
        ] : r ? m = [
            r / y,
            r / y
        ] : i && (m = [
            i / v,
            i / v
        ]));
        var w, b, x, N, L = g.childNodes;
        for(w = 0, b = L.length; w < b; w++)(x = L[w]).tagName && "PATH" === x.tagName.toUpperCase() && ((N = o(x.getAttribute("d").split(" ")))[0] = N[0] * m[0] + e, N[1] = N[1] * m[1] + n, this.lines.call(this, N[2], N[0], N[1], m));
        return this;
    }, et.addSVG = et.addSvg, et.addSvgAsImage = function(t, e, n, r, i, o, a, s) {
        if (isNaN(e) || isNaN(n)) throw console.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
        if (isNaN(r) || isNaN(i)) throw console.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
        var l = document.createElement("canvas");
        l.width = r, l.height = i;
        var h = l.getContext("2d");
        return h.fillStyle = "#fff", h.fillRect(0, 0, l.width, l.height), canvg(l, t, {
            ignoreMouse: !0,
            ignoreAnimation: !0,
            ignoreDimensions: !0,
            ignoreClear: !0
        }), this.addImage(l.toDataURL("image/jpeg", 1), e, n, r, i, a, s), this;
    }, lt.API.putTotalPages = function(t) {
        var e, n = 0;
        n = parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (e = new RegExp(t, "g"), this.internal.getNumberOfPages()) : (e = new RegExp(this.pdfEscape16(t, this.internal.getFont()), "g"), this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
        for(var r = 1; r <= this.internal.getNumberOfPages(); r++)for(var i = 0; i < this.internal.pages[r].length; i++)this.internal.pages[r][i] = this.internal.pages[r][i].replace(e, n);
        return this;
    }, lt.API.viewerPreferences = function(t, e) {
        var n;
        t = t || {}, e = e || !1;
        var r, i, o = {
            HideToolbar: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            HideMenubar: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            HideWindowUI: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            FitWindow: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            CenterWindow: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            DisplayDocTitle: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.4
            },
            NonFullScreenPageMode: {
                defaultValue: "UseNone",
                value: "UseNone",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "UseNone",
                    "UseOutlines",
                    "UseThumbs",
                    "UseOC"
                ],
                pdfVersion: 1.3
            },
            Direction: {
                defaultValue: "L2R",
                value: "L2R",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "L2R",
                    "R2L"
                ],
                pdfVersion: 1.3
            },
            ViewArea: {
                defaultValue: "CropBox",
                value: "CropBox",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "MediaBox",
                    "CropBox",
                    "TrimBox",
                    "BleedBox",
                    "ArtBox"
                ],
                pdfVersion: 1.4
            },
            ViewClip: {
                defaultValue: "CropBox",
                value: "CropBox",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "MediaBox",
                    "CropBox",
                    "TrimBox",
                    "BleedBox",
                    "ArtBox"
                ],
                pdfVersion: 1.4
            },
            PrintArea: {
                defaultValue: "CropBox",
                value: "CropBox",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "MediaBox",
                    "CropBox",
                    "TrimBox",
                    "BleedBox",
                    "ArtBox"
                ],
                pdfVersion: 1.4
            },
            PrintClip: {
                defaultValue: "CropBox",
                value: "CropBox",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "MediaBox",
                    "CropBox",
                    "TrimBox",
                    "BleedBox",
                    "ArtBox"
                ],
                pdfVersion: 1.4
            },
            PrintScaling: {
                defaultValue: "AppDefault",
                value: "AppDefault",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "AppDefault",
                    "None"
                ],
                pdfVersion: 1.6
            },
            Duplex: {
                defaultValue: "",
                value: "none",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "Simplex",
                    "DuplexFlipShortEdge",
                    "DuplexFlipLongEdge",
                    "none"
                ],
                pdfVersion: 1.7
            },
            PickTrayByPDFSize: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.7
            },
            PrintPageRange: {
                defaultValue: "",
                value: "",
                type: "array",
                explicitSet: !1,
                valueSet: null,
                pdfVersion: 1.7
            },
            NumCopies: {
                defaultValue: 1,
                value: 1,
                type: "integer",
                explicitSet: !1,
                valueSet: null,
                pdfVersion: 1.7
            }
        }, a = Object.keys(o), s = [], l = 0, h = 0, u = 0, c = !0;
        function f(t, e) {
            var n, r = !1;
            for(n = 0; n < t.length; n += 1)t[n] === e && (r = !0);
            return r;
        }
        if (void 0 === this.internal.viewerpreferences && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(o)), this.internal.viewerpreferences.isSubscribed = !1), n = this.internal.viewerpreferences.configuration, "reset" === t || !0 === e) {
            var p = a.length;
            for(u = 0; u < p; u += 1)n[a[u]].value = n[a[u]].defaultValue, n[a[u]].explicitSet = !1;
        }
        if ("object" === se(t)) {
            for(r in t)if (i = t[r], f(a, r) && void 0 !== i) {
                if ("boolean" === n[r].type && "boolean" == typeof i) n[r].value = i;
                else if ("name" === n[r].type && f(n[r].valueSet, i)) n[r].value = i;
                else if ("integer" === n[r].type && Number.isInteger(i)) n[r].value = i;
                else if ("array" === n[r].type) {
                    for(l = 0; l < i.length; l += 1)if (c = !0, 1 === i[l].length && "number" == typeof i[l][0]) s.push(String(i[l] - 1));
                    else if (1 < i[l].length) {
                        for(h = 0; h < i[l].length; h += 1)"number" != typeof i[l][h] && (c = !1);
                        !0 === c && s.push([
                            i[l][0] - 1,
                            i[l][1] - 1
                        ].join(" "));
                    }
                    n[r].value = "[" + s.join(" ") + "]";
                } else n[r].value = n[r].defaultValue;
                n[r].explicitSet = !0;
            }
        }
        return !1 === this.internal.viewerpreferences.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
            var t, e = [];
            for(t in n)!0 === n[t].explicitSet && ("name" === n[t].type ? e.push("/" + t + " /" + n[t].value) : e.push("/" + t + " " + n[t].value));
            0 !== e.length && this.internal.write("/ViewerPreferences\n<<\n" + e.join("\n") + "\n>>");
        }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = n, this;
    }, /** ==================================================================== 
   * jsPDF XMP metadata plugin
   * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
   * 
   * 
   * ====================================================================
   */ nt = lt.API, ot = it = rt = "", nt.addMetadata = function(t, e) {
        return it = e || "http://jspdf.default.namespaceuri/", rt = t, this.internal.events.subscribe("postPutResources", function() {
            if (rt) {
                var t = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + it + '"><jspdf:metadata>', e = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), n = unescape(encodeURIComponent(t)), r = unescape(encodeURIComponent(rt)), i = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), o = unescape(encodeURIComponent("</x:xmpmeta>")), a = n.length + r.length + i.length + e.length + o.length;
                ot = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + a + " >>"), this.internal.write("stream"), this.internal.write(e + n + r + i + o), this.internal.write("endstream"), this.internal.write("endobj");
            } else ot = "";
        }), this.internal.events.subscribe("putCatalog", function() {
            ot && this.internal.write("/Metadata " + ot + " 0 R");
        }), this;
    }, function(f, t) {
        var e = f.API;
        var m = e.pdfEscape16 = function(t, e) {
            for(var n, r = e.metadata.Unicode.widths, i = [
                "",
                "0",
                "00",
                "000",
                "0000"
            ], o = [
                ""
            ], a = 0, s = t.length; a < s; ++a){
                if (n = e.metadata.characterToGlyph(t.charCodeAt(a)), e.metadata.glyIdsUsed.push(n), e.metadata.toUnicode[n] = t.charCodeAt(a), -1 == r.indexOf(n) && (r.push(n), r.push([
                    parseInt(e.metadata.widthOfGlyph(n), 10)
                ])), "0" == n) return o.join("");
                n = n.toString(16), o.push(i[4 - n.length], n);
            }
            return o.join("");
        }, p = function(t) {
            var e, n, r, i, o, a, s;
            for(o = "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange", r = [], a = 0, s = (n = Object.keys(t).sort(function(t, e) {
                return t - e;
            })).length; a < s; a++)e = n[a], 100 <= r.length && (o += "\n" + r.length + " beginbfchar\n" + r.join("\n") + "\nendbfchar", r = []), i = ("0000" + t[e].toString(16)).slice(-4), e = ("0000" + (+e).toString(16)).slice(-4), r.push("<" + e + "><" + i + ">");
            return r.length && (o += "\n" + r.length + " beginbfchar\n" + r.join("\n") + "\nendbfchar\n"), o += "endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
        };
        e.events.push([
            "putFont",
            function(t) {
                !function(t, e, n, r) {
                    if (t.metadata instanceof f.API.TTFFont && "Identity-H" === t.encoding) {
                        for(var i = t.metadata.Unicode.widths, o = t.metadata.subset.encode(t.metadata.glyIdsUsed, 1), a = "", s = 0; s < o.length; s++)a += String.fromCharCode(o[s]);
                        var l = n();
                        r({
                            data: a,
                            addLength1: !0
                        }), e("endobj");
                        var h = n();
                        r({
                            data: p(t.metadata.toUnicode),
                            addLength1: !0
                        }), e("endobj");
                        var u = n();
                        e("<<"), e("/Type /FontDescriptor"), e("/FontName /" + t.fontName), e("/FontFile2 " + l + " 0 R"), e("/FontBBox " + f.API.PDFObject.convert(t.metadata.bbox)), e("/Flags " + t.metadata.flags), e("/StemV " + t.metadata.stemV), e("/ItalicAngle " + t.metadata.italicAngle), e("/Ascent " + t.metadata.ascender), e("/Descent " + t.metadata.decender), e("/CapHeight " + t.metadata.capHeight), e(">>"), e("endobj");
                        var c = n();
                        e("<<"), e("/Type /Font"), e("/BaseFont /" + t.fontName), e("/FontDescriptor " + u + " 0 R"), e("/W " + f.API.PDFObject.convert(i)), e("/CIDToGIDMap /Identity"), e("/DW 1000"), e("/Subtype /CIDFontType2"), e("/CIDSystemInfo"), e("<<"), e("/Supplement 0"), e("/Registry (Adobe)"), e("/Ordering (" + t.encoding + ")"), e(">>"), e(">>"), e("endobj"), t.objectNumber = n(), e("<<"), e("/Type /Font"), e("/Subtype /Type0"), e("/ToUnicode " + h + " 0 R"), e("/BaseFont /" + t.fontName), e("/Encoding /" + t.encoding), e("/DescendantFonts [" + c + " 0 R]"), e(">>"), e("endobj"), t.isAlreadyPutted = !0;
                    }
                }(t.font, t.out, t.newObject, t.putStream);
            }
        ]);
        e.events.push([
            "putFont",
            function(t) {
                !function(t, e, n, r) {
                    if (t.metadata instanceof f.API.TTFFont && "WinAnsiEncoding" === t.encoding) {
                        t.metadata.Unicode.widths;
                        for(var i = t.metadata.rawData, o = "", a = 0; a < i.length; a++)o += String.fromCharCode(i[a]);
                        var s = n();
                        r({
                            data: o,
                            addLength1: !0
                        }), e("endobj");
                        var l = n();
                        r({
                            data: p(t.metadata.toUnicode),
                            addLength1: !0
                        }), e("endobj");
                        var h = n();
                        for(e("<<"), e("/Descent " + t.metadata.decender), e("/CapHeight " + t.metadata.capHeight), e("/StemV " + t.metadata.stemV), e("/Type /FontDescriptor"), e("/FontFile2 " + s + " 0 R"), e("/Flags 96"), e("/FontBBox " + f.API.PDFObject.convert(t.metadata.bbox)), e("/FontName /" + t.fontName), e("/ItalicAngle " + t.metadata.italicAngle), e("/Ascent " + t.metadata.ascender), e(">>"), e("endobj"), t.objectNumber = n(), a = 0; a < t.metadata.hmtx.widths.length; a++)t.metadata.hmtx.widths[a] = parseInt(t.metadata.hmtx.widths[a] * (1e3 / t.metadata.head.unitsPerEm));
                        e("<</Subtype/TrueType/Type/Font/ToUnicode " + l + " 0 R/BaseFont/" + t.fontName + "/FontDescriptor " + h + " 0 R/Encoding/" + t.encoding + " /FirstChar 29 /LastChar 255 /Widths " + f.API.PDFObject.convert(t.metadata.hmtx.widths) + ">>"), e("endobj"), t.isAlreadyPutted = !0;
                    }
                }(t.font, t.out, t.newObject, t.putStream);
            }
        ]);
        var h = function(t) {
            var e, n, r = t.text || "", i = t.x, o = t.y, a = t.options || {}, s = t.mutex || {}, l = s.pdfEscape, h = s.activeFontKey, u = s.fonts, c = (s.activeFontSize, ""), f = 0, p = "", d = u[n = h].encoding;
            if ("Identity-H" !== u[n].encoding) return {
                text: r,
                x: i,
                y: o,
                options: a,
                mutex: s
            };
            for(p = r, n = h, "[object Array]" === Object.prototype.toString.call(r) && (p = r[0]), f = 0; f < p.length; f += 1)u[n].metadata.hasOwnProperty("cmap") && (e = u[n].metadata.cmap.unicode.codeMap[p[f].charCodeAt(0)]), e ? c += p[f] : p[f].charCodeAt(0) < 256 && u[n].metadata.hasOwnProperty("Unicode") ? c += p[f] : c += "";
            var g = "";
            return parseInt(n.slice(1)) < 14 || "WinAnsiEncoding" === d ? g = function(t) {
                for(var e = "", n = 0; n < t.length; n++)e += "" + t.charCodeAt(n).toString(16);
                return e;
            }(l(c, n)) : "Identity-H" === d && (g = m(c, u[n])), s.isHex = !0, {
                text: g,
                x: i,
                y: o,
                options: a,
                mutex: s
            };
        };
        e.events.push([
            "postProcessText",
            function(t) {
                var e = t.text || "", n = t.x, r = t.y, i = t.options, o = t.mutex, a = (i.lang, []), s = {
                    text: e,
                    x: n,
                    y: r,
                    options: i,
                    mutex: o
                };
                if ("[object Array]" === Object.prototype.toString.call(e)) {
                    var l = 0;
                    for(l = 0; l < e.length; l += 1)"[object Array]" === Object.prototype.toString.call(e[l]) && 3 === e[l].length ? a.push([
                        h(Object.assign({}, s, {
                            text: e[l][0]
                        })).text,
                        e[l][1],
                        e[l][2]
                    ]) : a.push(h(Object.assign({}, s, {
                        text: e[l]
                    })).text);
                    t.text = a;
                } else t.text = h(Object.assign({}, s, {
                    text: e
                })).text;
            }
        ]);
    }(lt, "undefined" != typeof self && self || "undefined" != typeof $parcel$global && $parcel$global || "undefined" != typeof window && window || Function("return this")()), at = lt.API, st = function(t) {
        return void 0 !== t && (void 0 === t.vFS && (t.vFS = {}), !0);
    }, at.existsFileInVFS = function(t) {
        return !!st(this.internal) && void 0 !== this.internal.vFS[t];
    }, at.addFileToVFS = function(t, e) {
        return st(this.internal), this.internal.vFS[t] = e, this;
    }, at.getFileFromVFS = function(t) {
        return st(this.internal), void 0 !== this.internal.vFS[t] ? this.internal.vFS[t] : null;
    }, lt.API.addHTML = function(t, d, g, s, m) {
        if ("undefined" == typeof html2canvas && "undefined" == typeof rasterizeHTML) throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");
        "number" != typeof d && (s = d, m = g), "function" == typeof s && (m = s, s = null), "function" != typeof m && (m = function() {});
        var e = this.internal, y = e.scaleFactor, v = e.pageSize.getWidth(), w = e.pageSize.getHeight();
        if ((s = s || {}).onrendered = (function(l) {
            d = parseInt(d) || 0, g = parseInt(g) || 0;
            var t = s.dim || {}, h = Object.assign({
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                useFor: "content"
            }, s.margin), e = t.h || Math.min(w, l.height / y), u = t.w || Math.min(v, l.width / y) - d, c = s.format || "JPEG", f = s.imageCompression || "SLOW";
            if (l.height > w - h.top - h.bottom && s.pagesplit) {
                var p = function(t, e, n, r, i) {
                    var o = document.createElement("canvas");
                    o.height = i, o.width = r;
                    var a = o.getContext("2d");
                    return a.mozImageSmoothingEnabled = !1, a.webkitImageSmoothingEnabled = !1, a.msImageSmoothingEnabled = !1, a.imageSmoothingEnabled = !1, a.fillStyle = s.backgroundColor || "#ffffff", a.fillRect(0, 0, r, i), a.drawImage(t, e, n, r, i, 0, 0, r, i), o;
                }, n = (function() {
                    for(var t, e, n = 0, r = 0, i = {}, o = !1;;){
                        var a;
                        if (r = 0, i.top = 0 !== n ? h.top : g, i.left = 0 !== n ? h.left : d, o = (v - h.left - h.right) * y < l.width, "content" === h.useFor ? 0 === n ? (t = Math.min((v - h.left) * y, l.width), e = Math.min((w - h.top) * y, l.height - n)) : (t = Math.min(v * y, l.width), e = Math.min(w * y, l.height - n), i.top = 0) : (t = Math.min((v - h.left - h.right) * y, l.width), e = Math.min((w - h.bottom - h.top) * y, l.height - n)), o) for(;;){
                            "content" === h.useFor && (0 === r ? t = Math.min((v - h.left) * y, l.width) : (t = Math.min(v * y, l.width - r), i.left = 0));
                            var s = [
                                a = p(l, r, n, t, e),
                                i.left,
                                i.top,
                                a.width / y,
                                a.height / y,
                                c,
                                null,
                                f
                            ];
                            if (this.addImage.apply(this, s), (r += t) >= l.width) break;
                            this.addPage();
                        }
                        else s = [
                            a = p(l, 0, n, t, e),
                            i.left,
                            i.top,
                            a.width / y,
                            a.height / y,
                            c,
                            null,
                            f
                        ], this.addImage.apply(this, s);
                        if ((n += e) >= l.height) break;
                        this.addPage();
                    }
                    m(u, n, null, s);
                }).bind(this);
                if ("CANVAS" === l.nodeName) {
                    var r = new Image;
                    r.onload = n, r.src = l.toDataURL("image/png"), l = r;
                } else n();
            } else {
                var i = Math.random().toString(35), o = [
                    l,
                    d,
                    g,
                    u,
                    e,
                    c,
                    i,
                    f
                ];
                this.addImage.apply(this, o), m(u, e, i, o);
            }
        }).bind(this), "undefined" != typeof html2canvas && !s.rstz) return html2canvas(t, s);
        if ("undefined" == typeof rasterizeHTML) return null;
        var n = "drawDocument";
        return "string" == typeof t && (n = /^http/.test(t) ? "drawURL" : "drawHTML"), s.width = s.width || v * y, rasterizeHTML[n](t, void 0, s).then(function(t) {
            s.onrendered(t.image);
        }, function(t) {
            m(null, t);
        });
    }, /**
   * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Daniel Husar, https://github.com/danielhusar
   *               2014 Wolfgang Gassler, https://github.com/woolfg
   *               2014 Steven Spungin, https://github.com/flamenco
   *
   * @license
   * 
   * ====================================================================
   */ function(t) {
        var P, k, i, a, s, l, h, u, I, w, f, c, p, n, C, B, d, g, m, j;
        P = function() {
            return function(t) {
                return e.prototype = t, new e;
            };
            function e() {}
        }(), w = function(t) {
            var e, n, r, i, o, a, s;
            for(n = 0, r = t.length, e = void 0, a = i = !1; !i && n !== r;)(e = t[n] = t[n].trimLeft()) && (i = !0), n++;
            for(n = r - 1; r && !a && -1 !== n;)(e = t[n] = t[n].trimRight()) && (a = !0), n--;
            for(o = /\s+$/g, s = !0, n = 0; n !== r;)"\u2028" != t[n] && (e = t[n].replace(/\s+/g, " "), s && (e = e.trimLeft()), e && (s = o.test(e)), t[n] = e), n++;
            return t;
        }, c = function(t) {
            var e, n, r;
            for(e = void 0, n = (r = t.split(",")).shift(); !e && n;)e = i[n.trim().toLowerCase()], n = r.shift();
            return e;
        }, p = function(t) {
            var e;
            return -1 < (t = "auto" === t ? "0px" : t).indexOf("em") && !isNaN(Number(t.replace("em", ""))) && (t = 18.719 * Number(t.replace("em", "")) + "px"), -1 < t.indexOf("pt") && !isNaN(Number(t.replace("pt", ""))) && (t = 1.333 * Number(t.replace("pt", "")) + "px"), (e = n[t]) ? e : void 0 !== (e = ({
                "xx-small": 9,
                "x-small": 11,
                small: 13,
                medium: 16,
                large: 19,
                "x-large": 23,
                "xx-large": 28,
                auto: 0
            })[t]) ? n[t] = e / 16 : (e = parseFloat(t)) ? n[t] = e / 16 : (e = t.match(/([\d\.]+)(px)/), Array.isArray(e) && 3 === e.length ? n[t] = parseFloat(e[1]) / 16 : n[t] = 1);
        }, I = function(t) {
            var e, n, r, i, o;
            return o = t, i = document.defaultView && document.defaultView.getComputedStyle ? document.defaultView.getComputedStyle(o, null) : o.currentStyle ? o.currentStyle : o.style, n = void 0, (e = {})["font-family"] = c((r = function(t) {
                return t = t.replace(/-\D/g, function(t) {
                    return t.charAt(1).toUpperCase();
                }), i[t];
            })("font-family")) || "times", e["font-style"] = a[r("font-style")] || "normal", e["text-align"] = s[r("text-align")] || "left", "bold" === (n = l[r("font-weight")] || "normal") && ("normal" === e["font-style"] ? e["font-style"] = n : e["font-style"] = n + e["font-style"]), e["font-size"] = p(r("font-size")) || 1, e["line-height"] = p(r("line-height")) || 1, e.display = "inline" === r("display") ? "inline" : "block", n = "block" === e.display, e["margin-top"] = n && p(r("margin-top")) || 0, e["margin-bottom"] = n && p(r("margin-bottom")) || 0, e["padding-top"] = n && p(r("padding-top")) || 0, e["padding-bottom"] = n && p(r("padding-bottom")) || 0, e["margin-left"] = n && p(r("margin-left")) || 0, e["margin-right"] = n && p(r("margin-right")) || 0, e["padding-left"] = n && p(r("padding-left")) || 0, e["padding-right"] = n && p(r("padding-right")) || 0, e["page-break-before"] = r("page-break-before") || "auto", e.float = h[r("cssFloat")] || "none", e.clear = u[r("clear")] || "none", e.color = r("color"), e;
        }, C = function(t, e, n) {
            var r, i, o, a, s;
            if (o = !1, a = i = void 0, r = n["#" + t.id]) {
                if ("function" == typeof r) o = r(t, e);
                else for(i = 0, a = r.length; !o && i !== a;)o = r[i](t, e), i++;
            }
            if (r = n[t.nodeName], !o && r) {
                if ("function" == typeof r) o = r(t, e);
                else for(i = 0, a = r.length; !o && i !== a;)o = r[i](t, e), i++;
            }
            for(s = "string" == typeof t.className ? t.className.split(" ") : [], i = 0; i < s.length; i++)if (r = n["." + s[i]], !o && r) {
                if ("function" == typeof r) o = r(t, e);
                else for(i = 0, a = r.length; !o && i !== a;)o = r[i](t, e), i++;
            }
            return o;
        }, j = function(t, e) {
            var n, r, i, o, a, s, l, h, u;
            for(n = [], r = [], i = 0, u = t.rows[0].cells.length, l = t.clientWidth; i < u;)h = t.rows[0].cells[i], r[i] = {
                name: h.textContent.toLowerCase().replace(/\s+/g, ""),
                prompt: h.textContent.replace(/\r?\n/g, ""),
                width: h.clientWidth / l * e.pdf.internal.pageSize.getWidth()
            }, i++;
            for(i = 1; i < t.rows.length;){
                for(s = t.rows[i], a = {}, o = 0; o < s.cells.length;)a[r[o].name] = s.cells[o].textContent.replace(/\r?\n/g, ""), o++;
                n.push(a), i++;
            }
            return {
                rows: n,
                headers: r
            };
        };
        var E = {
            SCRIPT: 1,
            STYLE: 1,
            NOSCRIPT: 1,
            OBJECT: 1,
            EMBED: 1,
            SELECT: 1
        }, M = 1;
        k = function(t, i, e) {
            var n, r, o, a, s, l, h, u;
            for(r = t.childNodes, n = void 0, (s = "block" === (o = I(t)).display) && (i.setBlockBoundary(), i.setBlockStyle(o)), a = 0, l = r.length; a < l;){
                if ("object" === se(n = r[a])) {
                    if (i.executeWatchFunctions(n), 1 === n.nodeType && "HEADER" === n.nodeName) {
                        var c = n, f = i.pdf.margins_doc.top;
                        i.pdf.internal.events.subscribe("addPage", function(t) {
                            i.y = f, k(c, i, e), i.pdf.margins_doc.top = i.y + 10, i.y += 10;
                        }, !1);
                    }
                    if (8 === n.nodeType && "#comment" === n.nodeName) ~n.textContent.indexOf("ADD_PAGE") && (i.pdf.addPage(), i.y = i.pdf.margins_doc.top);
                    else if (1 !== n.nodeType || E[n.nodeName]) {
                        if (3 === n.nodeType) {
                            var p = n.nodeValue;
                            if (n.nodeValue && "LI" === n.parentNode.nodeName) {
                                if ("OL" === n.parentNode.parentNode.nodeName) p = M++ + ". " + p;
                                else {
                                    var d = o["font-size"], g = (3 - .75 * d) * i.pdf.internal.scaleFactor, m = .75 * d * i.pdf.internal.scaleFactor, y = 1.74 * d / i.pdf.internal.scaleFactor;
                                    u = function(t, e) {
                                        this.pdf.circle(t + g, e + m, y, "FD");
                                    };
                                }
                            }
                            16 & n.ownerDocument.body.compareDocumentPosition(n) && i.addText(p, o);
                        } else "string" == typeof n && i.addText(n, o);
                    } else {
                        var v;
                        if ("IMG" === n.nodeName) {
                            var w = n.getAttribute("src");
                            v = B[i.pdf.sHashCode(w) || w];
                        }
                        if (v) {
                            i.pdf.internal.pageSize.getHeight() - i.pdf.margins_doc.bottom < i.y + n.height && i.y > i.pdf.margins_doc.top && (i.pdf.addPage(), i.y = i.pdf.margins_doc.top, i.executeWatchFunctions(n));
                            var b = I(n), x = i.x, N = 12 / i.pdf.internal.scaleFactor, L = (b["margin-left"] + b["padding-left"]) * N, A = (b["margin-right"] + b["padding-right"]) * N, S = (b["margin-top"] + b["padding-top"]) * N, _ = (b["margin-bottom"] + b["padding-bottom"]) * N;
                            void 0 !== b.float && "right" === b.float ? x += i.settings.width - n.width - A : x += L, i.pdf.addImage(v, x, i.y + S, n.width, n.height), v = void 0, "right" === b.float || "left" === b.float ? (i.watchFunctions.push((function(t, e, n, r) {
                                return i.y >= e ? (i.x += t, i.settings.width += n, !0) : !!(r && 1 === r.nodeType && !E[r.nodeName] && i.x + r.width > i.pdf.margins_doc.left + i.pdf.margins_doc.width) && (i.x += t, i.y = e, i.settings.width += n, !0);
                            }).bind(this, "left" === b.float ? -n.width - L - A : 0, i.y + n.height + S + _, n.width)), i.watchFunctions.push((function(t, e, n) {
                                return !(i.y < t && e === i.pdf.internal.getNumberOfPages()) || 1 === n.nodeType && "both" === I(n).clear && (i.y = t, !0);
                            }).bind(this, i.y + n.height, i.pdf.internal.getNumberOfPages())), i.settings.width -= n.width + L + A, "left" === b.float && (i.x += n.width + L + A)) : i.y += n.height + S + _;
                        } else if ("TABLE" === n.nodeName) h = j(n, i), i.y += 10, i.pdf.table(i.x, i.y, h.rows, h.headers, {
                            autoSize: !1,
                            printHeaders: e.printHeaders,
                            margins: i.pdf.margins_doc,
                            css: I(n)
                        }), i.y = i.pdf.lastCellPos.y + i.pdf.lastCellPos.h + 20;
                        else if ("OL" === n.nodeName || "UL" === n.nodeName) M = 1, C(n, i, e) || k(n, i, e), i.y += 10;
                        else if ("LI" === n.nodeName) {
                            var F = i.x;
                            i.x += 20 / i.pdf.internal.scaleFactor, i.y += 3, C(n, i, e) || k(n, i, e), i.x = F;
                        } else "BR" === n.nodeName ? (i.y += o["font-size"] * i.pdf.internal.scaleFactor, i.addText("\u2028", P(o))) : C(n, i, e) || k(n, i, e);
                    }
                }
                a++;
            }
            if (e.outY = i.y, s) return i.setBlockBoundary(u);
        }, B = {}, d = function(t, o, e, n) {
            var a, r = t.getElementsByTagName("img"), i = r.length, s = 0;
            function l() {
                o.pdf.internal.events.publish("imagesLoaded"), n(a);
            }
            function h(e, n, r) {
                if (e) {
                    var i = new Image;
                    a = ++s, i.crossOrigin = "", i.onerror = i.onload = function() {
                        if (i.complete && (0 === i.src.indexOf("data:image/") && (i.width = n || i.width || 0, i.height = r || i.height || 0), i.width + i.height)) {
                            var t = o.pdf.sHashCode(e) || e;
                            B[t] = B[t] || i;
                        }
                        --s || l();
                    }, i.src = e;
                }
            }
            for(; i--;)h(r[i].getAttribute("src"), r[i].width, r[i].height);
            return s || l();
        }, g = function(t, o, a) {
            var s = t.getElementsByTagName("footer");
            if (0 < s.length) {
                s = s[0];
                var e = o.pdf.internal.write, n = o.y;
                o.pdf.internal.write = function() {}, k(s, o, a);
                var l = Math.ceil(o.y - n) + 5;
                o.y = n, o.pdf.internal.write = e, o.pdf.margins_doc.bottom += l;
                for(var r = function(t) {
                    var e = void 0 !== t ? t.pageNumber : 1, n = o.y;
                    o.y = o.pdf.internal.pageSize.getHeight() - o.pdf.margins_doc.bottom, o.pdf.margins_doc.bottom -= l;
                    for(var r = s.getElementsByTagName("span"), i = 0; i < r.length; ++i)-1 < (" " + r[i].className + " ").replace(/[\n\t]/g, " ").indexOf(" pageCounter ") && (r[i].innerHTML = e), -1 < (" " + r[i].className + " ").replace(/[\n\t]/g, " ").indexOf(" totalPages ") && (r[i].innerHTML = "###jsPDFVarTotalPages###");
                    k(s, o, a), o.pdf.margins_doc.bottom += l, o.y = n;
                }, i = s.getElementsByTagName("span"), h = 0; h < i.length; ++h)-1 < (" " + i[h].className + " ").replace(/[\n\t]/g, " ").indexOf(" totalPages ") && o.pdf.internal.events.subscribe("htmlRenderingFinished", o.pdf.putTotalPages.bind(o.pdf, "###jsPDFVarTotalPages###"), !0);
                o.pdf.internal.events.subscribe("addPage", r, !1), r(), E.FOOTER = 1;
            }
        }, m = function(t, e, n, r, i, o) {
            if (!e) return !1;
            var a, s, l, h;
            "string" == typeof e || e.parentNode || (e = "" + e.innerHTML), "string" == typeof e && (a = e.replace(/<\/?script[^>]*?>/gi, ""), h = "jsPDFhtmlText" + Date.now().toString() + (1e3 * Math.random()).toFixed(0), (l = document.createElement("div")).style.cssText = "position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;", l.innerHTML = '<iframe style="height:1px;width:1px" name="' + h + '" />', document.body.appendChild(l), (s = window.frames[h]).document.open(), s.document.writeln(a), s.document.close(), e = s.document.body);
            var u, c = new f(t, n, r, i);
            return d.call(this, e, c, i.elementHandlers, function(t) {
                g(e, c, i.elementHandlers), k(e, c, i.elementHandlers), c.pdf.internal.events.publish("htmlRenderingFinished"), u = c.dispose(), "function" == typeof o ? o(u) : t && console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!");
            }), u || {
                x: c.x,
                y: c.y
            };
        }, (f = function(t, e, n, r) {
            return this.pdf = t, this.x = e, this.y = n, this.settings = r, this.watchFunctions = [], this.init(), this;
        }).prototype.init = function() {
            return this.paragraph = {
                text: [],
                style: []
            }, this.pdf.internal.write("q");
        }, f.prototype.dispose = function() {
            return this.pdf.internal.write("Q"), {
                x: this.x,
                y: this.y,
                ready: !0
            };
        }, f.prototype.executeWatchFunctions = function(t) {
            var e = !1, n = [];
            if (0 < this.watchFunctions.length) {
                for(var r = 0; r < this.watchFunctions.length; ++r)!0 === this.watchFunctions[r](t) ? e = !0 : n.push(this.watchFunctions[r]);
                this.watchFunctions = n;
            }
            return e;
        }, f.prototype.splitFragmentsIntoLines = function(t, e) {
            var n, r, i, o, a, s, l, h, u, c, f, p, d, g;
            for(c = this.pdf.internal.scaleFactor, o = {}, s = l = h = g = a = i = u = r = void 0, p = [
                f = []
            ], n = 0, d = this.settings.width; t.length;)if (a = t.shift(), g = e.shift(), a) {
                if ((i = o[(r = g["font-family"]) + (u = g["font-style"])]) || (i = this.pdf.internal.getFont(r, u).metadata.Unicode, o[r + u] = i), h = {
                    widths: i.widths,
                    kerning: i.kerning,
                    fontSize: 12 * g["font-size"],
                    textIndent: n
                }, l = this.pdf.getStringUnitWidth(a, h) * h.fontSize / c, "\u2028" == a) f = [], p.push(f);
                else if (d < n + l) {
                    for(s = this.pdf.splitTextToSize(a, d, h), f.push([
                        s.shift(),
                        g
                    ]); s.length;)f = [
                        [
                            s.shift(),
                            g
                        ]
                    ], p.push(f);
                    n = this.pdf.getStringUnitWidth(f[0][0], h) * h.fontSize / c;
                } else f.push([
                    a,
                    g
                ]), n += l;
            }
            if (void 0 !== g["text-align"] && ("center" === g["text-align"] || "right" === g["text-align"] || "justify" === g["text-align"])) for(var m = 0; m < p.length; ++m){
                var y = this.pdf.getStringUnitWidth(p[m][0][0], h) * h.fontSize / c;
                0 < m && (p[m][0][1] = P(p[m][0][1]));
                var v = d - y;
                if ("right" === g["text-align"]) p[m][0][1]["margin-left"] = v;
                else if ("center" === g["text-align"]) p[m][0][1]["margin-left"] = v / 2;
                else if ("justify" === g["text-align"]) {
                    var w = p[m][0][0].split(" ").length - 1;
                    p[m][0][1]["word-spacing"] = v / w, m === p.length - 1 && (p[m][0][1]["word-spacing"] = 0);
                }
            }
            return p;
        }, f.prototype.RenderTextFragment = function(t, e) {
            var n, r;
            r = 0, this.pdf.internal.pageSize.getHeight() - this.pdf.margins_doc.bottom < this.y + this.pdf.internal.getFontSize() && (this.pdf.internal.write("ET", "Q"), this.pdf.addPage(), this.y = this.pdf.margins_doc.top, this.pdf.internal.write("q", "BT", this.getPdfColor(e.color), this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td"), r = Math.max(r, e["line-height"], e["font-size"]), this.pdf.internal.write(0, (-12 * r).toFixed(2), "Td")), n = this.pdf.internal.getFont(e["font-family"], e["font-style"]);
            var i = this.getPdfColor(e.color);
            i !== this.lastTextColor && (this.pdf.internal.write(i), this.lastTextColor = i), void 0 !== e["word-spacing"] && 0 < e["word-spacing"] && this.pdf.internal.write(e["word-spacing"].toFixed(2), "Tw"), this.pdf.internal.write("/" + n.id, (12 * e["font-size"]).toFixed(2), "Tf", "(" + this.pdf.internal.pdfEscape(t) + ") Tj"), void 0 !== e["word-spacing"] && this.pdf.internal.write(0, "Tw");
        }, f.prototype.getPdfColor = function(t) {
            var e, n, r, i = /rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);
            if (null != i) e = parseInt(i[1]), n = parseInt(i[2]), r = parseInt(i[3]);
            else {
                if ("string" == typeof t && "#" != t.charAt(0)) {
                    var o = new RGBColor(t);
                    t = o.ok ? o.toHex() : "#000000";
                }
                e = t.substring(1, 3), e = parseInt(e, 16), n = t.substring(3, 5), n = parseInt(n, 16), r = t.substring(5, 7), r = parseInt(r, 16);
            }
            if ("string" == typeof e && /^#[0-9A-Fa-f]{6}$/.test(e)) {
                var a = parseInt(e.substr(1), 16);
                e = a >> 16 & 255, n = a >> 8 & 255, r = 255 & a;
            }
            var s = this.f3;
            return 0 === e && 0 === n && 0 === r || void 0 === n ? s(e / 255) + " g" : [
                s(e / 255),
                s(n / 255),
                s(r / 255),
                "rg"
            ].join(" ");
        }, f.prototype.f3 = function(t) {
            return t.toFixed(3);
        }, f.prototype.renderParagraph = function(t) {
            var e, n, r, i, o, a, s, l, h, u, c, f, p;
            if (r = w(this.paragraph.text), f = this.paragraph.style, e = this.paragraph.blockstyle, this.paragraph.priorblockstyle, this.paragraph = {
                text: [],
                style: [],
                blockstyle: {},
                priorblockstyle: e
            }, r.join("").trim()) {
                s = this.splitFragmentsIntoLines(r, f), l = a = void 0, n = 12 / this.pdf.internal.scaleFactor, this.priorMarginBottom = this.priorMarginBottom || 0, c = (Math.max((e["margin-top"] || 0) - this.priorMarginBottom, 0) + (e["padding-top"] || 0)) * n, u = ((e["margin-bottom"] || 0) + (e["padding-bottom"] || 0)) * n, this.priorMarginBottom = e["margin-bottom"] || 0, "always" === e["page-break-before"] && (this.pdf.addPage(), this.y = 0, c = ((e["margin-top"] || 0) + (e["padding-top"] || 0)) * n), h = this.pdf.internal.write, o = i = void 0, this.y += c, h("q", "BT 0 g", this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td");
                for(var d = 0; s.length;){
                    for(i = l = 0, o = (a = s.shift()).length; i !== o;)a[i][0].trim() && (l = Math.max(l, a[i][1]["line-height"], a[i][1]["font-size"]), p = 7 * a[i][1]["font-size"]), i++;
                    var g = 0, m = 0;
                    for(void 0 !== a[0][1]["margin-left"] && 0 < a[0][1]["margin-left"] && (g = (m = this.pdf.internal.getCoordinateString(a[0][1]["margin-left"])) - d, d = m), h(g + Math.max(e["margin-left"] || 0, 0) * n, (-12 * l).toFixed(2), "Td"), i = 0, o = a.length; i !== o;)a[i][0] && this.RenderTextFragment(a[i][0], a[i][1]), i++;
                    if (this.y += l * n, this.executeWatchFunctions(a[0][1]) && 0 < s.length) {
                        var y = [], v = [];
                        s.forEach(function(t) {
                            for(var e = 0, n = t.length; e !== n;)t[e][0] && (y.push(t[e][0] + " "), v.push(t[e][1])), ++e;
                        }), s = this.splitFragmentsIntoLines(w(y), v), h("ET", "Q"), h("q", "BT 0 g", this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td");
                    }
                }
                return t && "function" == typeof t && t.call(this, this.x - 9, this.y - p / 2), h("ET", "Q"), this.y += u;
            }
        }, f.prototype.setBlockBoundary = function(t) {
            return this.renderParagraph(t);
        }, f.prototype.setBlockStyle = function(t) {
            return this.paragraph.blockstyle = t;
        }, f.prototype.addText = function(t, e) {
            return this.paragraph.text.push(t), this.paragraph.style.push(e);
        }, i = {
            helvetica: "helvetica",
            "sans-serif": "helvetica",
            "times new roman": "times",
            serif: "times",
            times: "times",
            monospace: "courier",
            courier: "courier"
        }, l = {
            100: "normal",
            200: "normal",
            300: "normal",
            400: "normal",
            500: "bold",
            600: "bold",
            700: "bold",
            800: "bold",
            900: "bold",
            normal: "normal",
            bold: "bold",
            bolder: "bold",
            lighter: "normal"
        }, a = {
            normal: "normal",
            italic: "italic",
            oblique: "italic"
        }, s = {
            left: "left",
            right: "right",
            center: "center",
            justify: "justify"
        }, h = {
            none: "none",
            right: "right",
            left: "left"
        }, u = {
            none: "none",
            both: "both"
        }, n = {
            normal: 1
        }, t.fromHTML = function(t, e, n, r, i, o) {
            return this.margins_doc = o || {
                top: 0,
                bottom: 0
            }, r || (r = {}), r.elementHandlers || (r.elementHandlers = {}), m(this, t, isNaN(e) ? 4 : e, isNaN(n) ? 4 : n, r, i);
        };
    }(lt.API), lt.API, ("undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global).html2pdf = function(t, a, e) {
        var n = a.canvas;
        if (n) {
            var r, i;
            if ((n.pdf = a).annotations = {
                _nameMap: [],
                createAnnotation: function(t, e) {
                    var n, r = a.context2d._wrapX(e.left), i = a.context2d._wrapY(e.top), o = (a.context2d._page(e.top), t.indexOf("#"));
                    n = 0 <= o ? {
                        name: t.substring(o + 1)
                    } : {
                        url: t
                    }, a.link(r, i, e.right - e.left, e.bottom - e.top, n);
                },
                setName: function(t, e) {
                    var n = a.context2d._wrapX(e.left), r = a.context2d._wrapY(e.top), i = a.context2d._page(e.top);
                    this._nameMap[t] = {
                        page: i,
                        x: n,
                        y: r
                    };
                }
            }, n.annotations = a.annotations, a.context2d._pageBreakAt = function(t) {
                this.pageBreaks.push(t);
            }, a.context2d._gotoPage = function(t) {
                for(; a.internal.getNumberOfPages() < t;)a.addPage();
                a.setPage(t);
            }, "string" == typeof t) {
                t = t.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "");
                var o, s, l = document.createElement("iframe");
                document.body.appendChild(l), null != (o = l.contentDocument) && null != o || (o = l.contentWindow.document), o.open(), o.write(t), o.close(), r = o.body, s = o.body || {}, t = o.documentElement || {}, i = Math.max(s.scrollHeight, s.offsetHeight, t.clientHeight, t.scrollHeight, t.offsetHeight);
            } else s = (r = t).body || {}, i = Math.max(s.scrollHeight, s.offsetHeight, t.clientHeight, t.scrollHeight, t.offsetHeight);
            var h = {
                async: !0,
                allowTaint: !0,
                backgroundColor: "#ffffff",
                canvas: n,
                imageTimeout: 15e3,
                logging: !0,
                proxy: null,
                removeContainer: !0,
                foreignObjectRendering: !1,
                useCORS: !1,
                windowHeight: i = a.internal.pageSize.getHeight(),
                scrollY: i
            };
            a.context2d.pageWrapYEnabled = !0, a.context2d.pageWrapY = a.internal.pageSize.getHeight(), html2canvas(r, h).then(function(t) {
                e && (l && l.parentElement.removeChild(l), e(a));
            });
        } else alert("jsPDF canvas plugin not installed");
    }, window.tmp = html2pdf, function(f) {
        var r = f.BlobBuilder || f.WebKitBlobBuilder || f.MSBlobBuilder || f.MozBlobBuilder;
        f.URL = f.URL || f.webkitURL || function(t, e) {
            return (e = document.createElement("a")).href = t, e;
        };
        var n = f.Blob, p = URL.createObjectURL, d = URL.revokeObjectURL, o = f.Symbol && f.Symbol.toStringTag, t = !1, e = !1, g = !!f.ArrayBuffer, i = r && r.prototype.append && r.prototype.getBlob;
        try {
            t = 2 === new Blob([
                "\xe4"
            ]).size, e = 2 === new Blob([
                new Uint8Array([
                    1,
                    2
                ])
            ]).size;
        } catch (t) {}
        function a(t) {
            return t.map(function(t) {
                if (t.buffer instanceof ArrayBuffer) {
                    var e = t.buffer;
                    if (t.byteLength !== e.byteLength) {
                        var n = new Uint8Array(t.byteLength);
                        n.set(new Uint8Array(e, t.byteOffset, t.byteLength)), e = n.buffer;
                    }
                    return e;
                }
                return t;
            });
        }
        function s(t, e) {
            e = e || {};
            var n = new r;
            return a(t).forEach(function(t) {
                n.append(t);
            }), e.type ? n.getBlob(e.type) : n.getBlob();
        }
        function l(t, e) {
            return new n(a(t), e || {});
        }
        if (f.Blob && (s.prototype = Blob.prototype, l.prototype = Blob.prototype), o) try {
            File.prototype[o] = "File", Blob.prototype[o] = "Blob", FileReader.prototype[o] = "FileReader";
        } catch (t) {}
        function h() {
            var t = !!f.ActiveXObject || "-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style, e = f.XMLHttpRequest && f.XMLHttpRequest.prototype.send;
            t && e && (XMLHttpRequest.prototype.send = function(t) {
                t instanceof Blob && this.setRequestHeader("Content-Type", t.type), e.call(this, t);
            });
            try {
                new File([], "");
            } catch (t) {
                try {
                    var n = new Function('class File extends Blob {constructor(chunks, name, opts) {opts = opts || {};super(chunks, opts || {});this.name = name;this.lastModifiedDate = opts.lastModified ? new Date(opts.lastModified) : new Date;this.lastModified = +this.lastModifiedDate;}};return new File([], ""), File')();
                    f.File = n;
                } catch (t) {
                    n = function(t, e, n) {
                        var r = new Blob(t, n), i = n && void 0 !== n.lastModified ? new Date(n.lastModified) : new Date;
                        return r.name = e, r.lastModifiedDate = i, r.lastModified = +i, r.toString = function() {
                            return "[object File]";
                        }, o && (r[o] = "File"), r;
                    };
                    f.File = n;
                }
            }
        }
        t ? (h(), f.Blob = e ? f.Blob : l) : i ? (h(), f.Blob = s) : function() {
            function a(t) {
                for(var e = [], n = 0; n < t.length; n++){
                    var r = t.charCodeAt(n);
                    r < 128 ? e.push(r) : r < 2048 ? e.push(192 | r >> 6, 128 | 63 & r) : r < 55296 || 57344 <= r ? e.push(224 | r >> 12, 128 | r >> 6 & 63, 128 | 63 & r) : (n++, r = 65536 + ((1023 & r) << 10 | 1023 & t.charCodeAt(n)), e.push(240 | r >> 18, 128 | r >> 12 & 63, 128 | r >> 6 & 63, 128 | 63 & r));
                }
                return e;
            }
            function e(t) {
                var e, n, r, i, o, a;
                for(e = "", r = t.length, n = 0; n < r;)switch((i = t[n++]) >> 4){
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                        e += String.fromCharCode(i);
                        break;
                    case 12:
                    case 13:
                        o = t[n++], e += String.fromCharCode((31 & i) << 6 | 63 & o);
                        break;
                    case 14:
                        o = t[n++], a = t[n++], e += String.fromCharCode((15 & i) << 12 | (63 & o) << 6 | (63 & a) << 0);
                }
                return e;
            }
            function s(t) {
                for(var e = new Array(t.byteLength), n = new Uint8Array(t), r = e.length; r--;)e[r] = n[r];
                return e;
            }
            function n(t) {
                for(var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", n = [], r = 0; r < t.length; r += 3){
                    var i = t[r], o = r + 1 < t.length, a = o ? t[r + 1] : 0, s = r + 2 < t.length, l = s ? t[r + 2] : 0, h = i >> 2, u = (3 & i) << 4 | a >> 4, c = (15 & a) << 2 | l >> 6, f = 63 & l;
                    s || (f = 64, o || (c = 64)), n.push(e[h], e[u], e[c], e[f]);
                }
                return n.join("");
            }
            var t = Object.create || function(t) {
                function e() {}
                return e.prototype = t, new e;
            };
            if (g) var r = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ], l = ArrayBuffer.isView || function(t) {
                return t && -1 < r.indexOf(Object.prototype.toString.call(t));
            };
            function h(t, e) {
                for(var n = 0, r = (t = t || []).length; n < r; n++){
                    var i = t[n];
                    i instanceof h ? t[n] = i._buffer : "string" == typeof i ? t[n] = a(i) : g && (ArrayBuffer.prototype.isPrototypeOf(i) || l(i)) ? t[n] = s(i) : g && (o = i) && DataView.prototype.isPrototypeOf(o) ? t[n] = s(i.buffer) : t[n] = a(String(i));
                }
                var o;
                this._buffer = [].concat.apply([], t), this.size = this._buffer.length, this.type = e && e.type || "";
            }
            function i(t, e, n) {
                var r = h.call(this, t, n = n || {}) || this;
                return r.name = e, r.lastModifiedDate = n.lastModified ? new Date(n.lastModified) : new Date, r.lastModified = +r.lastModifiedDate, r;
            }
            if (h.prototype.slice = function(t, e, n) {
                return new h([
                    this._buffer.slice(t || 0, e || this._buffer.length)
                ], {
                    type: n
                });
            }, h.prototype.toString = function() {
                return "[object Blob]";
            }, (i.prototype = t(h.prototype)).constructor = i, Object.setPrototypeOf) Object.setPrototypeOf(i, h);
            else try {
                i.__proto__ = h;
            } catch (t) {}
            function o() {
                if (!(this instanceof o)) throw new TypeError("Failed to construct 'FileReader': Please use the 'new' operator, this DOM object constructor cannot be called as a function.");
                var n = document.createDocumentFragment();
                this.addEventListener = n.addEventListener, this.dispatchEvent = function(t) {
                    var e = this["on" + t.type];
                    "function" == typeof e && e(t), n.dispatchEvent(t);
                }, this.removeEventListener = n.removeEventListener;
            }
            function u(t, e, n) {
                if (!(e instanceof h)) throw new TypeError("Failed to execute '" + n + "' on 'FileReader': parameter 1 is not of type 'Blob'.");
                t.result = "", setTimeout(function() {
                    this.readyState = o.LOADING, t.dispatchEvent(new Event("load")), t.dispatchEvent(new Event("loadend"));
                });
            }
            i.prototype.toString = function() {
                return "[object File]";
            }, o.EMPTY = 0, o.LOADING = 1, o.DONE = 2, o.prototype.error = null, o.prototype.onabort = null, o.prototype.onerror = null, o.prototype.onload = null, o.prototype.onloadend = null, o.prototype.onloadstart = null, o.prototype.onprogress = null, o.prototype.readAsDataURL = function(t) {
                u(this, t, "readAsDataURL"), this.result = "data:" + t.type + ";base64," + n(t._buffer);
            }, o.prototype.readAsText = function(t) {
                u(this, t, "readAsText"), this.result = e(t._buffer);
            }, o.prototype.readAsArrayBuffer = function(t) {
                u(this, t, "readAsText"), this.result = t._buffer.slice();
            }, o.prototype.abort = function() {}, URL.createObjectURL = function(t) {
                return t instanceof h ? "data:" + t.type + ";base64," + n(t._buffer) : p.call(URL, t);
            }, URL.revokeObjectURL = function(t) {
                d && d.call(URL, t);
            };
            var c = f.XMLHttpRequest && f.XMLHttpRequest.prototype.send;
            c && (XMLHttpRequest.prototype.send = function(t) {
                t instanceof h ? (this.setRequestHeader("Content-Type", t.type), c.call(this, e(t._buffer))) : c.call(this, t);
            }), f.FileReader = o, f.File = i, f.Blob = h;
        }();
    }("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")());
    var ht, ut, ct, ft, pt, dt, gt, mt, yt, vt, wt, bt, xt, Nt, Lt, le = le || function(s) {
        if (!(void 0 === s || "undefined" != typeof navigator && /MSIE [1-9]\./.test(navigator.userAgent))) {
            var t = s.document, l = function() {
                return s.URL || s.webkitURL || s;
            }, h = t.createElementNS("http://www.w3.org/1999/xhtml", "a"), u = "download" in h, c = /constructor/i.test(s.HTMLElement) || s.safari, f = /CriOS\/[\d]+/.test(navigator.userAgent), p = s.setImmediate || s.setTimeout, d = function(t) {
                p(function() {
                    throw t;
                }, 0);
            }, g = function(t) {
                setTimeout(function() {
                    "string" == typeof t ? l().revokeObjectURL(t) : t.remove();
                }, 4e4);
            }, m = function(t) {
                return /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type) ? new Blob([
                    String.fromCharCode(65279),
                    t
                ], {
                    type: t.type
                }) : t;
            }, r = function(t, n, e) {
                e || (t = m(t));
                var r, i = this, o = "application/octet-stream" === t.type, a = function() {
                    !function(t, e, n) {
                        for(var r = (e = [].concat(e)).length; r--;){
                            var i = t["on" + e[r]];
                            if ("function" == typeof i) try {
                                i.call(t, n || t);
                            } catch (t) {
                                d(t);
                            }
                        }
                    }(i, "writestart progress write writeend".split(" "));
                };
                if (i.readyState = i.INIT, u) return r = l().createObjectURL(t), void p(function() {
                    var t, e;
                    h.href = r, h.download = n, t = h, e = new MouseEvent("click"), t.dispatchEvent(e), a(), g(r), i.readyState = i.DONE;
                }, 0);
                !function() {
                    if ((f || o && c) && s.FileReader) {
                        var e = new FileReader;
                        return e.onloadend = function() {
                            var t = f ? e.result : e.result.replace(/^data:[^;]*;/, "data:attachment/file;");
                            s.open(t, "_blank") || (s.location.href = t), t = void 0, i.readyState = i.DONE, a();
                        }, e.readAsDataURL(t), i.readyState = i.INIT;
                    }
                    r || (r = l().createObjectURL(t)), o ? s.location.href = r : s.open(r, "_blank") || (s.location.href = r);
                    i.readyState = i.DONE, a(), g(r);
                }();
            }, e = r.prototype;
            return "undefined" != typeof navigator && navigator.msSaveOrOpenBlob ? function(t, e, n) {
                return e = e || t.name || "download", n || (t = m(t)), navigator.msSaveOrOpenBlob(t, e);
            } : (e.abort = function() {}, e.readyState = e.INIT = 0, e.WRITING = 1, e.DONE = 2, e.error = e.onwritestart = e.onprogress = e.onwrite = e.onabort = e.onerror = e.onwriteend = null, function(t, e, n) {
                return new r(t, e || t.name || "download", n);
            });
        }
    }("undefined" != typeof self && self || "undefined" != typeof window && window || void 0);
    function At(x) {
        var t = 0;
        if (71 !== x[t++] || 73 !== x[t++] || 70 !== x[t++] || 56 !== x[t++] || 56 != (x[t++] + 1 & 253) || 97 !== x[t++]) throw "Invalid GIF 87a/89a header.";
        var N = x[t++] | x[t++] << 8, e = x[t++] | x[t++] << 8, n = x[t++], r = n >> 7, i = 1 << (7 & n) + 1;
        x[t++];
        x[t++];
        var o = null;
        r && (o = t, t += 3 * i);
        var a = !0, s = [], l = 0, h = null, u = 0, c = null;
        for(this.width = N, this.height = e; a && t < x.length;)switch(x[t++]){
            case 33:
                switch(x[t++]){
                    case 255:
                        if (11 !== x[t] || 78 == x[t + 1] && 69 == x[t + 2] && 84 == x[t + 3] && 83 == x[t + 4] && 67 == x[t + 5] && 65 == x[t + 6] && 80 == x[t + 7] && 69 == x[t + 8] && 50 == x[t + 9] && 46 == x[t + 10] && 48 == x[t + 11] && 3 == x[t + 12] && 1 == x[t + 13] && 0 == x[t + 16]) t += 14, c = x[t++] | x[t++] << 8, t++;
                        else for(t += 12;;){
                            if (0 === (A = x[t++])) break;
                            t += A;
                        }
                        break;
                    case 249:
                        if (4 !== x[t++] || 0 !== x[t + 4]) throw "Invalid graphics extension block.";
                        var f = x[t++];
                        l = x[t++] | x[t++] << 8, h = x[t++], 0 == (1 & f) && (h = null), u = f >> 2 & 7, t++;
                        break;
                    case 254:
                        for(;;){
                            if (0 === (A = x[t++])) break;
                            t += A;
                        }
                        break;
                    default:
                        throw "Unknown graphic control label: 0x" + x[t - 1].toString(16);
                }
                break;
            case 44:
                var p = x[t++] | x[t++] << 8, d = x[t++] | x[t++] << 8, g = x[t++] | x[t++] << 8, m = x[t++] | x[t++] << 8, y = x[t++], v = y >> 6 & 1, w = o, b = !1;
                if (y >> 7) {
                    b = !0;
                    w = t, t += 3 * (1 << (7 & y) + 1);
                }
                var L = t;
                for(t++;;){
                    var A;
                    if (0 === (A = x[t++])) break;
                    t += A;
                }
                s.push({
                    x: p,
                    y: d,
                    width: g,
                    height: m,
                    has_local_palette: b,
                    palette_offset: w,
                    data_offset: L,
                    data_length: t - L,
                    transparent_index: h,
                    interlaced: !!v,
                    delay: l,
                    disposal: u
                });
                break;
            case 59:
                a = !1;
                break;
            default:
                throw "Unknown gif block: 0x" + x[t - 1].toString(16);
        }
        this.numFrames = function() {
            return s.length;
        }, this.loopCount = function() {
            return c;
        }, this.frameInfo = function(t) {
            if (t < 0 || t >= s.length) throw "Frame index out of range.";
            return s[t];
        }, this.decodeAndBlitFrameBGRA = function(t, e) {
            var n = this.frameInfo(t), r = n.width * n.height, i = new Uint8Array(r);
            St(x, n.data_offset, i, r);
            var o = n.palette_offset, a = n.transparent_index;
            null === a && (a = 256);
            var s = n.width, l = N - s, h = s, u = 4 * (n.y * N + n.x), c = 4 * ((n.y + n.height) * N + n.x), f = u, p = 4 * l;
            !0 === n.interlaced && (p += 4 * (s + l) * 7);
            for(var d = 8, g = 0, m = i.length; g < m; ++g){
                var y = i[g];
                if (0 === h && (h = s, c <= (f += p) && (p = l + 4 * (s + l) * (d - 1), f = u + (s + l) * (d << 1), d >>= 1)), y === a) f += 4;
                else {
                    var v = x[o + 3 * y], w = x[o + 3 * y + 1], b = x[o + 3 * y + 2];
                    e[f++] = b, e[f++] = w, e[f++] = v, e[f++] = 255;
                }
                --h;
            }
        }, this.decodeAndBlitFrameRGBA = function(t, e) {
            var n = this.frameInfo(t), r = n.width * n.height, i = new Uint8Array(r);
            St(x, n.data_offset, i, r);
            var o = n.palette_offset, a = n.transparent_index;
            null === a && (a = 256);
            var s = n.width, l = N - s, h = s, u = 4 * (n.y * N + n.x), c = 4 * ((n.y + n.height) * N + n.x), f = u, p = 4 * l;
            !0 === n.interlaced && (p += 4 * (s + l) * 7);
            for(var d = 8, g = 0, m = i.length; g < m; ++g){
                var y = i[g];
                if (0 === h && (h = s, c <= (f += p) && (p = l + 4 * (s + l) * (d - 1), f = u + (s + l) * (d << 1), d >>= 1)), y === a) f += 4;
                else {
                    var v = x[o + 3 * y], w = x[o + 3 * y + 1], b = x[o + 3 * y + 2];
                    e[f++] = v, e[f++] = w, e[f++] = b, e[f++] = 255;
                }
                --h;
            }
        };
    }
    function St(t, e, n, r) {
        for(var i = t[e++], o = 1 << i, a = o + 1, s = a + 1, l = i + 1, h = (1 << l) - 1, u = 0, c = 0, f = 0, p = t[e++], d = new Int32Array(4096), g = null;;){
            for(; u < 16 && 0 !== p;)c |= t[e++] << u, u += 8, 1 === p ? p = t[e++] : --p;
            if (u < l) break;
            var m = c & h;
            if (c >>= l, u -= l, m !== o) {
                if (m === a) break;
                for(var y = m < s ? m : g, v = 0, w = y; o < w;)w = d[w] >> 8, ++v;
                var b = w;
                if (r < f + v + (y !== m ? 1 : 0)) return void console.log("Warning, gif stream longer than expected.");
                n[f++] = b;
                var x = f += v;
                for(y !== m && (n[f++] = b), w = y; v--;)w = d[w], n[--x] = 255 & w, w >>= 8;
                null !== g && s < 4096 && (d[s++] = g << 8 | b, h + 1 <= s && l < 12 && (++l, h = h << 1 | 1)), g = m;
            } else s = a + 1, h = (1 << (l = i + 1)) - 1, g = null;
        }
        return f !== r && console.log("Warning, gif stream shorter than expected."), n;
    }
    try {
        $d4a0bfe8d6ddfc13$exports.GifWriter = function(y, t, e, n) {
            var v = 0, r = void 0 === (n = void 0 === n ? {} : n).loop ? null : n.loop, w = void 0 === n.palette ? null : n.palette;
            if (t <= 0 || e <= 0 || 65535 < t || 65535 < e) throw "Width/Height invalid.";
            function b(t) {
                var e = t.length;
                if (e < 2 || 256 < e || e & e - 1) throw "Invalid code/color length, must be power of 2 and 2 .. 256.";
                return e;
            }
            y[v++] = 71, y[v++] = 73, y[v++] = 70, y[v++] = 56, y[v++] = 57, y[v++] = 97;
            var i = 0, o = 0;
            if (null !== w) {
                for(var a = b(w); a >>= 1;)++i;
                if (a = 1 << i, --i, void 0 !== n.background) {
                    if (a <= (o = n.background)) throw "Background index out of range.";
                    if (0 === o) throw "Background index explicitly passed as 0.";
                }
            }
            if (y[v++] = 255 & t, y[v++] = t >> 8 & 255, y[v++] = 255 & e, y[v++] = e >> 8 & 255, y[v++] = (null !== w ? 128 : 0) | i, y[v++] = o, y[v++] = 0, null !== w) for(var s = 0, l = w.length; s < l; ++s){
                var h = w[s];
                y[v++] = h >> 16 & 255, y[v++] = h >> 8 & 255, y[v++] = 255 & h;
            }
            if (null !== r) {
                if (r < 0 || 65535 < r) throw "Loop count invalid.";
                y[v++] = 33, y[v++] = 255, y[v++] = 11, y[v++] = 78, y[v++] = 69, y[v++] = 84, y[v++] = 83, y[v++] = 67, y[v++] = 65, y[v++] = 80, y[v++] = 69, y[v++] = 50, y[v++] = 46, y[v++] = 48, y[v++] = 3, y[v++] = 1, y[v++] = 255 & r, y[v++] = r >> 8 & 255, y[v++] = 0;
            }
            var x = !1;
            this.addFrame = function(t, e, n, r, i, o) {
                if (!0 === x && (--v, x = !1), o = void 0 === o ? {} : o, t < 0 || e < 0 || 65535 < t || 65535 < e) throw "x/y invalid.";
                if (n <= 0 || r <= 0 || 65535 < n || 65535 < r) throw "Width/Height invalid.";
                if (i.length < n * r) throw "Not enough pixels for the frame size.";
                var a = !0, s = o.palette;
                if (null == s && (a = !1, s = w), null == s) throw "Must supply either a local or global palette.";
                for(var l = b(s), h = 0; l >>= 1;)++h;
                l = 1 << h;
                var u = void 0 === o.delay ? 0 : o.delay, c = void 0 === o.disposal ? 0 : o.disposal;
                if (c < 0 || 3 < c) throw "Disposal out of range.";
                var f = !1, p = 0;
                if (void 0 !== o.transparent && null !== o.transparent && (f = !0, (p = o.transparent) < 0 || l <= p)) throw "Transparent color index.";
                if ((0 !== c || f || 0 !== u) && (y[v++] = 33, y[v++] = 249, y[v++] = 4, y[v++] = c << 2 | (!0 === f ? 1 : 0), y[v++] = 255 & u, y[v++] = u >> 8 & 255, y[v++] = p, y[v++] = 0), y[v++] = 44, y[v++] = 255 & t, y[v++] = t >> 8 & 255, y[v++] = 255 & e, y[v++] = e >> 8 & 255, y[v++] = 255 & n, y[v++] = n >> 8 & 255, y[v++] = 255 & r, y[v++] = r >> 8 & 255, y[v++] = !0 === a ? 128 | h - 1 : 0, !0 === a) for(var d = 0, g = s.length; d < g; ++d){
                    var m = s[d];
                    y[v++] = m >> 16 & 255, y[v++] = m >> 8 & 255, y[v++] = 255 & m;
                }
                v = function(e, n, t, r) {
                    e[n++] = t;
                    var i = n++, o = 1 << t, a = o - 1, s = o + 1, l = s + 1, h = t + 1, u = 0, c = 0;
                    function f(t) {
                        for(; t <= u;)e[n++] = 255 & c, c >>= 8, u -= 8, n === i + 256 && (e[i] = 255, i = n++);
                    }
                    function p(t) {
                        c |= t << u, u += h, f(8);
                    }
                    var d = r[0] & a, g = {};
                    p(o);
                    for(var m = 1, y = r.length; m < y; ++m){
                        var v = r[m] & a, w = d << 8 | v, b = g[w];
                        if (void 0 === b) {
                            for(c |= d << u, u += h; 8 <= u;)e[n++] = 255 & c, c >>= 8, u -= 8, n === i + 256 && (e[i] = 255, i = n++);
                            4096 === l ? (p(o), l = s + 1, h = t + 1, g = {}) : (1 << h <= l && ++h, g[w] = l++), d = v;
                        } else d = b;
                    }
                    return p(d), p(s), f(1), i + 1 === n ? e[i] = 0 : (e[i] = n - i - 1, e[n++] = 0), n;
                }(y, v, h < 2 ? 2 : h, i);
            }, this.end = function() {
                return !1 === x && (y[v++] = 59, x = !0), v;
            };
        }, $d4a0bfe8d6ddfc13$exports.GifReader = At;
    } catch (t) {}
    /*
    Copyright (c) 2008, Adobe Systems Incorporated
    All rights reserved.

    Redistribution and use in source and binary forms, with or without 
    modification, are permitted provided that the following conditions are
    met:

    * Redistributions of source code must retain the above copyright notice, 
      this list of conditions and the following disclaimer.
    
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the 
      documentation and/or other materials provided with the distribution.
    
    * Neither the name of Adobe Systems Incorporated nor the names of its 
      contributors may be used to endorse or promote products derived from 
      this software without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
    IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
    THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
    PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
    CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
    EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
    PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
    PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
    LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
    NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
    SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */ function _t(t) {
        var N, L, A, S, e, c = Math.floor, _ = new Array(64), F = new Array(64), P = new Array(64), k = new Array(64), y = new Array(65535), v = new Array(65535), Z = new Array(64), w = new Array(64), I = [], C = 0, B = 7, j = new Array(64), E = new Array(64), M = new Array(64), n = new Array(256), O = new Array(2048), b = [
            0,
            1,
            5,
            6,
            14,
            15,
            27,
            28,
            2,
            4,
            7,
            13,
            16,
            26,
            29,
            42,
            3,
            8,
            12,
            17,
            25,
            30,
            41,
            43,
            9,
            11,
            18,
            24,
            31,
            40,
            44,
            53,
            10,
            19,
            23,
            32,
            39,
            45,
            52,
            54,
            20,
            22,
            33,
            38,
            46,
            51,
            55,
            60,
            21,
            34,
            37,
            47,
            50,
            56,
            59,
            61,
            35,
            36,
            48,
            49,
            57,
            58,
            62,
            63
        ], q = [
            0,
            0,
            1,
            5,
            1,
            1,
            1,
            1,
            1,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], T = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ], R = [
            0,
            0,
            2,
            1,
            3,
            3,
            2,
            4,
            3,
            5,
            5,
            4,
            4,
            0,
            0,
            1,
            125
        ], D = [
            1,
            2,
            3,
            0,
            4,
            17,
            5,
            18,
            33,
            49,
            65,
            6,
            19,
            81,
            97,
            7,
            34,
            113,
            20,
            50,
            129,
            145,
            161,
            8,
            35,
            66,
            177,
            193,
            21,
            82,
            209,
            240,
            36,
            51,
            98,
            114,
            130,
            9,
            10,
            22,
            23,
            24,
            25,
            26,
            37,
            38,
            39,
            40,
            41,
            42,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            131,
            132,
            133,
            134,
            135,
            136,
            137,
            138,
            146,
            147,
            148,
            149,
            150,
            151,
            152,
            153,
            154,
            162,
            163,
            164,
            165,
            166,
            167,
            168,
            169,
            170,
            178,
            179,
            180,
            181,
            182,
            183,
            184,
            185,
            186,
            194,
            195,
            196,
            197,
            198,
            199,
            200,
            201,
            202,
            210,
            211,
            212,
            213,
            214,
            215,
            216,
            217,
            218,
            225,
            226,
            227,
            228,
            229,
            230,
            231,
            232,
            233,
            234,
            241,
            242,
            243,
            244,
            245,
            246,
            247,
            248,
            249,
            250
        ], U = [
            0,
            0,
            3,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            0,
            0,
            0,
            0,
            0
        ], z = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ], H = [
            0,
            0,
            2,
            1,
            2,
            4,
            4,
            3,
            4,
            7,
            5,
            4,
            4,
            0,
            1,
            2,
            119
        ], W = [
            0,
            1,
            2,
            3,
            17,
            4,
            5,
            33,
            49,
            6,
            18,
            65,
            81,
            7,
            97,
            113,
            19,
            34,
            50,
            129,
            8,
            20,
            66,
            145,
            161,
            177,
            193,
            9,
            35,
            51,
            82,
            240,
            21,
            98,
            114,
            209,
            10,
            22,
            36,
            52,
            225,
            37,
            241,
            23,
            24,
            25,
            26,
            38,
            39,
            40,
            41,
            42,
            53,
            54,
            55,
            56,
            57,
            58,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            130,
            131,
            132,
            133,
            134,
            135,
            136,
            137,
            138,
            146,
            147,
            148,
            149,
            150,
            151,
            152,
            153,
            154,
            162,
            163,
            164,
            165,
            166,
            167,
            168,
            169,
            170,
            178,
            179,
            180,
            181,
            182,
            183,
            184,
            185,
            186,
            194,
            195,
            196,
            197,
            198,
            199,
            200,
            201,
            202,
            210,
            211,
            212,
            213,
            214,
            215,
            216,
            217,
            218,
            226,
            227,
            228,
            229,
            230,
            231,
            232,
            233,
            234,
            242,
            243,
            244,
            245,
            246,
            247,
            248,
            249,
            250
        ];
        function r(t, e) {
            for(var n = 0, r = 0, i = new Array, o = 1; o <= 16; o++){
                for(var a = 1; a <= t[o]; a++)i[e[r]] = [], i[e[r]][0] = n, i[e[r]][1] = o, r++, n++;
                n *= 2;
            }
            return i;
        }
        function V(t) {
            for(var e = t[0], n = t[1] - 1; 0 <= n;)e & 1 << n && (C |= 1 << B), n--, --B < 0 && (255 == C ? (G(255), G(0)) : G(C), B = 7, C = 0);
        }
        function G(t) {
            I.push(t);
        }
        function Y(t) {
            G(t >> 8 & 255), G(255 & t);
        }
        function J(t, e, n, r, i) {
            for(var o, a = i[0], s = i[240], l = function(t, e) {
                var n, r, i, o, a, s, l, h, u, c, f = 0;
                for(u = 0; u < 8; ++u){
                    n = t[f], r = t[f + 1], i = t[f + 2], o = t[f + 3], a = t[f + 4], s = t[f + 5], l = t[f + 6];
                    var p = n + (h = t[f + 7]), d = n - h, g = r + l, m = r - l, y = i + s, v = i - s, w = o + a, b = o - a, x = p + w, N = p - w, L = g + y, A = g - y;
                    t[f] = x + L, t[f + 4] = x - L;
                    var S = .707106781 * (A + N);
                    t[f + 2] = N + S, t[f + 6] = N - S;
                    var _ = .382683433 * ((x = b + v) - (A = m + d)), F = .5411961 * x + _, P = 1.306562965 * A + _, k = .707106781 * (L = v + m), I = d + k, C = d - k;
                    t[f + 5] = C + F, t[f + 3] = C - F, t[f + 1] = I + P, t[f + 7] = I - P, f += 8;
                }
                for(u = f = 0; u < 8; ++u){
                    n = t[f], r = t[f + 8], i = t[f + 16], o = t[f + 24], a = t[f + 32], s = t[f + 40], l = t[f + 48];
                    var B = n + (h = t[f + 56]), j = n - h, E = r + l, M = r - l, O = i + s, q = i - s, T = o + a, R = o - a, D = B + T, U = B - T, z = E + O, H = E - O;
                    t[f] = D + z, t[f + 32] = D - z;
                    var W = .707106781 * (H + U);
                    t[f + 16] = U + W, t[f + 48] = U - W;
                    var V = .382683433 * ((D = R + q) - (H = M + j)), G = .5411961 * D + V, Y = 1.306562965 * H + V, J = .707106781 * (z = q + M), X = j + J, K = j - J;
                    t[f + 40] = K + G, t[f + 24] = K - G, t[f + 8] = X + Y, t[f + 56] = X - Y, f++;
                }
                for(u = 0; u < 64; ++u)c = t[u] * e[u], Z[u] = 0 < c ? c + .5 | 0 : c - .5 | 0;
                return Z;
            }(t, e), h = 0; h < 64; ++h)w[b[h]] = l[h];
            var u = w[0] - n;
            n = w[0], 0 == u ? V(r[0]) : (V(r[v[o = 32767 + u]]), V(y[o]));
            for(var c = 63; 0 < c && 0 == w[c]; c--);
            if (0 == c) return V(a), n;
            for(var f, p = 1; p <= c;){
                for(var d = p; 0 == w[p] && p <= c; ++p);
                var g = p - d;
                if (16 <= g) {
                    f = g >> 4;
                    for(var m = 1; m <= f; ++m)V(s);
                    g &= 15;
                }
                o = 32767 + w[p], V(i[(g << 4) + v[o]]), V(y[o]), p++;
            }
            return 63 != c && V(a), n;
        }
        function X(t) {
            if (t <= 0 && (t = 1), 100 < t && (t = 100), e != t) (function(t) {
                for(var e = [
                    16,
                    11,
                    10,
                    16,
                    24,
                    40,
                    51,
                    61,
                    12,
                    12,
                    14,
                    19,
                    26,
                    58,
                    60,
                    55,
                    14,
                    13,
                    16,
                    24,
                    40,
                    57,
                    69,
                    56,
                    14,
                    17,
                    22,
                    29,
                    51,
                    87,
                    80,
                    62,
                    18,
                    22,
                    37,
                    56,
                    68,
                    109,
                    103,
                    77,
                    24,
                    35,
                    55,
                    64,
                    81,
                    104,
                    113,
                    92,
                    49,
                    64,
                    78,
                    87,
                    103,
                    121,
                    120,
                    101,
                    72,
                    92,
                    95,
                    98,
                    112,
                    100,
                    103,
                    99
                ], n = 0; n < 64; n++){
                    var r = c((e[n] * t + 50) / 100);
                    r < 1 ? r = 1 : 255 < r && (r = 255), _[b[n]] = r;
                }
                for(var i = [
                    17,
                    18,
                    24,
                    47,
                    99,
                    99,
                    99,
                    99,
                    18,
                    21,
                    26,
                    66,
                    99,
                    99,
                    99,
                    99,
                    24,
                    26,
                    56,
                    99,
                    99,
                    99,
                    99,
                    99,
                    47,
                    66,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99
                ], o = 0; o < 64; o++){
                    var a = c((i[o] * t + 50) / 100);
                    a < 1 ? a = 1 : 255 < a && (a = 255), F[b[o]] = a;
                }
                for(var s = [
                    1,
                    1.387039845,
                    1.306562965,
                    1.175875602,
                    1,
                    .785694958,
                    .5411961,
                    .275899379
                ], l = 0, h = 0; h < 8; h++)for(var u = 0; u < 8; u++)P[l] = 1 / (_[b[l]] * s[h] * s[u] * 8), k[l] = 1 / (F[b[l]] * s[h] * s[u] * 8), l++;
            })(t < 50 ? Math.floor(5e3 / t) : Math.floor(200 - 2 * t)), e = t;
        }
        this.encode = function(t, e) {
            var n, r;
            (new Date).getTime();
            e && X(e), I = new Array, C = 0, B = 7, Y(65496), Y(65504), Y(16), G(74), G(70), G(73), G(70), G(0), G(1), G(1), G(0), Y(1), Y(1), G(0), G(0), function() {
                Y(65499), Y(132), G(0);
                for(var t = 0; t < 64; t++)G(_[t]);
                G(1);
                for(var e = 0; e < 64; e++)G(F[e]);
            }(), n = t.width, r = t.height, Y(65472), Y(17), G(8), Y(r), Y(n), G(3), G(1), G(17), G(0), G(2), G(17), G(1), G(3), G(17), G(1), function() {
                Y(65476), Y(418), G(0);
                for(var t = 0; t < 16; t++)G(q[t + 1]);
                for(var e = 0; e <= 11; e++)G(T[e]);
                G(16);
                for(var n = 0; n < 16; n++)G(R[n + 1]);
                for(var r = 0; r <= 161; r++)G(D[r]);
                G(1);
                for(var i = 0; i < 16; i++)G(U[i + 1]);
                for(var o = 0; o <= 11; o++)G(z[o]);
                G(17);
                for(var a = 0; a < 16; a++)G(H[a + 1]);
                for(var s = 0; s <= 161; s++)G(W[s]);
            }(), Y(65498), Y(12), G(3), G(1), G(0), G(2), G(17), G(3), G(17), G(0), G(63), G(0);
            var i = 0, o = 0, a = 0;
            C = 0, B = 7, this.encode.displayName = "_encode_";
            for(var s, l, h, u, c, f, p, d, g, m = t.data, y = t.width, v = t.height, w = 4 * y, b = 0; b < v;){
                for(s = 0; s < w;){
                    for(f = c = w * b + s, p = -1, g = d = 0; g < 64; g++)f = c + (d = g >> 3) * w + (p = 4 * (7 & g)), v <= b + d && (f -= w * (b + 1 + d - v)), w <= s + p && (f -= s + p - w + 4), l = m[f++], h = m[f++], u = m[f++], j[g] = (O[l] + O[h + 256 >> 0] + O[u + 512 >> 0] >> 16) - 128, E[g] = (O[l + 768 >> 0] + O[h + 1024 >> 0] + O[u + 1280 >> 0] >> 16) - 128, M[g] = (O[l + 1280 >> 0] + O[h + 1536 >> 0] + O[u + 1792 >> 0] >> 16) - 128;
                    i = J(j, P, i, N, A), o = J(E, k, o, L, S), a = J(M, k, a, L, S), s += 32;
                }
                b += 8;
            }
            if (0 <= B) {
                var x = [];
                x[1] = B + 1, x[0] = (1 << B + 1) - 1, V(x);
            }
            return Y(65497), new Uint8Array(I);
        }, function() {
            (new Date).getTime();
            t || (t = 50), function() {
                for(var t = String.fromCharCode, e = 0; e < 256; e++)n[e] = t(e);
            }(), N = r(q, T), L = r(U, z), A = r(R, D), S = r(H, W), function() {
                for(var t = 1, e = 2, n = 1; n <= 15; n++){
                    for(var r = t; r < e; r++)v[32767 + r] = n, y[32767 + r] = [], y[32767 + r][1] = n, y[32767 + r][0] = r;
                    for(var i = -(e - 1); i <= -t; i++)v[32767 + i] = n, y[32767 + i] = [], y[32767 + i][1] = n, y[32767 + i][0] = e - 1 + i;
                    t <<= 1, e <<= 1;
                }
            }(), function() {
                for(var t = 0; t < 256; t++)O[t] = 19595 * t, O[t + 256 >> 0] = 38470 * t, O[t + 512 >> 0] = 7471 * t + 32768, O[t + 768 >> 0] = -11059 * t, O[t + 1024 >> 0] = -21709 * t, O[t + 1280 >> 0] = 32768 * t + 8421375, O[t + 1536 >> 0] = -27439 * t, O[t + 1792 >> 0] = -5329 * t;
            }(), X(t), (new Date).getTime();
        }();
    }
    function Ft(t, e) {
        if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, -1 === [
            "BM",
            "BA",
            "CI",
            "CP",
            "IC",
            "PT"
        ].indexOf(this.flag)) throw new Error("Invalid BMP File");
        this.parseHeader(), this.parseBGR();
    }
    window.tmp = At, lt.API.adler32cs = (dt = "function" == typeof ArrayBuffer && "function" == typeof Uint8Array, gt = null, mt = function() {
        if (!dt) return function() {
            return !1;
        };
        try {
            var t = {};
            "function" == typeof t.Buffer && (gt = t.Buffer);
        } catch (t) {}
        return function(t) {
            return t instanceof ArrayBuffer || null !== gt && t instanceof gt;
        };
    }(), yt = null !== gt ? function(t) {
        return new gt(t, "utf8").toString("binary");
    } : function(t) {
        return unescape(encodeURIComponent(t));
    }, vt = function(t, e) {
        for(var n = 65535 & t, r = t >>> 16, i = 0, o = e.length; i < o; i++)n = (n + (255 & e.charCodeAt(i))) % 65521, r = (r + n) % 65521;
        return (r << 16 | n) >>> 0;
    }, wt = function(t, e) {
        for(var n = 65535 & t, r = t >>> 16, i = 0, o = e.length; i < o; i++)n = (n + e[i]) % 65521, r = (r + n) % 65521;
        return (r << 16 | n) >>> 0;
    }, xt = (bt = {}).Adler32 = (((pt = (ft = function(t) {
        if (!(this instanceof ft)) throw new TypeError("Constructor cannot called be as a function.");
        if (!isFinite(t = null == t ? 1 : +t)) throw new Error("First arguments needs to be a finite number.");
        this.checksum = t >>> 0;
    }).prototype = {}).constructor = ft).from = ((ht = function(t) {
        if (!(this instanceof ft)) throw new TypeError("Constructor cannot called be as a function.");
        if (null == t) throw new Error("First argument needs to be a string.");
        this.checksum = vt(1, t.toString());
    }).prototype = pt, ht), ft.fromUtf8 = ((ut = function(t) {
        if (!(this instanceof ft)) throw new TypeError("Constructor cannot called be as a function.");
        if (null == t) throw new Error("First argument needs to be a string.");
        var e = yt(t.toString());
        this.checksum = vt(1, e);
    }).prototype = pt, ut), dt && (ft.fromBuffer = ((ct = function(t) {
        if (!(this instanceof ft)) throw new TypeError("Constructor cannot called be as a function.");
        if (!mt(t)) throw new Error("First argument needs to be ArrayBuffer.");
        var e = new Uint8Array(t);
        return this.checksum = wt(1, e);
    }).prototype = pt, ct)), pt.update = function(t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        return t = t.toString(), this.checksum = vt(this.checksum, t);
    }, pt.updateUtf8 = function(t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        var e = yt(t.toString());
        return this.checksum = vt(this.checksum, e);
    }, dt && (pt.updateBuffer = function(t) {
        if (!mt(t)) throw new Error("First argument needs to be ArrayBuffer.");
        var e = new Uint8Array(t);
        return this.checksum = wt(this.checksum, e);
    }), pt.clone = function() {
        return new xt(this.checksum);
    }, ft), bt.from = function(t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        return vt(1, t.toString());
    }, bt.fromUtf8 = function(t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        var e = yt(t.toString());
        return vt(1, e);
    }, dt && (bt.fromBuffer = function(t) {
        if (!mt(t)) throw new Error("First argument need to be ArrayBuffer.");
        var e = new Uint8Array(t);
        return wt(1, e);
    }), bt), function(t) {
        t.__bidiEngine__ = t.prototype.__bidiEngine__ = function(t) {
            var d, g, c, f, i, o, a, s = e, m = [
                [
                    0,
                    3,
                    0,
                    1,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    3,
                    0,
                    1,
                    2,
                    2,
                    0
                ],
                [
                    0,
                    3,
                    0,
                    17,
                    2,
                    0,
                    1
                ],
                [
                    0,
                    3,
                    5,
                    5,
                    4,
                    1,
                    0
                ],
                [
                    0,
                    3,
                    21,
                    21,
                    4,
                    0,
                    1
                ],
                [
                    0,
                    3,
                    5,
                    5,
                    4,
                    2,
                    0
                ]
            ], y = [
                [
                    2,
                    0,
                    1,
                    1,
                    0,
                    1,
                    0
                ],
                [
                    2,
                    0,
                    1,
                    1,
                    0,
                    2,
                    0
                ],
                [
                    2,
                    0,
                    2,
                    1,
                    3,
                    2,
                    0
                ],
                [
                    2,
                    0,
                    2,
                    33,
                    3,
                    1,
                    1
                ]
            ], v = {
                L: 0,
                R: 1,
                EN: 2,
                AN: 3,
                N: 4,
                B: 5,
                S: 6
            }, l = {
                0: 0,
                5: 1,
                6: 2,
                7: 3,
                32: 4,
                251: 5,
                254: 6,
                255: 7
            }, h = [
                "(",
                ")",
                "(",
                "<",
                ">",
                "<",
                "[",
                "]",
                "[",
                "{",
                "}",
                "{",
                "\xab",
                "\xbb",
                "\xab",
                "‹",
                "›",
                "‹",
                "⁅",
                "⁆",
                "⁅",
                "⁽",
                "⁾",
                "⁽",
                "₍",
                "₎",
                "₍",
                "≤",
                "≥",
                "≤",
                "〈",
                "〉",
                "〈",
                "﹙",
                "﹚",
                "﹙",
                "﹛",
                "﹜",
                "﹛",
                "﹝",
                "﹞",
                "﹝",
                "﹤",
                "﹥",
                "﹤"
            ], u = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), w = !1, b = 0;
            this.__bidiEngine__ = {};
            var x = function(t) {
                var e = t.charCodeAt(), n = e >> 8, r = l[n];
                return void 0 !== r ? s[256 * r + (255 & e)] : 252 === n || 253 === n ? "AL" : u.test(n) ? "L" : 8 === n ? "R" : "N";
            }, p = function(t) {
                for(var e, n = 0; n < t.length; n++){
                    if ("L" === (e = x(t.charAt(n)))) return !1;
                    if ("R" === e) return !0;
                }
                return !1;
            }, N = function(t, e, n, r) {
                var i, o, a, s, l = e[r];
                switch(l){
                    case "L":
                    case "R":
                        w = !1;
                        break;
                    case "N":
                    case "AN":
                        break;
                    case "EN":
                        w && (l = "AN");
                        break;
                    case "AL":
                        w = !0, l = "R";
                        break;
                    case "WS":
                        l = "N";
                        break;
                    case "CS":
                        r < 1 || r + 1 >= e.length || "EN" !== (i = n[r - 1]) && "AN" !== i || "EN" !== (o = e[r + 1]) && "AN" !== o ? l = "N" : w && (o = "AN"), l = o === i ? o : "N";
                        break;
                    case "ES":
                        l = "EN" === (i = 0 < r ? n[r - 1] : "B") && r + 1 < e.length && "EN" === e[r + 1] ? "EN" : "N";
                        break;
                    case "ET":
                        if (0 < r && "EN" === n[r - 1]) {
                            l = "EN";
                            break;
                        }
                        if (w) {
                            l = "N";
                            break;
                        }
                        for(a = r + 1, s = e.length; a < s && "ET" === e[a];)a++;
                        l = a < s && "EN" === e[a] ? "EN" : "N";
                        break;
                    case "NSM":
                        if (c && !f) {
                            for(s = e.length, a = r + 1; a < s && "NSM" === e[a];)a++;
                            if (a < s) {
                                var h = t[r], u = 1425 <= h && h <= 2303 || 64286 === h;
                                if (i = e[a], u && ("R" === i || "AL" === i)) {
                                    l = "R";
                                    break;
                                }
                            }
                        }
                        l = r < 1 || "B" === (i = e[r - 1]) ? "N" : n[r - 1];
                        break;
                    case "B":
                        d = (w = !1, true), l = b;
                        break;
                    case "S":
                        g = !0, l = "N";
                        break;
                    case "LRE":
                    case "RLE":
                    case "LRO":
                    case "RLO":
                    case "PDF":
                        w = !1;
                        break;
                    case "BN":
                        l = "N";
                }
                return l;
            }, L = function(t, e, n) {
                var r = t.split("");
                return n && A(r, n, {
                    hiLevel: b
                }), r.reverse(), e && e.reverse(), r.join("");
            }, A = function(t, e, n) {
                var r, i, o, a, s, l = -1, h = t.length, u = 0, c = [], f = b ? y : m, p = [];
                for(g = d = w = !1, i = 0; i < h; i++)p[i] = x(t[i]);
                for(o = 0; o < h; o++){
                    if (s = u, c[o] = N(t, p, c, o), r = 240 & (u = f[s][v[c[o]]]), u &= 15, e[o] = a = f[u][5], 0 < r) {
                        if (16 === r) {
                            for(i = l; i < o; i++)e[i] = 1;
                            l = -1;
                        } else l = -1;
                    }
                    if (f[u][6]) -1 === l && (l = o);
                    else if (-1 < l) {
                        for(i = l; i < o; i++)e[i] = a;
                        l = -1;
                    }
                    "B" === p[o] && (e[o] = 0), n.hiLevel |= a;
                }
                g && function(t, e, n) {
                    for(var r = 0; r < n; r++)if ("S" === t[r]) {
                        e[r] = b;
                        for(var i = r - 1; 0 <= i && "WS" === t[i]; i--)e[i] = b;
                    }
                }(p, e, h);
            }, S = function(t, e, n, r, i) {
                if (!(i.hiLevel < t)) {
                    if (1 === t && 1 === b && !d) return e.reverse(), void (n && n.reverse());
                    for(var o, a, s, l, h = e.length, u = 0; u < h;){
                        if (r[u] >= t) {
                            for(s = u + 1; s < h && r[s] >= t;)s++;
                            for(l = u, a = s - 1; l < a; l++, a--)o = e[l], e[l] = e[a], e[a] = o, n && (o = n[l], n[l] = n[a], n[a] = o);
                            u = s;
                        }
                        u++;
                    }
                }
            }, _ = function(t, e, n) {
                var r = t.split(""), i = {
                    hiLevel: b
                };
                return n || (n = []), A(r, n, i), function(t, e, n) {
                    if (0 !== n.hiLevel && a) for(var r, i = 0; i < t.length; i++)1 === e[i] && 0 <= (r = h.indexOf(t[i])) && (t[i] = h[r + 1]);
                }(r, n, i), S(2, r, e, n, i), S(1, r, e, n, i), r.join("");
            };
            return this.__bidiEngine__.doBidiReorder = function(t, e, n) {
                if (function(t, e) {
                    if (e) for(var n = 0; n < t.length; n++)e[n] = n;
                    void 0 === f && (f = p(t)), void 0 === o && (o = p(t));
                }(t, e), c || !i || o) {
                    if (c && i && f ^ o) b = f ? 1 : 0, t = L(t, e, n);
                    else if (!c && i && o) b = f ? 1 : 0, t = _(t, e, n), t = L(t, e);
                    else if (!c || f || i || o) {
                        if (c && !i && f ^ o) t = L(t, e), t = f ? (b = 0, _(t, e, n)) : (b = 1, t = _(t, e, n), L(t, e));
                        else if (c && f && !i && o) b = 1, t = _(t, e, n), t = L(t, e);
                        else if (!c && !i && f ^ o) {
                            var r = a;
                            f ? (b = 1, t = _(t, e, n), b = 0, a = !1, t = _(t, e, n), a = r) : (b = 0, t = _(t, e, n), t = L(t, e), a = (b = 1, false), t = _(t, e, n), a = r, t = L(t, e));
                        }
                    } else b = 0, t = _(t, e, n);
                } else b = f ? 1 : 0, t = _(t, e, n);
                return t;
            }, this.__bidiEngine__.setOptions = function(t) {
                t && (c = t.isInputVisual, i = t.isOutputVisual, f = t.isInputRtl, o = t.isOutputRtl, a = t.isSymmetricSwapping);
            }, this.__bidiEngine__.setOptions(t), this.__bidiEngine__;
        };
        var e = [
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "S",
            "B",
            "S",
            "WS",
            "B",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "B",
            "B",
            "B",
            "S",
            "WS",
            "N",
            "N",
            "ET",
            "ET",
            "ET",
            "N",
            "N",
            "N",
            "N",
            "N",
            "ES",
            "CS",
            "ES",
            "CS",
            "CS",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "CS",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "N",
            "N",
            "N",
            "N",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "B",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "CS",
            "N",
            "ET",
            "ET",
            "ET",
            "ET",
            "N",
            "N",
            "N",
            "N",
            "L",
            "N",
            "N",
            "BN",
            "N",
            "N",
            "ET",
            "ET",
            "EN",
            "EN",
            "N",
            "L",
            "N",
            "N",
            "N",
            "EN",
            "L",
            "N",
            "N",
            "N",
            "N",
            "N",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "N",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "N",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "N",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "N",
            "N",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "N",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "N",
            "L",
            "N",
            "N",
            "N",
            "N",
            "N",
            "ET",
            "N",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "R",
            "NSM",
            "R",
            "NSM",
            "NSM",
            "R",
            "NSM",
            "NSM",
            "R",
            "NSM",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "N",
            "N",
            "N",
            "N",
            "N",
            "R",
            "R",
            "R",
            "R",
            "R",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "AN",
            "AN",
            "AN",
            "AN",
            "AN",
            "AN",
            "N",
            "N",
            "AL",
            "ET",
            "ET",
            "AL",
            "CS",
            "AL",
            "N",
            "N",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "AL",
            "AL",
            "N",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "AN",
            "AN",
            "AN",
            "AN",
            "AN",
            "AN",
            "AN",
            "AN",
            "AN",
            "AN",
            "ET",
            "AN",
            "AN",
            "AL",
            "AL",
            "AL",
            "NSM",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "AN",
            "N",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "AL",
            "AL",
            "NSM",
            "NSM",
            "N",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "AL",
            "AL",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "N",
            "AL",
            "AL",
            "NSM",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "N",
            "N",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "AL",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "R",
            "R",
            "N",
            "N",
            "N",
            "N",
            "R",
            "N",
            "N",
            "N",
            "N",
            "N",
            "WS",
            "WS",
            "WS",
            "WS",
            "WS",
            "WS",
            "WS",
            "WS",
            "WS",
            "WS",
            "WS",
            "BN",
            "BN",
            "BN",
            "L",
            "R",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "WS",
            "B",
            "LRE",
            "RLE",
            "PDF",
            "LRO",
            "RLO",
            "CS",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "CS",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "WS",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "N",
            "LRI",
            "RLI",
            "FSI",
            "PDI",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "BN",
            "EN",
            "L",
            "N",
            "N",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "ES",
            "ES",
            "N",
            "N",
            "N",
            "L",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "ES",
            "ES",
            "N",
            "N",
            "N",
            "N",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "N",
            "N",
            "N",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "ET",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "L",
            "L",
            "L",
            "L",
            "L",
            "N",
            "N",
            "N",
            "N",
            "N",
            "R",
            "NSM",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "ES",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "N",
            "R",
            "R",
            "R",
            "R",
            "R",
            "N",
            "R",
            "N",
            "R",
            "R",
            "N",
            "R",
            "R",
            "N",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "R",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "NSM",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "CS",
            "N",
            "CS",
            "N",
            "N",
            "CS",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "ET",
            "N",
            "N",
            "ES",
            "ES",
            "N",
            "N",
            "N",
            "N",
            "N",
            "ET",
            "ET",
            "N",
            "N",
            "N",
            "N",
            "N",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "N",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "AL",
            "N",
            "N",
            "BN",
            "N",
            "N",
            "N",
            "ET",
            "ET",
            "ET",
            "N",
            "N",
            "N",
            "N",
            "N",
            "ES",
            "CS",
            "ES",
            "CS",
            "CS",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "EN",
            "CS",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "N",
            "N",
            "N",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "N",
            "N",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "N",
            "N",
            "L",
            "L",
            "L",
            "L",
            "L",
            "L",
            "N",
            "N",
            "L",
            "L",
            "L",
            "N",
            "N",
            "N",
            "ET",
            "ET",
            "N",
            "N",
            "N",
            "ET",
            "ET",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N",
            "N"
        ], o = new t.__bidiEngine__({
            isInputVisual: !0
        });
        t.API.events.push([
            "postProcessText",
            function(t) {
                var e = t.text, n = (t.x, t.y, t.options || {}), r = (t.mutex, n.lang, []);
                if ("[object Array]" === Object.prototype.toString.call(e)) {
                    var i = 0;
                    for(r = [], i = 0; i < e.length; i += 1)"[object Array]" === Object.prototype.toString.call(e[i]) ? r.push([
                        o.doBidiReorder(e[i][0]),
                        e[i][1],
                        e[i][2]
                    ]) : r.push([
                        o.doBidiReorder(e[i])
                    ]);
                    t.text = r;
                } else t.text = o.doBidiReorder(e);
            }
        ]);
    }(lt), window.tmp = _t, Ft.prototype.parseHeader = function() {
        if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, 16 === this.bitPP && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
            var t = 0 === this.colors ? 1 << this.bitPP : this.colors;
            this.palette = new Array(t);
            for(var e = 0; e < t; e++){
                var n = this.datav.getUint8(this.pos++, !0), r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0);
                this.palette[e] = {
                    red: i,
                    green: r,
                    blue: n,
                    quad: o
                };
            }
        }
        this.height < 0 && (this.height *= -1, this.bottom_up = !1);
    }, Ft.prototype.parseBGR = function() {
        this.pos = this.offset;
        try {
            var t = "bit" + this.bitPP, e = this.width * this.height * 4;
            this.data = new Uint8Array(e), this[t]();
        } catch (t) {
            console.log("bit decode error:" + t);
        }
    }, Ft.prototype.bit1 = function() {
        var t = Math.ceil(this.width / 8), e = t % 4, n = 0 <= this.height ? this.height - 1 : -this.height;
        for(n = this.height - 1; 0 <= n; n--){
            for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < t; i++)for(var o = this.datav.getUint8(this.pos++, !0), a = r * this.width * 4 + 8 * i * 4, s = 0; s < 8 && 8 * i + s < this.width; s++){
                var l = this.palette[o >> 7 - s & 1];
                this.data[a + 4 * s] = l.blue, this.data[a + 4 * s + 1] = l.green, this.data[a + 4 * s + 2] = l.red, this.data[a + 4 * s + 3] = 255;
            }
            0 != e && (this.pos += 4 - e);
        }
    }, Ft.prototype.bit4 = function() {
        for(var t = Math.ceil(this.width / 2), e = t % 4, n = this.height - 1; 0 <= n; n--){
            for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < t; i++){
                var o = this.datav.getUint8(this.pos++, !0), a = r * this.width * 4 + 2 * i * 4, s = o >> 4, l = 15 & o, h = this.palette[s];
                if (this.data[a] = h.blue, this.data[a + 1] = h.green, this.data[a + 2] = h.red, this.data[a + 3] = 255, 2 * i + 1 >= this.width) break;
                h = this.palette[l], this.data[a + 4] = h.blue, this.data[a + 4 + 1] = h.green, this.data[a + 4 + 2] = h.red, this.data[a + 4 + 3] = 255;
            }
            0 != e && (this.pos += 4 - e);
        }
    }, Ft.prototype.bit8 = function() {
        for(var t = this.width % 4, e = this.height - 1; 0 <= e; e--){
            for(var n = this.bottom_up ? e : this.height - 1 - e, r = 0; r < this.width; r++){
                var i = this.datav.getUint8(this.pos++, !0), o = n * this.width * 4 + 4 * r;
                if (i < this.palette.length) {
                    var a = this.palette[i];
                    this.data[o] = a.red, this.data[o + 1] = a.green, this.data[o + 2] = a.blue, this.data[o + 3] = 255;
                } else this.data[o] = 255, this.data[o + 1] = 255, this.data[o + 2] = 255, this.data[o + 3] = 255;
            }
            0 != t && (this.pos += 4 - t);
        }
    }, Ft.prototype.bit15 = function() {
        for(var t = this.width % 3, e = parseInt("11111", 2), n = this.height - 1; 0 <= n; n--){
            for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < this.width; i++){
                var o = this.datav.getUint16(this.pos, !0);
                this.pos += 2;
                var a = (o & e) / e * 255 | 0, s = (o >> 5 & e) / e * 255 | 0, l = (o >> 10 & e) / e * 255 | 0, h = o >> 15 ? 255 : 0, u = r * this.width * 4 + 4 * i;
                this.data[u] = l, this.data[u + 1] = s, this.data[u + 2] = a, this.data[u + 3] = h;
            }
            this.pos += t;
        }
    }, Ft.prototype.bit16 = function() {
        for(var t = this.width % 3, e = parseInt("11111", 2), n = parseInt("111111", 2), r = this.height - 1; 0 <= r; r--){
            for(var i = this.bottom_up ? r : this.height - 1 - r, o = 0; o < this.width; o++){
                var a = this.datav.getUint16(this.pos, !0);
                this.pos += 2;
                var s = (a & e) / e * 255 | 0, l = (a >> 5 & n) / n * 255 | 0, h = (a >> 11) / e * 255 | 0, u = i * this.width * 4 + 4 * o;
                this.data[u] = h, this.data[u + 1] = l, this.data[u + 2] = s, this.data[u + 3] = 255;
            }
            this.pos += t;
        }
    }, Ft.prototype.bit24 = function() {
        for(var t = this.height - 1; 0 <= t; t--){
            for(var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++){
                var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), a = e * this.width * 4 + 4 * n;
                this.data[a] = o, this.data[a + 1] = i, this.data[a + 2] = r, this.data[a + 3] = 255;
            }
            this.pos += this.width % 4;
        }
    }, Ft.prototype.bit32 = function() {
        for(var t = this.height - 1; 0 <= t; t--)for(var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++){
            var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), s = e * this.width * 4 + 4 * n;
            this.data[s] = o, this.data[s + 1] = i, this.data[s + 2] = r, this.data[s + 3] = a;
        }
    }, Ft.prototype.getData = function() {
        return this.data;
    }, window.tmp = Ft, /*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */ function(t) {
        var d = 15, g = 573, e = [
            0,
            1,
            2,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            6,
            6,
            7,
            7,
            7,
            7,
            8,
            8,
            8,
            8,
            8,
            8,
            8,
            8,
            9,
            9,
            9,
            9,
            9,
            9,
            9,
            9,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            0,
            0,
            16,
            17,
            18,
            18,
            19,
            19,
            20,
            20,
            20,
            20,
            21,
            21,
            21,
            21,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29
        ];
        function ct() {
            var p = this;
            function l(t, e) {
                for(var n = 0; n |= 1 & t, t >>>= 1, n <<= 1, 0 < --e;);
                return n >>> 1;
            }
            p.build_tree = function(t) {
                var e, n, r, i = p.dyn_tree, o = p.stat_desc.static_tree, a = p.stat_desc.elems, s = -1;
                for(t.heap_len = 0, t.heap_max = g, e = 0; e < a; e++)0 !== i[2 * e] ? (t.heap[++t.heap_len] = s = e, t.depth[e] = 0) : i[2 * e + 1] = 0;
                for(; t.heap_len < 2;)i[2 * (r = t.heap[++t.heap_len] = s < 2 ? ++s : 0)] = 1, t.depth[r] = 0, t.opt_len--, o && (t.static_len -= o[2 * r + 1]);
                for(p.max_code = s, e = Math.floor(t.heap_len / 2); 1 <= e; e--)t.pqdownheap(i, e);
                for(r = a; e = t.heap[1], t.heap[1] = t.heap[t.heap_len--], t.pqdownheap(i, 1), n = t.heap[1], t.heap[--t.heap_max] = e, t.heap[--t.heap_max] = n, i[2 * r] = i[2 * e] + i[2 * n], t.depth[r] = Math.max(t.depth[e], t.depth[n]) + 1, i[2 * e + 1] = i[2 * n + 1] = r, t.heap[1] = r++, t.pqdownheap(i, 1), 2 <= t.heap_len;);
                t.heap[--t.heap_max] = t.heap[1], function(t) {
                    var e, n, r, i, o, a, s = p.dyn_tree, l = p.stat_desc.static_tree, h = p.stat_desc.extra_bits, u = p.stat_desc.extra_base, c = p.stat_desc.max_length, f = 0;
                    for(i = 0; i <= d; i++)t.bl_count[i] = 0;
                    for(s[2 * t.heap[t.heap_max] + 1] = 0, e = t.heap_max + 1; e < g; e++)c < (i = s[2 * s[2 * (n = t.heap[e]) + 1] + 1] + 1) && (i = c, f++), s[2 * n + 1] = i, n > p.max_code || (t.bl_count[i]++, o = 0, u <= n && (o = h[n - u]), a = s[2 * n], t.opt_len += a * (i + o), l && (t.static_len += a * (l[2 * n + 1] + o)));
                    if (0 !== f) {
                        do {
                            for(i = c - 1; 0 === t.bl_count[i];)i--;
                            t.bl_count[i]--, t.bl_count[i + 1] += 2, t.bl_count[c]--, f -= 2;
                        }while (0 < f);
                        for(i = c; 0 !== i; i--)for(n = t.bl_count[i]; 0 !== n;)(r = t.heap[--e]) > p.max_code || (s[2 * r + 1] != i && (t.opt_len += (i - s[2 * r + 1]) * s[2 * r], s[2 * r + 1] = i), n--);
                    }
                }(t), function(t, e, n) {
                    var r, i, o, a = [], s = 0;
                    for(r = 1; r <= d; r++)a[r] = s = s + n[r - 1] << 1;
                    for(i = 0; i <= e; i++)0 !== (o = t[2 * i + 1]) && (t[2 * i] = l(a[o]++, o));
                }(i, p.max_code, t.bl_count);
            };
        }
        function ft(t, e, n, r, i) {
            this.static_tree = t, this.extra_bits = e, this.extra_base = n, this.elems = r, this.max_length = i;
        }
        ct._length_code = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            12,
            12,
            13,
            13,
            13,
            13,
            14,
            14,
            14,
            14,
            15,
            15,
            15,
            15,
            16,
            16,
            16,
            16,
            16,
            16,
            16,
            16,
            17,
            17,
            17,
            17,
            17,
            17,
            17,
            17,
            18,
            18,
            18,
            18,
            18,
            18,
            18,
            18,
            19,
            19,
            19,
            19,
            19,
            19,
            19,
            19,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            28
        ], ct.base_length = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            10,
            12,
            14,
            16,
            20,
            24,
            28,
            32,
            40,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            160,
            192,
            224,
            0
        ], ct.base_dist = [
            0,
            1,
            2,
            3,
            4,
            6,
            8,
            12,
            16,
            24,
            32,
            48,
            64,
            96,
            128,
            192,
            256,
            384,
            512,
            768,
            1024,
            1536,
            2048,
            3072,
            4096,
            6144,
            8192,
            12288,
            16384,
            24576
        ], ct.d_code = function(t) {
            return t < 256 ? e[t] : e[256 + (t >>> 7)];
        }, ct.extra_lbits = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0
        ], ct.extra_dbits = [
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13
        ], ct.extra_blbits = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2,
            3,
            7
        ], ct.bl_order = [
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ], ft.static_ltree = [
            12,
            8,
            140,
            8,
            76,
            8,
            204,
            8,
            44,
            8,
            172,
            8,
            108,
            8,
            236,
            8,
            28,
            8,
            156,
            8,
            92,
            8,
            220,
            8,
            60,
            8,
            188,
            8,
            124,
            8,
            252,
            8,
            2,
            8,
            130,
            8,
            66,
            8,
            194,
            8,
            34,
            8,
            162,
            8,
            98,
            8,
            226,
            8,
            18,
            8,
            146,
            8,
            82,
            8,
            210,
            8,
            50,
            8,
            178,
            8,
            114,
            8,
            242,
            8,
            10,
            8,
            138,
            8,
            74,
            8,
            202,
            8,
            42,
            8,
            170,
            8,
            106,
            8,
            234,
            8,
            26,
            8,
            154,
            8,
            90,
            8,
            218,
            8,
            58,
            8,
            186,
            8,
            122,
            8,
            250,
            8,
            6,
            8,
            134,
            8,
            70,
            8,
            198,
            8,
            38,
            8,
            166,
            8,
            102,
            8,
            230,
            8,
            22,
            8,
            150,
            8,
            86,
            8,
            214,
            8,
            54,
            8,
            182,
            8,
            118,
            8,
            246,
            8,
            14,
            8,
            142,
            8,
            78,
            8,
            206,
            8,
            46,
            8,
            174,
            8,
            110,
            8,
            238,
            8,
            30,
            8,
            158,
            8,
            94,
            8,
            222,
            8,
            62,
            8,
            190,
            8,
            126,
            8,
            254,
            8,
            1,
            8,
            129,
            8,
            65,
            8,
            193,
            8,
            33,
            8,
            161,
            8,
            97,
            8,
            225,
            8,
            17,
            8,
            145,
            8,
            81,
            8,
            209,
            8,
            49,
            8,
            177,
            8,
            113,
            8,
            241,
            8,
            9,
            8,
            137,
            8,
            73,
            8,
            201,
            8,
            41,
            8,
            169,
            8,
            105,
            8,
            233,
            8,
            25,
            8,
            153,
            8,
            89,
            8,
            217,
            8,
            57,
            8,
            185,
            8,
            121,
            8,
            249,
            8,
            5,
            8,
            133,
            8,
            69,
            8,
            197,
            8,
            37,
            8,
            165,
            8,
            101,
            8,
            229,
            8,
            21,
            8,
            149,
            8,
            85,
            8,
            213,
            8,
            53,
            8,
            181,
            8,
            117,
            8,
            245,
            8,
            13,
            8,
            141,
            8,
            77,
            8,
            205,
            8,
            45,
            8,
            173,
            8,
            109,
            8,
            237,
            8,
            29,
            8,
            157,
            8,
            93,
            8,
            221,
            8,
            61,
            8,
            189,
            8,
            125,
            8,
            253,
            8,
            19,
            9,
            275,
            9,
            147,
            9,
            403,
            9,
            83,
            9,
            339,
            9,
            211,
            9,
            467,
            9,
            51,
            9,
            307,
            9,
            179,
            9,
            435,
            9,
            115,
            9,
            371,
            9,
            243,
            9,
            499,
            9,
            11,
            9,
            267,
            9,
            139,
            9,
            395,
            9,
            75,
            9,
            331,
            9,
            203,
            9,
            459,
            9,
            43,
            9,
            299,
            9,
            171,
            9,
            427,
            9,
            107,
            9,
            363,
            9,
            235,
            9,
            491,
            9,
            27,
            9,
            283,
            9,
            155,
            9,
            411,
            9,
            91,
            9,
            347,
            9,
            219,
            9,
            475,
            9,
            59,
            9,
            315,
            9,
            187,
            9,
            443,
            9,
            123,
            9,
            379,
            9,
            251,
            9,
            507,
            9,
            7,
            9,
            263,
            9,
            135,
            9,
            391,
            9,
            71,
            9,
            327,
            9,
            199,
            9,
            455,
            9,
            39,
            9,
            295,
            9,
            167,
            9,
            423,
            9,
            103,
            9,
            359,
            9,
            231,
            9,
            487,
            9,
            23,
            9,
            279,
            9,
            151,
            9,
            407,
            9,
            87,
            9,
            343,
            9,
            215,
            9,
            471,
            9,
            55,
            9,
            311,
            9,
            183,
            9,
            439,
            9,
            119,
            9,
            375,
            9,
            247,
            9,
            503,
            9,
            15,
            9,
            271,
            9,
            143,
            9,
            399,
            9,
            79,
            9,
            335,
            9,
            207,
            9,
            463,
            9,
            47,
            9,
            303,
            9,
            175,
            9,
            431,
            9,
            111,
            9,
            367,
            9,
            239,
            9,
            495,
            9,
            31,
            9,
            287,
            9,
            159,
            9,
            415,
            9,
            95,
            9,
            351,
            9,
            223,
            9,
            479,
            9,
            63,
            9,
            319,
            9,
            191,
            9,
            447,
            9,
            127,
            9,
            383,
            9,
            255,
            9,
            511,
            9,
            0,
            7,
            64,
            7,
            32,
            7,
            96,
            7,
            16,
            7,
            80,
            7,
            48,
            7,
            112,
            7,
            8,
            7,
            72,
            7,
            40,
            7,
            104,
            7,
            24,
            7,
            88,
            7,
            56,
            7,
            120,
            7,
            4,
            7,
            68,
            7,
            36,
            7,
            100,
            7,
            20,
            7,
            84,
            7,
            52,
            7,
            116,
            7,
            3,
            8,
            131,
            8,
            67,
            8,
            195,
            8,
            35,
            8,
            163,
            8,
            99,
            8,
            227,
            8
        ], ft.static_dtree = [
            0,
            5,
            16,
            5,
            8,
            5,
            24,
            5,
            4,
            5,
            20,
            5,
            12,
            5,
            28,
            5,
            2,
            5,
            18,
            5,
            10,
            5,
            26,
            5,
            6,
            5,
            22,
            5,
            14,
            5,
            30,
            5,
            1,
            5,
            17,
            5,
            9,
            5,
            25,
            5,
            5,
            5,
            21,
            5,
            13,
            5,
            29,
            5,
            3,
            5,
            19,
            5,
            11,
            5,
            27,
            5,
            7,
            5,
            23,
            5
        ], ft.static_l_desc = new ft(ft.static_ltree, ct.extra_lbits, 257, 286, d), ft.static_d_desc = new ft(ft.static_dtree, ct.extra_dbits, 0, 30, d), ft.static_bl_desc = new ft(null, ct.extra_blbits, 0, 19, 7);
        function n(t, e, n, r, i) {
            this.good_length = t, this.max_lazy = e, this.nice_length = n, this.max_chain = r, this.func = i;
        }
        var pt = [
            new n(0, 0, 0, 0, 0),
            new n(4, 4, 8, 4, 1),
            new n(4, 5, 16, 8, 1),
            new n(4, 6, 32, 32, 1),
            new n(4, 4, 16, 16, 2),
            new n(8, 16, 32, 32, 2),
            new n(8, 16, 128, 128, 2),
            new n(8, 32, 128, 256, 2),
            new n(32, 128, 258, 1024, 2),
            new n(32, 258, 258, 4096, 2)
        ], dt = [
            "need dictionary",
            "stream end",
            "",
            "",
            "stream error",
            "data error",
            "",
            "buffer error",
            "",
            ""
        ];
        function gt(t, e, n, r) {
            var i = t[2 * e], o = t[2 * n];
            return i < o || i == o && r[e] <= r[n];
        }
        function r() {
            var l, h, u, c, f, p, d, g, i, m, y, v, w, a, b, x, N, L, A, S, _, F, P, k, I, C, B, j, E, M, s, O, q, T, R, D, U, o, z, H, W, V = this, G = new ct, Y = new ct, J = new ct;
            function X() {
                var t;
                for(t = 0; t < 286; t++)s[2 * t] = 0;
                for(t = 0; t < 30; t++)O[2 * t] = 0;
                for(t = 0; t < 19; t++)q[2 * t] = 0;
                s[512] = 1, V.opt_len = V.static_len = 0, D = o = 0;
            }
            function K(t, e) {
                var n, r, i = -1, o = t[1], a = 0, s = 7, l = 4;
                for(0 === o && (s = 138, l = 3), t[2 * (e + 1) + 1] = 65535, n = 0; n <= e; n++)r = o, o = t[2 * (n + 1) + 1], ++a < s && r == o || (a < l ? q[2 * r] += a : 0 !== r ? (r != i && q[2 * r]++, q[32]++) : a <= 10 ? q[34]++ : q[36]++, i = r, l = (a = 0) === o ? (s = 138, 3) : r == o ? (s = 6, 3) : (s = 7, 4));
            }
            function Z(t) {
                V.pending_buf[V.pending++] = t;
            }
            function Q(t) {
                Z(255 & t), Z(t >>> 8 & 255);
            }
            function $(t, e) {
                var n, r = e;
                16 - r < W ? (Q(H |= (n = t) << W & 65535), H = n >>> 16 - W, W += r - 16) : (H |= t << W & 65535, W += r);
            }
            function tt(t, e) {
                var n = 2 * t;
                $(65535 & e[n], 65535 & e[n + 1]);
            }
            function et(t, e) {
                var n, r, i = -1, o = t[1], a = 0, s = 7, l = 4;
                for(0 === o && (s = 138, l = 3), n = 0; n <= e; n++)if (r = o, o = t[2 * (n + 1) + 1], !(++a < s && r == o)) {
                    if (a < l) for(; tt(r, q), 0 != --a;);
                    else 0 !== r ? (r != i && (tt(r, q), a--), tt(16, q), $(a - 3, 2)) : a <= 10 ? (tt(17, q), $(a - 3, 3)) : (tt(18, q), $(a - 11, 7));
                    i = r, l = (a = 0) === o ? (s = 138, 3) : r == o ? (s = 6, 3) : (s = 7, 4);
                }
            }
            function nt() {
                16 == W ? (Q(H), W = H = 0) : 8 <= W && (Z(255 & H), H >>>= 8, W -= 8);
            }
            function rt(t, e) {
                var n, r, i;
                if (V.pending_buf[U + 2 * D] = t >>> 8 & 255, V.pending_buf[U + 2 * D + 1] = 255 & t, V.pending_buf[T + D] = 255 & e, D++, 0 === t ? s[2 * e]++ : (o++, t--, s[2 * (ct._length_code[e] + 256 + 1)]++, O[2 * ct.d_code(t)]++), 0 == (8191 & D) && 2 < B) {
                    for(n = 8 * D, r = _ - N, i = 0; i < 30; i++)n += O[2 * i] * (5 + ct.extra_dbits[i]);
                    if (n >>>= 3, o < Math.floor(D / 2) && n < Math.floor(r / 2)) return !0;
                }
                return D == R - 1;
            }
            function it(t, e) {
                var n, r, i, o, a = 0;
                if (0 !== D) for(; n = V.pending_buf[U + 2 * a] << 8 & 65280 | 255 & V.pending_buf[U + 2 * a + 1], r = 255 & V.pending_buf[T + a], a++, 0 === n ? tt(r, t) : (tt((i = ct._length_code[r]) + 256 + 1, t), 0 !== (o = ct.extra_lbits[i]) && $(r -= ct.base_length[i], o), tt(i = ct.d_code(--n), e), 0 !== (o = ct.extra_dbits[i]) && $(n -= ct.base_dist[i], o)), a < D;);
                tt(256, t), z = t[513];
            }
            function ot() {
                8 < W ? Q(H) : 0 < W && Z(255 & H), W = H = 0;
            }
            function at(t, e, n) {
                var r, i, o;
                $(0 + (n ? 1 : 0), 3), r = t, i = e, o = !0, ot(), z = 8, o && (Q(i), Q(~i)), V.pending_buf.set(g.subarray(r, r + i), V.pending), V.pending += i;
            }
            function e(t, e, n) {
                var r, i, o = 0;
                0 < B ? (G.build_tree(V), Y.build_tree(V), o = function() {
                    var t;
                    for(K(s, G.max_code), K(O, Y.max_code), J.build_tree(V), t = 18; 3 <= t && 0 === q[2 * ct.bl_order[t] + 1]; t--);
                    return V.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                }(), r = V.opt_len + 3 + 7 >>> 3, (i = V.static_len + 3 + 7 >>> 3) <= r && (r = i)) : r = i = e + 5, e + 4 <= r && -1 != t ? at(t, e, n) : i == r ? ($(2 + (n ? 1 : 0), 3), it(ft.static_ltree, ft.static_dtree)) : ($(4 + (n ? 1 : 0), 3), function(t, e, n) {
                    var r;
                    for($(t - 257, 5), $(e - 1, 5), $(n - 4, 4), r = 0; r < n; r++)$(q[2 * ct.bl_order[r] + 1], 3);
                    et(s, t - 1), et(O, e - 1);
                }(G.max_code + 1, Y.max_code + 1, o + 1), it(s, O)), X(), n && ot();
            }
            function st(t) {
                e(0 <= N ? N : -1, _ - N, t), N = _, l.flush_pending();
            }
            function lt() {
                var t, e, n, r;
                do {
                    if (0 === (r = i - P - _) && 0 === _ && 0 === P) r = f;
                    else if (-1 == r) r--;
                    else if (f + f - 262 <= _) {
                        for(g.set(g.subarray(f, f + f), 0), F -= f, _ -= f, N -= f, n = t = w; e = 65535 & y[--n], y[n] = f <= e ? e - f : 0, 0 != --t;);
                        for(n = t = f; e = 65535 & m[--n], m[n] = f <= e ? e - f : 0, 0 != --t;);
                        r += f;
                    }
                    if (0 === l.avail_in) return;
                    t = l.read_buf(g, _ + P, r), 3 <= (P += t) && (v = ((v = 255 & g[_]) << x ^ 255 & g[_ + 1]) & b);
                }while (P < 262 && 0 !== l.avail_in);
            }
            function ht(t) {
                var e, n, r = I, i = _, o = k, a = f - 262 < _ ? _ - (f - 262) : 0, s = M, l = d, h = _ + 258, u = g[i + o - 1], c = g[i + o];
                E <= k && (r >>= 2), P < s && (s = P);
                do if (g[(e = t) + o] == c && g[e + o - 1] == u && g[e] == g[i] && g[++e] == g[i + 1]) {
                    i += 2, e++;
                    do ;
                    while (g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && i < h);
                    if (n = 258 - (h - i), i = h - 258, o < n) {
                        if (F = t, s <= (o = n)) break;
                        u = g[i + o - 1], c = g[i + o];
                    }
                }
                while ((t = 65535 & m[t & l]) > a && 0 != --r);
                return o <= P ? o : P;
            }
            function ut(t) {
                return t.total_in = t.total_out = 0, t.msg = null, V.pending = 0, V.pending_out = 0, h = 113, c = 0, G.dyn_tree = s, G.stat_desc = ft.static_l_desc, Y.dyn_tree = O, Y.stat_desc = ft.static_d_desc, J.dyn_tree = q, J.stat_desc = ft.static_bl_desc, W = H = 0, z = 8, X(), function() {
                    var t;
                    for(i = 2 * f, t = y[w - 1] = 0; t < w - 1; t++)y[t] = 0;
                    C = pt[B].max_lazy, E = pt[B].good_length, M = pt[B].nice_length, I = pt[B].max_chain, L = k = 2, v = S = P = N = _ = 0;
                }(), 0;
            }
            V.depth = [], V.bl_count = [], V.heap = [], s = [], O = [], q = [], V.pqdownheap = function(t, e) {
                for(var n = V.heap, r = n[e], i = e << 1; i <= V.heap_len && (i < V.heap_len && gt(t, n[i + 1], n[i], V.depth) && i++, !gt(t, r, n[i], V.depth));)n[e] = n[i], e = i, i <<= 1;
                n[e] = r;
            }, V.deflateInit = function(t, e, n, r, i, o) {
                return r || (r = 8), i || (i = 8), o || (o = 0), t.msg = null, -1 == e && (e = 6), i < 1 || 9 < i || 8 != r || n < 9 || 15 < n || e < 0 || 9 < e || o < 0 || 2 < o ? -2 : (t.dstate = V, d = (f = 1 << (p = n)) - 1, b = (w = 1 << (a = i + 7)) - 1, x = Math.floor((a + 3 - 1) / 3), g = new Uint8Array(2 * f), m = [], y = [], R = 1 << i + 6, V.pending_buf = new Uint8Array(4 * R), u = 4 * R, U = Math.floor(R / 2), T = 3 * R, B = e, j = o, ut(t));
            }, V.deflateEnd = function() {
                return 42 != h && 113 != h && 666 != h ? -2 : (V.pending_buf = null, g = m = y = null, V.dstate = null, 113 == h ? -3 : 0);
            }, V.deflateParams = function(t, e, n) {
                var r = 0;
                return -1 == e && (e = 6), e < 0 || 9 < e || n < 0 || 2 < n ? -2 : (pt[B].func != pt[e].func && 0 !== t.total_in && (r = t.deflate(1)), B != e && (C = pt[B = e].max_lazy, E = pt[B].good_length, M = pt[B].nice_length, I = pt[B].max_chain), j = n, r);
            }, V.deflateSetDictionary = function(t, e, n) {
                var r, i = n, o = 0;
                if (!e || 42 != h) return -2;
                if (i < 3) return 0;
                for(f - 262 < i && (o = n - (i = f - 262)), g.set(e.subarray(o, o + i), 0), N = _ = i, v = ((v = 255 & g[0]) << x ^ 255 & g[1]) & b, r = 0; r <= i - 3; r++)v = (v << x ^ 255 & g[r + 2]) & b, m[r & d] = y[v], y[v] = r;
                return 0;
            }, V.deflate = function(t, e) {
                var n, r, i, o, a, s;
                if (4 < e || e < 0) return -2;
                if (!t.next_out || !t.next_in && 0 !== t.avail_in || 666 == h && 4 != e) return t.msg = dt[4], -2;
                if (0 === t.avail_out) return t.msg = dt[7], -5;
                if (l = t, o = c, c = e, 42 == h && (r = 8 + (p - 8 << 4) << 8, 3 < (i = (B - 1 & 255) >> 1) && (i = 3), r |= i << 6, 0 !== _ && (r |= 32), h = 113, Z((s = r += 31 - r % 31) >> 8 & 255), Z(255 & s)), 0 !== V.pending) {
                    if (l.flush_pending(), 0 === l.avail_out) return c = -1, 0;
                } else if (0 === l.avail_in && e <= o && 4 != e) return l.msg = dt[7], -5;
                if (666 == h && 0 !== l.avail_in) return t.msg = dt[7], -5;
                if (0 !== l.avail_in || 0 !== P || 0 != e && 666 != h) {
                    switch(a = -1, pt[B].func){
                        case 0:
                            a = function(t) {
                                var e, n = 65535;
                                for(u - 5 < n && (n = u - 5);;){
                                    if (P <= 1) {
                                        if (lt(), 0 === P && 0 == t) return 0;
                                        if (0 === P) break;
                                    }
                                    if (_ += P, e = N + n, ((P = 0) === _ || e <= _) && (P = _ - e, _ = e, st(!1), 0 === l.avail_out)) return 0;
                                    if (f - 262 <= _ - N && (st(!1), 0 === l.avail_out)) return 0;
                                }
                                return st(4 == t), 0 === l.avail_out ? 4 == t ? 2 : 0 : 4 == t ? 3 : 1;
                            }(e);
                            break;
                        case 1:
                            a = function(t) {
                                for(var e, n = 0;;){
                                    if (P < 262) {
                                        if (lt(), P < 262 && 0 == t) return 0;
                                        if (0 === P) break;
                                    }
                                    if (3 <= P && (v = (v << x ^ 255 & g[_ + 2]) & b, n = 65535 & y[v], m[_ & d] = y[v], y[v] = _), 0 !== n && (_ - n & 65535) <= f - 262 && 2 != j && (L = ht(n)), 3 <= L) {
                                        if (e = rt(_ - F, L - 3), P -= L, L <= C && 3 <= P) {
                                            for(L--; v = (v << x ^ 255 & g[++_ + 2]) & b, n = 65535 & y[v], m[_ & d] = y[v], y[v] = _, 0 != --L;);
                                            _++;
                                        } else _ += L, L = 0, v = ((v = 255 & g[_]) << x ^ 255 & g[_ + 1]) & b;
                                    } else e = rt(0, 255 & g[_]), P--, _++;
                                    if (e && (st(!1), 0 === l.avail_out)) return 0;
                                }
                                return st(4 == t), 0 === l.avail_out ? 4 == t ? 2 : 0 : 4 == t ? 3 : 1;
                            }(e);
                            break;
                        case 2:
                            a = function(t) {
                                for(var e, n, r = 0;;){
                                    if (P < 262) {
                                        if (lt(), P < 262 && 0 == t) return 0;
                                        if (0 === P) break;
                                    }
                                    if (3 <= P && (v = (v << x ^ 255 & g[_ + 2]) & b, r = 65535 & y[v], m[_ & d] = y[v], y[v] = _), k = L, A = F, L = 2, 0 !== r && k < C && (_ - r & 65535) <= f - 262 && (2 != j && (L = ht(r)), L <= 5 && (1 == j || 3 == L && 4096 < _ - F) && (L = 2)), 3 <= k && L <= k) {
                                        for(n = _ + P - 3, e = rt(_ - 1 - A, k - 3), P -= k - 1, k -= 2; ++_ <= n && (v = (v << x ^ 255 & g[_ + 2]) & b, r = 65535 & y[v], m[_ & d] = y[v], y[v] = _), 0 != --k;);
                                        if (S = 0, L = 2, _++, e && (st(!1), 0 === l.avail_out)) return 0;
                                    } else if (0 !== S) {
                                        if ((e = rt(0, 255 & g[_ - 1])) && st(!1), _++, P--, 0 === l.avail_out) return 0;
                                    } else S = 1, _++, P--;
                                }
                                return 0 !== S && (e = rt(0, 255 & g[_ - 1]), S = 0), st(4 == t), 0 === l.avail_out ? 4 == t ? 2 : 0 : 4 == t ? 3 : 1;
                            }(e);
                    }
                    if (2 != a && 3 != a || (h = 666), 0 == a || 2 == a) return 0 === l.avail_out && (c = -1), 0;
                    if (1 == a) {
                        if (1 == e) $(2, 3), tt(256, ft.static_ltree), nt(), 1 + z + 10 - W < 9 && ($(2, 3), tt(256, ft.static_ltree), nt()), z = 7;
                        else if (at(0, 0, !1), 3 == e) for(n = 0; n < w; n++)y[n] = 0;
                        if (l.flush_pending(), 0 === l.avail_out) return c = -1, 0;
                    }
                }
                return 4 != e ? 0 : 1;
            };
        }
        function i() {
            this.next_in_index = 0, this.next_out_index = 0, this.avail_in = 0, this.total_in = 0, this.avail_out = 0, this.total_out = 0;
        }
        i.prototype = {
            deflateInit: function(t, e) {
                return this.dstate = new r, e || (e = d), this.dstate.deflateInit(this, t, e);
            },
            deflate: function(t) {
                return this.dstate ? this.dstate.deflate(this, t) : -2;
            },
            deflateEnd: function() {
                if (!this.dstate) return -2;
                var t = this.dstate.deflateEnd();
                return this.dstate = null, t;
            },
            deflateParams: function(t, e) {
                return this.dstate ? this.dstate.deflateParams(this, t, e) : -2;
            },
            deflateSetDictionary: function(t, e) {
                return this.dstate ? this.dstate.deflateSetDictionary(this, t, e) : -2;
            },
            read_buf: function(t, e, n) {
                var r = this.avail_in;
                return n < r && (r = n), 0 === r ? 0 : (this.avail_in -= r, t.set(this.next_in.subarray(this.next_in_index, this.next_in_index + r), e), this.next_in_index += r, this.total_in += r, r);
            },
            flush_pending: function() {
                var t = this, e = t.dstate.pending;
                e > t.avail_out && (e = t.avail_out), 0 !== e && (t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out, t.dstate.pending_out + e), t.next_out_index), t.next_out_index += e, t.dstate.pending_out += e, t.total_out += e, t.avail_out -= e, t.dstate.pending -= e, 0 === t.dstate.pending && (t.dstate.pending_out = 0));
            }
        };
        var o = t.zip || t;
        o.Deflater = o._jzlib_Deflater = function(t) {
            var s = new i, l = new Uint8Array(512), e = t ? t.level : -1;
            void 0 === e && (e = -1), s.deflateInit(e), s.next_out = l, this.append = function(t, e) {
                var n, r = [], i = 0, o = 0, a = 0;
                if (t.length) {
                    s.next_in_index = 0, s.next_in = t, s.avail_in = t.length;
                    do {
                        if (s.next_out_index = 0, s.avail_out = 512, 0 != s.deflate(0)) throw new Error("deflating: " + s.msg);
                        s.next_out_index && (512 == s.next_out_index ? r.push(new Uint8Array(l)) : r.push(new Uint8Array(l.subarray(0, s.next_out_index)))), a += s.next_out_index, e && 0 < s.next_in_index && s.next_in_index != i && (e(s.next_in_index), i = s.next_in_index);
                    }while (0 < s.avail_in || 0 === s.avail_out);
                    return n = new Uint8Array(a), r.forEach(function(t) {
                        n.set(t, o), o += t.length;
                    }), n;
                }
            }, this.flush = function() {
                var t, e, n = [], r = 0, i = 0;
                do {
                    if (s.next_out_index = 0, s.avail_out = 512, 1 != (t = s.deflate(4)) && 0 != t) throw new Error("deflating: " + s.msg);
                    0 < 512 - s.avail_out && n.push(new Uint8Array(l.subarray(0, s.next_out_index))), i += s.next_out_index;
                }while (0 < s.avail_in || 0 === s.avail_out);
                return s.deflateEnd(), e = new Uint8Array(i), n.forEach(function(t) {
                    e.set(t, r), r += t.length;
                }), e;
            };
        };
    }("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")()), ("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")()).RGBColor = function(t) {
        var e;
        t = t || "", this.ok = !1, "#" == t.charAt(0) && (t = t.substr(1, 6)), t = (t = t.replace(/ /g, "")).toLowerCase();
        var n = {
            aliceblue: "f0f8ff",
            antiquewhite: "faebd7",
            aqua: "00ffff",
            aquamarine: "7fffd4",
            azure: "f0ffff",
            beige: "f5f5dc",
            bisque: "ffe4c4",
            black: "000000",
            blanchedalmond: "ffebcd",
            blue: "0000ff",
            blueviolet: "8a2be2",
            brown: "a52a2a",
            burlywood: "deb887",
            cadetblue: "5f9ea0",
            chartreuse: "7fff00",
            chocolate: "d2691e",
            coral: "ff7f50",
            cornflowerblue: "6495ed",
            cornsilk: "fff8dc",
            crimson: "dc143c",
            cyan: "00ffff",
            darkblue: "00008b",
            darkcyan: "008b8b",
            darkgoldenrod: "b8860b",
            darkgray: "a9a9a9",
            darkgreen: "006400",
            darkkhaki: "bdb76b",
            darkmagenta: "8b008b",
            darkolivegreen: "556b2f",
            darkorange: "ff8c00",
            darkorchid: "9932cc",
            darkred: "8b0000",
            darksalmon: "e9967a",
            darkseagreen: "8fbc8f",
            darkslateblue: "483d8b",
            darkslategray: "2f4f4f",
            darkturquoise: "00ced1",
            darkviolet: "9400d3",
            deeppink: "ff1493",
            deepskyblue: "00bfff",
            dimgray: "696969",
            dodgerblue: "1e90ff",
            feldspar: "d19275",
            firebrick: "b22222",
            floralwhite: "fffaf0",
            forestgreen: "228b22",
            fuchsia: "ff00ff",
            gainsboro: "dcdcdc",
            ghostwhite: "f8f8ff",
            gold: "ffd700",
            goldenrod: "daa520",
            gray: "808080",
            green: "008000",
            greenyellow: "adff2f",
            honeydew: "f0fff0",
            hotpink: "ff69b4",
            indianred: "cd5c5c",
            indigo: "4b0082",
            ivory: "fffff0",
            khaki: "f0e68c",
            lavender: "e6e6fa",
            lavenderblush: "fff0f5",
            lawngreen: "7cfc00",
            lemonchiffon: "fffacd",
            lightblue: "add8e6",
            lightcoral: "f08080",
            lightcyan: "e0ffff",
            lightgoldenrodyellow: "fafad2",
            lightgrey: "d3d3d3",
            lightgreen: "90ee90",
            lightpink: "ffb6c1",
            lightsalmon: "ffa07a",
            lightseagreen: "20b2aa",
            lightskyblue: "87cefa",
            lightslateblue: "8470ff",
            lightslategray: "778899",
            lightsteelblue: "b0c4de",
            lightyellow: "ffffe0",
            lime: "00ff00",
            limegreen: "32cd32",
            linen: "faf0e6",
            magenta: "ff00ff",
            maroon: "800000",
            mediumaquamarine: "66cdaa",
            mediumblue: "0000cd",
            mediumorchid: "ba55d3",
            mediumpurple: "9370d8",
            mediumseagreen: "3cb371",
            mediumslateblue: "7b68ee",
            mediumspringgreen: "00fa9a",
            mediumturquoise: "48d1cc",
            mediumvioletred: "c71585",
            midnightblue: "191970",
            mintcream: "f5fffa",
            mistyrose: "ffe4e1",
            moccasin: "ffe4b5",
            navajowhite: "ffdead",
            navy: "000080",
            oldlace: "fdf5e6",
            olive: "808000",
            olivedrab: "6b8e23",
            orange: "ffa500",
            orangered: "ff4500",
            orchid: "da70d6",
            palegoldenrod: "eee8aa",
            palegreen: "98fb98",
            paleturquoise: "afeeee",
            palevioletred: "d87093",
            papayawhip: "ffefd5",
            peachpuff: "ffdab9",
            peru: "cd853f",
            pink: "ffc0cb",
            plum: "dda0dd",
            powderblue: "b0e0e6",
            purple: "800080",
            red: "ff0000",
            rosybrown: "bc8f8f",
            royalblue: "4169e1",
            saddlebrown: "8b4513",
            salmon: "fa8072",
            sandybrown: "f4a460",
            seagreen: "2e8b57",
            seashell: "fff5ee",
            sienna: "a0522d",
            silver: "c0c0c0",
            skyblue: "87ceeb",
            slateblue: "6a5acd",
            slategray: "708090",
            snow: "fffafa",
            springgreen: "00ff7f",
            steelblue: "4682b4",
            tan: "d2b48c",
            teal: "008080",
            thistle: "d8bfd8",
            tomato: "ff6347",
            turquoise: "40e0d0",
            violet: "ee82ee",
            violetred: "d02090",
            wheat: "f5deb3",
            white: "ffffff",
            whitesmoke: "f5f5f5",
            yellow: "ffff00",
            yellowgreen: "9acd32"
        };
        for(var r in n)t == r && (t = n[r]);
        for(var i = [
            {
                re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
                example: [
                    "rgb(123, 234, 45)",
                    "rgb(255,234,245)"
                ],
                process: function(t) {
                    return [
                        parseInt(t[1]),
                        parseInt(t[2]),
                        parseInt(t[3])
                    ];
                }
            },
            {
                re: /^(\w{2})(\w{2})(\w{2})$/,
                example: [
                    "#00ff00",
                    "336699"
                ],
                process: function(t) {
                    return [
                        parseInt(t[1], 16),
                        parseInt(t[2], 16),
                        parseInt(t[3], 16)
                    ];
                }
            },
            {
                re: /^(\w{1})(\w{1})(\w{1})$/,
                example: [
                    "#fb0",
                    "f0f"
                ],
                process: function(t) {
                    return [
                        parseInt(t[1] + t[1], 16),
                        parseInt(t[2] + t[2], 16),
                        parseInt(t[3] + t[3], 16)
                    ];
                }
            }
        ], o = 0; o < i.length; o++){
            var a = i[o].re, s = i[o].process, l = a.exec(t);
            l && (e = s(l), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
        }
        this.r = this.r < 0 || isNaN(this.r) ? 0 : 255 < this.r ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : 255 < this.g ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : 255 < this.b ? 255 : this.b, this.toRGB = function() {
            return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
        }, this.toHex = function() {
            var t = this.r.toString(16), e = this.g.toString(16), n = this.b.toString(16);
            return 1 == t.length && (t = "0" + t), 1 == e.length && (e = "0" + e), 1 == n.length && (n = "0" + n), "#" + t + e + n;
        };
    }, function(t) {
        var n = "+".charCodeAt(0), r = "/".charCodeAt(0), i = "0".charCodeAt(0), o = "a".charCodeAt(0), a = "A".charCodeAt(0), s = "-".charCodeAt(0), l = "_".charCodeAt(0), u = function(t) {
            var e = t.charCodeAt(0);
            return e === n || e === s ? 62 : e === r || e === l ? 63 : e < i ? -1 : e < i + 10 ? e - i + 26 + 26 : e < a + 26 ? e - a : e < o + 26 ? e - o + 26 : void 0;
        };
        t.API.TTFFont = function() {
            function i(t, e, n) {
                var r;
                if (this.rawData = t, r = this.contents = new J(t), this.contents.pos = 4, "ttcf" === r.readString(4)) {
                    if (!e) throw new Error("Must specify a font name for TTC files.");
                    throw new Error("Font " + e + " not found in TTC file.");
                }
                r.pos = 0, this.parse(), this.subset = new P(this), this.registerTTF();
            }
            return i.open = function(t, e, n, r) {
                if ("string" != typeof n) throw new Error("Invalid argument supplied in TTFFont.open");
                return new i(function(t) {
                    var e, n, r, i, o, a;
                    if (0 < t.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
                    var s = t.length;
                    o = "=" === t.charAt(s - 2) ? 2 : "=" === t.charAt(s - 1) ? 1 : 0, a = new Uint8Array(3 * t.length / 4 - o), r = 0 < o ? t.length - 4 : t.length;
                    var l = 0;
                    function h(t) {
                        a[l++] = t;
                    }
                    for(n = e = 0; e < r; e += 4, n += 3)h((16711680 & (i = u(t.charAt(e)) << 18 | u(t.charAt(e + 1)) << 12 | u(t.charAt(e + 2)) << 6 | u(t.charAt(e + 3)))) >> 16), h((65280 & i) >> 8), h(255 & i);
                    return 2 === o ? h(255 & (i = u(t.charAt(e)) << 2 | u(t.charAt(e + 1)) >> 4)) : 1 === o && (h((i = u(t.charAt(e)) << 10 | u(t.charAt(e + 1)) << 4 | u(t.charAt(e + 2)) >> 2) >> 8 & 255), h(255 & i)), a;
                }(n), e, r);
            }, i.prototype.parse = function() {
                return this.directory = new e(this.contents), this.head = new p(this), this.name = new b(this), this.cmap = new y(this), this.toUnicode = new Map, this.hhea = new g(this), this.maxp = new x(this), this.hmtx = new N(this), this.post = new v(this), this.os2 = new m(this), this.loca = new F(this), this.glyf = new A(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [
                    this.head.xMin,
                    this.head.yMin,
                    this.head.xMax,
                    this.head.yMax
                ];
            }, i.prototype.registerTTF = function() {
                var i, t, e, n, r;
                if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
                    var t, e, n, r;
                    for(r = [], t = 0, e = (n = this.bbox).length; t < e; t++)i = n[t], r.push(Math.round(i * this.scaleFactor));
                    return r;
                }).call(this), this.stemV = 0, this.post.exists ? (e = 255 & (n = this.post.italic_angle), !0 & (t = n >> 16) && (t = -(1 + (65535 ^ t))), this.italicAngle = +(t + "." + e)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = 1 === (r = this.familyClass) || 2 === r || 3 === r || 4 === r || 5 === r || 7 === r, this.isScript = 10 === this.familyClass, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), 0 !== this.italicAngle && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
            }, i.prototype.characterToGlyph = function(t) {
                var e;
                return (null != (e = this.cmap.unicode) ? e.codeMap[t] : void 0) || 0;
            }, i.prototype.widthOfGlyph = function(t) {
                var e;
                return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t).advance * e;
            }, i.prototype.widthOfString = function(t, e, n) {
                var r, i, o, a, s;
                for(i = a = o = 0, s = (t = "" + t).length; 0 <= s ? a < s : s < a; i = 0 <= s ? ++a : --a)r = t.charCodeAt(i), o += this.widthOfGlyph(this.characterToGlyph(r)) + n * (1e3 / e) || 0;
                return o * (e / 1e3);
            }, i.prototype.lineHeight = function(t, e) {
                var n;
                return null == e && (e = !1), n = e ? this.lineGap : 0, (this.ascender + n - this.decender) / 1e3 * t;
            }, i;
        }();
        var h, J = function() {
            function t(t) {
                this.data = null != t ? t : [], this.pos = 0, this.length = this.data.length;
            }
            return t.prototype.readByte = function() {
                return this.data[this.pos++];
            }, t.prototype.writeByte = function(t) {
                return this.data[this.pos++] = t;
            }, t.prototype.readUInt32 = function() {
                return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
            }, t.prototype.writeUInt32 = function(t) {
                return this.writeByte(t >>> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
            }, t.prototype.readInt32 = function() {
                var t;
                return 2147483648 <= (t = this.readUInt32()) ? t - 4294967296 : t;
            }, t.prototype.writeInt32 = function(t) {
                return t < 0 && (t += 4294967296), this.writeUInt32(t);
            }, t.prototype.readUInt16 = function() {
                return this.readByte() << 8 | this.readByte();
            }, t.prototype.writeUInt16 = function(t) {
                return this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
            }, t.prototype.readInt16 = function() {
                var t;
                return 32768 <= (t = this.readUInt16()) ? t - 65536 : t;
            }, t.prototype.writeInt16 = function(t) {
                return t < 0 && (t += 65536), this.writeUInt16(t);
            }, t.prototype.readString = function(t) {
                var e, n, r;
                for(n = [], e = r = 0; 0 <= t ? r < t : t < r; e = 0 <= t ? ++r : --r)n[e] = String.fromCharCode(this.readByte());
                return n.join("");
            }, t.prototype.writeString = function(t) {
                var e, n, r, i;
                for(i = [], e = n = 0, r = t.length; 0 <= r ? n < r : r < n; e = 0 <= r ? ++n : --n)i.push(this.writeByte(t.charCodeAt(e)));
                return i;
            }, t.prototype.readShort = function() {
                return this.readInt16();
            }, t.prototype.writeShort = function(t) {
                return this.writeInt16(t);
            }, t.prototype.readLongLong = function() {
                var t, e, n, r, i, o, a, s;
                return t = this.readByte(), e = this.readByte(), n = this.readByte(), r = this.readByte(), i = this.readByte(), o = this.readByte(), a = this.readByte(), s = this.readByte(), 128 & t ? -1 * (72057594037927940 * (255 ^ t) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ n) + 4294967296 * (255 ^ r) + 16777216 * (255 ^ i) + 65536 * (255 ^ o) + 256 * (255 ^ a) + (255 ^ s) + 1) : 72057594037927940 * t + 281474976710656 * e + 1099511627776 * n + 4294967296 * r + 16777216 * i + 65536 * o + 256 * a + s;
            }, t.prototype.writeLongLong = function(t) {
                var e, n;
                return e = Math.floor(t / 4294967296), n = 4294967295 & t, this.writeByte(e >> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e), this.writeByte(n >> 24 & 255), this.writeByte(n >> 16 & 255), this.writeByte(n >> 8 & 255), this.writeByte(255 & n);
            }, t.prototype.readInt = function() {
                return this.readInt32();
            }, t.prototype.writeInt = function(t) {
                return this.writeInt32(t);
            }, t.prototype.read = function(t) {
                var e, n;
                for(e = [], n = 0; 0 <= t ? n < t : t < n; 0 <= t ? ++n : --n)e.push(this.readByte());
                return e;
            }, t.prototype.write = function(t) {
                var e, n, r, i;
                for(i = [], n = 0, r = t.length; n < r; n++)e = t[n], i.push(this.writeByte(e));
                return i;
            }, t;
        }(), e = function() {
            var d;
            function t(t) {
                var e, n, r;
                for(this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, n = 0, r = this.tableCount; 0 <= r ? n < r : r < n; 0 <= r ? ++n : --n)e = {
                    tag: t.readString(4),
                    checksum: t.readInt(),
                    offset: t.readInt(),
                    length: t.readInt()
                }, this.tables[e.tag] = e;
            }
            return t.prototype.encode = function(t) {
                var e, n, r, i, o, a, s, l, h, u, c, f, p;
                for(p in c = Object.keys(t).length, a = Math.log(2), h = 16 * Math.floor(Math.log(c) / a), i = Math.floor(h / a), l = 16 * c - h, (n = new J).writeInt(this.scalarType), n.writeShort(c), n.writeShort(h), n.writeShort(i), n.writeShort(l), r = 16 * c, s = n.pos + r, o = null, f = [], t)for(u = t[p], n.writeString(p), n.writeInt(d(u)), n.writeInt(s), n.writeInt(u.length), f = f.concat(u), "head" === p && (o = s), s += u.length; s % 4;)f.push(0), s++;
                return n.write(f), e = 2981146554 - d(n.data), n.pos = o + 8, n.writeUInt32(e), n.data;
            }, d = function(t) {
                var e, n, r, i;
                for(t = L.call(t); t.length % 4;)t.push(0);
                for(n = new J(t), r = e = 0, i = t.length; r < i; r += 4)e += n.readUInt32();
                return 4294967295 & e;
            }, t;
        }(), c = {}.hasOwnProperty, f = function(t, e) {
            for(var n in e)c.call(e, n) && (t[n] = e[n]);
            function r() {
                this.constructor = t;
            }
            return r.prototype = e.prototype, t.prototype = new r, t.__super__ = e.prototype, t;
        };
        h = function() {
            function t(t) {
                var e;
                this.file = t, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
            }
            return t.prototype.parse = function() {}, t.prototype.encode = function() {}, t.prototype.raw = function() {
                return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
            }, t;
        }();
        var p = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, h), e.prototype.tag = "head", e.prototype.parse = function(t) {
                return t.pos = this.offset, this.version = t.readInt(), this.revision = t.readInt(), this.checkSumAdjustment = t.readInt(), this.magicNumber = t.readInt(), this.flags = t.readShort(), this.unitsPerEm = t.readShort(), this.created = t.readLongLong(), this.modified = t.readLongLong(), this.xMin = t.readShort(), this.yMin = t.readShort(), this.xMax = t.readShort(), this.yMax = t.readShort(), this.macStyle = t.readShort(), this.lowestRecPPEM = t.readShort(), this.fontDirectionHint = t.readShort(), this.indexToLocFormat = t.readShort(), this.glyphDataFormat = t.readShort();
            }, e.prototype.encode = function(t) {
                var e;
                return (e = new J).writeInt(this.version), e.writeInt(this.revision), e.writeInt(this.checkSumAdjustment), e.writeInt(this.magicNumber), e.writeShort(this.flags), e.writeShort(this.unitsPerEm), e.writeLongLong(this.created), e.writeLongLong(this.modified), e.writeShort(this.xMin), e.writeShort(this.yMin), e.writeShort(this.xMax), e.writeShort(this.yMax), e.writeShort(this.macStyle), e.writeShort(this.lowestRecPPEM), e.writeShort(this.fontDirectionHint), e.writeShort(t), e.writeShort(this.glyphDataFormat), e.data;
            }, e;
        }(), d = function() {
            function t(n, t) {
                var e, r, i, o, a, s, l, h, u, c, f, p, d, g, m, y, v, w;
                switch(this.platformID = n.readUInt16(), this.encodingID = n.readShort(), this.offset = t + n.readInt(), u = n.pos, n.pos = this.offset, this.format = n.readUInt16(), this.length = n.readUInt16(), this.language = n.readUInt16(), this.isUnicode = 3 === this.platformID && 1 === this.encodingID && 4 === this.format || 0 === this.platformID && 4 === this.format, this.codeMap = {}, this.format){
                    case 0:
                        for(s = m = 0; m < 256; s = ++m)this.codeMap[s] = n.readByte();
                        break;
                    case 4:
                        for(f = n.readUInt16(), c = f / 2, n.pos += 6, i = function() {
                            var t, e;
                            for(e = [], s = t = 0; 0 <= c ? t < c : c < t; s = 0 <= c ? ++t : --t)e.push(n.readUInt16());
                            return e;
                        }(), n.pos += 2, d = function() {
                            var t, e;
                            for(e = [], s = t = 0; 0 <= c ? t < c : c < t; s = 0 <= c ? ++t : --t)e.push(n.readUInt16());
                            return e;
                        }(), l = function() {
                            var t, e;
                            for(e = [], s = t = 0; 0 <= c ? t < c : c < t; s = 0 <= c ? ++t : --t)e.push(n.readUInt16());
                            return e;
                        }(), h = function() {
                            var t, e;
                            for(e = [], s = t = 0; 0 <= c ? t < c : c < t; s = 0 <= c ? ++t : --t)e.push(n.readUInt16());
                            return e;
                        }(), r = (this.length - n.pos + this.offset) / 2, a = function() {
                            var t, e;
                            for(e = [], s = t = 0; 0 <= r ? t < r : r < t; s = 0 <= r ? ++t : --t)e.push(n.readUInt16());
                            return e;
                        }(), s = y = 0, w = i.length; y < w; s = ++y)for(g = i[s], e = v = p = d[s]; p <= g ? v <= g : g <= v; e = p <= g ? ++v : --v)0 === h[s] ? o = e + l[s] : 0 !== (o = a[h[s] / 2 + (e - p) - (c - s)] || 0) && (o += l[s]), this.codeMap[e] = 65535 & o;
                }
                n.pos = u;
            }
            return t.encode = function(t, e) {
                var n, r, i, o, a, s, l, h, u, c, f, p, d, g, m, y, v, w, b, x, N, L, A, S, _, F, P, k, I, C, B, j, E, M, O, q, T, R, D, U, z, H, W, V, G, Y;
                switch(k = new J, o = Object.keys(t).sort(function(t, e) {
                    return t - e;
                }), e){
                    case "macroman":
                        for(d = 0, g = function() {
                            var t, e;
                            for(e = [], p = t = 0; t < 256; p = ++t)e.push(0);
                            return e;
                        }(), y = {
                            0: 0
                        }, i = {}, I = 0, E = o.length; I < E; I++)null == y[W = t[r = o[I]]] && (y[W] = ++d), i[r] = {
                            old: t[r],
                            new: y[t[r]]
                        }, g[r] = y[t[r]];
                        return k.writeUInt16(1), k.writeUInt16(0), k.writeUInt32(12), k.writeUInt16(0), k.writeUInt16(262), k.writeUInt16(0), k.write(g), {
                            charMap: i,
                            subtable: k.data,
                            maxGlyphID: d + 1
                        };
                    case "unicode":
                        for(F = [], u = [], y = {}, n = {}, m = l = null, C = v = 0, M = o.length; C < M; C++)null == y[b = t[r = o[C]]] && (y[b] = ++v), n[r] = {
                            old: b,
                            new: y[b]
                        }, a = y[b] - r, null != m && a === l || (m && u.push(m), F.push(r), l = a), m = r;
                        for(m && u.push(m), u.push(65535), F.push(65535), S = 2 * (A = F.length), L = 2 * Math.pow(Math.log(A) / Math.LN2, 2), c = Math.log(L / 2) / Math.LN2, N = 2 * A - L, s = [], x = [], f = [], p = B = 0, O = F.length; B < O; p = ++B){
                            if (_ = F[p], h = u[p], 65535 === _) {
                                s.push(0), x.push(0);
                                break;
                            }
                            if (32768 <= _ - (P = n[_].new)) for(s.push(0), x.push(2 * (f.length + A - p)), r = j = _; _ <= h ? j <= h : h <= j; r = _ <= h ? ++j : --j)f.push(n[r].new);
                            else s.push(P - _), x.push(0);
                        }
                        for(k.writeUInt16(3), k.writeUInt16(1), k.writeUInt32(12), k.writeUInt16(4), k.writeUInt16(16 + 8 * A + 2 * f.length), k.writeUInt16(0), k.writeUInt16(S), k.writeUInt16(L), k.writeUInt16(c), k.writeUInt16(N), z = 0, q = u.length; z < q; z++)r = u[z], k.writeUInt16(r);
                        for(k.writeUInt16(0), H = 0, T = F.length; H < T; H++)r = F[H], k.writeUInt16(r);
                        for(V = 0, R = s.length; V < R; V++)a = s[V], k.writeUInt16(a);
                        for(G = 0, D = x.length; G < D; G++)w = x[G], k.writeUInt16(w);
                        for(Y = 0, U = f.length; Y < U; Y++)d = f[Y], k.writeUInt16(d);
                        return {
                            charMap: n,
                            subtable: k.data,
                            maxGlyphID: v + 1
                        };
                }
            }, t;
        }(), y = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, h), e.prototype.tag = "cmap", e.prototype.parse = function(t) {
                var e, n, r;
                for(t.pos = this.offset, this.version = t.readUInt16(), n = t.readUInt16(), this.tables = [], this.unicode = null, r = 0; 0 <= n ? r < n : n < r; 0 <= n ? ++r : --r)e = new d(t, this.offset), this.tables.push(e), e.isUnicode && null == this.unicode && (this.unicode = e);
                return !0;
            }, e.encode = function(t, e) {
                var n, r;
                return null == e && (e = "macroman"), n = d.encode(t, e), (r = new J).writeUInt16(0), r.writeUInt16(1), n.table = r.data.concat(n.subtable), n;
            }, e;
        }(), g = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, h), e.prototype.tag = "hhea", e.prototype.parse = function(t) {
                return t.pos = this.offset, this.version = t.readInt(), this.ascender = t.readShort(), this.decender = t.readShort(), this.lineGap = t.readShort(), this.advanceWidthMax = t.readShort(), this.minLeftSideBearing = t.readShort(), this.minRightSideBearing = t.readShort(), this.xMaxExtent = t.readShort(), this.caretSlopeRise = t.readShort(), this.caretSlopeRun = t.readShort(), this.caretOffset = t.readShort(), t.pos += 8, this.metricDataFormat = t.readShort(), this.numberOfMetrics = t.readUInt16();
            }, e;
        }(), m = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, h), e.prototype.tag = "OS/2", e.prototype.parse = function(n) {
                if (n.pos = this.offset, this.version = n.readUInt16(), this.averageCharWidth = n.readShort(), this.weightClass = n.readUInt16(), this.widthClass = n.readUInt16(), this.type = n.readShort(), this.ySubscriptXSize = n.readShort(), this.ySubscriptYSize = n.readShort(), this.ySubscriptXOffset = n.readShort(), this.ySubscriptYOffset = n.readShort(), this.ySuperscriptXSize = n.readShort(), this.ySuperscriptYSize = n.readShort(), this.ySuperscriptXOffset = n.readShort(), this.ySuperscriptYOffset = n.readShort(), this.yStrikeoutSize = n.readShort(), this.yStrikeoutPosition = n.readShort(), this.familyClass = n.readShort(), this.panose = function() {
                    var t, e;
                    for(e = [], t = 0; t < 10; ++t)e.push(n.readByte());
                    return e;
                }(), this.charRange = function() {
                    var t, e;
                    for(e = [], t = 0; t < 4; ++t)e.push(n.readInt());
                    return e;
                }(), this.vendorID = n.readString(4), this.selection = n.readShort(), this.firstCharIndex = n.readShort(), this.lastCharIndex = n.readShort(), 0 < this.version && (this.ascent = n.readShort(), this.descent = n.readShort(), this.lineGap = n.readShort(), this.winAscent = n.readShort(), this.winDescent = n.readShort(), this.codePageRange = function() {
                    var t, e;
                    for(e = [], t = 0; t < 2; ++t)e.push(n.readInt());
                    return e;
                }(), 1 < this.version)) return this.xHeight = n.readShort(), this.capHeight = n.readShort(), this.defaultChar = n.readShort(), this.breakChar = n.readShort(), this.maxContext = n.readShort();
            }, e;
        }(), v = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, h), e.prototype.tag = "post", e.prototype.parse = function(r) {
                var t, e, n, i;
                switch(r.pos = this.offset, this.format = r.readInt(), this.italicAngle = r.readInt(), this.underlinePosition = r.readShort(), this.underlineThickness = r.readShort(), this.isFixedPitch = r.readInt(), this.minMemType42 = r.readInt(), this.maxMemType42 = r.readInt(), this.minMemType1 = r.readInt(), this.maxMemType1 = r.readInt(), this.format){
                    case 65536:
                        break;
                    case 131072:
                        for(e = r.readUInt16(), this.glyphNameIndex = [], n = 0; 0 <= e ? n < e : e < n; 0 <= e ? ++n : --n)this.glyphNameIndex.push(r.readUInt16());
                        for(this.names = [], i = []; r.pos < this.offset + this.length;)t = r.readByte(), i.push(this.names.push(r.readString(t)));
                        return i;
                    case 151552:
                        return e = r.readUInt16(), this.offsets = r.read(e);
                    case 196608:
                        break;
                    case 262144:
                        return this.map = (function() {
                            var t, e, n;
                            for(n = [], t = 0, e = this.file.maxp.numGlyphs; 0 <= e ? t < e : e < t; 0 <= e ? ++t : --t)n.push(r.readUInt32());
                            return n;
                        }).call(this);
                }
            }, e;
        }(), w = function(t, e) {
            this.raw = t, this.length = t.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
        }, b = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, h), e.prototype.tag = "name", e.prototype.parse = function(t) {
                var e, n, r, i, o, a, s, l, h, u, c, f;
                for(t.pos = this.offset, t.readShort(), e = t.readShort(), a = t.readShort(), n = [], i = h = 0; 0 <= e ? h < e : e < h; i = 0 <= e ? ++h : --h)n.push({
                    platformID: t.readShort(),
                    encodingID: t.readShort(),
                    languageID: t.readShort(),
                    nameID: t.readShort(),
                    length: t.readShort(),
                    offset: this.offset + a + t.readShort()
                });
                for(s = {}, i = u = 0, c = n.length; u < c; i = ++u)r = n[i], t.pos = r.offset, l = t.readString(r.length), o = new w(l, r), null == s[f = r.nameID] && (s[f] = []), s[r.nameID].push(o);
                this.strings = s, this.copyright = s[0], this.fontFamily = s[1], this.fontSubfamily = s[2], this.uniqueSubfamily = s[3], this.fontName = s[4], this.version = s[5];
                try {
                    this.postscriptName = s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
                } catch (t) {
                    this.postscriptName = s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
                }
                return this.trademark = s[7], this.manufacturer = s[8], this.designer = s[9], this.description = s[10], this.vendorUrl = s[11], this.designerUrl = s[12], this.license = s[13], this.licenseUrl = s[14], this.preferredFamily = s[15], this.preferredSubfamily = s[17], this.compatibleFull = s[18], this.sampleText = s[19];
            }, e;
        }(), x = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, h), e.prototype.tag = "maxp", e.prototype.parse = function(t) {
                return t.pos = this.offset, this.version = t.readInt(), this.numGlyphs = t.readUInt16(), this.maxPoints = t.readUInt16(), this.maxContours = t.readUInt16(), this.maxCompositePoints = t.readUInt16(), this.maxComponentContours = t.readUInt16(), this.maxZones = t.readUInt16(), this.maxTwilightPoints = t.readUInt16(), this.maxStorage = t.readUInt16(), this.maxFunctionDefs = t.readUInt16(), this.maxInstructionDefs = t.readUInt16(), this.maxStackElements = t.readUInt16(), this.maxSizeOfInstructions = t.readUInt16(), this.maxComponentElements = t.readUInt16(), this.maxComponentDepth = t.readUInt16();
            }, e;
        }(), N = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, h), e.prototype.tag = "hmtx", e.prototype.parse = function(n) {
                var t, r, i, e, o, a, s;
                for(n.pos = this.offset, this.metrics = [], e = 0, a = this.file.hhea.numberOfMetrics; 0 <= a ? e < a : a < e; 0 <= a ? ++e : --e)this.metrics.push({
                    advance: n.readUInt16(),
                    lsb: n.readInt16()
                });
                for(r = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
                    var t, e;
                    for(e = [], t = 0; 0 <= r ? t < r : r < t; 0 <= r ? ++t : --t)e.push(n.readInt16());
                    return e;
                }(), this.widths = (function() {
                    var t, e, n, r;
                    for(r = [], t = 0, e = (n = this.metrics).length; t < e; t++)i = n[t], r.push(i.advance);
                    return r;
                }).call(this), t = this.widths[this.widths.length - 1], s = [], o = 0; 0 <= r ? o < r : r < o; 0 <= r ? ++o : --o)s.push(this.widths.push(t));
                return s;
            }, e.prototype.forGlyph = function(t) {
                return t in this.metrics ? this.metrics[t] : {
                    advance: this.metrics[this.metrics.length - 1].advance,
                    lsb: this.leftSideBearings[t - this.metrics.length]
                };
            }, e;
        }(), L = [].slice, A = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, h), e.prototype.tag = "glyf", e.prototype.parse = function(t) {
                return this.cache = {};
            }, e.prototype.glyphFor = function(t) {
                var e, n, r, i, o, a, s, l, h, u;
                return t in this.cache ? this.cache[t] : (i = this.file.loca, e = this.file.contents, n = i.indexOf(t), 0 === (r = i.lengthOf(t)) ? this.cache[t] = null : (e.pos = this.offset + n, o = (a = new J(e.read(r))).readShort(), l = a.readShort(), u = a.readShort(), s = a.readShort(), h = a.readShort(), this.cache[t] = -1 === o ? new _(a, l, u, s, h) : new S(a, o, l, u, s, h), this.cache[t]));
            }, e.prototype.encode = function(t, e, n) {
                var r, i, o, a, s;
                for(o = [], i = [], a = 0, s = e.length; a < s; a++)r = t[e[a]], i.push(o.length), r && (o = o.concat(r.encode(n)));
                return i.push(o.length), {
                    table: o,
                    offsets: i
                };
            }, e;
        }(), S = function() {
            function t(t, e, n, r, i, o) {
                this.raw = t, this.numberOfContours = e, this.xMin = n, this.yMin = r, this.xMax = i, this.yMax = o, this.compound = !1;
            }
            return t.prototype.encode = function() {
                return this.raw.data;
            }, t;
        }(), _ = function() {
            function t(t, e, n, r, i) {
                var o, a;
                for(this.raw = t, this.xMin = e, this.yMin = n, this.xMax = r, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], o = this.raw; a = o.readShort(), this.glyphOffsets.push(o.pos), this.glyphIDs.push(o.readShort()), 32 & a;)o.pos += 1 & a ? 4 : 2, 128 & a ? o.pos += 8 : 64 & a ? o.pos += 4 : 8 & a && (o.pos += 2);
            }
            return t.prototype.encode = function(t) {
                var e, n, r, i, o;
                for(n = new J(L.call(this.raw.data)), e = r = 0, i = (o = this.glyphIDs).length; r < i; e = ++r)o[e], n.pos = this.glyphOffsets[e];
                return n.data;
            }, t;
        }(), F = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, h), e.prototype.tag = "loca", e.prototype.parse = function(r) {
                var t;
                return r.pos = this.offset, t = this.file.head.indexToLocFormat, this.offsets = 0 === t ? (function() {
                    var t, e, n;
                    for(n = [], t = 0, e = this.length; t < e; t += 2)n.push(2 * r.readUInt16());
                    return n;
                }).call(this) : (function() {
                    var t, e, n;
                    for(n = [], t = 0, e = this.length; t < e; t += 4)n.push(r.readUInt32());
                    return n;
                }).call(this);
            }, e.prototype.indexOf = function(t) {
                return this.offsets[t];
            }, e.prototype.lengthOf = function(t) {
                return this.offsets[t + 1] - this.offsets[t];
            }, e.prototype.encode = function(t, e) {
                for(var n = new Uint32Array(this.offsets.length), r = 0, i = 0, o = 0; o < n.length; ++o)if (n[o] = r, i < e.length && e[i] == o) {
                    ++i, n[o] = r;
                    var a = this.offsets[o], s = this.offsets[o + 1] - a;
                    0 < s && (r += s);
                }
                for(var l = new Array(4 * n.length), h = 0; h < n.length; ++h)l[4 * h + 3] = 255 & n[h], l[4 * h + 2] = (65280 & n[h]) >> 8, l[4 * h + 1] = (16711680 & n[h]) >> 16, l[4 * h] = (4278190080 & n[h]) >> 24;
                return l;
            }, e;
        }(), P = function() {
            function t(t) {
                this.font = t, this.subset = {}, this.unicodes = {}, this.next = 33;
            }
            return t.prototype.generateCmap = function() {
                var t, e, n, r, i;
                for(e in r = this.font.cmap.tables[0].codeMap, t = {}, i = this.subset)n = i[e], t[e] = r[n];
                return t;
            }, t.prototype.glyphsFor = function(t) {
                var e, n, r, i, o, a, s;
                for(r = {}, o = 0, a = t.length; o < a; o++)r[i = t[o]] = this.font.glyf.glyphFor(i);
                for(i in e = [], r)(null != (n = r[i]) ? n.compound : void 0) && e.push.apply(e, n.glyphIDs);
                if (0 < e.length) for(i in s = this.glyphsFor(e))n = s[i], r[i] = n;
                return r;
            }, t.prototype.encode = function(t, e) {
                var n, r, i, o, a, s, l, h, u, c, f, p, d, g, m;
                for(r in n = y.encode(this.generateCmap(), "unicode"), o = this.glyphsFor(t), f = {
                    0: 0
                }, m = n.charMap)f[(s = m[r]).old] = s.new;
                for(p in c = n.maxGlyphID, o)p in f || (f[p] = c++);
                return h = function(t) {
                    var e, n;
                    for(e in n = {}, t)n[t[e]] = e;
                    return n;
                }(f), u = Object.keys(h).sort(function(t, e) {
                    return t - e;
                }), d = function() {
                    var t, e, n;
                    for(n = [], t = 0, e = u.length; t < e; t++)a = u[t], n.push(h[a]);
                    return n;
                }(), i = this.font.glyf.encode(o, d, f), l = this.font.loca.encode(i.offsets, d), g = {
                    cmap: this.font.cmap.raw(),
                    glyf: i.table,
                    loca: l,
                    hmtx: this.font.hmtx.raw(),
                    hhea: this.font.hhea.raw(),
                    maxp: this.font.maxp.raw(),
                    post: this.font.post.raw(),
                    name: this.font.name.raw(),
                    head: this.font.head.encode(e)
                }, this.font.os2.exists && (g["OS/2"] = this.font.os2.raw()), this.font.directory.encode(g);
            }, t;
        }();
        t.API.PDFObject = function() {
            var o;
            function a() {}
            return o = function(t, e) {
                return (Array(e + 1).join("0") + t).slice(-e);
            }, a.convert = function(r) {
                var i, t, e, n;
                if (Array.isArray(r)) return "[" + (function() {
                    var t, e, n;
                    for(n = [], t = 0, e = r.length; t < e; t++)i = r[t], n.push(a.convert(i));
                    return n;
                })().join(" ") + "]";
                if ("string" == typeof r) return "/" + r;
                if (null != r ? r.isString : void 0) return "(" + r + ")";
                if (r instanceof Date) return "(D:" + o(r.getUTCFullYear(), 4) + o(r.getUTCMonth(), 2) + o(r.getUTCDate(), 2) + o(r.getUTCHours(), 2) + o(r.getUTCMinutes(), 2) + o(r.getUTCSeconds(), 2) + "Z)";
                if ("[object Object]" !== ({}).toString.call(r)) return "" + r;
                for(t in e = [
                    "<<"
                ], r)n = r[t], e.push("/" + t + " " + a.convert(n));
                return e.push(">>"), e.join("\n");
            }, a;
        }();
    }(lt), /*
  # PNG.js
  # Copyright (c) 2011 Devon Govett
  # MIT LICENSE
  # 
  # 
  */ Nt = "undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof $parcel$global && $parcel$global || Function('return typeof this === "object" && this.content')() || Function("return this")(), Lt = function() {
        var h, n, r;
        function i(t) {
            var e, n, r, i, o, a, s, l, h, u, c, f, p, d;
            for(this.data = t, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.animation = null, this.text = {}, a = null;;){
                switch(e = this.readUInt32(), h = (function() {
                    var t, e;
                    for(e = [], t = 0; t < 4; ++t)e.push(String.fromCharCode(this.data[this.pos++]));
                    return e;
                }).call(this).join("")){
                    case "IHDR":
                        this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
                        break;
                    case "acTL":
                        this.animation = {
                            numFrames: this.readUInt32(),
                            numPlays: this.readUInt32() || 1 / 0,
                            frames: []
                        };
                        break;
                    case "PLTE":
                        this.palette = this.read(e);
                        break;
                    case "fcTL":
                        a && this.animation.frames.push(a), this.pos += 4, a = {
                            width: this.readUInt32(),
                            height: this.readUInt32(),
                            xOffset: this.readUInt32(),
                            yOffset: this.readUInt32()
                        }, o = this.readUInt16(), i = this.readUInt16() || 100, a.delay = 1e3 * o / i, a.disposeOp = this.data[this.pos++], a.blendOp = this.data[this.pos++], a.data = [];
                        break;
                    case "IDAT":
                    case "fdAT":
                        for("fdAT" === h && (this.pos += 4, e -= 4), t = (null != a ? a.data : void 0) || this.imgData, f = 0; 0 <= e ? f < e : e < f; 0 <= e ? ++f : --f)t.push(this.data[this.pos++]);
                        break;
                    case "tRNS":
                        switch(this.transparency = {}, this.colorType){
                            case 3:
                                if (r = this.palette.length / 3, this.transparency.indexed = this.read(e), this.transparency.indexed.length > r) throw new Error("More transparent colors than palette size");
                                if (0 < (u = r - this.transparency.indexed.length)) for(p = 0; 0 <= u ? p < u : u < p; 0 <= u ? ++p : --p)this.transparency.indexed.push(255);
                                break;
                            case 0:
                                this.transparency.grayscale = this.read(e)[0];
                                break;
                            case 2:
                                this.transparency.rgb = this.read(e);
                        }
                        break;
                    case "tEXt":
                        s = (c = this.read(e)).indexOf(0), l = String.fromCharCode.apply(String, c.slice(0, s)), this.text[l] = String.fromCharCode.apply(String, c.slice(s + 1));
                        break;
                    case "IEND":
                        return a && this.animation.frames.push(a), this.colors = (function() {
                            switch(this.colorType){
                                case 0:
                                case 3:
                                case 4:
                                    return 1;
                                case 2:
                                case 6:
                                    return 3;
                            }
                        }).call(this), this.hasAlphaChannel = 4 === (d = this.colorType) || 6 === d, n = this.colors + (this.hasAlphaChannel ? 1 : 0), this.pixelBitlength = this.bits * n, this.colorSpace = (function() {
                            switch(this.colors){
                                case 1:
                                    return "DeviceGray";
                                case 3:
                                    return "DeviceRGB";
                            }
                        }).call(this), void (this.imgData = new Uint8Array(this.imgData));
                    default:
                        this.pos += e;
                }
                if (this.pos += 4, this.pos > this.data.length) throw new Error("Incomplete or corrupt PNG file");
            }
        }
        i.load = function(t, e, n) {
            var r;
            return "function" == typeof e && (n = e), (r = new XMLHttpRequest).open("GET", t, !0), r.responseType = "arraybuffer", r.onload = function() {
                var t;
                return t = new i(new Uint8Array(r.response || r.mozResponseArrayBuffer)), "function" == typeof (null != e ? e.getContext : void 0) && t.render(e), "function" == typeof n ? n(t) : void 0;
            }, r.send(null);
        }, i.prototype.read = function(t) {
            var e, n;
            for(n = [], e = 0; 0 <= t ? e < t : t < e; 0 <= t ? ++e : --e)n.push(this.data[this.pos++]);
            return n;
        }, i.prototype.readUInt32 = function() {
            return this.data[this.pos++] << 24 | this.data[this.pos++] << 16 | this.data[this.pos++] << 8 | this.data[this.pos++];
        }, i.prototype.readUInt16 = function() {
            return this.data[this.pos++] << 8 | this.data[this.pos++];
        }, i.prototype.decodePixels = function(C) {
            var B = this.pixelBitlength / 8, j = new Uint8Array(this.width * this.height * B), E = 0, M = this;
            if (null == C && (C = this.imgData), 0 === C.length) return new Uint8Array(0);
            function t(t, e, n, r) {
                var i, o, a, s, l, h, u, c, f, p, d, g, m, y, v, w, b, x, N, L, A, S = Math.ceil((M.width - t) / n), _ = Math.ceil((M.height - e) / r), F = M.width == S && M.height == _;
                for(y = B * S, g = F ? j : new Uint8Array(y * _), h = C.length, o = m = 0; m < _ && E < h;){
                    switch(C[E++]){
                        case 0:
                            for(s = b = 0; b < y; s = b += 1)g[o++] = C[E++];
                            break;
                        case 1:
                            for(s = x = 0; x < y; s = x += 1)i = C[E++], l = s < B ? 0 : g[o - B], g[o++] = (i + l) % 256;
                            break;
                        case 2:
                            for(s = N = 0; N < y; s = N += 1)i = C[E++], a = (s - s % B) / B, v = m && g[(m - 1) * y + a * B + s % B], g[o++] = (v + i) % 256;
                            break;
                        case 3:
                            for(s = L = 0; L < y; s = L += 1)i = C[E++], a = (s - s % B) / B, l = s < B ? 0 : g[o - B], v = m && g[(m - 1) * y + a * B + s % B], g[o++] = (i + Math.floor((l + v) / 2)) % 256;
                            break;
                        case 4:
                            for(s = A = 0; A < y; s = A += 1)i = C[E++], a = (s - s % B) / B, l = s < B ? 0 : g[o - B], 0 === m ? v = w = 0 : (v = g[(m - 1) * y + a * B + s % B], w = a && g[(m - 1) * y + (a - 1) * B + s % B]), u = l + v - w, c = Math.abs(u - l), p = Math.abs(u - v), d = Math.abs(u - w), f = c <= p && c <= d ? l : p <= d ? v : w, g[o++] = (i + f) % 256;
                            break;
                        default:
                            throw new Error("Invalid filter algorithm: " + C[E - 1]);
                    }
                    if (!F) {
                        var P = ((e + m * r) * M.width + t) * B, k = m * y;
                        for(s = 0; s < S; s += 1){
                            for(var I = 0; I < B; I += 1)j[P++] = g[k++];
                            P += (n - 1) * B;
                        }
                    }
                    m++;
                }
            }
            return C = (C = new kt(C)).getBytes(), 1 == M.interlaceMethod ? (t(0, 0, 8, 8), t(4, 0, 8, 8), t(0, 4, 4, 8), t(2, 0, 4, 4), t(0, 2, 2, 4), t(1, 0, 2, 2), t(0, 1, 1, 2)) : t(0, 0, 1, 1), j;
        }, i.prototype.decodePalette = function() {
            var t, e, n, r, i, o, a, s, l;
            for(n = this.palette, o = this.transparency.indexed || [], i = new Uint8Array((o.length || 0) + n.length), r = 0, n.length, e = a = t = 0, s = n.length; a < s; e = a += 3)i[r++] = n[e], i[r++] = n[e + 1], i[r++] = n[e + 2], i[r++] = null != (l = o[t++]) ? l : 255;
            return i;
        }, i.prototype.copyToImageData = function(t, e) {
            var n, r, i, o, a, s, l, h, u, c, f;
            if (r = this.colors, u = null, n = this.hasAlphaChannel, this.palette.length && (u = null != (f = this._decodedPalette) ? f : this._decodedPalette = this.decodePalette(), r = 4, n = !0), h = (i = t.data || t).length, a = u || e, o = s = 0, 1 === r) for(; o < h;)l = u ? 4 * e[o / 4] : s, c = a[l++], i[o++] = c, i[o++] = c, i[o++] = c, i[o++] = n ? a[l++] : 255, s = l;
            else for(; o < h;)l = u ? 4 * e[o / 4] : s, i[o++] = a[l++], i[o++] = a[l++], i[o++] = a[l++], i[o++] = n ? a[l++] : 255, s = l;
        }, i.prototype.decode = function() {
            var t;
            return t = new Uint8Array(this.width * this.height * 4), this.copyToImageData(t, this.decodePixels()), t;
        };
        try {
            n = Nt.document.createElement("canvas"), r = n.getContext("2d");
        } catch (t) {
            return -1;
        }
        return h = function(t) {
            var e;
            return r.width = t.width, r.height = t.height, r.clearRect(0, 0, t.width, t.height), r.putImageData(t, 0, 0), (e = new Image).src = n.toDataURL(), e;
        }, i.prototype.decodeFrames = function(t) {
            var e, n, r, i, o, a, s, l;
            if (this.animation) {
                for(l = [], n = o = 0, a = (s = this.animation.frames).length; o < a; n = ++o)e = s[n], r = t.createImageData(e.width, e.height), i = this.decodePixels(new Uint8Array(e.data)), this.copyToImageData(r, i), e.imageData = r, l.push(e.image = h(r));
                return l;
            }
        }, i.prototype.renderFrame = function(t, e) {
            var n, r, i;
            return n = (r = this.animation.frames)[e], i = r[e - 1], 0 === e && t.clearRect(0, 0, this.width, this.height), 1 === (null != i ? i.disposeOp : void 0) ? t.clearRect(i.xOffset, i.yOffset, i.width, i.height) : 2 === (null != i ? i.disposeOp : void 0) && t.putImageData(i.imageData, i.xOffset, i.yOffset), 0 === n.blendOp && t.clearRect(n.xOffset, n.yOffset, n.width, n.height), t.drawImage(n.image, n.xOffset, n.yOffset);
        }, i.prototype.animate = function(n) {
            var r, i, o, a, s, t, l = this;
            return i = 0, t = this.animation, a = t.numFrames, o = t.frames, s = t.numPlays, (r = function() {
                var t, e;
                if (t = i++ % a, e = o[t], l.renderFrame(n, t), 1 < a && i / a < s) return l.animation._timeout = setTimeout(r, e.delay);
            })();
        }, i.prototype.stopAnimation = function() {
            var t;
            return clearTimeout(null != (t = this.animation) ? t._timeout : void 0);
        }, i.prototype.render = function(t) {
            var e, n;
            return t._png && t._png.stopAnimation(), t._png = this, t.width = this.width, t.height = this.height, e = t.getContext("2d"), this.animation ? (this.decodeFrames(e), this.animate(e)) : (n = e.createImageData(this.width, this.height), this.copyToImageData(n, this.decodePixels()), e.putImageData(n, 0, 0));
        }, i;
    }(), Nt.PNG = Lt;
    /*
   * Extracted from pdf.js
   * https://github.com/andreasgal/pdf.js
   *
   * Copyright (c) 2011 Mozilla Foundation
   *
   * Contributors: Andreas Gal <gal@mozilla.com>
   *               Chris G Jones <cjones@mozilla.com>
   *               Shaon Barman <shaon.barman@gmail.com>
   *               Vivien Nicolas <21@vingtetun.org>
   *               Justin D'Arcangelo <justindarc@gmail.com>
   *               Yury Delendik
   *
   * 
   */ var Pt = function() {
        function t() {
            this.pos = 0, this.bufferLength = 0, this.eof = !1, this.buffer = null;
        }
        return t.prototype = {
            ensureBuffer: function(t) {
                var e = this.buffer, n = e ? e.byteLength : 0;
                if (t < n) return e;
                for(var r = 512; r < t;)r <<= 1;
                for(var i = new Uint8Array(r), o = 0; o < n; ++o)i[o] = e[o];
                return this.buffer = i;
            },
            getByte: function() {
                for(var t = this.pos; this.bufferLength <= t;){
                    if (this.eof) return null;
                    this.readBlock();
                }
                return this.buffer[this.pos++];
            },
            getBytes: function(t) {
                var e = this.pos;
                if (t) {
                    this.ensureBuffer(e + t);
                    for(var n = e + t; !this.eof && this.bufferLength < n;)this.readBlock();
                    var r = this.bufferLength;
                    r < n && (n = r);
                } else {
                    for(; !this.eof;)this.readBlock();
                    n = this.bufferLength;
                }
                return this.pos = n, this.buffer.subarray(e, n);
            },
            lookChar: function() {
                for(var t = this.pos; this.bufferLength <= t;){
                    if (this.eof) return null;
                    this.readBlock();
                }
                return String.fromCharCode(this.buffer[this.pos]);
            },
            getChar: function() {
                for(var t = this.pos; this.bufferLength <= t;){
                    if (this.eof) return null;
                    this.readBlock();
                }
                return String.fromCharCode(this.buffer[this.pos++]);
            },
            makeSubStream: function(t, e, n) {
                for(var r = t + e; this.bufferLength <= r && !this.eof;)this.readBlock();
                return new Stream(this.buffer, t, e, n);
            },
            skip: function(t) {
                t || (t = 1), this.pos += t;
            },
            reset: function() {
                this.pos = 0;
            }
        }, t;
    }(), kt = function() {
        if ("undefined" != typeof Uint32Array) {
            var k = new Uint32Array([
                16,
                17,
                18,
                0,
                8,
                7,
                9,
                6,
                10,
                5,
                11,
                4,
                12,
                3,
                13,
                2,
                14,
                1,
                15
            ]), I = new Uint32Array([
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                65547,
                65549,
                65551,
                65553,
                131091,
                131095,
                131099,
                131103,
                196643,
                196651,
                196659,
                196667,
                262211,
                262227,
                262243,
                262259,
                327811,
                327843,
                327875,
                327907,
                258,
                258,
                258
            ]), C = new Uint32Array([
                1,
                2,
                3,
                4,
                65541,
                65543,
                131081,
                131085,
                196625,
                196633,
                262177,
                262193,
                327745,
                327777,
                393345,
                393409,
                459009,
                459137,
                524801,
                525057,
                590849,
                591361,
                657409,
                658433,
                724993,
                727041,
                794625,
                798721,
                868353,
                876545
            ]), B = [
                new Uint32Array([
                    459008,
                    524368,
                    524304,
                    524568,
                    459024,
                    524400,
                    524336,
                    590016,
                    459016,
                    524384,
                    524320,
                    589984,
                    524288,
                    524416,
                    524352,
                    590048,
                    459012,
                    524376,
                    524312,
                    589968,
                    459028,
                    524408,
                    524344,
                    590032,
                    459020,
                    524392,
                    524328,
                    59e4,
                    524296,
                    524424,
                    524360,
                    590064,
                    459010,
                    524372,
                    524308,
                    524572,
                    459026,
                    524404,
                    524340,
                    590024,
                    459018,
                    524388,
                    524324,
                    589992,
                    524292,
                    524420,
                    524356,
                    590056,
                    459014,
                    524380,
                    524316,
                    589976,
                    459030,
                    524412,
                    524348,
                    590040,
                    459022,
                    524396,
                    524332,
                    590008,
                    524300,
                    524428,
                    524364,
                    590072,
                    459009,
                    524370,
                    524306,
                    524570,
                    459025,
                    524402,
                    524338,
                    590020,
                    459017,
                    524386,
                    524322,
                    589988,
                    524290,
                    524418,
                    524354,
                    590052,
                    459013,
                    524378,
                    524314,
                    589972,
                    459029,
                    524410,
                    524346,
                    590036,
                    459021,
                    524394,
                    524330,
                    590004,
                    524298,
                    524426,
                    524362,
                    590068,
                    459011,
                    524374,
                    524310,
                    524574,
                    459027,
                    524406,
                    524342,
                    590028,
                    459019,
                    524390,
                    524326,
                    589996,
                    524294,
                    524422,
                    524358,
                    590060,
                    459015,
                    524382,
                    524318,
                    589980,
                    459031,
                    524414,
                    524350,
                    590044,
                    459023,
                    524398,
                    524334,
                    590012,
                    524302,
                    524430,
                    524366,
                    590076,
                    459008,
                    524369,
                    524305,
                    524569,
                    459024,
                    524401,
                    524337,
                    590018,
                    459016,
                    524385,
                    524321,
                    589986,
                    524289,
                    524417,
                    524353,
                    590050,
                    459012,
                    524377,
                    524313,
                    589970,
                    459028,
                    524409,
                    524345,
                    590034,
                    459020,
                    524393,
                    524329,
                    590002,
                    524297,
                    524425,
                    524361,
                    590066,
                    459010,
                    524373,
                    524309,
                    524573,
                    459026,
                    524405,
                    524341,
                    590026,
                    459018,
                    524389,
                    524325,
                    589994,
                    524293,
                    524421,
                    524357,
                    590058,
                    459014,
                    524381,
                    524317,
                    589978,
                    459030,
                    524413,
                    524349,
                    590042,
                    459022,
                    524397,
                    524333,
                    590010,
                    524301,
                    524429,
                    524365,
                    590074,
                    459009,
                    524371,
                    524307,
                    524571,
                    459025,
                    524403,
                    524339,
                    590022,
                    459017,
                    524387,
                    524323,
                    589990,
                    524291,
                    524419,
                    524355,
                    590054,
                    459013,
                    524379,
                    524315,
                    589974,
                    459029,
                    524411,
                    524347,
                    590038,
                    459021,
                    524395,
                    524331,
                    590006,
                    524299,
                    524427,
                    524363,
                    590070,
                    459011,
                    524375,
                    524311,
                    524575,
                    459027,
                    524407,
                    524343,
                    590030,
                    459019,
                    524391,
                    524327,
                    589998,
                    524295,
                    524423,
                    524359,
                    590062,
                    459015,
                    524383,
                    524319,
                    589982,
                    459031,
                    524415,
                    524351,
                    590046,
                    459023,
                    524399,
                    524335,
                    590014,
                    524303,
                    524431,
                    524367,
                    590078,
                    459008,
                    524368,
                    524304,
                    524568,
                    459024,
                    524400,
                    524336,
                    590017,
                    459016,
                    524384,
                    524320,
                    589985,
                    524288,
                    524416,
                    524352,
                    590049,
                    459012,
                    524376,
                    524312,
                    589969,
                    459028,
                    524408,
                    524344,
                    590033,
                    459020,
                    524392,
                    524328,
                    590001,
                    524296,
                    524424,
                    524360,
                    590065,
                    459010,
                    524372,
                    524308,
                    524572,
                    459026,
                    524404,
                    524340,
                    590025,
                    459018,
                    524388,
                    524324,
                    589993,
                    524292,
                    524420,
                    524356,
                    590057,
                    459014,
                    524380,
                    524316,
                    589977,
                    459030,
                    524412,
                    524348,
                    590041,
                    459022,
                    524396,
                    524332,
                    590009,
                    524300,
                    524428,
                    524364,
                    590073,
                    459009,
                    524370,
                    524306,
                    524570,
                    459025,
                    524402,
                    524338,
                    590021,
                    459017,
                    524386,
                    524322,
                    589989,
                    524290,
                    524418,
                    524354,
                    590053,
                    459013,
                    524378,
                    524314,
                    589973,
                    459029,
                    524410,
                    524346,
                    590037,
                    459021,
                    524394,
                    524330,
                    590005,
                    524298,
                    524426,
                    524362,
                    590069,
                    459011,
                    524374,
                    524310,
                    524574,
                    459027,
                    524406,
                    524342,
                    590029,
                    459019,
                    524390,
                    524326,
                    589997,
                    524294,
                    524422,
                    524358,
                    590061,
                    459015,
                    524382,
                    524318,
                    589981,
                    459031,
                    524414,
                    524350,
                    590045,
                    459023,
                    524398,
                    524334,
                    590013,
                    524302,
                    524430,
                    524366,
                    590077,
                    459008,
                    524369,
                    524305,
                    524569,
                    459024,
                    524401,
                    524337,
                    590019,
                    459016,
                    524385,
                    524321,
                    589987,
                    524289,
                    524417,
                    524353,
                    590051,
                    459012,
                    524377,
                    524313,
                    589971,
                    459028,
                    524409,
                    524345,
                    590035,
                    459020,
                    524393,
                    524329,
                    590003,
                    524297,
                    524425,
                    524361,
                    590067,
                    459010,
                    524373,
                    524309,
                    524573,
                    459026,
                    524405,
                    524341,
                    590027,
                    459018,
                    524389,
                    524325,
                    589995,
                    524293,
                    524421,
                    524357,
                    590059,
                    459014,
                    524381,
                    524317,
                    589979,
                    459030,
                    524413,
                    524349,
                    590043,
                    459022,
                    524397,
                    524333,
                    590011,
                    524301,
                    524429,
                    524365,
                    590075,
                    459009,
                    524371,
                    524307,
                    524571,
                    459025,
                    524403,
                    524339,
                    590023,
                    459017,
                    524387,
                    524323,
                    589991,
                    524291,
                    524419,
                    524355,
                    590055,
                    459013,
                    524379,
                    524315,
                    589975,
                    459029,
                    524411,
                    524347,
                    590039,
                    459021,
                    524395,
                    524331,
                    590007,
                    524299,
                    524427,
                    524363,
                    590071,
                    459011,
                    524375,
                    524311,
                    524575,
                    459027,
                    524407,
                    524343,
                    590031,
                    459019,
                    524391,
                    524327,
                    589999,
                    524295,
                    524423,
                    524359,
                    590063,
                    459015,
                    524383,
                    524319,
                    589983,
                    459031,
                    524415,
                    524351,
                    590047,
                    459023,
                    524399,
                    524335,
                    590015,
                    524303,
                    524431,
                    524367,
                    590079
                ]),
                9
            ], j = [
                new Uint32Array([
                    327680,
                    327696,
                    327688,
                    327704,
                    327684,
                    327700,
                    327692,
                    327708,
                    327682,
                    327698,
                    327690,
                    327706,
                    327686,
                    327702,
                    327694,
                    0,
                    327681,
                    327697,
                    327689,
                    327705,
                    327685,
                    327701,
                    327693,
                    327709,
                    327683,
                    327699,
                    327691,
                    327707,
                    327687,
                    327703,
                    327695,
                    0
                ]),
                5
            ];
            return (t.prototype = Object.create(Pt.prototype)).getBits = function(t) {
                for(var e, n = this.codeSize, r = this.codeBuf, i = this.bytes, o = this.bytesPos; n < t;)void 0 === (e = i[o++]) && E("Bad encoding in flate stream"), r |= e << n, n += 8;
                return e = r & (1 << t) - 1, this.codeBuf = r >> t, this.codeSize = n -= t, this.bytesPos = o, e;
            }, t.prototype.getCode = function(t) {
                for(var e = t[0], n = t[1], r = this.codeSize, i = this.codeBuf, o = this.bytes, a = this.bytesPos; r < n;){
                    var s;
                    void 0 === (s = o[a++]) && E("Bad encoding in flate stream"), i |= s << r, r += 8;
                }
                var l = e[i & (1 << n) - 1], h = l >> 16, u = 65535 & l;
                return (0 == r || r < h || 0 == h) && E("Bad encoding in flate stream"), this.codeBuf = i >> h, this.codeSize = r - h, this.bytesPos = a, u;
            }, t.prototype.generateHuffmanTable = function(t) {
                for(var e = t.length, n = 0, r = 0; r < e; ++r)t[r] > n && (n = t[r]);
                for(var i = 1 << n, o = new Uint32Array(i), a = 1, s = 0, l = 2; a <= n; ++a, s <<= 1, l <<= 1)for(var h = 0; h < e; ++h)if (t[h] == a) {
                    var u = 0, c = s;
                    for(r = 0; r < a; ++r)u = u << 1 | 1 & c, c >>= 1;
                    for(r = u; r < i; r += l)o[r] = a << 16 | h;
                    ++s;
                }
                return [
                    o,
                    n
                ];
            }, t.prototype.readBlock = function() {
                function t(t, e, n, r, i) {
                    for(var o = t.getBits(n) + r; 0 < o--;)e[l++] = i;
                }
                var e = this.getBits(3);
                if (1 & e && (this.eof = !0), 0 != (e >>= 1)) {
                    var n, r;
                    if (1 == e) n = B, r = j;
                    else if (2 == e) {
                        for(var i = this.getBits(5) + 257, o = this.getBits(5) + 1, a = this.getBits(4) + 4, s = Array(k.length), l = 0; l < a;)s[k[l++]] = this.getBits(3);
                        for(var h = this.generateHuffmanTable(s), u = 0, c = (l = 0, i + o), f = new Array(c); l < c;){
                            var p = this.getCode(h);
                            16 == p ? t(this, f, 2, 3, u) : 17 == p ? t(this, f, 3, 3, u = 0) : 18 == p ? t(this, f, 7, 11, u = 0) : f[l++] = u = p;
                        }
                        n = this.generateHuffmanTable(f.slice(0, i)), r = this.generateHuffmanTable(f.slice(i, c));
                    } else E("Unknown block type in flate stream");
                    for(var d = (_ = this.buffer) ? _.length : 0, g = this.bufferLength;;){
                        var m = this.getCode(n);
                        if (m < 256) d <= g + 1 && (d = (_ = this.ensureBuffer(g + 1)).length), _[g++] = m;
                        else {
                            if (256 == m) return void (this.bufferLength = g);
                            var y = (m = I[m -= 257]) >> 16;
                            0 < y && (y = this.getBits(y));
                            u = (65535 & m) + y;
                            m = this.getCode(r), 0 < (y = (m = C[m]) >> 16) && (y = this.getBits(y));
                            var v = (65535 & m) + y;
                            d <= g + u && (d = (_ = this.ensureBuffer(g + u)).length);
                            for(var w = 0; w < u; ++w, ++g)_[g] = _[g - v];
                        }
                    }
                } else {
                    var b, x = this.bytes, N = this.bytesPos;
                    void 0 === (b = x[N++]) && E("Bad block header in flate stream");
                    var L = b;
                    void 0 === (b = x[N++]) && E("Bad block header in flate stream"), L |= b << 8, void 0 === (b = x[N++]) && E("Bad block header in flate stream");
                    var A = b;
                    void 0 === (b = x[N++]) && E("Bad block header in flate stream"), (A |= b << 8) != (65535 & ~L) && E("Bad uncompressed block length in flate stream"), this.codeBuf = 0, this.codeSize = 0;
                    var S = this.bufferLength, _ = this.ensureBuffer(S + L), F = S + L;
                    this.bufferLength = F;
                    for(var P = S; P < F; ++P){
                        if (void 0 === (b = x[N++])) {
                            this.eof = !0;
                            break;
                        }
                        _[P] = b;
                    }
                    this.bytesPos = N;
                }
            }, t;
        }
        function E(t) {
            throw new Error(t);
        }
        function t(t) {
            var e = 0, n = t[e++], r = t[e++];
            -1 != n && -1 != r || E("Invalid header in flate stream"), 8 != (15 & n) && E("Unknown compression method in flate stream"), ((n << 8) + r) % 31 != 0 && E("Bad FCHECK in flate stream"), 32 & r && E("FDICT bit set in flate stream"), this.bytes = t, this.bytesPos = 2, this.codeSize = 0, this.codeBuf = 0, Pt.call(this);
        }
    }();
    window.tmp = kt;
});
try {
    $d4a0bfe8d6ddfc13$exports = jsPDF;
} catch (t) {}


var $0eaa8c8dd0ff6bbe$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0eaa8c8dd0ff6bbe$export$efb60ace09439e95 = /** @class */ function(_super) {
    $0eaa8c8dd0ff6bbe$var$__extends(ReportModal, _super);
    function ReportModal(props) {
        var _this = _super.call(this, props) || this;
        _this.gridDomId = "SR-REPORTS-GRID";
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.getPdf = function() {
            var el = document.getElementById(_this.gridDomId);
            (0, (/*@__PURE__*/$parcel$interopDefault($5a197630e9446689$exports)))(el, {
                onclone: function(doc) {},
                allowTaint: true
            }).then(function(canvas) {
                var img = canvas.toDataURL("image/jpeg", 1.0);
                console.log("canvas width", canvas.width);
                console.log("canvas height", canvas.height);
                var canvasWidthForced = 1724;
                var imgWidth = 202;
                // var pageHeight = 298; 
                // var pageHeight = 318; 
                var pageHeight = 298;
                var imgHeight = canvas.height * imgWidth / canvasWidthForced;
                var heightLeft = imgHeight;
                var pdf = new (0, (/*@__PURE__*/$parcel$interopDefault($d4a0bfe8d6ddfc13$exports)))("p", "mm", "a4");
                var position = 0;
                pdf.addImage(img, "PNG", 4, position + 8, imgWidth, imgHeight);
                heightLeft -= pageHeight;
                while(heightLeft >= 0){
                    position = heightLeft - imgHeight;
                    pdf.addPage();
                    pdf.addImage(img, "PNG", 4, position + 12, imgWidth, imgHeight);
                    heightLeft -= pageHeight;
                }
                window.open(URL.createObjectURL(pdf.output("blob")));
            });
        };
        _this.calculateTotal(props.gridData);
        if (props.startDate && props.endDate) _this.setState({
            header: "Remittance Report | ".concat((0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(props.startDate).format("MMMM DD, YYYY"), " to ").concat((0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(props.endDate).format("MMMM DD, YYYY"))
        });
        else if (props.startDate && props.endDate) _this.setState({
            header: "Remittance Report | ".concat((0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(props.startDate).format("MMMM DD, YYYY"))
        });
        else _this.setState({
            header: "Remittance Report"
        });
        return _this;
    }
    ReportModal.prototype.calculateTotal = function(gridData) {
        var _this = this;
        var calc = 0;
        gridData.forEach(function(member) {
            // if (member.isCleared) {
            //   calc += member.amount;
            // }
            if (_this.props.status === "approved") {
                if (member.isCleared) calc += member.amount;
            } else if (!_this.props.status) calc += member.amount;
            else if (!member.isCleared) calc += member.amount;
        });
        this.setState({
            total: calc
        });
    };
    ReportModal.prototype.componentDidMount = function() {
        document.body.classList.add("scroll-lock");
    };
    ReportModal.prototype.componentWillUnmount = function() {
        document.body.classList.remove("scroll-lock");
    };
    ReportModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "anglo-modal container-fluid",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Report generation")), (0, $LjoDx.h)("div", {
            class: "col-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary",
            onClick: this.getPdf
        }, "Print PDF")), (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-remittance-report",
            id: this.gridDomId
        }, (0, $LjoDx.h)("div", {
            class: "anglo-remittance-report__head text-capitalize"
        }, state.header, " ", props.status ? " | Status - " + props.status : ""), (0, $LjoDx.h)("div", {
            class: "data-grid dash-remittance__grid-container__grid mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__col col-long"
        }, "Date of Transaction"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-long"
        }, "Area"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-long"
        }, "Sales Agent"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-long"
        }, "Bank Account"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Amount"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-short"
        }, "Status"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-long"
        }, "OR Number")), props.gridData.map(function(row, index) {
            // max of 32 per page
            // if (props.status !== 'approved' && !row.isCleared) {
            var indexPageBreak = index % 35 == 0 && index != 0 && index <= 35;
            var indexNextPage = index % 35 == 0 && index >= 70;
            return (0, $LjoDx.h)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("data-grid__row", {
                    "page-end": indexPageBreak,
                    "page-beginning": indexNextPage
                })
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col col-long"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(row.dateOfTransaction).format("MMMM DD, YYYY")), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-long"
            }, row.area), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-long"
            }, row.salesAgent), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-long"
            }, row.receivingBankAccount), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(row.amount)), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-short text-capitalize"
            }, row.stage), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-long text-capitalize"
            }, row.receiptNumber));
        // }
        })), (0, $LjoDx.h)("div", {
            class: "anglo-remittance-report__total mt-3 mb-5"
        }, "Total: ", (0, $LjoDx.h)("b", null, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(state.total), " "))))));
    };
    return ReportModal;
}((0, $3f2ba7f1e3532510$exports.Modal));



var $979857f2f335f0b4$exports = {};

$parcel$export($979857f2f335f0b4$exports, "ClearRemittanceModal", () => $979857f2f335f0b4$export$db8b063975dad2f4);

var $LjoDx = parcelRequire("LjoDx");










var $979857f2f335f0b4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $979857f2f335f0b4$export$db8b063975dad2f4 = /** @class */ function(_super) {
    $979857f2f335f0b4$var$__extends(ClearRemittanceModal, _super);
    function ClearRemittanceModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $ea864d6f3cd9447e$export$4107b97e676630a2),
                payload: {
                    remittanceId: _this.props.remittance.remittanceId,
                    receiptNumber: form.fields["receiptNumber"].value
                }
            });
        };
        _this.createForm();
        return _this;
    }
    ClearRemittanceModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "receiptNumber": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    ClearRemittanceModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var remittance$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(app) {
            return app.remittance;
        }));
        this.subs.push(remittance$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(remittance) {
            return remittance.approveRequestState;
        })).subscribe(function(reqState) {
            _this.setState({
                submitStatus: reqState
            });
            if (reqState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) _this.doModalClose();
        }));
        this.initialStoreDispatches();
    };
    ClearRemittanceModal.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
    };
    ClearRemittanceModal.prototype.componentWillUnmount = function() {
        this.subs.forEach(function(s) {
            return s.unsubscribe();
        });
    };
    ClearRemittanceModal.prototype.getSpinnerBlock = function(state) {
        if (state.submitStatus === (0, $ad7802471dc8ad45$export$93ca241731165d07)) return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    ClearRemittanceModal.prototype.render = function(props, state) {
        var _this = this;
        var form = state.form;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Clear Remittance | ", (0, $LjoDx.h)("small", null, props.remittance.remittanceId))), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-2"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Official Receipt Number*"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["receiptNumber"])
            }),
            value: form.fields["receiptNumber"].value,
            placeholder: "",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "receiptNumber")
        })), (0, $LjoDx.h)("div", {
            class: "col-2 offset-8 mt-4"
        }, this.getSpinnerBlock(state)), (0, $LjoDx.h)("div", {
            class: "col-2 mt-4"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !form.isValid
        }, "Clear Remittance"))));
    };
    return ClearRemittanceModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $204820985097eb0a$exports = {};

$parcel$export($204820985097eb0a$exports, "AutocompleteSearch", () => $204820985097eb0a$export$f06f67794055e0fa);

var $LjoDx = parcelRequire("LjoDx");





var $204820985097eb0a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $204820985097eb0a$export$f06f67794055e0fa = /** @class */ function(_super) {
    $204820985097eb0a$var$__extends(AutocompleteSearch, _super);
    function AutocompleteSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.onSearchInputChange = (0, $8cf160f30389af36$export$61fc7d43ac8f84b0)(function(event) {
            var searchTerm = event.target.value;
            if (searchTerm && searchTerm.length >= 2) _this.getSearchResults(searchTerm);
            _this.setState({
                search: searchTerm
            });
        }, 500);
        _this.onResultClick = function(result) {
            var label = "".concat(result.firstName, " ").concat(result.lastName);
            _this.setState({
                search: label,
                searchResults: [],
                isSearchResultsVisible: false
            });
            console.log("result", result);
            _this.props.onResultSelected(result);
        };
        _this.setState({
            searchResults: []
        });
        return _this;
    }
    AutocompleteSearch.prototype.getSearchResults = function(searchTerm) {
        var _this = this;
        var params = {
            userSearch: searchTerm
        };
        var searchUrl = this.props.searchUrl ? this.props.searchUrl : "supervisor";
        var axiosPromise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/").concat(searchUrl), {
            params: params,
            withCredentials: true
        });
        axiosPromise.then(function(response) {
            var results = response.data.results;
            _this.setState({
                searchResults: results,
                isSearchResultsVisible: true
            });
        }).catch(function(errResp) {
            var message = errResp.response.data.msg ? errResp.response.data.msg : null;
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to retrieve search",
                message: message,
                duration: 3000
            });
        });
    };
    AutocompleteSearch.prototype.render = function(props, state) {
        var _this = this;
        var result = function(member, index) {
            return (0, $LjoDx.h)("p", {
                onClick: _this.onResultClick.bind(_this, member)
            }, member.firstName, " ", member.lastName, " ", (0, $LjoDx.h)("i", null, "(", member.username, ")"));
        };
        return (0, $LjoDx.h)("div", {
            class: "autocomplete-search"
        }, (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("autocomplete-search__input form-control"),
            placeholder: props.placeholder ? props.placeholder : "Search by Supervisor",
            value: state.search,
            onInput: this.onSearchInputChange.bind(this)
        }), (0, $LjoDx.h)("span", {
            class: "autocomplete-search__icon"
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-search"
        })), (0, $LjoDx.h)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("autocomplete-search__results", {
                active: state.isSearchResultsVisible
            })
        }, this.state.searchResults.map(function(member, i) {
            return result(member, i);
        })));
    };
    return AutocompleteSearch;
}((0, $LjoDx.Component));


var $787290684425694f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $787290684425694f$export$8ec3d08588d2eeda = 20;
var $787290684425694f$export$1ec54e393e95ca5a = /** @class */ function(_super) {
    $787290684425694f$var$__extends(DashRemittance, _super);
    function DashRemittance(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.handleDatepickerValidation = function(date, fieldName) {
            var currentForm = _this.state.filters;
            // Manually do this because in order to follow the 
            // hopplerLinkstate validation system
            var clonedFields = {};
            for(var k in currentForm.fields){
                var prevField = currentForm.fields[k];
                clonedFields[k] = new (0, $49e398741f5b1a93$export$a455218a85c89869)(prevField.validators, prevField.customValidators, prevField.value);
                clonedFields[k].isValid = prevField.isValid;
            }
            var clone = new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(clonedFields);
            clone.fields[fieldName].value = date;
            clone.fields[fieldName].isPristine = false;
            // clone.fields[fieldName].customValidators.forEach(a => a(clone.fields[fieldName], clone));
            _this.form$.next(clone);
        };
        _this.onFilterToggleClicked = function() {
            _this.setState({
                isFilterVisible: !_this.state.isFilterVisible
            });
        };
        _this.onModalClose = function() {
            _this.setState({
                isEditModalOpen: false,
                isDeleteModalOpen: false,
                isReportModalOpen: false,
                isClearModalOpen: false,
                reportGridData: null
            });
        };
        _this.getPortalModal = function(state) {
            if (state.isEditModalOpen) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-111"
            }, (0, $LjoDx.h)((0, $607cca298669fe2d$exports.RequestEditModal), {
                remittance: state.focusedRemitance,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-111"
            })));
            else if (state.isDeleteModalOpen) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-111"
            }, (0, $LjoDx.h)((0, $e85371888f2032cb$exports.RequestDeleteModal), {
                remittance: state.focusedRemitance,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-111"
            })));
            else if (state.isReportModalOpen) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container full-page",
                id: "anglo-modal-111"
            }, (0, $LjoDx.h)((0, $0eaa8c8dd0ff6bbe$exports.ReportModal), {
                gridData: state.reportGridData,
                status: state.filters.fields["stage"].value,
                startDate: state.filters.fields["startDate"].value,
                endDate: state.filters.fields["endDate"].value,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-111"
            })));
            else if (state.isClearModalOpen) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-111"
            }, (0, $LjoDx.h)((0, $979857f2f335f0b4$exports.ClearRemittanceModal), {
                remittance: state.focusedRemitance,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-111"
            })));
        };
        _this.onRequestEdit = function(row) {
            _this.setState({
                isEditModalOpen: true,
                focusedRemitance: row
            });
        };
        _this.onRequestDelete = function(row) {
            _this.setState({
                isDeleteModalOpen: true,
                focusedRemitance: row
            });
        };
        _this.onApproveRemit = function(row) {
            _this.setState({
                isClearModalOpen: true,
                focusedRemitance: row
            });
        };
        _this.openReportModal = function() {
            // this.setState({
            //   isEditModalOpen: false,
            //   isDeleteModalOpen: false,
            //   isReportModalOpen: true
            // });
            var filters = new Map();
            var fieldList = _this.state.filters.fields;
            for(var k in fieldList)if (fieldList[k].value) filters.set(k, fieldList[k].value);
            filters.set("pageSize", 5000);
            filters.set("page", 1);
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $ea864d6f3cd9447e$export$e7552e3670d2fd5b),
                payload: {
                    filters: filters
                }
            });
        };
        _this.openSupervisorReportModal = function() {
            // this.setState({
            //   isEditModalOpen: false,
            //   isDeleteModalOpen: false,
            //   isReportModalOpen: true
            // });
            var filters = new Map();
            var fieldList = _this.state.filters.fields;
            for(var k in fieldList)if (fieldList[k].value) filters.set(k, fieldList[k].value);
            filters.set("pageSize", 5000);
            filters.set("page", 1);
            filters.set("username", _this.state.currentUser.username);
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $ea864d6f3cd9447e$export$e7552e3670d2fd5b),
                payload: {
                    filters: filters
                }
            });
        };
        _this.applyFilters = function() {
            // let filters: Map<string, any> = new Map<string, any>();
            var filters = {};
            var fieldList = _this.state.filters.fields;
            for(var k in fieldList)if (fieldList[k].value) // filters.set(k, fieldList[k].value);
            filters[k] = fieldList[k].value;
            // when new filters are applied, always set back to first page
            filters["page"] = 1;
            _this.setState({
                currentPage: 1
            });
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $ea864d6f3cd9447e$export$e82cebb195cca37c),
                payload: {
                    filters: filters,
                    gridRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
                }
            });
        };
        _this.resetFilters = function() {
            var fieldList = _this.state.filters.fields;
            for(var k in fieldList)fieldList[k].value = null;
            var form = _this.state.filters;
            form.fields = fieldList;
            _this.resetStartDate();
            _this.resetEndDate();
            form["page"] = 1;
            _this.setState({
                filters: form
            });
        };
        _this.onStartDateSelected = function(date) {
            _this.handleDatepickerValidation(date, "startDate");
        };
        _this.onEndDateSelected = function(date) {
            _this.handleDatepickerValidation(date, "endDate");
        };
        _this.onSupervisorSearchChange = function(supervisor) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filters, "username", supervisor.username);
        };
        _this.resetStartDates = function(returned) {
            _this.resetStartDate = returned;
        };
        _this.resetEndDates = function(returned) {
            _this.resetEndDate = returned;
        };
        _this.onPageClicked = function(page) {
            var filters = {};
            var fieldList = _this.state.filters.fields;
            for(var k in fieldList)if (fieldList[k].value) // filters.set(k, fieldList[k].value);
            filters[k] = fieldList[k].value;
            filters["page"] = page;
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $ea864d6f3cd9447e$export$e82cebb195cca37c),
                payload: {
                    filters: filters
                }
            });
            _this.setState({
                currentPage: page
            });
        };
        _this.setState({
            currentPage: 1
        });
        _this.createForm();
        return _this;
    }
    DashRemittance.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "startDate": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "endDate": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "minAmount": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "maxAmount": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "isCleared": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "stage": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "username": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "receivingBankAccount": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            filters: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["filters"] = form;
            _this.setState(state);
        });
    };
    DashRemittance.prototype.componentDidMount = function() {
        var _this = this;
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.user;
        }));
        this.subs.push(user$.subscribe(function(user) {
            if (user.currentUser) _this.setState({
                currentUser: user.currentUser
            });
        }));
        var remittance$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.remittance;
        }));
        // set request state
        this.subs.push(remittance$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(remittance) {
            return remittance.gridRequestState;
        })).subscribe(function(gridRequestState) {
            _this.setState({
                gridRequestState: gridRequestState
            });
        }));
        // set grid data
        this.subs.push(remittance$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(remittance) {
            return remittance.remittanceGridData;
        })).subscribe(function(remittanceGridData) {
            _this.setState({
                remittanceGridData: remittanceGridData
            });
        }));
        this.subs.push(remittance$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(remittance) {
            return remittance.reportGridData;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(reportGridData) {
            if (reportGridData) {
                _this.setState({
                    reportGridData: reportGridData
                });
                _this.setState({
                    isEditModalOpen: false,
                    isDeleteModalOpen: false,
                    isReportModalOpen: true
                });
            }
        }));
        this.subs.push(remittance$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(remittance) {
            return remittance.total;
        })).subscribe(function(total) {
            if (total) {
                var pages = [];
                var limit = Math.ceil(total / $787290684425694f$export$8ec3d08588d2eeda);
                for(var i = 0; i < limit; i++)pages.push(i + 1);
                _this.setState({
                    pages: pages
                });
            }
        }));
        // set overall Total
        this.subs.push(remittance$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(remittance) {
            return remittance.overallTotal;
        })).subscribe(function(overallTotal) {
            _this.setState({
                overallTotal: overallTotal
            });
        }));
        // set curMonth Total
        this.subs.push(remittance$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(remittance) {
            return remittance.currentMonthTotal;
        })).subscribe(function(currentMonthTotal) {
            _this.setState({
                currentMonthTotal: currentMonthTotal
            });
        }));
        // set previousMonthTotal Total
        this.subs.push(remittance$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(remittance) {
            return remittance.previousMonthTotal;
        })).subscribe(function(previousMonthTotal) {
            _this.setState({
                previousMonthTotal: previousMonthTotal
            });
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.allBankAccounts;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(allBankAccounts) {
            if (allBankAccounts) _this.setState({
                allBankAccounts: allBankAccounts
            });
        }));
        this.initialStoreDispatches();
    };
    DashRemittance.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $ea864d6f3cd9447e$export$e82cebb195cca37c),
            payload: {
                filters: {
                    page: 1
                }
            }
        });
        store.dispatch({
            type: (0, $ea864d6f3cd9447e$export$ac8ddd8847849ab)
        });
        store.dispatch({
            type: (0, $ea864d6f3cd9447e$export$6846fb968bdf775b)
        });
        store.dispatch({
            type: (0, $4c71eb74f53637d3$export$74d61c62c586516a)
        });
    };
    DashRemittance.prototype.componentWillUnmount = function() {
        this.subs.forEach(function(s) {
            return s.unsubscribe();
        });
    };
    DashRemittance.prototype.getActions = function(state, row, index) {
        var _this = this;
        if (state.currentUser && state.currentUser.role == "role_supervisor") return (0, $LjoDx.h)("div", {
            class: "dropdown-menu",
            "aria-labelledby": "actions".concat(index)
        }, (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return _this.onRequestEdit(row);
            }
        }, "Request Edit"), (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return _this.onRequestDelete(row);
            }
        }, "Request Delete"));
        else return (0, $LjoDx.h)("div", {
            class: "dropdown-menu",
            "aria-labelledby": "actions".concat(index)
        }, (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return _this.onApproveRemit(row);
            }
        }, "Clear"));
    };
    DashRemittance.prototype.getGridBlock = function(props, state) {
        var _this = this;
        if (state.gridRequestState == (0, $ad7802471dc8ad45$export$93ca241731165d07)) return (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading..."));
        else if (state.gridRequestState == (0, $ad7802471dc8ad45$export$3ee3100c952bc770) && state.remittanceGridData.length > 0) return (0, $LjoDx.h)("div", {
            class: "data-grid dash-remittance__grid-container__grid"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Actions"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-short"
        }, "Remittance ID"), state.currentUser && state.currentUser.role != "role_supervisor" ? (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Remitter") : "", (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Bank Account"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Amount"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-long"
        }, "Date of Transaction"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-long"
        }, "Date Created"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Status"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Area"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-long"
        }, "Sales Agent"), state.currentUser && state.currentUser.role != "role_supervisor" ? (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Auditted") : "", state.currentUser && state.currentUser.role != "role_supervisor" ? (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "OR Number") : null), state.remittanceGridData.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                class: "data-grid__row",
                id: row.remittanceId
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, (0, $LjoDx.h)("div", {
                class: "dropright"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-outline-primary dropdown-toggle",
                type: "button",
                id: "actions".concat(index),
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false"
            }, "Select action"), _this.getActions(state, row, index))), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-short"
            }, row.remittanceId), state.currentUser && state.currentUser.role != "role_supervisor" ? (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.user.firstName, " ", row.user.lastName) : "", (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.receivingBankAccount), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "₱ ", (0, $9e0c3e3a397653e5$export$63ad841d70774900)(row.amount)), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-long"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(row.dateOfTransaction).format("MMMM DD, YYYY")), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-long"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(row.dateCreated).format("MMMM DD, YYYY hh:mm:ss A")), (0, $LjoDx.h)("div", {
                class: "data-grid__col text-capitalize"
            }, row.stage), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.area), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-long"
            }, row.salesAgent), state.currentUser && state.currentUser.role != "role_supervisor" ? (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.isCleared ? "Yes" : "No") : "", state.currentUser && state.currentUser.role != "role_supervisor" ? (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.receiptNumber) : "");
        }));
        else if (state.gridRequestState == (0, $ad7802471dc8ad45$export$3ee3100c952bc770) && state.remittanceGridData.length < 1) return (0, $LjoDx.h)("div", {
            class: "data-grid dash-remittance__grid-container__grid"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Actions"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-short"
        }, "Remittance ID"), state.currentUser && state.currentUser.role != "role_supervisor" ? (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Remitter") : "", (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Bank Account"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Amount"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-long"
        }, "Date of Transaction"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Status"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Area"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-long"
        }, "Sales Agent"), state.currentUser && state.currentUser.role != "role_supervisor" ? (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Auditted") : "", state.currentUser && state.currentUser.role != "role_supervisor" ? (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "OR Number") : null), (0, $LjoDx.h)("div", {
            class: "data-grid__row py-4 text-center align-items-center justify-content-center"
        }, "No available remittance data."));
    };
    DashRemittance.prototype.getFilterBlock = function(state) {
        var form = state.filters;
        if (state.isFilterVisible) return (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "dash-remittance__filter-row__filters"
        }, (0, $LjoDx.h)("div", {
            class: "row align-items-end"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Start date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: this.onStartDateSelected,
            initialValue: form.fields["startDate"].value,
            isValid: form.fields["startDate"].isValid,
            isPristine: form.fields["startDate"].isPristine,
            reset: this.resetStartDates
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "End date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: this.onEndDateSelected,
            initialValue: form.fields["endDate"].value,
            isValid: form.fields["endDate"].isValid,
            isPristine: form.fields["endDate"].isPristine,
            reset: this.resetEndDates
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mt-3 mt-md-0"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.resetFilters
        }, "Reset Filters")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mt-3 mt-md-0"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.applyFilters
        }, "Apply Filters"))), (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Mininmum Amount"), (0, $LjoDx.h)("input", {
            type: "number",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["minAmount"])
            }),
            value: form.fields["minAmount"].value,
            placeholder: "",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "minAmount")
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Maximum Amount"), (0, $LjoDx.h)("input", {
            type: "number",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["maxAmount"])
            }),
            value: form.fields["maxAmount"].value,
            placeholder: "",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "maxAmount")
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Status"), (0, $LjoDx.h)("select", {
            class: "form-control",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control text-capitalize", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["stage"])
            }),
            placeholder: "Status",
            value: form.fields["stage"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "stage")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, "Select Status"), (0, $LjoDx.h)("option", {
            class: "text-capitalize",
            value: ""
        }, "All"), [
            "approved",
            "pending",
            "archive",
            "updated"
        ].map(function(status) {
            return (0, $LjoDx.h)("option", {
                class: "text-capitalize",
                value: status
            }, status);
        }))), state.currentUser.role !== "role_supervisor" ? (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Supervisor"), (0, $LjoDx.h)((0, $204820985097eb0a$exports.AutocompleteSearch), {
            onResultSelected: this.onSupervisorSearchChange
        })) : null, state.currentUser.role !== "role_supervisor" ? (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Receiving Bank Account"), (0, $LjoDx.h)("select", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["receivingBankAccount"])
            }),
            placeholder: "Bank Account",
            value: form.fields["receivingBankAccount"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "receivingBankAccount")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, "Select Account"), state.allBankAccounts.map(function(acc) {
            return (0, $LjoDx.h)("option", {
                value: acc.bankAccountName
            }, acc.bankAccountName);
        }))) : null)));
    };
    DashRemittance.prototype.getOverallTotalBlock = function(state) {
        if (state.overallTotal) return (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 col-xl-4 mt-4 mt-xl-0"
        }, (0, $LjoDx.h)((0, $942dea15bc973271$exports.DataDisplayWidget), {
            name: "Overall Total",
            data1: "₱ ".concat((0, $9e0c3e3a397653e5$export$63ad841d70774900)(state.overallTotal.total)),
            data1Label: "Total Remitted Amount (Overall)",
            data2: state.overallTotal.count,
            data2Label: "Number of Remittances Submitted (Overall)"
        }));
    };
    DashRemittance.prototype.getMonthAmountBlock = function(state) {
        if (state.currentMonthTotal && state.previousMonthTotal) {
            var change = state.currentMonthTotal.total - state.previousMonthTotal.total;
            var isPos = state.currentMonthTotal.total > state.previousMonthTotal.total;
            return (0, $LjoDx.h)("div", {
                class: "col-12 col-md-6 col-xl-4 mt-4 mt-xl-0"
            }, (0, $LjoDx.h)((0, $942dea15bc973271$exports.DataDisplayWidget), {
                name: "Monthly Amount",
                data1: "₱ ".concat((0, $9e0c3e3a397653e5$export$63ad841d70774900)(state.currentMonthTotal.total)),
                data1Label: "Total Remitted Amount (Current Month)",
                data2: "₱ ".concat((0, $9e0c3e3a397653e5$export$63ad841d70774900)(state.previousMonthTotal.total)),
                data2Label: "Total Remitted Amount (Previous Month)",
                changeAmount: change,
                isChangePositive: isPos
            }));
        }
    };
    DashRemittance.prototype.getMonthCountBlock = function(state) {
        if (state.currentMonthTotal && state.previousMonthTotal) {
            var change = state.currentMonthTotal.count - state.previousMonthTotal.count;
            var isPos = state.currentMonthTotal.count > state.previousMonthTotal.count;
            return (0, $LjoDx.h)("div", {
                class: "col-12 col-md-6 col-xl-4 mt-4 mt-xl-0"
            }, (0, $LjoDx.h)((0, $942dea15bc973271$exports.DataDisplayWidget), {
                name: "Monthly Count",
                data1: state.currentMonthTotal.count,
                data1Label: "Number of Remittances Submitted (Current Month)",
                data2: state.previousMonthTotal.count,
                data2Label: "Number of Remittances Submitted (Previous Month)",
                changeAmount: change,
                isChangePositive: isPos
            }));
        }
    };
    DashRemittance.prototype.getNoteSection = function(state) {
        if (state.currentUser && state.currentUser.role != "role_supervisor") return (0, $LjoDx.h)("div", {
            class: "row mb-4"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "anglo__dashboard__tips mt-2"
        }, "Note:", (0, $LjoDx.h)("span", {
            class: "ml-2"
        }, "You are viewing all remittances. This an auditor level feature."))));
    };
    DashRemittance.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "dash-remittance"
        }, this.getPortalModal(state), (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-8 col-lg-4"
        }, (0, $LjoDx.h)("nav", {
            "aria-label": "breadcrumb"
        }, (0, $LjoDx.h)("ol", {
            class: "breadcrumb"
        }, (0, $LjoDx.h)("li", {
            class: "breadcrumb-item"
        }, (0, $LjoDx.h)("a", {
            href: "/remittance"
        }, "Remittance"))))), (0, $LjoDx.h)("div", {
            class: "col-4 col-lg-2 offset-lg-6 d-flex justify-content-end align-items-center"
        }, (0, $LjoDx.h)("a", {
            class: "anglo__dashboard__faq",
            href: "#"
        }, "FAQs ", (0, $LjoDx.h)("i", {
            class: "fas fa-chevron-right"
        })))), this.getNoteSection(state), (0, $LjoDx.h)("div", {
            class: "row"
        }, this.getOverallTotalBlock(state), this.getMonthAmountBlock(state), this.getMonthCountBlock(state)), (0, $LjoDx.h)("div", {
            class: "row mt-4"
        }, state.currentUser && state.currentUser.role !== "role_supervisor" ? (0, $LjoDx.h)("div", {
            class: "col-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary",
            onClick: this.openReportModal
        }, "Generate Report")) : (0, $LjoDx.h)("div", {
            class: "col-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary",
            onClick: this.openSupervisorReportModal
        }, "Generate Supervisor Report")), (0, $LjoDx.h)("div", {
            class: "col d-flex justify-content-end align-items-center"
        }, (0, $LjoDx.h)("a", {
            class: "dash-remittance__filter-row__filter-btn mr-3",
            onClick: this.onFilterToggleClicked
        }, "Filter ", (0, $LjoDx.h)("i", {
            class: "fas fa-filter"
        }))), this.getFilterBlock(state)), (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "dash-remittance__grid-container mb-2"
        }, this.getGridBlock(props, state)), state.pages ? (0, $LjoDx.h)("div", {
            class: "dash-remittance__pagination mb-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn dash-remittance__pagination__page arrow",
            disabled: state.currentPage === 1,
            onClick: function() {
                return _this.onPageClicked(state.currentPage - 1);
            }
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-chevron-left"
        })), state.currentPage > 5 ? (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                "active": state.pages[0] === state.currentPage
            }),
            onClick: function() {
                return _this.onPageClicked(state.pages[0]);
            }
        }, state.pages[0]) : null, state.currentPage > 5 ? (0, $LjoDx.h)("span", {
            class: "mx-2"
        }, "...") : null, state.pages ? state.pages.map(function(page) {
            if (page > state.currentPage - 5 && page < state.currentPage + 5) return (0, $LjoDx.h)("button", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                    "active": page === state.currentPage
                }),
                onClick: function() {
                    return _this.onPageClicked(page);
                }
            }, page);
        }) : null, state.currentPage < state.pages.length - 5 ? (0, $LjoDx.h)("span", {
            class: "mx-2"
        }, "...") : null, state.currentPage < state.pages.length - 5 ? (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                "active": state.pages[state.pages.length - 1] === state.currentPage
            }),
            onClick: function() {
                return _this.onPageClicked(state.pages[state.pages.length - 1]);
            }
        }, state.pages[state.pages.length - 1]) : null, (0, $LjoDx.h)("button", {
            class: "btn dash-remittance__pagination__page arrow",
            disabled: state.currentPage === state.pages[state.pages.length - 1],
            onClick: function() {
                return _this.onPageClicked(state.currentPage + 1);
            }
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-chevron-right"
        }))) : null))));
    };
    return DashRemittance;
}((0, $LjoDx.Component));


var $4a63541bdaa844d2$exports = {};

$parcel$export($4a63541bdaa844d2$exports, "AuditLogDashboard", () => $4a63541bdaa844d2$export$fc13d33c36e7dae0);

var $LjoDx = parcelRequire("LjoDx");




var $4a63541bdaa844d2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4a63541bdaa844d2$export$fc13d33c36e7dae0 = /** @class */ function(_super) {
    $4a63541bdaa844d2$var$__extends(AuditLogDashboard, _super);
    function AuditLogDashboard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.subs = [];
        return _this;
    }
    AuditLogDashboard.prototype.componentDidMount = function() {
        var _this = this;
        var audit$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.audit;
        }));
        this.subs.push(audit$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(audit) {
            return audit.auditGridData;
        })).subscribe(function(auditGridData) {
            _this.setState({
                auditGridData: auditGridData
            });
        }));
        this.initialStoreDispatches();
    };
    AuditLogDashboard.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $25ac7cc755ebed09$export$13452f8bbda82685)
        });
    };
    AuditLogDashboard.prototype.getGridBlock = function(props, state) {
        if (state.auditGridData) return (0, $LjoDx.h)("div", {
            class: "data-grid dash-remittance__grid-container__grid"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__col col-short"
        }, "Username"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-long"
        }, "Action"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Date")), state.auditGridData.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                class: "data-grid__row"
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col col-short"
            }, row.username), (0, $LjoDx.h)("div", {
                class: "data-grid__col text-capitalize col-long"
            }, row.action), (0, $LjoDx.h)("div", {
                class: "data-grid__col "
            }, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(row.timestamp).format("MMM DD, YYYY @ hh:mm A")));
        }));
    };
    AuditLogDashboard.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "anglo-remittance"
        }, (0, $LjoDx.h)("div", {
            class: "container-fluid "
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-8 col-lg-4"
        }, (0, $LjoDx.h)("nav", {
            "aria-label": "breadcrumb"
        }, (0, $LjoDx.h)("ol", {
            class: "breadcrumb"
        }, (0, $LjoDx.h)("li", {
            class: "breadcrumb-item"
        }, (0, $LjoDx.h)("a", {
            href: "#"
        }, "History")))))), (0, $LjoDx.h)("div", {
            class: "row mt-5"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "dash-remittance__grid-container"
        }, this.getGridBlock(props, state))))));
    };
    return AuditLogDashboard;
}((0, $LjoDx.Component));


var $3ff198152c9f6cd6$exports = {};

$parcel$export($3ff198152c9f6cd6$exports, "DashUpdates", () => $3ff198152c9f6cd6$export$44821293332a67aa);

var $LjoDx = parcelRequire("LjoDx");





var $fdf28ccfc4fe3cf4$exports = {};

$parcel$export($fdf28ccfc4fe3cf4$exports, "UpdateCard", () => $fdf28ccfc4fe3cf4$export$d5e33d9e0862571d);

var $LjoDx = parcelRequire("LjoDx");


const $a7963103f67f283b$export$7295e7dacdd685b9 = 1;
const $a7963103f67f283b$export$edfc9686e61fe602 = 2;
const $a7963103f67f283b$export$bd8c052af7c42aad = 0;
const $a7963103f67f283b$export$93c8384e69cddb3d = [
    {
        value: $a7963103f67f283b$export$bd8c052af7c42aad,
        label: "Pending"
    },
    {
        value: $a7963103f67f283b$export$edfc9686e61fe602,
        label: "Approved"
    },
    {
        value: $a7963103f67f283b$export$7295e7dacdd685b9,
        label: "Declined"
    }
];


var $0189fd212a009aba$exports = {};

$parcel$export($0189fd212a009aba$exports, "ViewUpdateDetailModal", () => $0189fd212a009aba$export$4fe12c66ad87130b);

var $LjoDx = parcelRequire("LjoDx");







var $0189fd212a009aba$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0189fd212a009aba$export$4fe12c66ad87130b = /** @class */ function(_super) {
    $0189fd212a009aba$var$__extends(ViewUpdateDetailModal, _super);
    function ViewUpdateDetailModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onApprove = function(props) {
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            if (props.isEdit) store.dispatch({
                type: (0, $5ee26f856325551b$export$ba66402981b8dbe1),
                payload: {
                    remittanceId: props.request.remittanceId,
                    responseReason: _this.state.responseReason
                }
            });
            else store.dispatch({
                type: (0, $5ee26f856325551b$export$2e4ccd371a4d296c),
                payload: {
                    remittanceId: props.request.remittanceId,
                    responseReason: _this.state.responseReason
                }
            });
        };
        _this.onReject = function(props) {
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            if (props.isEdit) store.dispatch({
                type: (0, $5ee26f856325551b$export$be6f145b71ba0393),
                payload: {
                    remittanceId: props.request.remittanceId,
                    responseReason: _this.state.responseReason
                }
            });
            else store.dispatch({
                type: (0, $5ee26f856325551b$export$6a2afda38f4a1418),
                payload: {
                    remittanceId: props.request.remittanceId,
                    responseReason: _this.state.responseReason
                }
            });
        };
        _this.setState({
            responseReason: props.request.responseReason
        });
        return _this;
    }
    ViewUpdateDetailModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var updates$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(app) {
            return app.updates;
        }));
        this.subs.push(updates$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(updates) {
            return updates.editRequestState;
        })).subscribe(function(reqState) {
            _this.setState({
                editRequestState: reqState
            });
            if (reqState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) _this.doModalClose();
        }));
    };
    ViewUpdateDetailModal.prototype.getStatusLabel = function(status) {
        switch(status){
            case 0, $a7963103f67f283b$export$bd8c052af7c42aad:
                return "Pending";
            case 0, $a7963103f67f283b$export$edfc9686e61fe602:
                return "Approved";
            case 0, $a7963103f67f283b$export$7295e7dacdd685b9:
                return "Declined";
        }
    };
    ViewUpdateDetailModal.prototype.getFieldsBlock = function(props) {
        if (props.isEdit) return (0, $LjoDx.h)("div", {
            class: "row mt-3 view-update-detail-modal__fields-container"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("h4", {
            class: "view-update-detail-modal__fields-container__header"
        }, "Fields to be updated")), props.request.fields.map(function(field) {
            return (0, $LjoDx.h)("div", {
                class: "col-3"
            }, (0, $LjoDx.h)("h4", {
                class: "view-update-detail-modal__label text-capitalize"
            }, field["fieldName"]), (0, $LjoDx.h)("div", {
                class: "view-update-detail-modal__value"
            }, field["newValue"]));
        }));
    };
    ViewUpdateDetailModal.prototype.getUsernameBlock = function(props) {
        if (props.currentUser.role === "role_auditor" || props.currentUser.role === "role_management") return (0, $LjoDx.h)("div", {
            class: "col-12 d-flex view-update-detail-modal__status-reason"
        }, (0, $LjoDx.h)("h4", {
            class: "view-update-detail-modal__status-reason__label"
        }, "Username"), (0, $LjoDx.h)("div", {
            class: "view-update-detail-modal__status-reason__value"
        }, props.request.username));
    };
    ViewUpdateDetailModal.prototype.getResponseReasonBlock = function(props, state) {
        if (props.currentUser.role === "role_auditor" || props.currentUser.role === "role_management") return (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("h4", {
            class: "anglo-request-edit-modal__label"
        }, "Response Reason*"), (0, $LjoDx.h)("textarea", {
            class: "form-control anglo-request-edit-modal__reason",
            onInput: (0, $8846dd5c02dd2c05$export$2e2bcd8739ae039)(this, "responseReason"),
            value: state.responseReason,
            placeholder: "Reason for accepting or rejecting changes"
        })));
    };
    ViewUpdateDetailModal.prototype.getActionsBlock = function(props) {
        var _this = this;
        if (props.currentUser.role === "role_auditor" || props.currentUser.role === "role_management") {
            if (props.request.status != (0, $a7963103f67f283b$export$bd8c052af7c42aad)) return;
            return (0, $LjoDx.h)("div", {
                class: "anglo-modal__actions mb-3"
            }, (0, $LjoDx.h)("button", {
                class: "btn view-update-detail-modal__action reject",
                disabled: !this.state.responseReason,
                onClick: function(e) {
                    return _this.onReject(props);
                }
            }, "Reject"), (0, $LjoDx.h)("button", {
                class: "btn view-update-detail-modal__action approve ml-3",
                disabled: !this.state.responseReason,
                onClick: function(e) {
                    return _this.onApprove(props);
                }
            }, "Approve"));
        }
    };
    ViewUpdateDetailModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "view-update-detail-modal container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Viewing details of request | ", (0, $LjoDx.h)("small", null, props.request.remittanceId))), (0, $LjoDx.h)("div", {
            class: "col-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }), (0, $LjoDx.h)("div", {
            class: "row view-update-detail-modal__status-reason"
        }, this.getUsernameBlock(props), (0, $LjoDx.h)("div", {
            class: "col-12 d-flex view-update-detail-modal__status-reason"
        }, (0, $LjoDx.h)("h4", {
            class: "view-update-detail-modal__status-reason__label"
        }, "Status"), (0, $LjoDx.h)("div", {
            class: "view-update-detail-modal__status-reason__value"
        }, this.getStatusLabel(props.request.status))), (0, $LjoDx.h)("div", {
            class: "col-12 d-flex view-update-detail-modal__status-reason"
        }, (0, $LjoDx.h)("h4", {
            class: "view-update-detail-modal__status-reason__label"
        }, "Request reason"), (0, $LjoDx.h)("div", {
            class: "view-update-detail-modal__status-reason__value"
        }, props.request.reason))), this.getFieldsBlock(props), this.getResponseReasonBlock(props, state)), this.getActionsBlock(props));
    };
    return ViewUpdateDetailModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $fdf28ccfc4fe3cf4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $fdf28ccfc4fe3cf4$export$d5e33d9e0862571d = /** @class */ function(_super) {
    $fdf28ccfc4fe3cf4$var$__extends(UpdateCard, _super);
    function UpdateCard(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.onModalClose = function() {
            _this.setState({
                isModalOpen: false
            });
        };
        _this.onModalOpen = function() {
            _this.setState({
                isModalOpen: true
            });
        };
        return _this;
    }
    UpdateCard.prototype.componentDidMount = function() {};
    UpdateCard.prototype.getStatusLabel = function(status) {
        switch(status){
            case 0, $a7963103f67f283b$export$bd8c052af7c42aad:
                return "Pending";
            case 0, $a7963103f67f283b$export$edfc9686e61fe602:
                return "Approved";
            case 0, $a7963103f67f283b$export$7295e7dacdd685b9:
                return "Declined";
        }
    };
    UpdateCard.prototype.getPortalModal = function(state) {
        if (state.isModalOpen) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
            into: "body"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-modal-container",
            id: "anglo-modal-111"
        }, (0, $LjoDx.h)((0, $0189fd212a009aba$exports.ViewUpdateDetailModal), {
            currentUser: this.props.currentUser,
            request: this.props.request,
            isEdit: this.props.isEdit,
            close: this.onModalClose,
            isOutsideClickClose: false,
            containerId: "anglo-modal-111"
        })));
    };
    UpdateCard.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "update-card"
        }, this.getPortalModal(state), (0, $LjoDx.h)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("update-card__head pb-3", {
                "pending": props.request.status === (0, $a7963103f67f283b$export$bd8c052af7c42aad),
                "approved": props.request.status === (0, $a7963103f67f283b$export$edfc9686e61fe602),
                "denied": props.request.status === (0, $a7963103f67f283b$export$7295e7dacdd685b9)
            })
        }, (0, $LjoDx.h)("div", {
            class: ""
        }, props.request.remittanceId)), (0, $LjoDx.h)("div", {
            class: "update-card__content"
        }, (0, $LjoDx.h)("div", {
            class: "row update-card__body mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-3 update-card__body__label"
        }, "Status"), (0, $LjoDx.h)("div", {
            class: "col-9 update-card__body__value"
        }, this.getStatusLabel(props.request.status))), (0, $LjoDx.h)("div", {
            class: "row update-card__body mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-3 update-card__body__label"
        }, "Supervisor"), (0, $LjoDx.h)("div", {
            class: "col-9 update-card__body__value"
        }, props.request.username)), (0, $LjoDx.h)("div", {
            class: "row update-card__body mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-3 update-card__body__label"
        }, "Reason"), (0, $LjoDx.h)("div", {
            class: "col-9 update-card__body__value"
        }, (0, $LjoDx.h)("div", {
            class: "update-card__body__value__reason"
        }, props.request.reason)))), (0, $LjoDx.h)("div", {
            class: "row update-card__actions mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onModalOpen
        }, "View Details"))));
    };
    return UpdateCard;
}((0, $LjoDx.Component));







var $3ff198152c9f6cd6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3ff198152c9f6cd6$export$44821293332a67aa = /** @class */ function(_super) {
    $3ff198152c9f6cd6$var$__extends(DashUpdates, _super);
    function DashUpdates(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.resetFilters = function() {
            var fieldList = _this.state.filters.fields;
            for(var k in fieldList)fieldList[k].value = null;
            var form = _this.state.filters;
            form.fields = fieldList;
            // form['page'] = 1;
            _this.setState({
                filters: form
            });
        };
        _this.applyFilters = function() {
            // let filters: Map<string, any> = new Map<string, any>();
            var filters = {};
            var fieldList = _this.state.filters.fields;
            for(var k in fieldList)if (fieldList[k].value) // filters.set(k, fieldList[k].value);
            filters[k] = fieldList[k].value;
            // when new filters are applied, always set back to first page
            filters["page"] = 1;
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            if (!_this.state.isEditActive) {
                filters["type"] = "delete";
                store.dispatch({
                    type: (0, $5ee26f856325551b$export$f0fed340523808db),
                    payload: {
                        filters: filters
                    }
                });
            } else {
                filters["type"] = "edit";
                store.dispatch({
                    type: (0, $5ee26f856325551b$export$f0fed340523808db),
                    payload: {
                        filters: filters
                    }
                });
            }
        };
        // getDeleteData(state: DashUpdatesState) {
        //   if (state.deleteGridData && !state.isEditActive) {
        //     return (
        //       <div class="dash-updates__card-container row">
        //         {
        //           state.deleteGridData.map(member => 
        //             <div class="col-3">
        //               <UpdateCard request={member} />
        //             </div>
        //           )
        //         }
        //       </div>
        //     );
        //   }
        // }
        _this.onEditClicked = function() {
            _this.resetFilters();
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $5ee26f856325551b$export$f0fed340523808db),
                payload: {
                    filters: {
                        type: "edit"
                    }
                }
            });
            _this.setState({
                isEditActive: true
            });
        };
        _this.onDeleteClicked = function() {
            _this.resetFilters();
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $5ee26f856325551b$export$f0fed340523808db),
                payload: {
                    filters: {
                        type: "delete"
                    }
                }
            });
            _this.setState({
                isEditActive: false
            });
        };
        _this.onFilterToggleClicked = function() {
            _this.setState({
                isFilterVisible: !_this.state.isFilterVisible
            });
        };
        _this.onSupervisorSearchChange = function(supervisor) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filters, "username", supervisor.username);
        };
        _this.setState({
            isEditActive: true
        });
        _this.createForm();
        return _this;
    }
    DashUpdates.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "status": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "username": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            filters: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["filters"] = form;
            _this.setState(state);
        });
    };
    DashUpdates.prototype.componentDidMount = function() {
        var _this = this;
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.user;
        }));
        this.subs.push(user$.subscribe(function(user) {
            if (user.currentUser) _this.setState({
                currentUser: user.currentUser
            });
        }));
        var updates$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.updates;
        }));
        this.subs.push(updates$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(updates) {
            return updates.editGridData;
        })).subscribe(function(editGridData) {
            _this.setState({
                editGridData: editGridData
            });
        }));
        // this.subs.push(updates$.pipe(
        //   map(updates => updates.editGridData)
        // ).subscribe((deleteGridData) => {
        //     this.setState({
        //       deleteGridData: deleteGridData
        //     });
        //   })
        // );
        this.initialStoreDispatches();
    };
    DashUpdates.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $5ee26f856325551b$export$f0fed340523808db),
            payload: {
                filters: {
                    type: "edit"
                }
            }
        });
    };
    DashUpdates.prototype.getEditData = function(state) {
        if (state.editGridData && state.isEditActive) return (0, $LjoDx.h)("div", {
            class: "dash-updates__card-container row"
        }, state.editGridData.map(function(member) {
            return (0, $LjoDx.h)("div", {
                class: "col-12 col-md-3 mb-3"
            }, (0, $LjoDx.h)((0, $fdf28ccfc4fe3cf4$exports.UpdateCard), {
                currentUser: state.currentUser,
                request: member,
                isEdit: state.isEditActive
            }));
        }));
        else if (state.editGridData && !state.isEditActive) return (0, $LjoDx.h)("div", {
            class: "dash-updates__card-container row"
        }, state.editGridData.map(function(member) {
            return (0, $LjoDx.h)("div", {
                class: "col-12 col-md-3 mb-3"
            }, (0, $LjoDx.h)((0, $fdf28ccfc4fe3cf4$exports.UpdateCard), {
                currentUser: state.currentUser,
                request: member,
                isEdit: state.isEditActive
            }));
        }));
    };
    DashUpdates.prototype.getFilterBlock = function(state) {
        var form = state.filters;
        if (state.isFilterVisible && !state.isEditActive) return (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, (0, $LjoDx.h)("div", {
            class: "row mt-1 dash-vehicles__filters dash-remittance__filter-row__filters"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mb-2"
        }, (0, $LjoDx.h)("label", {
            class: "dash-vehicles__filters__label"
        }, "Status"), (0, $LjoDx.h)("select", {
            class: "form-control",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control text-capitalize", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["status"])
            }),
            placeholder: "Status",
            value: form.fields["status"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "status")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, "Select Status"), (0, $LjoDx.h)("option", {
            class: "text-capitalize",
            value: ""
        }, "All"), (0, $a7963103f67f283b$export$93c8384e69cddb3d).map(function(status) {
            return (0, $LjoDx.h)("option", {
                class: "text-capitalize",
                value: status.value
            }, status.label);
        }))), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mb-2"
        }, (0, $LjoDx.h)("label", {
            class: "dash-vehicles__filters__label"
        }, "Supervisor"), (0, $LjoDx.h)((0, $204820985097eb0a$exports.AutocompleteSearch), {
            onResultSelected: this.onSupervisorSearchChange
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-6 mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "mt-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.resetFilters
        }, "Reset Filters"))), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "mt-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.applyFilters
        }, "Apply Filters")))));
        else if (state.isFilterVisible && state.isEditActive) return (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, (0, $LjoDx.h)("div", {
            class: "row mt-1 dash-vehicles__filters dash-remittance__filter-row__filters"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mb-2"
        }, (0, $LjoDx.h)("label", {
            class: "dash-vehicles__filters__label"
        }, "Status"), (0, $LjoDx.h)("select", {
            class: "form-control",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control text-capitalize", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["status"])
            }),
            placeholder: "Status",
            value: form.fields["status"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "status")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, "Select Status"), (0, $LjoDx.h)("option", {
            class: "text-capitalize",
            value: ""
        }, "All"), (0, $a7963103f67f283b$export$93c8384e69cddb3d).map(function(status) {
            return (0, $LjoDx.h)("option", {
                class: "text-capitalize",
                value: status.value
            }, status.label);
        }))), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6"
        }, (0, $LjoDx.h)("label", {
            class: "dash-vehicles__filters__label"
        }, "Supervisor"), (0, $LjoDx.h)((0, $204820985097eb0a$exports.AutocompleteSearch), {
            onResultSelected: this.onSupervisorSearchChange
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-6 mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "mt-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.resetFilters
        }, "Reset Filters"))), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "mt-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.applyFilters
        }, "Apply Filters")))));
    };
    DashUpdates.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "dash-updates"
        }, (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-8 col-lg-4"
        }, (0, $LjoDx.h)("nav", {
            "aria-label": "breadcrumb"
        }, (0, $LjoDx.h)("ol", {
            class: "breadcrumb"
        }, (0, $LjoDx.h)("li", {
            class: "breadcrumb-item"
        }, (0, $LjoDx.h)("a", {
            href: "#"
        }, "Updates")))))), (0, $LjoDx.h)("div", {
            class: "row dash-updates__type-row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4 offset-md-4"
        }, (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("w-50 dash-updates__type-row__button first", {
                "active": state.isEditActive
            }),
            onClick: this.onEditClicked
        }, "View for Edit"), (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("w-50 dash-updates__type-row__button last", {
                "active": !state.isEditActive
            }),
            onClick: this.onDeleteClicked
        }, "View for Delete"))), (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col d-flex justify-content-end align-items-center"
        }, (0, $LjoDx.h)("a", {
            class: "dash-remittance__filter-row__filter-btn mr-3",
            onClick: this.onFilterToggleClicked
        }, "Filter ", (0, $LjoDx.h)("i", {
            class: "fas fa-filter"
        })))), this.getFilterBlock(state), (0, $LjoDx.h)("div", {
            class: "mt-5"
        }, this.getEditData(state))));
    };
    return DashUpdates;
}((0, $LjoDx.Component));


var $5c6b365a0e460dd1$exports = {};

$parcel$export($5c6b365a0e460dd1$exports, "DashVehicles", () => $5c6b365a0e460dd1$export$901c613ab30cda9b);

var $LjoDx = parcelRequire("LjoDx");






var $a4a8267daa7d5e18$exports = {};

$parcel$export($a4a8267daa7d5e18$exports, "VehicleCard", () => $a4a8267daa7d5e18$export$5580b706b7ac30a);

var $LjoDx = parcelRequire("LjoDx");


var $cf4c6aa3890dbf4e$exports = {};

$parcel$export($cf4c6aa3890dbf4e$exports, "EditVehicleModal", () => $cf4c6aa3890dbf4e$export$3884a3e52232cb21);

var $LjoDx = parcelRequire("LjoDx");











var $cf4c6aa3890dbf4e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $cf4c6aa3890dbf4e$export$3884a3e52232cb21 = /** @class */ function(_super) {
    $cf4c6aa3890dbf4e$var$__extends(EditVehicleModal, _super);
    function EditVehicleModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function(e) {
            e.preventDefault();
            var form = _this.state.vehicleForm;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            _this.setState({
                vehicleForm: form
            });
            if (!_this.state.vehicleForm.isValid) return;
            var vehicle = {
                vehicleId: _this.props.vehicle.vehicleId,
                supervisor: form.fields["supervisor"].value,
                modelMake: form.fields["modelMake"].value,
                plateNumber: form.fields["plateNumber"].value,
                lodgingLocation: form.fields["lodgingLocation"].value,
                type: _this.state.editType,
                status: form.fields["status"].value
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $7859e0852b06702e$export$aa1eb15edf81c53f),
                payload: {
                    vehicleToUpdate: vehicle
                }
            });
        };
        _this.createForm();
        return _this;
    }
    EditVehicleModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var vehicles$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(app) {
            return app.vehicles;
        }));
        this.subs.push(vehicles$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(vehicles) {
            return vehicles.editVehicleState;
        })).subscribe(function(reqState) {
            _this.setState({
                editVehicleState: reqState
            });
            if (reqState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) _this.doModalClose();
        }));
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(app) {
            return app.user;
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.supervisors;
        })).subscribe(function(supervisors) {
            _this.setState({
                supervisors: supervisors
            });
        }));
        this.initialStoreDispatches();
    };
    EditVehicleModal.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $4c71eb74f53637d3$export$d1320805de2a0f43)
        });
    };
    EditVehicleModal.prototype.componentWillUnmount = function() {
        console.log("unmounting");
    };
    EditVehicleModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "status": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, this.props.vehicle.status),
            "supervisor": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, this.props.vehicle.username),
            "modelMake": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, this.props.vehicle.modelMake),
            "plateNumber": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, this.props.vehicle.plateNumber),
            "lodgingLocation": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, this.props.vehicle.lodgingLocation)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            vehicleForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["vehicleForm"] = form;
            _this.setState(state);
        });
    };
    EditVehicleModal.prototype.getSpinnerBlock = function(state) {
        if (state.editVehicleState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    EditVehicleModal.prototype.getFormBlock = function(props, state) {
        var form = state.vehicleForm;
        if (state.editType === "edit") return (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-6 mb-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Supervisor"), (0, $LjoDx.h)("select", {
            disabled: true,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["supervisor"])
            }),
            placeholder: "Supervisor",
            value: form.fields["supervisor"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "supervisor")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, props.vehicle.username), state.supervisors.map(function(supervisor) {
            return (0, $LjoDx.h)("option", {
                value: supervisor.username
            }, supervisor.firstName, " ", supervisor.lastName);
        }))), (0, $LjoDx.h)("div", {
            class: "col-6 mb-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Plate Number*"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["plateNumber"])
            }),
            value: form.fields["plateNumber"].value,
            placeholder: "Plate Number",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "plateNumber")
        })), (0, $LjoDx.h)("div", {
            class: "col-6 mb-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Model/Make*"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["modelMake"])
            }),
            value: form.fields["modelMake"].value,
            placeholder: "Model/Make",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "modelMake")
        })), (0, $LjoDx.h)("div", {
            class: "col-6 mb-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Lodging Location"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["lodgingLocation"])
            }),
            value: form.fields["lodgingLocation"].value,
            placeholder: "Lodging Location",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "lodgingLocation")
        })), (0, $LjoDx.h)("div", {
            class: "col-6 mb-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Status"), (0, $LjoDx.h)("select", {
            class: "form-control",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control text-capitalize", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["status"])
            }),
            placeholder: "Status",
            value: form.fields["status"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "status")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, "Select Status"), (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "damaged",
            disabled: true
        }, "Damaged"), (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "updated",
            disabled: true
        }, "Updated"), [
            "in repair",
            "decommissioned",
            "orcr renewal"
        ].map(function(status) {
            return (0, $LjoDx.h)("option", {
                class: "text-capitalize",
                value: status
            }, status);
        }))), (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-1 offset-lg-9"
        }, this.getSpinnerBlock(state)), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: state.editVehicleState == (0, $ad7802471dc8ad45$export$93ca241731165d07)
        }, "Submit")))));
        else if (state.editType === "reassign") return (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mb-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Supervisor*"), (0, $LjoDx.h)("select", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["supervisor"])
            }),
            placeholder: "Supervisor",
            value: form.fields["supervisor"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "supervisor")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, "Supervisor"), state.supervisors.map(function(supervisor) {
            return (0, $LjoDx.h)("option", {
                value: supervisor.username
            }, supervisor.firstName, " ", supervisor.lastName);
        }))), (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-1 offset-9"
        }, this.getSpinnerBlock(state)), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: state.editVehicleState == (0, $ad7802471dc8ad45$export$93ca241731165d07)
        }, "Submit")))));
    };
    EditVehicleModal.prototype.getChooseTypeBlock = function(props, state) {
        var _this = this;
        if (!state.editType) return (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("button", {
            class: "col-4 col-lg-2 offset-2 offset-lg-3 btn btn-secondary",
            onClick: function(e) {
                _this.setState({
                    editType: "edit"
                });
            }
        }, "Edit"), (0, $LjoDx.h)("button", {
            class: "col-4 col-lg-2 offset-1 btn btn-dark",
            onClick: function(e) {
                _this.setState({
                    editType: "reassign"
                });
            }
        }, "Reassign"));
    };
    EditVehicleModal.prototype.render = function(props, state) {
        var _this = this;
        var form = state.vehicleForm;
        if (!state.supervisors) return;
        return (0, $LjoDx.h)("div", {
            class: "anglo-request-edit-modal container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create Vehicle Entry")), (0, $LjoDx.h)("div", {
            class: "col-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), this.getFormBlock(props, state), this.getChooseTypeBlock(props, state));
    };
    return EditVehicleModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $903a44c9b570043a$exports = {};

$parcel$export($903a44c9b570043a$exports, "FileReportModal", () => $903a44c9b570043a$export$9214e4b85649401a);

var $LjoDx = parcelRequire("LjoDx");










const $ef963b76c9929143$export$8e310280621c75cc = [
    "Accident",
    "Breakdown",
    "Maintenance",
    "ORCR Renewed",
    "Refuel"
];
const $ef963b76c9929143$export$a16c40bdf130d7bb = "vf-status-pending";
const $ef963b76c9929143$export$5345326be310f09d = "vf-status-approved";
const $ef963b76c9929143$export$9db2761dfefe51f4 = "vf-status-denied";
const $ef963b76c9929143$export$7ff2232ea0900df2 = [
    "new",
    "reassigned",
    "orcr renewed",
    "updated",
    "in repair",
    "damaged",
    "decommissioned"
];




var $903a44c9b570043a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $903a44c9b570043a$export$9214e4b85649401a = /** @class */ function(_super) {
    $903a44c9b570043a$var$__extends(FileReportModal, _super);
    function FileReportModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.handleDatepickerValidation = function(date, fieldName) {
            var currentForm = _this.state.vehicleForm;
            // Manually do this because in order to follow the 
            // hopplerLinkstate validation system
            var clonedFields = {};
            for(var k in currentForm.fields){
                var prevField = currentForm.fields[k];
                clonedFields[k] = new (0, $49e398741f5b1a93$export$a455218a85c89869)(prevField.validators, prevField.customValidators, prevField.value);
                clonedFields[k].isValid = prevField.isValid;
            }
            var clone = new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(clonedFields);
            clone.fields[fieldName].value = date;
            clone.fields[fieldName].isPristine = false;
            // clone.fields[fieldName].customValidators.forEach(a => a(clone.fields[fieldName], clone));
            _this.form$.next(clone);
        };
        _this.onAddExpense = function() {
            var expense = {
                name: "",
                amount: 0
            };
            var expenses = _this.state.expenses;
            expenses.push(expense);
            _this.setState({
                expenses: expenses
            });
        };
        _this.onRemoveExpense = function(index) {
            var expenses = _this.state.expenses;
            expenses.splice(index, 1);
            _this.setState({
                expenses: expenses
            });
        };
        _this.onDateSelected = function(date) {
            _this.handleDatepickerValidation(date, "dateOfIncident");
        };
        _this.onSubmit = function() {
            console.log(_this.state.expenses);
            var form = _this.state.vehicleForm;
            var expenses = _this.state.expenses;
            expenses = expenses.map(function(expense) {
                return {
                    name: expense.name,
                    amount: Number.parseInt(expense.amount)
                };
            });
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $7859e0852b06702e$export$cf8065a69c02ae59),
                payload: {
                    vehicleFileToCreate: {
                        supervisor: _this.props.currentUser.username,
                        vehicleId: _this.props.vehicle.vehicleId,
                        description: form.fields["description"].value,
                        type: form.fields["type"].value,
                        dateOfReport: form.fields["dateOfIncident"].value,
                        isMotorpool: form.fields["isMotorpool"].value,
                        expenses: _this.state.expenses
                    }
                }
            });
        };
        _this.setState({
            expenses: []
        });
        _this.createForm();
        return _this;
    }
    FileReportModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "type": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null),
            "dateOfIncident": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null),
            "description": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null),
            "isMotorpool": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            vehicleForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["vehicleForm"] = form;
            _this.setState(state);
        });
    };
    FileReportModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var vehicles$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(app) {
            return app.vehicles;
        }));
        this.subs.push(vehicles$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(vehicles) {
            return vehicles.createVehicleFileState;
        })).subscribe(function(reqState) {
            _this.setState({
                createVehicleFileState: reqState
            });
            if (reqState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) _this.doModalClose();
        }));
    };
    FileReportModal.prototype.getActionBlock = function(state) {
        if (state.createVehicleFileState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) return (0, $LjoDx.h)("div", {
            class: "offset-lg-9 offset-md-6 col-12 col-md-6 col-lg-3 mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
        else return (0, $LjoDx.h)("div", {
            class: "offset-lg-9 offset-md-6 col-12 col-md-6 col-lg-3 mt-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit
        }, "Submit"));
    };
    FileReportModal.prototype.render = function(props, state) {
        var _this = this;
        var form = state.vehicleForm;
        return (0, $LjoDx.h)("div", {
            class: "anglo-file-report-modal container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "File a report | ", (0, $LjoDx.h)("small", null, props.vehicle.plateNumber))), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Type"), (0, $LjoDx.h)("select", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["type"])
            }),
            placeholder: "Type",
            value: form.fields["type"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "type")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, "Select a type"), (0, $ef963b76c9929143$export$8e310280621c75cc).map(function(type) {
            return (0, $LjoDx.h)("option", {
                value: type
            }, type);
        }))), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mt-3 mt-md-0"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Date of Incident/Event"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: this.onDateSelected,
            initialValue: form.fields["dateOfIncident"].value,
            isValid: form.fields["dateOfIncident"].isValid,
            isPristine: form.fields["dateOfIncident"].isPristine
        })), (0, $LjoDx.h)("div", {
            class: "col-12 mt-3 d-flex align-items-center"
        }, "This happened in the Anglo motorpool ", (0, $LjoDx.h)("input", {
            class: "ml-2",
            type: "checkbox",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "isMotorpool", true)
        })), (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Description/Details"), (0, $LjoDx.h)("textarea", {
            class: "form-control anglo-request-edit-modal__reason",
            onInput: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "description"),
            value: form.fields["description"].value,
            placeholder: "Details of report"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "d-flex align-items-end justify-content-between"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label mb-0"
        }, "Expense Breakdown"), (0, $LjoDx.h)("button", {
            class: "btn anglo-file-report-modal__expenses-list__add",
            onClick: this.onAddExpense
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-plus"
        }))), (0, $LjoDx.h)("hr", {
            class: "my-2"
        }), (0, $LjoDx.h)("div", {
            class: "anglo-file-report-modal__expenses-list"
        }, state.expenses.map(function(expense, index) {
            return (0, $LjoDx.h)("div", {
                class: "anglo-file-report-modal__expense row mb-2 no-"
            }, (0, $LjoDx.h)("div", {
                class: "col-6 pr-0"
            }, (0, $LjoDx.h)("input", {
                type: "text",
                class: "form-control",
                placeholder: "Expense name",
                onInput: (0, $8846dd5c02dd2c05$export$2e2bcd8739ae039)(_this, "expenses.".concat(index, ".name"))
            })), (0, $LjoDx.h)("div", {
                class: "col pr-0 pl-1"
            }, (0, $LjoDx.h)("input", {
                type: "number",
                class: "form-control",
                placeholder: "Amount",
                onInput: (0, $8846dd5c02dd2c05$export$2e2bcd8739ae039)(_this, "expenses.".concat(index, ".amount"))
            })), (0, $LjoDx.h)("div", {
                class: "col-2 col-md-1 d-flex justify-content-end"
            }, (0, $LjoDx.h)("button", {
                class: "btn anglo-file-report-modal__expenses-list__add h-100",
                onClick: function() {
                    return _this.onRemoveExpense(index);
                }
            }, (0, $LjoDx.h)("i", {
                class: "fas fa-trash"
            }))));
        }))), this.getActionBlock(state)));
    };
    return FileReportModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $5bba464be234101c$exports = {};

$parcel$export($5bba464be234101c$exports, "CreateJobOrderModal", () => $5bba464be234101c$export$fc36ec159c58cf16);

var $LjoDx = parcelRequire("LjoDx");










var $5bba464be234101c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5bba464be234101c$export$fc36ec159c58cf16 = /** @class */ function(_super) {
    $5bba464be234101c$var$__extends(CreateJobOrderModal, _super);
    function CreateJobOrderModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function(e) {
            e.preventDefault();
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!_this.state.form.isValid) {
                for(var k in form.fields)if (!form.fields[k].isValid) console.log(k);
                return;
            }
            var jobOrder = {
                vehicleId: form.fields["vehicleId"].value,
                type: form.fields["type"].value,
                etaType: form.fields["etaType"].value,
                assignedPerson: form.fields["assignedPerson"].value
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $7859e0852b06702e$export$6beda060f5e67d2f),
                payload: {
                    jobOrderToCreate: jobOrder
                }
            });
        };
        _this.createForm(props);
        return _this;
    }
    CreateJobOrderModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var vehicles$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(app) {
            return app.vehicles;
        }));
        this.subs.push(vehicles$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(vehicles) {
            return vehicles.createJobOrderState;
        })).subscribe(function(reqState) {
            _this.setState({
                createJobOrderState: reqState
            });
            if (reqState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) _this.doModalClose();
        }));
    };
    CreateJobOrderModal.prototype.createForm = function(props) {
        var _this = this;
        var fields;
        if (props.vehicle) fields = {
            "vehicleId": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, props.vehicle.vehicleId),
            "type": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                "required"
            ], null, ""),
            "etaType": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                "required"
            ], null, ""),
            "assignedPerson": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                "required"
            ], null, ""),
            "notes": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, "")
        };
        else fields = {
            "vehicleId": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                "required"
            ], null, ""),
            "type": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                "required"
            ], null, ""),
            "etaType": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                "required"
            ], null, ""),
            "assignedPerson": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                "required"
            ], null, ""),
            "notes": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    CreateJobOrderModal.prototype.getSpinnerBlock = function(state) {
        if (state.createJobOrderState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    CreateJobOrderModal.prototype.getVehicleIdBlock = function(props, state) {
        var form = state.form;
        if (props.vehicle) return (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mb-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Vehicle ID*"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["vehicleId"])
            }),
            value: form.fields["vehicleId"].value,
            placeholder: "Vehicle ID",
            disabled: true,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "vehicleId")
        }));
        else return (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mb-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Vehicle ID*"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["vehicleId"])
            }),
            value: form.fields["vehicleId"].value,
            placeholder: "Vehicle ID",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "vehicleId")
        }));
    };
    CreateJobOrderModal.prototype.render = function(props, state) {
        var _this = this;
        var form = state.form;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create Job Order")), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3 m-0"
        }, this.getVehicleIdBlock(props, state), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mb-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Type*"), (0, $LjoDx.h)("select", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["type"])
            }),
            value: form.fields["type"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "type")
        }, (0, $LjoDx.h)("option", {
            value: "electrician"
        }, "Electrician"), (0, $LjoDx.h)("option", {
            value: "latero"
        }, "Latero"), (0, $LjoDx.h)("option", {
            value: "mechanic"
        }, "Mechanic"))), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mb-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "ETA*"), (0, $LjoDx.h)("select", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["etaType"])
            }),
            value: form.fields["etaType"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "etaType")
        }, (0, $LjoDx.h)("option", {
            value: "immediate"
        }, "Immediate"), (0, $LjoDx.h)("option", {
            value: "long"
        }, "Long"))), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mb-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Assigned To*"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["assignedPerson"])
            }),
            value: form.fields["assignedPerson"].value,
            placeholder: "Assigned Human Resource",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "assignedPerson")
        })), (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-md-1 offset-md-9"
        }, this.getSpinnerBlock(state)), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: state.createJobOrderState == (0, $ad7802471dc8ad45$export$93ca241731165d07)
        }, "Submit"))))));
    };
    return CreateJobOrderModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $daa42491034d496b$exports = {};

$parcel$export($daa42491034d496b$exports, "ViewHistoryModal", () => $daa42491034d496b$export$6ce6120c9bcd6878);

var $LjoDx = parcelRequire("LjoDx");






var $daa42491034d496b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $daa42491034d496b$export$6ce6120c9bcd6878 = /** @class */ function(_super) {
    $daa42491034d496b$var$__extends(ViewHistoryModal, _super);
    function ViewHistoryModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function(e) {};
        _this.setState({
            data: []
        });
        return _this;
    }
    ViewHistoryModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var vehicles$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(app) {
            return app.vehicles;
        }));
        this.subs.push(vehicles$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(vehicles) {
            return vehicles.vehicleMedicalHistory;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(medicalHistory) {
            if (medicalHistory) {
                var data = medicalHistory.jobOrders.concat(medicalHistory.vehicleFiles);
                data.sort(function(a, b) {
                    return new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime();
                });
                _this.setState({
                    data: data
                });
            }
        }));
        this.initialStoreDispatches();
    };
    ViewHistoryModal.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $7859e0852b06702e$export$664e2379a8eddc0c),
            payload: {
                vehicleId: this.props.vehicle.vehicleId
            }
        });
    };
    ViewHistoryModal.prototype.getSpinnerBlock = function(state) {
        if (state.createJobOrderState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    ViewHistoryModal.prototype.getListItem = function(data) {
        if (data.jobOrderId) {
            var jobOrder = data;
            return (0, $LjoDx.h)("div", {
                class: "vehicle-history-item"
            }, (0, $LjoDx.h)("div", {
                class: "vehicle-history-item__head"
            }, "Job Order"), (0, $LjoDx.h)("div", {
                class: "vehicle-history-item__body"
            }, (0, $LjoDx.h)("div", {
                class: "vehicle-history-item__body__detail"
            }, (0, $LjoDx.h)("p", {
                class: "vehicle-history-item__body__detail__title"
            }, "Job Type"), (0, $LjoDx.h)("p", {
                class: "text-capitalize"
            }, jobOrder.type)), (0, $LjoDx.h)("div", {
                class: "vehicle-history-item__body__detail"
            }, (0, $LjoDx.h)("p", {
                class: "vehicle-history-item__body__detail__title"
            }, "Assigned To"), (0, $LjoDx.h)("p", {
                class: "text-capitalize"
            }, jobOrder.assignedPerson)), (0, $LjoDx.h)("div", {
                class: "vehicle-history-item__body__detail"
            }, (0, $LjoDx.h)("p", {
                class: "vehicle-history-item__body__detail__title"
            }, "Status"), (0, $LjoDx.h)("p", {
                class: "text-capitalize"
            }, jobOrder.status)), (0, $LjoDx.h)("div", {
                class: "vehicle-history-item__body__detail"
            }, (0, $LjoDx.h)("p", {
                class: "vehicle-history-item__body__detail__title"
            }, "Eta Type"), (0, $LjoDx.h)("p", {
                class: "text-capitalize"
            }, jobOrder.etaType)), (0, $LjoDx.h)("div", {
                class: "vehicle-history-item__body__detail"
            }, (0, $LjoDx.h)("p", {
                class: "vehicle-history-item__body__detail__title"
            }, "Date Filed"), (0, $LjoDx.h)("p", null, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(jobOrder.dateCreated).format("MMMM DD, YYYY"))), (0, $LjoDx.h)("button", {
                class: "btn btn-secondary w-100"
            }, "View Details")));
        } else {
            var vehicleFile = data;
            return (0, $LjoDx.h)("div", {
                class: "vehicle-history-item"
            }, (0, $LjoDx.h)("div", {
                class: "vehicle-history-item__head"
            }, "Vehicle File", (0, $LjoDx.h)("i", {
                class: "vehicle-history-item__head__small"
            }, "(", vehicleFile.type, ")")), (0, $LjoDx.h)("div", {
                class: "vehicle-history-item__body"
            }, (0, $LjoDx.h)("div", {
                class: "vehicle-history-item__body__detail"
            }, (0, $LjoDx.h)("p", {
                class: "vehicle-history-item__body__detail__title"
            }, "Supervisor in-charge"), (0, $LjoDx.h)("p", {
                class: "text-capitalize"
            }, vehicleFile.username)), (0, $LjoDx.h)("div", {
                class: "vehicle-history-item__body__detail"
            }, (0, $LjoDx.h)("p", {
                class: "vehicle-history-item__body__detail__title"
            }, "Status"), (0, $LjoDx.h)("p", {
                class: "text-capitalize"
            }, vehicleFile.status)), (0, $LjoDx.h)("div", {
                class: "vehicle-history-item__body__detail"
            }, (0, $LjoDx.h)("p", {
                class: "vehicle-history-item__body__detail__title"
            }, "Date Filed"), (0, $LjoDx.h)("p", null, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(vehicleFile.dateOfReport).format("MMMM DD, YYYY"))), (0, $LjoDx.h)("button", {
                class: "btn btn-secondary w-100"
            }, "View Details")));
        }
    };
    ViewHistoryModal.prototype.getDataBlock = function(state) {
        var _this = this;
        // if (state.vehicleFiles && state.jobOrders) {
        return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, state.data.map(function(member) {
            return (0, $LjoDx.h)("div", {
                class: "col-12 mb-3"
            }, _this.getListItem(member));
        })));
    // }
    };
    ViewHistoryModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "View Vehicle History")), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, this.getDataBlock(state)));
    };
    return ViewHistoryModal;
}((0, $3f2ba7f1e3532510$exports.Modal));



var $a4a8267daa7d5e18$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a4a8267daa7d5e18$export$5580b706b7ac30a = /** @class */ function(_super) {
    $a4a8267daa7d5e18$var$__extends(VehicleCard, _super);
    function VehicleCard(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.MODAL_EDIT_VEHICLE = 0;
        _this.MODAL_FILE_REPORT = 1;
        _this.MODAL_DIAGNOSTIC = 2;
        _this.MODAL_CREATE_JOB_ORDER = 3;
        _this.onModalClose = function() {
            _this.setState({
                modalState: -1
            });
        };
        _this.onModalOpened = function(paramState) {
            var random = Math.floor(Math.random() * 200);
            _this.setState({
                modalState: paramState,
                modalId: "anglo-modal-".concat(random)
            });
        };
        _this.onJobOrderModalOpen = function() {
            var random = Math.floor(Math.random() * 200);
            _this.setState({
                isModalOpen: false,
                isFileReportOpen: false,
                isDiagosticOpen: false,
                isJobOrderOpen: true,
                modalId: "anglo-modal-".concat(random)
            });
        };
        return _this;
    }
    VehicleCard.prototype.componentDidMount = function() {};
    VehicleCard.prototype.getStatusLabel = function(status) {
        switch(status){
            case 0, $a7963103f67f283b$export$bd8c052af7c42aad:
                return "Pending";
            case 0, $a7963103f67f283b$export$edfc9686e61fe602:
                return "Approved";
            case 0, $a7963103f67f283b$export$7295e7dacdd685b9:
                return "Declined";
        }
    };
    VehicleCard.prototype.getDiagnosticModal = function(state) {
        if (state.modalState === this.MODAL_DIAGNOSTIC) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
            into: "body"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-modal-container scrollable",
            id: state.modalId
        }, (0, $LjoDx.h)((0, $daa42491034d496b$exports.ViewHistoryModal), {
            currentUser: this.props.currentUser,
            vehicle: this.props.vehicle,
            close: this.onModalClose,
            isOutsideClickClose: false,
            containerId: state.modalId
        })));
    };
    VehicleCard.prototype.getPortalModal = function(state) {
        if (state.modalState < 0) return;
        if (state.modalState === this.MODAL_EDIT_VEHICLE) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
            into: "body"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-modal-container",
            id: state.modalId
        }, (0, $LjoDx.h)((0, $cf4c6aa3890dbf4e$exports.EditVehicleModal), {
            currentUser: this.props.currentUser,
            vehicle: this.props.vehicle,
            close: this.onModalClose,
            isOutsideClickClose: false,
            containerId: state.modalId
        })));
        else if (state.modalState === this.MODAL_FILE_REPORT) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
            into: "body"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-modal-container scrollable",
            id: state.modalId
        }, (0, $LjoDx.h)((0, $903a44c9b570043a$exports.FileReportModal), {
            currentUser: this.props.currentUser,
            vehicle: this.props.vehicle,
            close: this.onModalClose,
            isOutsideClickClose: false,
            containerId: state.modalId
        })));
        else if (state.modalState === this.MODAL_CREATE_JOB_ORDER) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
            into: "body"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-modal-container scrollable",
            id: state.modalId
        }, (0, $LjoDx.h)((0, $5bba464be234101c$exports.CreateJobOrderModal), {
            vehicle: this.props.vehicle,
            close: this.onModalClose,
            isOutsideClickClose: false,
            containerId: "anglo-modal-111"
        })));
    };
    VehicleCard.prototype.getActionsBlock = function(props) {
        var _this = this;
        if (props.isDiagnostic) return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: function() {
                return _this.onModalOpened(_this.MODAL_DIAGNOSTIC);
            }
        }, "View vehicle history"))), (0, $LjoDx.h)("div", {
            class: "row mt-2"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: function() {
                return _this.onModalOpened(_this.MODAL_CREATE_JOB_ORDER);
            }
        }, "Create Job Order"))));
        else if (props.currentUser.role === (0, $b9c3387011d11553$export$b38e98e302041724) || props.currentUser.role === (0, $b9c3387011d11553$export$9cb152b3a874b8b0)) return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: function() {
                return _this.onModalOpened(_this.MODAL_EDIT_VEHICLE);
            }
        }, "Edit Vehicle"));
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: function() {
                return _this.onModalOpened(_this.MODAL_FILE_REPORT);
            }
        }, "File Update"));
    };
    VehicleCard.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "vehicle-card"
        }, this.getPortalModal(state), this.getDiagnosticModal(state), (0, $LjoDx.h)("div", {
            class: "vehicle-card__head pb-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, "Vehicle ID ", props.vehicle.vehicleId)), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__body mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-6 mb-3"
        }, (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__label"
        }, "Status"), (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__value"
        }, props.vehicle.status)), (0, $LjoDx.h)("div", {
            class: "col-6 mb-3"
        }, (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__label"
        }, "Plate Number"), (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__value"
        }, props.vehicle.plateNumber)), (0, $LjoDx.h)("div", {
            class: "col-6 mb-3"
        }, (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__label"
        }, "Model/Make"), (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__value"
        }, props.vehicle.modelMake)), (0, $LjoDx.h)("div", {
            class: "col-6 mb-3"
        }, (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__label"
        }, "Lodging Location"), (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__value"
        }, props.vehicle.lodgingLocation ? props.vehicle.lodgingLocation : "Not available"))), props.currentUser.role === "role_management" ? (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__assigned mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__label"
        }, "Assigned to"), (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__value"
        }, props.vehicle.user.firstName, " ", props.vehicle.user.lastName)) : null, (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions mt-3"
        }, this.getActionsBlock(props)));
    };
    return VehicleCard;
}((0, $LjoDx.Component));


var $f4b2eecd03a82f52$exports = {};

$parcel$export($f4b2eecd03a82f52$exports, "CreateVehicleModal", () => $f4b2eecd03a82f52$export$e1e9eb21a8ac6c5a);

var $LjoDx = parcelRequire("LjoDx");












var $f4b2eecd03a82f52$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f4b2eecd03a82f52$export$e1e9eb21a8ac6c5a = /** @class */ function(_super) {
    $f4b2eecd03a82f52$var$__extends(CreateVehicleModal, _super);
    function CreateVehicleModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.onSupervisorSearchChange = function(supervisor) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.vehicleForm, "supervisor", supervisor.username);
        };
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function(e) {
            e.preventDefault();
            var form = _this.state.vehicleForm;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            _this.setState({
                vehicleForm: form
            });
            if (!_this.state.vehicleForm.isValid) return;
            var vehicle = {
                supervisor: form.fields["supervisor"].value,
                modelMake: form.fields["modelMake"].value,
                plateNumber: form.fields["plateNumber"].value,
                lodgingLocation: form.fields["lodgingLocation"].value
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $7859e0852b06702e$export$3366fc19859b9ff8),
                payload: {
                    vehicleToCreate: vehicle
                }
            });
        };
        _this.createForm();
        return _this;
    }
    CreateVehicleModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var vehicles$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(app) {
            return app.vehicles;
        }));
        this.subs.push(vehicles$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(vehicles) {
            return vehicles.createVehicleState;
        })).subscribe(function(reqState) {
            _this.setState({
                createVehicleState: reqState
            });
            if (reqState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) _this.doModalClose();
        }));
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(app) {
            return app.user;
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.supervisors;
        })).subscribe(function(supervisors) {
            _this.setState({
                supervisors: supervisors
            });
        }));
        this.initialStoreDispatches();
    };
    CreateVehicleModal.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $4c71eb74f53637d3$export$d1320805de2a0f43)
        });
    };
    CreateVehicleModal.prototype.componentWillUnmount = function() {
        console.log("unmounting");
    };
    CreateVehicleModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "supervisor": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                "required"
            ], null, ""),
            "modelMake": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                "required"
            ], null, ""),
            "plateNumber": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                "required"
            ], null, ""),
            "lodgingLocation": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            vehicleForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["vehicleForm"] = form;
            _this.setState(state);
        });
    };
    CreateVehicleModal.prototype.getSpinnerBlock = function(state) {
        if (state.createVehicleState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    CreateVehicleModal.prototype.render = function(props, state) {
        var _this = this;
        var form = state.vehicleForm;
        if (!state.supervisors) return;
        return (0, $LjoDx.h)("div", {
            class: "anglo-request-edit-modal container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create Vehicle Entry")), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mb-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Supervisor*"), (0, $LjoDx.h)((0, $204820985097eb0a$exports.AutocompleteSearch), {
            onResultSelected: this.onSupervisorSearchChange
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mb-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Plate Number*"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["plateNumber"])
            }),
            value: form.fields["plateNumber"].value,
            placeholder: "Plate Number",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "plateNumber")
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mb-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Model/Make*"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["modelMake"])
            }),
            value: form.fields["modelMake"].value,
            placeholder: "Model/Make",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "modelMake")
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mb-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Lodging Location"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["lodgingLocation"])
            }),
            value: form.fields["lodgingLocation"].value,
            placeholder: "Lodging Location",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "lodgingLocation")
        })), (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-md-1 offset-md-9"
        }, this.getSpinnerBlock(state)), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: state.createVehicleState == (0, $ad7802471dc8ad45$export$93ca241731165d07)
        }, "Submit"))))));
    };
    return CreateVehicleModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $89a28c0d3a972742$exports = {};

$parcel$export($89a28c0d3a972742$exports, "VehicleFileCard", () => $89a28c0d3a972742$export$1e7acf539beb6c8d);

var $LjoDx = parcelRequire("LjoDx");




var $8432558487a57fc4$exports = {};

$parcel$export($8432558487a57fc4$exports, "RespondFileReportModal", () => $8432558487a57fc4$export$1e6718e858492ad1);

var $LjoDx = parcelRequire("LjoDx");













var $8432558487a57fc4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8432558487a57fc4$export$1e6718e858492ad1 = /** @class */ function(_super) {
    $8432558487a57fc4$var$__extends(RespondFileReportModal, _super);
    function RespondFileReportModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.handleDatepickerValidation = function(date, fieldName) {
            var currentForm = _this.state.vehicleForm;
            // Manually do this because in order to follow the 
            // hopplerLinkstate validation system
            var clonedFields = {};
            for(var k in currentForm.fields){
                var prevField = currentForm.fields[k];
                clonedFields[k] = new (0, $49e398741f5b1a93$export$a455218a85c89869)(prevField.validators, prevField.customValidators, prevField.value);
                clonedFields[k].isValid = prevField.isValid;
            }
            var clone = new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(clonedFields);
            clone.fields[fieldName].value = date;
            clone.fields[fieldName].isPristine = false;
            // clone.fields[fieldName].customValidators.forEach(a => a(clone.fields[fieldName], clone));
            _this.form$.next(clone);
        };
        _this.onDateSelected = function(date) {
            _this.handleDatepickerValidation(date, "dateOfIncident");
        };
        _this.onApprove = function() {
            var form = _this.state.vehicleForm;
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $7859e0852b06702e$export$615e5a2c325fd326),
                payload: {
                    responseReason: form.fields["responseReason"].value,
                    vehicleFileToUpdate: _this.props.vehicleFile._id,
                    vehicleId: _this.props.vehicleFile.vehicleId
                }
            });
        };
        _this.onReject = function() {
            var form = _this.state.vehicleForm;
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $7859e0852b06702e$export$b5f09aa9d5f1a613),
                payload: {
                    responseReason: form.fields["responseReason"].value,
                    vehicleFileToUpdate: _this.props.vehicleFile._id,
                    vehicleId: _this.props.vehicleFile.vehicleId
                }
            });
        };
        _this.createForm();
        return _this;
    }
    RespondFileReportModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "responseReason": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            vehicleForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["vehicleForm"] = form;
            _this.setState(state);
        });
    };
    RespondFileReportModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var vehicles$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(app) {
            return app.vehicles;
        }));
        this.subs.push(vehicles$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(vehicles) {
            return vehicles.respondVehicleFileState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(reqState) {
            _this.setState({
                respondVehicleFileState: reqState
            });
            if (reqState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) _this.doModalClose();
        }));
    };
    RespondFileReportModal.prototype.getStatusName = function(status) {
        if (status === (0, $ef963b76c9929143$export$a16c40bdf130d7bb)) return "Pending";
        if (status === (0, $ef963b76c9929143$export$5345326be310f09d)) return "Approved";
        if (status === (0, $ef963b76c9929143$export$9db2761dfefe51f4)) return "Denied";
    };
    RespondFileReportModal.prototype.getExpenseTotal = function(props) {
        var total = 0;
        var expenses = props.vehicleFile.expenses;
        expenses.forEach(function(expense) {
            total += Number.parseInt(expense.amount);
        });
        return "₱ ".concat((0, $9e0c3e3a397653e5$export$a81f732198733497)(total));
    };
    RespondFileReportModal.prototype.getExpensesBlock = function(props) {
        if (props.vehicleFile.expenses && props.vehicleFile.expenses.length > 0) return (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Expenses"), (0, $LjoDx.h)("hr", {
            class: "my-1"
        }), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-6"
        }, (0, $LjoDx.h)("b", {
            class: "mb-1"
        }, "Expense")), (0, $LjoDx.h)("div", {
            class: "col-6"
        }, (0, $LjoDx.h)("b", {
            class: "mb-1"
        }, "Amount"))), props.vehicleFile.expenses.map(function(member) {
            return (0, $LjoDx.h)("div", {
                class: "row mb-2"
            }, (0, $LjoDx.h)("div", {
                class: "col-6"
            }, (0, $LjoDx.h)("input", {
                type: "text",
                class: "form-control",
                value: member.name,
                disabled: true
            })), (0, $LjoDx.h)("div", {
                class: "col-6"
            }, (0, $LjoDx.h)("input", {
                type: "text",
                class: "form-control",
                value: "₱ ".concat(member.amount),
                disabled: true
            })));
        }), (0, $LjoDx.h)("h4", null, "Total: ", this.getExpenseTotal(props)));
    };
    RespondFileReportModal.prototype.getActionsBlock = function(props, state) {
        if (props.currentUser.role === (0, $b9c3387011d11553$export$b38e98e302041724) || props.currentUser.role === (0, $b9c3387011d11553$export$9cb152b3a874b8b0)) return (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "offset-4 col-4"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.onReject
        }, "Reject")), (0, $LjoDx.h)("div", {
            class: "col-4"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onApprove
        }, "Approve")));
    };
    RespondFileReportModal.prototype.getModalHeadingBlock = function(props) {
        if (props.currentUser.role === (0, $b9c3387011d11553$export$b38e98e302041724) || props.currentUser.role === (0, $b9c3387011d11553$export$9cb152b3a874b8b0)) return (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Vehicle File | ", (0, $LjoDx.h)("small", null, props.vehicleFile.user.firstName, " ", props.vehicleFile.user.lastName));
        else return (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Vehicle File | ", (0, $LjoDx.h)("small", null, props.vehicleFile.vehicleId));
    };
    RespondFileReportModal.prototype.getResponseReasonBlock = function(props, state) {
        if (props.currentUser.role === (0, $b9c3387011d11553$export$b38e98e302041724) || props.currentUser.role === (0, $b9c3387011d11553$export$9cb152b3a874b8b0)) {
            var form = state.vehicleForm;
            return (0, $LjoDx.h)("div", {
                class: "col-12 mt-3"
            }, (0, $LjoDx.h)("label", {
                class: "anglo-remittance__submit-form__label"
            }, "Response Reason*"), (0, $LjoDx.h)("textarea", {
                class: "form-control anglo-request-edit-modal__reason",
                value: form.fields["responseReason"].value,
                onInput: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "responseReason"),
                disabled: props.currentUser.role !== (0, $b9c3387011d11553$export$b38e98e302041724) && props.currentUser.role !== (0, $b9c3387011d11553$export$9cb152b3a874b8b0),
                placeholder: "Response Reason"
            }));
        }
    };
    RespondFileReportModal.prototype.render = function(props, state) {
        var _this = this;
        var form = state.vehicleForm;
        return (0, $LjoDx.h)("div", {
            class: "anglo-file-report-modal container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-10"
        }, this.getModalHeadingBlock(props)), (0, $LjoDx.h)("div", {
            class: "col-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Type"), (0, $LjoDx.h)("input", {
            type: "text",
            class: "form-control",
            disabled: true,
            value: this.getStatusName(props.vehicleFile.status)
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mt-3 mt-md-0"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Date of Incident"), (0, $LjoDx.h)("input", {
            type: "text",
            class: "form-control",
            disabled: true,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(props.vehicleFile.dateOfReport).format("MM-DD-YYYY")
        })), (0, $LjoDx.h)("div", {
            class: "col-12 mt-3 d-flex align-items-center"
        }, "This happened in the Anglo motorpool ", (0, $LjoDx.h)("input", {
            class: "ml-2",
            type: "checkbox",
            disabled: true,
            checked: props.vehicleFile.isMotorpool
        })), (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Description/Details"), (0, $LjoDx.h)("textarea", {
            class: "form-control anglo-request-edit-modal__reason",
            value: props.vehicleFile.description,
            disabled: true,
            placeholder: "Details of report"
        })), this.getExpensesBlock(props), this.getResponseReasonBlock(props, state), (0, $LjoDx.h)("div", {
            class: "col-12"
        }, this.getActionsBlock(props, state))));
    };
    return RespondFileReportModal;
}((0, $3f2ba7f1e3532510$exports.Modal));





var $89a28c0d3a972742$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $89a28c0d3a972742$export$1e7acf539beb6c8d = /** @class */ function(_super) {
    $89a28c0d3a972742$var$__extends(VehicleFileCard, _super);
    function VehicleFileCard(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.onModalClose = function() {
            _this.setState({
                isModalOpen: false
            });
            _this.update();
        };
        _this.onModalOpen = function() {
            var random = Math.floor(Math.random() * 200);
            console.log(_this.state);
            _this.setState({
                isModalOpen: true,
                modalId: "anglo-modal-".concat(random)
            });
        };
        return _this;
    }
    VehicleFileCard.prototype.componentDidMount = function() {};
    VehicleFileCard.prototype.getStatusLabel = function(status) {
        switch(status){
            case 0, $a7963103f67f283b$export$bd8c052af7c42aad:
                return "Pending";
            case 0, $a7963103f67f283b$export$edfc9686e61fe602:
                return "Approved";
            case 0, $a7963103f67f283b$export$7295e7dacdd685b9:
                return "Declined";
        }
    };
    VehicleFileCard.prototype.getPortalModal = function(state) {
        if (state.isModalOpen) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
            into: "body"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-modal-container scrollable",
            id: state.modalId
        }, (0, $LjoDx.h)((0, $8432558487a57fc4$exports.RespondFileReportModal), {
            currentUser: this.props.currentUser,
            vehicleFile: this.props.vehicleFile,
            close: this.onModalClose,
            isOutsideClickClose: false,
            containerId: state.modalId
        })));
    };
    VehicleFileCard.prototype.update = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $7859e0852b06702e$export$417d121b6bc4be50),
            payload: {
                type: "edit"
            }
        });
        store.dispatch({
            type: (0, $7859e0852b06702e$export$6d686d51d5c3c8d0),
            payload: {
            }
        });
    };
    VehicleFileCard.prototype.getStatusName = function(status) {
        if (status === (0, $ef963b76c9929143$export$a16c40bdf130d7bb)) return "Pending";
        if (status === (0, $ef963b76c9929143$export$5345326be310f09d)) return "Approved";
        if (status === (0, $ef963b76c9929143$export$9db2761dfefe51f4)) return "Denied";
    };
    VehicleFileCard.prototype.getActionsBlock = function(props) {
        // if (props.vehicleFile.status !== FILE_STATUS_PENDING) {
        //   return;
        // }
        if (props.currentUser.role === "role_management") return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onModalOpen
        }, "Respond to File"));
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onModalOpen
        }, "View Details"));
    };
    VehicleFileCard.prototype.getResponseBlock = function(props) {
        if (props.vehicleFile.responseReason) return (0, $LjoDx.h)("div", {
            class: "col-12 mb-3"
        }, (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__label"
        }, "Response"), (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__value"
        }, props.vehicleFile.responseReason));
    };
    VehicleFileCard.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "vehicle-card file"
        }, this.getPortalModal(state), (0, $LjoDx.h)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("vehicle-card__head pb-3", {
                "pending": props.vehicleFile.status === (0, $ef963b76c9929143$export$a16c40bdf130d7bb),
                "approved": props.vehicleFile.status === (0, $ef963b76c9929143$export$5345326be310f09d),
                "denied": props.vehicleFile.status === (0, $ef963b76c9929143$export$9db2761dfefe51f4)
            })
        }, (0, $LjoDx.h)("div", {
            class: ""
        }, "Vehicle ID ", props.vehicleFile.vehicleId), (0, $LjoDx.h)("div", {
            class: " text-right"
        }, props.vehicleFile.vehicle.plateNumber)), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__body mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-6 mb-3"
        }, (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__label"
        }, "File Type"), (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__value"
        }, props.vehicleFile.type)), (0, $LjoDx.h)("div", {
            class: "col-6 mb-3"
        }, (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__label"
        }, "Status"), (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__value"
        }, this.getStatusName(props.vehicleFile.status))), (0, $LjoDx.h)("div", {
            class: "col mb-3"
        }, (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__label"
        }, "Date of Report"), (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__value"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(props.vehicleFile.dateOfReport).format("MMM DD, YYYY"))), props.currentUser.role === "role_management" ? (0, $LjoDx.h)("div", {
            class: "col mb-3"
        }, (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__label"
        }, "Supervisor"), (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__value"
        }, props.vehicleFile.user.firstName, " ", props.vehicleFile.user.lastName)) : null, (0, $LjoDx.h)("div", {
            class: "col-12 mb-3"
        }, (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__label"
        }, "Details"), (0, $LjoDx.h)("div", {
            class: "vehicle-card__body__value"
        }, props.vehicleFile.description)), this.getResponseBlock(props)), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions mt-3"
        }, this.getActionsBlock(props)));
    };
    return VehicleFileCard;
}((0, $LjoDx.Component));









var $5735631cf4aa9e7e$exports = {};

$parcel$export($5735631cf4aa9e7e$exports, "GenerateExpenseReportModal", () => $5735631cf4aa9e7e$export$bbf12357a28c8946);

var $LjoDx = parcelRequire("LjoDx");












var $5735631cf4aa9e7e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5735631cf4aa9e7e$export$bbf12357a28c8946 = /** @class */ function(_super) {
    $5735631cf4aa9e7e$var$__extends(GenerateExpenseReportModal, _super);
    function GenerateExpenseReportModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.handleDatepickerValidation = function(date, fieldName) {
            var currentForm = _this.state.expenseReportForm;
            // Manually do this because in order to follow the 
            // hopplerLinkstate validation system
            var clonedFields = {};
            for(var k in currentForm.fields){
                var prevField = currentForm.fields[k];
                clonedFields[k] = new (0, $49e398741f5b1a93$export$a455218a85c89869)(prevField.validators, prevField.customValidators, prevField.value);
                clonedFields[k].isValid = prevField.isValid;
            }
            var clone = new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(clonedFields);
            clone.fields[fieldName].value = date;
            clone.fields[fieldName].isPristine = false;
            // clone.fields[fieldName].customValidators.forEach(a => a(clone.fields[fieldName], clone));
            _this.form$.next(clone);
        };
        _this.onSupervisorSearchChange = function(supervisor) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.expenseReportForm, "username", supervisor.username);
        };
        _this.onStartDateSelected = function(date) {
            _this.handleDatepickerValidation(date, "startDate");
        };
        _this.onEndDateSelected = function(date) {
            _this.handleDatepickerValidation(date, "endDate");
        };
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function(e) {
            e.preventDefault();
            var form = _this.state.expenseReportForm;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            _this.setState({
                expenseReportForm: form
            });
            if (!_this.state.expenseReportForm.isValid) return;
            var filters = {
                username: form.fields["username"].value,
                startDate: form.fields["startDate"].value,
                endDate: form.fields["endDate"].value
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $7859e0852b06702e$export$53f4e43bfbd6f4cc),
                payload: {
                    filters: filters
                }
            });
        };
        _this.createForm();
        return _this;
    }
    GenerateExpenseReportModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var vehicles$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(app) {
            return app.vehicles;
        }));
        this.subs.push(vehicles$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(vehicles) {
            return vehicles.createVehicleState;
        })).subscribe(function(reqState) {
            _this.setState({
                createVehicleState: reqState
            });
            if (reqState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) _this.doModalClose();
        }));
        this.initialStoreDispatches();
    };
    GenerateExpenseReportModal.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $4c71eb74f53637d3$export$d1320805de2a0f43)
        });
    };
    GenerateExpenseReportModal.prototype.componentWillUnmount = function() {
        this.subs.forEach(function(s) {
            return s.unsubscribe();
        });
    };
    GenerateExpenseReportModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "username": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                "required"
            ], null, ""),
            "startDate": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                ""
            ], null, ""),
            "endDate": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                ""
            ], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            expenseReportForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["expenseReportForm"] = form;
            _this.setState(state);
        });
    };
    GenerateExpenseReportModal.prototype.getSpinnerBlock = function(state) {
        if (state.createVehicleState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    GenerateExpenseReportModal.prototype.render = function(props, state) {
        var _this = this;
        var form = state.expenseReportForm;
        return (0, $LjoDx.h)("div", {
            class: "anglo-generate-expose-report-modal container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Generate Expense Report")), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4 mb-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Supervisor*"), (0, $LjoDx.h)((0, $204820985097eb0a$exports.AutocompleteSearch), {
            onResultSelected: this.onSupervisorSearchChange
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4 mb-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Start Date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: this.onStartDateSelected,
            initialValue: form.fields["startDate"].value,
            isValid: form.fields["startDate"].isValid,
            isPristine: form.fields["startDate"].isPristine
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4 mb-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "End Date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: this.onEndDateSelected,
            initialValue: form.fields["endDate"].value,
            isValid: form.fields["endDate"].isValid,
            isPristine: form.fields["endDate"].isPristine
        })), (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-md-1 offset-md-9"
        }, this.getSpinnerBlock(state)), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: state.createVehicleState == (0, $ad7802471dc8ad45$export$93ca241731165d07)
        }, "Generate"))))));
    };
    return GenerateExpenseReportModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $5c6b365a0e460dd1$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5c6b365a0e460dd1$export$901c613ab30cda9b = /** @class */ function(_super) {
    $5c6b365a0e460dd1$var$__extends(DashVehicles, _super);
    function DashVehicles(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.MODAL_CREATE_VEHICLE = 0;
        _this.MODAL_GENERATE_EXPENSE_REPORT = 1;
        _this.resetFilters = function() {
            var fieldList = _this.state.filters.fields;
            for(var k in fieldList)fieldList[k].value = null;
            var form = _this.state.filters;
            form.fields = fieldList;
            form["page"] = 1;
            _this.setState({
                filters: form
            });
        };
        _this.applyFilters = function() {
            // let filters: Map<string, any> = new Map<string, any>();
            var filters = {};
            var fieldList = _this.state.filters.fields;
            for(var k in fieldList)if (fieldList[k].value) // filters.set(k, fieldList[k].value);
            filters[k] = fieldList[k].value;
            // when new filters are applied, always set back to first page
            filters["page"] = 1;
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            if (!_this.state.isViewingFiles) store.dispatch({
                type: (0, $7859e0852b06702e$export$6d686d51d5c3c8d0),
                payload: {
                    filters: filters,
                    gridRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
                }
            });
            else store.dispatch({
                type: (0, $7859e0852b06702e$export$417d121b6bc4be50),
                payload: {
                    filters: filters,
                    gridRequestState: (0, $ad7802471dc8ad45$export$93ca241731165d07)
                }
            });
        };
        _this.onFilesPageClicked = function(page) {
            var filters = {};
            var fieldList = _this.state.filters.fields;
            for(var k in fieldList)if (fieldList[k].value) // filters.set(k, fieldList[k].value);
            filters[k] = fieldList[k].value;
            filters["page"] = page;
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $7859e0852b06702e$export$417d121b6bc4be50),
                payload: {
                    filters: filters
                }
            });
            _this.setState({
                filesCurrentPage: page
            });
        };
        _this.onVehiclesPageClicked = function(page) {
            var filters = {};
            var fieldList = _this.state.filters.fields;
            for(var k in fieldList)if (fieldList[k].value) // filters.set(k, fieldList[k].value);
            filters[k] = fieldList[k].value;
            filters["page"] = page;
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $7859e0852b06702e$export$6d686d51d5c3c8d0),
                payload: {
                    filters: filters
                }
            });
            _this.setState({
                vehiclesCurrentPage: page
            });
        };
        _this.onSupervisorSearchChange = function(supervisor) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filters, "username", supervisor.username);
        };
        _this.onVehiclesClicked = function() {
            _this.setState({
                isViewingFiles: false
            });
        };
        _this.onFilesClicked = function() {
            _this.setState({
                isViewingFiles: true
            });
        };
        _this.onFilterToggleClicked = function() {
            _this.setState({
                isFilterVisible: !_this.state.isFilterVisible
            });
        };
        _this.onModalOpened = function(paramState) {
            _this.setState({
                modalState: paramState
            });
        };
        _this.onModalClose = function() {
            _this.setState({
                modalState: -1
            });
        };
        _this.getPortalModal = function(state) {
            if (state.modalState < 0) return;
            if (state.modalState === _this.MODAL_CREATE_VEHICLE) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-111"
            }, (0, $LjoDx.h)((0, $f4b2eecd03a82f52$exports.CreateVehicleModal), {
                currentUser: state.currentUser,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-111"
            })));
            else if (state.modalState === _this.MODAL_GENERATE_EXPENSE_REPORT) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-111"
            }, (0, $LjoDx.h)((0, $5735631cf4aa9e7e$exports.GenerateExpenseReportModal), {
                currentUser: state.currentUser,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-111"
            })));
        };
        _this.setState({
            filesCurrentPage: 1,
            vehiclesCurrentPage: 1,
            modalState: -1
        });
        _this.createForm();
        return _this;
    }
    DashVehicles.prototype.componentDidMount = function() {
        var _this = this;
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.user;
        }));
        this.subs.push(user$.subscribe(function(user) {
            if (user.currentUser) _this.setState({
                currentUser: user.currentUser
            });
        }));
        var vehicles$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.vehicles;
        }));
        this.subs.push(vehicles$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(vehicles) {
            return vehicles.vehicles;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(vehicles) {
            _this.setState({
                vehicles: vehicles
            });
        }));
        this.subs.push(vehicles$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(vehicles) {
            return vehicles.totalVehicles;
        })).subscribe(function(total) {
            if (total) {
                var pages = [];
                var limit = Math.ceil(total / (0, $787290684425694f$exports.PAGE_SIZE));
                for(var i = 0; i < limit; i++)pages.push(i + 1);
                _this.setState({
                    vehiclesPages: pages
                });
            }
        }));
        this.subs.push(vehicles$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(vehicles) {
            return vehicles.vehicleFiles;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(vehicleFiles) {
            _this.setState({
                vehicleFiles: vehicleFiles
            });
        }));
        this.subs.push(vehicles$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(vehicles) {
            return vehicles.totalVehicleFiles;
        })).subscribe(function(total) {
            if (total) {
                var pages = [];
                var limit = Math.ceil(total / (0, $787290684425694f$exports.PAGE_SIZE));
                for(var i = 0; i < limit; i++)pages.push(i + 1);
                _this.setState({
                    filesPages: pages
                });
            }
        }));
        this.initialStoreDispatches();
    };
    DashVehicles.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "status": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "plateNumber": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "lodgingLocation": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "modelMake": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "username": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "vehicleId": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            filters: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["filters"] = form;
            _this.setState(state);
        });
    };
    DashVehicles.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $7859e0852b06702e$export$6d686d51d5c3c8d0),
            payload: {
                type: "edit",
                filters: {
                    page: 1
                }
            }
        });
        store.dispatch({
            type: (0, $7859e0852b06702e$export$417d121b6bc4be50),
            payload: {
                type: "edit",
                filters: {
                    page: 1
                }
            }
        });
    };
    DashVehicles.prototype.getVehicleData = function(state) {
        var _this = this;
        if (!state.isViewingFiles) {
            if (state.vehicles) return (0, $LjoDx.h)("div", {
                class: "dash-updates__card-container row"
            }, state.vehicles.map(function(member) {
                // if (state.currentUser.role === 'role_supervisor' && member.status !== 'decommissioned') {
                //   return (
                //     <div class="col-3">
                //       <VehicleCard currentUser={state.currentUser}
                //         vehicle={member} />
                //     </div>
                //   );
                // } else {
                //   return (
                //     <div class="col-3">
                //       <VehicleCard currentUser={state.currentUser}
                //         vehicle={member} />
                //     </div>
                //   );
                // }
                return (0, $LjoDx.h)("div", {
                    class: "col-12 col-md-6 col-lg-3 mb-3"
                }, (0, $LjoDx.h)((0, $a4a8267daa7d5e18$exports.VehicleCard), {
                    currentUser: state.currentUser,
                    vehicle: member
                }));
            }), (0, $LjoDx.h)("div", {
                class: "col-12 mt-4"
            }, state.vehiclesPages ? (0, $LjoDx.h)("div", {
                class: "dash-remittance__pagination mb-3"
            }, (0, $LjoDx.h)("button", {
                class: "btn dash-remittance__pagination__page arrow",
                disabled: state.vehiclesCurrentPage === 1,
                onClick: function() {
                    return _this.onVehiclesPageClicked(state.vehiclesCurrentPage - 1);
                }
            }, (0, $LjoDx.h)("i", {
                class: "fas fa-chevron-left"
            })), state.vehiclesCurrentPage > 5 ? (0, $LjoDx.h)("button", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                    "active": state.vehiclesPages[0] === state.vehiclesCurrentPage
                }),
                onClick: function() {
                    return _this.onVehiclesPageClicked(state.vehiclesPages[0]);
                }
            }, state.vehiclesPages[0]) : null, state.vehiclesCurrentPage > 5 ? (0, $LjoDx.h)("span", {
                class: "mx-2"
            }, "...") : null, state.vehiclesPages ? state.vehiclesPages.map(function(page) {
                if (page > state.vehiclesCurrentPage - 5 && page < state.vehiclesCurrentPage + 5) return (0, $LjoDx.h)("button", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                        "active": page === state.vehiclesCurrentPage
                    }),
                    onClick: function() {
                        return _this.onVehiclesPageClicked(page);
                    }
                }, page);
            }) : null, state.vehiclesCurrentPage < state.vehiclesPages.length - 5 ? (0, $LjoDx.h)("span", {
                class: "mx-2"
            }, "...") : null, state.vehiclesCurrentPage < state.vehiclesPages.length - 5 ? (0, $LjoDx.h)("button", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                    "active": state.vehiclesPages[state.vehiclesPages.length - 1] === state.vehiclesCurrentPage
                }),
                onClick: function() {
                    return _this.onVehiclesPageClicked(state.vehiclesPages[state.vehiclesPages.length - 1]);
                }
            }, state.vehiclesPages[state.vehiclesPages.length - 1]) : null, (0, $LjoDx.h)("button", {
                class: "btn dash-remittance__pagination__page arrow",
                disabled: state.vehiclesCurrentPage === state.vehiclesPages[state.vehiclesPages.length - 1],
                onClick: function() {
                    return _this.onVehiclesPageClicked(state.vehiclesCurrentPage + 1);
                }
            }, (0, $LjoDx.h)("i", {
                class: "fas fa-chevron-right"
            }))) : null));
        }
    };
    DashVehicles.prototype.getVehicleFilesData = function(state) {
        var _this = this;
        if (state.isViewingFiles) {
            if (state.vehicleFiles) return (0, $LjoDx.h)("div", {
                class: "dash-updates__card-container row"
            }, state.vehicleFiles.map(function(member) {
                return (0, $LjoDx.h)("div", {
                    class: "col-12 col-md-6 col-lg-3 mb-3"
                }, (0, $LjoDx.h)((0, $89a28c0d3a972742$exports.VehicleFileCard), {
                    currentUser: state.currentUser,
                    vehicleFile: member
                }));
            }), (0, $LjoDx.h)("div", {
                class: "col-12 mt-4"
            }, state.filesPages ? (0, $LjoDx.h)("div", {
                class: "dash-remittance__pagination mb-3"
            }, (0, $LjoDx.h)("button", {
                class: "btn dash-remittance__pagination__page arrow",
                disabled: state.filesCurrentPage === 1,
                onClick: function() {
                    return _this.onFilesPageClicked(state.filesCurrentPage - 1);
                }
            }, (0, $LjoDx.h)("i", {
                class: "fas fa-chevron-left"
            })), state.filesCurrentPage > 5 ? (0, $LjoDx.h)("button", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                    "active": state.filesPages[0] === state.filesCurrentPage
                }),
                onClick: function() {
                    return _this.onFilesPageClicked(state.filesPages[0]);
                }
            }, state.filesPages[0]) : null, state.filesCurrentPage > 5 ? (0, $LjoDx.h)("span", {
                class: "mx-2"
            }, "...") : null, state.filesPages ? state.filesPages.map(function(page) {
                if (page > state.filesCurrentPage - 5 && page < state.filesCurrentPage + 5) return (0, $LjoDx.h)("button", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                        "active": page === state.filesCurrentPage
                    }),
                    onClick: function() {
                        return _this.onFilesPageClicked(page);
                    }
                }, page);
            }) : null, state.filesCurrentPage < state.filesPages.length - 5 ? (0, $LjoDx.h)("span", {
                class: "mx-2"
            }, "...") : null, state.filesCurrentPage < state.filesPages.length - 5 ? (0, $LjoDx.h)("button", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                    "active": state.filesPages[state.filesPages.length - 1] === state.filesCurrentPage
                }),
                onClick: function() {
                    return _this.onFilesPageClicked(state.filesPages[state.filesPages.length - 1]);
                }
            }, state.filesPages[state.filesPages.length - 1]) : null, (0, $LjoDx.h)("button", {
                class: "btn dash-remittance__pagination__page arrow",
                disabled: state.filesCurrentPage === state.filesPages[state.filesPages.length - 1],
                onClick: function() {
                    return _this.onFilesPageClicked(state.filesCurrentPage + 1);
                }
            }, (0, $LjoDx.h)("i", {
                class: "fas fa-chevron-right"
            }))) : null));
        }
    };
    DashVehicles.prototype.getFilterBlock = function(state) {
        var form = state.filters;
        if (state.isFilterVisible && !state.isViewingFiles) return (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, (0, $LjoDx.h)("div", {
            class: "row mt-1 dash-vehicles__filters dash-remittance__filter-row__filters"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mb-2"
        }, (0, $LjoDx.h)("label", {
            class: "dash-vehicles__filters__label"
        }, "Plate Number"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["plateNumber"])
            }),
            value: form.fields["plateNumber"].value,
            placeholder: "",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "plateNumber")
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mb-2"
        }, (0, $LjoDx.h)("label", {
            class: "dash-vehicles__filters__label"
        }, "Vehicle ID"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["vehicleId"])
            }),
            value: form.fields["vehicleId"].value,
            placeholder: "",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "vehicleId")
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mb-2"
        }, (0, $LjoDx.h)("label", {
            class: "dash-vehicles__filters__label"
        }, "Model / Make"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["modelMake"])
            }),
            value: form.fields["modelMake"].value,
            placeholder: "",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "modelMake")
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mb-2"
        }, (0, $LjoDx.h)("label", {
            class: "dash-vehicles__filters__label"
        }, "Status"), (0, $LjoDx.h)("select", {
            class: "form-control",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control text-capitalize", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["status"])
            }),
            placeholder: "Status",
            value: form.fields["status"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "status")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, "Select Status"), (0, $LjoDx.h)("option", {
            class: "text-capitalize",
            value: ""
        }, "All"), (0, $ef963b76c9929143$export$7ff2232ea0900df2).map(function(status) {
            return (0, $LjoDx.h)("option", {
                class: "text-capitalize",
                value: status
            }, status);
        }))), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mb-2"
        }, (0, $LjoDx.h)("label", {
            class: "dash-vehicles__filters__label"
        }, "Supervisor"), (0, $LjoDx.h)((0, $204820985097eb0a$exports.AutocompleteSearch), {
            onResultSelected: this.onSupervisorSearchChange
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mb-2"
        }, (0, $LjoDx.h)("label", {
            class: "dash-vehicles__filters__label"
        }, "Lodging Location"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["lodgingLocation"])
            }),
            value: form.fields["lodgingLocation"].value,
            placeholder: "",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "lodgingLocation")
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "mt-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.resetFilters
        }, "Reset Filters"))), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "mt-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.applyFilters
        }, "Apply Filters")))));
        else if (state.isFilterVisible && state.isViewingFiles) return (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, (0, $LjoDx.h)("div", {
            class: "row mt-1 dash-vehicles__filters dash-remittance__filter-row__filters"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6"
        }, (0, $LjoDx.h)("label", {
            class: "dash-vehicles__filters__label"
        }, "Supervisor"), (0, $LjoDx.h)((0, $204820985097eb0a$exports.AutocompleteSearch), {
            onResultSelected: this.onSupervisorSearchChange
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6"
        }, (0, $LjoDx.h)("label", {
            class: "dash-vehicles__filters__label"
        }, "Vehicle ID"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["vehicleId"])
            }),
            value: form.fields["vehicleId"].value,
            placeholder: "",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "vehicleId")
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "mt-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.resetFilters
        }, "Reset Filters"))), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "mt-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.applyFilters
        }, "Apply Filters")))));
    };
    DashVehicles.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "dash-updates"
        }, this.getPortalModal(state), (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-8 col-lg-4"
        }, (0, $LjoDx.h)("nav", {
            "aria-label": "breadcrumb"
        }, (0, $LjoDx.h)("ol", {
            class: "breadcrumb"
        }, (0, $LjoDx.h)("li", {
            class: "breadcrumb-item"
        }, (0, $LjoDx.h)("a", {
            href: "#"
        }, "Vehicles")))))), (0, $LjoDx.h)("div", {
            class: "row dash-updates__type-row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4 offset-md-4"
        }, (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("w-50 dash-updates__type-row__button first", {
                "active": !state.isViewingFiles
            }),
            onClick: this.onVehiclesClicked
        }, "View Vehicles"), (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("w-50 dash-updates__type-row__button last", {
                "active": state.isViewingFiles
            }),
            onClick: this.onFilesClicked
        }, "View Vehicle Files"))), (0, $LjoDx.h)("hr", null), state.currentUser && (state.currentUser.role === "role_management" || state.currentUser.role === "role_vehicle-manager") ? (0, $LjoDx.h)("div", {
            class: "row mt-4 mb-4 mb-md-0"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4 col-lg-2 offset-md-2 offset-lg-8 d-flex mb-3 mb-md-0 justify-content-end align-items-center"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: function() {
                return _this.onModalOpened(_this.MODAL_GENERATE_EXPENSE_REPORT);
            }
        }, "Generate Expense Report")), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4 col-lg-2 d-flex justify-content-end align-items-center"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: function() {
                return _this.onModalOpened(_this.MODAL_CREATE_VEHICLE);
            }
        }, "Create Vehicle Entry"))) : null, (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col d-flex justify-content-end align-items-center"
        }, (0, $LjoDx.h)("a", {
            class: "dash-remittance__filter-row__filter-btn mr-3",
            onClick: this.onFilterToggleClicked
        }, "Filter ", (0, $LjoDx.h)("i", {
            class: "fas fa-filter"
        })))), this.getFilterBlock(state), (0, $LjoDx.h)("div", {
            class: "mt-5"
        }, this.getVehicleData(state), this.getVehicleFilesData(state))));
    };
    return DashVehicles;
}((0, $LjoDx.Component));


var $5760e073989df791$exports = {};

$parcel$export($5760e073989df791$exports, "DashUserManagement", () => $5760e073989df791$export$b7a3e8f0c6428462);

var $LjoDx = parcelRequire("LjoDx");






var $71fda3c649820f63$exports = {};

$parcel$export($71fda3c649820f63$exports, "CreateBankAccountModal", () => $71fda3c649820f63$export$2906014ad8dcf345);

var $LjoDx = parcelRequire("LjoDx");










var $71fda3c649820f63$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $71fda3c649820f63$export$2906014ad8dcf345 = /** @class */ function(_super) {
    $71fda3c649820f63$var$__extends(CreateBankAccountModal, _super);
    function CreateBankAccountModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var bankAccount = {
                bankAccountName: form.fields["bankAccountName"].value,
                bankAccountNumber: form.fields["bankAccountNumber"].value,
                bank: form.fields["bank"].value,
                accountBranch: form.fields["accountBranch"].value
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $4c71eb74f53637d3$export$3f05487ba7fe474b),
                payload: {
                    bankAccount: bankAccount
                }
            });
        };
        _this.createForm();
        return _this;
    }
    CreateBankAccountModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "bankAccountName": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "bankAccountNumber": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "bank": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "accountBranch": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    CreateBankAccountModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(app) {
            return app.user;
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.createBankAccountState;
        })).subscribe(function(reqState) {
            _this.setState({
                submitStatus: reqState
            });
            if (reqState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) _this.doModalClose();
        }));
    };
    CreateBankAccountModal.prototype.componentWillUnmount = function() {
        this.subs.forEach(function(s) {
            return s.unsubscribe();
        });
    };
    CreateBankAccountModal.prototype.getSpinnerBlock = function(state) {
        if (state.submitStatus === (0, $ad7802471dc8ad45$export$93ca241731165d07)) return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    CreateBankAccountModal.prototype.render = function(props, state) {
        var _this = this;
        var form = state.form;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create bank account")), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Account Name*"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["bankAccountName"])
            }),
            value: form.fields["bankAccountName"].value,
            placeholder: "",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "bankAccountName")
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mt-3 mt-md-0"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Account Number*"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["bankAccountNumber"])
            }),
            value: form.fields["bankAccountNumber"].value,
            placeholder: "",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "bankAccountNumber")
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mt-3 mt-md-0 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Bank*"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["bank"])
            }),
            value: form.fields["bank"].value,
            placeholder: "",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "bank")
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mt-3 mt-md-0 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Account Branch Location*"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["accountBranch"])
            }),
            value: form.fields["accountBranch"].value,
            placeholder: "",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "accountBranch")
        })), (0, $LjoDx.h)("div", {
            class: "col-2 offset-8 mt-4"
        }, this.getSpinnerBlock(state)), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-2 mt-4"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit
        }, "Submit"))));
    };
    return CreateBankAccountModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $06a59890bc9ce984$exports = {};

$parcel$export($06a59890bc9ce984$exports, "CreateUserModal", () => $06a59890bc9ce984$export$ca682fcf9bfd81bf);

var $LjoDx = parcelRequire("LjoDx");











var $06a59890bc9ce984$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $06a59890bc9ce984$export$ca682fcf9bfd81bf = /** @class */ function(_super) {
    $06a59890bc9ce984$var$__extends(CreateUserModal, _super);
    function CreateUserModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var user = {
                username: form.fields["username"].value,
                password: form.fields["password"].value,
                firstName: form.fields["firstName"].value,
                middleName: form.fields["middleName"].value,
                lastName: form.fields["lastName"].value,
                role: form.fields["role"].value
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $4c71eb74f53637d3$export$3886e73aa4232c67),
                payload: {
                    userToCreate: user
                }
            });
        };
        _this.createForm();
        return _this;
    }
    CreateUserModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "username": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "password": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "firstName": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "middleName": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "lastName": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "role": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "area": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    CreateUserModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(app) {
            return app.user;
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.createUserState;
        })).subscribe(function(reqState) {
            _this.setState({
                submitStatus: reqState
            });
            if (reqState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) _this.doModalClose();
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.allBankAccounts;
        })).subscribe(function(allBankAccounts) {
            _this.setState({
                allBankAccounts: allBankAccounts
            });
        }));
        this.initialStoreDispatches();
    };
    CreateUserModal.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $4c71eb74f53637d3$export$74d61c62c586516a)
        });
    };
    CreateUserModal.prototype.componentWillUnmount = function() {
        this.subs.forEach(function(s) {
            return s.unsubscribe();
        });
    };
    CreateUserModal.prototype.getSpinnerBlock = function(state) {
        if (state.submitStatus === (0, $ad7802471dc8ad45$export$93ca241731165d07)) return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    CreateUserModal.prototype.getRoleLabel = function(role) {
        if (role === (0, $b9c3387011d11553$export$819e975c5d2910e9)) return "Supervisor";
        if (role === (0, $b9c3387011d11553$export$a805ed97d1d93366)) return "Auditor";
        if (role === (0, $b9c3387011d11553$export$9cb152b3a874b8b0)) return "Vehicle Manager";
        if (role === (0, $b9c3387011d11553$export$b38e98e302041724)) return "Management";
        if (role === (0, $b9c3387011d11553$export$314e71fc1506697c)) return "Admin Sales";
    };
    CreateUserModal.prototype.render = function(props, state) {
        var _this = this;
        var form = state.form;
        if (!state.allBankAccounts) return;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create new user")), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Username*"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["username"])
            }),
            value: form.fields["username"].value,
            placeholder: "",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "username")
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Password*"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["password"])
            }),
            value: form.fields["password"].value,
            placeholder: "",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "password")
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Role*"), (0, $LjoDx.h)("select", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["role"])
            }),
            value: form.fields["role"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "role")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, "Select Role"), (0, $b9c3387011d11553$export$b58386da8102e2ea).map(function(role) {
            return (0, $LjoDx.h)("option", {
                value: role
            }, _this.getRoleLabel(role));
        }))), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Firstname*"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["firstName"])
            }),
            value: form.fields["firstName"].value,
            placeholder: "",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "firstName")
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Middlename"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["middleName"])
            }),
            value: form.fields["middleName"].value,
            placeholder: "",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "middleName")
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Lastname*"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["lastName"])
            }),
            value: form.fields["lastName"].value,
            placeholder: "",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "lastName")
        })), (0, $LjoDx.h)("div", {
            class: "col-2 offset-8 mt-4"
        }, this.getSpinnerBlock(state)), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-2 mt-4"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit
        }, "Submit"))));
    };
    return CreateUserModal;
}((0, $3f2ba7f1e3532510$exports.Modal));



var $c66d1d8c90e5360c$exports = {};

$parcel$export($c66d1d8c90e5360c$exports, "ChangePasswordModal", () => $c66d1d8c90e5360c$export$a5da2e560921fb7f);

var $LjoDx = parcelRequire("LjoDx");










var $c66d1d8c90e5360c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c66d1d8c90e5360c$export$a5da2e560921fb7f = /** @class */ function(_super) {
    $c66d1d8c90e5360c$var$__extends(ChangePasswordModal, _super);
    function ChangePasswordModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var user = {
                username: _this.props.selectedUser.username,
                password: form.fields["password"].value
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $4c71eb74f53637d3$export$67e8c4b0fd356271),
                payload: {
                    userToUpdate: user
                }
            });
        };
        _this.createForm();
        return _this;
    }
    ChangePasswordModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "password": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    ChangePasswordModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(app) {
            return app.user;
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.changePasswordStatus;
        })).subscribe(function(reqState) {
            _this.setState({
                submitStatus: reqState
            });
            if (reqState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) _this.doModalClose();
        }));
        this.initialStoreDispatches();
    };
    ChangePasswordModal.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
    };
    ChangePasswordModal.prototype.componentWillUnmount = function() {
        this.subs.forEach(function(s) {
            return s.unsubscribe();
        });
    };
    ChangePasswordModal.prototype.getSpinnerBlock = function(state) {
        if (state.submitStatus === (0, $ad7802471dc8ad45$export$93ca241731165d07)) return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    ChangePasswordModal.prototype.render = function(props, state) {
        var _this = this;
        var form = state.form;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Change password | ", (0, $LjoDx.h)("small", null, props.selectedUser.username))), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("p", {
            class: "col-12"
        }, "Note: This is a force reset of an existing password."), (0, $LjoDx.h)("div", {
            class: "col-12 mt-2"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "New Password*"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["password"])
            }),
            value: form.fields["password"].value,
            placeholder: "",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "password")
        })), (0, $LjoDx.h)("div", {
            class: "col-2 offset-8 mt-4"
        }, this.getSpinnerBlock(state)), (0, $LjoDx.h)("div", {
            class: "col-2 mt-4"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit
        }, "Submit"))));
    };
    return ChangePasswordModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $f76634f5ae5b0644$exports = {};

$parcel$export($f76634f5ae5b0644$exports, "AssignBankAccountModal", () => $f76634f5ae5b0644$export$1accf5610d0d8c2e);

var $LjoDx = parcelRequire("LjoDx");










var $f76634f5ae5b0644$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f76634f5ae5b0644$export$1accf5610d0d8c2e = /** @class */ function(_super) {
    $f76634f5ae5b0644$var$__extends(AssignBankAccountModal, _super);
    function AssignBankAccountModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $4c71eb74f53637d3$export$6630f5bab1479efb),
                payload: {
                    userToAssign: _this.props.selectedUser.username,
                    bankAccountNumber: form.fields["accountNumber"].value
                }
            });
        };
        _this.createForm();
        return _this;
    }
    AssignBankAccountModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "accountNumber": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    AssignBankAccountModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(app) {
            return app.user;
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.assignBankAccountStatus;
        })).subscribe(function(reqState) {
            _this.setState({
                submitStatus: reqState
            });
            if (reqState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) _this.doModalClose();
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.allBankAccounts;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(allBankAccounts) {
            if (allBankAccounts) {
                var accounts_1 = [];
                allBankAccounts.forEach(function(member) {
                    var found = _this.props.selectedUser.assignedBankAccounts.find(function(m) {
                        return member.bankAccountNumber === m.accountNumber;
                    });
                    if (!found) accounts_1.push(member);
                });
                _this.setState({
                    assignableBankAccounts: accounts_1
                });
            }
        }));
        this.initialStoreDispatches();
    };
    AssignBankAccountModal.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $4c71eb74f53637d3$export$74d61c62c586516a)
        });
    };
    AssignBankAccountModal.prototype.componentWillUnmount = function() {
        this.subs.forEach(function(s) {
            return s.unsubscribe();
        });
    };
    AssignBankAccountModal.prototype.getSpinnerBlock = function(state) {
        if (state.submitStatus === (0, $ad7802471dc8ad45$export$93ca241731165d07)) return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    AssignBankAccountModal.prototype.render = function(props, state) {
        var _this = this;
        var form = state.form;
        if (!state.assignableBankAccounts) return;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Assign bank account | ", (0, $LjoDx.h)("small", null, props.selectedUser.username))), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Bank account*"), (0, $LjoDx.h)("select", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["accountNumber"])
            }),
            value: form.fields["accountNumber"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "accountNumber")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, "Select account"), state.assignableBankAccounts.map(function(bankAccount) {
            return (0, $LjoDx.h)("option", {
                value: bankAccount.bankAccountNumber
            }, bankAccount.bankAccountName, " - ", bankAccount.bankAccountNumber, " ");
        }))), (0, $LjoDx.h)("div", {
            class: "col-2 offset-8 mt-4"
        }, this.getSpinnerBlock(state)), (0, $LjoDx.h)("div", {
            class: "col-2 mt-4"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit
        }, "Submit"))));
    };
    return AssignBankAccountModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $1f169b1599258c24$exports = {};

$parcel$export($1f169b1599258c24$exports, "ChangeStatusModal", () => $1f169b1599258c24$export$881238920861bf5a);

var $LjoDx = parcelRequire("LjoDx");










var $1f169b1599258c24$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1f169b1599258c24$export$881238920861bf5a = /** @class */ function(_super) {
    $1f169b1599258c24$var$__extends(ChangeStatusModal, _super);
    function ChangeStatusModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            console.log(form.fields["isActive"].value);
            var user = {
                username: _this.props.selectedUser.username,
                isActive: form.fields["isActive"].value === "true" ? true : false
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $4c71eb74f53637d3$export$b75cf570f6a6871c),
                payload: {
                    userToUpdate: user
                }
            });
        };
        _this.createForm();
        return _this;
    }
    ChangeStatusModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "isActive": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, this.props.selectedUser.isActive ? "true" : "false")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    ChangeStatusModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(app) {
            return app.user;
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.changeActiveStatus;
        })).subscribe(function(reqState) {
            _this.setState({
                submitStatus: reqState
            });
            if (reqState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) _this.doModalClose();
        }));
        this.initialStoreDispatches();
    };
    ChangeStatusModal.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
    };
    ChangeStatusModal.prototype.componentWillUnmount = function() {
        this.subs.forEach(function(s) {
            return s.unsubscribe();
        });
    };
    ChangeStatusModal.prototype.getSpinnerBlock = function(state) {
        if (state.submitStatus === (0, $ad7802471dc8ad45$export$93ca241731165d07)) return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    ChangeStatusModal.prototype.render = function(props, state) {
        var _this = this;
        var form = state.form;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Change status | ", (0, $LjoDx.h)("small", null, props.selectedUser.username))), (0, $LjoDx.h)("div", {
            class: "col-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("p", {
            class: "col-12"
        }, "Note: Users with status set to inactive will not be able to login."), (0, $LjoDx.h)("div", {
            class: "col-12 mt-2"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Status*"), (0, $LjoDx.h)("select", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["isActive"])
            }),
            value: form.fields["isActive"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "isActive")
        }, (0, $LjoDx.h)("option", {
            value: "true"
        }, "Active"), (0, $LjoDx.h)("option", {
            value: "false"
        }, "Inactive"))), (0, $LjoDx.h)("div", {
            class: "col-2 offset-8 mt-4"
        }, this.getSpinnerBlock(state)), (0, $LjoDx.h)("div", {
            class: "col-2 mt-4"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit
        }, "Submit"))));
    };
    return ChangeStatusModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $6daf521c5a00b5dc$exports = {};

$parcel$export($6daf521c5a00b5dc$exports, "AdjustStockModal", () => $6daf521c5a00b5dc$export$fecd3d021360d2eb);

var $LjoDx = parcelRequire("LjoDx");












var $6daf521c5a00b5dc$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6daf521c5a00b5dc$export$fecd3d021360d2eb = /** @class */ function(_super) {
    $6daf521c5a00b5dc$var$__extends(AdjustStockModal, _super);
    function AdjustStockModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function() {
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $4c71eb74f53637d3$export$d0fb24651868d5d6),
                payload: {
                    stocksToUpdate: _this.state.brands,
                    supervisorToUpdate: _this.props.selectedUser.supervisor.supervisorId
                }
            });
        };
        _this.onAddBrand = function() {
            _this.setState({
                isEditing: false,
                isAdding: true
            });
        };
        _this.onEditBrand = function(brand, index) {
            var form = _this.state.form;
            form.fields["name"].value = brand.name;
            form.fields["numOfCases"].value = brand.numOfCases ? brand.numOfCases : 0;
            form.fields["numOfReams"].value = brand.numOfReams ? brand.numOfReams : 0;
            form.fields["numOfPacks"].value = brand.numOfPacks ? brand.numOfPacks : 0;
            _this.setState({
                isEditing: true,
                isAdding: false,
                currentlySelectedBrandIndex: index
            });
        };
        _this.onRemoveBrand = function(index) {
            var brands = _this.state.brands;
            brands.splice(index, 1);
            _this.forceUpdate();
        };
        _this.onCompleteAddBrand = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var selectedBrand = _this.state.brandPrices.find(function(member) {
                return member.brandName === form.fields["name"].value;
            });
            var brand = {
                name: form.fields["name"].value,
                brandPriceId: selectedBrand.brandId,
                numOfCases: Number.parseInt(form.fields["numOfCases"].value),
                numOfReams: Number.parseInt(form.fields["numOfReams"].value),
                numOfPacks: Number.parseInt(form.fields["numOfPacks"].value)
            };
            var found = _this.state.brands.find(function(brandMember) {
                return brand.name === brandMember.name;
            });
            if (found) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to add brand",
                message: "This brand already exists in current group.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else _this.state.brands.push(brand);
            _this.setState({
                isAdding: false
            });
        // this.forceUpdate();
        };
        _this.onCompleteEdit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var selectedBrand = _this.state.brandPrices.find(function(member) {
                return member.brandName === form.fields["name"].value;
            });
            var brand = {
                name: form.fields["name"].value,
                brandPriceId: selectedBrand.brandId,
                numOfCases: Number.parseInt(form.fields["numOfCases"].value),
                numOfReams: Number.parseInt(form.fields["numOfReams"].value),
                numOfPacks: Number.parseInt(form.fields["numOfPacks"].value)
            };
            var currentBrandIndex = _this.state.currentlySelectedBrandIndex;
            _this.state.brands[currentBrandIndex] = brand;
            _this.setState({
                isEditing: false,
                currentlySelectedBrandIndex: -1
            });
        };
        _this.setState({
            brands: props.selectedUser.supervisor.currentStock
        });
        _this.createForm();
        return _this;
    }
    AdjustStockModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "name": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "numOfCases": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "numOfReams": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "numOfPacks": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    AdjustStockModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(app) {
            return app.user;
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(reqState) {
            _this.setState({
                submitStatus: reqState
            });
            if (reqState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) _this.doModalClose();
        }));
        var withdrawal$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.withdrawal;
        }));
        this.subs.push(withdrawal$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(withdrawal) {
            return withdrawal.brandPrices;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(prices) {
            _this.setState({
                brandPrices: prices
            });
        }));
        this.initialStoreDispatches();
    };
    AdjustStockModal.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $0aa7832c96ad7a8d$export$8a851eeafd335d3f)
        });
    };
    AdjustStockModal.prototype.componentWillUnmount = function() {
        this.subs.forEach(function(s) {
            return s.unsubscribe();
        });
    };
    AdjustStockModal.prototype.getSpinnerBlock = function() {
        return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    AdjustStockModal.prototype.getBrandCard = function(brand, index, length) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mb-2"
        }, (0, $LjoDx.h)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("container-fluid create-withdrawal-modal__form__brand-card py-2", {
                "editing": index === this.state.currentlySelectedBrandIndex
            })
        }, (0, $LjoDx.h)("div", {
            class: "row mt-2"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__name"
        }, brand.name)), (0, $LjoDx.h)("div", {
            class: "col-4"
        }, (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__label"
        }, "Cases"), (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__value"
        }, brand.numOfCases ? brand.numOfCases : 0)), (0, $LjoDx.h)("div", {
            class: "col-4"
        }, (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__label"
        }, "Reams"), (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__value"
        }, brand.numOfReams ? brand.numOfReams : 0)), (0, $LjoDx.h)("div", {
            class: "col-4"
        }, (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__label"
        }, "Packs"), (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__value"
        }, brand.numOfPacks ? brand.numOfPacks : 0))), (0, $LjoDx.h)("div", {
            class: "row mt-2"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: function() {
                return _this.onEditBrand(brand, index);
            }
        }, "Edit")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-2 mt-lg-0"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: function() {
                return _this.onRemoveBrand(index);
            }
        }, "Remove")))));
    };
    AdjustStockModal.prototype.getStocksBlock = function(props, state) {
        var _this = this;
        var brands = state.brands;
        return (0, $LjoDx.h)("div", {
            class: "row"
        }, brands.map(function(member, index) {
            return _this.getBrandCard(member, index, brands.length);
        }));
    };
    AdjustStockModal.prototype.getFormBlock = function(props, state) {
        if (state.isAdding || state.isEditing) {
            var form = state.form;
            return (0, $LjoDx.h)("div", {
                class: "row create-withdrawal-modal__form__brand py-3"
            }, (0, $LjoDx.h)("div", {
                class: "col-12"
            }, (0, $LjoDx.h)("label", {
                class: "anglo-remittance__submit-form__label"
            }, "Brand Name*"), (0, $LjoDx.h)("select", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                    "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["name"])
                }),
                placeholder: "Brand Name",
                value: form.fields["name"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "name")
            }, (0, $LjoDx.h)("option", {
                class: "text-muted",
                value: "",
                disabled: true,
                selected: true
            }, "Select Brand"), state.brandPrices.map(function(price) {
                return (0, $LjoDx.h)("option", {
                    value: price.brandName
                }, price.brandName, " - ₱ ", price.pricePerReam);
            }))), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-4 mt-3"
            }, (0, $LjoDx.h)("label", {
                class: "anglo-remittance__submit-form__label"
            }, "Number of Cases"), (0, $LjoDx.h)("input", {
                class: "form-control",
                type: "text",
                onInput: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "numOfCases"),
                value: form.fields["numOfCases"].value,
                placeholder: "# of Cases"
            })), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-4 mt-3"
            }, (0, $LjoDx.h)("label", {
                class: "anglo-remittance__submit-form__label"
            }, "Number of Reams"), (0, $LjoDx.h)("input", {
                class: "form-control",
                type: "text",
                onInput: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "numOfReams"),
                value: form.fields["numOfReams"].value,
                placeholder: "# of Reams"
            })), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-4 mt-3"
            }, (0, $LjoDx.h)("label", {
                class: "anglo-remittance__submit-form__label"
            }, "Number of Packs"), (0, $LjoDx.h)("input", {
                class: "form-control",
                type: "text",
                onInput: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "numOfPacks"),
                value: form.fields["numOfPacks"].value,
                placeholder: "# of Packs"
            })), (0, $LjoDx.h)("div", {
                class: "col-6 col-lg-3 offset-6 offset-lg-9 mt-3"
            }, this.getFormActionRow(state)));
        }
    };
    AdjustStockModal.prototype.getFormActionRow = function(state) {
        if (!state.isAdding && state.isEditing) return (0, $LjoDx.h)("button", {
            class: "btn btn-outline-primary w-100",
            onClick: this.onCompleteEdit
        }, "Edit Brand");
        else return (0, $LjoDx.h)("button", {
            class: "btn btn-outline-primary w-100",
            onClick: this.onCompleteAddBrand
        }, "Add Brand");
    };
    AdjustStockModal.prototype.getActionsRow = function(props, state) {
        if (state.submitStatus === (0, $ad7802471dc8ad45$export$93ca241731165d07)) return this.getSpinnerBlock();
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-6"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onAddBrand
        }, "Add New Brand")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.onSubmit
        }, "Update Stocks"))));
    };
    AdjustStockModal.prototype.render = function(props, state) {
        var _this = this;
        var form = state.form;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-disposal-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create Disposal")), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getStocksBlock(props, state), this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions mt-3"
        }, this.getActionsRow(props, state)));
    };
    return AdjustStockModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $0275abefcf139b5e$exports = {};

$parcel$export($0275abefcf139b5e$exports, "CreateSupervisorDataModal", () => $0275abefcf139b5e$export$c0b8f785a0365af7);

var $LjoDx = parcelRequire("LjoDx");










var $0275abefcf139b5e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0275abefcf139b5e$export$c0b8f785a0365af7 = /** @class */ function(_super) {
    $0275abefcf139b5e$var$__extends(CreateSupervisorDataModal, _super);
    function CreateSupervisorDataModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var supervisorRegistrationData = {
                user: _this.props.selectedUser.username,
                areaAssigned: form.fields["areaAssigned"].value,
                yearsAssigned: form.fields["yearsAssigned"].value,
                isWalkIn: form.fields["isWalkIn"].value
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $4c71eb74f53637d3$export$e65d189135623f3a),
                payload: {
                    supervisorRegistrationData: supervisorRegistrationData
                }
            });
        };
        _this.createForm();
        return _this;
    }
    CreateSupervisorDataModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "areaAssigned": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "yearsAssigned": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "isWalkIn": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, false)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    CreateSupervisorDataModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(app) {
            return app.user;
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(reqState) {
            _this.setState({
                submitStatus: reqState
            });
            if (reqState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) _this.doModalClose();
        }));
        this.initialStoreDispatches();
    };
    CreateSupervisorDataModal.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
    };
    CreateSupervisorDataModal.prototype.componentWillUnmount = function() {
        this.subs.forEach(function(s) {
            return s.unsubscribe();
        });
    };
    CreateSupervisorDataModal.prototype.getSpinnerBlock = function(state) {
        if (state.submitStatus === (0, $ad7802471dc8ad45$export$93ca241731165d07)) return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    CreateSupervisorDataModal.prototype.render = function(props, state) {
        var _this = this;
        var form = state.form;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create Supervisor Data | ", (0, $LjoDx.h)("small", null, props.selectedUser.firstName, " ", props.selectedUser.lastName))), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-2"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Sector / Area Assigned*"), (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["areaAssigned"])
            }),
            value: form.fields["areaAssigned"].value,
            placeholder: "",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "areaAssigned")
        })), (0, $LjoDx.h)("div", {
            class: "col-12 mt-2"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Number of Years Assigned*"), (0, $LjoDx.h)("input", {
            type: "number",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["yearsAssigned"])
            }),
            value: form.fields["yearsAssigned"].value,
            placeholder: "",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "yearsAssigned")
        })), (0, $LjoDx.h)("div", {
            class: "col-12 mt-3 d-flex align-items-center"
        }, (0, $LjoDx.h)("input", {
            class: "ml-2",
            type: "checkbox",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "isWalkIn", true)
        }), "\xa0 Is this Supervisor a Walk-In? ", (0, $LjoDx.h)("i", null, "(Different pricing applies)")), (0, $LjoDx.h)("div", {
            class: "col-2 offset-8 mt-4"
        }, this.getSpinnerBlock(state)), (0, $LjoDx.h)("div", {
            class: "col-2 mt-4"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit
        }, "Submit"))));
    };
    return CreateSupervisorDataModal;
}((0, $3f2ba7f1e3532510$exports.Modal));





var $d8c26406eab115f0$exports = {};

$parcel$export($d8c26406eab115f0$exports, "GridPagination", () => $d8c26406eab115f0$export$fa9a503101f8d472);

var $LjoDx = parcelRequire("LjoDx");

var $d8c26406eab115f0$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d8c26406eab115f0$export$fa9a503101f8d472 = /** @class */ function(_super) {
    $d8c26406eab115f0$var$__extends(GridPagination, _super);
    function GridPagination(props) {
        return _super.call(this, props) || this;
    }
    GridPagination.prototype.render = function(props, state) {
        var pages = props.pages;
        var currentPage = props.currentPage;
        return (0, $LjoDx.h)("div", {
            class: "row mt-2"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, pages ? (0, $LjoDx.h)("div", {
            class: "dash-remittance__pagination mb-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn dash-remittance__pagination__page arrow",
            disabled: currentPage === 1,
            onClick: function() {
                return props.onPageClicked(currentPage - 1);
            }
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-chevron-left"
        })), currentPage > 5 ? (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                active: pages[0] === currentPage
            }),
            onClick: function() {
                return props.onPageClicked(pages[0]);
            }
        }, pages[0]) : null, currentPage > 5 ? (0, $LjoDx.h)("span", {
            class: "mx-2"
        }, "...") : null, pages ? pages.map(function(page) {
            if (page > currentPage - 5 && page < currentPage + 5) return (0, $LjoDx.h)("button", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                    active: page === currentPage
                }),
                onClick: function() {
                    return props.onPageClicked(page);
                }
            }, page);
        }) : null, currentPage < pages.length - 5 ? (0, $LjoDx.h)("span", {
            class: "mx-2"
        }, "...") : null, currentPage < pages.length - 5 ? (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                active: pages[pages.length - 1] === currentPage
            }),
            onClick: function() {
                return props.onPageClicked(pages[pages.length - 1]);
            }
        }, pages[pages.length - 1]) : null, (0, $LjoDx.h)("button", {
            class: "btn dash-remittance__pagination__page arrow",
            disabled: currentPage === pages[pages.length - 1],
            onClick: function() {
                return props.onPageClicked(currentPage + 1);
            }
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-chevron-right"
        }))) : null));
    };
    return GridPagination;
}((0, $LjoDx.Component));



var $5760e073989df791$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5760e073989df791$export$b7a3e8f0c6428462 = /** @class */ function(_super) {
    $5760e073989df791$var$__extends(DashUserManagement, _super);
    function DashUserManagement(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.MODAL_EDIT_PASSWORD = 0;
        _this.MODAL_CREATE_USERS = 1;
        _this.MODAL_ASSIGN_BANK_ACCOUNT = 2;
        _this.MODAL_CREATE_BANK_ACCOUNT = 3;
        _this.MODAL_CHANGE_STATUS = 4;
        _this.MODAL_CREATE_SUPERVISOR_DATA = 5;
        _this.MODAL_ADJUST_STOCK = 6;
        _this.onModalOpened = function(paramState, row) {
            _this.setState({
                modalState: paramState,
                focusedUser: row
            });
        };
        _this.onModalClose = function() {
            _this.setState({
                modalState: -1
            });
        };
        _this.getPortalModal = function(state) {
            var modalNumber = Math.floor(Math.random() * 1000);
            var modalId = "anglo-modal-".concat(modalNumber);
            var modalState = state.modalState;
            if (modalState < 0) return null;
            else if (modalState === _this.MODAL_CREATE_USERS) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: modalId
            }, (0, $LjoDx.h)((0, $06a59890bc9ce984$exports.CreateUserModal), {
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: modalId
            })));
            else if (modalState === _this.MODAL_EDIT_PASSWORD) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: modalId
            }, (0, $LjoDx.h)((0, $c66d1d8c90e5360c$exports.ChangePasswordModal), {
                selectedUser: state.focusedUser,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: modalId
            })));
            else if (modalState === _this.MODAL_CREATE_BANK_ACCOUNT) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: modalId
            }, (0, $LjoDx.h)((0, $71fda3c649820f63$exports.CreateBankAccountModal), {
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: modalId
            })));
            else if (modalState === _this.MODAL_ASSIGN_BANK_ACCOUNT) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: modalId
            }, (0, $LjoDx.h)((0, $f76634f5ae5b0644$exports.AssignBankAccountModal), {
                selectedUser: state.focusedUser,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: modalId
            })));
            else if (modalState === _this.MODAL_CHANGE_STATUS) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: modalId
            }, (0, $LjoDx.h)((0, $1f169b1599258c24$exports.ChangeStatusModal), {
                selectedUser: state.focusedUser,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: modalId
            })));
            else if (modalState === _this.MODAL_CREATE_SUPERVISOR_DATA) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: modalId
            }, (0, $LjoDx.h)((0, $0275abefcf139b5e$exports.CreateSupervisorDataModal), {
                selectedUser: state.focusedUser,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: modalId
            })));
            else if (modalState === _this.MODAL_ADJUST_STOCK) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: modalId
            }, (0, $LjoDx.h)((0, $6daf521c5a00b5dc$exports.AdjustStockModal), {
                selectedUser: state.focusedUser,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: modalId
            })));
        };
        _this.onPageClicked = function(page) {
            var filterForm = {};
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filterForm[k] = fieldList[k].value;
            filterForm["page"] = page;
            var filters = _this.state.filters;
            filters.set("page", page);
            _this.refreshGrid();
            _this.setState({
                currentPage: page
            });
        };
        _this.onFilterToggleClicked = function() {
            _this.setState({
                isFilterVisible: !_this.state.isFilterVisible
            });
        };
        _this.resetFilters = function() {
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)fieldList[k].value = null;
            var filters = new Map();
            filters.set("page", 1);
            _this.setState({
                filters: filters,
                currentPage: 1
            });
            _this.refreshGrid();
        };
        _this.applyFilters = function() {
            var filters = _this.state.filters;
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filters.set(k, fieldList[k].value);
            _this.setState({
                filters: filters
            });
            _this.refreshGrid();
        };
        _this.getFilterForm = function(state) {
            var form = state.filterForm;
            return (0, $LjoDx.h)("div", {
                class: "row mt-3"
            }, (0, $LjoDx.h)("div", {
                className: "col-12 col-lg-4"
            }, (0, $LjoDx.h)("label", {
                className: "dash-remittance__filter-row__filters__label"
            }, "Last Name"), (0, $LjoDx.h)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
                type: "text",
                value: form.fields["searchTerm"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(_this.form$, form, "searchTerm"),
                placeholder: "Last Name"
            })));
        };
        var filters = new Map();
        filters.set("page", 1);
        _this.setState({
            filters: filters,
            currentPage: 1
        });
        _this.createForm();
        return _this;
    }
    DashUserManagement.prototype.createForm = function() {
        var _this = this;
        var fields = {
            searchTerm: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            filterForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["filterForm"] = form;
            _this.setState(state);
        });
    };
    DashUserManagement.prototype.componentDidMount = function() {
        var _this = this;
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.user;
        }));
        this.setState({
            modalState: -1
        });
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.currentUser;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(currentUser) {
            _this.setState({
                currentUser: currentUser
            });
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.allUsers;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(allUsers) {
            if (allUsers) _this.setState({
                allUsers: allUsers
            });
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.total;
        })).subscribe(function(total) {
            if (total) {
                var pages = [];
                var limit = Math.ceil(total / (0, $787290684425694f$exports.PAGE_SIZE));
                for(var i = 0; i < limit; i++)pages.push(i + 1);
                _this.setState({
                    pages: pages
                });
            }
        }));
        this.initialStoreDispatches();
    };
    DashUserManagement.prototype.refreshGrid = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $4c71eb74f53637d3$export$c387b27c89715baf),
            payload: {
                filters: this.state.filters
            }
        });
    };
    DashUserManagement.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $4c71eb74f53637d3$export$c387b27c89715baf),
            payload: {
                filters: this.state.filters
            }
        });
    };
    DashUserManagement.prototype.getSpinnerBlock = function() {
        return (0, $LjoDx.h)("div", {
            class: "col d-flex justify-content-start"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    DashUserManagement.prototype.getActions = function(state, row, index) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "dropdown-menu",
            "aria-labelledby": "actions".concat(index)
        }, (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return _this.onModalOpened(_this.MODAL_EDIT_PASSWORD, row);
            }
        }, "Change Password"), row.role === (0, $b9c3387011d11553$export$819e975c5d2910e9) ? (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return _this.onModalOpened(_this.MODAL_ASSIGN_BANK_ACCOUNT, row);
            }
        }, "Assign Bank Account") : null, row.role === (0, $b9c3387011d11553$export$819e975c5d2910e9) && !row.supervisor ? (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return _this.onModalOpened(_this.MODAL_CREATE_SUPERVISOR_DATA, row);
            }
        }, "Create Supervisor Data") : null, row.role === (0, $b9c3387011d11553$export$819e975c5d2910e9) && row.supervisor ? (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return _this.onModalOpened(_this.MODAL_ADJUST_STOCK, row);
            }
        }, "Adjust Supervisor Stock") : null, (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return _this.onModalOpened(_this.MODAL_CHANGE_STATUS, row);
            }
        }, "Change Status"));
    };
    DashUserManagement.prototype.getRoleLabel = function(role) {
        if (role === (0, $b9c3387011d11553$export$819e975c5d2910e9)) return "Supervisor";
        if (role === (0, $b9c3387011d11553$export$a805ed97d1d93366)) return "Auditor";
        if (role === (0, $b9c3387011d11553$export$9cb152b3a874b8b0)) return "Vehicle Manager";
        if (role === (0, $b9c3387011d11553$export$b38e98e302041724)) return "Management";
        if (role === (0, $b9c3387011d11553$export$ecb30477529ca9f0)) return "Super Admin";
        if (role === (0, $b9c3387011d11553$export$314e71fc1506697c)) return "Admin Sales";
    };
    DashUserManagement.prototype.getGridBlock = function(state) {
        var _this = this;
        if (state.allUsers) return (0, $LjoDx.h)("div", {
            class: "data-grid"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Actions"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Last Name"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "First Name"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Username"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Role"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Active")), state.allUsers.map(function(row, index) {
            if (row.role === (0, $b9c3387011d11553$export$ecb30477529ca9f0)) {
                if (_this.state.currentUser.role !== (0, $b9c3387011d11553$export$ecb30477529ca9f0)) return;
            } else return (0, $LjoDx.h)("div", {
                class: "data-grid__row"
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, (0, $LjoDx.h)("div", {
                class: "dropright"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-outline-primary dropdown-toggle",
                type: "button",
                id: "actions".concat(index),
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false"
            }, "Select action"), _this.getActions(state, row, index))), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.lastName), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.firstName), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.username), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, _this.getRoleLabel(row.role)), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.isActive ? "Yes" : "No"));
        }));
        else return this.getSpinnerBlock();
    };
    DashUserManagement.prototype.getFilterActions = function(state) {
        return (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2 offset-lg-8"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.resetFilters
        }, "Reset Filters")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.applyFilters
        }, "Apply Filters")));
    };
    DashUserManagement.prototype.getFilterBlock = function(state) {
        return (0, $LjoDx.h)("div", {
            class: "mb-3"
        }, (0, $LjoDx.h)("div", {
            className: "row justify-content-end"
        }, (0, $LjoDx.h)("div", {
            className: "col-12 col-lg-3 text-right"
        }, (0, $LjoDx.h)("a", {
            class: "dash-remittance__filter-row__filter-btn",
            onClick: this.onFilterToggleClicked
        }, "Filter ", (0, $LjoDx.h)("i", {
            class: "fas fa-filter"
        })))), (0, $LjoDx.h)("div", {
            className: "row no-gutters"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, state.isFilterVisible ? (0, $LjoDx.h)("div", {
            className: "dash-remittance__filter-row__filters"
        }, state.isFilterVisible ? this.getFilterForm(state) : null, state.isFilterVisible ? this.getFilterActions(state) : null) : null)));
    };
    DashUserManagement.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "dash-user-management"
        }, this.getPortalModal(state), (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-8 col-lg-4"
        }, (0, $LjoDx.h)("nav", {
            "aria-label": "breadcrumb"
        }, (0, $LjoDx.h)("ol", {
            class: "breadcrumb"
        }, (0, $LjoDx.h)("li", {
            class: "breadcrumb-item"
        }, (0, $LjoDx.h)("a", {
            href: "/remittance"
        }, "User Management"))))), (0, $LjoDx.h)("div", {
            class: "col-4 col-lg-2 offset-lg-6 d-flex justify-content-end align-items-center"
        }, (0, $LjoDx.h)("a", {
            class: "anglo__dashboard__faq",
            href: "#"
        }, "FAQs ", (0, $LjoDx.h)("i", {
            class: "fas fa-chevron-right"
        })))), (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: function(e) {
                return _this.onModalOpened(_this.MODAL_CREATE_USERS);
            }
        }, "Create User")), (0, $LjoDx.h)("div", {
            class: "col-md-3 mt-3 mt-md-0"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: function(e) {
                return _this.onModalOpened(_this.MODAL_CREATE_BANK_ACCOUNT);
            }
        }, "Create Bank Account"))), (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "dash-user-management__grid-container"
        }, this.getFilterBlock(state), this.getGridBlock(state), (0, $LjoDx.h)((0, $d8c26406eab115f0$exports.GridPagination), {
            pages: state.pages,
            currentPage: state.currentPage,
            onPageClicked: this.onPageClicked
        }))))));
    };
    return DashUserManagement;
}((0, $LjoDx.Component));


var $1b3d64ce21c3d489$exports = {};

$parcel$export($1b3d64ce21c3d489$exports, "MicroscopeRemittance", () => $1b3d64ce21c3d489$export$b30901b076cfbc25);

var $LjoDx = parcelRequire("LjoDx");









var $1b3d64ce21c3d489$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1b3d64ce21c3d489$var$MONTH_SELECTION = 0;
var $1b3d64ce21c3d489$var$SUPERVISOR_SELECTION = 1;
var $1b3d64ce21c3d489$var$AREA_SELECTION = 2;
var $1b3d64ce21c3d489$var$AGENT_SELECTION = 3;
var $1b3d64ce21c3d489$var$STATUS_SELECTION = 4;
var $1b3d64ce21c3d489$var$MONTH_TYPE = "month";
var $1b3d64ce21c3d489$var$SUPERVISOR_TYPE = "supervisor";
var $1b3d64ce21c3d489$var$AREA_TYPE = "area";
var $1b3d64ce21c3d489$var$AGENT_TYPE = "agent";
var $1b3d64ce21c3d489$var$STATUS_TYPE = "status";
var $1b3d64ce21c3d489$var$colors = [
    "#215B8A",
    "#f25b15",
    "#1b9b85",
    "#d7423e",
    "#0C8A38"
];


var $1b3d64ce21c3d489$export$b30901b076cfbc25 = /** @class */ function(_super) {
    $1b3d64ce21c3d489$var$__extends(MicroscopeRemittance, _super);
    function MicroscopeRemittance(props) {
        var _this = _super.call(this, props) || this;
        _this.onDataSelectionChange = function(type) {
            switch(type){
                case $1b3d64ce21c3d489$var$MONTH_SELECTION:
                    if (_this.state.isByMonthSelected) // being deactivated
                    _this.setState({
                        isByMonthSelected: !_this.state.isByMonthSelected,
                        typesSelected: _this.state.typesSelected - 1,
                        startDate: "",
                        endDate: ""
                    });
                    else if (_this.state.typesSelected < 2) // activating
                    _this.setState({
                        isByMonthSelected: !_this.state.isByMonthSelected,
                        typesSelected: _this.state.typesSelected + 1
                    });
                    break;
                case $1b3d64ce21c3d489$var$AREA_SELECTION:
                    if (_this.state.isByAreaSelected) // being deactivated
                    _this.setState({
                        isByAreaSelected: !_this.state.isByAreaSelected,
                        typesSelected: _this.state.typesSelected - 1
                    });
                    else if (_this.state.typesSelected < 2) // activating
                    _this.setState({
                        isByAreaSelected: !_this.state.isByAreaSelected,
                        typesSelected: _this.state.typesSelected + 1
                    });
                    break;
                case $1b3d64ce21c3d489$var$SUPERVISOR_SELECTION:
                    if (_this.state.isBySupervisorSelected) // being deactivated
                    _this.setState({
                        isBySupervisorSelected: !_this.state.isBySupervisorSelected,
                        typesSelected: _this.state.typesSelected - 1,
                        selectedSupervisors: []
                    });
                    else if (_this.state.typesSelected < 2) // activating
                    _this.setState({
                        isBySupervisorSelected: !_this.state.isBySupervisorSelected,
                        typesSelected: _this.state.typesSelected + 1
                    });
                    break;
                case $1b3d64ce21c3d489$var$AGENT_SELECTION:
                    if (_this.state.isByAgentSelected) // being deactivated
                    _this.setState({
                        isByAgentSelected: !_this.state.isByAgentSelected,
                        typesSelected: _this.state.typesSelected - 1
                    });
                    else if (_this.state.typesSelected < 2) // activating
                    _this.setState({
                        isByAgentSelected: !_this.state.isByAgentSelected,
                        typesSelected: _this.state.typesSelected + 1
                    });
                    break;
                case $1b3d64ce21c3d489$var$STATUS_SELECTION:
                    if (_this.state.isByStatusSelected) // being deactivated
                    _this.setState({
                        isByStatusSelected: !_this.state.isByStatusSelected,
                        typesSelected: _this.state.typesSelected - 1
                    });
                    else if (_this.state.typesSelected < 2) // activating
                    _this.setState({
                        isByStatusSelected: !_this.state.isByStatusSelected,
                        typesSelected: _this.state.typesSelected + 1
                    });
                    break;
            }
        };
        _this.onStartDateSelected = function(date) {
            _this.setState({
                startDate: date
            });
        };
        _this.onEndDateSelected = function(date) {
            _this.setState({
                endDate: date
            });
        };
        _this.onSupervisorSearchChange = function(user) {
            var supervisors = _this.state.selectedSupervisors;
            var found = supervisors.find(function(member) {
                return member.username === user.username;
            });
            // make sure we don't have duplicates
            if (!found) supervisors.push(user);
            _this.setState({
                selectedSupervisors: supervisors
            });
        };
        _this.onRemoveSupervisor = function(index) {
            var supervisors = _this.state.selectedSupervisors;
            supervisors.splice(index, 1);
            _this.setState({
                selectedSupervisors: supervisors
            });
        };
        _this.onAreaSearchChange = function(sector) {
            var areas = _this.state.selectedAreas;
            var found = areas.includes(sector.name);
            // make sure we don't have duplicates
            if (!found) areas.push(sector.name);
            _this.setState({
                selectedAreas: areas
            });
        };
        _this.onRemoveArea = function(index) {
            var areas = _this.state.selectedAreas;
            areas.splice(index, 1);
            _this.setState({
                selectedAreas: areas
            });
        };
        _this.onConstruct = function() {
            console.log("constructing data", _this);
            var dataTypes = _this.getGridDataTypes();
            var options = {
                dataTypes: dataTypes
            };
            var supervisors = _this.getSupervisorUsernames();
            var parameters = {
                startDate: _this.state.startDate,
                endDate: _this.state.endDate,
                supervisors: supervisors,
                areas: _this.state.selectedAreas
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            var action = {
                type: (0, $65e879dcad4ecaad$export$7d659f58fd3701d),
                payload: {
                    remittanceConfig: {
                        options: options,
                        parameters: parameters
                    }
                }
            };
            store.dispatch(action);
        };
        _this.setState({
            typesSelected: 0,
            selectedSupervisors: [],
            selectedAreas: []
        });
        return _this;
    }
    MicroscopeRemittance.prototype.componentDidMount = function() {
        var _this = this;
        var microscope$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.microscope;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)());
        microscope$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(microscope) {
            return microscope;
        })).subscribe(function(microscope) {
            console.log(microscope.remittanceGraphData);
            if (microscope.retrieveGraphDataStatus === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isRetrieveDataSuccess: true,
                    graphData: microscope.remittanceGraphData,
                    graphConfig: microscope.remittanceConfig
                });
                _this.createChart();
            }
        });
    };
    MicroscopeRemittance.prototype.getMonthString = function(month, year) {
        switch(month){
            case 1:
                return "January ".concat(year);
            case 2:
                return "February ".concat(year);
            case 3:
                return "March ".concat(year);
            case 4:
                return "April ".concat(year);
            case 5:
                return "May ".concat(year);
            case 6:
                return "June ".concat(year);
            case 7:
                return "July ".concat(year);
            case 8:
                return "August ".concat(year);
            case 9:
                return "September ".concat(year);
            case 10:
                return "October ".concat(year);
            case 11:
                return "November ".concat(year);
            case 12:
                return "December ".concat(year);
        }
    };
    MicroscopeRemittance.prototype.constructLabels = function() {
        var _this = this;
        var options = this.state.graphConfig.options;
        if (options.dataTypes.length == 2) {
            if (options.dataTypes.includes($1b3d64ce21c3d489$var$MONTH_TYPE) && options.dataTypes.includes($1b3d64ce21c3d489$var$SUPERVISOR_TYPE)) {
                var labels_1 = [];
                var firstSupervisor = this.state.graphData[0];
                var totals = firstSupervisor["totals"];
                totals.forEach(function(m, index) {
                    console.log("building label " + index, m);
                    labels_1.push(_this.getMonthString(m.month, m.year));
                });
                return labels_1;
            }
            if (options.dataTypes.includes($1b3d64ce21c3d489$var$MONTH_TYPE) && options.dataTypes.includes($1b3d64ce21c3d489$var$AREA_TYPE)) {
                var labels_2 = [];
                var firstArea = this.state.graphData[0];
                var totals = firstArea["totals"];
                totals.forEach(function(m, index) {
                    console.log("building label " + index, m);
                    labels_2.push(_this.getMonthString(m.month, m.year));
                });
                return labels_2;
            }
            if (options.dataTypes.includes($1b3d64ce21c3d489$var$SUPERVISOR_TYPE) && options.dataTypes.includes($1b3d64ce21c3d489$var$AREA_TYPE)) {
                var labels_3 = [];
                this.state.graphData.forEach(function(m, index) {
                    var totals = m["totals"];
                    totals.forEach(function(total) {
                        labels_3.push(total.area);
                    });
                });
                return labels_3;
            }
        } else {
            var dataType = options.dataTypes[0];
            if (dataType === $1b3d64ce21c3d489$var$MONTH_TYPE) return this.state.graphData.map(function(m) {
                return _this.getMonthString(m["_id"].month, m["_id"].year);
            });
            if (dataType === $1b3d64ce21c3d489$var$SUPERVISOR_TYPE) return this.state.graphData.map(function(m) {
                return m["_id"];
            });
            if (dataType === $1b3d64ce21c3d489$var$AREA_TYPE) return this.state.graphData.map(function(m) {
                return m["_id"];
            });
        }
    };
    MicroscopeRemittance.prototype.constructDatasets = function(labels) {
        var options = this.state.graphConfig.options;
        if (options.dataTypes.length == 2) {
            if (options.dataTypes.includes($1b3d64ce21c3d489$var$MONTH_TYPE) && options.dataTypes.includes($1b3d64ce21c3d489$var$SUPERVISOR_TYPE)) {
                var dataSets_1 = [];
                this.state.graphData.forEach(function(m, index) {
                    var dataSet = {};
                    var totals = m.totals;
                    dataSet.data = totals.map(function(a) {
                        // console.log(a);
                        return a["totalAmount"];
                    });
                    dataSet.label = m["_id"];
                    dataSet.backgroundColor = $1b3d64ce21c3d489$var$colors[index];
                    dataSets_1.push(dataSet);
                });
                console.log("dataSets", dataSets_1);
                return dataSets_1;
            }
            if (options.dataTypes.includes($1b3d64ce21c3d489$var$MONTH_TYPE) && options.dataTypes.includes($1b3d64ce21c3d489$var$AREA_TYPE)) {
                var dataSets_2 = [];
                this.state.graphData.forEach(function(m, index) {
                    var dataSet = {};
                    var totals = m.totals;
                    dataSet.data = totals.map(function(a) {
                        return a["totalAmount"];
                    });
                    dataSet.label = m["_id"];
                    dataSet.backgroundColor = $1b3d64ce21c3d489$var$colors[index];
                    dataSets_2.push(dataSet);
                });
                console.log("dataSets", dataSets_2);
                return dataSets_2;
            }
            if (options.dataTypes.includes($1b3d64ce21c3d489$var$SUPERVISOR_TYPE) && options.dataTypes.includes($1b3d64ce21c3d489$var$AREA_TYPE)) {
                var dataSets_3 = [];
                this.state.graphData.forEach(function(m, index) {
                    var dataSet = {};
                    dataSet.data = [];
                    var totals = m.totals;
                    labels.forEach(function(label) {
                        var found = totals.find(function(total) {
                            return total.area === label;
                        });
                        if (found) dataSet.data.push(found["totalAmount"]);
                        else dataSet.data.push(0);
                    });
                    dataSet.label = m["_id"];
                    dataSet.backgroundColor = $1b3d64ce21c3d489$var$colors[index];
                    dataSets_3.push(dataSet);
                });
                console.log("dataSets", dataSets_3);
                return dataSets_3;
            }
        } else {
            var dataType = options.dataTypes[0];
            var dataSet = {};
            if (dataType === $1b3d64ce21c3d489$var$MONTH_TYPE) {
                dataSet.data = this.state.graphData.map(function(m) {
                    return m["totalAmount"];
                });
                dataSet.backgroundColor = $1b3d64ce21c3d489$var$colors[0];
            }
            if (dataType === $1b3d64ce21c3d489$var$SUPERVISOR_TYPE) {
                dataSet.data = this.state.graphData.map(function(m) {
                    return m["totalAmount"];
                });
                dataSet.backgroundColor = $1b3d64ce21c3d489$var$colors[0];
            }
            if (dataType === $1b3d64ce21c3d489$var$AREA_TYPE) {
                dataSet.data = this.state.graphData.map(function(m) {
                    return m["totalAmount"];
                });
                dataSet.backgroundColor = $1b3d64ce21c3d489$var$colors[1];
            }
            return [
                dataSet
            ];
        }
    };
    // We do this to ensure lazy loading.
    // If chartjs is imported directly, it will be part of the main module
    // and bloat the whole thing.
    MicroscopeRemittance.prototype.createChart = function() {
        var _this = this;
        if (this.state.dataChart) // this.state.dataChart.resize();
        this.state.dataChart.destroy();
        (parcelRequire("28aOW")).then(function(Chart) {
            (parcelRequire("2aSuR")).then(function() {
                // let test = lol.map();
                var labels = _this.constructLabels();
                var datasets = _this.constructDatasets(labels);
                var chart = new Chart(_this.chartNode, {
                    type: "bar",
                    data: {
                        labels: labels,
                        datasets: datasets
                    },
                    options: {
                        responsive: false,
                        scales: {
                            yAxes: [
                                {
                                    ticks: {
                                        beginAtZero: true,
                                        callback: function(value, index, values) {
                                            return "₱ ".concat((0, $9e0c3e3a397653e5$export$a81f732198733497)(value));
                                        }
                                    }
                                }
                            ]
                        },
                        legend: {
                            display: false
                        },
                        plugins: {
                            datalabels: {
                                align: "end",
                                backgroundColor: function(context) {
                                    return context.dataset.backgroundColor;
                                },
                                borderColor: "white",
                                borderRadius: 25,
                                borderWidth: 2,
                                color: "white",
                                font: {
                                    weight: "bold"
                                },
                                formatter: function(value) {
                                    return "₱ ".concat((0, $9e0c3e3a397653e5$export$a81f732198733497)(value), " ");
                                }
                            }
                        }
                    }
                });
                chart.resize();
                _this, _this.setState({
                    dataChart: chart
                });
            });
        });
    };
    MicroscopeRemittance.prototype.getSupervisorUsernames = function() {
        return this.state.selectedSupervisors.map(function(user) {
            return user.username;
        });
    };
    MicroscopeRemittance.prototype.getGridDataTypes = function() {
        var types = [];
        if (this.state.isByMonthSelected) types.push($1b3d64ce21c3d489$var$MONTH_TYPE);
        if (this.state.isBySupervisorSelected) types.push($1b3d64ce21c3d489$var$SUPERVISOR_TYPE);
        if (this.state.isByAreaSelected) types.push($1b3d64ce21c3d489$var$AREA_TYPE);
        if (this.state.isByAgentSelected) types.push($1b3d64ce21c3d489$var$AGENT_TYPE);
        if (this.state.isByStatusSelected) types.push($1b3d64ce21c3d489$var$STATUS_TYPE);
        return types;
    };
    MicroscopeRemittance.prototype.getMonthParametersBlock = function(state) {
        if (state.isByMonthSelected) return (0, $LjoDx.h)("div", {
            class: "microscope-remittance__controls__params__month param"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("label", {
            class: "microscope-remittance__controls__options__label"
        }, "Start date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: this.onStartDateSelected,
            isValid: true
        })), (0, $LjoDx.h)("div", {
            class: "col-12 mt-2"
        }, (0, $LjoDx.h)("label", {
            class: "microscope-remittance__controls__options__label"
        }, "End date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: this.onEndDateSelected,
            isValid: true
        }))));
    };
    MicroscopeRemittance.prototype.getSupervisorParametersBlock = function(state) {
        var _this = this;
        if (state.isBySupervisorSelected) return (0, $LjoDx.h)("div", {
            class: "microscope-remittance__controls__params__supervisor param"
        }, (0, $LjoDx.h)("label", {
            class: "microscope-remittance__controls__options__label"
        }, "Supervisors"), (0, $LjoDx.h)("div", {
            class: "microscope-remittance__controls__params__supervisor__selected"
        }, state.selectedSupervisors.map(function(member, index) {
            return (0, $LjoDx.h)("div", {
                class: "anglo-chip"
            }, member.firstName, " ", member.lastName, (0, $LjoDx.h)("button", {
                class: "anglo-chip__icon-btn",
                onClick: function() {
                    return _this.onRemoveSupervisor(index);
                }
            }, (0, $LjoDx.h)("i", {
                class: "fas fa-times"
            })));
        })), (0, $LjoDx.h)((0, $204820985097eb0a$exports.AutocompleteSearch), {
            onResultSelected: this.onSupervisorSearchChange
        }));
    };
    MicroscopeRemittance.prototype.getAreaParametersBlock = function(state) {
        var _this = this;
        if (state.isByAreaSelected) return (0, $LjoDx.h)("div", {
            class: "microscope-remittance__controls__params__area param"
        }, (0, $LjoDx.h)("label", {
            class: "microscope-remittance__controls__options__label"
        }, "Areas"), (0, $LjoDx.h)("div", {
            class: "microscope-remittance__controls__params__area__selected"
        }, state.selectedAreas.map(function(member, index) {
            return (0, $LjoDx.h)("div", {
                class: "anglo-chip"
            }, member, (0, $LjoDx.h)("button", {
                class: "anglo-chip__icon-btn",
                onClick: function() {
                    return _this.onRemoveArea(index);
                }
            }, (0, $LjoDx.h)("i", {
                class: "fas fa-times"
            })));
        })), (0, $LjoDx.h)((0, $eb0c70f62dd91971$exports.AutocompleteSector), {
            onResultSelected: this.onAreaSearchChange
        }));
    };
    MicroscopeRemittance.prototype.getDataRenderBlock = function(state) {
        var _this = this;
        if (state.isRetrieveDataSuccess) return (0, $LjoDx.h)("div", {
            class: "microscope-remittance__data"
        }, (0, $LjoDx.h)("canvas", {
            class: "chart__canvas",
            id: "mortgageChart",
            ref: function(node) {
                return _this.chartNode = node;
            }
        }));
    };
    MicroscopeRemittance.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "microscope-remittance"
        }, (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-8 col-lg-4"
        }, (0, $LjoDx.h)("nav", {
            "aria-label": "breadcrumb"
        }, (0, $LjoDx.h)("ol", {
            class: "breadcrumb"
        }, (0, $LjoDx.h)("li", {
            class: "breadcrumb-item"
        }, (0, $LjoDx.h)("a", {
            href: "/remittance"
        }, "Remittance")), (0, $LjoDx.h)("li", {
            class: "breadcrumb-item active",
            "aria-current": "page"
        }, "Remittance Microscope"))))), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-8 offset-lg-2 mb-3"
        }, (0, $LjoDx.h)("div", {
            class: "microscope-remittance__controls row"
        }, (0, $LjoDx.h)("div", {
            class: "microscope-remittance__controls__options col-12 col-lg-6"
        }, (0, $LjoDx.h)("h2", {
            class: "microscope-remittance__controls__options__head"
        }, "Options"), (0, $LjoDx.h)("p", {
            class: "microscope-remittance__controls__options__label text-center mb-4"
        }, "Select the options and data types for graph behavior"), (0, $LjoDx.h)("div", {
            class: "microscope-remittance__controls__options__grid-type"
        }), (0, $LjoDx.h)("p", {
            class: "microscope-remittance__controls__options__label"
        }, "Only a maximum of 2 data types can be selected."), (0, $LjoDx.h)("div", {
            class: "microscope-remittance__controls__options__data-selection"
        }, (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("microscope-remittance__controls__options__data-selection__btn", {
                "active": state.isByMonthSelected
            }),
            onClick: function() {
                return _this.onDataSelectionChange($1b3d64ce21c3d489$var$MONTH_SELECTION);
            }
        }, "By Month"), (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("microscope-remittance__controls__options__data-selection__btn", {
                "active": state.isBySupervisorSelected
            }),
            onClick: function() {
                return _this.onDataSelectionChange($1b3d64ce21c3d489$var$SUPERVISOR_SELECTION);
            }
        }, "By Supervisor"), (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("microscope-remittance__controls__options__data-selection__btn", {
                "active": state.isByAreaSelected
            }),
            onClick: function() {
                return _this.onDataSelectionChange($1b3d64ce21c3d489$var$AREA_SELECTION);
            }
        }, "By Area"))), (0, $LjoDx.h)("div", {
            class: "microscope-remittance__controls__params col-12 col-lg-6"
        }, (0, $LjoDx.h)("h2", {
            class: "microscope-remittance__controls__params__head"
        }, "Parameters"), (0, $LjoDx.h)("p", {
            class: "microscope-remittance__controls__options__label text-center mb-4"
        }, "Input parameters that help control data computation and graph construction"), this.getMonthParametersBlock(state), this.getSupervisorParametersBlock(state), this.getAreaParametersBlock(state)))), (0, $LjoDx.h)("div", {
            class: "col-8 offset-2 d-flex justify-content-end"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary",
            onClick: this.onConstruct
        }, "Construct"))), (0, $LjoDx.h)("div", {
            class: "row mt-4"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, this.getDataRenderBlock(state)))));
    };
    return MicroscopeRemittance;
}((0, $LjoDx.Component));


var $60ecffd9a5a5e7f2$exports = {};

$parcel$export($60ecffd9a5a5e7f2$exports, "MODAL_CHANGE_WITHDRAWAL_REEDIT", () => $60ecffd9a5a5e7f2$export$47c8d224fbde431b);
$parcel$export($60ecffd9a5a5e7f2$exports, "MODAL_CHANGE_WITHDRAWAL_STAGE", () => $60ecffd9a5a5e7f2$export$df87e843004e889c);
$parcel$export($60ecffd9a5a5e7f2$exports, "DashWithdrawals", () => $60ecffd9a5a5e7f2$export$64cc22d8f57220ae);

var $LjoDx = parcelRequire("LjoDx");












const $863fdffda9e388c6$export$2ac304385a0db6a3 = "pending";
const $863fdffda9e388c6$export$cd5fa912601e9b06 = "approved";
const $863fdffda9e388c6$export$bc1ffb8f115a040f = "denied";
const $863fdffda9e388c6$export$6d26cce75c8aa07e = "reedit";
const $863fdffda9e388c6$export$c85ebe67e435111f = "reedit-accepted";
const $863fdffda9e388c6$export$7e5b6bb497eef5a0 = "complete";
const $863fdffda9e388c6$export$5d43c7892dccddfb = "approval-pending";
const $863fdffda9e388c6$export$ff74e99c6b9400f4 = "stock-preparing";
const $863fdffda9e388c6$export$937b6625a57111f5 = "ready-for-pickup";
const $863fdffda9e388c6$export$330c1e30d442478 = "picked-up";
const $863fdffda9e388c6$export$a14dc8c0408d0711 = "awaiting-shipment";
const $863fdffda9e388c6$export$53d74baf77612363 = "in-transit";
const $863fdffda9e388c6$export$ad95b36140490c52 = "shipment-received";


var $cedb2ff85af633a3$exports = {};

$parcel$export($cedb2ff85af633a3$exports, "ViewWithdrawalModal", () => $cedb2ff85af633a3$export$3713067b1cdbc128);

var $LjoDx = parcelRequire("LjoDx");










var $cedb2ff85af633a3$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $cedb2ff85af633a3$export$3713067b1cdbc128 = /** @class */ function(_super) {
    $cedb2ff85af633a3$var$__extends(ViewWithdrawalModal, _super);
    function ViewWithdrawalModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onReeditDecline = function() {
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $0aa7832c96ad7a8d$export$6cd1afba76b7e164),
                payload: {
                    withdrawalId: _this.props.withdrawal.withdrawalId
                }
            });
            _this.props.close();
        };
        _this.onReeditAccept = function() {
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $0aa7832c96ad7a8d$export$a2888da95f8fb454),
                payload: {
                    withdrawalId: _this.props.withdrawal.withdrawalId
                }
            });
            _this.props.close();
        };
        _this.onApprove = function() {
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $0aa7832c96ad7a8d$export$ce7e3994f699d240),
                payload: {
                    withdrawalId: _this.props.withdrawal.withdrawalId
                }
            });
            _this.props.close();
        };
        _this.onReject = function() {
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $0aa7832c96ad7a8d$export$16822945959ccb2e),
                payload: {
                    withdrawalId: _this.props.withdrawal.withdrawalId
                }
            });
            _this.props.close();
        };
        _this.onManagementReedit = function() {
            _this.props.close({
                changeMode: (0, $60ecffd9a5a5e7f2$exports.MODAL_CHANGE_WITHDRAWAL_REEDIT)
            });
        };
        _this.onChangeStage = function() {
            _this.props.close({
                changeMode: (0, $60ecffd9a5a5e7f2$exports.MODAL_CHANGE_WITHDRAWAL_STAGE)
            });
        };
        return _this;
    }
    ViewWithdrawalModal.prototype.getDataBlock = function(props) {
        return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mb-3"
        }, (0, $LjoDx.h)("h4", {
            class: "view-withdrawal__data__label"
        }, "Status"), (0, $LjoDx.h)("b", {
            class: "view-withdrawal__data__value"
        }, props.withdrawal.status)), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mb-3"
        }, (0, $LjoDx.h)("h4", {
            class: "view-withdrawal__data__label"
        }, "Stage"), (0, $LjoDx.h)("b", {
            class: "view-withdrawal__data__value"
        }, props.withdrawal.stage)), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mb-3"
        }, (0, $LjoDx.h)("h4", {
            class: "view-withdrawal__data__label"
        }, "Total Value"), (0, $LjoDx.h)("b", {
            class: "view-withdrawal__data__value"
        }, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(props.withdrawal.totalAmount))), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mb-3"
        }, (0, $LjoDx.h)("h4", {
            class: "view-withdrawal__data__label"
        }, "Date Created"), (0, $LjoDx.h)("b", {
            class: "view-withdrawal__data__value"
        }, props.withdrawal.dateCreated ? (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(props.withdrawal.dateCreated).format((0, $6ac96fa96dbfc52a$export$8132710d1930b03e).dateWorded) : "Not Available")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mb-3"
        }, (0, $LjoDx.h)("h4", {
            class: "view-withdrawal__data__label"
        }, "Date Withdrawn"), (0, $LjoDx.h)("b", {
            class: "view-withdrawal__data__value"
        }, props.withdrawal.dateOfWithdrawal ? (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(props.withdrawal.dateOfWithdrawal).format((0, $6ac96fa96dbfc52a$export$8132710d1930b03e).dateWorded) : "Not Available")));
    };
    ViewWithdrawalModal.prototype.getBrandRow = function(brand, index, length) {
        var value = 0;
        value += brand.numOfCases * (0, $6ac96fa96dbfc52a$export$117ed8e927f4bd45) * brand.pricePerReam;
        if (brand.numOfReams) value += brand.numOfReams * brand.pricePerReam;
        // value += (brand.numOfPacks / PACKS_PER_REAM) * brand.pricePerReam;
        return (0, $LjoDx.h)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("view-withdrawal__brands__grid__row", {
                "last": index === length - 1
            })
        }, (0, $LjoDx.h)("div", {
            class: "view-withdrawal__brands__grid__col"
        }, brand.name), (0, $LjoDx.h)("div", {
            class: "view-withdrawal__brands__grid__col"
        }, brand.numOfCases ? brand.numOfCases : 0), (0, $LjoDx.h)("div", {
            class: "view-withdrawal__brands__grid__col"
        }, brand.numOfReams ? brand.numOfReams : 0), (0, $LjoDx.h)("div", {
            class: "view-withdrawal__brands__grid__col"
        }, brand.pricePerReam), (0, $LjoDx.h)("div", {
            class: "view-withdrawal__brands__grid__col last"
        }, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(value)));
    };
    ViewWithdrawalModal.prototype.getBrandsBlock = function(props) {
        var _this = this;
        var brands = props.withdrawal.brands;
        return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, brands.map(function(brandGroup) {
            return (0, $LjoDx.h)("div", {
                class: "row mb-4"
            }, (0, $LjoDx.h)("div", {
                class: "col-12"
            }, (0, $LjoDx.h)("div", {
                class: "view-withdrawal__brands__agent-name"
            }, brandGroup.agentName)), (0, $LjoDx.h)("div", {
                class: "col-12 mt-3 view-withdrawal__brands__grid"
            }, (0, $LjoDx.h)("div", {
                class: "view-withdrawal__brands__grid__row header"
            }, (0, $LjoDx.h)("div", {
                class: "view-withdrawal__brands__grid__col view-withdrawal__brands__grid__header"
            }, "Brand"), (0, $LjoDx.h)("div", {
                class: "view-withdrawal__brands__grid__col view-withdrawal__brands__grid__header"
            }, "Number of Cases"), (0, $LjoDx.h)("div", {
                class: "view-withdrawal__brands__grid__col view-withdrawal__brands__grid__header"
            }, "Number of Reams"), (0, $LjoDx.h)("div", {
                class: "view-withdrawal__brands__grid__col view-withdrawal__brands__grid__header"
            }, "Price per Ream"), (0, $LjoDx.h)("div", {
                class: "view-withdrawal__brands__grid__col view-withdrawal__brands__grid__header"
            }, "Value")), brandGroup.brands.map(function(brand, index) {
                return _this.getBrandRow(brand, index, brandGroup.brands.length);
            })));
        })));
    };
    ViewWithdrawalModal.prototype.getActionsRow = function(props, state) {
        if (props.withdrawal.status === (0, $863fdffda9e388c6$export$6d26cce75c8aa07e)) return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-6"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-danger w-100",
            onClick: this.onReeditDecline
        }, "Decline")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onReeditAccept
        }, "Accept"))));
        else if (props.currentUser.role === (0, $b9c3387011d11553$export$b38e98e302041724) || props.currentUser.role === (0, $b9c3387011d11553$export$314e71fc1506697c)) {
            if (props.withdrawal.status === (0, $863fdffda9e388c6$export$2ac304385a0db6a3) || props.withdrawal.status === (0, $863fdffda9e388c6$export$c85ebe67e435111f)) return (0, $LjoDx.h)("div", {
                class: "col-12"
            }, (0, $LjoDx.h)("div", {
                class: "row"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3 offset-lg-3"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-danger w-100",
                onClick: this.onReject
            }, "Reject")), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-outline-dark w-100",
                onClick: this.onManagementReedit
            }, "Re-Edit")), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-primary w-100",
                onClick: this.onApprove
            }, "Approve"))));
            else if (props.withdrawal.status === (0, $863fdffda9e388c6$export$cd5fa912601e9b06)) return (0, $LjoDx.h)("div", {
                class: "col-12"
            }, (0, $LjoDx.h)("div", {
                class: "row"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3 offset-lg-9"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-primary w-100",
                onClick: this.onChangeStage
            }, "Change Stage"))));
        } else return (0, $LjoDx.h)("div", null);
    };
    ViewWithdrawalModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Withdrawal Details", (0, $LjoDx.h)("small", {
            class: "anglo-modal__head__small ml-2"
        }, props.withdrawal.withdrawalId))), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, this.getDataBlock(props), (0, $LjoDx.h)("hr", null), this.getBrandsBlock(props))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions mt-3"
        }, this.getActionsRow(props, state)));
    };
    return ViewWithdrawalModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $2172aaf0f07dea49$exports = {};

$parcel$export($2172aaf0f07dea49$exports, "CreateWithdrawalModal", () => $2172aaf0f07dea49$export$8d85a04a33c6a406);

var $LjoDx = parcelRequire("LjoDx");














var $2172aaf0f07dea49$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2172aaf0f07dea49$export$8d85a04a33c6a406 = /** @class */ function(_super) {
    $2172aaf0f07dea49$var$__extends(CreateWithdrawalModal, _super);
    function CreateWithdrawalModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onToggleForm = function(toggleState) {
            _this.setState({
                isFormVisible: toggleState ? toggleState : !_this.state.isFormVisible
            });
        };
        _this.onAddBrandGroup = function(state) {
            var brandGroups = state.brandGroups;
            var group = {
                brands: []
            };
            var currentIndex = state.currentlySelectedGroupIndex ? state.currentlySelectedGroupIndex : 0;
            if (_this.state.brandGroups.length > 0) currentIndex++;
            brandGroups.push(group);
            _this.setState({
                brandGroups: brandGroups,
                currentlySelectedGroupIndex: currentIndex
            });
            _this.onToggleForm();
        };
        _this.onAddBrand = function() {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(_this.state.withdrawalForm);
            if (!_this.state.withdrawalForm.isValid) return;
            var form = _this.state.withdrawalForm;
            var selectedBrand = _this.state.brandPrices.find(function(member) {
                return member.brandId === form.fields["name"].value;
            });
            var brand = {
                name: selectedBrand.brandName,
                brandPriceId: selectedBrand.brandId,
                numOfCases: form.fields["numOfCases"].value,
                numOfReams: form.fields["numOfReams"].value,
                pricePerReam: selectedBrand.pricePerReam
            };
            var currentIndex = _this.state.currentlySelectedGroupIndex;
            var currentGroup = _this.state.brandGroups[currentIndex];
            var found = currentGroup.brands.find(function(brandMember) {
                return brand.name === brandMember.name;
            });
            if (found) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to add brand",
                message: "This brand already exists in current group.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else {
                currentGroup.brands.push(brand);
                // need to force component to update to rerender
                _this.forceUpdate();
            }
        };
        _this.onEditBrand = function(brand, index) {
            var form = _this.state.withdrawalForm;
            form.fields["name"].value = brand.brandPriceId;
            form.fields["numOfCases"].value = brand.numOfCases;
            form.fields["numOfReams"].value = brand.numOfReams;
            _this.setState({
                isEditing: true,
                currentlySelectedBrandIndex: index
            });
        };
        _this.onRemoveBrand = function(index) {
            var currentIndex = _this.state.currentlySelectedGroupIndex;
            var currentGroup = _this.state.brandGroups[currentIndex];
            currentGroup.brands.splice(index, 1);
            _this.forceUpdate();
        };
        _this.onRemoveGroup = function(index) {
            var groups = _this.state.brandGroups;
            groups.splice(index, 1);
            _this.forceUpdate();
        };
        _this.onCompleteEdit = function() {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(_this.state.withdrawalForm);
            if (!_this.state.withdrawalForm.isValid) return;
            var form = _this.state.withdrawalForm;
            var selectedBrand = _this.state.brandPrices.find(function(member) {
                return member.brandId === form.fields["name"].value;
            });
            var brand = {
                name: selectedBrand.brandName,
                brandPriceId: selectedBrand.brandId,
                numOfCases: form.fields["numOfCases"].value,
                numOfReams: form.fields["numOfReams"].value,
                pricePerReam: selectedBrand.pricePerReam
            };
            var currentIndex = _this.state.currentlySelectedGroupIndex;
            var currentGroup = _this.state.brandGroups[currentIndex];
            var currentBrandIndex = _this.state.currentlySelectedBrandIndex;
            currentGroup.brands[currentBrandIndex] = brand;
            _this.setState({
                isEditing: false,
                currentlySelectedBrandIndex: -1
            });
        };
        _this.onCompleteBrandGroup = function() {
            var currentGroup = _this.state.brandGroups[_this.state.currentlySelectedGroupIndex];
            currentGroup.agentName = _this.state.currentAgentName;
            _this.setState({
                isFormVisible: false
            });
        };
        _this.onEditGroup = function(group, index) {
            _this.setState({
                currentlySelectedGroupIndex: index,
                isFormVisible: true,
                currentAgentName: group.agentName
            });
        };
        _this.onSubmit = function() {
            var brandGroups = _this.state.brandGroups;
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $0aa7832c96ad7a8d$export$e232a12d14bb88be),
                payload: {
                    brandGroupsToCreate: brandGroups
                }
            });
        };
        _this.onSubmitReedit = function() {
            var brandGroups = _this.state.brandGroups;
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $0aa7832c96ad7a8d$export$f521ec80f2675a14),
                payload: {
                    updatedBrands: brandGroups,
                    withdrawalId: _this.props.withdrawal.withdrawalId
                }
            });
        };
        _this.setState({
            brandGroups: []
        });
        _this.createForm();
        return _this;
    }
    CreateWithdrawalModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "name": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "numOfCases": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "numOfReams": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            withdrawalForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["withdrawalForm"] = form;
            _this.setState(state);
        });
    };
    CreateWithdrawalModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var withdrawal$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.withdrawal;
        }));
        this.subs.push(withdrawal$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(withdrawal) {
            return withdrawal.brandPrices;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(prices) {
            _this.setState({
                brandPrices: prices
            });
        }));
        this.subs.push(withdrawal$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(withdrawal) {
            return withdrawal.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
        }));
        this.initialStoreDispatches();
        this.handleExistingWithdrawal(this.props.withdrawal);
    };
    CreateWithdrawalModal.prototype.handleExistingWithdrawal = function(withdrawal) {
        if (withdrawal && withdrawal.brands && withdrawal.brands.length > 0) this.setState({
            brandGroups: withdrawal.brands
        });
    };
    CreateWithdrawalModal.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $0aa7832c96ad7a8d$export$8a851eeafd335d3f)
        });
    };
    CreateWithdrawalModal.prototype.getListBlock = function(state) {
        var _this = this;
        if (state.isEditing) {
            var currentGroup = state.brandGroups[state.currentlySelectedGroupIndex];
            return (0, $LjoDx.h)("div", null);
        } else if (!state.isFormVisible) {
            if (state.brandGroups.length < 1) return (0, $LjoDx.h)("div", {
                class: "row"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 text-center mt-3"
            }, "No brands added. Please add at least 1 withdrawal group."));
            else return (0, $LjoDx.h)("div", {
                class: "row"
            }, (0, $LjoDx.h)("div", {
                class: "col-12"
            }, state.brandGroups.map(function(group, index) {
                return (0, $LjoDx.h)("div", {
                    class: "row my-3 create-withdrawal-modal__list__group"
                }, (0, $LjoDx.h)("div", {
                    class: "col-12"
                }, (0, $LjoDx.h)("div", {
                    class: "row align-items-center mb-3"
                }, (0, $LjoDx.h)("div", {
                    class: "col-12 col-lg-6"
                }, (0, $LjoDx.h)("div", {
                    class: "view-withdrawal__brands__agent-name"
                }, group.agentName)), (0, $LjoDx.h)("div", {
                    class: "col-12 col-lg-3"
                }, (0, $LjoDx.h)("button", {
                    class: "btn btn-outline-danger w-100 mb-3 mb-lg-0",
                    onClick: function() {
                        return _this.onRemoveGroup(index);
                    }
                }, "Delete Group")), (0, $LjoDx.h)("div", {
                    class: "col-12 col-lg-3"
                }, (0, $LjoDx.h)("button", {
                    class: "btn btn-outline-primary w-100",
                    onClick: function() {
                        return _this.onEditGroup(group, index);
                    }
                }, "Edit Group")))), (0, $LjoDx.h)("div", {
                    class: "col-12"
                }, (0, $LjoDx.h)("div", {
                    class: "row"
                }, (0, $LjoDx.h)("div", {
                    class: "col view-withdrawal__brands__grid__header"
                }, "Brand"), (0, $LjoDx.h)("div", {
                    class: "col view-withdrawal__brands__grid__header"
                }, "Number of Cases"), (0, $LjoDx.h)("div", {
                    class: "col view-withdrawal__brands__grid__header"
                }, "Number of Reams"), (0, $LjoDx.h)("div", {
                    class: "col view-withdrawal__brands__grid__header"
                }, "Price per Ream"), (0, $LjoDx.h)("div", {
                    class: "col view-withdrawal__brands__grid__header"
                }, "Value")), group.brands.map(function(brand, index) {
                    return _this.getBrandRow(brand, index, group.brands.length);
                })));
            })));
        }
    };
    CreateWithdrawalModal.prototype.getBrandRow = function(brand, index, length) {
        var value = 0;
        value += brand.numOfCases * (0, $6ac96fa96dbfc52a$export$117ed8e927f4bd45) * brand.pricePerReam;
        if (brand.numOfReams) value += brand.numOfReams * brand.pricePerReam;
        // value += (brand.numOfPacks / PACKS_PER_REAM) * brand.pricePerReam;
        return (0, $LjoDx.h)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("row view-withdrawal__brands__grid__row", {
                "last": index === length - 1
            })
        }, (0, $LjoDx.h)("div", {
            class: "col view-withdrawal__brands__grid__col"
        }, brand.name), (0, $LjoDx.h)("div", {
            class: "col view-withdrawal__brands__grid__col"
        }, brand.numOfCases ? brand.numOfCases : 0), (0, $LjoDx.h)("div", {
            class: "col view-withdrawal__brands__grid__col"
        }, brand.numOfReams ? brand.numOfReams : 0), (0, $LjoDx.h)("div", {
            class: "col view-withdrawal__brands__grid__col last"
        }, brand.pricePerReam), (0, $LjoDx.h)("div", {
            class: "col view-withdrawal__brands__grid__col last"
        }, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(value)));
    };
    CreateWithdrawalModal.prototype.getFormBrandRow = function(brand, index, length) {
        var _this = this;
        var value = 0;
        value += brand.numOfCases * (0, $6ac96fa96dbfc52a$export$117ed8e927f4bd45) * brand.pricePerReam;
        if (brand.numOfReams) value += brand.numOfReams * brand.pricePerReam;
        // value += (brand.numOfPacks / PACKS_PER_REAM) * brand.pricePerReam;
        return (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mb-2"
        }, (0, $LjoDx.h)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("container-fluid create-withdrawal-modal__form__brand-card py-2", {
                "editing": index === this.state.currentlySelectedBrandIndex
            })
        }, (0, $LjoDx.h)("div", {
            class: "row mt-2"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__name"
        }, brand.name)), (0, $LjoDx.h)("div", {
            class: "col-6"
        }, (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__label"
        }, "Num of Cases"), (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__value"
        }, brand.numOfCases ? brand.numOfCases : 0)), (0, $LjoDx.h)("div", {
            class: "col-6"
        }, (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__label"
        }, "Num of Reams"), (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__value"
        }, brand.numOfReams ? brand.numOfReams : 0))), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-6"
        }, (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__label"
        }, "Price per Ream"), (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__value"
        }, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(brand.pricePerReam))), (0, $LjoDx.h)("div", {
            class: "col-6"
        }, (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__label"
        }, "Total Value"), (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__value"
        }, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(value)))), (0, $LjoDx.h)("div", {
            class: "row mt-2"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: function() {
                return _this.onEditBrand(brand, index);
            }
        }, "Edit")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-2 mt-lg-0"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: function() {
                return _this.onRemoveBrand(index);
            }
        }, "Remove")))));
    };
    CreateWithdrawalModal.prototype.getFormBlock = function(props, state) {
        var _this = this;
        if (state.isFormVisible) {
            var form = state.withdrawalForm;
            var currentIndex = state.currentlySelectedGroupIndex;
            var currentGroup_1 = state.brandGroups[currentIndex];
            return (0, $LjoDx.h)("div", {
                class: "row"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 create-withdrawal-modal__form"
            }, (0, $LjoDx.h)("div", {
                class: "row"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 mt-3"
            }, (0, $LjoDx.h)("label", {
                class: "anglo-remittance__submit-form__label"
            }, "Sales Agent*"), (0, $LjoDx.h)("input", {
                class: "form-control",
                type: "text",
                onInput: (0, $8846dd5c02dd2c05$export$2e2bcd8739ae039)(this, "currentAgentName"),
                value: state.currentAgentName,
                placeholder: "Agent name"
            }))), (0, $LjoDx.h)("div", {
                class: "container-fluid mt-3"
            }, (0, $LjoDx.h)("div", {
                class: "row no-gutters"
            }, (0, $LjoDx.h)("div", {
                class: "col-12"
            }, (0, $LjoDx.h)("i", null, "Brands Breakdown"))), (0, $LjoDx.h)("div", {
                class: "row"
            }, currentGroup_1.brands.map(function(member, index) {
                return _this.getFormBrandRow(member, index, currentGroup_1.brands.length);
            }))), (0, $LjoDx.h)("div", {
                class: "row create-withdrawal-modal__form__brand py-3"
            }, (0, $LjoDx.h)("div", {
                class: "col-12"
            }, (0, $LjoDx.h)("label", {
                class: "anglo-remittance__submit-form__label"
            }, "Brand Name*"), (0, $LjoDx.h)("select", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                    "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["name"])
                }),
                placeholder: "Brand Name",
                value: form.fields["name"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "name")
            }, (0, $LjoDx.h)("option", {
                class: "text-muted",
                value: "",
                disabled: true,
                selected: true
            }, "Select Brand"), state.brandPrices.map(function(price) {
                return (0, $LjoDx.h)("option", {
                    value: price.brandId
                }, price.brandName);
            }))), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-6 mt-3"
            }, (0, $LjoDx.h)("label", {
                class: "anglo-remittance__submit-form__label"
            }, "Number of Cases*"), (0, $LjoDx.h)("input", {
                class: "form-control",
                type: "text",
                onInput: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "numOfCases"),
                value: form.fields["numOfCases"].value,
                placeholder: "Cases"
            })), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-6 mt-3"
            }, (0, $LjoDx.h)("label", {
                class: "anglo-remittance__submit-form__label"
            }, "Number of Reams"), (0, $LjoDx.h)("input", {
                class: "form-control",
                type: "text",
                onInput: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "numOfReams"),
                value: form.fields["numOfReams"].value,
                placeholder: "Reams"
            })), (0, $LjoDx.h)("div", {
                class: "col-6 col-lg-3 offset-6 offset-lg-9 mt-3"
            }, this.getFormActionRow(state))), (0, $LjoDx.h)("div", {
                class: "row mt-3"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3 offset-lg-9"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-secondary w-100",
                onClick: this.onCompleteBrandGroup
            }, "Complete Brand Group")))));
        }
    };
    CreateWithdrawalModal.prototype.getFormActionRow = function(state) {
        if (state.isEditing) return (0, $LjoDx.h)("button", {
            class: "btn btn-outline-primary w-100",
            onClick: this.onCompleteEdit
        }, "Edit Brand");
        else return (0, $LjoDx.h)("button", {
            class: "btn btn-outline-primary w-100",
            onClick: this.onAddBrand
        }, "Add Brand");
    };
    CreateWithdrawalModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return this.getSpinnerBlock();
        else if (props.isReedit) return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmitReedit,
            disabled: state.brandGroups.length < 1
        }, "Re-Edit Withdrawals"))));
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: state.brandGroups.length < 1
        }, "Submit Withdrawals"))));
    };
    CreateWithdrawalModal.prototype.getSpinnerBlock = function() {
        return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    CreateWithdrawalModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-withdrawal-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, props.isReedit ? "Re-Edit Withdrawal Request" : "Create Withdrawal Request")), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, !state.isFormVisible ? (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: function() {
                return _this.onAddBrandGroup(state);
            }
        }, "Add Withdrawal Group"))) : null, this.getListBlock(state), this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions mt-3"
        }, this.getActionsRow(props, state)));
    };
    return CreateWithdrawalModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $34afa053d2470d75$exports = {};

$parcel$export($34afa053d2470d75$exports, "ReviewStocksModal", () => $34afa053d2470d75$export$bbb2f71790499066);

var $LjoDx = parcelRequire("LjoDx");





var $34afa053d2470d75$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $34afa053d2470d75$export$bbb2f71790499066 = /** @class */ function(_super) {
    $34afa053d2470d75$var$__extends(ReviewStocksModal, _super);
    function ReviewStocksModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.doModalClose = function() {
            _this.props.close();
        };
        return _this;
    }
    ReviewStocksModal.prototype.componentDidMount = function() {
        _super.prototype.componentDidMount.call(this);
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        var action = {
            type: (0, $4c71eb74f53637d3$export$ff67457b75dbf12a)
        };
        store.dispatch(action);
    };
    ReviewStocksModal.prototype.getBrandRow = function(brand, index, length) {
        var value = 0;
        value += brand.numOfCases * (0, $6ac96fa96dbfc52a$export$117ed8e927f4bd45) * brand.pricePerReam;
        if (brand.numOfReams) value += brand.numOfReams * brand.pricePerReam;
        // value += (brand.numOfPacks / PACKS_PER_REAM) * brand.pricePerReam;
        return (0, $LjoDx.h)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("row view-withdrawal__brands__grid__row", {
                "last": index === length - 1
            })
        }, (0, $LjoDx.h)("div", {
            class: "col view-withdrawal__brands__grid__col"
        }, brand.name), (0, $LjoDx.h)("div", {
            class: "col view-withdrawal__brands__grid__col"
        }, brand.numOfCases ? brand.numOfCases : 0), (0, $LjoDx.h)("div", {
            class: "col view-withdrawal__brands__grid__col last"
        }, brand.numOfReams ? brand.numOfReams : 0), (0, $LjoDx.h)("div", {
            class: "col view-withdrawal__brands__grid__col last"
        }, brand.numOfPacks ? brand.numOfPacks : 0));
    };
    ReviewStocksModal.prototype.getBrandsBlock = function(props) {
        var _this = this;
        console.log(props.currentUser);
        var brands = props.currentUser.supervisor.currentStock;
        return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row mb-4"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col view-withdrawal__brands__grid__header"
        }, "Brand"), (0, $LjoDx.h)("div", {
            class: "col view-withdrawal__brands__grid__header"
        }, "Number of Cases"), (0, $LjoDx.h)("div", {
            class: "col view-withdrawal__brands__grid__header"
        }, "Number of Reams"), (0, $LjoDx.h)("div", {
            class: "col view-withdrawal__brands__grid__header"
        }, "Number of Packs")), brands.map(function(brand, index) {
            return _this.getBrandRow(brand, index, brands.length);
        })))));
    };
    ReviewStocksModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Current Stocks", (0, $LjoDx.h)("small", {
            class: "anglo-modal__head__small ml-2"
        }, props.currentUser.firstName, " ", props.currentUser.lastName))), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, this.getBrandsBlock(props))));
    };
    return ReviewStocksModal;
}((0, $3f2ba7f1e3532510$exports.Modal));



var $2a8ea244f3f940d6$exports = {};

$parcel$export($2a8ea244f3f940d6$exports, "ChangeStageModal", () => $2a8ea244f3f940d6$export$eea3a19d8606b121);

var $LjoDx = parcelRequire("LjoDx");















var $2a8ea244f3f940d6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2a8ea244f3f940d6$export$eea3a19d8606b121 = /** @class */ function(_super) {
    $2a8ea244f3f940d6$var$__extends(ChangeStageModal, _super);
    function ChangeStageModal() {
        var _this = _super.call(this) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.pickedUpWithdrawal = function(field, form) {
            if (form.fields["selectedStage"].value === (0, $863fdffda9e388c6$export$330c1e30d442478) || form.fields["selectedStage"].value === (0, $863fdffda9e388c6$export$ad95b36140490c52)) return field.value ? true : false;
        };
        _this.inTransitWithdrawal = function(field, form) {
            if (form.fields["selectedStage"].value === (0, $863fdffda9e388c6$export$53d74baf77612363)) return field.value ? true : false;
        };
        _this.onChangeStage = function() {
            var form = _this.state.form;
            $fc45e937e6d1b794$export$ed692cabb252e59b(form);
            for(var k in form.fields)if (!form.fields[k].isValid) console.log(k);
            if (!form.isValid) return;
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $0aa7832c96ad7a8d$export$85e7a25aa0be6caf),
                payload: {
                    withdrawalId: _this.props.withdrawal.withdrawalId,
                    currentStage: _this.props.withdrawal.stage,
                    targetStage: _this.state.form.fields["selectedStage"].value,
                    supervisor: _this.props.withdrawal.supervisor,
                    dateOfWithdrawal: _this.state.form.fields["dateOfWithdrawal"].value,
                    dateOfShipment: _this.state.form.fields["dateOfShipment"].value
                }
            });
        };
        _this.onDateSelected = function(date) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.form, "dateOfWithdrawal", date);
        };
        _this.onDateShipmentSelected = function(date) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.form, "dateOfShipment", date);
        };
        _this.createForm();
        return _this;
    }
    ChangeStageModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "selectedStage": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "dateOfWithdrawal": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [
                this.pickedUpWithdrawal
            ], ""),
            "dateOfShipment": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [
                this.inTransitWithdrawal
            ], "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            $fc45e937e6d1b794$export$ed692cabb252e59b(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    ChangeStageModal.prototype.componentDidMount = function() {
        var _this = this;
        var withdrawal$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.withdrawal;
        }));
        this.subs.push(withdrawal$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(withdrawal) {
            return withdrawal.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) _this.props.close();
            else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isLoading: true
            });
        }));
    };
    ChangeStageModal.prototype.getDataBlock = function(props) {
        return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mb-3"
        }, (0, $LjoDx.h)("h4", {
            class: "view-withdrawal__data__label"
        }, "Status"), (0, $LjoDx.h)("b", {
            class: "view-withdrawal__data__value"
        }, props.withdrawal.status)), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mb-3"
        }, (0, $LjoDx.h)("h4", {
            class: "view-withdrawal__data__label"
        }, "Stage"), (0, $LjoDx.h)("b", {
            class: "view-withdrawal__data__value"
        }, props.withdrawal.stage)), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mb-3"
        }, (0, $LjoDx.h)("h4", {
            class: "view-withdrawal__data__label"
        }, "Total Value"), (0, $LjoDx.h)("b", {
            class: "view-withdrawal__data__value"
        }, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(props.withdrawal.totalAmount))), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mb-3"
        }, (0, $LjoDx.h)("h4", {
            class: "view-withdrawal__data__label"
        }, "Date Created"), (0, $LjoDx.h)("b", {
            class: "view-withdrawal__data__value"
        }, props.withdrawal.dateCreated ? (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(props.withdrawal.dateCreated).format((0, $6ac96fa96dbfc52a$export$8132710d1930b03e).dateWorded) : "Not Available")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mb-3"
        }, (0, $LjoDx.h)("h4", {
            class: "view-withdrawal__data__label"
        }, "Date Withdrawn"), (0, $LjoDx.h)("b", {
            class: "view-withdrawal__data__value"
        }, props.withdrawal.dateOfWithdrawal ? (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(props.withdrawal.dateOfWithdrawal).format((0, $6ac96fa96dbfc52a$export$8132710d1930b03e).dateWorded) : "Not Available")));
    };
    ChangeStageModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Withdrawal Details", (0, $LjoDx.h)("small", {
            class: "anglo-modal__head__small ml-2"
        }, props.withdrawal.withdrawalId))), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, this.getDataBlock(props), (0, $LjoDx.h)("hr", null), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "New Stage"), (0, $LjoDx.h)("select", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": $fc45e937e6d1b794$export$7c1f5a29b59be526(state.form.fields["selectedStage"])
            }),
            value: state.form.fields["selectedStage"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, state.form, "selectedStage")
        }, (0, $LjoDx.h)("option", {
            value: (0, $863fdffda9e388c6$export$ff74e99c6b9400f4)
        }, "Stock Preparing"), (0, $LjoDx.h)("option", {
            value: (0, $863fdffda9e388c6$export$937b6625a57111f5)
        }, "Walk-in | Ready for pickup"), (0, $LjoDx.h)("option", {
            value: (0, $863fdffda9e388c6$export$330c1e30d442478)
        }, "Walk-in | Picked up"), (0, $LjoDx.h)("option", {
            value: (0, $863fdffda9e388c6$export$a14dc8c0408d0711)
        }, "Shipment | Awaiting Shipment"), (0, $LjoDx.h)("option", {
            value: (0, $863fdffda9e388c6$export$53d74baf77612363)
        }, "Shipment | In Transit"), (0, $LjoDx.h)("option", {
            value: (0, $863fdffda9e388c6$export$ad95b36140490c52)
        }, "Shipment | Shipment Received"))), state.form.fields["selectedStage"].value === (0, $863fdffda9e388c6$export$330c1e30d442478) || state.form.fields["selectedStage"].value === (0, $863fdffda9e388c6$export$ad95b36140490c52) ? (0, $LjoDx.h)("div", {
            class: "col-12 mt-2"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Date of Withdrawal/Shipment Received"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: this.onDateSelected,
            isValid: $fc45e937e6d1b794$export$7c1f5a29b59be526(state.form.fields["dateOfWithdrawal"]),
            isPristine: state.form.fields["dateOfWithdrawal"].isPristine
        })) : null, state.form.fields["selectedStage"].value === (0, $863fdffda9e388c6$export$53d74baf77612363) ? (0, $LjoDx.h)("div", {
            class: "col-12 mt-2"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Date of Shipment"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: this.onDateShipmentSelected,
            isValid: $fc45e937e6d1b794$export$7c1f5a29b59be526(state.form.fields["dateOfShipment"]),
            isPristine: state.form.fields["dateOfShipment"].isPristine
        })) : null))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, state.isLoading ? (0, $LjoDx.h)("div", {
            class: ""
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading..."))) : (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onChangeStage
        }, "Update Stage"))))));
    };
    return ChangeStageModal;
}((0, $3f2ba7f1e3532510$exports.Modal));





var $60ecffd9a5a5e7f2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $60ecffd9a5a5e7f2$export$47c8d224fbde431b = "management-reedit";
var $60ecffd9a5a5e7f2$export$df87e843004e889c = "change-stage";
var $60ecffd9a5a5e7f2$export$64cc22d8f57220ae = /** @class */ function(_super) {
    $60ecffd9a5a5e7f2$var$__extends(DashWithdrawals, _super);
    function DashWithdrawals(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.MODAL_CREATE_WITHDRAWAL = 0;
        _this.MODAL_VIEW_DETAILS = 1;
        _this.MODAL_REVIEW_CURRENT_STOCKS = 2;
        _this.MODAL_REEDIT = 3;
        _this.MODAL_CHANGE_STAGE = 4;
        _this.onViewDetails = function(withdrawal) {
            _this.setState({
                selectedWithdrawal: withdrawal
            });
            _this.onModalOpened(_this.MODAL_VIEW_DETAILS);
        };
        _this.onModalOpened = function(paramState) {
            _this.setState({
                modalState: paramState
            });
        };
        _this.onModalClose = function(returnParms) {
            _this.setState({
                modalState: -1
            });
            if (returnParms) {
                if (returnParms.changeMode && returnParms.changeMode === $60ecffd9a5a5e7f2$export$47c8d224fbde431b) _this.onModalOpened(_this.MODAL_REEDIT);
                else if (returnParms.changeMode && returnParms.changeMode === $60ecffd9a5a5e7f2$export$df87e843004e889c) _this.onModalOpened(_this.MODAL_CHANGE_STAGE);
            }
            _this.initialStoreDispatches();
        };
        _this.onPageClicked = function(page) {
            var filterForm = {};
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) // filters.set(k, fieldList[k].value);
            filterForm[k] = fieldList[k].value;
            filterForm["page"] = page;
            var filters = _this.state.filters;
            filters.set("page", page);
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $0aa7832c96ad7a8d$export$77f66c384bff48ec),
                payload: {
                    filters: filters
                }
            });
            _this.setState({
                currentPage: page
            });
        };
        _this.onSupervisorSearchChange = function(supervisor) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filterForm, "username", supervisor.username);
        };
        _this.onFilterToggleClicked = function() {
            _this.setState({
                isFilterVisible: !_this.state.isFilterVisible
            });
        };
        _this.startDateSelected = function(date) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filterForm, "startDate", date);
        };
        _this.resetStartDates = function(returned) {
            _this.resetStartDate = returned;
        };
        _this.resetEndDates = function(returned) {
            _this.resetEndDate = returned;
        };
        _this.applyFilters = function() {
            var filters = _this.state.filters;
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filters.set(k, fieldList[k].value);
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $0aa7832c96ad7a8d$export$77f66c384bff48ec),
                payload: {
                    filters: filters
                }
            });
        };
        _this.resetFilters = function() {
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)fieldList[k].value = null;
            _this.resetStartDate();
            _this.resetEndDate();
            var filters = new Map();
            filters.set("page", 1);
            _this.setState({
                filters: filters,
                currentPage: 1
            });
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $0aa7832c96ad7a8d$export$77f66c384bff48ec),
                payload: {
                    filters: filters
                }
            });
        };
        _this.getPortalModal = function(state) {
            var modalState = state.modalState;
            if (modalState < 0) return null;
            else if (modalState === _this.MODAL_CREATE_WITHDRAWAL) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-124"
            }, (0, $LjoDx.h)((0, $2172aaf0f07dea49$exports.CreateWithdrawalModal), {
                currentUser: state.currentUser,
                withdrawal: state.selectedWithdrawal,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-123"
            })));
            else if (modalState === _this.MODAL_VIEW_DETAILS) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-123"
            }, (0, $LjoDx.h)((0, $cedb2ff85af633a3$exports.ViewWithdrawalModal), {
                currentUser: state.currentUser,
                withdrawal: state.selectedWithdrawal,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-123"
            })));
            else if (modalState === _this.MODAL_REVIEW_CURRENT_STOCKS) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-123"
            }, (0, $LjoDx.h)((0, $34afa053d2470d75$exports.ReviewStocksModal), {
                currentUser: state.currentUser,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-123"
            })));
            else if (modalState === _this.MODAL_REEDIT) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-123"
            }, (0, $LjoDx.h)((0, $2172aaf0f07dea49$exports.CreateWithdrawalModal), {
                currentUser: state.currentUser,
                withdrawal: state.selectedWithdrawal,
                isReedit: true,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-123"
            })));
            else if (modalState === _this.MODAL_CHANGE_STAGE) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-123"
            }, (0, $LjoDx.h)((0, $2a8ea244f3f940d6$exports.ChangeStageModal), {
                currentUser: state.currentUser,
                withdrawal: state.selectedWithdrawal,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-123"
            })));
            else return null;
        };
        var filters = new Map();
        filters.set("page", 1);
        _this.setState({
            modalState: -1,
            filters: filters,
            currentPage: 1
        });
        _this.createForm();
        return _this;
    }
    DashWithdrawals.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "startDate": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "endDate": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "minAmount": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "maxAmount": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "status": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "stage": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "username": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "withdrawalId": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            filterForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["filterForm"] = form;
            _this.setState(state);
        });
    };
    DashWithdrawals.prototype.componentDidMount = function() {
        var _this = this;
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.user;
        }));
        this.subs.push(user$.subscribe(function(user) {
            if (user.currentUser) _this.setState({
                currentUser: user.currentUser
            });
        }));
        var withdrawal$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.withdrawal;
        }));
        this.subs.push(withdrawal$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(withdrawal) {
            return withdrawal.gridRequestState;
        })).subscribe(function(gridRequestState) {
            _this.setState({
                gridRequestState: gridRequestState
            });
        }));
        this.subs.push(withdrawal$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(withdrawal) {
            return withdrawal.withdrawals;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(withdrawals) {
            _this.setState({
                gridData: withdrawals
            });
        }));
        this.subs.push(withdrawal$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(withdrawal) {
            return withdrawal.total;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(total) {
            if (total) {
                var pages = [];
                var limit = Math.ceil(total / (0, $787290684425694f$exports.PAGE_SIZE));
                for(var i = 0; i < limit; i++)pages.push(i + 1);
                _this.setState({
                    pages: pages
                });
            }
        }));
        this.initialStoreDispatches();
    };
    DashWithdrawals.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $0aa7832c96ad7a8d$export$77f66c384bff48ec),
            payload: {
                filters: this.state.filters
            }
        });
    };
    DashWithdrawals.prototype.getWithdrawalStage = function(stage) {
        switch(stage){
            case 0, $863fdffda9e388c6$export$5d43c7892dccddfb:
                return "Approval Pending";
            case 0, $863fdffda9e388c6$export$ff74e99c6b9400f4:
                return "Stock Preparing";
            case 0, $863fdffda9e388c6$export$937b6625a57111f5:
                return "Ready for Pickup";
            case 0, $863fdffda9e388c6$export$330c1e30d442478:
                return "Picked Up";
            case 0, $863fdffda9e388c6$export$a14dc8c0408d0711:
                return "Awaiting Shipment";
            case 0, $863fdffda9e388c6$export$53d74baf77612363:
                return "In Transit";
            case 0, $863fdffda9e388c6$export$ad95b36140490c52:
                return "Shipment Received";
        }
    };
    DashWithdrawals.prototype.getInsightBlock = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "row"
        });
    };
    DashWithdrawals.prototype.getActionsBlock = function(props, state) {
        var _this = this;
        if (state.currentUser && state.currentUser.role === (0, $b9c3387011d11553$export$819e975c5d2910e9)) return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 offset-lg-8 col-lg-2 mb-lg-0"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: function() {
                _this.onModalOpened(_this.MODAL_REVIEW_CURRENT_STOCKS);
            }
        }, "Review Current Stocks")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: function() {
                _this.onModalOpened(_this.MODAL_CREATE_WITHDRAWAL);
            }
        }, "Create Withdrawal")));
    };
    DashWithdrawals.prototype.getFilterForm = function(props, state) {
        var form = state.filterForm;
        if (state.currentUser && state.isFilterVisible) {
            if (state.currentUser.role === (0, $b9c3387011d11553$export$b38e98e302041724)) return (0, $LjoDx.h)("div", {
                class: "row mt-3"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3"
            }, (0, $LjoDx.h)("label", {
                class: "dash-remittance__filter-row__filters__label"
            }, "Supervisor"), (0, $LjoDx.h)((0, $204820985097eb0a$exports.AutocompleteSearch), {
                onResultSelected: this.onSupervisorSearchChange
            })), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3"
            }, (0, $LjoDx.h)("label", {
                class: "dash-remittance__filter-row__filters__label"
            }, "Withdrawal Id"), (0, $LjoDx.h)("input", {
                type: "text",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                    "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["withdrawalId"])
                }),
                value: form.fields["withdrawalId"].value,
                placeholder: "",
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "withdrawalId")
            })), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3"
            }, (0, $LjoDx.h)("label", {
                class: "dash-remittance__filter-row__filters__label"
            }, "Start Creation date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
                onDateSelected: this.startDateSelected,
                initialValue: form.fields["startDate"].value,
                isValid: form.fields["startDate"].isValid,
                isPristine: form.fields["startDate"].isPristine,
                reset: this.resetStartDates
            })), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3"
            }, (0, $LjoDx.h)("label", {
                class: "dash-remittance__filter-row__filters__label"
            }, "End Creation date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
                onDateSelected: this.startDateSelected,
                initialValue: form.fields["endDate"].value,
                isValid: form.fields["endDate"].isValid,
                isPristine: form.fields["endDate"].isPristine,
                reset: this.resetEndDates
            })));
            else return (0, $LjoDx.h)("div", {
                class: "row mt-3"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3"
            }, (0, $LjoDx.h)("label", {
                class: "dash-remittance__filter-row__filters__label"
            }, "Withdrawal Id"), (0, $LjoDx.h)("input", {
                type: "text",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                    "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["withdrawalId"])
                }),
                value: form.fields["withdrawalId"].value,
                placeholder: "",
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "withdrawalId")
            })), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3"
            }, (0, $LjoDx.h)("label", {
                class: "dash-remittance__filter-row__filters__label"
            }, "Start Creation date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
                onDateSelected: this.startDateSelected,
                initialValue: form.fields["startDate"].value,
                isValid: form.fields["startDate"].isValid,
                isPristine: form.fields["startDate"].isPristine,
                reset: this.resetStartDates
            })), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3"
            }, (0, $LjoDx.h)("label", {
                class: "dash-remittance__filter-row__filters__label"
            }, "End Creation date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
                onDateSelected: this.startDateSelected,
                initialValue: form.fields["endDate"].value,
                isValid: form.fields["endDate"].isValid,
                isPristine: form.fields["endDate"].isPristine,
                reset: this.resetEndDates
            })));
        }
    };
    DashWithdrawals.prototype.getFilterActions = function(props, state) {
        if (state.isFilterVisible) return (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2 offset-lg-8"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.resetFilters
        }, "Reset Filters")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.applyFilters
        }, "Apply Filters")));
    };
    DashWithdrawals.prototype.getFilterBlock = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "container-fluid px-0 mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "row justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("a", {
            class: "dash-remittance__filter-row__filter-btn",
            onClick: this.onFilterToggleClicked
        }, "Filter ", (0, $LjoDx.h)("i", {
            class: "fas fa-filter"
        })))), (0, $LjoDx.h)("div", {
            class: "row no-gutters"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, state.isFilterVisible ? (0, $LjoDx.h)("div", {
            class: "dash-remittance__filter-row__filters mt-2"
        }, this.getFilterForm(props, state), this.getFilterActions(props, state)) : null)));
    };
    DashWithdrawals.prototype.getGridBlock = function(props, state) {
        var _this = this;
        if (state.gridRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) return (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading..."))));
        else if (state.gridRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) // in the grid, we only show 4-5 columns
        // should the user wish to see the full breakdown
        // a modal will be used instead
        return (0, $LjoDx.h)("div", {
            class: "dash-remittance__grid-container"
        }, (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid dash-withdrawal__grid"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__col col-short"
        }, "Actions"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Withdrawal ID"), state.currentUser.role === (0, $b9c3387011d11553$export$b38e98e302041724) || state.currentUser.role === (0, $b9c3387011d11553$export$314e71fc1506697c) ? (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Supervisor") : null, (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Status"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Stage"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Calculated Value"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Date Created"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Date Withdrawn")), state.gridData.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                class: "data-grid__row",
                id: row.withdrawalId
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col col-short"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-outline-primary w-100",
                onClick: function() {
                    _this.onViewDetails(row);
                }
            }, "View")), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.withdrawalId), state.currentUser.role === (0, $b9c3387011d11553$export$b38e98e302041724) || state.currentUser.role === (0, $b9c3387011d11553$export$314e71fc1506697c) ? (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.user.firstName, " ", row.user.lastName) : null, (0, $LjoDx.h)("div", {
                class: "data-grid__col text-capitalize"
            }, row.status), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, _this.getWithdrawalStage(row.stage)), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(row.totalAmount)), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(row.dateCreated).format("MMMM DD, YYYY")), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.dateOfWithdrawal ? (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(row.dateOfWithdrawal).format("MMMM DD, YYYY") : "Not Available"));
        })))));
        else return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, "Failed to load grid data."));
    };
    DashWithdrawals.prototype.getPaginationBlock = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, state.pages ? (0, $LjoDx.h)("div", {
            class: "dash-remittance__pagination mb-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn dash-remittance__pagination__page arrow",
            disabled: state.currentPage === 1,
            onClick: function() {
                return _this.onPageClicked(state.currentPage - 1);
            }
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-chevron-left"
        })), state.currentPage > 5 ? (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                "active": state.pages[0] === state.currentPage
            }),
            onClick: function() {
                return _this.onPageClicked(state.pages[0]);
            }
        }, state.pages[0]) : null, state.currentPage > 5 ? (0, $LjoDx.h)("span", {
            class: "mx-2"
        }, "...") : null, state.pages ? state.pages.map(function(page) {
            if (page > state.currentPage - 5 && page < state.currentPage + 5) return (0, $LjoDx.h)("button", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                    "active": page === state.currentPage
                }),
                onClick: function() {
                    return _this.onPageClicked(page);
                }
            }, page);
        }) : null, state.currentPage < state.pages.length - 5 ? (0, $LjoDx.h)("span", {
            class: "mx-2"
        }, "...") : null, state.currentPage < state.pages.length - 5 ? (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                "active": state.pages[state.pages.length - 1] === state.currentPage
            }),
            onClick: function() {
                return _this.onPageClicked(state.pages[state.pages.length - 1]);
            }
        }, state.pages[state.pages.length - 1]) : null, (0, $LjoDx.h)("button", {
            class: "btn dash-remittance__pagination__page arrow",
            disabled: state.currentPage === state.pages[state.pages.length - 1],
            onClick: function() {
                return _this.onPageClicked(state.currentPage + 1);
            }
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-chevron-right"
        }))) : null));
    };
    DashWithdrawals.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "dash-withdrawal anglo__dashboard"
        }, this.getPortalModal(state), (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-8 col-lg-4"
        }, (0, $LjoDx.h)("nav", {
            "aria-label": "breadcrumb"
        }, (0, $LjoDx.h)("ol", {
            class: "breadcrumb"
        }, (0, $LjoDx.h)("li", {
            class: "breadcrumb-item"
        }, (0, $LjoDx.h)("a", {
            href: "/withdrawal"
        }, "Withdrawals")))))), this.getInsightBlock(props, state), this.getActionsBlock(props, state), this.getFilterBlock(props, state), this.getGridBlock(props, state), this.getPaginationBlock(props, state)));
    };
    return DashWithdrawals;
}((0, $LjoDx.Component));


var $1b4d8647546ef02f$exports = {};

$parcel$export($1b4d8647546ef02f$exports, "MODAL_CHANGE_CREATE_LOCATION", () => $1b4d8647546ef02f$export$9a8b7be01e798073);
$parcel$export($1b4d8647546ef02f$exports, "getDisposalValue", () => $1b4d8647546ef02f$export$4a115427c4247518);
$parcel$export($1b4d8647546ef02f$exports, "DashDisposals", () => $1b4d8647546ef02f$export$26f3e80c50f8ceda);

var $LjoDx = parcelRequire("LjoDx");











var $dc7b2e3ac4b2ef1f$exports = {};

$parcel$export($dc7b2e3ac4b2ef1f$exports, "ViewDisposalModal", () => $dc7b2e3ac4b2ef1f$export$a4bb87c7927e3d30);

var $LjoDx = parcelRequire("LjoDx");





const $467b0c242e1785f3$export$6ff90bb23a7ae4cb = "region";
const $467b0c242e1785f3$export$2f58ab114ec80e81 = "city";
const $467b0c242e1785f3$export$5390c682c808c396 = "area";
const $467b0c242e1785f3$export$d7b89ebffc081000 = "street";
const $467b0c242e1785f3$export$8e0b95edb3ba99d6 = "building";


var $dc7b2e3ac4b2ef1f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $dc7b2e3ac4b2ef1f$export$a4bb87c7927e3d30 = /** @class */ function(_super) {
    $dc7b2e3ac4b2ef1f$var$__extends(ViewDisposalModal, _super);
    function ViewDisposalModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.doModalClose = function() {
            _this.props.close();
        };
        return _this;
    }
    ViewDisposalModal.prototype.getLocationName = function(member) {
        switch(member.type){
            case 0, $467b0c242e1785f3$export$6ff90bb23a7ae4cb:
                return member.region;
            case 0, $467b0c242e1785f3$export$2f58ab114ec80e81:
                return "".concat(member.city, ", ").concat(member.region);
            case 0, $467b0c242e1785f3$export$5390c682c808c396:
                return "".concat(member.area, ", ").concat(member.city, ", ").concat(member.region);
            case 0, $467b0c242e1785f3$export$d7b89ebffc081000:
                return "".concat(member.street, ", ").concat(member.area, ", ").concat(member.city, ", ").concat(member.region);
            case 0, $467b0c242e1785f3$export$8e0b95edb3ba99d6:
                return "".concat(member.building, ", ").concat(member.street, ", ").concat(member.area, ", ").concat(member.city, ", ").concat(member.region);
            default:
                return null;
        }
    };
    ViewDisposalModal.prototype.getDataBlock = function(props) {
        return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mb-3"
        }, (0, $LjoDx.h)("h4", {
            class: "view-withdrawal__data__label"
        }, "Agent Involved"), (0, $LjoDx.h)("b", {
            class: "view-withdrawal__data__value"
        }, props.disposal.agentInvolved)), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mb-3"
        }, (0, $LjoDx.h)("h4", {
            class: "view-withdrawal__data__label"
        }, "Location"), (0, $LjoDx.h)("b", {
            class: "view-withdrawal__data__value"
        }, this.getLocationName(props.disposal.location))), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mb-3"
        }, (0, $LjoDx.h)("h4", {
            class: "view-withdrawal__data__label"
        }, "Total Value"), (0, $LjoDx.h)("b", {
            class: "view-withdrawal__data__value"
        }, "₱ ", (0, $1b4d8647546ef02f$exports.getDisposalValue)(props.disposal))), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 mb-3"
        }, (0, $LjoDx.h)("h4", {
            class: "view-withdrawal__data__label"
        }, "Date Created"), (0, $LjoDx.h)("b", {
            class: "view-withdrawal__data__value"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(props.disposal.dateCreated).format((0, $6ac96fa96dbfc52a$export$8132710d1930b03e).dateWorded))));
    };
    ViewDisposalModal.prototype.getBrandRow = function(brand, index, length) {
        var value = 0;
        value += brand.numOfCases * (0, $6ac96fa96dbfc52a$export$117ed8e927f4bd45) * brand.pricePerReam;
        if (brand.numOfReams) value += brand.numOfReams * brand.pricePerReam;
        // value += (brand.numOfPacks / PACKS_PER_REAM) * brand.pricePerReam;
        return (0, $LjoDx.h)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("view-withdrawal__brands__grid__row", {
                "last": index === length - 1
            })
        }, (0, $LjoDx.h)("div", {
            class: "view-withdrawal__brands__grid__col"
        }, brand.name), (0, $LjoDx.h)("div", {
            class: "view-withdrawal__brands__grid__col"
        }, brand.numOfCases ? brand.numOfCases : 0), (0, $LjoDx.h)("div", {
            class: "view-withdrawal__brands__grid__col"
        }, brand.numOfReams ? brand.numOfReams : 0), (0, $LjoDx.h)("div", {
            class: "view-withdrawal__brands__grid__col"
        }, brand.numOfPacks ? brand.numOfPacks : 0), (0, $LjoDx.h)("div", {
            class: "view-withdrawal__brands__grid__col last"
        }, brand.pricePerReam));
    };
    ViewDisposalModal.prototype.getBrandsBlock = function(props) {
        var _this = this;
        var brands = props.disposal.brandBreakdown;
        return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row mb-4"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-3 view-withdrawal__brands__grid"
        }, (0, $LjoDx.h)("div", {
            class: "view-withdrawal__brands__grid__row header"
        }, (0, $LjoDx.h)("div", {
            class: "view-withdrawal__brands__grid__col view-withdrawal__brands__grid__header"
        }, "Brand"), (0, $LjoDx.h)("div", {
            class: "view-withdrawal__brands__grid__col view-withdrawal__brands__grid__header"
        }, "# of Cases"), (0, $LjoDx.h)("div", {
            class: "view-withdrawal__brands__grid__col view-withdrawal__brands__grid__header"
        }, "# of Reams"), (0, $LjoDx.h)("div", {
            class: "view-withdrawal__brands__grid__col view-withdrawal__brands__grid__header"
        }, "# of Packs"), (0, $LjoDx.h)("div", {
            class: "view-withdrawal__brands__grid__col view-withdrawal__brands__grid__header"
        }, "Price per Ream")), brands.map(function(brand, index) {
            return _this.getBrandRow(brand, index, brands.length);
        })))));
    };
    // onReeditDecline = () => {
    //   const store = getStore();
    //   store.dispatch({
    //     type: REEDIT_DECLINE_WITHDRAWAL,
    //     payload: {
    //       withdrawalId: this.props.withdrawal.withdrawalId
    //     }
    //   });
    //   this.props.close();
    // }
    // onReeditAccept = () => {
    //   const store = getStore();
    //   store.dispatch({
    //     type: REEDIT_ACCEPT_WITHDRAWAL,
    //     payload: {
    //       withdrawalId: this.props.withdrawal.withdrawalId
    //     }
    //   });
    //   this.props.close();
    // }
    // onApprove = () => {
    //   const store = getStore();
    //   store.dispatch({
    //     type: APPROVE_WITHDRAWAL,
    //     payload: {
    //       withdrawalId: this.props.withdrawal.withdrawalId
    //     }
    //   });
    //   this.props.close();
    // }
    // onReject = () => {
    //   const store = getStore();
    //   store.dispatch({
    //     type: REJECT_WITHDRAWAL,
    //     payload: {
    //       withdrawalId: this.props.withdrawal.withdrawalId
    //     }
    //   });
    //   this.props.close();
    // }
    // onManagementReedit = () => {
    //   this.props.close({
    //     changeMode: MODAL_CHANGE_WITHDRAWAL_REEDIT
    //   });
    // }
    // onChangeStage = () => {
    //   this.props.close({
    //     changeMode: MODAL_CHANGE_WITHDRAWAL_STAGE
    //   });
    // }
    // getActionsRow(props: ViewDisposalModalProps, state: ViewDisposalModalState) {
    //   if (props.withdrawal.status === WITHDRAWAL_STATUS_REEDIT) {
    //     return (
    //       <div class="col-12">
    //         <div class="row">
    //           <div class="col-12 col-lg-3 offset-lg-6">
    //             <button class="btn btn-danger w-100"
    //               onClick={this.onReeditDecline}>
    //               Decline
    //             </button>
    //           </div>
    //           <div class="col-12 col-lg-3">
    //             <button class="btn btn-primary w-100"
    //               onClick={this.onReeditAccept}>
    //               Accept
    //             </button>
    //           </div>
    //         </div>
    //       </div>
    //     );
    //   } else if (props.currentUser.role === ROLE_MANAGEMENT) {
    //     if (props.withdrawal.status === WITHDRAWAL_STATUS_PENDING || 
    //       props.withdrawal.status === WITHDRAWAL_STATUS_REEDIT_ACCEPTED) {
    //       return (
    //         <div class="col-12">
    //           <div class="row">
    //             <div class="col-12 col-lg-3 offset-lg-3">
    //               <button class="btn btn-danger w-100"
    //                 onClick={this.onReject}>
    //                 Reject
    //               </button>
    //             </div>
    //             <div class="col-12 col-lg-3">
    //               <button class="btn btn-outline-dark w-100"
    //                 onClick={this.onManagementReedit}>
    //                 Re-Edit
    //               </button>
    //             </div>
    //             <div class="col-12 col-lg-3">
    //               <button class="btn btn-primary w-100"
    //                 onClick={this.onApprove}>
    //                 Approve
    //               </button>
    //             </div>
    //           </div>
    //         </div>
    //       );
    //     } else if (props.withdrawal.status === WITHDRAWAL_STATUS_APPROVED) {
    //       return (
    //         <div class="col-12">
    //           <div class="row">
    //             <div class="col-12 col-lg-3 offset-lg-9">
    //               <button class="btn btn-primary w-100"
    //                 onClick={this.onChangeStage}>
    //                 Change Stage
    //               </button>
    //             </div>
    //           </div>
    //         </div>
    //       );
    //     }
    //   } else {
    //     return (
    //       <div>
    //       </div>
    //     );
    //   }
    // }
    ViewDisposalModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Disposal Details")), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, this.getDataBlock(props), (0, $LjoDx.h)("hr", null), this.getBrandsBlock(props))));
    };
    return ViewDisposalModal;
}((0, $3f2ba7f1e3532510$exports.Modal));



var $5443ecefee3f6061$exports = {};

$parcel$export($5443ecefee3f6061$exports, "CreateDisposalModal", () => $5443ecefee3f6061$export$d6aff1bf3c012d53);

var $LjoDx = parcelRequire("LjoDx");














var $32bb41b2d7befcc7$exports = {};

$parcel$export($32bb41b2d7befcc7$exports, "AutocompleteLocation", () => $32bb41b2d7befcc7$export$fe80836ed288d0c4);

var $LjoDx = parcelRequire("LjoDx");






var $32bb41b2d7befcc7$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $32bb41b2d7befcc7$export$fe80836ed288d0c4 = /** @class */ function(_super) {
    $32bb41b2d7befcc7$var$__extends(AutocompleteLocation, _super);
    function AutocompleteLocation(props) {
        var _this = _super.call(this, props) || this;
        _this.onOutsideClick = function(ev) {
            var target = ev.target;
            var doesContain = _this.refNode.contains(target);
            if (!doesContain) _this.setState({
                isSearchResultsVisible: false
            });
        };
        _this.onSearchInputChange = (0, $8cf160f30389af36$export$61fc7d43ac8f84b0)(function(event) {
            var searchTerm = event.target.value;
            if (searchTerm && searchTerm.length >= 2) _this.getSearchResults(searchTerm);
            _this.setState({
                search: searchTerm
            });
        }, 500);
        _this.onResultClick = function(result) {
            var label = result.name;
            _this.setState({
                search: label,
                searchResults: [],
                isSearchResultsVisible: false
            });
            _this.props.onResultSelected(result);
        };
        _this.setState({
            searchResults: []
        });
        if (props.initialValue) _this.setState({
            search: props.initialValue
        });
        return _this;
    }
    AutocompleteLocation.prototype.componentDidMount = function() {
        document.body.addEventListener("mousedown", this.onOutsideClick, false);
    };
    AutocompleteLocation.prototype.componentWillUnmount = function() {
        document.body.removeEventListener("mousedown", this.onOutsideClick, false);
    };
    AutocompleteLocation.prototype.getSearchResults = function(searchTerm) {
        var _this = this;
        var params = {
            searchString: searchTerm
        };
        var axiosPromise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/location/search"), {
            params: params,
            withCredentials: true
        });
        axiosPromise.then(function(response) {
            var results = response.data.results;
            if (results && results.length > 0) _this.setState({
                searchResults: results,
                isSearchResultsVisible: true
            });
        }).catch(function(errResp) {
            var message = errResp.response.data.msg ? errResp.response.data.msg : null;
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to retrieve search",
                message: message,
                duration: 3000
            });
        });
    };
    AutocompleteLocation.prototype.getLocationName = function(member) {
        switch(member.type){
            case 0, $467b0c242e1785f3$export$6ff90bb23a7ae4cb:
                return member.region;
            case 0, $467b0c242e1785f3$export$2f58ab114ec80e81:
                return "".concat(member.city, ", ").concat(member.region);
            case 0, $467b0c242e1785f3$export$5390c682c808c396:
                return "".concat(member.area, ", ").concat(member.city, ", ").concat(member.region);
            case 0, $467b0c242e1785f3$export$d7b89ebffc081000:
                return "".concat(member.street, ", ").concat(member.area, ", ").concat(member.city, ", ").concat(member.region);
            case 0, $467b0c242e1785f3$export$8e0b95edb3ba99d6:
                return "".concat(member.building, ", ").concat(member.street, ", ").concat(member.area, ", ").concat(member.city, ", ").concat(member.region);
            default:
                return null;
        }
    };
    AutocompleteLocation.prototype.render = function(props, state) {
        var _this = this;
        var result = function(member, index) {
            return (0, $LjoDx.h)("p", {
                onClick: _this.onResultClick.bind(_this, member)
            }, _this.getLocationName(member));
        };
        return (0, $LjoDx.h)("div", {
            class: "autocomplete-search",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("autocomplete-search__input form-control"),
            disabled: props.disabled,
            placeholder: "Search for a location",
            value: state.search,
            onInput: this.onSearchInputChange.bind(this)
        }), (0, $LjoDx.h)("span", {
            class: "autocomplete-search__icon"
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-search"
        })), (0, $LjoDx.h)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("autocomplete-search__results", {
                active: state.isSearchResultsVisible
            })
        }, this.state.searchResults.map(function(member, i) {
            return result(member, i);
        })));
    };
    return AutocompleteLocation;
}((0, $LjoDx.Component));




var $5443ecefee3f6061$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5443ecefee3f6061$export$d6aff1bf3c012d53 = /** @class */ function(_super) {
    $5443ecefee3f6061$var$__extends(CreateDisposalModal, _super);
    function CreateDisposalModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onToggleForm = function(toggleState) {
            _this.setState({
                isFormVisible: toggleState ? toggleState : !_this.state.isFormVisible
            });
        };
        _this.onLocationSearchChange = function(location) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.disposalForm, "location", location.locationId);
        };
        _this.onAddBrand = function() {
            var form = _this.state.disposalForm;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var selectedBrand = _this.state.brandPrices.find(function(member) {
                return member.brandName === form.fields["name"].value;
            });
            var brand = {
                name: form.fields["name"].value,
                brandPriceId: selectedBrand.brandId,
                numOfCases: Number.parseInt(form.fields["numOfCases"].value),
                numOfReams: Number.parseInt(form.fields["numOfReams"].value),
                numOfPacks: Number.parseInt(form.fields["numOfPacks"].value),
                pricePerReam: _this.getPrice()
            };
            var found = _this.state.brands.find(function(brandMember) {
                return brand.name === brandMember.name;
            });
            if (found) (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to add brand",
                message: "This brand already exists in current group.",
                duration: 3000,
                type: (0, $7a4e6c0902e6b5c3$export$78870863d853b399)
            });
            else _this.state.brands.push(brand);
            _this.forceUpdate();
        };
        _this.onEditBrand = function(brand, index) {
            var form = _this.state.disposalForm;
            form.fields["name"].value = brand.name;
            form.fields["numOfCases"].value = brand.numOfCases ? brand.numOfCases : 0;
            form.fields["numOfReams"].value = brand.numOfReams ? brand.numOfReams : 0;
            form.fields["numOfPacks"].value = brand.numOfPacks ? brand.numOfPacks : 0;
            _this.setState({
                isEditing: true,
                currentlySelectedBrandIndex: index
            });
        };
        _this.onRemoveBrand = function(index) {
            var brands = _this.state.brands;
            brands.splice(index, 1);
            _this.forceUpdate();
        };
        _this.onCompleteEdit = function() {
            var form = _this.state.disposalForm;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var selectedBrand = _this.state.brandPrices.find(function(member) {
                return member.brandName === form.fields["name"].value;
            });
            var brand = {
                name: form.fields["name"].value,
                brandPriceId: selectedBrand.brandId,
                numOfCases: Number.parseInt(form.fields["numOfCases"].value),
                numOfReams: Number.parseInt(form.fields["numOfReams"].value),
                numOfPacks: Number.parseInt(form.fields["numOfPacks"].value),
                pricePerReam: _this.getPrice()
            };
            var currentBrandIndex = _this.state.currentlySelectedBrandIndex;
            _this.state.brands[currentBrandIndex] = brand;
            _this.setState({
                isEditing: false,
                currentlySelectedBrandIndex: -1
            });
        };
        _this.onSubmit = function() {
            var form = _this.state.disposalForm;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            _this.setState({
                disposalForm: form
            });
            if (!_this.state.disposalForm.isValid) return;
            var disposal = {
                agentInvolved: form.fields["agentInvolved"].value,
                brandBreakdown: _this.state.brands,
                supervisor: _this.props.currentUser.supervisor.supervisorId,
                locationId: form.fields["location"].value,
                dateDisposed: form.fields["dateDisposed"].value
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $5dbd95920940fbf7$export$39abb8eb105ebb6e),
                payload: {
                    disposalToCreate: disposal
                }
            });
        };
        _this.onCreateLocation = function() {
            _this.props.close({
                changeMode: (0, $1b4d8647546ef02f$exports.MODAL_CHANGE_CREATE_LOCATION)
            });
        };
        _this.onDateSelected = function(date) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.disposalForm, "dateDisposed", date);
        };
        _this.setState({
            brands: []
        });
        _this.createForm();
        return _this;
    }
    CreateDisposalModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "agentInvolved": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "location": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "name": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "numOfCases": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "numOfReams": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "numOfPacks": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "dateDisposed": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            disposalForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["disposalForm"] = form;
            _this.setState(state);
        });
    };
    CreateDisposalModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var withdrawal$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.withdrawal;
        }));
        this.subs.push(withdrawal$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(withdrawal) {
            return withdrawal.brandPrices;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(prices) {
            _this.setState({
                brandPrices: prices
            });
        }));
        var disposal$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.disposal;
        }));
        this.subs.push(disposal$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(disposal) {
            return disposal.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
        }));
        this.initialStoreDispatches();
    };
    CreateDisposalModal.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $0aa7832c96ad7a8d$export$8a851eeafd335d3f)
        });
    };
    CreateDisposalModal.prototype.getPrice = function() {
        var form = this.state.disposalForm;
        var brand = this.state.brandPrices.find(function(member) {
            return member.brandName === form.fields["name"].value;
        });
        return brand.pricePerReam;
    };
    CreateDisposalModal.prototype.getBrandCard = function(brand, index, length) {
        var _this = this;
        var value = 0;
        if (brand.numOfCases) value += brand.numOfCases * (0, $6ac96fa96dbfc52a$export$117ed8e927f4bd45) * brand.pricePerReam;
        if (brand.numOfReams) value += brand.numOfReams * brand.pricePerReam;
        if (brand.numOfPacks) value += brand.numOfPacks / (0, $6ac96fa96dbfc52a$export$ec5ef886be2edbb8) * brand.pricePerReam;
        return (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mb-2"
        }, (0, $LjoDx.h)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("container-fluid create-withdrawal-modal__form__brand-card py-2", {
                "editing": index === this.state.currentlySelectedBrandIndex
            })
        }, (0, $LjoDx.h)("div", {
            class: "row mt-2"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__name"
        }, brand.name)), (0, $LjoDx.h)("div", {
            class: "col-4"
        }, (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__label"
        }, "Cases"), (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__value"
        }, brand.numOfCases ? brand.numOfCases : 0)), (0, $LjoDx.h)("div", {
            class: "col-4"
        }, (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__label"
        }, "Reams"), (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__value"
        }, brand.numOfReams ? brand.numOfReams : 0)), (0, $LjoDx.h)("div", {
            class: "col-4"
        }, (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__label"
        }, "Packs"), (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__value"
        }, brand.numOfPacks ? brand.numOfPacks : 0))), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-6"
        }, (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__label"
        }, "Price per Ream"), (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__value"
        }, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(brand.pricePerReam))), (0, $LjoDx.h)("div", {
            class: "col-6"
        }, (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__label"
        }, "Total Value"), (0, $LjoDx.h)("div", {
            class: "create-withdrawal-modal__form__brand-card__value"
        }, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(value)))), (0, $LjoDx.h)("div", {
            class: "row mt-2"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: function() {
                return _this.onEditBrand(brand, index);
            }
        }, "Edit")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-2 mt-lg-0"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: function() {
                return _this.onRemoveBrand(index);
            }
        }, "Remove")))));
    };
    CreateDisposalModal.prototype.getFormActionRow = function(state) {
        if (state.isEditing) return (0, $LjoDx.h)("button", {
            class: "btn btn-outline-primary w-100",
            onClick: this.onCompleteEdit
        }, "Edit Brand");
        else return (0, $LjoDx.h)("button", {
            class: "btn btn-outline-primary w-100",
            onClick: this.onAddBrand
        }, "Add Brand");
    };
    CreateDisposalModal.prototype.getFormBlock = function(props, state) {
        var _this = this;
        if (state.brandPrices) {
            var form = state.disposalForm;
            var brands_1 = state.brands;
            return (0, $LjoDx.h)("div", {
                class: "row"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 create-withdrawal-modal__form"
            }, (0, $LjoDx.h)("div", {
                class: "row"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 mt-3"
            }, (0, $LjoDx.h)("label", {
                class: "anglo-remittance__submit-form__label"
            }, "Sales Agent*"), (0, $LjoDx.h)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                    "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["agentInvolved"])
                }),
                type: "text",
                value: form.fields["agentInvolved"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "agentInvolved"),
                placeholder: "Agent name"
            }))), (0, $LjoDx.h)("div", {
                class: "row"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 mt-3"
            }, (0, $LjoDx.h)("label", {
                class: "anglo-remittance__submit-form__label"
            }, "Location*"), (0, $LjoDx.h)((0, $32bb41b2d7befcc7$exports.AutocompleteLocation), {
                onResultSelected: this.onLocationSearchChange
            }))), (0, $LjoDx.h)("div", {
                class: "row mt-2"
            }, (0, $LjoDx.h)("div", {
                class: "col-12"
            }, (0, $LjoDx.h)("div", {
                class: "create-disposal-modal__new-location"
            }, (0, $LjoDx.h)("small", null, "Can't find the location of your disposal?"), (0, $LjoDx.h)("button", {
                class: "create-disposal-modal__new-location-button",
                onClick: this.onCreateLocation
            }, "Click here to add a new location")))), (0, $LjoDx.h)("div", {
                class: "row mt-2"
            }, (0, $LjoDx.h)("div", {
                class: "col-12"
            }, (0, $LjoDx.h)("label", {
                class: "anglo-remittance__submit-form__label"
            }, "Date Disposed*"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
                onDateSelected: this.onDateSelected,
                isValid: $fc45e937e6d1b794$export$7c1f5a29b59be526(form.fields["dateDisposed"]),
                isPristine: form.fields["dateDisposed"].isPristine
            }))), (0, $LjoDx.h)("hr", null), (0, $LjoDx.h)("div", {
                class: "row"
            }, brands_1.map(function(member, index) {
                return _this.getBrandCard(member, index, brands_1.length);
            })), (0, $LjoDx.h)("div", {
                class: "row create-withdrawal-modal__form__brand py-3"
            }, (0, $LjoDx.h)("div", {
                class: "col-12"
            }, (0, $LjoDx.h)("label", {
                class: "anglo-remittance__submit-form__label"
            }, "Brand Name*"), (0, $LjoDx.h)("select", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                    "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["name"])
                }),
                placeholder: "Brand Name",
                value: form.fields["name"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "name")
            }, (0, $LjoDx.h)("option", {
                class: "text-muted",
                value: "",
                disabled: true,
                selected: true
            }, "Select Brand"), props.currentUser.supervisor.currentStock.map(function(price) {
                return (0, $LjoDx.h)("option", {
                    value: price.name
                }, price.name, " - ₱ ", price.pricePerReam);
            }))), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-4 mt-3"
            }, (0, $LjoDx.h)("label", {
                class: "anglo-remittance__submit-form__label"
            }, "Number of Cases"), (0, $LjoDx.h)("input", {
                class: "form-control",
                type: "text",
                onInput: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "numOfCases"),
                value: form.fields["numOfCases"].value,
                placeholder: "# of Cases"
            })), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-4 mt-3"
            }, (0, $LjoDx.h)("label", {
                class: "anglo-remittance__submit-form__label"
            }, "Number of Reams"), (0, $LjoDx.h)("input", {
                class: "form-control",
                type: "text",
                onInput: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "numOfReams"),
                value: form.fields["numOfReams"].value,
                placeholder: "# of Reams"
            })), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-4 mt-3"
            }, (0, $LjoDx.h)("label", {
                class: "anglo-remittance__submit-form__label"
            }, "Number of Packs"), (0, $LjoDx.h)("input", {
                class: "form-control",
                type: "text",
                onInput: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "numOfPacks"),
                value: form.fields["numOfPacks"].value,
                placeholder: "# of Packs"
            })), (0, $LjoDx.h)("div", {
                class: "col-6 col-lg-3 offset-6 offset-lg-9 mt-3"
            }, this.getFormActionRow(state)))));
        }
    };
    CreateDisposalModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return this.getSpinnerBlock();
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !state.disposalForm.isValid
        }, "Submit Disposal"))));
    };
    CreateDisposalModal.prototype.getSpinnerBlock = function() {
        return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    CreateDisposalModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-disposal-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create Disposal")), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions mt-3"
        }, this.getActionsRow(props, state)));
    };
    return CreateDisposalModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $6e75590a903a2f1a$exports = {};

$parcel$export($6e75590a903a2f1a$exports, "CreateLocationModal", () => $6e75590a903a2f1a$export$b4536acfb72e8fee);

var $LjoDx = parcelRequire("LjoDx");











var $6e75590a903a2f1a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6e75590a903a2f1a$export$b4536acfb72e8fee = /** @class */ function(_super) {
    $6e75590a903a2f1a$var$__extends(CreateLocationModal, _super);
    function CreateLocationModal() {
        var _this = _super.call(this) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.isBuildingValidator = function(field, form) {
            if (form.fields["type"].value === (0, $467b0c242e1785f3$export$8e0b95edb3ba99d6)) return field.value ? true : false;
        };
        _this.isStreetValidator = function(field, form) {
            if (form.fields["type"].value === (0, $467b0c242e1785f3$export$d7b89ebffc081000)) return field.value ? true : false;
        };
        _this.isAreaValidator = function(field, form) {
            if (form.fields["type"].value === (0, $467b0c242e1785f3$export$d7b89ebffc081000) || form.fields["type"].value === (0, $467b0c242e1785f3$export$5390c682c808c396)) return field.value ? true : false;
        };
        _this.isCityValidator = function(field, form) {
            if (form.fields["type"].value === (0, $467b0c242e1785f3$export$2f58ab114ec80e81)) return field.value ? true : false;
        };
        _this.isRegionValidator = function(field, form) {
            if (form.fields["type"].value === (0, $467b0c242e1785f3$export$d7b89ebffc081000) || form.fields["type"].value === (0, $467b0c242e1785f3$export$5390c682c808c396) || form.fields["type"].value === (0, $467b0c242e1785f3$export$2f58ab114ec80e81) || form.fields["type"].value === (0, $467b0c242e1785f3$export$6ff90bb23a7ae4cb)) return field.value ? true : false;
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            if (!_this.isFormValid(form)) return;
            var location = {
                // name: this.getLocationName(form),
                name: form.fields["name"].value,
                region: form.fields["region"].value,
                city: form.fields["city"].value,
                area: form.fields["area"].value,
                street: form.fields["street"].value,
                building: form.fields["building"].value,
                type: form.fields["type"].value
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $5dbd95920940fbf7$export$d80ec8aacf18617a),
                payload: {
                    locationToCreate: location
                }
            });
        };
        _this.createForm();
        return _this;
    }
    CreateLocationModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var disposal$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.disposal;
        }));
        this.subs.push(disposal$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(withdrawal) {
            return withdrawal.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
            else _this.setState({
                isPostInProgress: false
            });
        }));
    };
    CreateLocationModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "type": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "region": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [
                this.isRegionValidator
            ], ""),
            "city": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [
                this.isCityValidator
            ], ""),
            "area": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [
                this.isAreaValidator
            ], ""),
            "street": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [
                this.isStreetValidator
            ], ""),
            "building": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [
                this.isBuildingValidator
            ], ""),
            "name": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            $fc45e937e6d1b794$export$ed692cabb252e59b(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    CreateLocationModal.prototype.isRegionVisible = function(form) {
        var type = form.fields["type"].value;
        switch(type){
            case 0, $467b0c242e1785f3$export$6ff90bb23a7ae4cb:
            case 0, $467b0c242e1785f3$export$2f58ab114ec80e81:
            case 0, $467b0c242e1785f3$export$5390c682c808c396:
            case 0, $467b0c242e1785f3$export$d7b89ebffc081000:
            case 0, $467b0c242e1785f3$export$8e0b95edb3ba99d6:
                return true;
            default:
                return false;
        }
    };
    CreateLocationModal.prototype.isCityVisible = function(form) {
        var type = form.fields["type"].value;
        switch(type){
            case 0, $467b0c242e1785f3$export$2f58ab114ec80e81:
            case 0, $467b0c242e1785f3$export$5390c682c808c396:
            case 0, $467b0c242e1785f3$export$d7b89ebffc081000:
            case 0, $467b0c242e1785f3$export$8e0b95edb3ba99d6:
                return true;
            default:
                return false;
        }
    };
    CreateLocationModal.prototype.isAreaVisible = function(form) {
        var type = form.fields["type"].value;
        switch(type){
            case 0, $467b0c242e1785f3$export$5390c682c808c396:
            case 0, $467b0c242e1785f3$export$d7b89ebffc081000:
            case 0, $467b0c242e1785f3$export$8e0b95edb3ba99d6:
                return true;
            default:
                return false;
        }
    };
    CreateLocationModal.prototype.isStreetVisible = function(form) {
        var type = form.fields["type"].value;
        switch(type){
            case 0, $467b0c242e1785f3$export$d7b89ebffc081000:
            case 0, $467b0c242e1785f3$export$8e0b95edb3ba99d6:
                return true;
            default:
                return false;
        }
    };
    CreateLocationModal.prototype.isBuildingVisible = function(form) {
        var type = form.fields["type"].value;
        switch(type){
            case 0, $467b0c242e1785f3$export$8e0b95edb3ba99d6:
                return true;
            default:
                return false;
        }
    };
    CreateLocationModal.prototype.isFormValid = function(form) {
        $fc45e937e6d1b794$export$ed692cabb252e59b(form);
        return form.isValid;
    };
    CreateLocationModal.prototype.getLocationName = function(form) {
        var type = form.fields["type"].value;
        switch(type){
            case 0, $467b0c242e1785f3$export$6ff90bb23a7ae4cb:
                return form.fields["region"].value;
            case 0, $467b0c242e1785f3$export$2f58ab114ec80e81:
                return form.fields["city"].value;
            case 0, $467b0c242e1785f3$export$5390c682c808c396:
                return form.fields["area"].value;
            case 0, $467b0c242e1785f3$export$d7b89ebffc081000:
                return form.fields["street"].value;
            case 0, $467b0c242e1785f3$export$8e0b95edb3ba99d6:
                return form.fields["building"].value;
            default:
                return null;
        }
    };
    CreateLocationModal.prototype.getLocationFieldSetsBlock = function(state) {
        var form = state.form;
        return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, this.getRegionBlock(form), this.getCityBlock(form), this.getAreaBlock(form), this.getStreetBlock(form), this.getBuildingBlock(form), this.getNameBlock(form)));
    };
    CreateLocationModal.prototype.getRegionBlock = function(form) {
        if (this.isRegionVisible(form)) return (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 col-lg-4 mb-2"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Region*"), (0, $LjoDx.h)("input", {
            class: "form-control",
            type: "text",
            onInput: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "region"),
            value: form.fields["region"].value,
            placeholder: "Region Name"
        }));
        return null;
    };
    CreateLocationModal.prototype.getCityBlock = function(form) {
        if (this.isCityVisible(form)) return (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 col-lg-4 mb-2"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "City"), (0, $LjoDx.h)("input", {
            class: "form-control",
            type: "text",
            onInput: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "city"),
            value: form.fields["city"].value,
            placeholder: "City Name"
        }));
        return null;
    };
    CreateLocationModal.prototype.getAreaBlock = function(form) {
        if (this.isAreaVisible(form)) return (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 col-lg-4 mb-2"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Area/Barangay*"), (0, $LjoDx.h)("input", {
            class: "form-control",
            type: "text",
            onInput: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "area"),
            value: form.fields["area"].value,
            placeholder: "Area or Barangay Name"
        }));
        return null;
    };
    CreateLocationModal.prototype.getStreetBlock = function(form) {
        if (this.isStreetVisible(form)) return (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 col-lg-4 mb-2"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Street Address*"), (0, $LjoDx.h)("input", {
            class: "form-control",
            type: "text",
            onInput: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "street"),
            value: form.fields["street"].value,
            placeholder: "Lot or Street Address"
        }));
        return null;
    };
    CreateLocationModal.prototype.getBuildingBlock = function(form) {
        if (this.isBuildingVisible(form)) return (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 col-lg-4 mb-2"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Area/Barangay*"), (0, $LjoDx.h)("input", {
            class: "form-control",
            type: "text",
            onInput: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "city"),
            value: form.fields["city"].value,
            placeholder: "Area or Barangay Name"
        }));
        return null;
    };
    CreateLocationModal.prototype.getNameBlock = function(form) {
        if (form.fields["type"].value) return (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 col-lg-4 mb-2"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Location Name*"), (0, $LjoDx.h)("input", {
            class: "form-control",
            type: "text",
            onInput: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "name"),
            value: form.fields["name"].value,
            placeholder: "Location Name"
        }));
        return null;
    };
    CreateLocationModal.prototype.getSpinnerBlock = function() {
        return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    CreateLocationModal.prototype.getActionsBlock = function(state) {
        var form = state.form;
        if (!state.isPostInProgress) {
            if (form.fields["type"].value) return (0, $LjoDx.h)("div", {
                class: "col-12"
            }, (0, $LjoDx.h)("div", {
                class: "row"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3 offset-lg-9"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-primary w-100",
                onClick: this.onSubmit,
                disabled: !this.isFormValid(form)
            }, "Submit Location"))));
        } else return this.getSpinnerBlock();
        return null;
    };
    CreateLocationModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create Location")), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("i", null, "Note: As of February 2021, it is preferred to select ", (0, $LjoDx.h)("b", null, "AREA/BARANGGAY"), " type when adding a new location."))), (0, $LjoDx.h)("hr", null), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Location Type*"), (0, $LjoDx.h)("select", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": $fc45e937e6d1b794$export$7c1f5a29b59be526(state.form.fields["type"])
            }),
            placeholder: "First select a location type",
            value: state.form.fields["type"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, state.form, "type")
        }, (0, $LjoDx.h)("option", {
            value: (0, $467b0c242e1785f3$export$8e0b95edb3ba99d6)
        }, "Building"), (0, $LjoDx.h)("option", {
            value: (0, $467b0c242e1785f3$export$d7b89ebffc081000)
        }, "Street Address"), (0, $LjoDx.h)("option", {
            value: (0, $467b0c242e1785f3$export$5390c682c808c396)
        }, "Area/Barangay"), (0, $LjoDx.h)("option", {
            value: (0, $467b0c242e1785f3$export$2f58ab114ec80e81)
        }, "City"), (0, $LjoDx.h)("option", {
            value: (0, $467b0c242e1785f3$export$6ff90bb23a7ae4cb)
        }, "Region")))), (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, this.getLocationFieldSetsBlock(state)), (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, this.getActionsBlock(state)))));
    };
    return CreateLocationModal;
}((0, $3f2ba7f1e3532510$exports.Modal));








var $1b4d8647546ef02f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1b4d8647546ef02f$export$9a8b7be01e798073 = "create-location";
function $1b4d8647546ef02f$export$4a115427c4247518(disposal) {
    var value = 0;
    disposal.brandBreakdown.forEach(function(member) {
        if (member.numOfCases) value += member.numOfCases * 50 * member.pricePerReam;
        if (member.numOfReams) value += member.numOfReams * member.pricePerReam;
        if (member.numOfPacks) value += member.numOfPacks / 10 * member.pricePerReam;
    });
    return (0, $9e0c3e3a397653e5$export$a81f732198733497)(value);
}
var $1b4d8647546ef02f$export$26f3e80c50f8ceda = /** @class */ function(_super) {
    $1b4d8647546ef02f$var$__extends(DashDisposals, _super);
    function DashDisposals(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.MODAL_CREATE_DISPOSAL = 0;
        _this.MODAL_VIEW_DETAILS = 1;
        _this.MODAL_REVIEW_CURRENT_STOCKS = 2;
        _this.MODAL_CREATE_LOCATION = 3;
        _this.onModalOpened = function(paramState) {
            _this.setState({
                modalState: paramState
            });
        };
        _this.onViewDetails = function(disposal) {
            _this.setState({
                selectedDisposal: disposal
            });
            _this.onModalOpened(_this.MODAL_VIEW_DETAILS);
        };
        _this.onPageClicked = function(page) {
            var filterForm = {};
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) // filters.set(k, fieldList[k].value);
            filterForm[k] = fieldList[k].value;
            filterForm["page"] = page;
            var filters = _this.state.filters;
            filters.set("page", page);
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $5dbd95920940fbf7$export$ccf130fa81c04150),
                payload: {
                    filters: filters
                }
            });
            _this.setState({
                currentPage: page
            });
        };
        _this.getBrandsDisposed = function(disposal) {
            var brands = "";
            for(var count = 0; count < disposal.brandBreakdown.length; count++){
                if (count > 0) brands = brands.concat(", ");
                brands = brands.concat(disposal.brandBreakdown[count].name);
            }
            return brands;
        };
        _this.onModalClose = function(returnParms) {
            _this.setState({
                modalState: -1
            });
            if (returnParms) {
                if (returnParms.changeMode && returnParms.changeMode === $1b4d8647546ef02f$export$9a8b7be01e798073) _this.onModalOpened(_this.MODAL_CREATE_LOCATION);
            }
            _this.initialStoreDispatches();
        };
        _this.onFilterToggleClicked = function() {
            _this.setState({
                isFilterVisible: !_this.state.isFilterVisible
            });
        };
        _this.onSupervisorSearchChange = function(supervisor) {
            console.log(supervisor);
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filterForm, "supervisor", supervisor.supervisor.supervisorId);
        };
        _this.onLocationSearchChange = function(location) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filterForm, "location", location.locationId);
        };
        _this.startDateSelected = function(date) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filterForm, "startDate", date);
        };
        _this.resetStartDates = function(returned) {
            _this.resetStartDate = returned;
        };
        _this.resetEndDates = function(returned) {
            _this.resetEndDate = returned;
        };
        _this.applyFilters = function() {
            var filters = _this.state.filters;
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filters.set(k, fieldList[k].value);
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $5dbd95920940fbf7$export$ccf130fa81c04150),
                payload: {
                    filters: filters
                }
            });
        };
        _this.resetFilters = function() {
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)fieldList[k].value = null;
            _this.resetStartDate();
            _this.resetEndDate();
            var filters = new Map();
            filters.set("page", 1);
            _this.setState({
                filters: filters,
                currentPage: 1
            });
            if (_this.state.currentUser.role === (0, $b9c3387011d11553$export$819e975c5d2910e9)) _this.state.filters.set("supervisor", _this.state.currentUser.supervisor.supervisorId);
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $5dbd95920940fbf7$export$ccf130fa81c04150),
                payload: {
                    filters: filters
                }
            });
        };
        _this.getPortalModal = function(state) {
            var modalState = state.modalState;
            if (modalState < 0) return null;
            else if (modalState === _this.MODAL_CREATE_DISPOSAL) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-124"
            }, (0, $LjoDx.h)((0, $5443ecefee3f6061$exports.CreateDisposalModal), {
                currentUser: state.currentUser,
                disposal: state.selectedDisposal,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-123"
            })));
            else if (modalState === _this.MODAL_VIEW_DETAILS) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-123"
            }, (0, $LjoDx.h)((0, $dc7b2e3ac4b2ef1f$exports.ViewDisposalModal), {
                currentUser: state.currentUser,
                disposal: state.selectedDisposal,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-123"
            })));
            else if (modalState === _this.MODAL_REVIEW_CURRENT_STOCKS) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-123"
            }, (0, $LjoDx.h)((0, $34afa053d2470d75$exports.ReviewStocksModal), {
                currentUser: state.currentUser,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-123"
            })));
            else if (modalState === _this.MODAL_CREATE_LOCATION) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-123"
            }, (0, $LjoDx.h)((0, $6e75590a903a2f1a$exports.CreateLocationModal), {
                currentUser: state.currentUser,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-123"
            })));
        };
        var filters = new Map();
        filters.set("page", 1);
        _this.setState({
            modalState: -1,
            filters: filters,
            currentPage: 1
        });
        _this.createForm();
        return _this;
    }
    DashDisposals.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "startDate": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "endDate": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "minAmount": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "maxAmount": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "location": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            "supervisor": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            filterForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["filterForm"] = form;
            _this.setState(state);
        });
    };
    DashDisposals.prototype.componentDidMount = function() {
        var _this = this;
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.user;
        }));
        this.subs.push(user$.subscribe(function(user) {
            if (user.currentUser) _this.setState({
                currentUser: user.currentUser
            });
        }));
        var disposal$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.disposal;
        }));
        this.subs.push(disposal$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(disposal) {
            return disposal.disposals;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(disposals) {
            _this.setState({
                gridData: disposals
            });
        }));
        this.subs.push(disposal$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(disposal) {
            return disposal.gridRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(gridRequestState) {
            _this.setState({
                gridRequestState: gridRequestState
            });
        }));
        this.subs.push(disposal$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(disposal) {
            return disposal.total;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(total) {
            if (total) {
                var pages = [];
                var limit = Math.ceil(total / (0, $787290684425694f$exports.PAGE_SIZE));
                for(var i = 0; i < limit; i++)pages.push(i + 1);
                _this.setState({
                    pages: pages
                });
            }
        }));
        this.initialStoreDispatches();
    };
    DashDisposals.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        if (this.state.currentUser.role === (0, $b9c3387011d11553$export$819e975c5d2910e9)) this.state.filters.set("supervisor", this.state.currentUser.supervisor.supervisorId);
        store.dispatch({
            type: (0, $5dbd95920940fbf7$export$ccf130fa81c04150),
            payload: {
                filters: this.state.filters
            }
        });
    };
    DashDisposals.prototype.getActionsBlock = function(props, state) {
        var _this = this;
        if (state.currentUser && state.currentUser.role === (0, $b9c3387011d11553$export$819e975c5d2910e9)) return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 offset-lg-6 col-lg-2 mb-3 mb-lg-0"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: function() {
                _this.onModalOpened(_this.MODAL_CREATE_LOCATION);
            }
        }, "Create Location")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2 mb-3 mb-lg-0"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: function() {
                _this.onModalOpened(_this.MODAL_REVIEW_CURRENT_STOCKS);
            }
        }, "Review Current Stocks")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: function() {
                _this.onModalOpened(_this.MODAL_CREATE_DISPOSAL);
            }
        }, "Create Disposal")));
    };
    DashDisposals.prototype.getGridBlock = function(props, state) {
        var _this = this;
        if (state.gridRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) return (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading..."))));
        else if (state.gridRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) // in the grid, we only show 4-5 columns
        // should the user wish to see the full breakdown
        // a modal will be used instead
        return (0, $LjoDx.h)("div", {
            class: "dash-remittance__grid-container"
        }, (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid dash-withdrawal__grid"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__col col-short"
        }, "Actions"), state.currentUser.role === (0, $b9c3387011d11553$export$b38e98e302041724) ? (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Supervisor") : null, (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Agent Involved"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Location"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Brands Disposed"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Disposal Value"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Date Disposed")), state.gridData.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                class: "data-grid__row",
                id: row._id
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col col-short"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-outline-primary w-100",
                onClick: function() {
                    _this.onViewDetails(row);
                }
            }, "View")), state.currentUser.role === (0, $b9c3387011d11553$export$b38e98e302041724) ? (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.supervisorData.username) : null, (0, $LjoDx.h)("div", {
                class: "data-grid__col text-capitalize"
            }, row.agentInvolved), (0, $LjoDx.h)("div", {
                class: "data-grid__col text-capitalize"
            }, row.location.area ? "".concat(row.location.area, ", ") : null, " ", row.location.name), (0, $LjoDx.h)("div", {
                class: "data-grid__col text-capitalize"
            }, _this.getBrandsDisposed(row)), (0, $LjoDx.h)("div", {
                class: "data-grid__col text-capitalize"
            }, "₱ ", $1b4d8647546ef02f$export$4a115427c4247518(row)), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(row.dateDisposed).format("MMMM DD, YYYY")));
        })))));
        else return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, "Failed to load grid data."));
    };
    DashDisposals.prototype.getPaginationBlock = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, state.pages ? (0, $LjoDx.h)("div", {
            class: "dash-remittance__pagination mb-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn dash-remittance__pagination__page arrow",
            disabled: state.currentPage === 1,
            onClick: function() {
                return _this.onPageClicked(state.currentPage - 1);
            }
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-chevron-left"
        })), state.currentPage > 5 ? (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                "active": state.pages[0] === state.currentPage
            }),
            onClick: function() {
                return _this.onPageClicked(state.pages[0]);
            }
        }, state.pages[0]) : null, state.currentPage > 5 ? (0, $LjoDx.h)("span", {
            class: "mx-2"
        }, "...") : null, state.pages ? state.pages.map(function(page) {
            if (page > state.currentPage - 5 && page < state.currentPage + 5) return (0, $LjoDx.h)("button", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                    "active": page === state.currentPage
                }),
                onClick: function() {
                    return _this.onPageClicked(page);
                }
            }, page);
        }) : null, state.currentPage < state.pages.length - 5 ? (0, $LjoDx.h)("span", {
            class: "mx-2"
        }, "...") : null, state.currentPage < state.pages.length - 5 ? (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                "active": state.pages[state.pages.length - 1] === state.currentPage
            }),
            onClick: function() {
                return _this.onPageClicked(state.pages[state.pages.length - 1]);
            }
        }, state.pages[state.pages.length - 1]) : null, (0, $LjoDx.h)("button", {
            class: "btn dash-remittance__pagination__page arrow",
            disabled: state.currentPage === state.pages[state.pages.length - 1],
            onClick: function() {
                return _this.onPageClicked(state.currentPage + 1);
            }
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-chevron-right"
        }))) : null));
    };
    DashDisposals.prototype.getFilterBlock = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "container-fluid px-0 mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "row justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("a", {
            class: "dash-remittance__filter-row__filter-btn",
            onClick: this.onFilterToggleClicked
        }, "Filter ", (0, $LjoDx.h)("i", {
            class: "fas fa-filter"
        })))), (0, $LjoDx.h)("div", {
            class: "row no-gutters"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, state.isFilterVisible ? (0, $LjoDx.h)("div", {
            class: "dash-remittance__filter-row__filters mt-2"
        }, this.getFilterForm(props, state), this.getFilterActions(props, state)) : null)));
    };
    DashDisposals.prototype.getFilterActions = function(props, state) {
        if (state.isFilterVisible) return (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2 offset-lg-8"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.resetFilters
        }, "Reset Filters")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.applyFilters
        }, "Apply Filters")));
    };
    DashDisposals.prototype.getFilterForm = function(props, state) {
        var form = state.filterForm;
        if (state.currentUser && state.isFilterVisible) {
            if (state.currentUser.role === (0, $b9c3387011d11553$export$b38e98e302041724)) return (0, $LjoDx.h)("div", {
                class: "row mt-3"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3"
            }, (0, $LjoDx.h)("label", {
                class: "dash-remittance__filter-row__filters__label"
            }, "Supervisor"), (0, $LjoDx.h)((0, $204820985097eb0a$exports.AutocompleteSearch), {
                onResultSelected: this.onSupervisorSearchChange
            })), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3"
            }, (0, $LjoDx.h)("label", {
                class: "dash-remittance__filter-row__filters__label"
            }, "Location"), (0, $LjoDx.h)((0, $32bb41b2d7befcc7$exports.AutocompleteLocation), {
                onResultSelected: this.onLocationSearchChange
            })), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3"
            }, (0, $LjoDx.h)("label", {
                class: "dash-remittance__filter-row__filters__label"
            }, "Start Disposal date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
                onDateSelected: this.startDateSelected,
                initialValue: form.fields["startDate"].value,
                isValid: form.fields["startDate"].isValid,
                isPristine: form.fields["startDate"].isPristine,
                reset: this.resetStartDates
            })), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3"
            }, (0, $LjoDx.h)("label", {
                class: "dash-remittance__filter-row__filters__label"
            }, "End Disposal date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
                onDateSelected: this.startDateSelected,
                initialValue: form.fields["endDate"].value,
                isValid: form.fields["endDate"].isValid,
                isPristine: form.fields["endDate"].isPristine,
                reset: this.resetEndDates
            })));
            else return (0, $LjoDx.h)("div", {
                class: "row mt-3"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3"
            }, (0, $LjoDx.h)("label", {
                class: "dash-remittance__filter-row__filters__label"
            }, "Location"), (0, $LjoDx.h)((0, $32bb41b2d7befcc7$exports.AutocompleteLocation), {
                onResultSelected: this.onLocationSearchChange
            })), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3"
            }, (0, $LjoDx.h)("label", {
                class: "dash-remittance__filter-row__filters__label"
            }, "Start Disposal date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
                onDateSelected: this.startDateSelected,
                initialValue: form.fields["startDate"].value,
                isValid: form.fields["startDate"].isValid,
                isPristine: form.fields["startDate"].isPristine,
                reset: this.resetStartDates
            })), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3"
            }, (0, $LjoDx.h)("label", {
                class: "dash-remittance__filter-row__filters__label"
            }, "End Disposal date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
                onDateSelected: this.startDateSelected,
                initialValue: form.fields["endDate"].value,
                isValid: form.fields["endDate"].isValid,
                isPristine: form.fields["endDate"].isPristine,
                reset: this.resetEndDates
            })));
        }
    };
    DashDisposals.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "dash-disposal anglo__dashboard"
        }, this.getPortalModal(state), (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-8 col-lg-4"
        }, (0, $LjoDx.h)("nav", {
            "aria-label": "breadcrumb"
        }, (0, $LjoDx.h)("ol", {
            class: "breadcrumb"
        }, (0, $LjoDx.h)("li", {
            class: "breadcrumb-item"
        }, (0, $LjoDx.h)("a", {
            href: "/disposal"
        }, "Disposals")))))), this.getActionsBlock(props, state), this.getFilterBlock(props, state), this.getGridBlock(props, state), this.getPaginationBlock(props, state)));
    };
    return DashDisposals;
}((0, $LjoDx.Component));


var $c1bb44a5a7d7dab3$exports = {};

$parcel$export($c1bb44a5a7d7dab3$exports, "DashCashbondLoans", () => $c1bb44a5a7d7dab3$export$164f9bd9b3d2e975);

var $LjoDx = parcelRequire("LjoDx");







const $d9b6e5150f6c90c2$export$ffc9cf134f4dc3af = 0;
const $d9b6e5150f6c90c2$export$7d06a9314511fa56 = 1;
const $d9b6e5150f6c90c2$export$d91e7fb746bbfbbe = 2;
const $d9b6e5150f6c90c2$export$e29bd7a43c841e14 = 3;
function $d9b6e5150f6c90c2$export$748f2d8f16569f72(status) {
    let statusAsString;
    switch(status){
        case $d9b6e5150f6c90c2$export$ffc9cf134f4dc3af:
            statusAsString = "unpaid";
            break;
        case $d9b6e5150f6c90c2$export$7d06a9314511fa56:
            statusAsString = "pending";
            break;
        case $d9b6e5150f6c90c2$export$d91e7fb746bbfbbe:
            statusAsString = "fully paid";
            break;
        case $d9b6e5150f6c90c2$export$e29bd7a43c841e14:
            statusAsString = "rejected";
            break;
    }
    return statusAsString;
}





var $0ed84acdee11af05$exports = {};

$parcel$export($0ed84acdee11af05$exports, "CreateLoanModal", () => $0ed84acdee11af05$export$b69d818b25ed01db);

var $LjoDx = parcelRequire("LjoDx");












var $0ed84acdee11af05$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0ed84acdee11af05$export$b69d818b25ed01db = /** @class */ function(_super) {
    $0ed84acdee11af05$var$__extends(CreateLoanModal, _super);
    function CreateLoanModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.loanForm;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            _this.setState({
                loanForm: form
            });
            if (!_this.state.loanForm.isValid) return;
            var loan = {
                agentId: form.fields["agentId"].value,
                // supervisor: this.props.currentUser.supervisor.supervisorId,
                supervisorUsername: form.fields["agentId"].value["supervisorUsername"],
                sectorId: form.fields["location"].value,
                amount: form.fields["amount"].value,
                description: form.fields["description"].value
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $9faeaaf3b7b2176c$export$d38286f15dd53ade),
                payload: {
                    loanToCreate: loan
                }
            });
        };
        _this.onAgentSearchChange = function(agent) {
            console.log("agent", agent);
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.loanForm, "agentId", agent._id);
        };
        _this.onSupervisorSearchChange = function(supervisor) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.loanForm, "supervisorUsername", supervisor.username);
        };
        _this.onLocationSearchChange = function(sector) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.loanForm, "location", sector.name);
        };
        _this.createForm();
        return _this;
    }
    CreateLoanModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            location: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            agentId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            amount: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            description: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            supervisorUsername: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            loanForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["loanForm"] = form;
            _this.setState(state);
        });
    };
    CreateLoanModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var cashbondloan$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.cashbondloan;
        }));
        this.subs.push(cashbondloan$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(cashbondloan) {
            return cashbondloan.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
        }));
    };
    CreateLoanModal.prototype.getFormBlock = function(props, state) {
        var form = state.loanForm;
        if (form) return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-loan-modal__form"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Agent*"), (0, $LjoDx.h)((0, $204820985097eb0a$exports.AutocompleteSearch), {
            onResultSelected: this.onAgentSearchChange,
            placeholder: "Search by Agent",
            searchUrl: "agent"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6  mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Sector/Location*"), (0, $LjoDx.h)((0, $eb0c70f62dd91971$exports.AutocompleteSector), {
            onResultSelected: this.onLocationSearchChange
        }))), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Amount*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["amount"])
            }),
            type: "text",
            value: form.fields["amount"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "amount"),
            placeholder: "Amount"
        }))), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Notes/Description"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["description"])
            }),
            type: "text",
            value: form.fields["description"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "description"),
            placeholder: "Description"
        })))));
    };
    CreateLoanModal.prototype.getSpinnerBlock = function() {
        return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    CreateLoanModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return this.getSpinnerBlock();
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !state.loanForm.isValid
        }, "Submit Loan"))));
    };
    CreateLoanModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-disposal-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create Loan")), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions mt-3"
        }, this.getActionsRow(props, state)));
    };
    return CreateLoanModal;
}((0, $3f2ba7f1e3532510$exports.Modal));
 /*



*/ 

var $1533e305b875b66a$exports = {};

$parcel$export($1533e305b875b66a$exports, "CreateLoanPaymentModal", () => $1533e305b875b66a$export$bd7e64d75d77e60e);

var $LjoDx = parcelRequire("LjoDx");












var $1533e305b875b66a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1533e305b875b66a$export$bd7e64d75d77e60e = /** @class */ function(_super) {
    $1533e305b875b66a$var$__extends(CreateLoanPaymentModal, _super);
    function CreateLoanPaymentModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.loanPaymentForm;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            _this.setState({
                loanPaymentForm: form
            });
            if (!_this.state.loanPaymentForm.isValid) return;
            var loanPayment = {
                loanId: _this.props.loan.loanId,
                agentId: _this.props.loan.agentId,
                sectorId: _this.props.loan.sectorId,
                dateOfTransaction: form.fields["dateOfTransaction"].value,
                receivingBankAccount: form.fields["receivingBankAccount"].value,
                amount: Number.parseFloat(form.fields["amount"].value),
                receiptNumber: form.fields["receiptNumber"].value
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $9faeaaf3b7b2176c$export$6964af2754c72e35),
                payload: {
                    loanPaymentToCreate: loanPayment
                }
            });
        };
        _this.onAgentSearchChange = function(agentId) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.loanPaymentForm, "agentId", agentId);
        };
        _this.onLocationSearchChange = function(sector) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.loanPaymentForm, "location", sector.sectorId);
        };
        _this.onDateSelected = function(date) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.loanPaymentForm, "dateOfTransaction", date);
        };
        _this.createForm();
        return _this;
    }
    CreateLoanPaymentModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "dateOfTransaction": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "receivingBankAccount": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "amount": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "receiptNumber": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            loanPaymentForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["loanPaymentForm"] = form;
            _this.setState(state);
        });
    };
    CreateLoanPaymentModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var cashbondloan$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.cashbondloan;
        }));
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.user;
        }));
        this.subs.push(cashbondloan$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(cashbondloan) {
            return cashbondloan.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
            else if (postPutRequestState === (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            }
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.allBankAccounts;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(allBankAccounts) {
            if (allBankAccounts) _this.setState({
                allBankAccounts: allBankAccounts
            });
        }));
        this.initialStoreDispatches();
    };
    CreateLoanPaymentModal.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $4c71eb74f53637d3$export$74d61c62c586516a),
            payload: {
                isSubmitRemit: true
            }
        });
    };
    CreateLoanPaymentModal.prototype.getFormBlock = function(props, state) {
        var form = state.loanPaymentForm;
        if (form && state.allBankAccounts) return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-loan-modal__form"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Amount*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["amount"])
            }),
            type: "text",
            value: form.fields["amount"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "amount"),
            placeholder: "Amount"
        }))), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Date of Transaction*"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: this.onDateSelected,
            initialValue: form.fields["dateOfTransaction"].value,
            isValid: form.fields["dateOfTransaction"].isValid,
            isPristine: form.fields["dateOfTransaction"].isPristine
        }))), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Receiving Bank Account*"), (0, $LjoDx.h)("select", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["receivingBankAccount"])
            }),
            placeholder: "Bank Account",
            value: form.fields["receivingBankAccount"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "receivingBankAccount")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, "Select Account"), state.allBankAccounts.map(function(acc) {
            return (0, $LjoDx.h)("option", {
                value: acc.bankAccountName
            }, acc.bankAccountName);
        }))))));
    };
    CreateLoanPaymentModal.prototype.getSpinnerBlock = function() {
        return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    CreateLoanPaymentModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return this.getSpinnerBlock();
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !state.loanPaymentForm.isValid
        }, "Submit Payment"))));
    };
    CreateLoanPaymentModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-disposal-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create Loan Payment - ", props.loan.loanId)), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions mt-3"
        }, this.getActionsRow(props, state)));
    };
    return CreateLoanPaymentModal;
}((0, $3f2ba7f1e3532510$exports.Modal));
 /*



*/ 

var $710675918c102ba5$exports = {};

$parcel$export($710675918c102ba5$exports, "ChangeLoanStateModal", () => $710675918c102ba5$export$30b0aad00b400d5f);

var $LjoDx = parcelRequire("LjoDx");











var $710675918c102ba5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $710675918c102ba5$export$30b0aad00b400d5f = /** @class */ function(_super) {
    $710675918c102ba5$var$__extends(ChangeLoanStateModal, _super);
    function ChangeLoanStateModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function(status) {
            var form = _this.state.loanApprovalForm;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            _this.setState({
                loanApprovalForm: form
            });
            if (!_this.state.loanApprovalForm.isValid) return;
            var loanStatus = {
                loanId: _this.props.loan.loanId,
                status: status
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $9faeaaf3b7b2176c$export$63c41752fe5bdae7),
                payload: {
                    loanStatusToUpdate: loanStatus
                }
            });
        };
        _this.createForm();
        return _this;
    }
    ChangeLoanStateModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "responseReason": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            loanApprovalForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["loanApprovalForm"] = form;
            _this.setState(state);
        });
    };
    ChangeLoanStateModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var cashbondloan$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.cashbondloan;
        }));
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.user;
        }));
        this.subs.push(cashbondloan$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(cashbondloan) {
            return cashbondloan.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
            else if (postPutRequestState === (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            }
        }));
    };
    ChangeLoanStateModal.prototype.getFormBlock = function(props, state) {
        var form = state.loanApprovalForm;
        if (form) return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-loan-modal__form"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Amount"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            type: "text",
            disabled: true,
            value: props.loan.amount,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "amount"),
            placeholder: "Amount"
        }))), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Description"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            type: "text",
            disabled: true,
            value: props.loan.description,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "description"),
            placeholder: "Description"
        }))), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Response Reason*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["responseReason"])
            }),
            type: "text",
            value: form.fields["responseReason"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "responseReason"),
            placeholder: "Response Reason"
        })))));
    };
    ChangeLoanStateModal.prototype.getSpinnerBlock = function() {
        return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    ChangeLoanStateModal.prototype.getActionsRow = function(props, state) {
        var _this = this;
        if (state.isPostInProgress) return this.getSpinnerBlock();
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-6"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: function() {
                return _this.onSubmit((0, $d9b6e5150f6c90c2$export$e29bd7a43c841e14));
            }
        }, "Reject Loan")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: function() {
                return _this.onSubmit((0, $d9b6e5150f6c90c2$export$ffc9cf134f4dc3af));
            }
        }, "Approve Loan"))));
    };
    ChangeLoanStateModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-disposal-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Change Loan Status - ", props.loan.loanId)), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions mt-3"
        }, this.getActionsRow(props, state)));
    };
    return ChangeLoanStateModal;
}((0, $3f2ba7f1e3532510$exports.Modal));
 /*



*/ 

var $20db4b7ae638ca3c$exports = {};

$parcel$export($20db4b7ae638ca3c$exports, "ViewLoanModal", () => $20db4b7ae638ca3c$export$5af0d423b2532b3b);

var $LjoDx = parcelRequire("LjoDx");







var $20db4b7ae638ca3c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $20db4b7ae638ca3c$export$5af0d423b2532b3b = /** @class */ function(_super) {
    $20db4b7ae638ca3c$var$__extends(ViewLoanModal, _super);
    function ViewLoanModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        return _this;
    }
    ViewLoanModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var cashbondloan$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.cashbondloan;
        }));
        this.subs.push(cashbondloan$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(cashbondloan) {
            return cashbondloan.loanPayments;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(loanPayments) {
            _this.setState({
                loanPayments: loanPayments
            });
        }));
        this.initialStoreDispatches();
    };
    ViewLoanModal.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        var filters = new Map();
        filters.set("loanId", this.props.loan.loanId);
        store.dispatch({
            type: (0, $9faeaaf3b7b2176c$export$b9bca83af8eb0508),
            payload: {
                filters: filters
            }
        });
    };
    ViewLoanModal.prototype.getFormBlock = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-loan-modal__form"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Amount Loaned"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            type: "text",
            disabled: true,
            value: props.loan.amount,
            placeholder: "Amount Loaned"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Remaining"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            type: "text",
            disabled: true,
            value: props.loan.remaining,
            placeholder: "Remaining"
        }))), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Status"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            type: "text",
            disabled: true,
            value: (0, $d9b6e5150f6c90c2$export$748f2d8f16569f72)(props.loan.status),
            placeholder: "Status"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Area/Sector"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            type: "text",
            disabled: true,
            value: props.loan.sectorId,
            placeholder: "Area/Sector"
        }))), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Date Created"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            type: "text",
            disabled: true,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(props.loan.dateCreated).format("MMMM DD, YYYY"),
            placeholder: "Date Created"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Date Approved"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            type: "text",
            disabled: true,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(props.loan.dateApproved).format("MMMM DD, YYYY"),
            placeholder: "Date Approved"
        }))), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Description/Notes"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            type: "text",
            disabled: true,
            value: props.loan.description,
            placeholder: "Description"
        }))), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Response Reason"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            type: "text",
            disabled: true,
            value: props.loan.responseReason,
            placeholder: "Response Reason"
        })))));
    };
    ViewLoanModal.prototype.getPaymentsBlock = function(props, state) {
        if (state.loanPayments) return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Payment ID"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Amount"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Date of Transaction"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Receipt Number")), state.loanPayments.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                class: "data-grid__row"
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.loanPaymentId), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.amount), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.dateOfTransaction), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.receiptNumber));
        })));
        else return this.getSpinnerBlock();
    };
    ViewLoanModal.prototype.getSpinnerBlock = function() {
        return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    ViewLoanModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return this.getSpinnerBlock();
    };
    ViewLoanModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal view-loan-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "View Loan - ", props.loan.loanId, " - ", props.loan.agent.firstName, " ", props.loan.agent.lastName)), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 view-loan-modal__body pb-3"
        }, this.getFormBlock(props, state), (0, $LjoDx.h)("div", {
            class: "row mt-3 view-loan-modal__payments"
        }, this.getPaymentsBlock(props, state)))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions mt-3"
        }, this.getActionsRow(props, state)));
    };
    return ViewLoanModal;
}((0, $3f2ba7f1e3532510$exports.Modal));
 /*



*/ 

var $8d0895b69e0b5055$exports = {};

$parcel$export($8d0895b69e0b5055$exports, "CreateCashbondModal", () => $8d0895b69e0b5055$export$ba5edefec7b50363);

var $LjoDx = parcelRequire("LjoDx");











var $8d0895b69e0b5055$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8d0895b69e0b5055$export$ba5edefec7b50363 = /** @class */ function(_super) {
    $8d0895b69e0b5055$var$__extends(CreateCashbondModal, _super);
    function CreateCashbondModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.cashbondForm;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            _this.setState({
                cashbondForm: form
            });
            if (!_this.state.cashbondForm.isValid) return;
            var cashbond = {
                agentId: form.fields["agentId"].value,
                sectorId: form.fields["location"].value
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $9faeaaf3b7b2176c$export$7a6efbf66dd44bf6),
                payload: {
                    cashbondToCreate: cashbond
                }
            });
        };
        _this.onAgentSearchChange = function(agentId) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.cashbondForm, "agentId", agentId);
        };
        _this.onLocationSearchChange = function(sector) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.cashbondForm, "location", sector.name);
        };
        _this.createForm();
        return _this;
    }
    CreateCashbondModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "location": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "agentId": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            cashbondForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["cashbondForm"] = form;
            _this.setState(state);
        });
    };
    CreateCashbondModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var cashbondloan$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.cashbondloan;
        }));
        this.subs.push(cashbondloan$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(cashbondloan) {
            return cashbondloan.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
        }));
    };
    CreateCashbondModal.prototype.getFormBlock = function(props, state) {
        var form = state.cashbondForm;
        return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-cashbond-modal__form"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Agent*"), (0, $LjoDx.h)((0, $204820985097eb0a$exports.AutocompleteSearch), {
            onResultSelected: this.onAgentSearchChange,
            placeholder: "Search by Agent",
            searchUrl: "agent"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Sector/Location*"), (0, $LjoDx.h)((0, $eb0c70f62dd91971$exports.AutocompleteSector), {
            onResultSelected: this.onLocationSearchChange
        })))));
    };
    CreateCashbondModal.prototype.getSpinnerBlock = function() {
        return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    CreateCashbondModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return this.getSpinnerBlock();
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !state.cashbondForm.isValid
        }, "Submit Cashbond"))));
    };
    CreateCashbondModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-disposal-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create Cashbond")), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions mt-3"
        }, this.getActionsRow(props, state)));
    };
    return CreateCashbondModal;
}((0, $3f2ba7f1e3532510$exports.Modal));
 /*



*/ 

var $be908c137e64dc9e$exports = {};

$parcel$export($be908c137e64dc9e$exports, "CreateCashbondPaymentModal", () => $be908c137e64dc9e$export$e58402ab1606da7c);

var $LjoDx = parcelRequire("LjoDx");












var $be908c137e64dc9e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $be908c137e64dc9e$export$e58402ab1606da7c = /** @class */ function(_super) {
    $be908c137e64dc9e$var$__extends(CreateCashbondPaymentModal, _super);
    function CreateCashbondPaymentModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.cashbondPaymentForm;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            _this.setState({
                cashbondPaymentForm: form
            });
            if (!_this.state.cashbondPaymentForm.isValid) return;
            var cashbondPayment = {
                cashbondId: _this.props.cashbond.cashbondId,
                agentId: _this.props.cashbond.agentId,
                sectorId: _this.props.cashbond.sectorId,
                dateOfTransaction: form.fields["dateOfTransaction"].value,
                receivingBankAccount: form.fields["receivingBankAccount"].value,
                amount: Number.parseFloat(form.fields["amount"].value),
                receiptNumber: form.fields["receiptNumber"].value
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $9faeaaf3b7b2176c$export$80f112149f100e38),
                payload: {
                    cashbondPaymentToCreate: cashbondPayment
                }
            });
        };
        _this.onAgentSearchChange = function(agentId) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.cashbondPaymentForm, "agentId", agentId);
        };
        _this.onLocationSearchChange = function(sector) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.cashbondPaymentForm, "location", sector.sectorId);
        };
        _this.onDateSelected = function(date) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.cashbondPaymentForm, "dateOfTransaction", date);
        };
        _this.createForm();
        return _this;
    }
    CreateCashbondPaymentModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "dateOfTransaction": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "receivingBankAccount": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "amount": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            "receiptNumber": new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            cashbondPaymentForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["cashbondPaymentForm"] = form;
            _this.setState(state);
        });
    };
    CreateCashbondPaymentModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var cashbondloan$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.cashbondloan;
        }));
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.user;
        }));
        this.subs.push(cashbondloan$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(cashbondloan) {
            return cashbondloan.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
            else if (postPutRequestState === (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            }
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.allBankAccounts;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(allBankAccounts) {
            if (allBankAccounts) _this.setState({
                allBankAccounts: allBankAccounts
            });
        }));
        this.initialStoreDispatches();
    };
    CreateCashbondPaymentModal.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $4c71eb74f53637d3$export$74d61c62c586516a),
            payload: {
                isSubmitRemit: true
            }
        });
    };
    CreateCashbondPaymentModal.prototype.getFormBlock = function(props, state) {
        var form = state.cashbondPaymentForm;
        if (form && state.allBankAccounts) return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-loan-modal__form"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Amount*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["amount"])
            }),
            type: "text",
            value: form.fields["amount"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "amount"),
            placeholder: "Amount"
        }))), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Date of Transaction*"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: this.onDateSelected,
            initialValue: form.fields["dateOfTransaction"].value,
            isValid: form.fields["dateOfTransaction"].isValid,
            isPristine: form.fields["dateOfTransaction"].isPristine
        }))), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Receiving Bank Account*"), (0, $LjoDx.h)("select", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                "invalid": (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["receivingBankAccount"])
            }),
            placeholder: "Bank Account",
            value: form.fields["receivingBankAccount"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "receivingBankAccount")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, "Select Account"), state.allBankAccounts.map(function(acc) {
            return (0, $LjoDx.h)("option", {
                value: acc.bankAccountName
            }, acc.bankAccountName);
        }))))));
        else return (0, $LjoDx.h)("div", {
            class: "row align-center"
        }, this.getSpinnerBlock());
    };
    CreateCashbondPaymentModal.prototype.getSpinnerBlock = function() {
        return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    CreateCashbondPaymentModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return this.getSpinnerBlock();
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !state.cashbondPaymentForm.isValid
        }, "Submit Payment"))));
    };
    CreateCashbondPaymentModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-disposal-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create Cashbond Payment - ", props.cashbond.cashbondId)), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions mt-3"
        }, this.getActionsRow(props, state)));
    };
    return CreateCashbondPaymentModal;
}((0, $3f2ba7f1e3532510$exports.Modal));
 /*



*/ 








var $c1bb44a5a7d7dab3$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c1bb44a5a7d7dab3$export$164f9bd9b3d2e975 = /** @class */ function(_super) {
    $c1bb44a5a7d7dab3$var$__extends(DashCashbondLoans, _super);
    function DashCashbondLoans(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.MODAL_VIEW_LOAN = 0;
        _this.MODAL_VIEW_CASHBOND = 1;
        _this.MODAL_PAY_LOAN = 2;
        _this.MODAL_PAY_CASHBOND = 3;
        _this.MODAL_CREATE_LOAN = 4;
        _this.MODAL_CREATE_CASHBOND = 5;
        _this.MODAL_UPDATE_LOAN_STATUS = 6;
        _this.onModalOpened = function(paramState, row) {
            if (paramState === _this.MODAL_VIEW_LOAN) _this.setState({
                modalState: paramState,
                focusedLoan: row
            });
            else if (paramState === _this.MODAL_VIEW_CASHBOND) _this.setState({
                modalState: paramState,
                focusedCashbond: row
            });
            else if (paramState === _this.MODAL_PAY_CASHBOND) _this.setState({
                modalState: paramState,
                focusedCashbond: row
            });
            else if (paramState === _this.MODAL_CREATE_CASHBOND) _this.setState({
                modalState: paramState
            });
            else if (paramState === _this.MODAL_CREATE_LOAN) _this.setState({
                modalState: paramState
            });
            else if (paramState === _this.MODAL_PAY_LOAN) _this.setState({
                modalState: paramState,
                focusedLoan: row
            });
            else if (paramState === _this.MODAL_UPDATE_LOAN_STATUS) _this.setState({
                modalState: paramState,
                focusedLoan: row
            });
        };
        _this.onModalClose = function(returnParams) {
            _this.setState({
                modalState: -1
            });
            _this.initialStoreDispatches();
        };
        _this.onSupervisorSearchChange = function(supervisor) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filterForm, "supervisorUsername", supervisor.username);
        };
        _this.onAgentSearchChange = function(agent) {
            console.log("agent", agent);
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filterForm, "agentId", agent._id);
        };
        _this.switchMode = function() {
            _this.setState({
                isLoansMode: !_this.state.isLoansMode
            });
        };
        _this.onPageClicked = function(page) {
            var filterForm = {};
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filterForm[k] = fieldList[k].value;
            filterForm["page"] = page;
            var filters = _this.state.filters;
            filters.set("page", page);
            var action = _this.state.isLoansMode ? (0, $9faeaaf3b7b2176c$export$843b4ad7e23f8cba) : (0, $9faeaaf3b7b2176c$export$1034728adc42b984);
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: action,
                payload: {
                    filters: filters
                }
            });
            _this.setState({
                currentPage: page
            });
        };
        _this.generateReport = function() {
            var filters = new Map();
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filters.set(k, fieldList[k].value);
            filters.set("pageSize", 5000);
            filters.set("page", 1);
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $9faeaaf3b7b2176c$export$a3a05ad01a242f49),
                payload: {
                    filters: filters
                }
            });
        };
        _this.generateCashbondReport = function() {
            var filters = new Map();
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filters.set(k, fieldList[k].value);
            filters.set("pageSize", 5000);
            filters.set("page", 1);
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $9faeaaf3b7b2176c$export$603f5590406dec35),
                payload: {
                    filters: filters
                }
            });
        };
        _this.onFilterToggleClicked = function() {
            _this.setState({
                isFilterVisible: !_this.state.isFilterVisible
            });
        };
        _this.startDateSelected = function(date) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filterForm, "startDate", date);
        };
        _this.endDateSelected = function(date) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filterForm, "endDate", date);
        };
        _this.resetStartDates = function(returned) {
            _this.resetStartDate = returned;
        };
        _this.resetEndDates = function(returned) {
            _this.resetEndDate = returned;
        };
        _this.resetFilters = function() {
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)fieldList[k].value = null;
            _this.resetStartDate();
            _this.resetEndDate();
            var filters = new Map();
            filters.set("page", 1);
            _this.setState({
                filters: filters,
                currentPage: 1
            });
            _this.initialStoreDispatches();
        };
        _this.applyFilters = function() {
            var filters = _this.state.filters;
            var fieldList = _this.state.filterForm.fields;
            console.log(fieldList);
            for(var k in fieldList)if (fieldList[k].value) filters.set(k, fieldList[k].value);
            var action = _this.state.isLoansMode ? (0, $9faeaaf3b7b2176c$export$843b4ad7e23f8cba) : (0, $9faeaaf3b7b2176c$export$1034728adc42b984);
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: action,
                payload: {
                    filters: filters
                }
            });
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Filters Applied",
                message: "Data filtered and new report may be generated",
                duration: 3000
            });
        };
        _this.getPortalModal = function(state) {
            var modalState = state.modalState;
            if (modalState < 0) return null;
            else if (modalState === _this.MODAL_CREATE_LOAN) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-124"
            }, (0, $LjoDx.h)((0, $0ed84acdee11af05$exports.CreateLoanModal), {
                currentUser: state.currentUser,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-123"
            })));
            else if (modalState === _this.MODAL_PAY_LOAN) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-124"
            }, (0, $LjoDx.h)((0, $1533e305b875b66a$exports.CreateLoanPaymentModal), {
                currentUser: state.currentUser,
                loan: state.focusedLoan,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-123"
            })));
            else if (modalState === _this.MODAL_UPDATE_LOAN_STATUS) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-124"
            }, (0, $LjoDx.h)((0, $710675918c102ba5$exports.ChangeLoanStateModal), {
                currentUser: state.currentUser,
                loan: state.focusedLoan,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-123"
            })));
            else if (modalState === _this.MODAL_VIEW_LOAN) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-124"
            }, (0, $LjoDx.h)((0, $20db4b7ae638ca3c$exports.ViewLoanModal), {
                currentUser: state.currentUser,
                loan: state.focusedLoan,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-123"
            })));
            else if (modalState === _this.MODAL_CREATE_CASHBOND) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-124"
            }, (0, $LjoDx.h)((0, $8d0895b69e0b5055$exports.CreateCashbondModal), {
                currentUser: state.currentUser,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-123"
            })));
            else if (modalState === _this.MODAL_PAY_CASHBOND) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-124"
            }, (0, $LjoDx.h)((0, $be908c137e64dc9e$exports.CreateCashbondPaymentModal), {
                currentUser: state.currentUser,
                cashbond: state.focusedCashbond,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-123"
            })));
        };
        var filters = new Map();
        filters.set("page", 1);
        _this.setState({
            modalState: -1,
            filters: filters,
            currentPage: 1,
            isLoansMode: true
        });
        _this.createForm();
        return _this;
    }
    DashCashbondLoans.prototype.createForm = function() {
        var _this = this;
        var fields = {
            startDate: new (0, $49e398741f5b1a93$export$a455218a85c89869)(),
            endDate: new (0, $49e398741f5b1a93$export$a455218a85c89869)(),
            loanId: new (0, $49e398741f5b1a93$export$a455218a85c89869)(),
            status: new (0, $49e398741f5b1a93$export$a455218a85c89869)(),
            supervisorUsername: new (0, $49e398741f5b1a93$export$a455218a85c89869)(),
            agentId: new (0, $49e398741f5b1a93$export$a455218a85c89869)()
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            filterForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["filterForm"] = form;
            _this.setState(state);
        });
    };
    DashCashbondLoans.prototype.componentDidMount = function() {
        var _this = this;
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.user;
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.currentUser;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(currentUser) {
            _this.setState({
                currentUser: currentUser
            });
        }));
        var cashbondLoans$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.cashbondloan;
        }));
        this.subs.push(cashbondLoans$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(cashbondloan) {
            return cashbondloan.loans;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(loans) {
            _this.setState({
                allLoans: loans
            });
        }));
        this.subs.push(cashbondLoans$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(cashbondloan) {
            return cashbondloan.cashbonds;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(cashbonds) {
            _this.setState({
                allCashbonds: cashbonds
            });
        }));
        this.subs.push(cashbondLoans$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(cashbondloan) {
            return cashbondloan.total;
        })).subscribe(function(total) {
            if (total) {
                var pages = [];
                var limit = Math.ceil(total / (0, $787290684425694f$exports.PAGE_SIZE));
                for(var i = 0; i < limit; i++)pages.push(i + 1);
                _this.setState({
                    pages: pages
                });
            }
        }));
        this.initialStoreDispatches();
    };
    DashCashbondLoans.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        var action = this.state.isLoansMode ? (0, $9faeaaf3b7b2176c$export$843b4ad7e23f8cba) : (0, $9faeaaf3b7b2176c$export$1034728adc42b984);
        store.dispatch({
            type: action,
            payload: {
                filters: this.state.filters
            }
        });
        store.dispatch({
            type: (0, $9faeaaf3b7b2176c$export$1034728adc42b984),
            payload: {
                postPutRequestState: (0, $ad7802471dc8ad45$export$76350ffc4854c457),
                paymentsRequestState: (0, $ad7802471dc8ad45$export$76350ffc4854c457),
                filters: this.state.filters
            }
        });
    };
    DashCashbondLoans.prototype.getActionsBlock = function(state) {
        var _this = this;
        var role;
        if (state && state.currentUser) role = state.currentUser.role;
        // if (state.currentUser && role && role !== ROLE_SUPERVISOR) {
        // } else {
        //   return null;
        // }
        if (state.isLoansMode) {
            if (role && role === (0, $b9c3387011d11553$export$b38e98e302041724) || role === (0, $b9c3387011d11553$export$a805ed97d1d93366)) return (0, $LjoDx.h)("div", {
                class: "row"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-2 mb-3 mb-lg-0"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-secondary w-100",
                onClick: this.generateReport
            }, "Generate Report")), (0, $LjoDx.h)("div", {
                class: "col-12 offset-lg-6 col-lg-2"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-outline-dark w-100",
                onClick: function() {
                    _this.onModalOpened(_this.MODAL_CREATE_LOAN);
                }
            }, "Create Loan")), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-2"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-primary w-100",
                onClick: this.switchMode
            }, "Switch to ", this.state.isLoansMode ? "Cashbonds" : "Loans")));
            else return (0, $LjoDx.h)("div", {
                class: "row"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 offset-lg-10 col-lg-2"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-primary w-100",
                onClick: this.switchMode
            }, "Switch to ", this.state.isLoansMode ? "Cashbonds" : "Loans")));
        } else {
            if (role && role === (0, $b9c3387011d11553$export$b38e98e302041724) || role === (0, $b9c3387011d11553$export$a805ed97d1d93366)) return (0, $LjoDx.h)("div", {
                class: "row"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-2 mb-3 mb-lg-0"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-secondary w-100",
                onClick: this.generateCashbondReport
            }, "Generate Report")), (0, $LjoDx.h)("div", {
                class: "col-12 offset-lg-6 col-lg-2 mb-3 mb-lg-0"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-outline-dark w-100",
                onClick: function() {
                    _this.onModalOpened(_this.MODAL_CREATE_CASHBOND);
                }
            }, "Create Cashbond")), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-2"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-primary w-100",
                onClick: this.switchMode
            }, "Switch to ", this.state.isLoansMode ? "Cashbonds" : "Loans")));
            else return (0, $LjoDx.h)("div", {
                class: "row"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 offset-lg-6 col-lg-2 mb-3 mb-lg-0"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-outline-dark w-100",
                onClick: function() {
                    _this.onModalOpened(_this.MODAL_CREATE_CASHBOND);
                }
            }, "Create Cashbond")), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-2"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-primary w-100",
                onClick: this.switchMode
            }, "Switch to ", this.state.isLoansMode ? "Cashbonds" : "Loans")));
        }
    };
    DashCashbondLoans.prototype.getLoanActions = function(state, row, index) {
        var _this = this;
        var role = state.currentUser.role;
        return (0, $LjoDx.h)("div", {
            class: "dropdown-menu",
            "aria-labelledby": "actions".concat(index)
        }, (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return _this.onModalOpened(_this.MODAL_VIEW_LOAN, row);
            }
        }, "View Loan Details"), role === (0, $b9c3387011d11553$export$819e975c5d2910e9) ? (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return _this.onModalOpened(_this.MODAL_PAY_LOAN, row);
            }
        }, "Make a Payment") : null, role === (0, $b9c3387011d11553$export$b38e98e302041724) || role === (0, $b9c3387011d11553$export$ecb30477529ca9f0) ? (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return _this.onModalOpened(_this.MODAL_UPDATE_LOAN_STATUS, row);
            }
        }, "Approve/Reject") : null);
    };
    DashCashbondLoans.prototype.getCashbondActions = function(state, row, index) {
        var _this = this;
        var role = state.currentUser.role;
        return (0, $LjoDx.h)("div", {
            class: "dropdown-menu",
            "aria-labelledby": "actions".concat(index)
        }, (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return _this.onModalOpened(_this.MODAL_PAY_CASHBOND, row);
            }
        }, "Make a Payment"));
    };
    DashCashbondLoans.prototype.getLoansGrid = function(state) {
        var _this = this;
        if (state.allLoans) return (0, $LjoDx.h)("div", {
            class: "dash-cashbon-loan___grid-container"
        }, (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Actions"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Loan ID"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Supervisor"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Agent"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Status"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Amount Loaned"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Remaining"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Sector")), state.allLoans.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                class: "data-grid__row"
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, (0, $LjoDx.h)("div", {
                class: "dropright"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-outline-primary dropdown-toggle",
                type: "button",
                id: "actions".concat(index),
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false"
            }, "Select action"), _this.getLoanActions(state, row, index))), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.loanId), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.supervisorUsername), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.agent.firstName, " ", row.agent.lastName), (0, $LjoDx.h)("div", {
                class: "data-grid__col text-capitalize"
            }, (0, $d9b6e5150f6c90c2$export$748f2d8f16569f72)(row.status)), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, (0, $LjoDx.h)("i", null, "₱ ", (0, $9e0c3e3a397653e5$export$63ad841d70774900)(row.amount))), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, (0, $LjoDx.h)("b", null, "₱ ", (0, $9e0c3e3a397653e5$export$63ad841d70774900)(row.remaining))), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.sectorId));
        })))));
    };
    DashCashbondLoans.prototype.getCashbondGrid = function(state) {
        var _this = this;
        if (state.allCashbonds) return (0, $LjoDx.h)("div", {
            class: "dash-cashbon-loan___grid-container"
        }, (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Actions"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Cashbond ID"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Supervisor"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Agent"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Amount Total"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Sector"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Date Created")), state.allCashbonds.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                class: "data-grid__row"
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, (0, $LjoDx.h)("div", {
                class: "dropright"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-outline-primary dropdown-toggle",
                type: "button",
                id: "actions".concat(index),
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false"
            }, "Select action"), _this.getCashbondActions(state, row, index))), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.cashbondId), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.supervisorUsername), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.agent.firstName, " ", row.agent.lastName), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "₱ ", (0, $9e0c3e3a397653e5$export$63ad841d70774900)(row.amount)), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.sectorId), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(row.dateCreated).format("MMMM DD, YYYY")));
        })))));
    };
    // we show loans by default. cashbonds can be switched to
    DashCashbondLoans.prototype.getGridBlock = function(state) {
        if (state.isLoansMode) return this.getLoansGrid(state);
        else return this.getCashbondGrid(state);
    };
    DashCashbondLoans.prototype.getPaginationBlock = function(state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, state.pages ? (0, $LjoDx.h)("div", {
            class: "dash-remittance__pagination mb-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn dash-remittance__pagination__page arrow",
            disabled: state.currentPage === 1,
            onClick: function() {
                return _this.onPageClicked(state.currentPage - 1);
            }
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-chevron-left"
        })), state.currentPage > 5 ? (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                active: state.pages[0] === state.currentPage
            }),
            onClick: function() {
                return _this.onPageClicked(state.pages[0]);
            }
        }, state.pages[0]) : null, state.currentPage > 5 ? (0, $LjoDx.h)("span", {
            class: "mx-2"
        }, "...") : null, state.pages ? state.pages.map(function(page) {
            if (page > state.currentPage - 5 && page < state.currentPage + 5) return (0, $LjoDx.h)("button", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                    active: page === state.currentPage
                }),
                onClick: function() {
                    return _this.onPageClicked(page);
                }
            }, page);
        }) : null, state.currentPage < state.pages.length - 5 ? (0, $LjoDx.h)("span", {
            class: "mx-2"
        }, "...") : null, state.currentPage < state.pages.length - 5 ? (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                active: state.pages[state.pages.length - 1] === state.currentPage
            }),
            onClick: function() {
                return _this.onPageClicked(state.pages[state.pages.length - 1]);
            }
        }, state.pages[state.pages.length - 1]) : null, (0, $LjoDx.h)("button", {
            class: "btn dash-remittance__pagination__page arrow",
            disabled: state.currentPage === state.pages[state.pages.length - 1],
            onClick: function() {
                return _this.onPageClicked(state.currentPage + 1);
            }
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-chevron-right"
        }))) : null));
    };
    DashCashbondLoans.prototype.getFilterBlock = function(state) {
        return (0, $LjoDx.h)("div", {
            class: "container-fluid px-0 mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "row justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("a", {
            class: "dash-remittance__filter-row__filter-btn",
            onClick: this.onFilterToggleClicked
        }, "Filter ", (0, $LjoDx.h)("i", {
            class: "fas fa-filter"
        })))), (0, $LjoDx.h)("div", {
            class: "row no-gutters"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, state.isFilterVisible ? (0, $LjoDx.h)("div", {
            class: "dash-remittance__filter-row__filters mt-2"
        }, this.getFilterForm(state), this.getFilterActions(state)) : null)));
    };
    DashCashbondLoans.prototype.getFilterForm = function(state) {
        var form = state.filterForm;
        if (form && state.isFilterVisible) return (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, state.currentUser.role === (0, $b9c3387011d11553$export$b38e98e302041724) || state.currentUser.role === (0, $b9c3387011d11553$export$a805ed97d1d93366) ? (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Supervisor"), (0, $LjoDx.h)((0, $204820985097eb0a$exports.AutocompleteSearch), {
            onResultSelected: this.onSupervisorSearchChange
        })) : null, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Agent*"), (0, $LjoDx.h)((0, $204820985097eb0a$exports.AutocompleteSearch), {
            onResultSelected: this.onAgentSearchChange,
            placeholder: "Search by Agent",
            searchUrl: "agent"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Loan ID"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            type: "text",
            value: form.fields["loanId"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "loanId"),
            placeholder: "Loan ID"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Start date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: this.startDateSelected,
            initialValue: form.fields["startDate"].value,
            isValid: form.fields["startDate"].isValid,
            isPristine: form.fields["startDate"].isPristine,
            reset: this.resetStartDates
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "End date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: this.endDateSelected,
            initialValue: form.fields["endDate"].value,
            isValid: form.fields["endDate"].isValid,
            isPristine: form.fields["endDate"].isPristine,
            reset: this.resetEndDates
        })));
    };
    DashCashbondLoans.prototype.getFilterActions = function(state) {
        if (state.isFilterVisible) return (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2 offset-lg-8"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.resetFilters
        }, "Reset Filters")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.applyFilters
        }, "Apply Filters")));
    };
    DashCashbondLoans.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "dash-cashbond-loans  anglo__dashboard"
        }, this.getPortalModal(state), (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-8 col-lg-4"
        }, (0, $LjoDx.h)("nav", {
            "aria-label": "breadcrumb"
        }, (0, $LjoDx.h)("ol", {
            class: "breadcrumb"
        }, (0, $LjoDx.h)("li", {
            class: "breadcrumb-item"
        }, (0, $LjoDx.h)("a", {
            href: "/disposal"
        }, "Cashbonds / Loans")))))), this.getActionsBlock(state), this.getFilterBlock(state), this.getGridBlock(state), this.getPaginationBlock(state)));
    };
    return DashCashbondLoans;
}((0, $LjoDx.Component));


var $7de11d8299f4e93d$exports = {};

$parcel$export($7de11d8299f4e93d$exports, "DashPaymentApproval", () => $7de11d8299f4e93d$export$a57ac6ef749f40c9);

var $LjoDx = parcelRequire("LjoDx");








var $3e52467f553dc02a$exports = {};

$parcel$export($3e52467f553dc02a$exports, "ApproveLoanPaymentModal", () => $3e52467f553dc02a$export$ff3115cc58e41494);

var $LjoDx = parcelRequire("LjoDx");







var $3e52467f553dc02a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3e52467f553dc02a$export$ff3115cc58e41494 = /** @class */ function(_super) {
    $3e52467f553dc02a$var$__extends(ApproveLoanPaymentModal, _super);
    function ApproveLoanPaymentModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function() {
            var _a, _b;
            var loanPaymentUpdate = {
                loanId: _this.props.loanPayment.loanId,
                paymentId: (_a = _this.props.loanPayment) === null || _a === void 0 ? void 0 : _a.loanPaymentId,
                amount: (_b = _this.props.loanPayment) === null || _b === void 0 ? void 0 : _b.amount
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $9faeaaf3b7b2176c$export$b982743d6eb42399),
                payload: {
                    loanPaymentToUpdate: loanPaymentUpdate
                }
            });
        };
        return _this;
    }
    ApproveLoanPaymentModal.prototype.componentDidMount = function() {
        var _this = this;
        var cashbondloan$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.cashbondloan;
        }));
        this.subs.push(cashbondloan$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(cashbondloan) {
            return cashbondloan.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.doModalClose();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
            else if (postPutRequestState === (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.doModalClose();
            }
        }));
    };
    ApproveLoanPaymentModal.prototype.getPaymentDetailsBlock = function(props) {
        var payment = props.loanPayment;
        return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "loan-payment-modal__label text-bold"
        }, "Agent"), (0, $LjoDx.h)("p", {
            class: "text-capitalize"
        }, payment.agent.firstName, " ", payment.agent.lastName)), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "loan-payment-modal__label"
        }, "Supervisor"), (0, $LjoDx.h)("p", null, payment.supervisor)), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "loan-payment-modal__label"
        }, "Date of Transaction"), (0, $LjoDx.h)("p", null, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(payment.dateOfTransaction).format("MMMM DD, YYYY")))), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "loan-payment-modal__label"
        }, "Amount"), (0, $LjoDx.h)("p", null, "₱ ", (0, $9e0c3e3a397653e5$export$63ad841d70774900)(payment.amount))), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "loan-payment-modal__label"
        }, "Bank"), (0, $LjoDx.h)("p", null, payment.receivingBankAccount)))));
    };
    ApproveLoanPaymentModal.prototype.getSpinnerBlock = function() {
        return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    ApproveLoanPaymentModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return this.getSpinnerBlock();
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit
        }, "Approve Payment"))));
    };
    ApproveLoanPaymentModal.prototype.render = function(props, state) {
        var _this = this;
        var _a;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal loan-payment-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Approve Loan Payment - ", (_a = props.loanPayment) === null || _a === void 0 ? void 0 : _a.loanPaymentId)), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 pb-3"
        }, this.getPaymentDetailsBlock(props))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions mt-3"
        }, this.getActionsRow(props, state)));
    };
    return ApproveLoanPaymentModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $428c0220c3c5f49b$exports = {};

$parcel$export($428c0220c3c5f49b$exports, "RejectLoanPaymentModal", () => $428c0220c3c5f49b$export$ab58edf0a0183a15);

var $LjoDx = parcelRequire("LjoDx");







var $428c0220c3c5f49b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $428c0220c3c5f49b$export$ab58edf0a0183a15 = /** @class */ function(_super) {
    $428c0220c3c5f49b$var$__extends(RejectLoanPaymentModal, _super);
    function RejectLoanPaymentModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function() {
            var _a;
            var loanPaymentUpdate = {
                paymentId: (_a = _this.props.loanPayment) === null || _a === void 0 ? void 0 : _a.loanPaymentId
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $9faeaaf3b7b2176c$export$286befb5f9ea4091),
                payload: {
                    loanPaymentToUpdate: loanPaymentUpdate
                }
            });
        };
        return _this;
    }
    RejectLoanPaymentModal.prototype.componentDidMount = function() {
        var _this = this;
        var cashbondloan$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.cashbondloan;
        }));
        this.subs.push(cashbondloan$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(cashbondloan) {
            return cashbondloan.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.doModalClose();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
            else if (postPutRequestState === (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.doModalClose();
            }
        }));
    };
    RejectLoanPaymentModal.prototype.getPaymentDetailsBlock = function(props) {
        var payment = props.loanPayment;
        return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "loan-payment-modal__label text-bold"
        }, "Agent"), (0, $LjoDx.h)("p", {
            class: "text-capitalize"
        }, payment.agent.firstName, " ", payment.agent.lastName)), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "loan-payment-modal__label"
        }, "Supervisor"), (0, $LjoDx.h)("p", null, payment.supervisor)), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "loan-payment-modal__label"
        }, "Date of Transaction"), (0, $LjoDx.h)("p", null, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(payment.dateOfTransaction).format("MMMM DD, YYYY")))), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "loan-payment-modal__label"
        }, "Amount"), (0, $LjoDx.h)("p", null, "₱ ", (0, $9e0c3e3a397653e5$export$63ad841d70774900)(payment.amount))), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "loan-payment-modal__label"
        }, "Bank"), (0, $LjoDx.h)("p", null, payment.receivingBankAccount)))));
    };
    RejectLoanPaymentModal.prototype.getSpinnerBlock = function() {
        return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    RejectLoanPaymentModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return this.getSpinnerBlock();
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit
        }, "Reject Payment"))));
    };
    RejectLoanPaymentModal.prototype.render = function(props, state) {
        var _this = this;
        var _a;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal loan-payment-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Reject Loan Payment - ", (_a = props.loanPayment) === null || _a === void 0 ? void 0 : _a.loanPaymentId)), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 pb-3"
        }, this.getPaymentDetailsBlock(props))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions mt-3"
        }, this.getActionsRow(props, state)));
    };
    return RejectLoanPaymentModal;
}((0, $3f2ba7f1e3532510$exports.Modal));










var $7de11d8299f4e93d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7de11d8299f4e93d$export$a57ac6ef749f40c9 = /** @class */ function(_super) {
    $7de11d8299f4e93d$var$__extends(DashPaymentApproval, _super);
    function DashPaymentApproval(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.MODAL_APPROVE_PAYMENT = 0;
        _this.MODAL_REJECT_PAYMENT = 1;
        _this.onPageClicked = function(page) {
            var filterForm = {};
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filterForm[k] = fieldList[k].value;
            filterForm["page"] = page;
            var filters = _this.state.filters;
            filters.set("page", page);
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $9faeaaf3b7b2176c$export$b9bca83af8eb0508),
                payload: {
                    filters: filters
                }
            });
            _this.setState({
                currentPage: page
            });
        };
        _this.onModalOpened = function(paramState, row) {
            if (paramState === _this.MODAL_APPROVE_PAYMENT) _this.setState({
                modalState: paramState,
                focusedPayment: row
            });
            else if (paramState === _this.MODAL_REJECT_PAYMENT) _this.setState({
                modalState: paramState,
                focusedPayment: row
            });
        };
        _this.onModalClose = function(returnParams) {
            _this.setState({
                modalState: -1
            });
            _this.initialStoreDispatches();
        };
        _this.onFilterToggleClicked = function() {
            _this.setState({
                isFilterVisible: !_this.state.isFilterVisible
            });
        };
        _this.resetStartDates = function(returned) {
            _this.resetStartDate = returned;
        };
        _this.resetEndDates = function(returned) {
            _this.resetEndDate = returned;
        };
        _this.resetFilters = function() {
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)fieldList[k].value = null;
            _this.resetStartDate();
            _this.resetEndDate();
            var filters = new Map();
            filters.set("page", 1);
            _this.setState({
                filters: filters,
                currentPage: 1
            });
            _this.initialStoreDispatches();
        };
        _this.startDateSelected = function(date) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filterForm, "startDate", date);
        };
        _this.endDateSelected = function(date) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filterForm, "endDate", date);
        };
        _this.applyFilters = function() {
            var filters = _this.state.filters;
            var fieldList = _this.state.filterForm.fields;
            console.log(fieldList);
            for(var k in fieldList)if (fieldList[k].value) filters.set(k, fieldList[k].value);
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $9faeaaf3b7b2176c$export$b9bca83af8eb0508),
                payload: {
                    filters: filters
                }
            });
        };
        _this.onSupervisorSearchChange = function(supervisor) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filterForm, "supervisor", supervisor.username);
        };
        _this.generateReport = function() {
            var filters = new Map();
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filters.set(k, fieldList[k].value);
            filters.set("pageSize", 5000);
            filters.set("page", 1);
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $9faeaaf3b7b2176c$export$ffc6ac2cbc266632),
                payload: {
                    filters: filters
                }
            });
        };
        _this.getActionsBlock = function(state) {
            var role;
            if (state && state.currentUser) role = state.currentUser.role;
            if (role && (role === (0, $b9c3387011d11553$export$b38e98e302041724) || role === (0, $b9c3387011d11553$export$a805ed97d1d93366))) return (0, $LjoDx.h)("div", {
                class: "row"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-2 mb-3 mb-lg-0"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-secondary w-100",
                onClick: _this.generateReport
            }, "Generate Report")));
        };
        _this.getFilterBlock = function(state) {
            return (0, $LjoDx.h)("div", {
                class: "container-fluid px-0 mt-3"
            }, (0, $LjoDx.h)("div", {
                class: "row justify-content-end"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3 offset-9 d-flex justify-content-end"
            }, (0, $LjoDx.h)("a", {
                class: "dash-remittance__filter-row__filter-btn",
                onClick: _this.onFilterToggleClicked
            }, "Filter ", (0, $LjoDx.h)("i", {
                class: "fas fa-filter"
            })))), (0, $LjoDx.h)("div", {
                class: "row no-gutters"
            }, (0, $LjoDx.h)("div", {
                class: "col-12"
            }, state.isFilterVisible ? (0, $LjoDx.h)("div", {
                class: "dash-remittance__filter-row__filters mt-2"
            }, _this.getFilterForm(state), _this.getFilterActions(state)) : null)));
        };
        _this.getGridBlock = function(state) {
            return state.allPayments ? (0, $LjoDx.h)("div", {
                class: "dash-cashbon-loan___grid-container"
            }, (0, $LjoDx.h)("div", {
                class: "row mt-3"
            }, (0, $LjoDx.h)("div", {
                class: "col-12"
            }, (0, $LjoDx.h)("div", {
                class: "data-grid"
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__row header"
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "Actions"), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "Loan ID"), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "Payment ID"), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "Supervisor"), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "Agent"), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "Status"), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "Amount Paid"), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "Bank"), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "Date Paid")), state.allPayments.map(function(row, index) {
                return (0, $LjoDx.h)("div", {
                    class: "data-grid__row"
                }, (0, $LjoDx.h)("div", {
                    class: "data-grid__col"
                }, (0, $LjoDx.h)("div", {
                    class: "dropright"
                }, (0, $LjoDx.h)("button", {
                    class: "btn btn-outline-primary dropdown-toggle",
                    type: "button",
                    id: "actions".concat(index),
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                }, "Select action"), _this.getPaymentActions(state, row, index))), (0, $LjoDx.h)("div", {
                    class: "data-grid__col"
                }, row.loanId), (0, $LjoDx.h)("div", {
                    class: "data-grid__col"
                }, row.loanPaymentId), (0, $LjoDx.h)("div", {
                    class: "data-grid__col"
                }, row.supervisor), (0, $LjoDx.h)("div", {
                    class: "data-grid__col"
                }, row.agent.firstName, " ", row.agent.lastName), (0, $LjoDx.h)("div", {
                    class: "data-grid__col text-capitalize"
                }, (0, $LjoDx.h)("b", null, row.status)), (0, $LjoDx.h)("div", {
                    class: "data-grid__col"
                }, (0, $LjoDx.h)("i", null, "₱ ", (0, $9e0c3e3a397653e5$export$63ad841d70774900)(row.amount))), (0, $LjoDx.h)("div", {
                    class: "data-grid__col"
                }, row.receivingBankAccount), (0, $LjoDx.h)("div", {
                    class: "data-grid__col"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(row.dateOfTransaction).format("MMMM DD, YYYY")));
            }))))) : null;
        };
        _this.getPortalModal = function(state) {
            var modalState = state.modalState;
            if (modalState < 0) return null;
            else if (modalState === _this.MODAL_APPROVE_PAYMENT) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-124"
            }, (0, $LjoDx.h)((0, $3e52467f553dc02a$exports.ApproveLoanPaymentModal), {
                loanPayment: state.focusedPayment,
                currentUser: state.currentUser,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-123"
            })));
            else if (modalState === _this.MODAL_REJECT_PAYMENT) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-124"
            }, (0, $LjoDx.h)((0, $428c0220c3c5f49b$exports.RejectLoanPaymentModal), {
                loanPayment: state.focusedPayment,
                currentUser: state.currentUser,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-123"
            })));
        };
        var filters = new Map();
        filters.set("page", 1);
        _this.setState({
            modalState: -1,
            filters: filters,
            currentPage: 1,
            currentUser: null
        });
        _this.createForm();
        return _this;
    }
    DashPaymentApproval.prototype.createForm = function() {
        var _this = this;
        var fields = {
            startDate: new (0, $49e398741f5b1a93$export$a455218a85c89869)([]),
            endDate: new (0, $49e398741f5b1a93$export$a455218a85c89869)([]),
            loanId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([]),
            loanPaymentId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([]),
            receivingBankAccount: new (0, $49e398741f5b1a93$export$a455218a85c89869)([]),
            minAmount: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            maxAmount: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            agentId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([]),
            status: new (0, $49e398741f5b1a93$export$a455218a85c89869)([]),
            supervisor: new (0, $49e398741f5b1a93$export$a455218a85c89869)([])
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            filterForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["filterForm"] = form;
            _this.setState(state);
        });
    };
    DashPaymentApproval.prototype.componentDidMount = function() {
        var _this = this;
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.user;
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.currentUser;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(currentUser) {
            _this.setState({
                currentUser: currentUser
            });
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.allBankAccounts;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(allBankAccounts) {
            if (allBankAccounts) _this.setState({
                allBankAccounts: allBankAccounts
            });
        }));
        var cashbondLoans$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.cashbondloan;
        }));
        this.subs.push(cashbondLoans$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(cashbondloan) {
            return cashbondloan.loanPayments;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(loanPayments) {
            _this.setState({
                allPayments: loanPayments
            });
        }));
        this.subs.push(cashbondLoans$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(cashbondloan) {
            return cashbondloan.total;
        })).subscribe(function(total) {
            if (total) {
                var pages = [];
                var limit = Math.ceil(total / (0, $787290684425694f$exports.PAGE_SIZE));
                for(var i = 0; i < limit; i++)pages.push(i + 1);
                _this.setState({
                    pages: pages
                });
            }
        }));
        this.initialStoreDispatches();
    };
    DashPaymentApproval.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $9faeaaf3b7b2176c$export$b9bca83af8eb0508),
            payload: {
                filters: this.state.filters
            }
        });
        store.dispatch({
            type: (0, $4c71eb74f53637d3$export$74d61c62c586516a)
        });
    };
    DashPaymentApproval.prototype.getFilterActions = function(state) {
        if (state.isFilterVisible) return (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2 offset-lg-8"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.resetFilters
        }, "Reset Filters")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.applyFilters
        }, "Apply Filters")));
    };
    DashPaymentApproval.prototype.getFilterForm = function(state) {
        var form = state.filterForm;
        if (form && state.isFilterVisible) return (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, state.currentUser.role === (0, $b9c3387011d11553$export$b38e98e302041724) || state.currentUser.role === (0, $b9c3387011d11553$export$a805ed97d1d93366) ? (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Supervisor"), (0, $LjoDx.h)((0, $204820985097eb0a$exports.AutocompleteSearch), {
            onResultSelected: this.onSupervisorSearchChange
        })) : null, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Loan ID"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            type: "text",
            value: form.fields["loanId"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "loanId"),
            placeholder: "Loan ID"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1 mb-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Loan Payment ID"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            type: "text",
            value: form.fields["loanPaymentId"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "loanPaymentId"),
            placeholder: "Loan Payment ID"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1 mb-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Receiving Bank Account"), (0, $LjoDx.h)("select", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            placeholder: "Bank Account",
            value: form.fields["receivingBankAccount"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "receivingBankAccount")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, "Select Account"), state.allBankAccounts.map(function(acc) {
            return (0, $LjoDx.h)("option", {
                value: acc.bankAccountName
            }, acc.bankAccountName);
        }))), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1 mb-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Mininmum Amount"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            type: "text",
            value: form.fields["minAmount"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "minAmount"),
            placeholder: "Mininmum Amount"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1 mb-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Maximum Amount"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            type: "text",
            value: form.fields["maxAmount"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "maxAmount"),
            placeholder: "Maximum Amount"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Start date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: this.startDateSelected,
            initialValue: form.fields["startDate"].value,
            isValid: form.fields["startDate"].isValid,
            isPristine: form.fields["startDate"].isPristine,
            reset: this.resetStartDates
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "End date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: this.endDateSelected,
            initialValue: form.fields["endDate"].value,
            isValid: form.fields["endDate"].isValid,
            isPristine: form.fields["endDate"].isPristine,
            reset: this.resetEndDates
        })));
    };
    DashPaymentApproval.prototype.getPaymentActions = function(state, row, index) {
        var _this = this;
        var role = state.currentUser.role;
        if (role === (0, $b9c3387011d11553$export$b38e98e302041724) || role === (0, $b9c3387011d11553$export$a805ed97d1d93366)) return (0, $LjoDx.h)("div", {
            class: "dropdown-menu",
            "aria-labelledby": "actions".concat(index)
        }, (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return _this.onModalOpened(_this.MODAL_APPROVE_PAYMENT, row);
            }
        }, "Approve"), (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return _this.onModalOpened(_this.MODAL_REJECT_PAYMENT, row);
            }
        }, "Reject"));
    };
    DashPaymentApproval.prototype.getPaginationBlock = function(state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, state.pages ? (0, $LjoDx.h)("div", {
            class: "dash-remittance__pagination mb-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn dash-remittance__pagination__page arrow",
            disabled: state.currentPage === 1,
            onClick: function() {
                return _this.onPageClicked(state.currentPage - 1);
            }
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-chevron-left"
        })), state.currentPage > 5 ? (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                active: state.pages[0] === state.currentPage
            }),
            onClick: function() {
                return _this.onPageClicked(state.pages[0]);
            }
        }, state.pages[0]) : null, state.currentPage > 5 ? (0, $LjoDx.h)("span", {
            class: "mx-2"
        }, "...") : null, state.pages ? state.pages.map(function(page) {
            if (page > state.currentPage - 5 && page < state.currentPage + 5) return (0, $LjoDx.h)("button", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                    active: page === state.currentPage
                }),
                onClick: function() {
                    return _this.onPageClicked(page);
                }
            }, page);
        }) : null, state.currentPage < state.pages.length - 5 ? (0, $LjoDx.h)("span", {
            class: "mx-2"
        }, "...") : null, state.currentPage < state.pages.length - 5 ? (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                active: state.pages[state.pages.length - 1] === state.currentPage
            }),
            onClick: function() {
                return _this.onPageClicked(state.pages[state.pages.length - 1]);
            }
        }, state.pages[state.pages.length - 1]) : null, (0, $LjoDx.h)("button", {
            class: "btn dash-remittance__pagination__page arrow",
            disabled: state.currentPage === state.pages[state.pages.length - 1],
            onClick: function() {
                return _this.onPageClicked(state.currentPage + 1);
            }
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-chevron-right"
        }))) : null));
    };
    DashPaymentApproval.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "dash-cashbond-loans anglo__dashboard"
        }, this.getPortalModal(state), (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-8 col-lg-4"
        }, (0, $LjoDx.h)("nav", {
            "aria-label": "breadcrumb"
        }, (0, $LjoDx.h)("ol", {
            class: "breadcrumb"
        }, (0, $LjoDx.h)("li", {
            class: "breadcrumb-item"
        }, (0, $LjoDx.h)("a", {
            href: "/disposal"
        }, "Payments Approval")))))), this.getActionsBlock(state), this.getFilterBlock(state), this.getGridBlock(state), this.getPaginationBlock(state)));
    };
    return DashPaymentApproval;
}((0, $LjoDx.Component));


var $b46bca7d9f5a0709$exports = {};

$parcel$export($b46bca7d9f5a0709$exports, "DashCashbondPaymentApproval", () => $b46bca7d9f5a0709$export$7c850024a13b2847);

var $LjoDx = parcelRequire("LjoDx");














var $05be6d6f613d2883$exports = {};

$parcel$export($05be6d6f613d2883$exports, "ApproveBondPaymentModal", () => $05be6d6f613d2883$export$f2147ad0e99de688);

var $LjoDx = parcelRequire("LjoDx");







var $05be6d6f613d2883$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $05be6d6f613d2883$export$f2147ad0e99de688 = /** @class */ function(_super) {
    $05be6d6f613d2883$var$__extends(ApproveBondPaymentModal, _super);
    function ApproveBondPaymentModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function() {
            var _a, _b, _c;
            var bondPayment = {
                cashbondId: (_a = _this.props.bondPayment) === null || _a === void 0 ? void 0 : _a.cashbondId,
                bondPaymentId: (_b = _this.props.bondPayment) === null || _b === void 0 ? void 0 : _b.bondPaymentId,
                amount: (_c = _this.props.bondPayment) === null || _c === void 0 ? void 0 : _c.amount
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $9faeaaf3b7b2176c$export$157e6387758438c2),
                payload: {
                    cashbondPaymentToUpdate: bondPayment
                }
            });
        };
        return _this;
    }
    ApproveBondPaymentModal.prototype.componentDidMount = function() {
        var _this = this;
        var cashbondloan$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.cashbondloan;
        }));
        this.subs.push(cashbondloan$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(cashbondloan) {
            return cashbondloan.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.doModalClose();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
            else if (postPutRequestState === (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.doModalClose();
            }
        }));
    };
    ApproveBondPaymentModal.prototype.getPaymentDetailsBlock = function(props) {
        var payment = props.bondPayment;
        console.log(payment);
        return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "loan-payment-modal__label text-bold"
        }, "Agent"), (0, $LjoDx.h)("p", {
            class: "text-capitalize"
        }, payment.agent.firstName, " ", payment.agent.lastName)), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "loan-payment-modal__label"
        }, "Supervisor"), (0, $LjoDx.h)("p", null, payment.supervisor)), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "loan-payment-modal__label"
        }, "Date of Transaction"), (0, $LjoDx.h)("p", null, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(payment.dateOfTransaction).format("MMMM DD, YYYY")))), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "loan-payment-modal__label"
        }, "Amount"), (0, $LjoDx.h)("p", null, "₱ ", (0, $9e0c3e3a397653e5$export$63ad841d70774900)(payment.amount))), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "loan-payment-modal__label"
        }, "Bank"), (0, $LjoDx.h)("p", null, payment.receivingBankAccount)))));
    };
    ApproveBondPaymentModal.prototype.getSpinnerBlock = function() {
        return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    ApproveBondPaymentModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return this.getSpinnerBlock();
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit
        }, "Approve Payment"))));
    };
    ApproveBondPaymentModal.prototype.render = function(props, state) {
        var _this = this;
        var _a;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal loan-payment-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Approve Cashbond Payment - ", (_a = props.bondPayment) === null || _a === void 0 ? void 0 : _a.bondPaymentId)), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 pb-3"
        }, this.getPaymentDetailsBlock(props))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions mt-3"
        }, this.getActionsRow(props, state)));
    };
    return ApproveBondPaymentModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $c663282b4721b31d$exports = {};

$parcel$export($c663282b4721b31d$exports, "RejectBondPaymentModal", () => $c663282b4721b31d$export$5a7865c8bf02db07);

var $LjoDx = parcelRequire("LjoDx");







var $c663282b4721b31d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c663282b4721b31d$export$5a7865c8bf02db07 = /** @class */ function(_super) {
    $c663282b4721b31d$var$__extends(RejectBondPaymentModal, _super);
    function RejectBondPaymentModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function() {
            var _a;
            var bondPayment = {
                bondPaymentId: (_a = _this.props.bondPayment) === null || _a === void 0 ? void 0 : _a.bondPaymentId
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $9faeaaf3b7b2176c$export$14d190b43fbb82db),
                payload: {
                    cashbondPaymentToUpdate: bondPayment
                }
            });
        };
        return _this;
    }
    RejectBondPaymentModal.prototype.componentDidMount = function() {
        var _this = this;
        var cashbondloan$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.cashbondloan;
        }));
        this.subs.push(cashbondloan$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(cashbondloan) {
            return cashbondloan.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.doModalClose();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
            else if (postPutRequestState === (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.doModalClose();
            }
        }));
    };
    RejectBondPaymentModal.prototype.getPaymentDetailsBlock = function(props) {
        var payment = props.bondPayment;
        console.log(payment);
        return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "loan-payment-modal__label text-bold"
        }, "Agent"), (0, $LjoDx.h)("p", {
            class: "text-capitalize"
        }, payment.agent.firstName, " ", payment.agent.lastName)), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "loan-payment-modal__label"
        }, "Supervisor"), (0, $LjoDx.h)("p", null, payment.supervisor)), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "loan-payment-modal__label"
        }, "Date of Transaction"), (0, $LjoDx.h)("p", null, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(payment.dateOfTransaction).format("MMMM DD, YYYY")))), (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "loan-payment-modal__label"
        }, "Amount"), (0, $LjoDx.h)("p", null, "₱ ", (0, $9e0c3e3a397653e5$export$63ad841d70774900)(payment.amount))), (0, $LjoDx.h)("div", {
            class: "col-12 col-md-4"
        }, (0, $LjoDx.h)("label", {
            class: "loan-payment-modal__label"
        }, "Bank"), (0, $LjoDx.h)("p", null, payment.receivingBankAccount)))));
    };
    RejectBondPaymentModal.prototype.getSpinnerBlock = function() {
        return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    RejectBondPaymentModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return this.getSpinnerBlock();
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit
        }, "Reject Payment"))));
    };
    RejectBondPaymentModal.prototype.render = function(props, state) {
        var _this = this;
        var _a;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal loan-payment-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Reject Cashbond Payment - ", (_a = props.bondPayment) === null || _a === void 0 ? void 0 : _a.bondPaymentId)), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 pb-3"
        }, this.getPaymentDetailsBlock(props))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions mt-3"
        }, this.getActionsRow(props, state)));
    };
    return RejectBondPaymentModal;
}((0, $3f2ba7f1e3532510$exports.Modal));




var $b46bca7d9f5a0709$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b46bca7d9f5a0709$export$7c850024a13b2847 = /** @class */ function(_super) {
    $b46bca7d9f5a0709$var$__extends(DashCashbondPaymentApproval, _super);
    function DashCashbondPaymentApproval(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.MODAL_APPROVE_PAYMENT = 0;
        _this.MODAL_REJECT_PAYMENT = 1;
        _this.onPageClicked = function(page) {
            var filterForm = {};
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filterForm[k] = fieldList[k].value;
            filterForm["page"] = page;
            var filters = _this.state.filters;
            filters.set("page", page);
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $9faeaaf3b7b2176c$export$81f41e5e6f50faec),
                payload: {
                    filters: filters
                }
            });
            _this.setState({
                currentPage: page
            });
        };
        _this.onModalOpened = function(paramState, row) {
            if (paramState === _this.MODAL_APPROVE_PAYMENT) _this.setState({
                modalState: paramState,
                focusedPayment: row
            });
            else if (paramState === _this.MODAL_REJECT_PAYMENT) _this.setState({
                modalState: paramState,
                focusedPayment: row
            });
        };
        _this.onModalClose = function(returnParams) {
            _this.setState({
                modalState: -1
            });
            _this.initialStoreDispatches();
        };
        _this.onFilterToggleClicked = function() {
            _this.setState({
                isFilterVisible: !_this.state.isFilterVisible
            });
        };
        _this.resetStartDates = function(returned) {
            _this.resetStartDate = returned;
        };
        _this.resetEndDates = function(returned) {
            _this.resetEndDate = returned;
        };
        _this.resetFilters = function() {
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)fieldList[k].value = null;
            _this.resetStartDate();
            _this.resetEndDate();
            var filters = new Map();
            filters.set("page", 1);
            _this.setState({
                filters: filters,
                currentPage: 1
            });
            _this.initialStoreDispatches();
        };
        _this.startDateSelected = function(date) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filterForm, "startDate", date);
        };
        _this.endDateSelected = function(date) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filterForm, "endDate", date);
        };
        _this.applyFilters = function() {
            var filters = _this.state.filters;
            var fieldList = _this.state.filterForm.fields;
            console.log(fieldList);
            for(var k in fieldList)if (fieldList[k].value) filters.set(k, fieldList[k].value);
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $9faeaaf3b7b2176c$export$81f41e5e6f50faec),
                payload: {
                    filters: filters
                }
            });
        };
        _this.onSupervisorSearchChange = function(supervisor) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filterForm, "supervisor", supervisor.username);
        };
        _this.onAgentSearchChange = function(agent) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filterForm, "agentId", agent._id);
        };
        _this.generateReport = function() {
            var filters = new Map();
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filters.set(k, fieldList[k].value);
            filters.set("pageSize", 5000);
            filters.set("page", 1);
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $9faeaaf3b7b2176c$export$71767bdee8fc1b58),
                payload: {
                    filters: filters
                }
            });
        };
        _this.getActionsBlock = function(state) {
            var role;
            if (state && state.currentUser) role = state.currentUser.role;
            if (role && (role === (0, $b9c3387011d11553$export$b38e98e302041724) || role === (0, $b9c3387011d11553$export$a805ed97d1d93366))) return (0, $LjoDx.h)("div", {
                class: "row"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-2 mb-3 mb-lg-0"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-secondary w-100",
                onClick: _this.generateReport
            }, "Generate Report")));
        };
        _this.getFilterBlock = function(state) {
            return (0, $LjoDx.h)("div", {
                class: "container-fluid px-0 mt-3"
            }, (0, $LjoDx.h)("div", {
                class: "row justify-content-end"
            }, (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-3 offset-9 d-flex justify-content-end"
            }, (0, $LjoDx.h)("a", {
                class: "dash-remittance__filter-row__filter-btn",
                onClick: _this.onFilterToggleClicked
            }, "Filter ", (0, $LjoDx.h)("i", {
                class: "fas fa-filter"
            })))), (0, $LjoDx.h)("div", {
                class: "row no-gutters"
            }, (0, $LjoDx.h)("div", {
                class: "col-12"
            }, state.isFilterVisible ? (0, $LjoDx.h)("div", {
                class: "dash-remittance__filter-row__filters mt-2"
            }, _this.getFilterForm(state), _this.getFilterActions(state)) : null)));
        };
        _this.getGridBlock = function(state) {
            return state.allPayments ? (0, $LjoDx.h)("div", {
                class: "dash-cashbon-loan___grid-container"
            }, (0, $LjoDx.h)("div", {
                class: "row mt-3"
            }, (0, $LjoDx.h)("div", {
                class: "col-12"
            }, (0, $LjoDx.h)("div", {
                class: "data-grid"
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__row header"
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "Actions"), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "Loan ID"), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "Payment ID"), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "Supervisor"), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "Agent"), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "Status"), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "Amount Paid"), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "Bank"), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "Date Paid")), state.allPayments.map(function(row, index) {
                return (0, $LjoDx.h)("div", {
                    class: "data-grid__row"
                }, (0, $LjoDx.h)("div", {
                    class: "data-grid__col"
                }, (0, $LjoDx.h)("div", {
                    class: "dropright"
                }, (0, $LjoDx.h)("button", {
                    class: "btn btn-outline-primary dropdown-toggle",
                    type: "button",
                    id: "actions".concat(index),
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                }, "Select action"), _this.getPaymentActions(state, row, index))), (0, $LjoDx.h)("div", {
                    class: "data-grid__col"
                }, row.cashbondId), (0, $LjoDx.h)("div", {
                    class: "data-grid__col"
                }, row.bondPaymentId), (0, $LjoDx.h)("div", {
                    class: "data-grid__col"
                }, row.supervisor), (0, $LjoDx.h)("div", {
                    class: "data-grid__col"
                }, row.agent ? "".concat(row.agent.firstName, " ").concat(row.agent.lastName) : "N/A"), (0, $LjoDx.h)("div", {
                    class: "data-grid__col text-capitalize"
                }, (0, $LjoDx.h)("b", null, row.status)), (0, $LjoDx.h)("div", {
                    class: "data-grid__col"
                }, (0, $LjoDx.h)("i", null, "₱ ", (0, $9e0c3e3a397653e5$export$63ad841d70774900)(row.amount))), (0, $LjoDx.h)("div", {
                    class: "data-grid__col"
                }, row.receivingBankAccount), (0, $LjoDx.h)("div", {
                    class: "data-grid__col"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(row.dateOfTransaction).format("MMMM DD, YYYY")));
            }))))) : null;
        };
        _this.getPortalModal = function(state) {
            var modalState = state.modalState;
            if (modalState < 0) return null;
            else if (modalState === _this.MODAL_APPROVE_PAYMENT) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-124"
            }, (0, $LjoDx.h)((0, $05be6d6f613d2883$exports.ApproveBondPaymentModal), {
                bondPayment: state.focusedPayment,
                currentUser: state.currentUser,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-123"
            })));
            else if (modalState === _this.MODAL_REJECT_PAYMENT) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                into: "body"
            }, (0, $LjoDx.h)("div", {
                class: "anglo-modal-container",
                id: "anglo-modal-124"
            }, (0, $LjoDx.h)((0, $c663282b4721b31d$exports.RejectBondPaymentModal), {
                bondPayment: state.focusedPayment,
                currentUser: state.currentUser,
                close: _this.onModalClose,
                isOutsideClickClose: false,
                containerId: "anglo-modal-123"
            })));
        };
        var filters = new Map();
        filters.set("page", 1);
        _this.setState({
            modalState: -1,
            filters: filters,
            currentPage: 1,
            currentUser: null
        });
        _this.createForm();
        return _this;
    }
    DashCashbondPaymentApproval.prototype.createForm = function() {
        var _this = this;
        var fields = {
            startDate: new (0, $49e398741f5b1a93$export$a455218a85c89869)([]),
            endDate: new (0, $49e398741f5b1a93$export$a455218a85c89869)([]),
            cashbondId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([]),
            bondPaymentId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([]),
            receivingBankAccount: new (0, $49e398741f5b1a93$export$a455218a85c89869)([]),
            minAmount: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            maxAmount: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, ""),
            agentId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([]),
            status: new (0, $49e398741f5b1a93$export$a455218a85c89869)([]),
            supervisor: new (0, $49e398741f5b1a93$export$a455218a85c89869)([])
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            filterForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["filterForm"] = form;
            _this.setState(state);
        });
    };
    DashCashbondPaymentApproval.prototype.componentDidMount = function() {
        var _this = this;
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.user;
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.currentUser;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(currentUser) {
            _this.setState({
                currentUser: currentUser
            });
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.allBankAccounts;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(allBankAccounts) {
            if (allBankAccounts) _this.setState({
                allBankAccounts: allBankAccounts
            });
        }));
        var cashbondLoans$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.cashbondloan;
        }));
        this.subs.push(cashbondLoans$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(cashbondloan) {
            return cashbondloan.bondPayment;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(bondPayment) {
            _this.setState({
                allPayments: bondPayment
            });
        }));
        this.subs.push(cashbondLoans$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(cashbondloan) {
            return cashbondloan.total;
        })).subscribe(function(total) {
            if (total) {
                var pages = [];
                var limit = Math.ceil(total / (0, $787290684425694f$exports.PAGE_SIZE));
                for(var i = 0; i < limit; i++)pages.push(i + 1);
                _this.setState({
                    pages: pages
                });
            }
        }));
        this.initialStoreDispatches();
    };
    DashCashbondPaymentApproval.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $9faeaaf3b7b2176c$export$81f41e5e6f50faec),
            payload: {
                filters: this.state.filters
            }
        });
        store.dispatch({
            type: (0, $4c71eb74f53637d3$export$74d61c62c586516a)
        });
    };
    DashCashbondPaymentApproval.prototype.getFilterActions = function(state) {
        if (state.isFilterVisible) return (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2 offset-lg-8"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.resetFilters
        }, "Reset Filters")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.applyFilters
        }, "Apply Filters")));
    };
    DashCashbondPaymentApproval.prototype.getFilterForm = function(state) {
        var form = state.filterForm;
        if (form && state.isFilterVisible) return (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, state.currentUser.role === (0, $b9c3387011d11553$export$b38e98e302041724) || state.currentUser.role === (0, $b9c3387011d11553$export$a805ed97d1d93366) ? (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1 mb-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Supervisor"), (0, $LjoDx.h)((0, $204820985097eb0a$exports.AutocompleteSearch), {
            onResultSelected: this.onSupervisorSearchChange
        })) : null, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1 mb-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Cashbond ID"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            type: "text",
            value: form.fields["cashbondId"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "cashbondId"),
            placeholder: "Cashbond ID"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1 mb-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Bond Payment ID"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            type: "text",
            value: form.fields["bondPaymentId"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "bondPaymentId"),
            placeholder: "Bond Payment ID"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1 mb-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Receiving Bank Account"), (0, $LjoDx.h)("select", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            placeholder: "Bank Account",
            value: form.fields["receivingBankAccount"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "receivingBankAccount")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, "Select Account"), state.allBankAccounts.map(function(acc) {
            return (0, $LjoDx.h)("option", {
                value: acc.bankAccountName
            }, acc.bankAccountName);
        }))), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1 mb-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Mininmum Amount"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            type: "text",
            value: form.fields["minAmount"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "minAmount"),
            placeholder: "Mininmum Amount"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1 mb-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Maximum Amount"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            type: "text",
            value: form.fields["maxAmount"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "maxAmount"),
            placeholder: "Maximum Amount"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1 mb-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "Start date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: this.startDateSelected,
            initialValue: form.fields["startDate"].value,
            isValid: form.fields["startDate"].isValid,
            isPristine: form.fields["startDate"].isPristine,
            reset: this.resetStartDates
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-1 mb-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "End date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: this.endDateSelected,
            initialValue: form.fields["endDate"].value,
            isValid: form.fields["endDate"].isValid,
            isPristine: form.fields["endDate"].isPristine,
            reset: this.resetEndDates
        })));
    };
    DashCashbondPaymentApproval.prototype.getPaymentActions = function(state, row, index) {
        var _this = this;
        var role = state.currentUser.role;
        if (role === (0, $b9c3387011d11553$export$b38e98e302041724) || role === (0, $b9c3387011d11553$export$a805ed97d1d93366)) return (0, $LjoDx.h)("div", {
            class: "dropdown-menu",
            "aria-labelledby": "actions".concat(index)
        }, (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return _this.onModalOpened(_this.MODAL_APPROVE_PAYMENT, row);
            }
        }, "Approve"), (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return _this.onModalOpened(_this.MODAL_REJECT_PAYMENT, row);
            }
        }, "Reject"));
    };
    DashCashbondPaymentApproval.prototype.getPaginationBlock = function(state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, state.pages ? (0, $LjoDx.h)("div", {
            class: "dash-remittance__pagination mb-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn dash-remittance__pagination__page arrow",
            disabled: state.currentPage === 1,
            onClick: function() {
                return _this.onPageClicked(state.currentPage - 1);
            }
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-chevron-left"
        })), state.currentPage > 5 ? (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                active: state.pages[0] === state.currentPage
            }),
            onClick: function() {
                return _this.onPageClicked(state.pages[0]);
            }
        }, state.pages[0]) : null, state.currentPage > 5 ? (0, $LjoDx.h)("span", {
            class: "mx-2"
        }, "...") : null, state.pages ? state.pages.map(function(page) {
            if (page > state.currentPage - 5 && page < state.currentPage + 5) return (0, $LjoDx.h)("button", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                    active: page === state.currentPage
                }),
                onClick: function() {
                    return _this.onPageClicked(page);
                }
            }, page);
        }) : null, state.currentPage < state.pages.length - 5 ? (0, $LjoDx.h)("span", {
            class: "mx-2"
        }, "...") : null, state.currentPage < state.pages.length - 5 ? (0, $LjoDx.h)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn dash-remittance__pagination__page", {
                active: state.pages[state.pages.length - 1] === state.currentPage
            }),
            onClick: function() {
                return _this.onPageClicked(state.pages[state.pages.length - 1]);
            }
        }, state.pages[state.pages.length - 1]) : null, (0, $LjoDx.h)("button", {
            class: "btn dash-remittance__pagination__page arrow",
            disabled: state.currentPage === state.pages[state.pages.length - 1],
            onClick: function() {
                return _this.onPageClicked(state.currentPage + 1);
            }
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-chevron-right"
        }))) : null));
    };
    DashCashbondPaymentApproval.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "dash-cashbond-loans anglo__dashboard"
        }, this.getPortalModal(state), (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-8 col-lg-4"
        }, (0, $LjoDx.h)("nav", {
            "aria-label": "breadcrumb"
        }, (0, $LjoDx.h)("ol", {
            class: "breadcrumb"
        }, (0, $LjoDx.h)("li", {
            class: "breadcrumb-item"
        }, (0, $LjoDx.h)("a", {
            href: "/disposal"
        }, "Cashbond Payments Approval")))))), this.getActionsBlock(state), this.getFilterBlock(state), this.getGridBlock(state), this.getPaginationBlock(state)));
    };
    return DashCashbondPaymentApproval;
}((0, $LjoDx.Component));


var $06add316fd6c06e8$exports = {};

$parcel$export($06add316fd6c06e8$exports, "EmployeeDashboard", () => $06add316fd6c06e8$export$badf445b533cc005);

var $LjoDx = parcelRequire("LjoDx");









var $b116a5101fc33bec$exports = {};

$parcel$export($b116a5101fc33bec$exports, "CreateEmployeeModal", () => $b116a5101fc33bec$export$1776f12072a21a1a);

var $LjoDx = parcelRequire("LjoDx");










var $b116a5101fc33bec$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b116a5101fc33bec$export$1776f12072a21a1a = /** @class */ function(_super) {
    $b116a5101fc33bec$var$__extends(CreateEmployeeModal, _super);
    function CreateEmployeeModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.employeeForm;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            _this.setState({
                employeeForm: form
            });
            if (!_this.state.employeeForm.isValid) return;
            var employee = {
                firstName: form.fields["firstName"].value,
                lastName: form.fields["lastName"].value,
                employeeType: form.fields["employeeType"].value,
                isActive: true
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $4c71eb74f53637d3$export$86dd998f89ad8fa6),
                payload: {
                    employeeToCreate: employee,
                    supervisorUsername: _this.props.selectedSupervisor.username
                }
            });
        };
        _this.createForm();
        return _this;
    }
    CreateEmployeeModal.prototype.createForm = function() {
        var _this = this;
        var fields = {
            firstName: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            lastName: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, ""),
            employeeType: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            employeeForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["employeeForm"] = form;
            _this.setState(state);
        });
    };
    CreateEmployeeModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.user;
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.createEmployeeState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
            else if (postPutRequestState === (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            }
        }));
    };
    CreateEmployeeModal.prototype.getFormBlock = function(props, state) {
        var form = this.state.employeeForm;
        if (form) return (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12 create-employee-modal__form"
        }, (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "First Name*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["firstName"])
            }),
            type: "text",
            value: form.fields["firstName"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "firstName"),
            placeholder: "First Name"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Last Name*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["lastName"])
            }),
            type: "text",
            value: form.fields["lastName"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "lastName"),
            placeholder: "Last Name"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Employee Type*"), (0, $LjoDx.h)("select", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["employeeType"])
            }),
            placeholder: "Employee Type",
            value: form.fields["employeeType"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "employeeType")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, "Select Type"), (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "agent",
            selected: true
        }, "Agent"), (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "secretary",
            selected: true
        }, "Secretary"), (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "driver",
            selected: true
        }, "Driver"))))));
        else return (0, $LjoDx.h)("div", {
            class: "row align-center"
        }, this.getSpinnerBlock());
    };
    CreateEmployeeModal.prototype.getSpinnerBlock = function() {
        return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    CreateEmployeeModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return this.getSpinnerBlock();
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !state.employeeForm.isValid
        }, "Submit"))));
    };
    CreateEmployeeModal.prototype.render = function(props, state) {
        var _this = this;
        var _a;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-disposal-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create Employee - Supervisor Username:", " ", (_a = props.selectedSupervisor) === null || _a === void 0 ? void 0 : _a.username)), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions mt-3"
        }, this.getActionsRow(props, state)));
    };
    return CreateEmployeeModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $28efbd2627b94e6d$exports = {};

$parcel$export($28efbd2627b94e6d$exports, "EditEmployeeModal", () => $28efbd2627b94e6d$export$5b4f193f4c2e5a0a);

var $LjoDx = parcelRequire("LjoDx");










var $28efbd2627b94e6d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $28efbd2627b94e6d$export$5b4f193f4c2e5a0a = /** @class */ function(_super) {
    $28efbd2627b94e6d$var$__extends(EditEmployeeModal, _super);
    function EditEmployeeModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.employeeForm;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            _this.setState({
                employeeForm: form
            });
            if (!_this.state.employeeForm.isValid) return;
            var employee = {
                _id: _this.props.selectedEmployee._id,
                firstName: form.fields["firstName"].value,
                lastName: form.fields["lastName"].value,
                employeeType: form.fields["employeeType"].value,
                isActive: true
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $4c71eb74f53637d3$export$1f1e8f449be51a90),
                payload: {
                    employeeToCreate: employee,
                    supervisorUsername: _this.props.selectedSupervisor.username
                }
            });
        };
        _this.createForm(props);
        return _this;
    }
    EditEmployeeModal.prototype.createForm = function(props) {
        var _this = this;
        var _a, _b, _c;
        var fields = {
            firstName: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, (_a = props.selectedEmployee) === null || _a === void 0 ? void 0 : _a.firstName),
            lastName: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, (_b = props.selectedEmployee) === null || _b === void 0 ? void 0 : _b.lastName),
            employeeType: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, (_c = props.selectedEmployee) === null || _c === void 0 ? void 0 : _c.employeeType)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            employeeForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["employeeForm"] = form;
            _this.setState(state);
        });
    };
    EditEmployeeModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.user;
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.createEmployeeState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
            else if (postPutRequestState === (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            }
        }));
    };
    EditEmployeeModal.prototype.getFormBlock = function(props, state) {
        var form = this.state.employeeForm;
        if (form) return (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12 create-employee-modal__form"
        }, (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "First Name*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["firstName"])
            }),
            type: "text",
            value: form.fields["firstName"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "firstName"),
            placeholder: "First Name"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Last Name*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["lastName"])
            }),
            type: "text",
            value: form.fields["lastName"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "lastName"),
            placeholder: "Last Name"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Employee Type*"), (0, $LjoDx.h)("select", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["employeeType"])
            }),
            placeholder: "Employee Type",
            value: form.fields["employeeType"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "employeeType")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, "Select Type"), (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "agent",
            selected: true
        }, "Agent"), (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "secretary",
            selected: true
        }, "Secretary"), (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "driver",
            selected: true
        }, "Driver"))))));
        else return (0, $LjoDx.h)("div", {
            class: "row align-center"
        }, this.getSpinnerBlock());
    };
    EditEmployeeModal.prototype.getSpinnerBlock = function() {
        return (0, $LjoDx.h)("div", {
            class: "col offset-md-9 d-flex justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "spinner-border text-primary mt-3",
            role: "status"
        }, (0, $LjoDx.h)("span", {
            class: "sr-only"
        }, "Loading...")));
    };
    EditEmployeeModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return this.getSpinnerBlock();
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !state.employeeForm.isValid
        }, "Submit Edit"))));
    };
    EditEmployeeModal.prototype.render = function(props, state) {
        var _this = this;
        var _a;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-disposal-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Edit Employee - ", (_a = props.selectedEmployee) === null || _a === void 0 ? void 0 : _a.firstName, " ")), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions mt-3"
        }, this.getActionsRow(props, state)));
    };
    return EditEmployeeModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $06add316fd6c06e8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $06add316fd6c06e8$export$badf445b533cc005 = /** @class */ function(_super) {
    $06add316fd6c06e8$var$__extends(EmployeeDashboard, _super);
    function EmployeeDashboard(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.MODAL_EDIT_EMPLOYEE = 0;
        _this.MODAL_REASSIGN_EMPLOYEE = 1;
        _this.MODAL_CREATE_EMPLOYEE = 2;
        _this.onModalOpened = function(paramState, row) {
            if (paramState === _this.MODAL_CREATE_EMPLOYEE) _this.setState({
                modalState: paramState
            });
            else if (paramState === _this.MODAL_EDIT_EMPLOYEE) _this.setState({
                modalState: paramState,
                selectedEmployee: row
            });
        };
        _this.onModalClose = function(returnParams) {
            _this.setState({
                modalState: -1
            });
            _this.state.selectedSupervisor ? _this.onSupervisorClick(_this.state.selectedSupervisor) : _this.initialStoreDispatches();
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $4c71eb74f53637d3$export$ce53836c0900812a)
            });
        };
        _this.onFilterSupervisorsToggleClicked = function() {
            _this.setState({
                isSupervisorFilterVisible: !_this.state.isSupervisorFilterVisible
            });
        };
        _this.resetFilters = function() {
            var fieldList = _this.state.supervisorForm.fields;
            for(var k in fieldList)fieldList[k].value = null;
            var filters = new Map();
            _this.setState({
                supervisorFilters: filters
            });
            _this.initialStoreDispatches();
        };
        _this.applyFilters = function() {
            var supervisorFilters = _this.state.supervisorFilters;
            var supervisorFieldList = _this.state.supervisorForm.fields;
            for(var k in supervisorFieldList)if (supervisorFieldList[k].value) supervisorFilters.set(k, supervisorFieldList[k].value);
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $4c71eb74f53637d3$export$d1320805de2a0f43),
                payload: {
                    filters: supervisorFilters
                }
            });
        };
        var supervisorFilters = new Map();
        var employeeFilters = new Map();
        _this.setState({
            modalState: -1,
            supervisorFilters: supervisorFilters,
            employeeFilters: employeeFilters,
            currentUser: null,
            isSupervisorFilterVisible: false
        });
        _this.setupSupervisorFilterForm();
        _this.setupEmployeeFilterForm();
        return _this;
    }
    EmployeeDashboard.prototype.componentDidMount = function() {
        var _this = this;
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.user;
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.supervisors;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(supervisors) {
            _this.setState({
                allSupervisors: supervisors
            });
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.agents;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(agents) {
            _this.setState({
                allEmployees: agents
            });
        }));
        this.initialStoreDispatches();
    };
    EmployeeDashboard.prototype.initialStoreDispatches = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $4c71eb74f53637d3$export$d1320805de2a0f43)
        });
    };
    EmployeeDashboard.prototype.setupSupervisorFilterForm = function() {
        var _this = this;
        var fields = {
            supervisor: new (0, $49e398741f5b1a93$export$a455218a85c89869)([]),
            userSearch: new (0, $49e398741f5b1a93$export$a455218a85c89869)([])
        };
        this.supervisorForm$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            supervisorForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.supervisorForm$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {
                supervisorForm: form
            };
            _this.setState(state);
        });
    };
    EmployeeDashboard.prototype.setupEmployeeFilterForm = function() {
        var _this = this;
        var fields = {
            supervisor: new (0, $49e398741f5b1a93$export$a455218a85c89869)([]),
            agentId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([]),
            employeeType: new (0, $49e398741f5b1a93$export$a455218a85c89869)([])
        };
        this.employeeForm$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            employeeForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.employeeForm$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {
                employeeForm: form
            };
            _this.setState(state);
        });
    };
    // -------------------- HANDLERS --------------------
    EmployeeDashboard.prototype.onSupervisorClick = function(row) {
        var employeeFilters = this.state.employeeFilters;
        var employeeFieldList = this.state.employeeForm.fields;
        for(var k in employeeFieldList)if (employeeFieldList[k].value) employeeFilters.set(k, employeeFieldList[k].value);
        employeeFilters.set("supervisorUsername", row.username);
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $4c71eb74f53637d3$export$dfa3dd78ac296cf2),
            payload: {
                employeeFilters: employeeFilters
            }
        });
        this.setState({
            selectedSupervisor: row
        });
    };
    // -------------------- RENDER & BLOCKS --------------------
    EmployeeDashboard.prototype.getPortalModal = function(state) {
        var modalState = state.modalState;
        if (modalState < 0) return null;
        else if (modalState === this.MODAL_CREATE_EMPLOYEE) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
            into: "body"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-modal-container",
            id: "anglo-modal-124"
        }, (0, $LjoDx.h)((0, $b116a5101fc33bec$exports.CreateEmployeeModal), {
            selectedSupervisor: state.selectedSupervisor,
            currentUser: state.currentUser,
            close: this.onModalClose,
            isOutsideClickClose: false,
            containerId: "anglo-modal-123"
        })));
        else if (modalState === this.MODAL_EDIT_EMPLOYEE) return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
            into: "body"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-modal-container",
            id: "anglo-modal-124"
        }, (0, $LjoDx.h)((0, $28efbd2627b94e6d$exports.EditEmployeeModal), {
            selectedSupervisor: state.selectedSupervisor,
            selectedEmployee: state.selectedEmployee,
            currentUser: state.currentUser,
            close: this.onModalClose,
            isOutsideClickClose: false,
            containerId: "anglo-modal-123"
        })));
        return (0, $LjoDx.h)("div", null);
    };
    EmployeeDashboard.prototype.getSupervisorFilterForm = function(state) {
        var form = state.supervisorForm;
        if (form) return (0, $LjoDx.h)("div", {
            className: "container-fluid px-0 mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-1 mb-1"
        }, (0, $LjoDx.h)("label", {
            class: "dash-remittance__filter-row__filters__label"
        }, "User Search"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            type: "text",
            value: form.fields["userSearch"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.supervisorForm$, form, "userSearch"),
            placeholder: "User Search"
        }))));
    };
    EmployeeDashboard.prototype.getFilterActions = function(state) {
        if (state.isSupervisorFilterVisible) return (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("col-12 ", {
                "offset-lg-8 col-lg-2": !state.selectedSupervisor,
                "col-lg-6": state.selectedSupervisor
            })
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.resetFilters
        }, "Reset Filters")), (0, $LjoDx.h)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("col-12", {
                "col-lg-2": !state.selectedSupervisor,
                "col-lg-6": state.selectedSupervisor
            })
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.applyFilters
        }, "Apply Filters")));
    };
    EmployeeDashboard.prototype.getEmployeeActions = function(state, row, index) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "dropdown-menu",
            "aria-labelledby": "actions".concat(index)
        }, (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return _this.onModalOpened(_this.MODAL_EDIT_EMPLOYEE, row);
            }
        }, "Edit"));
    };
    EmployeeDashboard.prototype.getEmployeesList = function(state) {
        var _this = this;
        var _a;
        return (0, $LjoDx.h)("div", {
            class: "data-grid"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Action"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Name"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Type"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Active"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Total Loan Balance"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Total CB Balance")), state.allEmployees ? (_a = state.allEmployees) === null || _a === void 0 ? void 0 : _a.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                class: "data-grid__row"
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, (0, $LjoDx.h)("div", {
                class: "dropright"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-outline-primary dropdown-toggle",
                type: "button",
                id: "actions".concat(index),
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false"
            }, "Select action"), _this.getEmployeeActions(state, row, index))), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.firstName, " ", row.lastName), (0, $LjoDx.h)("div", {
                class: "data-grid__col text-capitalize"
            }, row.employeeType), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.isActive ? "Yes" : "No"), (0, $LjoDx.h)("div", {
                class: "data-grid__col text-capitalize"
            }, row.balance && row.balance[0] && row.balance[0].runningLoanBalance ? row.balance[0].runningLoanBalance : "N/A"), (0, $LjoDx.h)("div", {
                class: "data-grid__col text-capitalize"
            }, row.balance && row.balance[0] && row.balance[0].runningCashbondBalance ? row.balance[0].runningCashbondBalance : "N/A"));
        }) : null);
    };
    EmployeeDashboard.prototype.getEmployeeActionBar = function(state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            className: "col-7"
        }, (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12 col-lg-6 offset-lg-6"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: function(e) {
                return _this.onModalOpened(_this.MODAL_CREATE_EMPLOYEE);
            }
        }, "Create Employee"))));
    };
    EmployeeDashboard.prototype.getFilterBlock = function(state) {
        return (0, $LjoDx.h)("div", {
            class: "container-fluid px-0 mt-3 mb-2"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col"
        }, (0, $LjoDx.h)("div", {
            class: "row justify-content-end"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 offset-6 d-flex justify-content-end"
        }, (0, $LjoDx.h)("a", {
            class: "dash-remittance__filter-row__filter-btn",
            onClick: this.onFilterSupervisorsToggleClicked
        }, "Filter Supervisors ", (0, $LjoDx.h)("i", {
            class: "fas fa-filter"
        })))), (0, $LjoDx.h)("div", {
            className: "row no-gutters"
        }, (0, $LjoDx.h)("div", {
            class: "col-12"
        }, state.isSupervisorFilterVisible ? (0, $LjoDx.h)("div", {
            class: "dash-remittance__filter-row__filters mt-2"
        }, this.getSupervisorFilterForm(state), this.getFilterActions(state)) : null))), state.selectedSupervisor ? this.getEmployeeActionBar(state) : null));
    };
    EmployeeDashboard.prototype.getGridBlock = function(state) {
        var _this = this;
        var _a;
        return (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                "col-12": !state.selectedSupervisor,
                "col-5": state.selectedSupervisor
            })
        }, (0, $LjoDx.h)("div", {
            class: "data-grid"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__col col-short"
        }, "Full Name"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-short"
        }, "Username"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-short"
        }, "Active")), state.allSupervisors ? (_a = state.allSupervisors) === null || _a === void 0 ? void 0 : _a.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("data-grid__row", {
                    active: state.selectedSupervisor === row
                }),
                onClick: function() {
                    return _this.onSupervisorClick(row);
                }
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col col-short"
            }, row.firstName, " ", row.lastName), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-short"
            }, row.username), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-short"
            }, row.isActive ? "Yes" : "No"));
        }) : null)), (0, $LjoDx.h)("div", {
            class: "col-7"
        }, state.selectedSupervisor ? this.getEmployeesList(state) : null));
    };
    EmployeeDashboard.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "dash-cashbond-employee anglo__dashboard"
        }, this.getPortalModal(state), (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-8 col-lg-4"
        }, (0, $LjoDx.h)("nav", {
            "aria-label": "breadcrumb"
        }, (0, $LjoDx.h)("ol", {
            class: "breadcrumb"
        }, (0, $LjoDx.h)("li", {
            class: "breadcrumb-item"
        }, (0, $LjoDx.h)("a", {
            href: "/disposal"
        }, "Employees")))))), this.getFilterBlock(state), this.getGridBlock(state)));
    };
    return EmployeeDashboard;
}((0, $LjoDx.Component));


var $f038725d2d01793f$exports = {};

$parcel$export($f038725d2d01793f$exports, "MOTORPOOL_MODAL_VIEW_PD", () => $f038725d2d01793f$export$22d945a08b9e794);
$parcel$export($f038725d2d01793f$exports, "MOTORPOOL_MODAL_UPDATE_PD", () => $f038725d2d01793f$export$58ae6bd9dc66e50f);
$parcel$export($f038725d2d01793f$exports, "MOTORPOOL_MODAL_SIGN_PD", () => $f038725d2d01793f$export$88b7cd3d3bfdd9b3);
$parcel$export($f038725d2d01793f$exports, "MOTORPOOL_MODAL_CREATE_PO", () => $f038725d2d01793f$export$b9f23dd9ce45ff9b);
$parcel$export($f038725d2d01793f$exports, "MOTORPOOL_MODAL_APPROVE_PO", () => $f038725d2d01793f$export$fd66d32b180010f9);
$parcel$export($f038725d2d01793f$exports, "MOTORPOOL_MODAL_CREATE_RR", () => $f038725d2d01793f$export$59195327aa90e13d);
$parcel$export($f038725d2d01793f$exports, "MOTORPOOL_MODAL_EDIT_SUPPLIER", () => $f038725d2d01793f$export$433c36a6a02fb3a7);
$parcel$export($f038725d2d01793f$exports, "MotorpoolDashboard", () => $f038725d2d01793f$export$b2c45db5ec313572);

var $LjoDx = parcelRequire("LjoDx");

var $b3494da6fa501def$exports = {};

$parcel$export($b3494da6fa501def$exports, "PurchaseDocumentGrid", () => $b3494da6fa501def$export$6a65d6668f45f50c);

var $LjoDx = parcelRequire("LjoDx");














var $b3494da6fa501def$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b3494da6fa501def$export$6a65d6668f45f50c = /** @class */ function(_super) {
    $b3494da6fa501def$var$__extends(PurchaseDocumentGrid, _super);
    function PurchaseDocumentGrid(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.onFilterToggleClicked = function() {
            _this.setState({
                isFilterVisible: !_this.state.isFilterVisible
            });
        };
        _this.onPageClicked = function(page) {
            var filterForm = {};
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filterForm[k] = fieldList[k].value;
            filterForm["page"] = page;
            var filters = _this.state.filters;
            filters.set("page", page);
            _this.refreshGrid();
            _this.setState({
                currentPage: page
            });
        };
        _this.startDateSelected = function(date) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filterForm, "startDate", date);
        };
        _this.endDateSelected = function(date) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.filterForm, "endDate", date);
        };
        _this.resetStartDates = function(returned) {
            _this.resetStartDate = returned;
        };
        _this.resetEndDates = function(returned) {
            _this.resetEndDate = returned;
        };
        _this.resetFilters = function() {
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)fieldList[k].value = null;
            _this.resetStartDate();
            _this.resetEndDate();
            var filters = new Map();
            filters.set("page", 1);
            _this.setState({
                filters: filters,
                currentPage: 1
            });
            _this.initialStoreDispatches();
        };
        _this.applyFilters = function() {
            var filters = _this.state.filters;
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filters.set(k, fieldList[k].value);
            _this.setState({
                filters: filters
            });
            _this.refreshGrid();
        };
        _this.getFilterForm = function(props, state) {
            var form = state.filterForm;
            return (0, $LjoDx.h)("div", {
                class: "row mt-3"
            }, (0, $LjoDx.h)("div", {
                className: "col-12 col-lg-4"
            }, (0, $LjoDx.h)("label", {
                className: "dash-remittance__filter-row__filters__label"
            }, "Purchase Document ID"), (0, $LjoDx.h)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
                type: "text",
                value: form.fields["purchaseDocumentId"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(_this.form$, form, "purchaseDocumentId"),
                placeholder: "Purchase Document ID"
            })), (0, $LjoDx.h)("div", {
                className: "col-12 col-lg-4"
            }, (0, $LjoDx.h)("label", {
                className: "dash-remittance__filter-row__filters__label"
            }, "Requested By"), (0, $LjoDx.h)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
                type: "text",
                value: form.fields["requestedBy"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(_this.form$, form, "requestedBy"),
                placeholder: "Requested By"
            })), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-4"
            }, (0, $LjoDx.h)("label", {
                class: "dash-remittance__filter-row__filters__label"
            }, "Start date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
                onDateSelected: _this.startDateSelected,
                initialValue: form.fields["startDate"].value,
                isValid: form.fields["startDate"].isValid,
                isPristine: form.fields["startDate"].isPristine,
                reset: _this.resetStartDates
            })), (0, $LjoDx.h)("div", {
                class: "col-12 col-lg-4 mt-1"
            }, (0, $LjoDx.h)("label", {
                class: "dash-remittance__filter-row__filters__label"
            }, "End date"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
                onDateSelected: _this.endDateSelected,
                initialValue: form.fields["endDate"].value,
                isValid: form.fields["endDate"].isValid,
                isPristine: form.fields["endDate"].isPristine,
                reset: _this.resetEndDates
            })));
        };
        var filters = new Map();
        filters.set("page", 1);
        _this.setState({
            filters: filters,
            currentPage: 1
        });
        _this.createForm(props);
        if (props.refreshGrid) _this.props.refreshGrid(_this.refreshGrid);
        return _this;
    // props.onModalAction(onModalOpened('', {}))
    }
    PurchaseDocumentGrid.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            startDate: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], props.initialFilters.get("startDate")),
            endDate: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], props.initialFilters.get("endDate")),
            status: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], props.initialFilters.get("status")),
            purchaseDocumentId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], props.initialFilters.get("purchaseDocumentId")),
            requestedBy: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], props.initialFilters.get("requestedBy"))
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            filterForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["filterForm"] = form;
            _this.setState(state);
        });
    };
    PurchaseDocumentGrid.prototype.componentDidMount = function() {
        var _this = this;
        var motorpool$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.motorpool;
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.purchaseDocuments;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(purchaseDocuments) {
            _this.setState({
                data: purchaseDocuments
            });
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.pdTotal;
        })).subscribe(function(pdTotal) {
            if (pdTotal) {
                var pages = [];
                var limit = Math.ceil(pdTotal / (0, $787290684425694f$exports.PAGE_SIZE));
                for(var i = 0; i < limit; i++)pages.push(i + 1);
                _this.setState({
                    pages: pages
                });
            }
        }));
        this.initialStoreDispatches();
    };
    PurchaseDocumentGrid.prototype.initialStoreDispatches = function() {
        this.refreshGrid();
    };
    PurchaseDocumentGrid.prototype.refreshGrid = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $42d61ffa1d8a8d2b$export$2c11d93fae2a2b91),
            payload: {
                filters: this.state.filters
            }
        });
    };
    PurchaseDocumentGrid.prototype.getGridBlock = function(props, state) {
        var _this = this;
        if (state.data) return (0, $LjoDx.h)("div", {
            class: "grid-container"
        }, (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Actions"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Purchase Document ID"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Requested By"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Status"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Total Amount"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Date Created")), state.data.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                class: "data-grid__row"
            }, (0, $LjoDx.h)("div", {
                className: "data-grid__col"
            }, (0, $LjoDx.h)("div", {
                class: "dropright"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-outline-primary dropdown-toggle",
                type: "button",
                id: "actions".concat(index),
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false"
            }, "Select action"), _this.getRowActions(props, row, index))), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.purchaseDocumentId), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.requestedBy), (0, $LjoDx.h)("div", {
                class: "data-grid__col text-capitalize"
            }, $b3494da6fa501def$export$4eec53fc0f7991ea(row.status)), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.totalAmount), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(row.dateCreated).format("MMMM DD, YYYY")));
        })))));
    };
    PurchaseDocumentGrid.prototype.getRowActions = function(props, row, index) {
        return (0, $LjoDx.h)("div", {
            class: "dropdown-menu",
            "aria-labelledby": "actions".concat(index)
        }, (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return props.onModalAction((0, $3f2ba7f1e3532510$exports.onModalOpened)((0, $f038725d2d01793f$exports.MOTORPOOL_MODAL_VIEW_PD), {
                    pd: row
                }));
            }
        }, "View Purchase Document"), (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return props.onModalAction((0, $3f2ba7f1e3532510$exports.onModalOpened)((0, $f038725d2d01793f$exports.MOTORPOOL_MODAL_UPDATE_PD), {
                    pd: row
                }));
            }
        }, "Edit"), (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return props.onModalAction((0, $3f2ba7f1e3532510$exports.onModalOpened)((0, $f038725d2d01793f$exports.MOTORPOOL_MODAL_SIGN_PD), {
                    pd: row,
                    signAction: "notedBy"
                }));
            }
        }, "Note"), (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return props.onModalAction((0, $3f2ba7f1e3532510$exports.onModalOpened)((0, $f038725d2d01793f$exports.MOTORPOOL_MODAL_SIGN_PD), {
                    pd: row,
                    signAction: "requestApprovedBy"
                }));
            }
        }, "Approve"), (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return props.onModalAction((0, $3f2ba7f1e3532510$exports.onModalOpened)((0, $f038725d2d01793f$exports.MOTORPOOL_MODAL_CREATE_PO), {
                    pd: row,
                    signAction: "requestApprovedBy"
                }));
            }
        }, "Create PO"), (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return props.onModalAction((0, $3f2ba7f1e3532510$exports.onModalOpened)((0, $f038725d2d01793f$exports.MOTORPOOL_MODAL_APPROVE_PO), {
                    pd: row
                }));
            }
        }, "Approve PO"), (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return props.onModalAction((0, $3f2ba7f1e3532510$exports.onModalOpened)((0, $f038725d2d01793f$exports.MOTORPOOL_MODAL_CREATE_RR), {
                    pd: row
                }));
            }
        }, "Create Receiving Report"));
    };
    PurchaseDocumentGrid.prototype.getFilterBlock = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: ""
        }, (0, $LjoDx.h)("div", {
            className: "row justify-content-end"
        }, (0, $LjoDx.h)("div", {
            className: "col-12 col-lg-3 text-right"
        }, (0, $LjoDx.h)("a", {
            class: "dash-remittance__filter-row__filter-btn",
            onClick: this.onFilterToggleClicked
        }, "Filter ", (0, $LjoDx.h)("i", {
            class: "fas fa-filter"
        })))), (0, $LjoDx.h)("div", {
            className: "row no-gutters"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, state.isFilterVisible ? this.getFilterForm(props, state) : null, state.isFilterVisible ? this.getFilterActions(props, state) : null)));
    };
    PurchaseDocumentGrid.prototype.getFilterActions = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2 offset-lg-8"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.resetFilters
        }, "Reset Filters")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.applyFilters
        }, "Apply Filters")));
    };
    PurchaseDocumentGrid.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "dash-cashbond-loans anglo__dashboard card"
        }, (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, this.getFilterBlock(props, state), this.getGridBlock(props, state), (0, $LjoDx.h)((0, $d8c26406eab115f0$exports.GridPagination), {
            pages: state.pages,
            currentPage: state.currentPage,
            onPageClicked: this.onPageClicked
        })));
    };
    return PurchaseDocumentGrid;
}((0, $LjoDx.Component));
var $b3494da6fa501def$export$4eec53fc0f7991ea = function(key) {
    var split = key.split("-");
    if (split.length === 1) return split[0];
    else {
        var clean = split.reduce(function(prev, cur) {
            return "".concat(prev, " ").concat(cur);
        });
        return clean;
    }
};


var $85e153d92f3f7a06$exports = {};

$parcel$export($85e153d92f3f7a06$exports, "SupplierGrid", () => $85e153d92f3f7a06$export$db28a0f906c82213);

var $LjoDx = parcelRequire("LjoDx");












var $85e153d92f3f7a06$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $85e153d92f3f7a06$export$db28a0f906c82213 = /** @class */ function(_super) {
    $85e153d92f3f7a06$var$__extends(SupplierGrid, _super);
    function SupplierGrid(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.onFilterToggleClicked = function() {
            _this.setState({
                isFilterVisible: !_this.state.isFilterVisible
            });
        };
        _this.onPageClicked = function(page) {
            var filterForm = {};
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filterForm[k] = fieldList[k].value;
            filterForm["page"] = page;
            var filters = _this.state.filters;
            filters.set("page", page);
            _this.refreshGrid();
            _this.setState({
                currentPage: page
            });
        };
        _this.resetFilters = function() {
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)fieldList[k].value = null;
            var filters = new Map();
            filters.set("page", 1);
            _this.setState({
                filters: filters,
                currentPage: 1
            });
            _this.initialStoreDispatches();
        };
        _this.applyFilters = function() {
            var filters = _this.state.filters;
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filters.set(k, fieldList[k].value);
            _this.setState({
                filters: filters
            });
            _this.refreshGrid();
        };
        _this.getFilterForm = function(props, state) {
            var form = state.filterForm;
            return (0, $LjoDx.h)("div", {
                class: "row mt-3"
            }, (0, $LjoDx.h)("div", {
                className: "col-12 col-lg-4"
            }, (0, $LjoDx.h)("label", {
                className: "dash-remittance__filter-row__filters__label"
            }, "Supplier ID"), (0, $LjoDx.h)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
                type: "text",
                value: form.fields["purchaseDocumentId"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(_this.form$, form, "purchaseDocumentId"),
                placeholder: "Purchase Document ID"
            })), (0, $LjoDx.h)("div", {
                className: "col-12 col-lg-4"
            }, (0, $LjoDx.h)("label", {
                className: "dash-remittance__filter-row__filters__label"
            }, "Supplier Name"), (0, $LjoDx.h)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
                type: "text",
                value: form.fields["purchaseDocumentId"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(_this.form$, form, "purchaseDocumentId"),
                placeholder: "Purchase Document ID"
            })), (0, $LjoDx.h)("div", {
                className: "col-12 col-lg-4"
            }, (0, $LjoDx.h)("label", {
                className: "dash-remittance__filter-row__filters__label"
            }, "Address"), (0, $LjoDx.h)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
                type: "text",
                value: form.fields["requestedBy"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(_this.form$, form, "requestedBy"),
                placeholder: "Requested By"
            })), (0, $LjoDx.h)("div", {
                className: "col-12 col-lg-4"
            }, (0, $LjoDx.h)("label", {
                className: "dash-remittance__filter-row__filters__label"
            }, "TIN"), (0, $LjoDx.h)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
                type: "text",
                value: form.fields["requestedBy"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(_this.form$, form, "requestedBy"),
                placeholder: "Requested By"
            })));
        };
        var filters = new Map();
        filters.set("page", 1);
        _this.setState({
            filters: filters,
            currentPage: 1
        });
        _this.createForm(props);
        if (props.refreshGrid) _this.props.refreshGrid(_this.refreshGrid);
        return _this;
    // props.onModalAction(onModalOpened('', {}))
    }
    SupplierGrid.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            supplierName: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], props.initialFilters.get("supplierName")),
            supplierId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], props.initialFilters.get("supplierId")),
            address: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], props.initialFilters.get("address")),
            tin: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], props.initialFilters.get("tin"))
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            filterForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["filterForm"] = form;
            _this.setState(state);
        });
    };
    SupplierGrid.prototype.componentDidMount = function() {
        var _this = this;
        var motorpool$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.motorpool;
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.suppliers;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(suppliers) {
            _this.setState({
                data: suppliers
            });
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.total;
        })).subscribe(function(total) {
            if (total) {
                var pages = [];
                var limit = Math.ceil(total / (0, $787290684425694f$exports.PAGE_SIZE));
                for(var i = 0; i < limit; i++)pages.push(i + 1);
                _this.setState({
                    pages: pages
                });
            }
        }));
        this.initialStoreDispatches();
    };
    SupplierGrid.prototype.initialStoreDispatches = function() {
        this.refreshGrid();
    };
    SupplierGrid.prototype.refreshGrid = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $42d61ffa1d8a8d2b$export$4b47e70039a23c0d),
            payload: {
                filters: this.state.filters
            }
        });
    };
    SupplierGrid.prototype.getGridBlock = function(props, state) {
        var _this = this;
        if (state.data) return (0, $LjoDx.h)("div", {
            class: "grid-container"
        }, (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Actions"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Name"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Supplier ID"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Address"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "TIN")), state.data.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                class: "data-grid__row"
            }, (0, $LjoDx.h)("div", {
                className: "data-grid__col"
            }, (0, $LjoDx.h)("div", {
                class: "dropright"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-outline-primary dropdown-toggle",
                type: "button",
                id: "actions".concat(index),
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false"
            }, "Select action"), _this.getRowActions(props, row, index))), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.supplierName), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.supplierId), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.address), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.tin));
        })))));
    };
    SupplierGrid.prototype.getRowActions = function(props, row, index) {
        return (0, $LjoDx.h)("div", {
            class: "dropdown-menu",
            "aria-labelledby": "actions".concat(index)
        }, (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return props.onModalAction((0, $3f2ba7f1e3532510$exports.onModalOpened)((0, $f038725d2d01793f$exports.MOTORPOOL_MODAL_EDIT_SUPPLIER), {
                    supplier: row
                }));
            }
        }, "Edit"));
    };
    SupplierGrid.prototype.getFilterBlock = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: ""
        }, (0, $LjoDx.h)("div", {
            className: "row justify-content-end"
        }, (0, $LjoDx.h)("div", {
            className: "col-12 col-lg-3 text-right"
        }, (0, $LjoDx.h)("a", {
            class: "dash-remittance__filter-row__filter-btn",
            onClick: this.onFilterToggleClicked
        }, "Filter ", (0, $LjoDx.h)("i", {
            class: "fas fa-filter"
        })))), (0, $LjoDx.h)("div", {
            className: "row no-gutters"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, state.isFilterVisible ? this.getFilterForm(props, state) : null, state.isFilterVisible ? this.getFilterActions(props, state) : null)));
    };
    SupplierGrid.prototype.getFilterActions = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2 offset-lg-8"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.resetFilters
        }, "Reset Filters")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.applyFilters
        }, "Apply Filters")));
    };
    SupplierGrid.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "dash-cashbond-loans anglo__dashboard card"
        }, (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, this.getFilterBlock(props, state), this.getGridBlock(props, state), (0, $LjoDx.h)((0, $d8c26406eab115f0$exports.GridPagination), {
            pages: state.pages,
            currentPage: state.currentPage,
            onPageClicked: this.onPageClicked
        })));
    };
    return SupplierGrid;
}((0, $LjoDx.Component));


var $da159e80b016286b$exports = {};

$parcel$export($da159e80b016286b$exports, "ItemGrid", () => $da159e80b016286b$export$b0da79f95f552dc6);

var $LjoDx = parcelRequire("LjoDx");










var $da159e80b016286b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $da159e80b016286b$export$b0da79f95f552dc6 = /** @class */ function(_super) {
    $da159e80b016286b$var$__extends(ItemGrid, _super);
    function ItemGrid(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.onFilterToggleClicked = function() {
            _this.setState({
                isFilterVisible: !_this.state.isFilterVisible
            });
        };
        _this.onPageClicked = function(page) {
            var filterForm = {};
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filterForm[k] = fieldList[k].value;
            filterForm["page"] = page;
            var filters = _this.state.filters;
            filters.set("page", page);
            _this.refreshGrid();
            _this.setState({
                currentPage: page
            });
        };
        _this.resetFilters = function() {
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)fieldList[k].value = null;
            var filters = new Map();
            filters.set("page", 1);
            _this.setState({
                filters: filters,
                currentPage: 1
            });
            _this.initialStoreDispatches();
        };
        _this.applyFilters = function() {
            var filters = _this.state.filters;
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filters.set(k, fieldList[k].value);
            _this.setState({
                filters: filters
            });
            _this.refreshGrid();
        };
        _this.getFilterForm = function(props, state) {
            var form = state.filterForm;
            return (0, $LjoDx.h)("div", {
                class: "row mt-3"
            }, (0, $LjoDx.h)("div", {
                className: "col-12 col-lg-4"
            }, (0, $LjoDx.h)("label", {
                className: "dash-remittance__filter-row__filters__label"
            }, "Item Code"), (0, $LjoDx.h)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
                type: "text",
                value: form.fields["itemCode"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(_this.form$, form, "itemCode"),
                placeholder: "Item Code"
            })), (0, $LjoDx.h)("div", {
                className: "col-12 col-lg-4"
            }, (0, $LjoDx.h)("label", {
                className: "dash-remittance__filter-row__filters__label"
            }, "Item Name"), (0, $LjoDx.h)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
                type: "text",
                value: form.fields["name"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(_this.form$, form, "name"),
                placeholder: "Item Name"
            })), (0, $LjoDx.h)("div", {
                className: "col-12 col-lg-4"
            }, (0, $LjoDx.h)("label", {
                className: "dash-remittance__filter-row__filters__label"
            }, "Supplier ID"), (0, $LjoDx.h)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
                type: "text",
                value: form.fields["supplierId"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(_this.form$, form, "supplierId"),
                placeholder: "Supplier ID"
            })));
        };
        var filters = new Map();
        filters.set("page", 1);
        _this.setState({
            filters: filters,
            currentPage: 1
        });
        _this.createForm(props);
        if (props.refreshGrid) _this.props.refreshGrid(_this.refreshGrid);
        return _this;
    // props.onModalAction(onModalOpened('', {}))
    }
    ItemGrid.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            itemCode: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], props.initialFilters.get("itemCode")),
            name: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], props.initialFilters.get("name")),
            supplierId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], props.initialFilters.get("supplierId"))
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            filterForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["filterForm"] = form;
            _this.setState(state);
        });
    };
    ItemGrid.prototype.componentDidMount = function() {
        var _this = this;
        var motorpool$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.motorpool;
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.items;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(items) {
            _this.setState({
                data: items
            });
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.total;
        })).subscribe(function(total) {
            if (total) {
                var pages = [];
                var limit = Math.ceil(total / (0, $787290684425694f$exports.PAGE_SIZE));
                for(var i = 0; i < limit; i++)pages.push(i + 1);
                _this.setState({
                    pages: pages
                });
            }
        }));
        this.initialStoreDispatches();
    };
    ItemGrid.prototype.initialStoreDispatches = function() {
        this.refreshGrid();
    };
    ItemGrid.prototype.refreshGrid = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $42d61ffa1d8a8d2b$export$ac218852b62ed936),
            payload: {
                filters: this.state.filters
            }
        });
    };
    ItemGrid.prototype.getGridBlock = function(props, state) {
        if (state.data) return (0, $LjoDx.h)("div", {
            class: "grid-container"
        }, (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Name"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Item Code"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Supplier"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Unit Price"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Amount in Storage")), state.data.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                class: "data-grid__row"
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.name), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.itemCode), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.supplierId), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.unitPrice), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.amount));
        })))));
    };
    ItemGrid.prototype.getFilterBlock = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: ""
        }, (0, $LjoDx.h)("div", {
            className: "row justify-content-end"
        }, (0, $LjoDx.h)("div", {
            className: "col-12 col-lg-3 text-right"
        }, (0, $LjoDx.h)("a", {
            class: "dash-remittance__filter-row__filter-btn",
            onClick: this.onFilterToggleClicked
        }, "Filter ", (0, $LjoDx.h)("i", {
            class: "fas fa-filter"
        })))), (0, $LjoDx.h)("div", {
            className: "row no-gutters"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, state.isFilterVisible ? this.getFilterForm(props, state) : null, state.isFilterVisible ? this.getFilterActions(props, state) : null)));
    };
    ItemGrid.prototype.getFilterActions = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2 offset-lg-8"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.resetFilters
        }, "Reset Filters")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.applyFilters
        }, "Apply Filters")));
    };
    ItemGrid.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "dash-cashbond-loans anglo__dashboard card"
        }, (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, this.getFilterBlock(props, state), this.getGridBlock(props, state), (0, $LjoDx.h)((0, $d8c26406eab115f0$exports.GridPagination), {
            pages: state.pages,
            currentPage: state.currentPage,
            onPageClicked: this.onPageClicked
        })));
    };
    return ItemGrid;
}((0, $LjoDx.Component));


var $bc15ecc3bbe55d0e$exports = {};

$parcel$export($bc15ecc3bbe55d0e$exports, "ViewPDModal", () => $bc15ecc3bbe55d0e$export$d7fbf89c8d53f293);

var $LjoDx = parcelRequire("LjoDx");







var $bc15ecc3bbe55d0e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $bc15ecc3bbe55d0e$export$d7fbf89c8d53f293 = /** @class */ function(_super) {
    $bc15ecc3bbe55d0e$var$__extends(ViewPDModal, _super);
    function ViewPDModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            if (_this.props.close) _this.props.close();
        };
        _this.focusRR = function(rr) {
            _this.setState({
                focusedRR: rr
            });
        };
        _this.createForm(props);
        return _this;
    }
    ViewPDModal.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            status: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, props.pd.status),
            totalAmount: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, props.pd.totalAmount),
            requestedBy: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, props.pd.requestedBy)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    ViewPDModal.prototype.getFormBlock = function(props, state) {
        var form = this.state.form;
        return (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Requested By"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["requestedBy"])
            }),
            disabled: true,
            type: "text",
            value: form.fields["requestedBy"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "requestedBy"),
            placeholder: "Requested By"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Status"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["status"])
            }),
            type: "text",
            disabled: true,
            value: form.fields["status"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "status"),
            placeholder: "Status"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Total Amount"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["totalAmount"])
            }),
            type: "text",
            disabled: true,
            value: form.fields["totalAmount"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "totalAmount"),
            placeholder: "Total Amount"
        }))), this.getSignatures(props), (0, $LjoDx.h)("div", {
            className: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, this.getItemList(props.pd.itemList)))));
    };
    ViewPDModal.prototype.getSignatureBlock = function(title, fieldKey, dateFieldKey, pd) {
        if (pd[fieldKey]) return (0, $LjoDx.h)("div", {
            className: "col-3"
        }, (0, $LjoDx.h)("div", {
            className: "card signature-block"
        }, (0, $LjoDx.h)("h4", null, title), (0, $LjoDx.h)("div", {
            className: "values"
        }, (0, $LjoDx.h)("p", null, pd[fieldKey]), (0, $LjoDx.h)("p", null, (0, $LjoDx.h)("i", null, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(pd[dateFieldKey]).format("MMMM DD, YYYY"))))));
        return null;
    };
    ViewPDModal.prototype.getSignatures = function(props) {
        return (0, $LjoDx.h)("div", {
            className: "row mt-3"
        }, this.getSignatureBlock("Requested By", "requestedBy", "dateCreated", props.pd), this.getSignatureBlock("Noted By", "notedBy", "dateNoted", props.pd), this.getSignatureBlock("PR Approved By", "requestApprovedBy", "dateRequestApproved", props.pd), this.getSignatureBlock("PO Approved By", "orderApprovedBy", "dateOrdered", props.pd));
    };
    ViewPDModal.prototype.getItemList = function(itemList) {
        return (0, $LjoDx.h)("div", {
            class: "item-list data-grid"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Name"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Item Code"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Amount"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Unit Price"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Remark")), itemList.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                className: "data-grid__row"
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.name), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.itemCode), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.amount), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.unitPrice), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.remark));
        }));
    };
    ViewPDModal.prototype.getRRCard = function(rr) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            className: "col-4"
        }, (0, $LjoDx.h)("div", {
            className: "card rr-card",
            onClick: function() {
                return _this.focusRR(rr);
            }
        }, rr.receivedBy, " ", (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(rr.dateReceived).format("MMMM DD, YYYY")));
    };
    ViewPDModal.prototype.getReceivingReportBlock = function(props) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("hr", null), "Receiving Reports", (0, $LjoDx.h)("div", {
            className: "row"
        }, props.pd.receivingReportList.map(function(row, index) {
            return _this.getRRCard(row);
        })), (0, $LjoDx.h)("div", {
            className: "row mt-2"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, this.getRRItemList()))));
    };
    ViewPDModal.prototype.getRRItemList = function() {
        if (this.state.focusedRR) return this.getItemList(this.state.focusedRR.itemList);
        return null;
    };
    ViewPDModal.prototype.getReceivingReport = function(data) {
        return (0, $LjoDx.h)("div", {
            className: "card receiving-report"
        }, (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-6"
        }, (0, $LjoDx.h)("div", {
            className: "card signature-block"
        }, (0, $LjoDx.h)("h4", null, "Checked By"), (0, $LjoDx.h)("div", {
            className: "values"
        }, (0, $LjoDx.h)("p", null, data.checkedBy), (0, $LjoDx.h)("p", null, (0, $LjoDx.h)("i", null, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(data.dateChecked).format("MMMM DD, YYYY")))))), (0, $LjoDx.h)("div", {
            className: "col-6"
        }, (0, $LjoDx.h)("div", {
            className: "card signature-block"
        }, (0, $LjoDx.h)("h4", null, "Received By"), (0, $LjoDx.h)("div", {
            className: "values"
        }, (0, $LjoDx.h)("p", null, data.receivedBy), (0, $LjoDx.h)("p", null, (0, $LjoDx.h)("i", null, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(data.dateReceived).format("MMMM DD, YYYY"))))))), (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, this.getItemList(data.itemList))));
    };
    ViewPDModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-disposal-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Purchase Document | ", props.pd.purchaseDocumentId)), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state), props.pd.receivingReportList ? this.getReceivingReportBlock(props) : null)));
    };
    return ViewPDModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $2ede7c29da1f6f24$exports = {};

$parcel$export($2ede7c29da1f6f24$exports, "CreatePDModal", () => $2ede7c29da1f6f24$export$e8011de45614f75b);

var $LjoDx = parcelRequire("LjoDx");









var $ee05a9b0e0b7db62$exports = {};

$parcel$export($ee05a9b0e0b7db62$exports, "ItemSearch", () => $ee05a9b0e0b7db62$export$4058b79f59f0f9cf);

var $LjoDx = parcelRequire("LjoDx");





var $ee05a9b0e0b7db62$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ee05a9b0e0b7db62$export$4058b79f59f0f9cf = /** @class */ function(_super) {
    $ee05a9b0e0b7db62$var$__extends(ItemSearch, _super);
    function ItemSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.onOutsideClick = function(ev) {
            var target = ev.target;
            var doesContain = _this.refNode.contains(target);
            if (!doesContain) _this.setState({
                isSearchResultsVisible: false
            });
        };
        _this.onSearchInputChange = (0, $8cf160f30389af36$export$61fc7d43ac8f84b0)(function(event) {
            var searchTerm = event.target.value;
            if (searchTerm && searchTerm.length >= 2) _this.getSearchResults(searchTerm);
            _this.setState({
                search: searchTerm
            });
        }, 500);
        _this.onResultClick = function(result) {
            var label = result.name;
            _this.setState({
                search: label,
                searchResults: [],
                isSearchResultsVisible: false
            });
            _this.props.onResultSelected(result);
        };
        _this.setState({
            searchResults: []
        });
        if (props.initialValue) _this.setState({
            search: props.initialValue
        });
        return _this;
    }
    ItemSearch.prototype.componentDidMount = function() {
        document.body.addEventListener("mousedown", this.onOutsideClick, false);
    };
    ItemSearch.prototype.componentWillUnmount = function() {
        document.body.removeEventListener("mousedown", this.onOutsideClick, false);
    };
    ItemSearch.prototype.getSearchResults = function(searchTerm) {
        var _this = this;
        var params = {
            itemSearch: searchTerm,
            page: 1
        };
        var axiosPromise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/item"), {
            params: params,
            withCredentials: true
        });
        axiosPromise.then(function(response) {
            var results = response.data[0].data;
            if (results && results.length > 0) _this.setState({
                searchResults: results,
                isSearchResultsVisible: true
            });
        }).catch(function(errResp) {
            var message = errResp.response.data.msg ? errResp.response.data.msg : null;
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to retrieve search",
                message: message,
                duration: 3000
            });
        });
    };
    ItemSearch.prototype.render = function(props, state) {
        var _this = this;
        var result = function(member, index) {
            return (0, $LjoDx.h)("p", {
                onClick: _this.onResultClick.bind(_this, member)
            }, member.name, " - ", (0, $LjoDx.h)("i", null, member.itemCode), " - ", (0, $LjoDx.h)("i", null, member.supplierId), " ", "- ", (0, $LjoDx.h)("b", null, member.amount, " Available"));
        };
        return (0, $LjoDx.h)("div", {
            class: "autocomplete-search",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("autocomplete-search__input form-control"),
            disabled: props.disabled,
            placeholder: "Search for an item name or code",
            value: state.search,
            onInput: this.onSearchInputChange.bind(this)
        }), (0, $LjoDx.h)("span", {
            class: "autocomplete-search__icon"
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-search"
        })), (0, $LjoDx.h)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("autocomplete-search__results", {
                active: state.isSearchResultsVisible
            })
        }, this.state.searchResults.map(function(member, i) {
            return result(member, i);
        })));
    };
    return ItemSearch;
}((0, $LjoDx.Component));





var $2ede7c29da1f6f24$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2ede7c29da1f6f24$export$e8011de45614f75b = /** @class */ function(_super) {
    $2ede7c29da1f6f24$var$__extends(CreatePDModal, _super);
    function CreatePDModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            if (_this.props.close) _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var pd = {
                requestedBy: form.fields["requestedBy"].value,
                itemList: _this.state.itemList
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $42d61ffa1d8a8d2b$export$e85b08d1656584fd),
                payload: {
                    purchaseDocumentToCreate: pd
                }
            });
        };
        _this.onItemSelected = function(a) {
            var itemList = _this.state.itemList;
            var existing = itemList.find(function(member) {
                return member.itemCode === a.itemCode;
            });
            if (!existing) {
                // brute force setting amount to 1 (we don't set the amount in system)
                a.amount = 1;
                itemList.push(a);
                _this.setState({
                    itemList: itemList
                });
            }
        };
        _this.getRunningTotal = function() {
            var runningTotal = 0;
            var itemList = _this.state.itemList;
            itemList.forEach(function(i) {
                runningTotal += i.amount * i.unitPrice;
            });
            return runningTotal;
        };
        _this.removeItem = function(index) {
            var itemList = _this.state.itemList;
            itemList.splice(index, 1);
            _this.setState({
                itemList: itemList
            });
        };
        _this.onItemAmountChange = function(event, index) {
            var target = event.target;
            var value = target.value;
            var itemList = _this.state.itemList;
            itemList[index].amount = value;
            _this.setState({
                itemList: itemList
            });
        };
        _this.createForm(props);
        _this.setState({
            itemList: []
        });
        return _this;
    }
    CreatePDModal.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            requestedBy: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    CreatePDModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var motorpool$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.motorpool;
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
        }));
    };
    CreatePDModal.prototype.getFormBlock = function(props, state) {
        var form = this.state.form;
        return (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Requested By"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["requestedBy"])
            }),
            type: "text",
            value: form.fields["requestedBy"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "requestedBy"),
            placeholder: "Requested By"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)((0, $ee05a9b0e0b7db62$exports.ItemSearch), {
            onResultSelected: this.onItemSelected
        }))), (0, $LjoDx.h)("div", {
            className: "row my-2"
        }, (0, $LjoDx.h)("div", {
            className: "col-12 col-lg-4 offset-lg-8 text-right"
        }, (0, $LjoDx.h)("p", {
            class: "mb-0"
        }, (0, $LjoDx.h)("b", null, "Running Total: ₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(this.getRunningTotal()))))), (0, $LjoDx.h)("div", {
            className: "row mt-2"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, state.itemList.length > 0 ? this.getItemList(state.itemList) : null))));
    };
    CreatePDModal.prototype.getItemList = function(itemList) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "item-list data-grid"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Name"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Item Code"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Supplier"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Unit Price"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-short"
        }, "Amount"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Total"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-short"
        }, "Remove")), itemList.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                className: "data-grid__row"
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.name), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.itemCode), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.supplierId), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(row.unitPrice)), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-short"
            }, (0, $LjoDx.h)("input", {
                className: "form-control",
                type: "number",
                value: row.amount,
                onChange: function(ev) {
                    return _this.onItemAmountChange(ev, index);
                },
                placeholder: "Requested By"
            })), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(row.unitPrice * row.amount)), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-short"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-outline-dark",
                onClick: function(ev) {
                    return _this.removeItem(index);
                }
            }, (0, $LjoDx.h)("i", {
                class: "fas fa-trash"
            }))));
        }));
    };
    CreatePDModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return (0, $75d6025062e781ef$export$89b84a018a9c9ba3)(state.isPostInProgress);
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !state.form.isValid
        }, "Submit"))));
    };
    CreatePDModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-pd-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create Purchase Document")), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions"
        }, this.getActionsRow(props, state)));
    };
    return CreatePDModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $760746ce9635f486$exports = {};

$parcel$export($760746ce9635f486$exports, "UpdatePDModal", () => $760746ce9635f486$export$252a9760d4267c1);

var $LjoDx = parcelRequire("LjoDx");













var $760746ce9635f486$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $760746ce9635f486$export$252a9760d4267c1 = /** @class */ function(_super) {
    $760746ce9635f486$var$__extends(UpdatePDModal, _super);
    function UpdatePDModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            if (_this.props.close) _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var pd = {
                requestedBy: form.fields["requestedBy"].value,
                itemList: _this.state.itemList
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $42d61ffa1d8a8d2b$export$f30ae27113e62e75),
                payload: {
                    purchaseDocumentToUpdate: pd
                }
            });
        };
        _this.onItemSelected = function(a) {
            var itemList = _this.state.itemList;
            var existing = itemList.find(function(member) {
                return member.itemCode === a.itemCode;
            });
            if (!existing) {
                // brute force setting amount to 1 (we don't set the amount in system)
                a.amount = 1;
                itemList.push(a);
                _this.setState({
                    itemList: itemList
                });
            }
        };
        _this.getRunningTotal = function() {
            var runningTotal = 0;
            var itemList = _this.state.itemList;
            itemList.forEach(function(i) {
                runningTotal += i.amount * i.unitPrice;
            });
            return runningTotal;
        };
        _this.removeItem = function(index) {
            var itemList = _this.state.itemList;
            itemList.splice(index, 1);
            _this.setState({
                itemList: itemList
            });
        };
        _this.onItemAmountChange = function(event, index) {
            var target = event.target;
            var value = target.value;
            var itemList = _this.state.itemList;
            itemList[index].amount = value;
            _this.setState({
                itemList: itemList
            });
        };
        _this.createForm(props);
        _this.setState({
            itemList: props.pd.itemList
        });
        return _this;
    }
    UpdatePDModal.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            status: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, props.pd.status),
            requestedBy: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, props.pd.requestedBy)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    UpdatePDModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var motorpool$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.motorpool;
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
        }));
    };
    UpdatePDModal.prototype.getFormBlock = function(props, state) {
        var form = this.state.form;
        if (!form) return;
        return (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Requested By"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["requestedBy"])
            }),
            type: "text",
            value: form.fields["requestedBy"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "requestedBy"),
            placeholder: "Requested By"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Status"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["status"])
            }),
            type: "text",
            value: form.fields["status"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "status"),
            placeholder: "Status"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)((0, $ee05a9b0e0b7db62$exports.ItemSearch), {
            onResultSelected: this.onItemSelected
        }))), (0, $LjoDx.h)("div", {
            className: "row my-2"
        }, (0, $LjoDx.h)("div", {
            className: "col-12 col-lg-4 offset-lg-8 text-right"
        }, (0, $LjoDx.h)("p", {
            class: "mb-0"
        }, (0, $LjoDx.h)("b", null, "Running Total: ₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(this.getRunningTotal()))))), (0, $LjoDx.h)("div", {
            className: "row mt-2"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, state.itemList.length > 0 ? this.getItemList(state.itemList) : null))));
    };
    UpdatePDModal.prototype.getItemList = function(itemList) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "item-list data-grid"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Name"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Item Code"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Supplier"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Unit Price"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-short"
        }, "Amount"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Total"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-short"
        }, "Remove")), itemList.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                className: "data-grid__row"
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.name), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.itemCode), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.supplierId), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(row.unitPrice)), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-short"
            }, (0, $LjoDx.h)("input", {
                className: "form-control",
                type: "number",
                value: row.amount,
                onChange: function(ev) {
                    return _this.onItemAmountChange(ev, index);
                },
                placeholder: "Requested By"
            })), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(row.unitPrice * row.amount)), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-short"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-outline-dark",
                onClick: function(ev) {
                    return _this.removeItem(index);
                }
            }, (0, $LjoDx.h)("i", {
                class: "fas fa-trash"
            }))));
        }));
    };
    UpdatePDModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return (0, $75d6025062e781ef$export$89b84a018a9c9ba3)(state.isPostInProgress);
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !state.form.isValid
        }, "Submit"))));
    };
    UpdatePDModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-pd-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Update Purchase Document | ", props.pd.purchaseDocumentId)), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions"
        }, this.getActionsRow(props, state)));
    };
    return UpdatePDModal;
}((0, $3f2ba7f1e3532510$exports.Modal));



var $25a31ca3275c2a33$exports = {};

$parcel$export($25a31ca3275c2a33$exports, "CreateRRModal", () => $25a31ca3275c2a33$export$c7bc92c122d129c7);

var $LjoDx = parcelRequire("LjoDx");














var $25a31ca3275c2a33$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $25a31ca3275c2a33$export$c7bc92c122d129c7 = /** @class */ function(_super) {
    $25a31ca3275c2a33$var$__extends(CreateRRModal, _super);
    function CreateRRModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            if (_this.props.close) _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var receivingReport = {
                checkedBy: form.fields["checkedBy"].value,
                dateChecked: form.fields["dateChecked"].value,
                receivedBy: form.fields["receivedBy"].value,
                dateReceived: form.fields["dateReceived"].value,
                itemList: _this.state.itemList
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $42d61ffa1d8a8d2b$export$219ad08fb66a8ce9),
                payload: {
                    purchaseDocumentId: _this.props.pd.purchaseDocumentId,
                    receivingReport: receivingReport
                }
            });
        };
        _this.onItemSelected = function(a) {
            var itemList = _this.state.itemList;
            var existing = itemList.find(function(member) {
                return member.itemCode === a.itemCode;
            });
            if (!existing) {
                // brute force setting amount to 1 (we don't set the amount in system)
                a.amount = 1;
                itemList.push(a);
                _this.setState({
                    itemList: itemList
                });
            }
        };
        _this.onDateSelected = function(date, fieldName) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.form, fieldName, date);
        };
        _this.removeItem = function(index) {
            var itemList = _this.state.itemList;
            itemList.splice(index, 1);
            _this.setState({
                itemList: itemList
            });
        };
        _this.onItemAmountChange = function(event, index) {
            var target = event.target;
            var value = target.value;
            var itemList = _this.state.itemList;
            itemList[index].amount = value;
            _this.setState({
                itemList: itemList
            });
        };
        _this.createForm(props);
        _this.setState({
            itemList: []
        });
        return _this;
    }
    CreateRRModal.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            checkedBy: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null),
            dateChecked: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null),
            receivedBy: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null),
            dateReceived: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null),
            receivingRemarks: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, null)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    CreateRRModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var motorpool$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.motorpool;
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
        }));
    };
    CreateRRModal.prototype.getFormBlock = function(props, state) {
        var _this = this;
        var form = this.state.form;
        if (!form) return;
        return (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Received By*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["receivedBy"])
            }),
            type: "text",
            value: form.fields["receivedBy"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "receivedBy"),
            placeholder: "Received By"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Date of Checking*"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: function(returned) {
                return _this.onDateSelected(returned, "dateReceived");
            },
            initialValue: form.fields["dateReceived"].value,
            isValid: form.fields["dateReceived"].isValid,
            isPristine: form.fields["dateReceived"].isPristine
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Checked By*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["checkedBy"])
            }),
            type: "text",
            value: form.fields["checkedBy"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "checkedBy"),
            placeholder: "Checked By"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Date of Checking*"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: function(returned) {
                return _this.onDateSelected(returned, "dateChecked");
            },
            initialValue: form.fields["dateChecked"].value,
            isValid: form.fields["dateChecked"].isValid,
            isPristine: form.fields["dateChecked"].isPristine
        }))), (0, $LjoDx.h)("hr", null), (0, $LjoDx.h)("p", {
            class: "m-0"
        }, (0, $LjoDx.h)("b", null, "Receiving Report Item List")), (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)((0, $ee05a9b0e0b7db62$exports.ItemSearch), {
            onResultSelected: this.onItemSelected
        }))), (0, $LjoDx.h)("div", {
            className: "row mt-2"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, state.itemList.length > 0 ? this.getItemList(state.itemList) : null))));
    };
    CreateRRModal.prototype.getItemList = function(itemList) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "item-list data-grid"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Name"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Item Code"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Supplier"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Unit Price"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-short"
        }, "Amount"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Total"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-short"
        }, "Remove")), itemList.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                className: "data-grid__row"
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.name), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.itemCode), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.supplierId), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(row.unitPrice)), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-short"
            }, (0, $LjoDx.h)("input", {
                className: "form-control",
                type: "number",
                value: row.amount,
                onChange: function(ev) {
                    return _this.onItemAmountChange(ev, index);
                },
                placeholder: "Requested By"
            })), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(row.unitPrice * row.amount)), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-short"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-outline-dark",
                onClick: function(ev) {
                    return _this.removeItem(index);
                }
            }, (0, $LjoDx.h)("i", {
                class: "fas fa-trash"
            }))));
        }));
    };
    CreateRRModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return (0, $75d6025062e781ef$export$89b84a018a9c9ba3)(state.isPostInProgress);
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !state.form.isValid
        }, "Submit"))));
    };
    CreateRRModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-pd-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create Receiving Report | ", props.pd.purchaseDocumentId)), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions"
        }, this.getActionsRow(props, state)));
    };
    return CreateRRModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $bf831a9bb0c3f85f$exports = {};

$parcel$export($bf831a9bb0c3f85f$exports, "CreateSupplierModal", () => $bf831a9bb0c3f85f$export$7a433e9a99362a02);

var $LjoDx = parcelRequire("LjoDx");











var $bf831a9bb0c3f85f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $bf831a9bb0c3f85f$export$7a433e9a99362a02 = /** @class */ function(_super) {
    $bf831a9bb0c3f85f$var$__extends(CreateSupplierModal, _super);
    function CreateSupplierModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            if (_this.props.close) _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var supplier = {
                supplierName: form.fields["supplierName"].value,
                supplierId: form.fields["supplierId"].value,
                address: form.fields["address"].value,
                tin: form.fields["tin"].value
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $42d61ffa1d8a8d2b$export$7a1acd13345d31d1),
                payload: {
                    supplierToCreate: supplier
                }
            });
        };
        _this.createForm(props);
        return _this;
    }
    CreateSupplierModal.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            supplierName: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null),
            supplierId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, null),
            address: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null),
            tin: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    CreateSupplierModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var motorpool$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.motorpool;
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
        }));
    };
    CreateSupplierModal.prototype.getFormBlock = function(props, state) {
        var form = this.state.form;
        return (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Supplier Name*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["supplierName"])
            }),
            type: "text",
            value: form.fields["supplierName"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "supplierName"),
            placeholder: "Supplier Name"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Suggested Supplier ID"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["supplierId"])
            }),
            type: "text",
            value: form.fields["supplierId"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "supplierId"),
            placeholder: "Suggested Supplier ID"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Address*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["address"])
            }),
            type: "text",
            value: form.fields["address"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "address"),
            placeholder: "Address"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Tin*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["tin"])
            }),
            type: "text",
            value: form.fields["tin"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "tin"),
            placeholder: "Tin"
        })))));
    };
    CreateSupplierModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return (0, $75d6025062e781ef$export$89b84a018a9c9ba3)(state.isPostInProgress);
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !state.form.isValid
        }, "Submit"))));
    };
    CreateSupplierModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-pd-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create Supplier")), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions"
        }, this.getActionsRow(props, state)));
    };
    return CreateSupplierModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $5422f878b5edd325$exports = {};

$parcel$export($5422f878b5edd325$exports, "EditSupplierModal", () => $5422f878b5edd325$export$6eaf6c103a50f57c);

var $LjoDx = parcelRequire("LjoDx");











var $5422f878b5edd325$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5422f878b5edd325$export$6eaf6c103a50f57c = /** @class */ function(_super) {
    $5422f878b5edd325$var$__extends(EditSupplierModal, _super);
    function EditSupplierModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            if (_this.props.close) _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var supplier = {
                supplierName: form.fields["supplierName"].value,
                supplierId: form.fields["supplierId"].value,
                address: form.fields["address"].value,
                tin: form.fields["tin"].value
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $a7963103f67f283b$export$93c8384e69cddb3d),
                payload: {
                    supplierToEdit: supplier
                }
            });
        };
        _this.createForm(props);
        return _this;
    }
    EditSupplierModal.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            supplierName: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, props.supplier.supplierName),
            supplierId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, props.supplier.supplierId),
            address: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, props.supplier.address),
            tin: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, props.supplier.tin)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    EditSupplierModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var motorpool$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.motorpool;
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
        }));
    };
    EditSupplierModal.prototype.getFormBlock = function(props, state) {
        var form = this.state.form;
        return (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Supplier Name*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["supplierName"])
            }),
            type: "text",
            value: form.fields["supplierName"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "supplierName"),
            placeholder: "Supplier Name"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Suggested Supplier ID"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["supplierId"])
            }),
            type: "text",
            disabled: true,
            value: form.fields["supplierId"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "supplierId"),
            placeholder: "Suggested Supplier ID"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Address*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["address"])
            }),
            type: "text",
            value: form.fields["address"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "address"),
            placeholder: "Address"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Tin*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["tin"])
            }),
            type: "text",
            value: form.fields["tin"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "tin"),
            placeholder: "Tin"
        })))));
    };
    EditSupplierModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return (0, $75d6025062e781ef$export$89b84a018a9c9ba3)(state.isPostInProgress);
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !state.form.isValid
        }, "Submit"))));
    };
    EditSupplierModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-pd-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create Supplier")), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions"
        }, this.getActionsRow(props, state)));
    };
    return EditSupplierModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $3fe14ced3c105f7b$exports = {};

$parcel$export($3fe14ced3c105f7b$exports, "CreatePOModal", () => $3fe14ced3c105f7b$export$658928ac0649620a);

var $LjoDx = parcelRequire("LjoDx");











var $3fe14ced3c105f7b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3fe14ced3c105f7b$export$658928ac0649620a = /** @class */ function(_super) {
    $3fe14ced3c105f7b$var$__extends(CreatePOModal, _super);
    function CreatePOModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            if (_this.props.close) _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var purchaseDocumentSignPayload = {
                purchaseDocumentId: _this.props.pd.purchaseDocumentId
            };
            purchaseDocumentSignPayload["orderNumber"] = form.fields["orderNumber"].value;
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $42d61ffa1d8a8d2b$export$c732d4e88ae15264),
                payload: {
                    purchaseDocumentSignPayload: purchaseDocumentSignPayload
                }
            });
        };
        _this.createForm(props);
        return _this;
    }
    CreatePOModal.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            orderNumber: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    CreatePOModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var motorpool$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.motorpool;
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
        }));
    };
    CreatePOModal.prototype.getFormBlock = function(props, state) {
        var form = this.state.form;
        return (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Purchase Order Number"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["orderNumber"])
            }),
            type: "text",
            value: form.fields["orderNumber"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "orderNumber"),
            placeholder: "Purchase Order Number"
        })))));
    };
    CreatePOModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return (0, $75d6025062e781ef$export$89b84a018a9c9ba3)(state.isPostInProgress);
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !state.form.isValid
        }, "Submit"))));
    };
    CreatePOModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-pd-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create Purchase Order for PD | ", props.pd.purchaseDocumentId)), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions"
        }, this.getActionsRow(props, state)));
    };
    return CreatePOModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $4fccf0739fe3345e$exports = {};

$parcel$export($4fccf0739fe3345e$exports, "CreateItemModal", () => $4fccf0739fe3345e$export$9b389693e6eca17d);

var $LjoDx = parcelRequire("LjoDx");











var $b90b068f390e1d99$exports = {};

$parcel$export($b90b068f390e1d99$exports, "SupplierSearch", () => $b90b068f390e1d99$export$86163bed9b7c257c);

var $LjoDx = parcelRequire("LjoDx");





var $b90b068f390e1d99$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b90b068f390e1d99$export$86163bed9b7c257c = /** @class */ function(_super) {
    $b90b068f390e1d99$var$__extends(SupplierSearch, _super);
    function SupplierSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.onOutsideClick = function(ev) {
            var target = ev.target;
            var doesContain = _this.refNode.contains(target);
            if (!doesContain) _this.setState({
                isSearchResultsVisible: false
            });
        };
        _this.onSearchInputChange = (0, $8cf160f30389af36$export$61fc7d43ac8f84b0)(function(event) {
            var searchTerm = event.target.value;
            if (searchTerm && searchTerm.length >= 2) _this.getSearchResults(searchTerm);
            _this.setState({
                search: searchTerm
            });
        }, 500);
        _this.onResultClick = function(result) {
            var label = result.name;
            _this.setState({
                search: label,
                searchResults: [],
                isSearchResultsVisible: false
            });
            _this.props.onResultSelected(result);
        };
        _this.setState({
            searchResults: []
        });
        if (props.initialValue) _this.setState({
            search: props.initialValue
        });
        return _this;
    }
    SupplierSearch.prototype.componentDidMount = function() {
        document.body.addEventListener("mousedown", this.onOutsideClick, false);
    };
    SupplierSearch.prototype.componentWillUnmount = function() {
        document.body.removeEventListener("mousedown", this.onOutsideClick, false);
    };
    SupplierSearch.prototype.getSearchResults = function(searchTerm) {
        var _this = this;
        var params = {
            searchTerm: searchTerm,
            page: 1
        };
        var axiosPromise = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get("".concat((0, $6ac96fa96dbfc52a$export$6a92ee59a864e7f2), "/motorpool/supplier"), {
            params: params,
            withCredentials: true
        });
        axiosPromise.then(function(response) {
            var results = response.data[0].data;
            if (results && results.length > 0) _this.setState({
                searchResults: results,
                isSearchResultsVisible: true
            });
        }).catch(function(errResp) {
            var message = errResp.response.data.msg ? errResp.response.data.msg : null;
            (0, $7a4e6c0902e6b5c3$export$f6cef6fcf9ca4e17)({
                title: "Failed to retrieve search",
                message: message,
                duration: 3000
            });
        });
    };
    SupplierSearch.prototype.render = function(props, state) {
        var _this = this;
        var result = function(member, index) {
            return (0, $LjoDx.h)("p", {
                onClick: _this.onResultClick.bind(_this, member)
            }, member.supplierName, " - ", member.supplierId, " - ", member.tin);
        };
        return (0, $LjoDx.h)("div", {
            class: "autocomplete-search",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("input", {
            type: "text",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("autocomplete-search__input form-control"),
            disabled: props.disabled,
            placeholder: "Search for an supplier name",
            value: state.search,
            onInput: this.onSearchInputChange.bind(this)
        }), (0, $LjoDx.h)("span", {
            class: "autocomplete-search__icon"
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-search"
        })), (0, $LjoDx.h)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("autocomplete-search__results", {
                active: state.isSearchResultsVisible
            })
        }, this.state.searchResults.map(function(member, i) {
            return result(member, i);
        })));
    };
    return SupplierSearch;
}((0, $LjoDx.Component));


var $4fccf0739fe3345e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4fccf0739fe3345e$export$9b389693e6eca17d = /** @class */ function(_super) {
    $4fccf0739fe3345e$var$__extends(CreateItemModal, _super);
    function CreateItemModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            if (_this.props.close) _this.props.close();
        };
        _this.onSupplierSelected = function(a) {
            var form = _this.state.form;
            form.fields["supplierId"].value = a.supplierId;
            _this.setState({
                form: form
            });
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var item = {
                name: form.fields["name"].value,
                itemCode: form.fields["itemCode"].value,
                supplierId: form.fields["supplierId"].value,
                unitPrice: form.fields["unitPrice"].value,
                amount: form.fields["amount"].value,
                description: form.fields["description"].value
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $42d61ffa1d8a8d2b$export$12c5a76e8711aaf9),
                payload: {
                    itemToCreate: item
                }
            });
        };
        _this.createForm(props);
        return _this;
    }
    CreateItemModal.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            name: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null),
            itemCode: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, null),
            supplierId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null),
            unitPrice: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null),
            amount: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, null),
            description: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    CreateItemModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var motorpool$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.motorpool;
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
        }));
    };
    CreateItemModal.prototype.getFormBlock = function(props, state) {
        var form = this.state.form;
        return (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Name*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["name"])
            }),
            type: "text",
            value: form.fields["name"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "name"),
            placeholder: "Name"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Item Code"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["itemCode"])
            }),
            type: "text",
            value: form.fields["itemCode"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "itemCode"),
            placeholder: "Item Code"
        })), (0, $LjoDx.h)("hr", null), (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)((0, $b90b068f390e1d99$exports.SupplierSearch), {
            onResultSelected: this.onSupplierSelected
        })), form.fields["supplierId"].value ? (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Selected Supplier*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["supplierId"])
            }),
            type: "text",
            disabled: true,
            value: form.fields["supplierId"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "supplierId"),
            placeholder: "Selected Supplier"
        })) : null, (0, $LjoDx.h)("hr", null), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Unit Price*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["unitPrice"])
            }),
            type: "text",
            value: form.fields["unitPrice"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "unitPrice"),
            placeholder: "Unit Price"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Amount"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["amount"])
            }),
            type: "text",
            value: form.fields["amount"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "amount"),
            placeholder: "Amount"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Description"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["description"])
            }),
            type: "text",
            value: form.fields["description"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "description"),
            placeholder: "Description"
        })))));
    };
    CreateItemModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return (0, $75d6025062e781ef$export$89b84a018a9c9ba3)(state.isPostInProgress);
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !state.form.isValid
        }, "Submit"))));
    };
    CreateItemModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-pd-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create Item")), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions"
        }, this.getActionsRow(props, state)));
    };
    return CreateItemModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $834ce4ecb48b3c86$exports = {};

$parcel$export($834ce4ecb48b3c86$exports, "JOB_ORDER_MODAL_VIEW_JO", () => $834ce4ecb48b3c86$export$6f49c11ea5bc340d);
$parcel$export($834ce4ecb48b3c86$exports, "JOB_ORDER_MODAL_CREATE_JO", () => $834ce4ecb48b3c86$export$22acd5346b3aab6c);
$parcel$export($834ce4ecb48b3c86$exports, "JOB_ORDER_MODAL_EDIT_JO", () => $834ce4ecb48b3c86$export$2507a1defa7e68ec);
$parcel$export($834ce4ecb48b3c86$exports, "JOB_ORDER_MODAL_VIEW_WITHDRAWAL", () => $834ce4ecb48b3c86$export$e1169109c1927f13);
$parcel$export($834ce4ecb48b3c86$exports, "JOB_ORDER_MODAL_APPROVE_IW", () => $834ce4ecb48b3c86$export$7d7cc4283a1aa4e0);
$parcel$export($834ce4ecb48b3c86$exports, "JobOrderDashboard", () => $834ce4ecb48b3c86$export$4660271701e3719);

var $LjoDx = parcelRequire("LjoDx");

var $51ce3c4ea72e932e$exports = {};

$parcel$export($51ce3c4ea72e932e$exports, "ItemWithdrawalGrid", () => $51ce3c4ea72e932e$export$b3334bcdb04a8c1c);

var $LjoDx = parcelRequire("LjoDx");












var $51ce3c4ea72e932e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $51ce3c4ea72e932e$export$b3334bcdb04a8c1c = /** @class */ function(_super) {
    $51ce3c4ea72e932e$var$__extends(ItemWithdrawalGrid, _super);
    function ItemWithdrawalGrid(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.onFilterToggleClicked = function() {
            _this.setState({
                isFilterVisible: !_this.state.isFilterVisible
            });
        };
        _this.onPageClicked = function(page) {
            var filterForm = {};
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filterForm[k] = fieldList[k].value;
            filterForm["page"] = page;
            var filters = _this.state.filters;
            filters.set("page", page);
            _this.refreshGrid();
            _this.setState({
                currentPage: page
            });
        };
        _this.resetFilters = function() {
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)fieldList[k].value = null;
            var filters = new Map();
            filters.set("page", 1);
            _this.setState({
                filters: filters,
                currentPage: 1
            });
            _this.initialStoreDispatches();
        };
        _this.applyFilters = function() {
            var filters = _this.state.filters;
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filters.set(k, fieldList[k].value);
            _this.setState({
                filters: filters
            });
            _this.refreshGrid();
        };
        _this.getFilterForm = function(props, state) {
            var form = state.filterForm;
            return (0, $LjoDx.h)("div", {
                class: "row mt-3"
            }, (0, $LjoDx.h)("div", {
                className: "col-12 col-lg-4"
            }, (0, $LjoDx.h)("label", {
                className: "dash-remittance__filter-row__filters__label"
            }, "Supplier ID"), (0, $LjoDx.h)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
                type: "text",
                value: form.fields["purchaseDocumentId"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(_this.form$, form, "purchaseDocumentId"),
                placeholder: "Purchase Document ID"
            })), (0, $LjoDx.h)("div", {
                className: "col-12 col-lg-4"
            }, (0, $LjoDx.h)("label", {
                className: "dash-remittance__filter-row__filters__label"
            }, "Supplier Name"), (0, $LjoDx.h)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
                type: "text",
                value: form.fields["purchaseDocumentId"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(_this.form$, form, "purchaseDocumentId"),
                placeholder: "Purchase Document ID"
            })), (0, $LjoDx.h)("div", {
                className: "col-12 col-lg-4"
            }, (0, $LjoDx.h)("label", {
                className: "dash-remittance__filter-row__filters__label"
            }, "Address"), (0, $LjoDx.h)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
                type: "text",
                value: form.fields["requestedBy"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(_this.form$, form, "requestedBy"),
                placeholder: "Requested By"
            })), (0, $LjoDx.h)("div", {
                className: "col-12 col-lg-4"
            }, (0, $LjoDx.h)("label", {
                className: "dash-remittance__filter-row__filters__label"
            }, "TIN"), (0, $LjoDx.h)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
                type: "text",
                value: form.fields["requestedBy"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(_this.form$, form, "requestedBy"),
                placeholder: "Requested By"
            })));
        };
        var filters = new Map();
        filters.set("page", 1);
        _this.setState({
            filters: filters,
            currentPage: 1
        });
        _this.createForm(props);
        if (props.refreshGrid) _this.props.refreshGrid(_this.refreshGrid);
        return _this;
    // props.onModalAction(onModalOpened('', {}))
    }
    ItemWithdrawalGrid.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            supplierName: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], props.initialFilters.get("supplierName")),
            supplierId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], props.initialFilters.get("supplierId")),
            address: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], props.initialFilters.get("address")),
            tin: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], props.initialFilters.get("tin"))
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            filterForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["filterForm"] = form;
            _this.setState(state);
        });
    };
    ItemWithdrawalGrid.prototype.componentDidMount = function() {
        var _this = this;
        var motorpool$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.motorpool;
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.itemWithdrawals;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(itemWithdrawals) {
            _this.setState({
                data: itemWithdrawals
            });
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.total;
        })).subscribe(function(total) {
            if (total) {
                var pages = [];
                var limit = Math.ceil(total / (0, $787290684425694f$exports.PAGE_SIZE));
                for(var i = 0; i < limit; i++)pages.push(i + 1);
                _this.setState({
                    pages: pages
                });
            }
        }));
        this.initialStoreDispatches();
    };
    ItemWithdrawalGrid.prototype.initialStoreDispatches = function() {
        this.refreshGrid();
    };
    ItemWithdrawalGrid.prototype.refreshGrid = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $42d61ffa1d8a8d2b$export$8c063221a5c296f6),
            payload: {
                filters: this.state.filters
            }
        });
    };
    ItemWithdrawalGrid.prototype.getGridBlock = function(props, state) {
        var _this = this;
        if (state.data) return (0, $LjoDx.h)("div", {
            class: "grid-container"
        }, (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Actions"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Withdrawal ID"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Requested By"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Status")), state.data.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                class: "data-grid__row"
            }, (0, $LjoDx.h)("div", {
                className: "data-grid__col"
            }, (0, $LjoDx.h)("div", {
                class: "dropright"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-outline-primary dropdown-toggle",
                type: "button",
                id: "actions".concat(index),
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false"
            }, "Select action"), _this.getRowActions(props, row, index))), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.itemWithdrawalId), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.requestedBy), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.status));
        })))));
    };
    ItemWithdrawalGrid.prototype.getRowActions = function(props, row, index) {
        return (0, $LjoDx.h)("div", {
            class: "dropdown-menu",
            "aria-labelledby": "actions".concat(index)
        }, (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return props.onModalAction((0, $3f2ba7f1e3532510$exports.onModalOpened)((0, $834ce4ecb48b3c86$exports.JOB_ORDER_MODAL_VIEW_WITHDRAWAL), {
                    iw: row
                }));
            }
        }, "View"), (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return props.onModalAction((0, $3f2ba7f1e3532510$exports.onModalOpened)((0, $834ce4ecb48b3c86$exports.JOB_ORDER_MODAL_APPROVE_IW), {
                    iw: row,
                    isApproval: false
                }));
            }
        }, "Process"), (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return props.onModalAction((0, $3f2ba7f1e3532510$exports.onModalOpened)((0, $834ce4ecb48b3c86$exports.JOB_ORDER_MODAL_APPROVE_IW), {
                    iw: row,
                    isApproval: true
                }));
            }
        }, "Approve"));
    };
    ItemWithdrawalGrid.prototype.getFilterBlock = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: ""
        }, (0, $LjoDx.h)("div", {
            className: "row justify-content-end"
        }, (0, $LjoDx.h)("div", {
            className: "col-12 col-lg-3 text-right"
        }, (0, $LjoDx.h)("a", {
            class: "dash-remittance__filter-row__filter-btn",
            onClick: this.onFilterToggleClicked
        }, "Filter ", (0, $LjoDx.h)("i", {
            class: "fas fa-filter"
        })))), (0, $LjoDx.h)("div", {
            className: "row no-gutters"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, state.isFilterVisible ? this.getFilterForm(props, state) : null, state.isFilterVisible ? this.getFilterActions(props, state) : null)));
    };
    ItemWithdrawalGrid.prototype.getFilterActions = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2 offset-lg-8"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.resetFilters
        }, "Reset Filters")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.applyFilters
        }, "Apply Filters")));
    };
    ItemWithdrawalGrid.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "dash-cashbond-loans anglo__dashboard card"
        }, (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, this.getFilterBlock(props, state), this.getGridBlock(props, state), (0, $LjoDx.h)((0, $d8c26406eab115f0$exports.GridPagination), {
            pages: state.pages,
            currentPage: state.currentPage,
            onPageClicked: this.onPageClicked
        })));
    };
    return ItemWithdrawalGrid;
}((0, $LjoDx.Component));


var $9d50a51026bdf4b4$exports = {};

$parcel$export($9d50a51026bdf4b4$exports, "JobOrderGrid", () => $9d50a51026bdf4b4$export$da6aaffdb9b630f0);

var $LjoDx = parcelRequire("LjoDx");












var $9d50a51026bdf4b4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9d50a51026bdf4b4$export$da6aaffdb9b630f0 = /** @class */ function(_super) {
    $9d50a51026bdf4b4$var$__extends(JobOrderGrid, _super);
    function JobOrderGrid(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.onFilterToggleClicked = function() {
            _this.setState({
                isFilterVisible: !_this.state.isFilterVisible
            });
        };
        _this.onPageClicked = function(page) {
            var filterForm = {};
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filterForm[k] = fieldList[k].value;
            filterForm["page"] = page;
            var filters = _this.state.filters;
            filters.set("page", page);
            _this.refreshGrid();
            _this.setState({
                currentPage: page
            });
        };
        _this.resetFilters = function() {
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)fieldList[k].value = null;
            var filters = new Map();
            filters.set("page", 1);
            _this.setState({
                filters: filters,
                currentPage: 1
            });
            _this.initialStoreDispatches();
        };
        _this.applyFilters = function() {
            var filters = _this.state.filters;
            var fieldList = _this.state.filterForm.fields;
            for(var k in fieldList)if (fieldList[k].value) filters.set(k, fieldList[k].value);
            _this.setState({
                filters: filters
            });
            _this.refreshGrid();
        };
        _this.getFilterForm = function(props, state) {
            var form = state.filterForm;
            return (0, $LjoDx.h)("div", {
                class: "row mt-3"
            }, (0, $LjoDx.h)("div", {
                className: "col-12 col-lg-4"
            }, (0, $LjoDx.h)("label", {
                className: "dash-remittance__filter-row__filters__label"
            }, "Supplier ID"), (0, $LjoDx.h)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
                type: "text",
                value: form.fields["purchaseDocumentId"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(_this.form$, form, "purchaseDocumentId"),
                placeholder: "Purchase Document ID"
            })), (0, $LjoDx.h)("div", {
                className: "col-12 col-lg-4"
            }, (0, $LjoDx.h)("label", {
                className: "dash-remittance__filter-row__filters__label"
            }, "Supplier Name"), (0, $LjoDx.h)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
                type: "text",
                value: form.fields["purchaseDocumentId"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(_this.form$, form, "purchaseDocumentId"),
                placeholder: "Purchase Document ID"
            })), (0, $LjoDx.h)("div", {
                className: "col-12 col-lg-4"
            }, (0, $LjoDx.h)("label", {
                className: "dash-remittance__filter-row__filters__label"
            }, "Address"), (0, $LjoDx.h)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
                type: "text",
                value: form.fields["requestedBy"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(_this.form$, form, "requestedBy"),
                placeholder: "Requested By"
            })), (0, $LjoDx.h)("div", {
                className: "col-12 col-lg-4"
            }, (0, $LjoDx.h)("label", {
                className: "dash-remittance__filter-row__filters__label"
            }, "TIN"), (0, $LjoDx.h)("input", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
                type: "text",
                value: form.fields["requestedBy"].value,
                onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(_this.form$, form, "requestedBy"),
                placeholder: "Requested By"
            })));
        };
        var filters = new Map();
        filters.set("page", 1);
        _this.setState({
            filters: filters,
            currentPage: 1
        });
        _this.createForm(props);
        if (props.refreshGrid) _this.props.refreshGrid(_this.refreshGrid);
        return _this;
    // props.onModalAction(onModalOpened('', {}))
    }
    JobOrderGrid.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            supplierName: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], props.initialFilters.get("supplierName")),
            supplierId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], props.initialFilters.get("supplierId")),
            address: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], props.initialFilters.get("address")),
            tin: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], [], props.initialFilters.get("tin"))
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            filterForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["filterForm"] = form;
            _this.setState(state);
        });
    };
    JobOrderGrid.prototype.componentDidMount = function() {
        var _this = this;
        var motorpool$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.motorpool;
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.jobOrders;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(jobOrders) {
            _this.setState({
                data: jobOrders
            });
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.total;
        })).subscribe(function(total) {
            if (total) {
                var pages = [];
                var limit = Math.ceil(total / (0, $787290684425694f$exports.PAGE_SIZE));
                for(var i = 0; i < limit; i++)pages.push(i + 1);
                _this.setState({
                    pages: pages
                });
            }
        }));
        this.initialStoreDispatches();
    };
    JobOrderGrid.prototype.initialStoreDispatches = function() {
        this.refreshGrid();
    };
    JobOrderGrid.prototype.refreshGrid = function() {
        var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
        store.dispatch({
            type: (0, $42d61ffa1d8a8d2b$export$dd693b166ab0dca),
            payload: {
                filters: this.state.filters
            }
        });
    };
    JobOrderGrid.prototype.getGridBlock = function(props, state) {
        var _this = this;
        if (state.data) return (0, $LjoDx.h)("div", {
            class: "grid-container"
        }, (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Actions"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Job Order ID"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Vehicle ID"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Type"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Status"), (0, $LjoDx.h)("div", {
            className: "data-grid__col"
        }, "Assigned")), state.data.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                class: "data-grid__row"
            }, (0, $LjoDx.h)("div", {
                className: "data-grid__col"
            }, (0, $LjoDx.h)("div", {
                class: "dropright"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-outline-primary dropdown-toggle",
                type: "button",
                id: "actions".concat(index),
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false"
            }, "Select action"), _this.getRowActions(props, row, index))), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.jobOrderId), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.vehicleId), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.type), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.status), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.assignedPerson));
        })))));
    };
    JobOrderGrid.prototype.getRowActions = function(props, row, index) {
        return (0, $LjoDx.h)("div", {
            class: "dropdown-menu",
            "aria-labelledby": "actions".concat(index)
        }, (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return props.onModalAction((0, $3f2ba7f1e3532510$exports.onModalOpened)((0, $834ce4ecb48b3c86$exports.JOB_ORDER_MODAL_VIEW_JO), {
                    jo: row
                }));
            }
        }, "View"), (0, $LjoDx.h)("button", {
            class: "dropdown-item",
            onClick: function(e) {
                return props.onModalAction((0, $3f2ba7f1e3532510$exports.onModalOpened)((0, $834ce4ecb48b3c86$exports.JOB_ORDER_MODAL_EDIT_JO), {
                    jo: row
                }));
            }
        }, "Edit"));
    };
    JobOrderGrid.prototype.getFilterBlock = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: ""
        }, (0, $LjoDx.h)("div", {
            className: "row justify-content-end"
        }, (0, $LjoDx.h)("div", {
            className: "col-12 col-lg-3 text-right"
        }, (0, $LjoDx.h)("a", {
            class: "dash-remittance__filter-row__filter-btn",
            onClick: this.onFilterToggleClicked
        }, "Filter ", (0, $LjoDx.h)("i", {
            class: "fas fa-filter"
        })))), (0, $LjoDx.h)("div", {
            className: "row no-gutters"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, state.isFilterVisible ? this.getFilterForm(props, state) : null, state.isFilterVisible ? this.getFilterActions(props, state) : null)));
    };
    JobOrderGrid.prototype.getFilterActions = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2 offset-lg-8"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.resetFilters
        }, "Reset Filters")), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-secondary w-100",
            onClick: this.applyFilters
        }, "Apply Filters")));
    };
    JobOrderGrid.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "dash-cashbond-loans anglo__dashboard card"
        }, (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, this.getFilterBlock(props, state), this.getGridBlock(props, state), (0, $LjoDx.h)((0, $d8c26406eab115f0$exports.GridPagination), {
            pages: state.pages,
            currentPage: state.currentPage,
            onPageClicked: this.onPageClicked
        })));
    };
    return JobOrderGrid;
}((0, $LjoDx.Component));


var $cc5fa9831f73e2ab$exports = {};

$parcel$export($cc5fa9831f73e2ab$exports, "CreateJOModal", () => $cc5fa9831f73e2ab$export$893ad0c7b3e811bd);

var $LjoDx = parcelRequire("LjoDx");











const $fa252804671e36f2$export$12263d9d824049bb = "latero";
const $fa252804671e36f2$export$99057e3dabeaa67a = "electronics";
const $fa252804671e36f2$export$ed85bfac6a239fbf = "engine-repairs";
const $fa252804671e36f2$export$3a1eb1b0e953aee1 = "parts-replacement";
const $fa252804671e36f2$export$89df8e5f819ed9d8 = [
    $fa252804671e36f2$export$12263d9d824049bb,
    $fa252804671e36f2$export$99057e3dabeaa67a,
    $fa252804671e36f2$export$ed85bfac6a239fbf,
    $fa252804671e36f2$export$3a1eb1b0e953aee1
];
const $fa252804671e36f2$export$39c246f0236d1ee1 = "pending";
const $fa252804671e36f2$export$b065ef3429f86935 = "fulfillment";
const $fa252804671e36f2$export$c6b7a96520858792 = "on-hold";
const $fa252804671e36f2$export$5340900f0f405fa8 = "completed";
const $fa252804671e36f2$export$3bb18e542e53f02d = "cancelled";
const $fa252804671e36f2$export$4ed479ac13dfe56e = [
    $fa252804671e36f2$export$39c246f0236d1ee1,
    $fa252804671e36f2$export$b065ef3429f86935,
    $fa252804671e36f2$export$c6b7a96520858792,
    $fa252804671e36f2$export$3bb18e542e53f02d,
    $fa252804671e36f2$export$5340900f0f405fa8
];


var $cc5fa9831f73e2ab$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $cc5fa9831f73e2ab$export$893ad0c7b3e811bd = /** @class */ function(_super) {
    $cc5fa9831f73e2ab$var$__extends(CreateJOModal, _super);
    function CreateJOModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            if (_this.props.close) _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var jo = {
                itemWithdrawalId: form.fields["itemWithdrawalId"].value,
                vehicleId: form.fields["vehicleId"].value,
                description: form.fields["description"].value,
                type: form.fields["type"].value,
                assignedPerson: form.fields["assignedPerson"].value
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $42d61ffa1d8a8d2b$export$b756dd7da319f967),
                payload: {
                    joToCreate: jo
                }
            });
        };
        _this.createForm(props);
        return _this;
    }
    CreateJOModal.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            vehicleId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null),
            description: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null),
            type: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null),
            itemWithdrawalId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, null),
            assignedPerson: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, null)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    CreateJOModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var motorpool$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.motorpool;
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
        }));
    };
    CreateJOModal.prototype.getFormBlock = function(props, state) {
        var form = this.state.form;
        return (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Vehicle ID*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["vehicleId"])
            }),
            type: "text",
            value: form.fields["vehicleId"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "vehicleId"),
            placeholder: "Vehicle ID"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Item Withdrawal ID"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["itemWithdrawalId"])
            }),
            type: "text",
            value: form.fields["itemWithdrawalId"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "itemWithdrawalId"),
            placeholder: "Item Withdrawal ID"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Description*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["description"])
            }),
            type: "text",
            value: form.fields["description"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "description"),
            placeholder: "Description"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Job Order Type*"), (0, $LjoDx.h)("select", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            placeholder: "Bank Account",
            value: form.fields["type"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "type")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, "Select Job Order Type"), (0, $fa252804671e36f2$export$89df8e5f819ed9d8).map(function(acc) {
            return (0, $LjoDx.h)("option", {
                value: acc
            }, acc);
        }))), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Assigned Person"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["assignedPerson"])
            }),
            type: "text",
            value: form.fields["assignedPerson"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "assignedPerson"),
            placeholder: "Assigned Person"
        })))));
    };
    CreateJOModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return (0, $75d6025062e781ef$export$89b84a018a9c9ba3)(state.isPostInProgress);
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !state.form.isValid
        }, "Submit"))));
    };
    CreateJOModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-pd-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create Job Order")), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions"
        }, this.getActionsRow(props, state)));
    };
    return CreateJOModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $d8ad319637854a84$exports = {};

$parcel$export($d8ad319637854a84$exports, "CreateIWModal", () => $d8ad319637854a84$export$51bf7919d989626);

var $LjoDx = parcelRequire("LjoDx");













var $d8ad319637854a84$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d8ad319637854a84$export$51bf7919d989626 = /** @class */ function(_super) {
    $d8ad319637854a84$var$__extends(CreateIWModal, _super);
    function CreateIWModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            if (_this.props.close) _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var iw = {
                requestedBy: form.fields["requestedBy"].value,
                reason: form.fields["reason"].value,
                itemCodes: _this.state.itemList
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $42d61ffa1d8a8d2b$export$957a5f118c67b29c),
                payload: {
                    iwToCreate: iw
                }
            });
        };
        _this.onItemSelected = function(a) {
            var itemList = _this.state.itemList;
            var existing = itemList.find(function(member) {
                return member.itemCode === a.itemCode;
            });
            a.amountStock = a.amount;
            if (!existing) {
                // brute force setting amount to 1 (we don't set the amount in system)
                a.amount = 1;
                itemList.push(a);
                _this.setState({
                    itemList: itemList
                });
            }
        };
        _this.onDateSelected = function(date, fieldName) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.form, fieldName, date);
        };
        _this.removeItem = function(index) {
            var itemList = _this.state.itemList;
            itemList.splice(index, 1);
            _this.setState({
                itemList: itemList
            });
        };
        _this.onItemAmountChange = function(event, index) {
            var target = event.target;
            var value = target.value;
            var itemList = _this.state.itemList;
            itemList[index].amount = value;
            _this.setState({
                itemList: itemList
            });
        };
        _this.createForm(props);
        _this.setState({
            itemList: []
        });
        return _this;
    }
    CreateIWModal.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            requestedBy: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null),
            reason: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    CreateIWModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var motorpool$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.motorpool;
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
        }));
    };
    CreateIWModal.prototype.getFormBlock = function(props, state) {
        var form = this.state.form;
        if (!form) return;
        return (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Requested By*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["requestedBy"])
            }),
            type: "text",
            value: form.fields["requestedBy"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "requestedBy"),
            placeholder: "Requested By"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Reason*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["reason"])
            }),
            type: "text",
            value: form.fields["reason"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "reason"),
            placeholder: "Reason"
        }))), (0, $LjoDx.h)("hr", null), (0, $LjoDx.h)("p", {
            class: "m-0"
        }, (0, $LjoDx.h)("b", null, "Items to be Withdrawn")), (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)((0, $ee05a9b0e0b7db62$exports.ItemSearch), {
            onResultSelected: this.onItemSelected
        }))), (0, $LjoDx.h)("div", {
            className: "row mt-2"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, state.itemList.length > 0 ? this.getItemList(state.itemList) : null))));
    };
    CreateIWModal.prototype.getItemList = function(itemList) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "item-list data-grid"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Name"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Item Code"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Supplier"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-short"
        }, "Unit Price"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-short"
        }, "Available In Stock"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-short"
        }, "Amount"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Total"), (0, $LjoDx.h)("div", {
            class: "data-grid__col col-short"
        }, "Remove")), itemList.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                className: "data-grid__row"
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.name), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.itemCode), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.supplierId), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-short"
            }, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(row.unitPrice)), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-short"
            }, row.amountStock), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-short"
            }, (0, $LjoDx.h)("input", {
                className: "form-control",
                type: "number",
                value: row.amount,
                onChange: function(ev) {
                    return _this.onItemAmountChange(ev, index);
                },
                placeholder: "Requested By"
            })), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, "₱ ", (0, $9e0c3e3a397653e5$export$a81f732198733497)(row.unitPrice * row.amount)), (0, $LjoDx.h)("div", {
                class: "data-grid__col col-short"
            }, (0, $LjoDx.h)("button", {
                class: "btn btn-outline-dark",
                onClick: function(ev) {
                    return _this.removeItem(index);
                }
            }, (0, $LjoDx.h)("i", {
                class: "fas fa-trash"
            }))));
        }));
    };
    CreateIWModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return (0, $75d6025062e781ef$export$89b84a018a9c9ba3)(state.isPostInProgress);
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !state.form.isValid
        }, "Submit"))));
    };
    CreateIWModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-pd-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Create Item Withdrawal")), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions"
        }, this.getActionsRow(props, state)));
    };
    return CreateIWModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $6f97c06eff28aa74$exports = {};

$parcel$export($6f97c06eff28aa74$exports, "ViewIWModal", () => $6f97c06eff28aa74$export$4e5612190641f7f1);

var $LjoDx = parcelRequire("LjoDx");







var $6f97c06eff28aa74$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6f97c06eff28aa74$export$4e5612190641f7f1 = /** @class */ function(_super) {
    $6f97c06eff28aa74$var$__extends(ViewIWModal, _super);
    function ViewIWModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            if (_this.props.close) _this.props.close();
        };
        _this.createForm(props);
        return _this;
    }
    ViewIWModal.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            reason: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, props.iw.reason),
            requestedBy: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, props.iw.requestedBy),
            status: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, props.iw.status)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    ViewIWModal.prototype.getFormBlock = function(props, state) {
        var form = this.state.form;
        return (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Requested By"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["requestedBy"])
            }),
            disabled: true,
            type: "text",
            value: form.fields["requestedBy"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "requestedBy"),
            placeholder: "Requested By"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Status"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["status"])
            }),
            type: "text",
            disabled: true,
            value: form.fields["status"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "status"),
            placeholder: "Status"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Reason"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["reason"])
            }),
            type: "text",
            disabled: true,
            value: form.fields["reason"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "reason"),
            placeholder: "Reason"
        }))), this.getSignatures(props), (0, $LjoDx.h)("div", {
            className: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, this.getItemList(props.iw.itemCodes)))));
    };
    ViewIWModal.prototype.getSignatureBlock = function(title, fieldKey, dateFieldKey, iw) {
        if (iw[fieldKey]) return (0, $LjoDx.h)("div", {
            className: "col-3"
        }, (0, $LjoDx.h)("div", {
            className: "card signature-block"
        }, (0, $LjoDx.h)("h4", null, title), (0, $LjoDx.h)("div", {
            className: "values"
        }, (0, $LjoDx.h)("p", null, iw[fieldKey]), (0, $LjoDx.h)("p", null, (0, $LjoDx.h)("i", null, (0, (/*@__PURE__*/$parcel$interopDefault($8f0643c1e1a747fe$exports)))(iw[dateFieldKey]).format("MMMM DD, YYYY"))))));
        return null;
    };
    ViewIWModal.prototype.getSignatures = function(props) {
        return (0, $LjoDx.h)("div", {
            className: "row mt-3"
        }, this.getSignatureBlock("Processed By", "processedBy", "dateProcessed", props.iw), this.getSignatureBlock("Approved By", "approvedBy", "dateApproved", props.iw));
    };
    ViewIWModal.prototype.getItemList = function(itemList) {
        return (0, $LjoDx.h)("div", {
            class: "item-list data-grid"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Name"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Item Code"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Amount"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Unit Price"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Remark")), itemList.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                className: "data-grid__row"
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.name), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.itemCode), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.amount), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.unitPrice), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.remark));
        }));
    };
    ViewIWModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-disposal-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Item Withdrawal | ", props.iw.itemWithdrawalId)), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))));
    };
    return ViewIWModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $9f360ec5d73f3028$exports = {};

$parcel$export($9f360ec5d73f3028$exports, "SignIWModal", () => $9f360ec5d73f3028$export$9f5b8b7278cbfc6e);

var $LjoDx = parcelRequire("LjoDx");












var $9f360ec5d73f3028$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9f360ec5d73f3028$export$9f5b8b7278cbfc6e = /** @class */ function(_super) {
    $9f360ec5d73f3028$var$__extends(SignIWModal, _super);
    function SignIWModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            if (_this.props.close) _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var iw = _this.props.iw;
            var actionByName = _this.props.isApproval ? "approvedBy" : "processedBy";
            var dateName = _this.props.isApproval ? "dateApproved" : "dateProcessed";
            var actionType = _this.props.isApproval ? (0, $42d61ffa1d8a8d2b$export$8f972aa3ca99dbc7) : (0, $42d61ffa1d8a8d2b$export$80f60acd99fb252a);
            var iwSignPayload = {
                itemWithdrawalId: _this.props.iw.itemWithdrawalId
            };
            iwSignPayload[actionByName] = form.fields["actionBy"].value;
            iwSignPayload[dateName] = form.fields["dateAction"].value;
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: actionType,
                payload: {
                    iwSignPayload: iwSignPayload
                }
            });
        };
        _this.onDateSelected = function(date, fieldName) {
            (0, $7689db45fd0b6293$export$1065ee7c53aa27ff)(_this.form$, _this.state.form, fieldName, date);
        };
        _this.createForm(props);
        return _this;
    }
    SignIWModal.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            actionBy: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null),
            dateAction: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    SignIWModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var motorpool$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.motorpool;
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
        }));
    };
    SignIWModal.prototype.getFormBlock = function(props, state) {
        var _this = this;
        var form = this.state.form;
        var actionByName = props.isApproval ? "Approved By" : "Processed By";
        var dateName = props.isApproval ? "Date of Approval" : "Date of Processed";
        return (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, actionByName, "*"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["actionBy"])
            }),
            type: "text",
            value: form.fields["actionBy"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "actionBy"),
            placeholder: actionByName
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, dateName, "*"), (0, $LjoDx.h)((0, $beda7ca2e1efa502$exports.DatePicker), {
            onDateSelected: function(returned) {
                return _this.onDateSelected(returned, "dateAction");
            },
            initialValue: form.fields["dateAction"].value,
            isValid: form.fields["dateAction"].isValid,
            isPristine: form.fields["dateAction"].isPristine
        })))));
    };
    SignIWModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return (0, $75d6025062e781ef$export$89b84a018a9c9ba3)(state.isPostInProgress);
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !state.form.isValid
        }, "Submit"))));
    };
    SignIWModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-iw-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Approve Item Withdrawal | ", props.iw.itemWithdrawalId)), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions"
        }, this.getActionsRow(props, state)));
    };
    return SignIWModal;
}((0, $3f2ba7f1e3532510$exports.Modal));
var $9f360ec5d73f3028$export$ee5307445f41333d = function(signAction) {
    var fieldName = "";
    switch(signAction){
        case $9f360ec5d73f3028$export$af8f23d5f78834c3:
            fieldName = "Noted By";
            break;
        case $9f360ec5d73f3028$export$799082bd3ee8b4ae:
            fieldName = "Request Approved By";
            break;
    }
    return fieldName;
};
var $9f360ec5d73f3028$export$af8f23d5f78834c3 = "notedBy";
var $9f360ec5d73f3028$export$799082bd3ee8b4ae = "requestApprovedBy";
var $9f360ec5d73f3028$export$cc35d0e77634d48f = "orderApprovedBy";


var $771a11ebd09af05b$exports = {};

$parcel$export($771a11ebd09af05b$exports, "ViewJOModal", () => $771a11ebd09af05b$export$2e837ca0214e993b);

var $LjoDx = parcelRequire("LjoDx");






var $771a11ebd09af05b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $771a11ebd09af05b$export$2e837ca0214e993b = /** @class */ function(_super) {
    $771a11ebd09af05b$var$__extends(ViewJOModal, _super);
    function ViewJOModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            if (_this.props.close) _this.props.close();
        };
        _this.createForm(props);
        return _this;
    }
    ViewJOModal.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            type: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, props.jo.type),
            status: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, props.jo.status),
            vehicleId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, props.jo.vehicleId),
            description: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, props.jo.description),
            assignedPerson: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, props.jo.assignedPerson)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    ViewJOModal.prototype.getFormBlock = function(props, state) {
        var form = this.state.form;
        return (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Vehicle ID"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["vehicleId"])
            }),
            disabled: true,
            type: "text",
            value: form.fields["vehicleId"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "vehicleId"),
            placeholder: "Vehicle ID"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Status"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["status"])
            }),
            type: "text",
            disabled: true,
            value: form.fields["status"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "status"),
            placeholder: "Status"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Type"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["type"])
            }),
            type: "text",
            disabled: true,
            value: form.fields["type"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "type"),
            placeholder: "Type"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Description"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["description"])
            }),
            type: "text",
            disabled: true,
            value: form.fields["description"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "description"),
            placeholder: "Description"
        }))), props.jo.itemWithdrawal ? (0, $LjoDx.h)("div", {
            className: "row mt-3"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, this.getItemList(props.jo.itemWithdrawal.itemCodes))) : null));
    };
    ViewJOModal.prototype.getItemList = function(itemList) {
        return (0, $LjoDx.h)("div", {
            class: "item-list data-grid"
        }, (0, $LjoDx.h)("div", {
            className: "data-grid__row header"
        }, (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Name"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Item Code"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Amount"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Unit Price"), (0, $LjoDx.h)("div", {
            class: "data-grid__col"
        }, "Remark")), itemList.map(function(row, index) {
            return (0, $LjoDx.h)("div", {
                className: "data-grid__row"
            }, (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.name), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.itemCode), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.amount), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.unitPrice), (0, $LjoDx.h)("div", {
                class: "data-grid__col"
            }, row.remark));
        }));
    };
    ViewJOModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-disposal-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Job Order | ", props.jo.jobOrderId)), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))));
    };
    return ViewJOModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $6235fa6c991e0c19$exports = {};

$parcel$export($6235fa6c991e0c19$exports, "UdpateJOModal", () => $6235fa6c991e0c19$export$47d02ff9b0219eaf);

var $LjoDx = parcelRequire("LjoDx");












var $6235fa6c991e0c19$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6235fa6c991e0c19$export$47d02ff9b0219eaf = /** @class */ function(_super) {
    $6235fa6c991e0c19$var$__extends(UdpateJOModal, _super);
    function UdpateJOModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            if (_this.props.close) _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var jo = {
                itemWithdrawalId: form.fields["itemWithdrawalId"].value,
                vehicleId: form.fields["vehicleId"].value,
                type: form.fields["type"].value,
                description: form.fields["description"].value,
                assignedPerson: form.fields["assignedPerson"].value,
                jobOrderId: _this.props.jo.jobOrderId
            };
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $42d61ffa1d8a8d2b$export$3eb2cadfcad095b9),
                payload: {
                    joToUpdate: jo
                }
            });
        };
        _this.createForm(props);
        var form = _this.state.form;
        (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
        return _this;
    }
    UdpateJOModal.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            type: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, props.jo.type),
            status: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, props.jo.status),
            vehicleId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, props.jo.vehicleId),
            itemWithdrawalId: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, props.jo.itemWithdrawalId),
            description: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, props.jo.description),
            assignedPerson: new (0, $49e398741f5b1a93$export$a455218a85c89869)([], null, props.jo.assignedPerson)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    UdpateJOModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var motorpool$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.motorpool;
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                console.log("huh");
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
        }));
    };
    UdpateJOModal.prototype.getFormBlock = function(props, state) {
        var form = this.state.form;
        return (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Vehicle ID"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["vehicleId"])
            }),
            disabled: props.isEditingDisabled,
            type: "text",
            value: form.fields["vehicleId"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "vehicleId"),
            placeholder: "Vehicle ID"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Status*"), (0, $LjoDx.h)("select", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            placeholder: "Status",
            value: form.fields["status"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "status")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, "Select Status"), (0, $fa252804671e36f2$export$4ed479ac13dfe56e).map(function(acc) {
            return (0, $LjoDx.h)("option", {
                value: acc
            }, acc);
        }))), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-4 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Job Order Type*"), (0, $LjoDx.h)("select", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control"),
            placeholder: "JO Type",
            value: form.fields["type"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "type")
        }, (0, $LjoDx.h)("option", {
            class: "text-muted",
            value: "",
            disabled: true,
            selected: true
        }, "Select Job Order Type"), (0, $fa252804671e36f2$export$89df8e5f819ed9d8).map(function(acc) {
            return (0, $LjoDx.h)("option", {
                value: acc
            }, acc);
        }))), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Description"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["description"])
            }),
            type: "text",
            disabled: props.isEditingDisabled,
            value: form.fields["description"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "description"),
            placeholder: "Description"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Assigned Person"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["assignedPerson"])
            }),
            type: "text",
            value: form.fields["assignedPerson"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "assignedPerson"),
            placeholder: "Assigned Person"
        })), (0, $LjoDx.h)("div", {
            class: "col-12 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "Item Withdrawal ID"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["itemWithdrawalId"])
            }),
            type: "text",
            disabled: props.isEditingDisabled,
            value: form.fields["itemWithdrawalId"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "itemWithdrawalId"),
            placeholder: "Item Withdrawal ID"
        })))));
    };
    UdpateJOModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return (0, $75d6025062e781ef$export$89b84a018a9c9ba3)(state.isPostInProgress);
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !state.form.isValid
        }, "Submit"))));
    };
    UdpateJOModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-pd-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Edit Job Order | ", props.jo.jobOrderId)), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions"
        }, this.getActionsRow(props, state)));
    };
    return UdpateJOModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $834ce4ecb48b3c86$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $834ce4ecb48b3c86$export$6f49c11ea5bc340d = "modal-view-jo";
var $834ce4ecb48b3c86$export$22acd5346b3aab6c = "modal-create-jo";
var $834ce4ecb48b3c86$export$2507a1defa7e68ec = "modal-edit-jo";
var $834ce4ecb48b3c86$export$a599147d6620ad1e = "modal-approve-jo";
var $834ce4ecb48b3c86$export$e1169109c1927f13 = "modal-view-iw";
var $834ce4ecb48b3c86$export$e8fe90ccbd362d64 = "modal-create-iw";
var $834ce4ecb48b3c86$export$7d7cc4283a1aa4e0 = "modal-approve-iw";
var $834ce4ecb48b3c86$export$4660271701e3719 = /** @class */ function(_super) {
    $834ce4ecb48b3c86$var$__extends(JobOrderDashboard, _super);
    function JobOrderDashboard(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.onModalAction = function(modalData) {
            _this.setState({
                modalAction: modalData
            });
        };
        _this.onModalClose = function() {
            console.log("close");
            _this.setState({
                modalAction: {
                    name: "",
                    parameters: null
                }
            });
            _this.refreshPDGrid();
        };
        _this.onCreateJO = function() {
            var modalData = {
                name: $834ce4ecb48b3c86$export$22acd5346b3aab6c,
                parameters: null
            };
            _this.setState({
                modalAction: modalData
            });
        };
        _this.onCreateIW = function() {
            var modalData = {
                name: $834ce4ecb48b3c86$export$e8fe90ccbd362d64,
                parameters: null
            };
            _this.setState({
                modalAction: modalData
            });
        };
        _this.passRefreshPDGrid = function(returned) {
            _this.refreshPDGrid = returned;
        };
        _this.pdGridFilters = new Map();
        _this.setState({
            modalAction: {
                name: "",
                parameters: null
            }
        });
        return _this;
    }
    JobOrderDashboard.prototype.getPortalModal = function(state) {
        var modalState = state.modalAction;
        switch(modalState.name){
            case $834ce4ecb48b3c86$export$22acd5346b3aab6c:
                return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                    into: "body"
                }, (0, $LjoDx.h)("div", {
                    class: "anglo-modal-container",
                    id: "anglo-modal-124"
                }, (0, $LjoDx.h)((0, $cc5fa9831f73e2ab$exports.CreateJOModal), {
                    close: this.onModalClose,
                    isOutsideClickClose: true
                })));
            case $834ce4ecb48b3c86$export$6f49c11ea5bc340d:
                return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                    into: "body"
                }, (0, $LjoDx.h)("div", {
                    class: "anglo-modal-container",
                    id: "anglo-modal-124"
                }, (0, $LjoDx.h)((0, $771a11ebd09af05b$exports.ViewJOModal), {
                    jo: modalState.parameters.get("jo"),
                    close: this.onModalClose,
                    isOutsideClickClose: true
                })));
            case $834ce4ecb48b3c86$export$2507a1defa7e68ec:
                return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                    into: "body"
                }, (0, $LjoDx.h)("div", {
                    class: "anglo-modal-container",
                    id: "anglo-modal-124"
                }, (0, $LjoDx.h)((0, $6235fa6c991e0c19$exports.UdpateJOModal), {
                    jo: modalState.parameters.get("jo"),
                    close: this.onModalClose,
                    isOutsideClickClose: true
                })));
            case $834ce4ecb48b3c86$export$e8fe90ccbd362d64:
                return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                    into: "body"
                }, (0, $LjoDx.h)("div", {
                    class: "anglo-modal-container",
                    id: "anglo-modal-124"
                }, (0, $LjoDx.h)((0, $d8ad319637854a84$exports.CreateIWModal), {
                    close: this.onModalClose,
                    isOutsideClickClose: true
                })));
            case $834ce4ecb48b3c86$export$e1169109c1927f13:
                return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                    into: "body"
                }, (0, $LjoDx.h)("div", {
                    class: "anglo-modal-container",
                    id: "anglo-modal-124"
                }, (0, $LjoDx.h)((0, $6f97c06eff28aa74$exports.ViewIWModal), {
                    iw: modalState.parameters.get("iw"),
                    close: this.onModalClose,
                    isOutsideClickClose: true
                })));
            case $834ce4ecb48b3c86$export$7d7cc4283a1aa4e0:
                return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                    into: "body"
                }, (0, $LjoDx.h)("div", {
                    class: "anglo-modal-container",
                    id: "anglo-modal-124"
                }, (0, $LjoDx.h)((0, $9f360ec5d73f3028$exports.SignIWModal), {
                    iw: modalState.parameters.get("iw"),
                    isApproval: modalState.parameters.get("isApproval"),
                    close: this.onModalClose,
                    isOutsideClickClose: true
                })));
            default:
                return null;
        }
    };
    JobOrderDashboard.prototype.getActionsBlock = function(state) {
        return (0, $LjoDx.h)("div", {
            className: "row mb-3"
        }, (0, $LjoDx.h)("div", {
            className: "col-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.onCreateJO
        }, "Create Job Order")), (0, $LjoDx.h)("div", {
            className: "col-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.onCreateIW
        }, "Create Withdrawal")));
    };
    JobOrderDashboard.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "anglo-remittance"
        }, this.getPortalModal(state), (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, (0, $LjoDx.h)("hr", null), (0, $LjoDx.h)("p", null, (0, $LjoDx.h)("b", null, "Quick Actions")), this.getActionsBlock(state), (0, $LjoDx.h)("hr", null), (0, $LjoDx.h)("p", null, (0, $LjoDx.h)("b", null, "Job Orders")), (0, $LjoDx.h)((0, $9d50a51026bdf4b4$exports.JobOrderGrid), {
            initialFilters: this.pdGridFilters,
            onModalAction: this.onModalAction,
            refreshGrid: this.passRefreshPDGrid
        }), (0, $LjoDx.h)("hr", null), (0, $LjoDx.h)("p", null, (0, $LjoDx.h)("b", null, "Item Withdrawals")), (0, $LjoDx.h)((0, $51ce3c4ea72e932e$exports.ItemWithdrawalGrid), {
            initialFilters: this.pdGridFilters,
            onModalAction: this.onModalAction,
            refreshGrid: this.passRefreshPDGrid
        })));
    };
    return JobOrderDashboard;
}((0, $LjoDx.Component));



var $3d3cf06f41839071$exports = {};

$parcel$export($3d3cf06f41839071$exports, "ApprovePOModal", () => $3d3cf06f41839071$export$e7e1bc600f0701fb);

var $LjoDx = parcelRequire("LjoDx");











var $3d3cf06f41839071$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3d3cf06f41839071$export$e7e1bc600f0701fb = /** @class */ function(_super) {
    $3d3cf06f41839071$var$__extends(ApprovePOModal, _super);
    function ApprovePOModal(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.doModalClose = function() {
            if (_this.props.close) _this.props.close();
        };
        _this.onSubmit = function() {
            var form = _this.state.form;
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            if (!form.isValid) return;
            var purchaseDocumentSignPayload = {
                purchaseDocumentId: _this.props.pd.purchaseDocumentId
            };
            purchaseDocumentSignPayload["orderApprovedBy"] = form.fields["orderApprovedBy"].value;
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            store.dispatch({
                type: (0, $42d61ffa1d8a8d2b$export$9847d0c5208657f5),
                payload: {
                    purchaseDocumentSignPayload: purchaseDocumentSignPayload
                }
            });
        };
        _this.createForm(props);
        return _this;
    }
    ApprovePOModal.prototype.createForm = function(props) {
        var _this = this;
        var fields = {
            orderApprovedBy: new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                $fc45e937e6d1b794$export$a7a0278c004aac3f
            ], null, null)
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            form: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["form"] = form;
            _this.setState(state);
        });
    };
    ApprovePOModal.prototype.componentDidMount = function() {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        var motorpool$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.motorpool;
        }));
        this.subs.push(motorpool$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(motorpool) {
            return motorpool.postPutRequestState;
        }), (0, $89e911a23ad872a9$export$779c5fb865a0172e)()).subscribe(function(postPutRequestState) {
            if (postPutRequestState === (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                _this.setState({
                    isPostInProgress: false
                });
                _this.props.close();
            } else if (postPutRequestState === (0, $ad7802471dc8ad45$export$93ca241731165d07)) _this.setState({
                isPostInProgress: true
            });
        }));
    };
    ApprovePOModal.prototype.getFormBlock = function(props, state) {
        var form = this.state.form;
        return (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            className: "col-12"
        }, (0, $LjoDx.h)("div", {
            className: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-6 mt-3"
        }, (0, $LjoDx.h)("label", {
            class: "anglo-remittance__submit-form__label"
        }, "PO Approved By"), (0, $LjoDx.h)("input", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("form-control", {
                invalid: (0, $fc45e937e6d1b794$export$7c1f5a29b59be526)(form.fields["orderApprovedBy"])
            }),
            type: "text",
            value: form.fields["orderApprovedBy"].value,
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, form, "orderApprovedBy"),
            placeholder: "PO Approved By"
        })))));
    };
    ApprovePOModal.prototype.getActionsRow = function(props, state) {
        if (state.isPostInProgress) return (0, $75d6025062e781ef$export$89b84a018a9c9ba3)(state.isPostInProgress);
        else return (0, $LjoDx.h)("div", {
            class: "col-12"
        }, (0, $LjoDx.h)("div", {
            class: "row"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 col-lg-3 offset-lg-9"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-primary w-100",
            onClick: this.onSubmit,
            disabled: !state.form.isValid
        }, "Submit"))));
    };
    ApprovePOModal.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "container anglo-modal create-pd-modal",
            ref: function(node) {
                return _this.refNode = node;
            }
        }, (0, $LjoDx.h)("div", {
            class: "row anglo-modal__head align-items-center"
        }, (0, $LjoDx.h)("div", {
            class: "col-9 col-md-10"
        }, (0, $LjoDx.h)("h3", {
            class: "mb-0"
        }, "Approve Purchase Order for PD | ", props.pd.purchaseDocumentId)), (0, $LjoDx.h)("div", {
            class: "col-3 col-md-2"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-light w-100",
            onClick: this.doModalClose
        }, (0, $LjoDx.h)("i", {
            class: "fas fa-times"
        })))), (0, $LjoDx.h)("div", {
            class: "row anglo-modal__body py-3"
        }, (0, $LjoDx.h)("div", {
            class: "col-12 create-withdrawal-modal__body pb-3"
        }, this.getFormBlock(props, state))), (0, $LjoDx.h)("div", {
            class: "row vehicle-card__actions"
        }, this.getActionsRow(props, state)));
    };
    return ApprovePOModal;
}((0, $3f2ba7f1e3532510$exports.Modal));


var $f038725d2d01793f$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f038725d2d01793f$export$22d945a08b9e794 = "modal-view-pd";
var $f038725d2d01793f$export$a689578f38e33b8e = "modal-create-pd";
var $f038725d2d01793f$export$58ae6bd9dc66e50f = "modal-update-pd";
var $f038725d2d01793f$export$88b7cd3d3bfdd9b3 = "modal-sign-pd";
var $f038725d2d01793f$export$b9f23dd9ce45ff9b = "modal-create-po";
var $f038725d2d01793f$export$fd66d32b180010f9 = "modal-approve-po";
var $f038725d2d01793f$export$59195327aa90e13d = "modal-create-rr";
var $f038725d2d01793f$export$2166295265a23890 = "modal-create-supplier";
var $f038725d2d01793f$export$433c36a6a02fb3a7 = "modal-edit-supplier";
var $f038725d2d01793f$export$d7cc7d01659b1d6a = "modal-create-item";
var $f038725d2d01793f$export$b2c45db5ec313572 = /** @class */ function(_super) {
    $f038725d2d01793f$var$__extends(MotorpoolDashboard, _super);
    function MotorpoolDashboard(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.onModalAction = function(modalData) {
            _this.setState({
                modalAction: modalData
            });
        };
        _this.onModalClose = function() {
            console.log("close");
            _this.setState({
                modalAction: {
                    name: "",
                    parameters: null
                }
            });
            _this.refreshPDGrid();
        };
        _this.onCreatePD = function() {
            var modalData = {
                name: $f038725d2d01793f$export$a689578f38e33b8e,
                parameters: null
            };
            _this.setState({
                modalAction: modalData
            });
        };
        _this.onCreateJO = function() {
            var modalData = {
                name: (0, $834ce4ecb48b3c86$exports.JOB_ORDER_MODAL_CREATE_JO),
                parameters: null
            };
            _this.setState({
                modalAction: modalData
            });
        };
        _this.onCreateItem = function() {
            var modalData = {
                name: $f038725d2d01793f$export$d7cc7d01659b1d6a,
                parameters: null
            };
            _this.setState({
                modalAction: modalData
            });
        };
        _this.onCreateSupplier = function() {
            var modalData = {
                name: $f038725d2d01793f$export$2166295265a23890,
                parameters: null
            };
            _this.setState({
                modalAction: modalData
            });
        };
        _this.passRefreshPDGrid = function(returned) {
            _this.refreshPDGrid = returned;
        };
        _this.pdGridFilters = new Map();
        _this.setState({
            modalAction: {
                name: "",
                parameters: null
            }
        });
        return _this;
    }
    MotorpoolDashboard.prototype.getPortalModal = function(state) {
        var modalState = state.modalAction;
        switch(modalState.name){
            case $f038725d2d01793f$export$22d945a08b9e794:
                return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                    into: "body"
                }, (0, $LjoDx.h)("div", {
                    class: "anglo-modal-container",
                    id: "anglo-modal-124"
                }, (0, $LjoDx.h)((0, $bc15ecc3bbe55d0e$exports.ViewPDModal), {
                    close: this.onModalClose,
                    isOutsideClickClose: true,
                    pd: modalState.parameters.get("pd")
                })));
            case $f038725d2d01793f$export$a689578f38e33b8e:
                return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                    into: "body"
                }, (0, $LjoDx.h)("div", {
                    class: "anglo-modal-container",
                    id: "anglo-modal-124"
                }, (0, $LjoDx.h)((0, $2ede7c29da1f6f24$exports.CreatePDModal), {
                    close: this.onModalClose,
                    isOutsideClickClose: true
                })));
            case $f038725d2d01793f$export$58ae6bd9dc66e50f:
                return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                    into: "body"
                }, (0, $LjoDx.h)("div", {
                    class: "anglo-modal-container",
                    id: "anglo-modal-124"
                }, (0, $LjoDx.h)((0, $760746ce9635f486$exports.UpdatePDModal), {
                    pd: modalState.parameters.get("pd"),
                    close: this.onModalClose,
                    isOutsideClickClose: true
                })));
            case $f038725d2d01793f$export$88b7cd3d3bfdd9b3:
                return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                    into: "body"
                }, (0, $LjoDx.h)("div", {
                    class: "anglo-modal-container",
                    id: "anglo-modal-124"
                }, (0, $LjoDx.h)((0, $8f2b169202e9ad3c$exports.SignPDModal), {
                    pd: modalState.parameters.get("pd"),
                    signAction: modalState.parameters.get("signAction"),
                    close: this.onModalClose,
                    isOutsideClickClose: true
                })));
            case $f038725d2d01793f$export$59195327aa90e13d:
                return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                    into: "body"
                }, (0, $LjoDx.h)("div", {
                    class: "anglo-modal-container",
                    id: "anglo-modal-124"
                }, (0, $LjoDx.h)((0, $25a31ca3275c2a33$exports.CreateRRModal), {
                    pd: modalState.parameters.get("pd"),
                    close: this.onModalClose,
                    isOutsideClickClose: true
                })));
            case $f038725d2d01793f$export$2166295265a23890:
                return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                    into: "body"
                }, (0, $LjoDx.h)("div", {
                    class: "anglo-modal-container",
                    id: "anglo-modal-124"
                }, (0, $LjoDx.h)((0, $bf831a9bb0c3f85f$exports.CreateSupplierModal), {
                    close: this.onModalClose,
                    isOutsideClickClose: true
                })));
            case $f038725d2d01793f$export$433c36a6a02fb3a7:
                return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                    into: "body"
                }, (0, $LjoDx.h)("div", {
                    class: "anglo-modal-container",
                    id: "anglo-modal-124"
                }, (0, $LjoDx.h)((0, $5422f878b5edd325$exports.EditSupplierModal), {
                    supplier: modalState.parameters.get("supplier"),
                    close: this.onModalClose,
                    isOutsideClickClose: true
                })));
            case $f038725d2d01793f$export$d7cc7d01659b1d6a:
                return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                    into: "body"
                }, (0, $LjoDx.h)("div", {
                    class: "anglo-modal-container",
                    id: "anglo-modal-124"
                }, (0, $LjoDx.h)((0, $4fccf0739fe3345e$exports.CreateItemModal), {
                    close: this.onModalClose,
                    isOutsideClickClose: true
                })));
            case 0, $834ce4ecb48b3c86$exports.JOB_ORDER_MODAL_CREATE_JO:
                return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                    into: "body"
                }, (0, $LjoDx.h)("div", {
                    class: "anglo-modal-container",
                    id: "anglo-modal-124"
                }, (0, $LjoDx.h)((0, $cc5fa9831f73e2ab$exports.CreateJOModal), {
                    close: this.onModalClose,
                    isOutsideClickClose: true
                })));
            case $f038725d2d01793f$export$b9f23dd9ce45ff9b:
                return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                    into: "body"
                }, (0, $LjoDx.h)("div", {
                    class: "anglo-modal-container",
                    id: "anglo-modal-124"
                }, (0, $LjoDx.h)((0, $3fe14ced3c105f7b$exports.CreatePOModal), {
                    pd: modalState.parameters.get("pd"),
                    signAction: modalState.parameters.get("signAction"),
                    close: this.onModalClose,
                    isOutsideClickClose: true
                })));
            case $f038725d2d01793f$export$fd66d32b180010f9:
                return (0, $LjoDx.h)((0, (/*@__PURE__*/$parcel$interopDefault($80e1c1c28a093336$exports))), {
                    into: "body"
                }, (0, $LjoDx.h)("div", {
                    class: "anglo-modal-container",
                    id: "anglo-modal-124"
                }, (0, $LjoDx.h)((0, $3d3cf06f41839071$exports.ApprovePOModal), {
                    pd: modalState.parameters.get("pd"),
                    close: this.onModalClose,
                    isOutsideClickClose: true
                })));
            default:
                return null;
        }
    };
    MotorpoolDashboard.prototype.getActionsBlock = function(state) {
        return (0, $LjoDx.h)("div", {
            className: "row mb-3"
        }, (0, $LjoDx.h)("div", {
            className: "col-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.onCreatePD
        }, "Create Purchase Document")), (0, $LjoDx.h)("div", {
            className: "col-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.onCreateItem
        }, "Create New Item")), (0, $LjoDx.h)("div", {
            className: "col-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.onCreateSupplier
        }, "Create Supplier")), (0, $LjoDx.h)("div", {
            className: "col-3"
        }, (0, $LjoDx.h)("button", {
            class: "btn btn-outline-dark w-100",
            onClick: this.onCreateJO
        }, "Create Job Order")));
    };
    MotorpoolDashboard.prototype.render = function(props, state) {
        return (0, $LjoDx.h)("div", {
            class: "anglo-remittance"
        }, this.getPortalModal(state), (0, $LjoDx.h)("div", {
            class: "container-fluid"
        }, (0, $LjoDx.h)("hr", null), (0, $LjoDx.h)("p", null, (0, $LjoDx.h)("b", null, "Quick Actions")), this.getActionsBlock(state), (0, $LjoDx.h)("hr", null), (0, $LjoDx.h)("p", null, (0, $LjoDx.h)("b", null, "Purchase Documents")), (0, $LjoDx.h)((0, $b3494da6fa501def$exports.PurchaseDocumentGrid), {
            initialFilters: this.pdGridFilters,
            onModalAction: this.onModalAction,
            refreshGrid: this.passRefreshPDGrid
        }), (0, $LjoDx.h)("hr", null), (0, $LjoDx.h)("p", null, (0, $LjoDx.h)("b", null, "Inventory")), (0, $LjoDx.h)((0, $da159e80b016286b$exports.ItemGrid), {
            initialFilters: this.pdGridFilters,
            onModalAction: this.onModalAction
        }), (0, $LjoDx.h)("hr", null), (0, $LjoDx.h)("p", null, (0, $LjoDx.h)("b", null, "Suppliers")), (0, $LjoDx.h)((0, $85e153d92f3f7a06$exports.SupplierGrid), {
            initialFilters: this.pdGridFilters,
            onModalAction: this.onModalAction
        })));
    };
    return MotorpoolDashboard;
}((0, $LjoDx.Component));



var $d5ba0d87554d611e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
"anglo-app";
var $d5ba0d87554d611e$export$1b925f4758db83dd = /** @class */ function(_super) {
    $d5ba0d87554d611e$var$__extends(PreactApp, _super);
    function PreactApp(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.onSidenavClicked = function() {
            _this.setState({
                isSidenavVisible: !_this.state.isSidenavVisible
            });
        };
        _this.onRouteChange = function(e) {
            // need to implement a better routing strategy
            if (e.url === "/microscope") {
                if (_this.state.currentUser.role === "role_management") _this.setState({
                    currentUrl: e.url,
                    isSidenavVisible: false
                });
                else (0, $ea0dbf761ed9dde7$export$4cb887bfde2d34ca)("/", true);
            } else _this.setState({
                currentUrl: e.url,
                isSidenavVisible: false
            });
        };
        _this.setState({
            isAppVisible: false
        });
        return _this;
    }
    PreactApp.prototype.componentWillMount = function() {
        var _this = this;
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.user;
        }));
        this.subs.push(user$.subscribe(function(user) {
            if (user.getCurrentUserState == (0, $ad7802471dc8ad45$export$3ee3100c952bc770)) {
                if (user.currentUser && user.currentUser.username && user.currentUser.isActive) _this.setState({
                    isAppVisible: true,
                    currentUser: user.currentUser
                });
            } else if (user.getCurrentUserState == (0, $ad7802471dc8ad45$export$71d4adaa9696bca2)) location.href = "/login";
        }));
    };
    PreactApp.prototype.componentDidMount = function() {};
    PreactApp.prototype.render = function(props, state) {
        if (!state.isAppVisible) return (0, $LjoDx.h)("div", {
            class: "anglo"
        }, "Loading...");
        return (0, $LjoDx.h)("div", {
            class: "anglo"
        }, (0, $LjoDx.h)((0, $0c2ffb8529973f6f$exports.Navbar), {
            sidenavMenuCallback: this.onSidenavClicked
        }), (0, $LjoDx.h)("div", {
            class: "anglo__content"
        }, (0, $LjoDx.h)((0, $b364e60c259a0096$exports.Sidenav), {
            isSidenavVisible: state.isSidenavVisible,
            currentRoute: state.currentUrl,
            currentUser: state.currentUser
        }), (0, $LjoDx.h)("div", {
            class: "anglo__content__routes"
        }, (0, $LjoDx.h)((0, $ea0dbf761ed9dde7$export$2e2bcd8739ae039), {
            onChange: this.onRouteChange
        }, (0, $LjoDx.h)((0, $8f5e6c1f64b6d302$exports.AngloDashboard), {
            path: "/"
        }), (0, $LjoDx.h)((0, $8f5e6c1f64b6d302$exports.AngloDashboard), {
            path: "/dashboard"
        }), (0, $LjoDx.h)((0, $787290684425694f$exports.DashRemittance), {
            path: "/remittance"
        }), (0, $LjoDx.h)((0, $60ecffd9a5a5e7f2$exports.DashWithdrawals), {
            path: "/withdrawal"
        }), (0, $LjoDx.h)((0, $1b3d64ce21c3d489$exports.MicroscopeRemittance), {
            path: "/microscope"
        }), (0, $LjoDx.h)((0, $388f15e0b6245f4f$exports.SubmitRemittance), {
            path: "/remittance/submit"
        }), (0, $LjoDx.h)((0, $4a63541bdaa844d2$exports.AuditLogDashboard), {
            path: "/history"
        }), (0, $LjoDx.h)((0, $3ff198152c9f6cd6$exports.DashUpdates), {
            path: "/updates"
        }), (0, $LjoDx.h)((0, $3ff198152c9f6cd6$exports.DashUpdates), {
            path: "/audits"
        }), (0, $LjoDx.h)((0, $5c6b365a0e460dd1$exports.DashVehicles), {
            path: "/vehicles"
        }), (0, $LjoDx.h)((0, $5760e073989df791$exports.DashUserManagement), {
            path: "/user-management"
        }), (0, $LjoDx.h)((0, $1b4d8647546ef02f$exports.DashDisposals), {
            path: "/disposal"
        }), (0, $LjoDx.h)((0, $c1bb44a5a7d7dab3$exports.DashCashbondLoans), {
            path: "/cashbond-loan"
        }), (0, $LjoDx.h)((0, $7de11d8299f4e93d$exports.DashPaymentApproval), {
            path: "/loan-payments"
        }), (0, $LjoDx.h)((0, $b46bca7d9f5a0709$exports.DashCashbondPaymentApproval), {
            path: "/cashbond-payments"
        }), (0, $LjoDx.h)((0, $06add316fd6c06e8$exports.EmployeeDashboard), {
            path: "/employees"
        }), (0, $LjoDx.h)((0, $f038725d2d01793f$exports.MotorpoolDashboard), {
            path: "/motorpool"
        }), (0, $LjoDx.h)((0, $834ce4ecb48b3c86$exports.JobOrderDashboard), {
            path: "/job-orders"
        }), (0, $LjoDx.h)((0, $ecac5cf7ec1afbdd$exports.PreactTester), {
            path: "/test"
        })))));
    };
    return PreactApp;
}((0, $LjoDx.Component));


var $0fc3348cad8984ad$exports = {};

$parcel$export($0fc3348cad8984ad$exports, "AngloLogin", () => $0fc3348cad8984ad$export$cdd37e5efa532e4a);

var $LjoDx = parcelRequire("LjoDx");







var $0fc3348cad8984ad$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
"anglo-login";
var $0fc3348cad8984ad$export$cdd37e5efa532e4a = /** @class */ function(_super) {
    $0fc3348cad8984ad$var$__extends(AngloLogin, _super);
    function AngloLogin(props) {
        var _this = _super.call(this, props) || this;
        _this.subs = [];
        _this.onLogin = function(e, state) {
            e.preventDefault();
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(_this.state.loginForm);
            if (!_this.state.loginForm.isValid) return;
            var store = (0, $364b9d08877d223b$export$2e2bcd8739ae039)();
            var payload = {
                authUsername: _this.state.loginForm.fields["username"].value,
                authPassword: _this.state.loginForm.fields["password"].value
            };
            store.dispatch({
                type: (0, $4c71eb74f53637d3$export$eed606b4351295d7),
                payload: payload
            });
        };
        // if user exists in store, redirect
        _this.createForm();
        return _this;
    }
    AngloLogin.prototype.createForm = function() {
        var _this = this;
        var fields = {
            "username": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                "required"
            ], null, ""),
            "password": new (0, $49e398741f5b1a93$export$a455218a85c89869)([
                "required"
            ], null, "")
        };
        this.form$ = new (0, $7a16164e7ee15ac3$export$b6bbab5a9b109038)();
        this.setState({
            loginForm: new (0, $49e398741f5b1a93$export$a7fed597f4b8afd8)(fields)
        });
        this.form$.subscribe(function(form) {
            (0, $fc45e937e6d1b794$export$ed692cabb252e59b)(form);
            var state = {};
            state["loginForm"] = form;
            _this.setState(state);
        });
    };
    AngloLogin.prototype.componentWillMount = function() {
        var user$ = (0, $364b9d08877d223b$export$9f88e9db215c9dfb).pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(appState) {
            return appState.user;
        }));
        this.subs.push(user$.pipe((0, $0df2ebea4aa1249c$export$871de8747c9eaa88)(function(user) {
            return user.currentUser;
        })).subscribe(function(user) {
            console.log(user);
            if (user && user.username && user.isActive) // location.href = '/dashboard';
            window.location = "/";
        }));
    };
    AngloLogin.prototype.render = function(props, state) {
        var _this = this;
        return (0, $LjoDx.h)("div", {
            class: "anglo-login"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-login__login-card"
        }, (0, $LjoDx.h)("div", {
            class: "anglo-login__logo"
        }, (0, $LjoDx.h)("img", {
            src: "assets/aatcLogo.jpg",
            alt: "anglo-american-tobacco-corp-logo"
        })), (0, $LjoDx.h)("h1", {
            class: "anglo-login__login-card__h1 mt-3"
        }, "Sign In"), (0, $LjoDx.h)("form", null, (0, $LjoDx.h)("div", {
            class: "mt-3"
        }, (0, $LjoDx.h)("input", {
            type: "text",
            class: "form-control",
            value: state.loginForm.fields["username"].value,
            placeholder: "Username",
            onChange: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, state.loginForm, "username")
        })), (0, $LjoDx.h)("div", {
            class: "mt-3"
        }, (0, $LjoDx.h)("input", {
            type: "password",
            class: "form-control",
            value: state.loginForm.fields["password"].value,
            placeholder: "Password",
            onInput: (0, $7689db45fd0b6293$export$2e2bcd8739ae039)(this.form$, state.loginForm, "password")
        })), (0, $LjoDx.h)("button", {
            class: "btn btn-info mt-4 w-100",
            disabled: !state.loginForm.isValid,
            type: "submit",
            onClick: function(e) {
                _this.onLogin(e, state);
            }
        }, "Login")), (0, $LjoDx.h)("p", {
            class: "anglo-login__login-card__forgot mt-4"
        }, "If you've forgotten your login credentials, you may request for assistance from your corresponding manager or you can mail support at", (0, $LjoDx.h)("a", {
            href: "mailto:carta.mailer@gmail.com",
            class: "ml-1"
        }, "carta.mailer@gmail.com"), ".")));
    };
    return AngloLogin;
}((0, $LjoDx.Component));


var $161a557e76cf0c6d$var$PREACT_APP_SELECTOR = "anglo-app";
var $161a557e76cf0c6d$var$APP_SELECTORS = [
    {
        name: "anglo-app",
        component: (0, $d5ba0d87554d611e$exports.PreactApp)
    },
    {
        name: "anglo-login",
        component: (0, $0fc3348cad8984ad$exports.AngloLogin)
    }
];
var $161a557e76cf0c6d$export$2e2bcd8739ae039 = document.addEventListener("DOMContentLoaded", function() {
    if ((0, $6a59fa973dab83d3$export$ba6e2dd81d982fe).isOnClient()) // console.log('Running on client');
    $161a557e76cf0c6d$var$APP_SELECTORS.forEach(function(selector) {
        var targets = document.querySelectorAll(selector.name);
        var componentVDOM = (0, $LjoDx.h)(selector.component, {});
        targets.forEach(function(member) {
            (0, $LjoDx.render)(componentVDOM, member);
        });
    });
});


var $63e1dbd895a84834$exports = {};



/*!
  * Bootstrap dropdown.js v4.6.2 (https://getbootstrap.com/)
  * Copyright 2011-2022 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $63e1dbd895a84834$exports = factory((parcelRequire("6KOho")), (parcelRequire("kJWRP")), (parcelRequire("05SHZ")));
})($63e1dbd895a84834$exports, function($, Popper, Util) {
    "use strict";
    function _interopDefaultLegacy(e) {
        return e && typeof e === "object" && "default" in e ? e : {
            "default": e
        };
    }
    var $__default = /*#__PURE__*/ _interopDefaultLegacy($);
    var Popper__default = /*#__PURE__*/ _interopDefaultLegacy(Popper);
    var Util__default = /*#__PURE__*/ _interopDefaultLegacy(Util);
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    /**
   * Constants
   */ var NAME = "dropdown";
    var VERSION = "4.6.2";
    var DATA_KEY = "bs.dropdown";
    var EVENT_KEY = "." + DATA_KEY;
    var DATA_API_KEY = ".data-api";
    var JQUERY_NO_CONFLICT = $__default["default"].fn[NAME];
    var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key
    var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key
    var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key
    var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key
    var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key
    var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)
    var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + "|" + ARROW_DOWN_KEYCODE + "|" + ESCAPE_KEYCODE);
    var CLASS_NAME_DISABLED = "disabled";
    var CLASS_NAME_SHOW = "show";
    var CLASS_NAME_DROPUP = "dropup";
    var CLASS_NAME_DROPRIGHT = "dropright";
    var CLASS_NAME_DROPLEFT = "dropleft";
    var CLASS_NAME_MENURIGHT = "dropdown-menu-right";
    var CLASS_NAME_POSITION_STATIC = "position-static";
    var EVENT_HIDE = "hide" + EVENT_KEY;
    var EVENT_HIDDEN = "hidden" + EVENT_KEY;
    var EVENT_SHOW = "show" + EVENT_KEY;
    var EVENT_SHOWN = "shown" + EVENT_KEY;
    var EVENT_CLICK = "click" + EVENT_KEY;
    var EVENT_CLICK_DATA_API = "click" + EVENT_KEY + DATA_API_KEY;
    var EVENT_KEYDOWN_DATA_API = "keydown" + EVENT_KEY + DATA_API_KEY;
    var EVENT_KEYUP_DATA_API = "keyup" + EVENT_KEY + DATA_API_KEY;
    var SELECTOR_DATA_TOGGLE = '[data-toggle="dropdown"]';
    var SELECTOR_FORM_CHILD = ".dropdown form";
    var SELECTOR_MENU = ".dropdown-menu";
    var SELECTOR_NAVBAR_NAV = ".navbar-nav";
    var SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
    var PLACEMENT_TOP = "top-start";
    var PLACEMENT_TOPEND = "top-end";
    var PLACEMENT_BOTTOM = "bottom-start";
    var PLACEMENT_BOTTOMEND = "bottom-end";
    var PLACEMENT_RIGHT = "right-start";
    var PLACEMENT_LEFT = "left-start";
    var Default = {
        offset: 0,
        flip: true,
        boundary: "scrollParent",
        reference: "toggle",
        display: "dynamic",
        popperConfig: null
    };
    var DefaultType = {
        offset: "(number|string|function)",
        flip: "boolean",
        boundary: "(string|element)",
        reference: "(string|element)",
        display: "string",
        popperConfig: "(null|object)"
    };
    /**
   * Class definition
   */ var Dropdown = /*#__PURE__*/ function() {
        function Dropdown(element, config) {
            this._element = element;
            this._popper = null;
            this._config = this._getConfig(config);
            this._menu = this._getMenuElement();
            this._inNavbar = this._detectNavbar();
            this._addEventListeners();
        } // Getters
        var _proto = Dropdown.prototype;
        // Public
        _proto.toggle = function toggle() {
            if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED)) return;
            var isActive = $__default["default"](this._menu).hasClass(CLASS_NAME_SHOW);
            Dropdown._clearMenus();
            if (isActive) return;
            this.show(true);
        };
        _proto.show = function show(usePopper) {
            if (usePopper === void 0) usePopper = false;
            if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED) || $__default["default"](this._menu).hasClass(CLASS_NAME_SHOW)) return;
            var relatedTarget = {
                relatedTarget: this._element
            };
            var showEvent = $__default["default"].Event(EVENT_SHOW, relatedTarget);
            var parent = Dropdown._getParentFromElement(this._element);
            $__default["default"](parent).trigger(showEvent);
            if (showEvent.isDefaultPrevented()) return;
             // Totally disable Popper for Dropdowns in Navbar
            if (!this._inNavbar && usePopper) {
                // Check for Popper dependency
                if (typeof Popper__default["default"] === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
                var referenceElement = this._element;
                if (this._config.reference === "parent") referenceElement = parent;
                else if (Util__default["default"].isElement(this._config.reference)) {
                    referenceElement = this._config.reference; // Check if it's jQuery element
                    if (typeof this._config.reference.jquery !== "undefined") referenceElement = this._config.reference[0];
                } // If boundary is not `scrollParent`, then set position to `static`
                // to allow the menu to "escape" the scroll parent's boundaries
                // https://github.com/twbs/bootstrap/issues/24251
                if (this._config.boundary !== "scrollParent") $__default["default"](parent).addClass(CLASS_NAME_POSITION_STATIC);
                this._popper = new Popper__default["default"](referenceElement, this._menu, this._getPopperConfig());
            } // If this is a touch-enabled device we add extra
            // empty mouseover listeners to the body's immediate children;
            // only needed because of broken event delegation on iOS
            // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
            if ("ontouchstart" in document.documentElement && $__default["default"](parent).closest(SELECTOR_NAVBAR_NAV).length === 0) $__default["default"](document.body).children().on("mouseover", null, $__default["default"].noop);
            this._element.focus();
            this._element.setAttribute("aria-expanded", true);
            $__default["default"](this._menu).toggleClass(CLASS_NAME_SHOW);
            $__default["default"](parent).toggleClass(CLASS_NAME_SHOW).trigger($__default["default"].Event(EVENT_SHOWN, relatedTarget));
        };
        _proto.hide = function hide() {
            if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED) || !$__default["default"](this._menu).hasClass(CLASS_NAME_SHOW)) return;
            var relatedTarget = {
                relatedTarget: this._element
            };
            var hideEvent = $__default["default"].Event(EVENT_HIDE, relatedTarget);
            var parent = Dropdown._getParentFromElement(this._element);
            $__default["default"](parent).trigger(hideEvent);
            if (hideEvent.isDefaultPrevented()) return;
            if (this._popper) this._popper.destroy();
            $__default["default"](this._menu).toggleClass(CLASS_NAME_SHOW);
            $__default["default"](parent).toggleClass(CLASS_NAME_SHOW).trigger($__default["default"].Event(EVENT_HIDDEN, relatedTarget));
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY);
            $__default["default"](this._element).off(EVENT_KEY);
            this._element = null;
            this._menu = null;
            if (this._popper !== null) {
                this._popper.destroy();
                this._popper = null;
            }
        };
        _proto.update = function update() {
            this._inNavbar = this._detectNavbar();
            if (this._popper !== null) this._popper.scheduleUpdate();
        } // Private
        ;
        _proto._addEventListeners = function _addEventListeners() {
            var _this = this;
            $__default["default"](this._element).on(EVENT_CLICK, function(event) {
                event.preventDefault();
                event.stopPropagation();
                _this.toggle();
            });
        };
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, this.constructor.Default, $__default["default"](this._element).data(), config);
            Util__default["default"].typeCheckConfig(NAME, config, this.constructor.DefaultType);
            return config;
        };
        _proto._getMenuElement = function _getMenuElement() {
            if (!this._menu) {
                var parent = Dropdown._getParentFromElement(this._element);
                if (parent) this._menu = parent.querySelector(SELECTOR_MENU);
            }
            return this._menu;
        };
        _proto._getPlacement = function _getPlacement() {
            var $parentDropdown = $__default["default"](this._element.parentNode);
            var placement = PLACEMENT_BOTTOM; // Handle dropup
            if ($parentDropdown.hasClass(CLASS_NAME_DROPUP)) placement = $__default["default"](this._menu).hasClass(CLASS_NAME_MENURIGHT) ? PLACEMENT_TOPEND : PLACEMENT_TOP;
            else if ($parentDropdown.hasClass(CLASS_NAME_DROPRIGHT)) placement = PLACEMENT_RIGHT;
            else if ($parentDropdown.hasClass(CLASS_NAME_DROPLEFT)) placement = PLACEMENT_LEFT;
            else if ($__default["default"](this._menu).hasClass(CLASS_NAME_MENURIGHT)) placement = PLACEMENT_BOTTOMEND;
            return placement;
        };
        _proto._detectNavbar = function _detectNavbar() {
            return $__default["default"](this._element).closest(".navbar").length > 0;
        };
        _proto._getOffset = function _getOffset() {
            var _this2 = this;
            var offset = {};
            if (typeof this._config.offset === "function") offset.fn = function(data) {
                data.offsets = _extends({}, data.offsets, _this2._config.offset(data.offsets, _this2._element));
                return data;
            };
            else offset.offset = this._config.offset;
            return offset;
        };
        _proto._getPopperConfig = function _getPopperConfig() {
            var popperConfig = {
                placement: this._getPlacement(),
                modifiers: {
                    offset: this._getOffset(),
                    flip: {
                        enabled: this._config.flip
                    },
                    preventOverflow: {
                        boundariesElement: this._config.boundary
                    }
                }
            }; // Disable Popper if we have a static display
            if (this._config.display === "static") popperConfig.modifiers.applyStyle = {
                enabled: false
            };
            return _extends({}, popperConfig, this._config.popperConfig);
        } // Static
        ;
        Dropdown._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY);
                var _config = typeof config === "object" ? config : null;
                if (!data) {
                    data = new Dropdown(this, _config);
                    $__default["default"](this).data(DATA_KEY, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        Dropdown._clearMenus = function _clearMenus(event) {
            if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === "keyup" && event.which !== TAB_KEYCODE)) return;
            var toggles = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE));
            for(var i = 0, len = toggles.length; i < len; i++){
                var parent = Dropdown._getParentFromElement(toggles[i]);
                var context = $__default["default"](toggles[i]).data(DATA_KEY);
                var relatedTarget = {
                    relatedTarget: toggles[i]
                };
                if (event && event.type === "click") relatedTarget.clickEvent = event;
                if (!context) continue;
                var dropdownMenu = context._menu;
                if (!$__default["default"](parent).hasClass(CLASS_NAME_SHOW)) continue;
                if (event && (event.type === "click" && /input|textarea/i.test(event.target.tagName) || event.type === "keyup" && event.which === TAB_KEYCODE) && $__default["default"].contains(parent, event.target)) continue;
                var hideEvent = $__default["default"].Event(EVENT_HIDE, relatedTarget);
                $__default["default"](parent).trigger(hideEvent);
                if (hideEvent.isDefaultPrevented()) continue;
                 // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support
                if ("ontouchstart" in document.documentElement) $__default["default"](document.body).children().off("mouseover", null, $__default["default"].noop);
                toggles[i].setAttribute("aria-expanded", "false");
                if (context._popper) context._popper.destroy();
                $__default["default"](dropdownMenu).removeClass(CLASS_NAME_SHOW);
                $__default["default"](parent).removeClass(CLASS_NAME_SHOW).trigger($__default["default"].Event(EVENT_HIDDEN, relatedTarget));
            }
        };
        Dropdown._getParentFromElement = function _getParentFromElement(element) {
            var parent;
            var selector = Util__default["default"].getSelectorFromElement(element);
            if (selector) parent = document.querySelector(selector);
            return parent || element.parentNode;
        } // eslint-disable-next-line complexity
        ;
        Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
            // If not input/textarea:
            //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
            // If input/textarea:
            //  - If space key => not a dropdown command
            //  - If key is other than escape
            //    - If key is not up or down => not a dropdown command
            //    - If trigger inside the menu => not a dropdown command
            if (/input|textarea/i.test(event.target.tagName) ? event.which === SPACE_KEYCODE || event.which !== ESCAPE_KEYCODE && (event.which !== ARROW_DOWN_KEYCODE && event.which !== ARROW_UP_KEYCODE || $__default["default"](event.target).closest(SELECTOR_MENU).length) : !REGEXP_KEYDOWN.test(event.which)) return;
            if (this.disabled || $__default["default"](this).hasClass(CLASS_NAME_DISABLED)) return;
            var parent = Dropdown._getParentFromElement(this);
            var isActive = $__default["default"](parent).hasClass(CLASS_NAME_SHOW);
            if (!isActive && event.which === ESCAPE_KEYCODE) return;
            event.preventDefault();
            event.stopPropagation();
            if (!isActive || event.which === ESCAPE_KEYCODE || event.which === SPACE_KEYCODE) {
                if (event.which === ESCAPE_KEYCODE) $__default["default"](parent.querySelector(SELECTOR_DATA_TOGGLE)).trigger("focus");
                $__default["default"](this).trigger("click");
                return;
            }
            var items = [].slice.call(parent.querySelectorAll(SELECTOR_VISIBLE_ITEMS)).filter(function(item) {
                return $__default["default"](item).is(":visible");
            });
            if (items.length === 0) return;
            var index = items.indexOf(event.target);
            if (event.which === ARROW_UP_KEYCODE && index > 0) // Up
            index--;
            if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) // Down
            index++;
            if (index < 0) index = 0;
            items[index].focus();
        };
        _createClass(Dropdown, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType;
                }
            }
        ]);
        return Dropdown;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE, Dropdown._dataApiKeydownHandler).on(EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown._dataApiKeydownHandler).on(EVENT_CLICK_DATA_API + " " + EVENT_KEYUP_DATA_API, Dropdown._clearMenus).on(EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
        event.preventDefault();
        event.stopPropagation();
        Dropdown._jQueryInterface.call($__default["default"](this), "toggle");
    }).on(EVENT_CLICK_DATA_API, SELECTOR_FORM_CHILD, function(e) {
        e.stopPropagation();
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME] = Dropdown._jQueryInterface;
    $__default["default"].fn[NAME].Constructor = Dropdown;
    $__default["default"].fn[NAME].noConflict = function() {
        $__default["default"].fn[NAME] = JQUERY_NO_CONFLICT;
        return Dropdown._jQueryInterface;
    };
    return Dropdown;
});




//# sourceMappingURL=scriptloader.649a358c.js.map
